import * as React from "react";
import { useRef, useEffect } from 'react';
import gsap from 'gsap';


export default function TemplesOnly(props) {
    const columnRefs = useRef([]);
    const upperRefs = useRef([]);
    const { shouldAnimate } = props;
    // Initialize refs array
    columnRefs.current = [];
    upperRefs.current = [];
  
    const addToColumnRefs = el => {
      if (el && !columnRefs.current.includes(el)) {
        columnRefs.current.push(el);
      }
    };
  
    const addToUpperRefs = el => {
      if (el && !upperRefs.current.includes(el)) {
        upperRefs.current.push(el);
      }
    };
  
    useEffect(() => {
      // Always hide initially
      columnRefs.current.forEach(ref => gsap.set(ref, { opacity: 0, y: -80 }));
      upperRefs.current.forEach(ref => gsap.set(ref, { opacity: 0, x: 80 }));
    }, []);
  
    useEffect(() => {
      if (shouldAnimate) {
        const tl = gsap.timeline({ defaults: { ease: 'power2.out' } });
  
        tl.to([...columnRefs.current].reverse(), {
          opacity: 1,
          y: 0,
          stagger: 0.5,
          duration: 0.5
        })
        .to(upperRefs.current, {
          opacity: 1,
          x: 0,
          stagger: 0.5,
          duration: 0.5
        }, '+=0.15');
      }
    }, [shouldAnimate]);

  return (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 205.93 283.04"
    {...props}
  >
    <defs>
      <style>
        {
          ".templesOnly_svg__cls-2{fill:#cd8c4e}.templesOnly_svg__cls-9{fill:#d79856}.templesOnly_svg__cls-12{fill:#ba6128}.templesOnly_svg__cls-15{fill:#b6602b}.templesOnly_svg__cls-17{fill:#a95217}.templesOnly_svg__cls-25{fill:#ac6830}.templesOnly_svg__cls-27{fill:#c36b2b}.templesOnly_svg__cls-29{fill:#bc652b}.templesOnly_svg__cls-34{fill:#e1ae7b}.templesOnly_svg__cls-46{fill:#c86f29}.templesOnly_svg__cls-50{fill:#bc6f32}.templesOnly_svg__cls-54{fill:#ad622b}.templesOnly_svg__cls-58{fill:#c57231}.templesOnly_svg__cls-61{fill:#bf501a}.templesOnly_svg__cls-64{fill:#b06b31}.templesOnly_svg__cls-74{fill:#c59b66}.templesOnly_svg__cls-75{fill:#eec799}.templesOnly_svg__cls-77{fill:#963f16}.templesOnly_svg__cls-88{fill:#ca6d2b}.templesOnly_svg__cls-90{fill:#cf6c2a}.templesOnly_svg__cls-91{fill:#df7831}.templesOnly_svg__cls-95{fill:#ce6728}.templesOnly_svg__cls-98{fill:#cf692a}.templesOnly_svg__cls-104{fill:#d37628}.templesOnly_svg__cls-114{fill:#e3b37f}.templesOnly_svg__cls-124{fill:#9c4615}.templesOnly_svg__cls-130{fill:#d36b29}.templesOnly_svg__cls-132{fill:#d46b29}.templesOnly_svg__cls-137{fill:#de8138}.templesOnly_svg__cls-140{fill:#e17933}.templesOnly_svg__cls-143{fill:#e07a34}.templesOnly_svg__cls-146{fill:#d07331}.templesOnly_svg__cls-159{fill:#b36b34}.templesOnly_svg__cls-171{fill:#db7730}.templesOnly_svg__cls-172{fill:#df7c35}.templesOnly_svg__cls-173{fill:#e9843a}.templesOnly_svg__cls-174{fill:#e07b30}.templesOnly_svg__cls-181{fill:#bc7131}.templesOnly_svg__cls-182{fill:#f4c691}.templesOnly_svg__cls-200{fill:#a86836}.templesOnly_svg__cls-205{fill:#98582f}.templesOnly_svg__cls-217{fill:#ba5c23}.templesOnly_svg__cls-218{fill:#803411}.templesOnly_svg__cls-220{fill:#bf5f26}.templesOnly_svg__cls-236{fill:#984e1e}.templesOnly_svg__cls-239{fill:#a2491a}.templesOnly_svg__cls-245{fill:#964d1b}.templesOnly_svg__cls-249{fill:#be6927}.templesOnly_svg__cls-251{fill:#be6e30}.templesOnly_svg__cls-266{fill:#b52}.templesOnly_svg__cls-271{fill:#be5d1e}.templesOnly_svg__cls-273{fill:#cd8a49}.templesOnly_svg__cls-277{fill:#b2501c}.templesOnly_svg__cls-285{fill:#b04919}.templesOnly_svg__cls-287{fill:#b14a19}.templesOnly_svg__cls-289{fill:#b44e1d}.templesOnly_svg__cls-290{fill:#c26529}.templesOnly_svg__cls-291{fill:#a54718}.templesOnly_svg__cls-294{fill:#954c1d}.templesOnly_svg__cls-299{fill:#c07d40}.templesOnly_svg__cls-303{fill:#a86129}.templesOnly_svg__cls-311{fill:#9a4b1c}.templesOnly_svg__cls-320{fill:#b85e1e}.templesOnly_svg__cls-321{fill:#c05823}.templesOnly_svg__cls-325{fill:#94390f}.templesOnly_svg__cls-349{fill:#ce8c4a}.templesOnly_svg__cls-357{fill:#ab4b19}.templesOnly_svg__cls-360{fill:#ae511e}.templesOnly_svg__cls-362{fill:#af5826}.templesOnly_svg__cls-365{fill:#9c3f12}.templesOnly_svg__cls-368{fill:#a54c18}.templesOnly_svg__cls-401{fill:#6b2608}.templesOnly_svg__cls-402{fill:#b65417}.templesOnly_svg__cls-403{fill:#e0944d}.templesOnly_svg__cls-404{fill:#a64713}.templesOnly_svg__cls-410{fill:#583312}.templesOnly_svg__cls-411{fill:#704d23}.templesOnly_svg__cls-414{fill:#522d0c}.templesOnly_svg__cls-420{fill:#c3672c}.templesOnly_svg__cls-421{fill:#b46629}.templesOnly_svg__cls-423{fill:#bd6427}.templesOnly_svg__cls-427{fill:#b0652a}.templesOnly_svg__cls-428{fill:#b25e22}.templesOnly_svg__cls-429{fill:#be7b36}.templesOnly_svg__cls-433{fill:#e1a764}.templesOnly_svg__cls-436{fill:#c37f3f}.templesOnly_svg__cls-440{fill:#b2682d}.templesOnly_svg__cls-448{fill:#c77c38}.templesOnly_svg__cls-450{fill:#d27c35}.templesOnly_svg__cls-470{fill:#d7a56c}.templesOnly_svg__cls-482{fill:#e6b67e}.templesOnly_svg__cls-485{fill:#b37a46}.templesOnly_svg__cls-492{fill:#9a3f10}.templesOnly_svg__cls-496{fill:#ebb06d}.templesOnly_svg__cls-510{fill:#dfa361}.templesOnly_svg__cls-512{fill:#e1ab6d}.templesOnly_svg__cls-518{fill:#bf7b38}.templesOnly_svg__cls-519{fill:#e1a15e}.templesOnly_svg__cls-525{fill:#f0be8a}.templesOnly_svg__cls-535{fill:#efbb80}.templesOnly_svg__cls-537{fill:#f7b56f}.templesOnly_svg__cls-547{fill:#da9757}.templesOnly_svg__cls-548{fill:#f1c194}.templesOnly_svg__cls-555{fill:#e4af76}.templesOnly_svg__cls-561{fill:#daa562}.templesOnly_svg__cls-568{fill:#e3ab65}.templesOnly_svg__cls-578{fill:#97460c}.templesOnly_svg__cls-582{fill:#efb576}.templesOnly_svg__cls-601{fill:#efbb82}.templesOnly_svg__cls-605{fill:#b8642e}.templesOnly_svg__cls-608{fill:#9f6d43}.templesOnly_svg__cls-610{fill:#e7b67b}.templesOnly_svg__cls-611{fill:#c57f41}.templesOnly_svg__cls-614{fill:#c6702d}.templesOnly_svg__cls-615{fill:#d89e63}.templesOnly_svg__cls-617{fill:#e1aa70}.templesOnly_svg__cls-621{fill:#edae68}.templesOnly_svg__cls-630{fill:#ac5214}.templesOnly_svg__cls-634{fill:#b55a20}.templesOnly_svg__cls-638{fill:#d18f4d}.templesOnly_svg__cls-646{fill:#ba7030}.templesOnly_svg__cls-647{fill:#ad6123}.templesOnly_svg__cls-649{fill:#bc7535}.templesOnly_svg__cls-653{fill:#c77333}.templesOnly_svg__cls-660{fill:#d09355}.templesOnly_svg__cls-661{fill:#fcc388}.templesOnly_svg__cls-668{fill:#993d04}.templesOnly_svg__cls-670{fill:#8c3410}.templesOnly_svg__cls-674{fill:#742607}.templesOnly_svg__cls-676{fill:#edbe82}.templesOnly_svg__cls-679{fill:#c86826}.templesOnly_svg__cls-682{fill:#c46d2d}.templesOnly_svg__cls-690{fill:#ba6626}.templesOnly_svg__cls-692{fill:#c75f26}.templesOnly_svg__cls-694{fill:#c04d1b}.templesOnly_svg__cls-695{fill:#c2521b}.templesOnly_svg__cls-700{fill:#c45f24}.templesOnly_svg__cls-705{fill:#bc4b17}.templesOnly_svg__cls-707{fill:#c17e3b}.templesOnly_svg__cls-713{fill:#dfaa6c}.templesOnly_svg__cls-715{fill:#fcc585}.templesOnly_svg__cls-735{fill:#cc6426}.templesOnly_svg__cls-736{fill:#cb5d23}.templesOnly_svg__cls-739{fill:#cf6527}.templesOnly_svg__cls-740{fill:#c16c29}.templesOnly_svg__cls-748{fill:#c95820}.templesOnly_svg__cls-749{fill:#c2511e}.templesOnly_svg__cls-751{fill:#c4662e}.templesOnly_svg__cls-754{fill:#be4d18}.templesOnly_svg__cls-756{fill:#af4212}.templesOnly_svg__cls-759{fill:#bf7a34}.templesOnly_svg__cls-762{fill:#b26927}.templesOnly_svg__cls-778{fill:#6d2c12}.templesOnly_svg__cls-801{fill:#d06325}.templesOnly_svg__cls-808{fill:#bb511c}.templesOnly_svg__cls-810{fill:#b66b27}.templesOnly_svg__cls-814{fill:#c27b3a}.templesOnly_svg__cls-817{fill:#bd7632}.templesOnly_svg__cls-825{fill:#813b1d}.templesOnly_svg__cls-832{fill:#b7632d}.templesOnly_svg__cls-836{fill:#a46d3e}.templesOnly_svg__cls-844{fill:#54220f}.templesOnly_svg__cls-846{fill:#c75a1f}.templesOnly_svg__cls-853{fill:#d56b2a}.templesOnly_svg__cls-872{fill:#d89052}.templesOnly_svg__cls-873{fill:#e8b06f}.templesOnly_svg__cls-877{fill:#a15427}.templesOnly_svg__cls-879{fill:#af4d19}.templesOnly_svg__cls-882{fill:#b46332}.templesOnly_svg__cls-888{fill:#581400}.templesOnly_svg__cls-892{fill:#c86f28}.templesOnly_svg__cls-897{fill:#ca5a23}.templesOnly_svg__cls-900{fill:#c85821}.templesOnly_svg__cls-902{fill:#c1571e}.templesOnly_svg__cls-903{fill:#ca6420}.templesOnly_svg__cls-904{fill:#68240a}.templesOnly_svg__cls-906{fill:#4b190f}.templesOnly_svg__cls-910{fill:#c2662b}.templesOnly_svg__cls-911{fill:#c8733a}.templesOnly_svg__cls-917{fill:#cd5e22}.templesOnly_svg__cls-919{fill:#581600}.templesOnly_svg__cls-922{fill:#a33d10}.templesOnly_svg__cls-929{fill:#d06022}.templesOnly_svg__cls-930{fill:#cc5b22}.templesOnly_svg__cls-933{fill:#bc5d25}.templesOnly_svg__cls-935{fill:#c15620}.templesOnly_svg__cls-939{fill:#b94f19}.templesOnly_svg__cls-942{fill:#bf521c}.templesOnly_svg__cls-947{fill:#511b10}.templesOnly_svg__cls-953{fill:#cb591e}.templesOnly_svg__cls-959{fill:#b04e12}.templesOnly_svg__cls-961{fill:#ba5f23}.templesOnly_svg__cls-963{fill:#7d3510}.templesOnly_svg__cls-967{fill:#d05c26}.templesOnly_svg__cls-969{fill:#91300c}.templesOnly_svg__cls-970{fill:#ab5c21}.templesOnly_svg__cls-980{fill:#c35b1b}.templesOnly_svg__cls-984{fill:#ca5d1e}.templesOnly_svg__cls-991{fill:#ba5e28}.templesOnly_svg__cls-996{fill:#b04715}.templesOnly_svg__cls-999{fill:#ac4e18}.templesOnly_svg__cls-1000{fill:#b55622}.templesOnly_svg__cls-1013{fill:#cf5b22}.templesOnly_svg__cls-1020{fill:#b67137}.templesOnly_svg__cls-1028{fill:#c57234}.templesOnly_svg__cls-1037{fill:#b45d25}.templesOnly_svg__cls-1041{fill:#ba6b30}.templesOnly_svg__cls-1044{fill:#ca6220}.templesOnly_svg__cls-1047{fill:#ae5c21}.templesOnly_svg__cls-1048{fill:#a8501a}.templesOnly_svg__cls-1057{fill:#863d1c}.templesOnly_svg__cls-1058{fill:#721b00}.templesOnly_svg__cls-1068{fill:#c96425}.templesOnly_svg__cls-1072{fill:#cb6929}.templesOnly_svg__cls-1074{fill:#d8a265}.templesOnly_svg__cls-1084{fill:#852700}.templesOnly_svg__cls-1085{fill:#a44313}.templesOnly_svg__cls-1090{fill:#e1a869}.templesOnly_svg__cls-1098{fill:#a75219}.templesOnly_svg__cls-1102{fill:#9b4310}.templesOnly_svg__cls-1110{fill:#ce8b47}.templesOnly_svg__cls-1112{fill:#c67d39}.templesOnly_svg__cls-1113{fill:#ad5e24}.templesOnly_svg__cls-1121{fill:#c16224}.templesOnly_svg__cls-1127{fill:#d4a163}.templesOnly_svg__cls-1131{fill:#ca9a64}.templesOnly_svg__cls-1135{fill:#e5a86e}.templesOnly_svg__cls-1144{fill:#b06025}.templesOnly_svg__cls-1147{fill:#e1a96e}.templesOnly_svg__cls-1162{fill:#e6aa67}.templesOnly_svg__cls-1168{fill:#c59f6e}.templesOnly_svg__cls-1177{fill:#c79c6c}.templesOnly_svg__cls-1178{fill:#d09f6a}.templesOnly_svg__cls-1184{fill:#a57242}.templesOnly_svg__cls-1211{fill:#cb965d}.templesOnly_svg__cls-1230{fill:#d0682a}.templesOnly_svg__cls-1231{fill:#c36636}.templesOnly_svg__cls-1234{fill:#bc6129}.templesOnly_svg__cls-1235{fill:#66210d}.templesOnly_svg__cls-1236{fill:#d77734}.templesOnly_svg__cls-1238{fill:#b9491a}.templesOnly_svg__cls-1242{fill:#ac5d2b}.templesOnly_svg__cls-1243{fill:#d76a2a}.templesOnly_svg__cls-1245{fill:#d66727}.templesOnly_svg__cls-1246{fill:#d86f2b}.templesOnly_svg__cls-1247{fill:#da6a28}.templesOnly_svg__cls-1248{fill:#d66525}.templesOnly_svg__cls-1259{fill:#c55e25}.templesOnly_svg__cls-1261{fill:#c55e23}.templesOnly_svg__cls-1273{fill:#df7e3f}.templesOnly_svg__cls-1284{fill:#bd6d2c}.templesOnly_svg__cls-1286{fill:#bf6e35}.templesOnly_svg__cls-1288{fill:#b56c38}.templesOnly_svg__cls-1290{fill:#d05f1e}.templesOnly_svg__cls-1299{fill:#cc762f}.templesOnly_svg__cls-1307{fill:#c85d1f}.templesOnly_svg__cls-1317{fill:#bd4d18}.templesOnly_svg__cls-1350{fill:#e3b88b}.templesOnly_svg__cls-1352{fill:#e5bb86}.templesOnly_svg__cls-1358{fill:#ae4f18}.templesOnly_svg__cls-1361{fill:#b86526}.templesOnly_svg__cls-1365{fill:#cb742e}.templesOnly_svg__cls-1374{fill:#c26428}.templesOnly_svg__cls-1380{fill:#bf4f1a}.templesOnly_svg__cls-1387{fill:#e6af72}.templesOnly_svg__cls-1394{fill:#ce8e51}.templesOnly_svg__cls-1397{fill:#d8a973}.templesOnly_svg__cls-1407{fill:#fbc483}.templesOnly_svg__cls-1408{fill:#edb97c}.templesOnly_svg__cls-1412{fill:#eeb778}.templesOnly_svg__cls-1416{fill:#d08e4f}.templesOnly_svg__cls-1417{fill:#bd6e2e}.templesOnly_svg__cls-1421{fill:#b66d2b}.templesOnly_svg__cls-1435{fill:#cb8740}.templesOnly_svg__cls-1437{fill:#c57332}.templesOnly_svg__cls-1446{fill:#a46833}.templesOnly_svg__cls-1454{fill:#cc8944}.templesOnly_svg__cls-1455{fill:#d3985b}.templesOnly_svg__cls-1499{fill:#b87539}.templesOnly_svg__cls-1501{fill:#773810}.templesOnly_svg__cls-1503{fill:#c19976}.templesOnly_svg__cls-1505{fill:#88330f}.templesOnly_svg__cls-1506{fill:#924413}.templesOnly_svg__cls-1513{fill:#752b10}.templesOnly_svg__cls-1518{fill:#ad5f28}.templesOnly_svg__cls-1519{fill:#85370c}.templesOnly_svg__cls-1521{fill:#863710}.templesOnly_svg__cls-1524{fill:#8b4916}.templesOnly_svg__cls-1530{fill:#6c3318}.templesOnly_svg__cls-1534{fill:#874b2d}.templesOnly_svg__cls-1535{fill:#5d280e}.templesOnly_svg__cls-1536{fill:#975020}.templesOnly_svg__cls-1539{fill:#954e21}.templesOnly_svg__cls-1543{fill:#9a5c28}.templesOnly_svg__cls-1545{fill:#84592f}.templesOnly_svg__cls-1547{fill:#773a1b}.templesOnly_svg__cls-1551{fill:#5e210d}.templesOnly_svg__cls-1552{fill:#8b461e}.templesOnly_svg__cls-1559{fill:#7c2f09}.templesOnly_svg__cls-1560{fill:#78370f}.templesOnly_svg__cls-1562{fill:#64331a}.templesOnly_svg__cls-1566{fill:#903d12}.templesOnly_svg__cls-1568{fill:#762906}.templesOnly_svg__cls-1570{fill:#86380d}.templesOnly_svg__cls-1571{fill:#7b3b19}.templesOnly_svg__cls-1573{fill:#b66a2f}.templesOnly_svg__cls-1577{fill:#874014}.templesOnly_svg__cls-1578{fill:#621f04}.templesOnly_svg__cls-1579{fill:#5d2308}.templesOnly_svg__cls-1580{fill:#a0572c}.templesOnly_svg__cls-1585{fill:#8a390e}.templesOnly_svg__cls-1588{fill:#742d0e}.templesOnly_svg__cls-1589{fill:#753a17}.templesOnly_svg__cls-1598{fill:#c0864a}.templesOnly_svg__cls-1605{fill:#9e5022}.templesOnly_svg__cls-1607{fill:#af561a}.templesOnly_svg__cls-1609{fill:#c46b29}.templesOnly_svg__cls-1611{fill:#903c11}.templesOnly_svg__cls-1617{fill:#7e3408}.templesOnly_svg__cls-1620{fill:#92461a}.templesOnly_svg__cls-1622{fill:#944313}.templesOnly_svg__cls-1635{fill:#7f2706}.templesOnly_svg__cls-1637{fill:#964717}.templesOnly_svg__cls-1638{fill:#7e2f06}.templesOnly_svg__cls-1644{fill:#883d17}.templesOnly_svg__cls-1647{fill:#7c3310}.templesOnly_svg__cls-1650{fill:#803504}.templesOnly_svg__cls-1654{fill:#863e15}.templesOnly_svg__cls-1655{fill:#7b320f}.templesOnly_svg__cls-1656{fill:#853508}.templesOnly_svg__cls-1658{fill:#793208}.templesOnly_svg__cls-1659{fill:#a05424}.templesOnly_svg__cls-1661{fill:#8a3c0f}.templesOnly_svg__cls-1670{fill:#632009}.templesOnly_svg__cls-1681{fill:#97451b}.templesOnly_svg__cls-1685{fill:#9d481b}.templesOnly_svg__cls-1690{fill:#a64e18}.templesOnly_svg__cls-1691{fill:#752d0c}.templesOnly_svg__cls-1706{fill:#461501}.templesOnly_svg__cls-1708{fill:#883006}.templesOnly_svg__cls-1709{fill:#68250a}.templesOnly_svg__cls-1712{fill:#631400}.templesOnly_svg__cls-1721{fill:#994e20}.templesOnly_svg__cls-1722{fill:#924716}.templesOnly_svg__cls-1726{fill:#914a0f}.templesOnly_svg__cls-1729{fill:#853107}.templesOnly_svg__cls-1732{fill:#8f4318}.templesOnly_svg__cls-1737{fill:#924515}.templesOnly_svg__cls-1765{fill:#824016}.templesOnly_svg__cls-1772{fill:#b07645}.templesOnly_svg__cls-1778{fill:#fbb86b}.templesOnly_svg__cls-1779{fill:#efaa5e}.templesOnly_svg__cls-1790{fill:#cf7b45}.templesOnly_svg__cls-1791{fill:#a35117}.templesOnly_svg__cls-1812{fill:#b26c39}.templesOnly_svg__cls-1821{fill:#73280e}.templesOnly_svg__cls-1843{fill:#8f4a19}.templesOnly_svg__cls-1848{fill:#803e07}.templesOnly_svg__cls-1863{fill:#7b2f0d}.templesOnly_svg__cls-1870{fill:#661900}.templesOnly_svg__cls-1877{fill:#9a4817}.templesOnly_svg__cls-1879{fill:#631500}.templesOnly_svg__cls-1888{fill:#702704}.templesOnly_svg__cls-1902{fill:#b1663d}.templesOnly_svg__cls-1905{fill:#883815}.templesOnly_svg__cls-1923{fill:#a3511f}.templesOnly_svg__cls-1930{fill:#450c00}.templesOnly_svg__cls-1933{fill:#611b06}.templesOnly_svg__cls-1938{fill:#682a0c}.templesOnly_svg__cls-1941{fill:#b46a30}.templesOnly_svg__cls-1942{fill:#823d1a}.templesOnly_svg__cls-1953{fill:#703315}.templesOnly_svg__cls-1963{fill:#ab5a27}.templesOnly_svg__cls-1972{fill:#9a5321}.templesOnly_svg__cls-1983{fill:#9a4d16}.templesOnly_svg__cls-1994{fill:#6c2303}.templesOnly_svg__cls-2000{fill:#834421}.templesOnly_svg__cls-2001{fill:#a45220}.templesOnly_svg__cls-2009{fill:#7a290b}.templesOnly_svg__cls-2020{fill:#742c04}.templesOnly_svg__cls-2021{fill:#70270a}.templesOnly_svg__cls-2026{fill:#662001}.templesOnly_svg__cls-2033{fill:#561507}.templesOnly_svg__cls-2040{fill:#581c08}.templesOnly_svg__cls-2044{fill:#74260a}.templesOnly_svg__cls-2051{fill:#6c1d06}.templesOnly_svg__cls-2060{fill:#681f02}.templesOnly_svg__cls-2062{fill:#732c08}.templesOnly_svg__cls-2064{fill:#92441c}.templesOnly_svg__cls-2065{fill:#692205}.templesOnly_svg__cls-2070{fill:#762900}.templesOnly_svg__cls-2073{fill:#691900}.templesOnly_svg__cls-2095{fill:#a85b2f}.templesOnly_svg__cls-2107{fill:#621700}.templesOnly_svg__cls-2110{fill:#5b1000}.templesOnly_svg__cls-2111{fill:#691a00}.templesOnly_svg__cls-2113{fill:#611600}.templesOnly_svg__cls-2117{fill:#d28c53}.templesOnly_svg__cls-2126{fill:#713215}.templesOnly_svg__cls-2128{fill:#4c1c10}.templesOnly_svg__cls-2134{fill:#2c0401}.templesOnly_svg__cls-2135{fill:#4c1c0a}.templesOnly_svg__cls-2140{fill:#591d0a}.templesOnly_svg__cls-2148{fill:#5e2a0d}.templesOnly_svg__cls-2153{fill:#fec279}.templesOnly_svg__cls-2154{fill:#f7ae66}.templesOnly_svg__cls-2169{fill:#c57b3e}.templesOnly_svg__cls-2173{fill:#cc8341}.templesOnly_svg__cls-2176{fill:#d78836}.templesOnly_svg__cls-2190{fill:#601306}.templesOnly_svg__cls-2192{fill:#833d16}.templesOnly_svg__cls-2205{fill:#733313}.templesOnly_svg__cls-2214{fill:#7f3618}.templesOnly_svg__cls-2217{fill:#590e00}.templesOnly_svg__cls-2221{fill:#671a06}.templesOnly_svg__cls-2231{fill:#6d1f08}.templesOnly_svg__cls-2232{fill:#7a2d08}.templesOnly_svg__cls-2242{fill:#70230b}.templesOnly_svg__cls-2245{fill:#681e05}.templesOnly_svg__cls-2249{fill:#833711}.templesOnly_svg__cls-2258{fill:#661808}.templesOnly_svg__cls-2263{fill:#712c09}.templesOnly_svg__cls-2280{fill:#570d00}.templesOnly_svg__cls-2284{fill:#671b00}.templesOnly_svg__cls-2286{fill:#762509}.templesOnly_svg__cls-2289{fill:#7b2b09}.templesOnly_svg__cls-2292{fill:#762809}.templesOnly_svg__cls-2302{fill:#91552f}.templesOnly_svg__cls-2310{fill:#4d1405}.templesOnly_svg__cls-2313{fill:#5e1b11}.templesOnly_svg__cls-2315{fill:#501302}.templesOnly_svg__cls-2316{fill:#c16a2b}.templesOnly_svg__cls-2324{fill:#c56b2f}.templesOnly_svg__cls-2340{fill:#8d3005}.templesOnly_svg__cls-2341{fill:#e18b3f}.templesOnly_svg__cls-2344{fill:#a1440e}.templesOnly_svg__cls-2345{fill:#d27f25}.templesOnly_svg__cls-2347{fill:#e9963d}.templesOnly_svg__cls-2348{fill:#f09c49}.templesOnly_svg__cls-2349{fill:#aa5f23}.templesOnly_svg__cls-2356{fill:#976134}.templesOnly_svg__cls-2359{fill:#904214}.templesOnly_svg__cls-2361{fill:#71300f}.templesOnly_svg__cls-2369{fill:#c87535}.templesOnly_svg__cls-2376{fill:#682407}.templesOnly_svg__cls-2383{fill:#691f0b}.templesOnly_svg__cls-2396{fill:#4f1a06}.templesOnly_svg__cls-2412{fill:#7e3214}.templesOnly_svg__cls-2421{fill:#571906}.templesOnly_svg__cls-2423{fill:#7d2707}.templesOnly_svg__cls-2428{fill:#9a4214}.templesOnly_svg__cls-2438{fill:#511707}.templesOnly_svg__cls-2442{fill:#54170a}.templesOnly_svg__cls-2444{fill:#914622}.templesOnly_svg__cls-2445{fill:#7a2c0d}.templesOnly_svg__cls-2446{fill:#7e3513}.templesOnly_svg__cls-2450{fill:#863a12}.templesOnly_svg__cls-2456{fill:#823111}.templesOnly_svg__cls-2469{fill:#3d0900}.templesOnly_svg__cls-2478{fill:#772c10}.templesOnly_svg__cls-2482{fill:#ce7e34}.templesOnly_svg__cls-2499{fill:#7b3212}.templesOnly_svg__cls-2502{fill:#d27c46}.templesOnly_svg__cls-2504{fill:#9b3d0f}.templesOnly_svg__cls-2508{fill:#ef9847}.templesOnly_svg__cls-2529{fill:#9b5127}.templesOnly_svg__cls-2530{fill:#702102}.templesOnly_svg__cls-2538{fill:#c97f3e}.templesOnly_svg__cls-2548{fill:#803215}.templesOnly_svg__cls-2557{fill:#7f330d}.templesOnly_svg__cls-2569{fill:#a95425}.templesOnly_svg__cls-2572{fill:#82330f}.templesOnly_svg__cls-2574{fill:#a6501e}.templesOnly_svg__cls-2575{fill:#993c09}.templesOnly_svg__cls-2587{fill:#90471d}.templesOnly_svg__cls-2593{fill:#984015}.templesOnly_svg__cls-2594{fill:#8a3a14}.templesOnly_svg__cls-2601{fill:#6d2405}.templesOnly_svg__cls-2605{fill:#742a07}.templesOnly_svg__cls-2625{fill:#833708}.templesOnly_svg__cls-2626{fill:#7c290a}.templesOnly_svg__cls-2627{fill:#661d0d}.templesOnly_svg__cls-2632{fill:#943d0f}.templesOnly_svg__cls-2637{fill:#521000}.templesOnly_svg__cls-2649{fill:#83350e}.templesOnly_svg__cls-2662{fill:#c2712c}.templesOnly_svg__cls-2666{fill:#7e2c09}.templesOnly_svg__cls-2667{fill:#612107}.templesOnly_svg__cls-2671{fill:#701600}.templesOnly_svg__cls-2678{fill:#ee8e41}.templesOnly_svg__cls-2700{fill:#954111}.templesOnly_svg__cls-2714{fill:#722b02}.templesOnly_svg__cls-2718{fill:#76270c}.templesOnly_svg__cls-2723{fill:#641706}.templesOnly_svg__cls-2747{fill:#b64e22}.templesOnly_svg__cls-2748{fill:#c15c27}.templesOnly_svg__cls-2751{fill:#923d15}.templesOnly_svg__cls-2759{fill:#c2712f}.templesOnly_svg__cls-2760{fill:#bb6e33}.templesOnly_svg__cls-2770{fill:#954a20}.templesOnly_svg__cls-2776{fill:#b65e2c}.templesOnly_svg__cls-2787{fill:#803312}.templesOnly_svg__cls-2789{fill:#802f0c}.templesOnly_svg__cls-2797{fill:#b16434}.templesOnly_svg__cls-2801{fill:#b65f25}.templesOnly_svg__cls-2802{fill:#e09250}.templesOnly_svg__cls-2803{fill:#7b2d07}.templesOnly_svg__cls-2808{fill:#de853b}.templesOnly_svg__cls-2812{fill:#541100}.templesOnly_svg__cls-2821{fill:#bf6927}.templesOnly_svg__cls-2825{fill:#8c4017}.templesOnly_svg__cls-2826{fill:#b0612b}.templesOnly_svg__cls-2831{fill:#9b3a11}.templesOnly_svg__cls-2852{fill:#813712}.templesOnly_svg__cls-2863{fill:#782706}.templesOnly_svg__cls-2865{fill:#742303}.templesOnly_svg__cls-2872{fill:#af663a}.templesOnly_svg__cls-2875{fill:#ba5b28}.templesOnly_svg__cls-2876{fill:#af5427}.templesOnly_svg__cls-2882{fill:#cf7631}.templesOnly_svg__cls-2887{fill:#b24c16}.templesOnly_svg__cls-2888{fill:#f3a45a}.templesOnly_svg__cls-2889{fill:#c6723d}.templesOnly_svg__cls-2891{fill:#c16425}.templesOnly_svg__cls-2892{fill:#86340b}.templesOnly_svg__cls-2898{fill:#f8b168}.templesOnly_svg__cls-2902{fill:#e49f65}.templesOnly_svg__cls-2904{fill:#a74514}.templesOnly_svg__cls-2915{fill:#8e3a0a}.templesOnly_svg__cls-2917{fill:#a84d18}.templesOnly_svg__cls-2953{fill:#b55615}.templesOnly_svg__cls-2962{fill:#a0410a}.templesOnly_svg__cls-2969{fill:#f3a450}.templesOnly_svg__cls-2970{fill:#f09c4f}.templesOnly_svg__cls-2996{fill:#a54408}.templesOnly_svg__cls-3003{fill:#b5551a}.templesOnly_svg__cls-3007{fill:#feb061}.templesOnly_svg__cls-3009{fill:#f3a150}.templesOnly_svg__cls-3014{fill:#ac4312}.templesOnly_svg__cls-3015{fill:#b45624}.templesOnly_svg__cls-3017{fill:#a0450a}.templesOnly_svg__cls-3022{fill:#e09c4e}.templesOnly_svg__cls-3023{fill:#f3a555}.templesOnly_svg__cls-3024{fill:#f6af75}.templesOnly_svg__cls-3030{fill:#7d2a0e}.templesOnly_svg__cls-3037{fill:#d87b3e}.templesOnly_svg__cls-3038{fill:#d37a32}.templesOnly_svg__cls-3067{fill:#944009}.templesOnly_svg__cls-3069{fill:#de893f}.templesOnly_svg__cls-3070{fill:#782205}.templesOnly_svg__cls-3079{fill:#963f0b}.templesOnly_svg__cls-3080{fill:#9d400f}.templesOnly_svg__cls-3089{fill:#f9b05e}.templesOnly_svg__cls-3092{fill:#f8b66f}.templesOnly_svg__cls-3100{fill:#e78c41}.templesOnly_svg__cls-3104{fill:#a53d0f}.templesOnly_svg__cls-3109{fill:#f5a859}.templesOnly_svg__cls-3113{fill:#e18d3f}.templesOnly_svg__cls-3120{fill:#c5733b}.templesOnly_svg__cls-3123{fill:#ac4a19}.templesOnly_svg__cls-3128{fill:#ed9c52}.templesOnly_svg__cls-3130{fill:#cc793e}.templesOnly_svg__cls-3132{fill:#ae5d24}.templesOnly_svg__cls-3145{fill:#d57642}.templesOnly_svg__cls-3147{fill:#902b05}.templesOnly_svg__cls-3149{fill:#9c3b0c}.templesOnly_svg__cls-3150{fill:#892a05}.templesOnly_svg__cls-3154{fill:#e7964c}.templesOnly_svg__cls-3155{fill:#f6ad5c}.templesOnly_svg__cls-3168{fill:#ee9d4d}.templesOnly_svg__cls-3171{fill:#f9ad52}.templesOnly_svg__cls-3173{fill:#e69b4e}.templesOnly_svg__cls-3174{fill:#f0a14f}.templesOnly_svg__cls-3175{fill:#d38b35}.templesOnly_svg__cls-3177{fill:#eea351}.templesOnly_svg__cls-3179{fill:#d38534}.templesOnly_svg__cls-3185{fill:#fbad60}.templesOnly_svg__cls-3186{fill:#72260a}.templesOnly_svg__cls-3194{fill:#85320b}.templesOnly_svg__cls-3195{fill:#82310a}.templesOnly_svg__cls-3203{fill:#efab65}.templesOnly_svg__cls-3204{fill:#e8a35d}.templesOnly_svg__cls-3207{fill:#914f1d}.templesOnly_svg__cls-3208{fill:#a75720}.templesOnly_svg__cls-3209{fill:#e79354}.templesOnly_svg__cls-3219{fill:#e29540}.templesOnly_svg__cls-3225{fill:#e6974c}.templesOnly_svg__cls-3226{fill:#f19246}.templesOnly_svg__cls-3228{fill:#d0803d}.templesOnly_svg__cls-3238{fill:#9d4a1e}.templesOnly_svg__cls-3246{fill:#ad591e}.templesOnly_svg__cls-3248{fill:#febe71}.templesOnly_svg__cls-3251{fill:#a34f1f}.templesOnly_svg__cls-3253{fill:#c87537}.templesOnly_svg__cls-3256{fill:#d67e3f}.templesOnly_svg__cls-3261{fill:#6f1e01}.templesOnly_svg__cls-3264{fill:#612402}.templesOnly_svg__cls-3269{fill:#b45b1f}.templesOnly_svg__cls-3272{fill:#d88848}.templesOnly_svg__cls-3279{fill:#963806}.templesOnly_svg__cls-3283{fill:#9b440d}.templesOnly_svg__cls-3285{fill:#994412}.templesOnly_svg__cls-3287{fill:#aa4613}.templesOnly_svg__cls-3292{fill:#702208}.templesOnly_svg__cls-3295{fill:#8b3108}.templesOnly_svg__cls-3298{fill:#8b3308}.templesOnly_svg__cls-3321{fill:#661d04}.templesOnly_svg__cls-3322{fill:#4e0d00}.templesOnly_svg__cls-3329{fill:#5e1500}.templesOnly_svg__cls-3334{fill:#813616}.templesOnly_svg__cls-3336{fill:#dfb67f}.templesOnly_svg__cls-3339{fill:#f6c792}.templesOnly_svg__cls-3340{fill:#d59c66}.templesOnly_svg__cls-3344{fill:#d67c42}.templesOnly_svg__cls-3347{fill:#daa36e}.templesOnly_svg__cls-3355{fill:#cb8f54}.templesOnly_svg__cls-3356{fill:#cd894a}.templesOnly_svg__cls-3357{fill:#cf9259}.templesOnly_svg__cls-3358{fill:#d3985a}.templesOnly_svg__cls-3360{fill:#d4a167}.templesOnly_svg__cls-3365{fill:#c2874b}.templesOnly_svg__cls-3372{fill:#ddab75}.templesOnly_svg__cls-3378{fill:#b26929}.templesOnly_svg__cls-3379{fill:#b97532}.templesOnly_svg__cls-3380{fill:#b67234}.templesOnly_svg__cls-3381{fill:#b86e2e}.templesOnly_svg__cls-3384{fill:#ae6627}.templesOnly_svg__cls-3390{fill:#ab6525}.templesOnly_svg__cls-3396{fill:#ad682f}.templesOnly_svg__cls-3415{fill:#ecb679}.templesOnly_svg__cls-3424{fill:#b76c2f}.templesOnly_svg__cls-3428{fill:#c06e2a}.templesOnly_svg__cls-3429{fill:#ad6327}.templesOnly_svg__cls-3432{fill:#c46d2a}.templesOnly_svg__cls-3437{fill:#c26426}.templesOnly_svg__cls-3440{fill:#b96829}.templesOnly_svg__cls-3443{fill:#bf6f2a}.templesOnly_svg__cls-3453{fill:#ca511e}.templesOnly_svg__cls-3455{fill:#bd4e17}.templesOnly_svg__cls-3474{fill:#e0722b}.templesOnly_svg__cls-3476{fill:#d7772f}.templesOnly_svg__cls-3477{fill:#d0712a}.templesOnly_svg__cls-3482{fill:#d05f24}.templesOnly_svg__cls-3494{fill:#d55524}.templesOnly_svg__cls-3495{fill:#db6c28}.templesOnly_svg__cls-3497{fill:#d86326}.templesOnly_svg__cls-3499{fill:#d86328}.templesOnly_svg__cls-3500{fill:#d86924}.templesOnly_svg__cls-3502{fill:#d56629}.templesOnly_svg__cls-3503{fill:#db7830}.templesOnly_svg__cls-3517{fill:#dc6b29}.templesOnly_svg__cls-3521{fill:#de712c}.templesOnly_svg__cls-3525{fill:#d75f23}.templesOnly_svg__cls-3543{fill:#8b5429}"
        }
      </style>
    </defs>
    <g id="templesOnly_svg__Layer_2" data-name="Layer 2">
      <g id="templesOnly_svg__Layer_1-2" data-name="Layer 1">
        <g id="templesOnly_svg__column1" ref={el => columnRefs.current[0] = el}>
          <path
            d="M13 258c1.15-1.35 1-3 1-4.58v-43c0-1.42-.51-3 .93-4-.32-1.23-1-2.45-.89-3.62.23-4-.9-8.15.88-12.11.44-1 .07-2.3.07-3.46v-49.45c0-.92-1-2.44 1-2.79.08 1.5 1.24.85 2 1a21.5 21.5 0 0 0-1 3.55 10.2 10.2 0 0 0 .06 4.41 6.34 6.34 0 0 1 0 3.18c-.29 3.27 0 6.59-.14 9.88s-.63 6.65-1 10c.33 1 .66 2 1 3-.09 3.92-.17 7.85-.3 11.77 0 .24-.44.46-.68.7 1.38.89.92 2.28 1 3.53.24 2.44-.9 4.8-.84 7.06.1 4.06-1.66 8-.26 12.17.38 1.15-.44 2.71-.73 4.21 1.7 2.55 1 5.27-.13 7.66a8.7 8.7 0 0 1 .92 2.4c.08 3.49 0 7 0 10.47A89 89 0 0 1 16 240c-.4 3.5 1.33 6.66 1.08 10.07v3c-1.93.47-.62 2-1 3-.34.41-.64.86-1 1.24a9 9 0 0 1-1 .76Z"
            style={{
              fill: "#deae83",
            }}
          />
          <path
            d="m14 129-1.91-2.61c.73-.5 1.09-1.06.09-1.7L13 124l3-1v1c-.35 1.22-.69 2.45-1.13 4H19c-.16.76.49 1.91-1 2-.4-.33-.75-.88-1.19-.95A17.5 17.5 0 0 0 14 129"
            className="templesOnly_svg__cls-2"
          />
          <path
            d="M14 129a17.5 17.5 0 0 1 2.81.05c.44.07.79.62 1.19.95-.76.15-1.92-.5-2 1 .33.33.66.67 1 1l2 1v1l-1 1h-2z"
            style={{
              fill: "#dc9e66",
            }}
          />
          <path
            d="m16 123-3 1-1-2h2l1-1h1l1 1c-.3.37-.63.71-1 1"
            style={{
              fill: "#e09f66",
            }}
          />
          <path
            d="M17 250c.25-3.41-1.48-6.57-1.08-10.07A89 89 0 0 0 16 230v-10.47a8.7 8.7 0 0 0-.92-2.4c1.12-2.39 1.83-5.11.13-7.66.29-1.5 1.11-3.06.73-4.21-1.4-4.13.36-8.11.26-12.17-.06-2.26 1.08-4.62.84-7.06h1v20l-1 .76c.33.41.66.83 1 1.24.33 1 .66 2 1 3l-1 1c-1.66.17-1 1.47-1 2.26-.07 4 0 7.92 0 11.89 0 3.79.25 7.61-.07 11.38-.34 3.94 1.43 7.6 1.03 11.44v1Z"
            style={{
              fill: "#cf965c",
            }}
          />
          <path
            d="M16 167c.33-3.33.79-6.64 1-10s-.15-6.61.14-9.88a6.34 6.34 0 0 0 0-3.18 10.2 10.2 0 0 1-.06-4.41A21.5 21.5 0 0 1 18 136h1v6l-.83.33.83.67v12c-.34.42-.95.83-1 1.25-.08 3.58 0 7.17 0 10.75Z"
            style={{
              fill: "#cd955d",
            }}
          />
          <path
            d="M18 186h-1c-.06-1.25.4-2.64-1-3.53.24-.24.67-.46.68-.7.13-3.92.21-7.85.3-11.77h1v8.76c0 .42.62.83 1 1.24l-.73 2.66c1.89 1.05.17 2.21-.25 3.34"
            style={{
              fill: "#d69c63",
            }}
          />
          <path
            d="M14 258a9 9 0 0 0 1-.76c.37-.38.67-.83 1-1.24v3l-2 1h3v2h-2v2h-1z"
            style={{
              fill: "#f3b776",
            }}
          />
          <path
            d="M17 262v-2l-1-1v-3c.38-1-.93-2.53 1-3a37 37 0 0 0 0 3.8c.05.43.62.8 1 1.2v2c-.12.8.53 2-1 2"
            className="templesOnly_svg__cls-9"
          />
          <path
            d="M18 258c-.34-.4-.91-.77-1-1.2a37 37 0 0 1 0-3.8v-3h1Z"
            style={{
              fill: "#be8141",
            }}
          />
          <path
            d="M18 170h-1c-.34-1-.67-2-1-3h2Z"
            style={{
              fill: "#dbab7c",
            }}
          />
          <path
            d="M16 135h2v1c-.72-.11-1.88.54-2-1"
            className="templesOnly_svg__cls-12"
          />
          <path
            d="M18 128h-3.09c.44-1.55.78-2.78 1.13-4h2l1 2c-.34.33-.67.67-1 1Z"
            style={{
              fill: "#9a3d0a",
            }}
          />
          <path
            d="M18 130c1.49-.09.84-1.24 1-2h1v4h-1l-1-1Z"
            style={{
              fill: "#af5a1c",
            }}
          />
          <path
            d="M18 124h-2v-1c.33-.33.66-.67 1-1h1Z"
            className="templesOnly_svg__cls-15"
          />
          <path
            d="M20 128h-2v-1h1Z"
            style={{
              fill: "#953605",
            }}
          />
          <path
            d="M18 136v-1l1-1h2v1l-2 1Z"
            className="templesOnly_svg__cls-17"
          />
          <path
            d="M21 134h-2v-2h1c.33.33.66.67 1 1h1v1Z"
            style={{
              fill: "#c46b30",
            }}
          />
          <path
            d="M19 132v1l-2-1v-1h1Z"
            style={{
              fill: "#c6783a",
            }}
          />
          <path
            d="M18 131h-2c.08-1.5 1.24-.85 2-1Z"
            className="templesOnly_svg__cls-2"
          />
          <path
            d="M16 131h1v1c-.3-.29-.63-.63-1-1"
            style={{
              fill: "#b2783c",
            }}
          />
          <path
            d="M16 121c.08-1.5 1.24-.85 2-1h1v1h-1c-.34.33-.67.67-1 1Z"
            style={{
              fill: "#a64d1c",
            }}
          />
          <path
            d="M14 121h1l-1 1Z"
            style={{
              fill: "#f8ae6e",
            }}
          />
          <path
            d="M18 258v-9l1.87-2.48c-2.4-3.76-1.8-7.69-1.87-11.52h3v1h-1.73v6l1.73-1v4c.07 2-.48 4.19 1 6 .12 1.18-.36 2.42.84 3.46.48.42.34 1.5-.84 1.54-.87-.66-1.73-1.32-3-2.31V260h-1Zm1.17-5.16.86-.11-.39-1.62-.47.07Z"
            style={{
              fill: "#b2692f",
            }}
          />
          <path
            d="M18 235c.07 3.83-.53 7.76 1.87 11.52L18 249c.36-3.88-1.41-7.54-1.07-11.47.32-3.77.07-7.59.07-11.38v-11.89c0-.79-.69-2.09 1-2.26v14c.15.76-.5 1.91 1 2v1c-.34.4-.93.79-1 1.21z"
            style={{
              fill: "#c28247",
            }}
          />
          <path
            d="M18 217v-5l1-1c-.34-1-.67-2-1-3v-20h1v15l1 1-1 1.82a2.4 2.4 0 0 0 0 .57c2 .49-.07 3.19 2 3.61v1l-2 3v3Z"
            className="templesOnly_svg__cls-25"
          />
          <path
            d="M19 188h-1v-2c.38-1.17 2.1-2.33.27-3.34L19 180v-3h2v5a2.47 2.47 0 0 0 0 4v5h-1c-.35-.94 1-2.49-1-3"
            style={{
              fill: "#ba6a29",
            }}
          />
          <path
            d="M18 206v2c-.34-.41-.67-.83-1-1.24ZM19 211l-1 1Z"
            className="templesOnly_svg__cls-27"
          />
          <path
            d="M19 142v-1c.33-.23.84-.39 1-.7.42-1.07.7-2.2 1-3.3h1v2l-.91 1.57c1.33.81.82 2.2.91 3.43 0 2.59 0 5.18-.05 7.76 0 .43-.62.83-.95 1.24v-2h-2v-2a2.48 2.48 0 0 0 0-4z"
            className="templesOnly_svg__cls-12"
          />
          <path
            d="M19 177v3c-.34-.41-.95-.82-1-1.24v-22.51c0-.42.62-.83 1-1.25z"
            style={{
              fill: "#bb7d43",
            }}
          />
          <path
            d="M19 156v-5h2v6ZM21 137c-.34 1.1-.62 2.23-1 3.3-.12.31-.63.47-1 .7v-4ZM19 145a2.48 2.48 0 0 1 0 4Z"
            className="templesOnly_svg__cls-29"
          />
          <path d="M21 137h-2v-1l2-1Z" className="templesOnly_svg__cls-12" />
          <path d="M19 142v1l-.83-.67Z" className="templesOnly_svg__cls-29" />
          <path d="M15 264v-2h2l1 2Z" className="templesOnly_svg__cls-9" />
          <path
            d="m16 259 1 1h-3Z"
            style={{
              fill: "#e4aa71",
            }}
          />
          <path d="M14 264h1l-1 1Z" className="templesOnly_svg__cls-9" />
          <path
            d="m18 264-1-2c1.49-.09.84-1.24 1-2h3c.75.15 1.91-.5 2 1l-1 1c-1.5.09-.85 1.24-1 2Z"
            style={{
              fill: "#cc7e35",
            }}
          />
          <path
            d="m14 265 1-1h3v2l-2 .26 1 1.74-2.72-.74L13 268v-2Z"
            style={{
              fill: "#f5bd86",
            }}
          />
          <path
            d="m13 268 1.28-.74L17 268h1v1h-5Z"
            style={{
              fill: "#fbcc96",
            }}
          />
          <path d="M11 271v-2h1v1Z" className="templesOnly_svg__cls-34" />
          <circle
            cx={12.54}
            cy={269.54}
            r={0.71}
            style={{
              fill: "#fecb95",
            }}
          />
          <path
            d="M18 124v-2h1v1l1 1 1 1v1h-2Z"
            style={{
              fill: "#be5d2b",
            }}
          />
          <path
            d="M19 127h-1c.33-.33.66-.67 1-1Z"
            style={{
              fill: "#8c2a00",
            }}
          />
          <path
            d="M20 131v-3h1c.15.76-.5 1.91 1 2v1z"
            style={{
              fill: "#a14614",
            }}
          />
          <path
            d="M20 131h1v2c-.34-.33-.67-.67-1-1Z"
            style={{
              fill: "#a54e15",
            }}
          />
          <path
            d="M17 122c.33-.33.66-.67 1-1v1Z"
            style={{
              fill: "#9c3e0e",
            }}
          />
          <path
            d="M21 128h-1l-1-1v-1h2Z"
            style={{
              fill: "#a04315",
            }}
          />
          <path
            d="M21 137v-3h1c.33.33.66.67 1 1l-1 2Z"
            style={{
              fill: "#b54f18",
            }}
          />
          <path
            d="M23 135c-.34-.33-.67-.67-1-1v-1h3l1 1-1 1Z"
            style={{
              fill: "#b8501f",
            }}
          />
          <ellipse
            cx={21.54}
            cy={132.04}
            rx={0.71}
            ry={1.41}
            style={{
              fill: "#ac521c",
            }}
          />
          <path
            d="M19 121v-1h1v1c-.34.33-.67.67-1 1Z"
            style={{
              fill: "#dd9765",
            }}
          />
          <circle
            cx={18.54}
            cy={121.54}
            r={0.71}
            className="templesOnly_svg__cls-15"
          />
          <path
            d="M21 191v-4h1v6.47c0 3.87-.44 7.78 1 11.53l-1.14.44L24 207v2c-.29.12-.81.23-.82.35v8.3c0 .12.53.23.82.35a13.5 13.5 0 0 0-1 3.06c-.15 2 0 4 0 5.94v1c0 1.67-.12 3.34 0 5 .13 1.41-1.5 2.78-.09 4.12l-1.12 2.52c.74 1.47 1.39 2.78 1.73 3.46L23 246l-2-1v-19c1.33 0 1.22-1.2.94-1.72a6.67 6.67 0 0 1 0-6.6c.28-.59 1-2.35-.9-2.68v-11c-.21-2.35.67-4.85-1.24-7.29 2.41-1.36.81-3.71 1.2-5.71"
            className="templesOnly_svg__cls-27"
          />
          <path
            d="M23 261c-.09-1.5-1.25-.85-2-1l1.71-1.38c-.24-.9-.48-1.76-.71-2.62 1.18 0 1.32-1.12.84-1.54-1.2-1-.72-2.28-.84-3.46h1l1 1 .39.87L26 252l-.75 2.78.68.58L25 257c.38 1-.93 2.53 1 3-.43 2-2 .66-3 1"
            className="templesOnly_svg__cls-46"
          />
          <path
            d="M22 256c.23.86.47 1.72.71 2.62L21 260h-2v-6.31c1.31 1.03 2.17 1.69 3 2.31"
            style={{
              fill: "#ab6427",
            }}
          />
          <path
            d="M23 251h-1c-1.48-1.81-.93-4-1-6l2 1 1 1c-.34.39-.89.75-1 1.18a17.7 17.7 0 0 0 0 2.82"
            style={{
              fill: "#b86626",
            }}
          />
          <path
            d="M21 236v5l-1.77 1v-6Z"
            style={{
              fill: "#a65f27",
            }}
          />
          <path
            d="M21 232v3h-3c0-1.6-.07-3.2 0-4.79 0-.42.62-.81 1-1.21l.18 4Z"
            className="templesOnly_svg__cls-50"
          />
          <path
            d="M19.21 252.88v-1.66l.47-.07.39 1.62Z"
            style={{
              fill: "#a76126",
            }}
          />
          <path
            d="M21 226v5a4.8 4.8 0 0 1-1-1.27c-.23-.67.3-1.72-1-1.73-1.5-.09-.85-1.24-1-2z"
            className="templesOnly_svg__cls-50"
          />
          <path
            d="M20 226h-2v-6h1q.54 3 1 6"
            className="templesOnly_svg__cls-25"
          />
          <path
            d="M19 228c1.33 0 .8 1.06 1 1.73a4.8 4.8 0 0 0 1 1.27v1l-1.82 1-.18-4Z"
            style={{
              fill: "#ab622b",
            }}
          />
          <path d="M19 220h-1v-3h1z" className="templesOnly_svg__cls-50" />
          <path
            d="M21 191c-.43 2 1.17 4.31-1.24 5.71 1.91 2.44 1 4.94 1.24 7.29h-1v-1c-.39-1 .92-2.53-1-3v-9z"
            style={{
              fill: "#ac5c24",
            }}
          />
          <path
            d="M20 204h1v6c-2.07-.42 0-3.12-2-3.61a2.4 2.4 0 0 1 0-.57Z"
            className="templesOnly_svg__cls-54"
          />
          <path
            d="M19 218v-4l2 1v3Z"
            style={{
              fill: "#a55c27",
            }}
          />
          <path d="m21 215-2-1 2-3Z" className="templesOnly_svg__cls-54" />
          <path
            d="M20 191h-1v-3c2 .51.65 2.06 1 3"
            style={{
              fill: "#a55a23",
            }}
          />
          <path
            d="M19 200c1.92.47.61 2 1 3h-1Z"
            style={{
              fill: "#a65820",
            }}
          />
          <path d="M19 203h1v1Z" className="templesOnly_svg__cls-54" />
          <path
            d="M19 177v-1q2.055-1.5 0-3v-3l1 1 2 1.57V176a8 8 0 0 0 .3 1.78c1 2.46 1 3.37-.3 5.22l-1-1v-5Z"
            className="templesOnly_svg__cls-58"
          />
          <path
            d="m21 182 1 1v2l-1 1a2.47 2.47 0 0 1 0-4"
            style={{
              fill: "#b46526",
            }}
          />
          <path d="m21 186 1-1v2h-1Z" className="templesOnly_svg__cls-58" />
          <path
            d="M21 155v-2c.33-.41.94-.81.95-1.24.09-2.58.05-5.17.05-7.76.86-.09 2.07.44 2-1.24 0-.25.62-.51 1-.76v6c0 1.93-.06 3.86 0 5.78 0 .42.62.81 1 1.22v3h-1l-.26-2-1.74 1v-2Zm2.75-9h-.5v2h.5Z"
            style={{
              fill: "#ca5c21",
            }}
          />
          <path
            d="M25 142c-.34.25-1 .51-1 .76 0 1.68-1.18 1.15-2 1.24-.09-1.23.42-2.62-.91-3.43L22 139h2c.37 1 .7 2 1 3"
            className="templesOnly_svg__cls-61"
          />
          <path
            d="M24 139h-2v-2l1-2h2c-.16.76.49 1.91-1 2l-.83.33.83.67Z"
            style={{
              fill: "#ba4b18",
            }}
          />
          <ellipse
            cx={19.54}
            cy={162.04}
            rx={0.71}
            ry={5.66}
            style={{
              fill: "#ab662d",
            }}
          />
          <path
            d="M19 166h1c.33.33.66.67 1 1v2c-.16.76.49 1.91-1 2l-1-1Z"
            className="templesOnly_svg__cls-64"
          />
          <path
            d="M20 158h-1v-2l2 1v1Z"
            style={{
              fill: "#a75723",
            }}
          />
          <path
            d="M19 173q2.055 1.5 0 3Z"
            className="templesOnly_svg__cls-64"
          />
          <path
            d="M21 155h2v2h-2Z"
            style={{
              fill: "#cf6628",
            }}
          />
          <path
            d="M21 264c.15-.76-.5-1.91 1-2 1.17 1.91 3 2.09 5 2v2l-1 1c-.73.22-1.45.48-2.18.66s-1.22.23-1.82.34h-1v-1l1.89-.35-.07-.65H19a8 8 0 0 1 .76-1 15 15 0 0 1 1.24-1"
            style={{
              fill: "#bb7030",
            }}
          />
          <path
            d="M23 261c1-.38 2.53.93 3-1h1l1 1v1h-6Z"
            style={{
              fill: "#d78031",
            }}
          />
          <path
            d="M21 264a15 15 0 0 0-1.24 1 8 8 0 0 0-.76 1h-1v-2Z"
            className="templesOnly_svg__cls-9"
          />
          <path d="M10 272v-1h1Z" className="templesOnly_svg__cls-34" />
          <path
            d="M21 267v1h-4l-1-1.74 2-.26c.5 2 2.05.66 3 1"
            style={{
              fill: "#bb804a",
            }}
          />
          <path
            d="m13 266 1-1Z"
            style={{
              fill: "#b27036",
            }}
          />
          <path
            d="M14 269h2l1 1v1h-4v-1Z"
            style={{
              fill: "#d2a472",
            }}
          />
          <path
            d="M18 268h4v1h-4Z"
            style={{
              fill: "#d49b67",
            }}
          />
          <path
            d="M18 269h1v1h-2v-1Z"
            style={{
              fill: "#ad7f47",
            }}
          />
          <path d="M17 269v1l-1-1Z" className="templesOnly_svg__cls-74" />
          <path d="m14 269-1 1v-1Z" className="templesOnly_svg__cls-75" />
          <path
            d="M13 270v2l-1 1 1 1v2h-1l-1-1-1-1v-2l1-1 1-1Z"
            style={{
              fill: "#eec091",
            }}
          />
          <path
            d="M21 128v-3l1-1h2l1 1c-.16.76.49 1.91-1 2l-.45-1.14L22 128Z"
            className="templesOnly_svg__cls-77"
          />
          <path
            d="M19 122c.33-.33.66-.67 1-1h1v3h-1l-1-1Z"
            className="templesOnly_svg__cls-15"
          />
          <path
            d="M20 124h2l-1 1Z"
            style={{
              fill: "#d57845",
            }}
          />
          <path
            d="m19 123 1 1Z"
            style={{
              fill: "#b0521a",
            }}
          />
          <path
            d="M22 133v-3h1c.33 1 .66 2 1 3Z"
            style={{
              fill: "#9e400f",
            }}
          />
          <path
            d="M23 130h-1c-1.5-.09-.85-1.24-1-2h1c.33.33.66.67 1 1Z"
            style={{
              fill: "#903609",
            }}
          />
          <path
            d="M24 137c1.49-.09.84-1.24 1-2l1-1h2v2l-.83.33.83.67v11h-3v-6c-.34-1-.67-2-1-3z"
            style={{
              fill: "#ce6427",
            }}
          />
          <path
            d="M28 134h-2l-1-1c.08-.87-.44-2.07 1.23-2 .25 0 .51-.62.77-1h1zm-1.67-1h.33v-1h-.33Z"
            style={{
              fill: "#a04210",
            }}
          />
          <path
            d="M27 130c-.26.33-.52 1-.77 1-1.67 0-1.15 1.18-1.23 2h-1c-.34-1-.67-2-1-3v-1h1c.33.33.66.67 1 1z"
            style={{
              fill: "#ab4c20",
            }}
          />
          <path
            d="M7 279v-7a6 6 0 0 1 1 .52c.08.07 0 .31 0 .48l1 2c-1.35 0-.86 1-1 1.75s.68 2.13-1 2.25"
            style={{
              fill: "#f0b57e",
            }}
          />
          <path
            d="m9 275-1-2h2v1l1 1c-.09 1.5-1.25.85-2 1Z"
            style={{
              fill: "#d19e6d",
            }}
          />
          <path
            d="M22 187v-1a9 9 0 0 1 1 .76c.37.38.67.83 1 1.24v1c-1.5.09-.85 1.24-1 2v6.13l2-1.13-.75 5.27L25 204l-1 1h-1c-1.44-3.75-1-7.66-1-11.53z"
            style={{
              fill: "#cc6a29",
            }}
          />
          <path
            d="m24 247-1-1 .55-2.91-1.73-3.46 1.18-2.48c-1.41-1.34.22-2.71.09-4.12-.15-1.65 0-3.32 0-5h1v4c-.71 5.73 1.3 11.3 1 17-.16.76.49 1.91-1 2Z"
            className="templesOnly_svg__cls-88"
          />
          <path
            d="M19 218h2v-3c1.92.33 1.18 2.09.9 2.68a6.67 6.67 0 0 0 0 6.6c.28.52.39 1.71-.94 1.72H20q-.51-3-1-6Z"
            style={{
              fill: "#ab632c",
            }}
          />
          <path
            d="M23 227c0-2-.11-4 0-5.94a13.5 13.5 0 0 1 1-3.06c2.36 1 .09 1.91 0 3a4.77 4.77 0 0 1 0 6ZM24 218c-.29-.12-.81-.23-.82-.35v-8.3c0-.12.53-.23.82-.35.84 3.38.83 3.37 0 7.53a7.2 7.2 0 0 0 0 1.47M23 205h1v2l-2.14-1.56ZM24 209v-2l1 .76c-.3.45-.63.87-1 1.24"
            className="templesOnly_svg__cls-90"
          />
          <circle
            cx={23.54}
            cy={227.54}
            r={0.71}
            className="templesOnly_svg__cls-91"
          />
          <path
            d="M28 262v-5h-3l1-1.6-.68-.58L26 252h1l2 1h1a16.6 16.6 0 0 0-1 3 31 31 0 0 0 0 4l1 1v1c-.09 1.5-1.25.85-2 1Z"
            style={{
              fill: "#da792b",
            }}
          />
          <path
            d="M27 252h-1l-1.61.87L24 252v-1c1.49-.09.84-1.24 1-2h2Z"
            style={{
              fill: "#d97330",
            }}
          />
          <path
            d="M25 257h1c.33 1 .66 2 1 3h-1c-1.89-.43-.58-2-1-3"
            style={{
              fill: "#db7f37",
            }}
          />
          <path d="M24 251v1l-1-1Z" className="templesOnly_svg__cls-88" />
          <path
            d="M24 251h-1a17.7 17.7 0 0 1 0-2.82c.07-.43.62-.79 1-1.18Z"
            className="templesOnly_svg__cls-46"
          />
          <path
            d="M22 185v-2c1.29-1.85 1.32-2.76.3-5.22A8 8 0 0 1 22 176h2v8Z"
            className="templesOnly_svg__cls-95"
          />
          <path
            d="M23 176h-1v-3.43L20 171c1.49-.09.84-1.24 1-2a2.47 2.47 0 0 1 2 3Z"
            style={{
              fill: "#c06426",
            }}
          />
          <path
            d="m22 185 2-1c.33.33.66.67 1 1v1l-.83.33.83.67v1h-1c-.34-.41-.64-.86-1-1.24a9 9 0 0 0-1-.76Z"
            style={{
              fill: "#c86123",
            }}
          />
          <path
            d="M25 158h1v8h-2c-.34-.67-.67-1.33-1-2 .75-.15 1.91.5 2-1v-1l-1.84-2.53L24 158Z"
            className="templesOnly_svg__cls-98"
          />
          <path
            d="M25 148h3v5l-2-2.3v4.3c-.34-.41-.94-.8-1-1.22z"
            style={{
              fill: "#d76a29",
            }}
          />
          <path
            d="M26 155v-4.3l2 2.3v4l-2 1Z"
            style={{
              fill: "#db712e",
            }}
          />
          <path
            d="M25 158h-4v-1h2l1.74-1Z"
            style={{
              fill: "#c65d1e",
            }}
          />
          <ellipse
            cx={23.54}
            cy={147.04}
            rx={0.35}
            ry={1.41}
            style={{
              fill: "#c2541d",
            }}
          />
          <path d="M24 137v1l-.83-.67Z" className="templesOnly_svg__cls-61" />
          <path
            d="M20 158h1v9c-.34-.33-.67-.67-1-1Z"
            style={{
              fill: "#b2612a",
            }}
          />
          <path
            d="M23 172a2.47 2.47 0 0 0-2-3v-2h4v2c0 1.93.05 3.86-.05 5.78 0 .42-.62.81-.95 1.22a17.7 17.7 0 0 0-.05-2.82c-.03-.39-.58-.75-.95-1.18"
            className="templesOnly_svg__cls-95"
          />
          <path
            d="M28 263c.75-.15 1.91.5 2-1h1v4h-4v-2a8 8 0 0 0 1-.05l-.15.14.7.82.31-.32a5.5 5.5 0 0 0-.86-.64 7 7 0 0 1 0-.95"
            className="templesOnly_svg__cls-104"
          />
          <path
            d="M22 262h5v2c-1.94.13-3.79 0-5-2"
            style={{
              fill: "#cd7d31",
            }}
          />
          <path
            d="M22 269v-1c.6-.11 1.22-.18 1.82-.34s1.45-.44 2.18-.66l1 1-1 1Z"
            style={{
              fill: "#c27f3f",
            }}
          />
          <path
            d="M21 267c-1-.38-2.54.93-3-1h4.82l.07.65Z"
            style={{
              fill: "#9c5b25",
            }}
          />
          <path
            d="m27 268-1-1 1-1h1v2Z"
            style={{
              fill: "#d7883f",
            }}
          />
          <path
            d="M27 264v-2h1v2Z"
            style={{
              fill: "#e58c3d",
            }}
          />
          <path
            d="M28 260v1l-1-1Z"
            style={{
              fill: "#e88533",
            }}
          />
          <path
            d="M7 280v-1c1.64-.16.8-1.44 1-2.25s-.33-1.74 1-1.75v1c.33 1 .66 2 1 3l-.83.33.83.67v3l-2-1H7Z"
            style={{
              fill: "#e7ad75",
            }}
          />
          <path
            d="M14 271h1l1 2v2l-1 2v-3c-.09-1.5-1.25-.85-2-1v-1Z"
            style={{
              fill: "#fed9ad",
            }}
          />
          <path d="m16 273-1-2h2l1 2z" className="templesOnly_svg__cls-75" />
          <ellipse
            cx={18.04}
            cy={270.54}
            className="templesOnly_svg__cls-74"
            rx={1.41}
            ry={0.71}
          />
          <path d="m14 271-1 1v-1Z" className="templesOnly_svg__cls-75" />
          <path
            d="M19 270v-1h3l1 2h-2l-1-1Z"
            style={{
              fill: "#ba804e",
            }}
          />
          <path
            d="M10 279c-.34-1-.67-2-1-3 .75-.15 1.91.5 2-1l1 1v1l-1 1Z"
            className="templesOnly_svg__cls-114"
          />
          <path
            d="M13 273c.75.15 1.91-.5 2 1-.34.41-.64.86-1 1.24a9 9 0 0 1-1 .76z"
            className="templesOnly_svg__cls-75"
          />
          <circle
            cx={12.54}
            cy={276.54}
            r={0.71}
            className="templesOnly_svg__cls-75"
          />
          <path
            d="m11 275-1-1Z"
            style={{
              fill: "#bf9063",
            }}
          />
          <path
            d="M13 273v1l-1-1Z"
            style={{
              fill: "#f4cda2",
            }}
          />
          <path d="M13 273h-1l1-1Z" className="templesOnly_svg__cls-75" />
          <path
            d="M21 123v-2h1c.08 1.5 1.24.85 2 1v2h-2Z"
            style={{
              fill: "#7d2b03",
            }}
          />
          <path
            d="M24 127c1.49-.09.84-1.24 1-2h1l1 1v2h-3Z"
            style={{
              fill: "#832d07",
            }}
          />
          <path
            d="M24 127v2h-1c-.34-.33-.67-.67-1-1l1.55-2.14Z"
            style={{
              fill: "#7f2501",
            }}
          />
          <path
            d="M24 124v-1h1l1 1-1 1Z"
            style={{
              fill: "#9a461f",
            }}
          />
          <path d="m21 123 1 1h-1Z" className="templesOnly_svg__cls-77" />
          <path
            d="M28 154v-20c1.34 0 1 1 1 1.76V154Z"
            style={{
              fill: "#c7672a",
            }}
          />
          <path
            d="M28 136v1l-.83-.67Z"
            style={{
              fill: "#c3530f",
            }}
          />
          <path
            d="M29 154v-18.24c0-.72.36-1.75-1-1.76v-1c.33-.39 1-.8.94-1.17A5.9 5.9 0 0 1 30 128h1a32 32 0 0 0-1 4 41 41 0 0 0 0 4.45v22.25c0 .8.69 2.09-1 2.26Z"
            style={{
              fill: "#bb6a2d",
            }}
          />
          <path
            d="M30 128a5.9 5.9 0 0 0-1 3.87c0 .37-.61.78-.94 1.17v-3c-.16-.76.49-1.91-1-2v-2c.33-.33.66-.67 1-1h1c.36.96-.95 2.53.94 2.96"
            className="templesOnly_svg__cls-124"
          />
          <path
            d="M27 128c1.49.09.84 1.24 1 2h-1Z"
            style={{
              fill: "#8e3503",
            }}
          />
          <ellipse
            cx={26.54}
            cy={132.54}
            rx={0.24}
            ry={0.71}
            style={{
              fill: "#933505",
            }}
          />
          <path
            d="M24 129v-1h2v1l-1 1c-.3-.29-.63-.63-1-1"
            style={{
              fill: "#b2572e",
            }}
          />
          <path
            d="M26 129v-1h1v2h-1Z"
            style={{
              fill: "#933c11",
            }}
          />
          <path
            d="M26 129v1h-1Z"
            style={{
              fill: "#be663e",
            }}
          />
          <path
            d="M27 249h-2c.3-5.7-1.71-11.27-1-17l.82-.33L24 231v-4a4.77 4.77 0 0 0 0-6c.11-1.08 2.38-2 0-3a7.2 7.2 0 0 1 0-1.47c.82-4.16.83-4.15 0-7.53.33-.41.66-.83 1-1.24l-1-.76v-2l1-1v1.73l2.07.7c-.36.36-.8.59-.8.83-.1 4.44-1 9.08 0 13.26 1 4 .12 7.79.69 11.63-1.69 2.16-.81 4.69-1 7.07 0 .24.62.52 1 .78l.76 1.34-1.73 6Z"
            className="templesOnly_svg__cls-130"
          />
          <path
            d="M25 188v-3l-1-1v-5h1c.33-.39.88-.75.95-1.18A17.7 17.7 0 0 0 26 175h1v3c-.24.86-.47 1.73-.6 2.2.23 1.28.45 2.3.58 3.34s.13 2.24-.95 3c1.21.73 1 1.92 1 3V199l-1 1a17.7 17.7 0 0 1-.05 2.82c-.07.43-.62.79-.95 1.18l-.75-2.73L25 196Z"
            style={{
              fill: "#d96826",
            }}
          />
          <path
            d="M25 188v8l-2 1.13V191c1.49-.09.84-1.24 1-2v-1Z"
            className="templesOnly_svg__cls-132"
          />
          <path
            d="M24 189c-.16.76.49 1.91-1 2 .19-.72-.46-1.87 1-2"
            style={{
              fill: "#d5702e",
            }}
          />
          <path
            d="m24 231 .82.67-.82.33Z"
            className="templesOnly_svg__cls-91"
          />
          <path
            d="M31 262h-1v-1l-1-1a31 31 0 0 1 0-4 16.6 16.6 0 0 1 1-3v-68a17.7 17.7 0 0 0-.05-2.82c-.07-.43-.62-.79-.95-1.18v-18c1.94 1.91 2 4.35 2 6.84v84.1c0 1.75-.33 3.57 1 5.06-1.89.51-.58 2.06-1 3"
            style={{
              fill: "#d48139",
            }}
          />
          <path
            d="m27 249-1-1.68 1.73-6L27 240a37 37 0 0 1 0-3.8c.05-.43.62-.8 1-1.2 0 1.73-.32 3.53 1 5v13l-2-1Z"
            style={{
              fill: "#e77a36",
            }}
          />
          <path
            d="M28 260h-1c-.34-1-.67-2-1-3h2Z"
            style={{
              fill: "#e48138",
            }}
          />
          <ellipse
            cx={29.54}
            cy={252.04}
            className="templesOnly_svg__cls-137"
            rx={0.71}
            ry={1.41}
          />
          <path d="m29 260 1 1Z" className="templesOnly_svg__cls-104" />
          <path
            d="M26 175a17.7 17.7 0 0 1-.05 2.82c-.07.43-.62.79-.95 1.18l-1-1v-2c.33-.41.93-.8.95-1.22.1-1.92.05-3.85.05-5.78h1c.33 1 .66 2 1 3v1c-1.46.13-.81 1.28-1 2"
            style={{
              fill: "#d46420",
            }}
          />
          <path
            d="M23 172c.33.39.88.75.95 1.18A17.7 17.7 0 0 1 24 176h-1Z"
            style={{
              fill: "#c55d24",
            }}
          />
          <path
            d="m24 178 1 1h-1ZM25 186v1l-.83-.67ZM24 184l1 1c-.3-.29-.63-.63-1-1"
            className="templesOnly_svg__cls-132"
          />
          <path
            d="M27 172c-.34-1-.67-2-1-3a12 12 0 0 1 .62-1.11c.59-.91.75-1.65-.62-1.89v-6l2 1h1v1l-1 .76c.33.41.66.83 1 1.24v1l-.83.33.83.67v3l-.83.33.83.67v1l-1 1Z"
            className="templesOnly_svg__cls-140"
          />
          <path
            d="M22 158h2l-.84 1.47L25 162h-3Z"
            style={{
              fill: "#c66020",
            }}
          />
          <path
            d="M26 166c1.37.24 1.21 1 .62 1.89A12 12 0 0 0 26 169h-1v-2h-2v-1z"
            style={{
              fill: "#cd5f1b",
            }}
          />
          <path d="m28 161-2-1v-2l2-1Z" className="templesOnly_svg__cls-143" />
          <path
            d="M24 166h-3v-2h2c.37.71.7 1.37 1 2"
            className="templesOnly_svg__cls-95"
          />
          <path
            d="M22 162h3v1h-2c-.3-.29-.63-.63-1-1"
            style={{
              fill: "#cb6524",
            }}
          />
          <path
            d="M23 163h2c-.09 1.5-1.25.85-2 1Z"
            style={{
              fill: "#d46c2c",
            }}
          />
          <path d="M28 161v-7h1v7Z" className="templesOnly_svg__cls-146" />
          <ellipse
            cx={21.54}
            cy={160.04}
            rx={0.71}
            ry={2.83}
            style={{
              fill: "#c26326",
            }}
          />
          <path
            d="M21 162h1c.33.33.66.67 1 1v1h-2Z"
            className="templesOnly_svg__cls-98"
          />
          <ellipse
            cx={22.04}
            cy={166.54}
            rx={1.41}
            ry={0.71}
            style={{
              fill: "#bf5d1c",
            }}
          />
          <path
            d="M28 268v-2h2l1 1v1l-1 1h-2Z"
            style={{
              fill: "#d07c36",
            }}
          />
          <path
            d="m31 267-1-1h1Z"
            style={{
              fill: "#dc8543",
            }}
          />
          <path
            d="m28.13 263.94.81.69-.31.32-.7-.82Z"
            style={{
              fill: "#c0641e",
            }}
          />
          <path
            d="m23 271-1-2h4l1 1v1c-.76.15-1.92-.5-2 1-.72-.11-1.88.54-2-1"
            style={{
              fill: "#a4692f",
            }}
          />
          <path
            d="m27 270-1-1 1-1h1v2Z"
            style={{
              fill: "#b87731",
            }}
          />
          <path
            d="M11 282h-1v-3l1-1h1a5.4 5.4 0 0 1-1 4"
            style={{
              fill: "#f3c289",
            }}
          />
          <path d="M10 279v1l-.83-.67Z" className="templesOnly_svg__cls-114" />
          <path
            d="m20 270 1 1v10c-.76.15-1.92-.5-2 1l-1.61-.87c-.1.22-.25.54-.39.87h-1c.4-1.31.81-2.61 1-3.32l3.15-2.22L18 275h-2v-2h1l.32.83.68-.83-1-2h2Z"
            style={{
              fill: "#daaa78",
            }}
          />
          <path
            d="M16 275h2c0 .31.13.75 0 .92-1 1.06-2 2.06-3 3.08h-1v-1l-1-1v-1a9 9 0 0 0 1-.76c.37-.38.67-.83 1-1.24v3Z"
            style={{
              fill: "#fdd0a0",
            }}
          />
          <path
            d="m18 273-.68.83L17 273Z"
            style={{
              fill: "#cda575",
            }}
          />
          <path
            d="m20 270-1 1v-1Z"
            style={{
              fill: "#e0b580",
            }}
          />
          <path
            d="M21 277v-6h1v2h2v1c-.67.75-1.32 1.52-2 2.25a8 8 0 0 1-1 .75"
            className="templesOnly_svg__cls-159"
          />
          <path
            d="M24 273h-2v-2h1c.08 1.5 1.24.85 2 1v1Z"
            style={{
              fill: "#a1622a",
            }}
          />
          <path d="M12 278h-1l1-1Z" className="templesOnly_svg__cls-75" />
          <path
            d="M12 278v-1h1v1l1 1h1c-.34 1-.67 2-1 3v1l-3-1a5.4 5.4 0 0 0 1-4"
            style={{
              fill: "#faca91",
            }}
          />
          <path
            d="M22 121v-2h1c.08 1.5 1.24.85 2 1v2h-1c-.72-.11-1.88.54-2-1"
            style={{
              fill: "#a24118",
            }}
          />
          <circle
            cx={24.54}
            cy={122.54}
            r={0.71}
            style={{
              fill: "#a9502b",
            }}
          />
          <path
            d="m27 126-1-1h1Z"
            style={{
              fill: "#711d00",
            }}
          />
          <path
            d="m25 125 1-1v1Z"
            style={{
              fill: "#9e4d28",
            }}
          />
          <path
            d="M26 125v-1l-1-1v-1h2v3Z"
            style={{
              fill: "#84320d",
            }}
          />
          <path
            d="M32 123c-.34 1.67-.67 3.33-1 5h-1v-4Z"
            className="templesOnly_svg__cls-124"
          />
          <path
            d="M30 124v1h-2v-2h2Z"
            style={{
              fill: "#963d0f",
            }}
          />
          <path
            d="M28 123v2c-.34.33-.67.67-1 1v-3Z"
            style={{
              fill: "#863108",
            }}
          />
          <path
            d="M29 125h1v3c-1.89-.43-.58-2-1-3"
            style={{
              fill: "#923d0b",
            }}
          />
          <path
            d="M28 235c-.34.4-.91.77-1 1.2a37 37 0 0 0 0 3.8c-.34-.26-1-.54-1-.78.15-2.38-.73-4.91 1-7.07-.57-3.84.29-7.64-.69-11.63-1-4.18-.14-8.82 0-13.26 0-.24.44-.47.8-.83l-2.07-.7V204c.33-.39.88-.75.95-1.18A17.7 17.7 0 0 0 26 200l1-1v-5h2v2c-1.61.14-.85 1.38-1 2.18-.26 1.47.6 3.18-1 4.37 1.38.86.85 2.24 1 3.45v2l-1 2.09 1.13 2-1.12 2 1.19 2-1 1.61 2.09.74-1.88.89L28 222c0 2-.05 3.92 0 5.87s-.27 4.14.23 6.13H30v1Z"
            className="templesOnly_svg__cls-91"
          />
          <path
            d="M27 172h1v2c.15.76-.5 1.91 1 2v5a2.47 2.47 0 0 0 0 4c-.34 1.67-.67 3.33-1 5-.39 1 .92 2.53-1 3v-3.43c0-1.11.24-2.3-1-3 1.08-.76 1.1-1.87.95-3s-.35-2.06-.58-3.34c.13-.47.36-1.34.6-2.2l.82-.33-.79-.7z"
            style={{
              fill: "#e57b34",
            }}
          />
          <path
            d="M27 193c1.92-.47.61-2 1-3l2-1v7h-1v-2h-2Z"
            className="templesOnly_svg__cls-171"
          />
          <path
            d="M27 173v2h-1c.19-.72-.46-1.87 1-2"
            className="templesOnly_svg__cls-140"
          />
          <path d="m27 199-1 1Z" className="templesOnly_svg__cls-171" />
          <path
            d="m27 177 .82.67-.82.33Z"
            className="templesOnly_svg__cls-172"
          />
          <path
            d="m28 222-.71-2.7 1.88-.89-2.09-.74 1-1.61-1.19-2 1.12-2-1.13-2L28 208a9 9 0 0 1 1 .76c.37.38.67.83 1 1.24v1q-2.055 1.5 0 3v14h-1c0-1.6.06-3.2-.05-4.79.05-.38-.58-.77-.95-1.21"
            className="templesOnly_svg__cls-173"
          />
          <path
            d="M28 222c.33.4.92.79.95 1.21.11 1.59.05 3.19.05 4.79.15.76-.5 1.91 1 2v4h-1.72c-.5-2-.18-4.08-.23-6.13S28 224 28 222"
            className="templesOnly_svg__cls-174"
          />
          <path
            d="M30 210c-.34-.41-.64-.86-1-1.24a9 9 0 0 0-1-.76v-2c.33-.41.94-.82.95-1.24.09-2.92.05-5.84.05-8.76h1Z"
            className="templesOnly_svg__cls-137"
          />
          <path
            d="M28 235h2v5h-1c-1.28-1.43-.94-3.23-1-5"
            className="templesOnly_svg__cls-174"
          />
          <ellipse
            cx={29.54}
            cy={244.04}
            className="templesOnly_svg__cls-137"
            rx={0.71}
            ry={5.66}
          />
          <path
            d="m30 189-2 1c.33-1.67.66-3.33 1-5h1Z"
            className="templesOnly_svg__cls-172"
          />
          <path
            d="M30 185h-1v-4c.33.39.88.75.95 1.18A17.7 17.7 0 0 1 30 185"
            className="templesOnly_svg__cls-132"
          />
          <ellipse
            cx={29.54}
            cy={249.54}
            rx={0.71}
            ry={2.12}
            style={{
              fill: "#d57c37",
            }}
          />
          <path d="M28 174v-2l1-1v3Z" className="templesOnly_svg__cls-172" />
          <path
            d="M30 214q-2.055-1.5 0-3Z"
            className="templesOnly_svg__cls-137"
          />
          <path
            d="M29 162v2c-.34-.41-.67-.83-1-1.24Z"
            className="templesOnly_svg__cls-146"
          />
          <path
            d="M30 230c-1.5-.09-.85-1.24-1-2h1Z"
            className="templesOnly_svg__cls-137"
          />
          <path
            d="M28 174h1v2c-1.46 0-.81-1.2-1-2"
            className="templesOnly_svg__cls-140"
          />
          <path
            d="m29 170-.83-.67.83-.33Z"
            className="templesOnly_svg__cls-143"
          />
          <path
            d="m29 166-.83-.67.83-.33Z"
            className="templesOnly_svg__cls-172"
          />
          <path
            d="M28 270v-1h2l1-1v-2h1v6h-1l-1-1c0-1.46-1.21-.81-2-1"
            style={{
              fill: "#c47d3c",
            }}
          />
          <path
            d="m31 268-1 1Z"
            style={{
              fill: "#c17432",
            }}
          />
          <path
            d="M25 272c.08-1.5 1.24-.85 2-1 .86.08 2.07-.44 2 1.24 0 .25.62.51 1 .76v1h-1l-1 1v2h-1a5.9 5.9 0 0 1-1-3.79c0-.37-.63-.78-1-1.21"
            style={{
              fill: "#cb8d48",
            }}
          />
          <path
            d="M30 273c-.34-.25-1-.51-1-.76 0-1.68-1.18-1.16-2-1.24v-1h1c.75.15 1.91-.5 2 1Z"
            style={{
              fill: "#c78443",
            }}
          />
          <path
            d="M27 117h1v1c-1.5.09-.85 1.24-1 2-.34.33-.67.67-1 1v1h-1v-3a9 9 0 0 0 1-.76c.4-.34.7-.79 1-1.24"
            style={{
              fill: "#872d08",
            }}
          />
          <path
            d="M25 272c.33.39 1 .8.94 1.17A5.9 5.9 0 0 0 27 277l-1.52 1.23-.81-2.06c-2 .65-1.67 2.31-1.67 3.83l-2 1v-4a8 8 0 0 0 1-.75c.69-.73 1.34-1.5 2-2.25l1-1Z"
            className="templesOnly_svg__cls-181"
          />
          <path
            d="M15 282h-1c.33-1 .66-2 1-3 1-1 2-2 3-3.08.16-.17 0-.61 0-.92l2.18 1.46-3.15 2.22c-.22.71-.63 2-1 3.32ZM14 279l-1-1h1Z"
            className="templesOnly_svg__cls-182"
          />
          <path d="M14 278h-1v-1Z" className="templesOnly_svg__cls-75" />
          <path
            d="m25 273-1 1v-1Z"
            style={{
              fill: "#9e5a17",
            }}
          />
          <path
            d="M28 123h-1v-1l2-1v2Z"
            style={{
              fill: "#9a411b",
            }}
          />
          <path
            d="M26 122v-1l1 1Z"
            style={{
              fill: "#6e1400",
            }}
          />
          <path
            d="M30 124v-3c.33-.41.63-.86 1-1.24a8.5 8.5 0 0 1 1-.76v4Z"
            style={{
              fill: "#8e3e1d",
            }}
          />
          <ellipse
            cx={29.54}
            cy={122.04}
            rx={0.71}
            ry={1.41}
            style={{
              fill: "#a3471f",
            }}
          />
          <path
            d="M29 196c0 2.92 0 5.84-.05 8.76 0 .42-.62.83-.95 1.24-.11-1.21.42-2.59-1-3.45 1.57-1.19.71-2.9 1-4.37.19-.76-.57-2 1-2.18"
            className="templesOnly_svg__cls-173"
          />
          <path
            d="M29 181v4a2.47 2.47 0 0 1 0-4"
            className="templesOnly_svg__cls-172"
          />
          <path
            d="M31 272v1h-1v-2Z"
            style={{
              fill: "#b27336",
            }}
          />
          <path
            d="M23 280c0-1.52-.34-3.18 1.67-3.83l.81 2.06L27 277h1l3-1v3c-.73.22-1.45.48-2.18.66s-1.22.23-1.82.34c-.23-.33-.53-1-.68-1-1.09.33-2.18.71-3.32 1"
            className="templesOnly_svg__cls-159"
          />
          <path
            d="m31 276-3 1v-2l1-1h2z"
            className="templesOnly_svg__cls-181"
          />
          <path
            d="m29 274-1 1Z"
            style={{
              fill: "#bb6923",
            }}
          />
          <circle
            cx={30.54}
            cy={273.54}
            r={0.71}
            style={{
              fill: "#ae6d30",
            }}
          />
          <path
            d="M28 120c.75.15 1.91-.5 2 1h-1l-2 1-1-1c.33-.33.66-.67 1-1Z"
            style={{
              fill: "#89300c",
            }}
          />
          <path
            d="m24 282-1-2c1.1-.33 2.19-.71 3.32-1 .15 0 .45.62.68 1l-2.44.43L26 281v1Z"
            style={{
              fill: "#774018",
            }}
          />
          <path
            d="m31 279 1 1v1h-5v-1c.6-.11 1.22-.18 1.82-.34s1.49-.4 2.18-.66"
            style={{
              fill: "#66350d",
            }}
          />
        </g>
        <g id="templesOnly_svg__column6" ref={el => columnRefs.current[5] = el}>
          <path
            d="M193.91 200c-.33 2.69-.79 5.36-1 8.05s0 5.3 0 7.95a17.7 17.7 0 0 1 0 2.82c-.07.44-.62.79-1 1.18l-1-1-1-1v-2c.28-.11.76-.17.81-.35.53-1.94-.27-4.08 1.09-6 .3-.42 1-2.33-.9-2.67v-1a2.48 2.48 0 0 0 0-4V186h1a19 19 0 0 0 0 2.82c.08.44.63.79 1 1.18v1a4.3 4.3 0 0 0-.81.34c.24 1.33.63 2.63.78 4s.11 2.91.22 4.36c.01.12.53.22.81.3"
            style={{
              fill: "#c76f35",
            }}
          />
          <path
            d="M191.91 162v7h-1v-1c0-3.81-.12-7.62.06-11.43a7.3 7.3 0 0 0-1.06-3.57v-9c-.33-1-.67-2-1-3v-9l1 1c-.52 3.34 1.33 6.38 1.21 9.68 0 .1.51.21.79.32z"
            style={{
              fill: "#a45821",
            }}
          />
          <path
            d="M190.91 74c1.66.17 1 1.47 1 2.27.05 8.58 0 17.16 0 25.73a17.7 17.7 0 0 1 0 2.82c-.07.44-.62.79-1 1.18l-1-1c1.47-1.81.92-4 1-6-.31-4.15.83-8.43-1-12.46.33-.36.68-.7 1-1.08.08-.1 0-.32 0-.49-.93-1.75-.93-1.9-.2-3.41-.47-.92-.89-1.74-1.3-2.56h-1.5v-2c.76-.15 1.91.5 2-1 .33-.33.67-.66 1-1Z"
            style={{
              fill: "#a15f2e",
            }}
          />
          <path
            d="M194.91 244c.64.88 1.28 1.75 1.41 1.94.69 2.18 1.14 3.62 1.59 5.06h-3l-4-.64V252h-4v-1l2-.25c-.4-.74-.68-1.24-1-1.75h4l2.39-.4c-1.24-1.85-1.26-4-3.39-4.6.33-.66.67-1.33 1-2Z"
            style={{
              fill: "#97562c",
            }}
          />
          <path
            d="M193.91 228v8c-.67.67-1.33 1.34-2 2h-1c.29-1.29.58-2.59.9-4.06l-1.9 1.06v-7h2l.39.88Z"
            style={{
              fill: "#a85a1e",
            }}
          />
          <path
            d="M191.91 170c.33.4.88.75 1 1.19a17.5 17.5 0 0 1 0 2.81c-2.55 1.87-2.63 2.19-1 4v5c-1.93.47-.62 2-1 3l-1-1v-16h1v1c.11.64.23 1.27.34 1.9l.66-.06Z"
            style={{
              fill: "#c16728",
            }}
          />
          <path
            d="M190.91 106c.33-.39.88-.74 1-1.18a17.7 17.7 0 0 0 0-2.82c1.35 0 1 1 1 1.77V124h-1v-10c-.3-1.48-.61-3-.94-4.6l.7-.6c-.29-1.04-.53-1.9-.76-2.8"
            className="templesOnly_svg__cls-200"
          />
          <path
            d="M191.91 69c-.38 1 .93 2.54-1 3l-2 3-2-1.08-2 1.08h-1l.85-1.5-.85-1.5c.76-.15 1.91.5 2-1 .37.21.76.39 1.11.63.91.59 1.65.75 1.89-.63.67-.66 1.33-1.33 2-2Z"
            style={{
              fill: "#7a2d0d",
            }}
          />
          <path
            d="M196.91 251h1l2 1v1l3 3c-.12.8.46 1.89-1.08 2.05a6.3 6.3 0 0 0-1.92.95c-.38-1 .93-2.53-1-3-.67-1.63-1.33-3.3-2-5"
            style={{
              fill: "#7c482d",
            }}
          />
          <path
            d="M191.91 238c.67-.66 1.33-1.33 2-2 .53 1.13 1.26 2.13 1.05 3.56a30 30 0 0 0-.05 4.44l-3-2c.27-.48.53-1 .87-1.6l-.87-.4Z"
            style={{
              fill: "#9e643b",
            }}
          />
          <path
            d="M191.91 228h-1c.24-.86.47-1.72.68-2.5-.21-.78-.44-1.64-.68-2.5 1.93-.46.62-2 1-3 .33-.39.88-.74 1-1.18a17.7 17.7 0 0 0 0-2.82c.33.4.91.78 1 1.2a37 37 0 0 1 0 3.8c-1.6.14-.94 1.38-1 2.17-.04 1.71.16 3.42-1 4.83"
            style={{
              fill: "#b46831",
            }}
          />
          <path
            d="M191.91 124h1v14h-1v-4c-.06-2.52.47-5.12-.82-7 .35-1.25.59-2.11.82-3"
            className="templesOnly_svg__cls-205"
          />
          <path
            d="M191.91 162v-14h1v12.26c-.02.74.34 1.74-1 1.74"
            style={{
              fill: "#925623",
            }}
          />
          <path
            d="M188.91 60h1a5.34 5.34 0 0 0 1 4l1 1v1l1 1c-.33.34-.67.67-1 1h-1c-.15-.75.5-1.91-1-2l-2-2v-1c1.93-.43.62-2 1-3"
            style={{
              fill: "#873b13",
            }}
          />
          <path
            d="M193.91 200c-.28-.11-.8-.21-.81-.34-.11-1.45 0-2.92-.22-4.36s-.54-2.63-.78-4a4.3 4.3 0 0 1 .81-.34l1 1Z"
            style={{
              fill: "#c37b43",
            }}
          />
          <path
            d="M191.91 66v-1l-1-1a5.34 5.34 0 0 1-1-4l3 2.39V66Z"
            style={{
              fill: "#802d08",
            }}
          />
          <path
            d="M191.91 228c1.16-1.44 1-3.15 1-4.83 0-.79-.63-2 1-2.17v7l-1.61.88Z"
            style={{
              fill: "#aa662a",
            }}
          />
          <path
            d="m193.91 192-1-1v-8h1Z"
            style={{
              fill: "#b26e30",
            }}
          />
          <path
            d="M193.91 183h-2v-1c.33-.39.91-.77 1-1.2a37 37 0 0 0 0-3.8c.33.41.92.79 1 1.22.09 1.62 0 3.22 0 4.78"
            style={{
              fill: "#ae682c",
            }}
          />
          <path
            d="M192.91 177a37 37 0 0 1 0 3.8c0 .43-.62.81-1 1.2v-4c.15-.75-.5-1.91 1-2Z"
            style={{
              fill: "#af6326",
            }}
          />
          <path
            d="M192.91 176c-1.5.09-.85 1.25-1 2-1.63-1.81-1.55-2.13 1-4Z"
            style={{
              fill: "#c26d2d",
            }}
          />
          <ellipse
            cx={192.41}
            cy={145.53}
            className="templesOnly_svg__cls-205"
            rx={0.71}
            ry={3.54}
          />
          <ellipse
            cx={192.41}
            cy={140.53}
            rx={0.71}
            ry={3.54}
            style={{
              fill: "#8c5427",
            }}
          />
          <path
            d="m188.91 75 2-3v3Z"
            style={{
              fill: "#5f1d00",
            }}
          />
          <circle
            cx={191.41}
            cy={169.53}
            r={0.71}
            className="templesOnly_svg__cls-217"
          />
          <circle
            cx={191.41}
            cy={68.53}
            r={0.71}
            className="templesOnly_svg__cls-218"
          />
          <path
            d="m189.91 185 1 1v15c-.33.34-.67.67-1 1h-1l-1-1 2.19-1.72c-.35-.59-.73-1.22-1.07-1.77l1.22-1.78-2.34-1.73-1-1c.22-.72.48-1.44.66-2.17s.23-1.22.34-1.83c.23-.85.46-1.71.74-2.71l-.74-1.29z"
            style={{
              fill: "#bc591f",
            }}
          />
          <path
            d="M190.91 207c1.93.34 1.2 2.25.9 2.67-1.36 1.9-.56 4-1.09 6-.05.18-.53.24-.81.35h-1c0-2.05-1.7-3.82-1-6 .33-.24 1-.58 1-.72a25 25 0 0 0-1.07-2.73l2.12-1.55c.15 1.63-.31 3.33 1 4.84Z"
            className="templesOnly_svg__cls-220"
          />
          <path
            d="M188.91 216h1v7l-2 1h-1v-1c2.21-.56 2.08-2.29 2-4z"
            style={{
              fill: "#c26223",
            }}
          />
          <path
            d="M190.91 207v2.84c-1.31-1.51-.85-3.21-1-4.84v-3h1z"
            style={{
              fill: "#b95b19",
            }}
          />
          <path
            d="M189.91 223v-3c.33-.33.67-.66 1-1l1 1c-.38 1 .93 2.54-1 3Z"
            style={{
              fill: "#c86c2e",
            }}
          />
          <path
            d="M191.91 183h1v7c-.33-.39-.88-.74-1-1.18a19 19 0 0 1 0-2.82Z"
            style={{
              fill: "#bf7132",
            }}
          />
          <path
            d="M190.91 206v-4a2.48 2.48 0 0 1 0 4"
            className="templesOnly_svg__cls-220"
          />
          <path
            d="M191.91 183v3h-1c.38-.95-.91-2.5 1-3"
            style={{
              fill: "#cb7434",
            }}
          />
          <path
            d="M190.91 219c-.33.34-.67.67-1 1v-2Z"
            style={{
              fill: "#d07233",
            }}
          />
          <path
            d="M190.91 202h-1c.33-.33.67-.66 1-1Z"
            className="templesOnly_svg__cls-220"
          />
          <path
            d="M190.91 169h-2l-3 1-2-1.59V171h-1c-.25-.33-.44-.87-.76-1-1.57-.45-2.46-1.31-2.24-3v-4h1l4 1.13V162h2l2 3a2.46 2.46 0 0 0 2 3Z"
            style={{
              fill: "#b2511c",
            }}
          />
          <path
            d="M191.91 124c-.23.86-.47 1.72-.82 3 1.29 1.85.76 4.45.82 7l-2-1-1-1v-2l1.08-2c-.37-.68-.73-1.34-1.08-2v-3l2.44-.42-1.44-.58a5.34 5.34 0 0 0 1-4h1Z"
            style={{
              fill: "#945225",
            }}
          />
          <path
            d="M188.91 137v4c-.33.41-.93.8-.95 1.23-.11 1.92-.05 3.85-.05 5.77h-1v-5c-.33-1.66-.67-3.33-1-5v-2h1c.09 1.53 1.24.88 2 1"
            style={{
              fill: "#b5551d",
            }}
          />
          <path
            d="M187.91 148c0-1.92-.06-3.85.05-5.77 0-.43.62-.82.95-1.23.33 1 .67 2 1 3q-2.055 1.5 0 3v6h-2z"
            style={{
              fill: "#b75c25",
            }}
          />
          <path
            d="M188.91 153h1a7.3 7.3 0 0 1 1.09 3.6c-.18 3.81-.06 7.62-.06 11.43a2.46 2.46 0 0 1-2-3h.48a19.66 19.66 0 0 0 0-10s-.31 0-.48 0v-2Z"
            style={{
              fill: "#c06628",
            }}
          />
          <path
            d="m189.91 133 2 1v9c-.28-.11-.8-.22-.79-.32.12-3.27-1.73-6.31-1.21-9.68"
            style={{
              fill: "#9e5727",
            }}
          />
          <path
            d="M188.91 137c-.76-.15-1.91.5-2-1 .33-.41 1-.9.93-1.23a14.4 14.4 0 0 0-1.29-2.77h2.36Z"
            style={{
              fill: "#b45c23",
            }}
          />
          <path
            d="M189.91 147q-2.055-1.5 0-3Z"
            style={{
              fill: "#b5602c",
            }}
          />
          <path
            d="M190.91 106c.23.87.47 1.73.76 2.8l-.7.6c.33 1.63.64 3.12.94 4.6h-1c-.09-1.49-1.24-.84-2-1a17.5 17.5 0 0 0 0-2.81c-.07-.44-.62-.79-1-1.19h-1c.33-.66.67-1.33 1-2 .33-.24 1-.5 1-.73a17.8 17.8 0 0 1 1-7.27h1c-.08 2 .47 4.19-1 6Z"
            style={{
              fill: "#a35b25",
            }}
          />
          <path
            d="M190.91 99h-1V89l-2.08-1.47 1-.19c-.47-1.79 1.36-3.62-.88-5.39V79h1.5c.41.82.83 1.64 1.3 2.56-.73 1.51-.73 1.66.2 3.41 0 .17.07.39 0 .49-.31.38-.66.72-1 1.08 1.79 4.06.65 8.34.96 12.46"
            className="templesOnly_svg__cls-236"
          />
          <path
            d="M188.91 75h2c-.33.34-.67.67-1 1-.76.16-1.91-.49-2 1v1h-2c-.33-1-.67-2-1-3l2-1.08Z"
            style={{
              fill: "#a55824",
            }}
          />
          <path
            d="M187.91 77c.09-1.49 1.24-.84 2-1-.09 1.53-1.24.88-2 1"
            style={{
              fill: "#b66e36",
            }}
          />
          <path d="m190.91 106-1-1Z" className="templesOnly_svg__cls-200" />
          <path d="M186.91 78h1v1Z" className="templesOnly_svg__cls-239" />
          <path
            d="m191.91 240 .87.4c-.34.63-.6 1.12-.87 1.6-.33.67-.67 1.34-1 2l-2 .26c.4.74.68 1.24 1 1.74l-3-1v-1l-1-1v-1h1a4.58 4.58 0 0 0 4-2Z"
            style={{
              fill: "#a35823",
            }}
          />
          <path
            d="M196.91 251c.67 1.67 1.33 3.34 2 5-.33.4-.88.75-1 1.19a19 19 0 0 0 0 2.81h-1c-.38-1 .93-2.53-1-3v-6Z"
            style={{
              fill: "#9a5421",
            }}
          />
          <path
            d="M189.91 246c-.28-.5-.56-1-1-1.74l2-.26c2.13.64 2.15 2.75 3.39 4.6l-2.39.4-1-1c-.15-.72.5-1.88-1-2"
            style={{
              fill: "#98491f",
            }}
          />
          <path
            d="M187.91 249c.28.51.56 1 1 1.75l-2 .25h-4v-1l2-.25c-.4-.74-.68-1.24-1-1.75h3Z"
            style={{
              fill: "#b67e4d",
            }}
          />
          <path
            d="M190.91 252v-1.64l4 .64v2h-4Z"
            style={{
              fill: "#874517",
            }}
          />
          <path
            d="m190.91 248 1 1h-4c.47-1.89 2.02-.58 3-1"
            className="templesOnly_svg__cls-245"
          />
          <path
            d="M185.91 251h1v3h-1z"
            style={{
              fill: "#c99568",
            }}
          />
          <path
            d="M186.91 254v-2h2v1Z"
            style={{
              fill: "#894f23",
            }}
          />
          <path
            d="M188.91 253v-1h2v1c-.33.34-.67.67-1 1Z"
            className="templesOnly_svg__cls-245"
          />
          <ellipse
            cx={195.41}
            cy={252.03}
            rx={0.71}
            ry={1.41}
            style={{
              fill: "#8e3d0e",
            }}
          />
          <path
            d="M190.91 240a4.58 4.58 0 0 1-4 2v-2a2.48 2.48 0 0 0 0-4h-1v-1h2l1.61.88.39-.88 1.9-1.06c-.32 1.47-.61 2.77-.9 4.06h-1c-.33.34-.67.67-1 1 .09 1.53 1.24.88 2 1"
            className="templesOnly_svg__cls-249"
          />
          <path
            d="M189.91 223h1c.24.86.47 1.72.68 2.5-.21.78-.44 1.64-.68 2.5h-1c-.09-.66-.17-1.32-.26-2l-1.74 1v-3Z"
            style={{
              fill: "#c6692b",
            }}
          />
          <path
            d="m189.91 235-.39.88-1.61-.88.94-1.64-.68-.59c.28-1.06.51-1.91.74-2.77s-.5-1.91 1-2Z"
            className="templesOnly_svg__cls-251"
          />
          <path
            d="M190.91 240c-.76-.15-1.91.5-2-1 .33-.33.67-.66 1-1h2v2Z"
            style={{
              fill: "#bd7034",
            }}
          />
          <path
            d="M182.91 171h1c.25.34.5.67.76 1l1.24-1v-1l3-1 1 1v15h-1v-9l-.19-4c-.78.45-1.3.74-1.81 1a7.78 7.78 0 0 0-4 3Z"
            style={{
              fill: "#bc5b1e",
            }}
          />
          <path
            d="M190.91 170h1v1.84l-.66.06c-.11-.6-.25-1.23-.34-1.9"
            style={{
              fill: "#bc7a46",
            }}
          />
          <path d="m189.91 170-1-1h1Z" className="templesOnly_svg__cls-217" />
          <path
            d="M190.91 114h1v2h-2c-.29-.56-.58-1.13-1-2Z"
            style={{
              fill: "#7e3403",
            }}
          />
          <path
            d="M189.91 116h2v2h-1c-1.5 0-.85-1.21-1-2"
            style={{
              fill: "#8e4e21",
            }}
          />
          <path
            d="M184.91 75c.33 1 .67 2 1 3l-.75 2.76 2 .76-1.27.48h-2v-7Z"
            className="templesOnly_svg__cls-239"
          />
          <path
            d="M188.91 71c-.24 1.38-1 1.22-1.89.63-.35-.24-.74-.42-1.11-.63v-1c.33-.33.67-.66 1-1h2l-.91 1.64Z"
            style={{
              fill: "#611c03",
            }}
          />
          <path
            d="m183.91 72 .85 1.5-.85 1.5-1-1v-2Z"
            style={{
              fill: "#5f1700",
            }}
          />
          <path
            d="m188.91 71-.87-.39.87-1.61h2c-.67.7-1.33 1.37-2 2"
            className="templesOnly_svg__cls-218"
          />
          <path
            d="M185.91 71c-.09 1.5-1.24.85-2 1v-1Z"
            style={{
              fill: "#8c3f26",
            }}
          />
          <path
            d="M199.91 259a6.3 6.3 0 0 1 1.92-.95c1.54-.16 1-1.25 1.08-2.05h1v3h-2v2h-2c-.27-.48-.53-1-.87-1.6Z"
            style={{
              fill: "#6d3515",
            }}
          />
          <path
            d="m199.91 259-.87.4c.34.63.6 1.12.87 1.6h-2v-1a19 19 0 0 1 0-2.81c.08-.44.63-.79 1-1.19 1.93.5.62 2.05 1 3"
            style={{
              fill: "#914d28",
            }}
          />
          <path
            d="M199.91 253h4v1c-1.5.09-.85 1.25-1 2Z"
            style={{
              fill: "#62452f",
            }}
          />
          <path
            d="M203.93 254v-1h1v8l-1 1c-.34-.33-.67-.66-1-1 1.49-.08.84-1.24 1-2z"
            style={{
              fill: "#7a5a29",
            }}
          />
          <path
            d="M188.91 67c.33-.33.67-.66 1-1 1.5.09.85 1.25 1 2h-2Z"
            className="templesOnly_svg__cls-218"
          />
          <path
            d="M188.91 68h2v1h-4c.09-1.46 1.24-.81 2-1"
            style={{
              fill: "#83381e",
            }}
          />
          <path
            d="M189.91 203v2l-2.12 1.55a25 25 0 0 1 1.07 2.73c0 .14-.62.48-1 .78l.15-.15-.69-.81-.32.31a6 6 0 0 0 .86.65c-.65 2.12 1 3.89 1 5.94v1h-1v-2h-2v-4l-.33-.82-.67.82v1h-1a19 19 0 0 1 0-2.81c.08-.44.63-.79 1-1.19h1q2.055-1.5 0-3h-2c.39-1.81-.91-3.93.9-5.41-.37-.67-.74-1.32-1.14-2l2.24-1V194h2l2.34 1.73-1.2 1.81c.34.55.72 1.18 1.07 1.77l-2.16 1.69a5.8 5.8 0 0 1-.58 2.24c.2.51.57.31.55.17a8 8 0 0 0-.44-1.41c-.17.61-.34 1.21-.11 1.24.91-1.24 1.25-1.24 1.58-1.24Z"
            style={{
              fill: "#bc551d",
            }}
          />
          <path
            d="M188.91 176v6l-2.37.34 1.37 2.66.74 1.29c-.28 1-.51 1.86-.74 2.71-1-.86-1.93-1.73-2.82-2.53l.82-1.47c-.38-1 .93-2.53-1-3 .21-.7.4-1.41.62-2.11.45-1.41 1-2.82-.62-3.89.09-1.49 1.24-.84 2-1Z"
            className="templesOnly_svg__cls-266"
          />
          <path
            d="m185.91 185-.82 1.47c.89.8 1.85 1.67 2.82 2.53-.11.61-.18 1.23-.34 1.83s-.44 1.45-.66 2.17l-2-1c.4-.8.79-1.6 1.13-2.29l-2.13-1.71-.85-1.5.85-1.5z"
            style={{
              fill: "#b6511d",
            }}
          />
          <path
            d="m187.91 185-1.37-2.66 2.37-.34v3Z"
            style={{
              fill: "#be5a23",
            }}
          />
          <path
            d="m184.91 192 2 1 1 1h-2c-1.5 0-.85-1.21-1-2"
            style={{
              fill: "#b7501b",
            }}
          />
          <path
            d="m189.91 203-1-1h1ZM187.91 202v-1l1 1Z"
            className="templesOnly_svg__cls-220"
          />
          <path
            d="M186.91 223v1h-1l-2-1h-1v-2h2v-3l2 1h1v2l-2.56-1.07Z"
            style={{
              fill: "#c36226",
            }}
          />
          <path
            d="m186.91 223-1.56-3.13 2.56 1.07V219h1c.09 1.74.21 3.47-2 4"
            className="templesOnly_svg__cls-271"
          />
          <path
            d="M188.91 219h-1l-1-1v-1h2Z"
            style={{
              fill: "#b95619",
            }}
          />
          <circle
            cx={187.41}
            cy={224.53}
            r={0.71}
            className="templesOnly_svg__cls-271"
          />
          <path
            d="m183.91 185-.85 1.5.85 1.5h-4v-2c.06-2.53-.44-5.14 1.18-7.63l-2.47-2c1.28-1.86.17-3.75.37-5.59.13-1.23-1.22-3 .92-3.76-.22 1.73.67 2.59 2.24 3 .32.09.51.63.76 1v5a19 19 0 0 0 0 2.82c.08.44.63.79 1 1.18v1a2.48 2.48 0 0 0 0 3.98"
            className="templesOnly_svg__cls-217"
          />
          <path
            d="M179.91 167c-2.14.77-.79 2.53-.92 3.76-.2 1.84.91 3.73-.37 5.59l2.47 2c-1.62 2.49-1.12 5.1-1.18 7.63-1.93.47-.62 2-1 3h-2.31l1.05-2.55c-1.13-1.66-.63-3.5-.31-5.55.25-1.58 1-3.21.57-4.9 0-1.59.07-3.19 0-4.78 0-.43-.62-.81-1-1.22.05-1.24-.41-2.64 1-3.5s.94-2.25 1-3.5h1Z"
            className="templesOnly_svg__cls-273"
          />
          <path
            d="M188.91 154v11l-2-3v-4h-2v-1c.76-.15 1.91.5 2-1v-1c.33-.33.67-.66 1-1Z"
            style={{
              fill: "#bc5921",
            }}
          />
          <path
            d="M184.91 162v2.13l-4-1.13v-2l3 1Z"
            style={{
              fill: "#b75421",
            }}
          />
          <path
            d="M185.91 170v1h-2v-2.59Z"
            style={{
              fill: "#c25a28",
            }}
          />
          <path
            d="M180.91 161v2h-1c.15-.72-.5-1.88 1-2"
            className="templesOnly_svg__cls-277"
          />
          <path
            d="M185.91 162h-1v-1l.33-.82.67.82Z"
            style={{
              fill: "#c35e2d",
            }}
          />
          <circle
            cx={186.41}
            cy={161.53}
            r={0.71}
            style={{
              fill: "#b14d19",
            }}
          />
          <path
            d="M189.91 116c.15.76-.5 1.92 1 2a5.34 5.34 0 0 1-1 4h-1c-.09-1.49-1.24-.84-2-1v-2q2.055-1.5 0-3l2-3c.76.16 1.91-.49 2 1h-2c.42.9.71 1.47 1 2"
            style={{
              fill: "#9e4d1d",
            }}
          />
          <path
            d="M188.91 132h-2.36a14.4 14.4 0 0 1 1.29 2.77c.07.33-.6.82-.93 1.23h-1v-1c-.09-1.49-1.24-.84-2-1v-1h2v-2l.14.15.82-.7-.32-.31a5.5 5.5 0 0 0-.64.86 7 7 0 0 1-1 0c-.29-.56-.58-1.13-1-2h2l3 1Z"
            style={{
              fill: "#ac531c",
            }}
          />
          <path
            d="m188.91 130-3-1c.33-.66.67-1.33 1-2v-1h2c.35.66.71 1.32 1.08 2Z"
            style={{
              fill: "#a14c12",
            }}
          />
          <path
            d="M188.91 126h-2c-.61-.06-1.16 0-.59-1a7.7 7.7 0 0 0 .59-2h2Z"
            style={{
              fill: "#b35c23",
            }}
          />
          <path
            d="M188.91 122h1l1.44.58-2.44.42Z"
            style={{
              fill: "#914618",
            }}
          />
          <path
            d="M186.91 147v2c-.3.53-.61 1.05-.88 1.51l1.24 1.76-2.36 1.73-2-2v-2c.33-.33.67-.66 1-1 1.34 0 .81-1.05 1-1.73a5 5 0 0 1 1-1.27Z"
            className="templesOnly_svg__cls-285"
          />
          <path
            d="M185.91 135v3l-3 1v-8h2c-.33.67-.67 1.34-1 2v1c.09 1.53 1.24.88 2 1"
            style={{
              fill: "#ac4616",
            }}
          />
          <path
            d="m182.91 139 3-1c.33 1.67.67 3.34 1 5l-3 1-.89-.6c1.73-.88-.35-1.59-.11-2.4l1.9-.33-.07-.67h-1.83Z"
            className="templesOnly_svg__cls-285"
          />
          <path
            d="m183.91 144 3-1v2c-.33.34-.67.67-1 1a5 5 0 0 0-1 1.27c-.22.68.31 1.73-1 1.73l-1-1-1-1Z"
            className="templesOnly_svg__cls-287"
          />
          <circle
            cx={187.41}
            cy={148.53}
            r={0.71}
            className="templesOnly_svg__cls-287"
          />
          <path d="m186.91 147-1-1h1Z" className="templesOnly_svg__cls-287" />
          <path
            d="M186.91 146h-1c.33-.33.67-.66 1-1Z"
            style={{
              fill: "#ab4615",
            }}
          />
          <path
            d="M186.91 149h1v5c-.33.34-.67.67-1 1-.76-.15-1.91.5-2-1l2.36-1.73-1.27-1.73c.3-.46.61-.98.91-1.54"
            className="templesOnly_svg__cls-289"
          />
          <circle
            cx={188.41}
            cy={153.53}
            r={0.71}
            className="templesOnly_svg__cls-290"
          />
          <path
            d="M188.91 165v-10h.48a19.66 19.66 0 0 1 0 10s-.31 0-.48 0"
            className="templesOnly_svg__cls-290"
          />
          <path
            d="M187.91 107c-.33.67-.67 1.34-1 2l-2-2.29V110l-2.77 2.5 1.77 1.5h-3a37 37 0 0 0 0-3.8c0-.42-.62-.8-1-1.2v-2l3-1c1.93-.46.62-2 1-3l1.5.86 1.5-.86a5.34 5.34 0 0 0 1 4"
            className="templesOnly_svg__cls-291"
          />
          <path
            d="M187.91 107a5.34 5.34 0 0 1-1-4v-7l2 1.44-1.24 1.56h2.24a17.8 17.8 0 0 0-1 7.27c-.03.26-.67.52-1 .73"
            className="templesOnly_svg__cls-236"
          />
          <path
            d="M184.91 110v-3.29l2 2.29c.11.64.23 1.27.34 1.9l.66-.06V109c.33.4.88.75 1 1.19a17.5 17.5 0 0 1 0 2.81l-2 3h-1l-1-.45c.41-.45.73-.76 1-1.11.07-.09 0-.29 0-.44a17.5 17.5 0 0 0 0-2.81c-.12-.41-.67-.76-1-1.19"
            style={{
              fill: "#af5926",
            }}
          />
          <path
            d="M187.91 109v1.84l-.66.06c-.11-.63-.23-1.26-.34-1.9Z"
            style={{
              fill: "#b8662f",
            }}
          />
          <path
            d="M189.91 99h-2.24l1.21-1.56-2-1.44v-9c1.31-1.47 1-3.27 1-5 2.24 1.77.41 3.6.88 5.39l-1 .19 2.08 1.47Z"
            className="templesOnly_svg__cls-294"
          />
          <path
            d="M187.91 82c0 1.73.31 3.53-1 5-1.5-.08-.85-1.24-1-2l.83-.32-.83-.68v-2l1.27-.48-2-.76.75-2.76h1l1 1Z"
            style={{
              fill: "#96420d",
            }}
          />
          <path
            d="M186.91 240v2h-6l-1-1v-1h1a9.3 9.3 0 0 1 3.24.59c.51-.2.31-.57.16-.55a8 8 0 0 0-1.4.43c.6.17 1.21.34 1.24.12-1-.92-.71-1.57-.56-1.53 1.12.27 2.22.64 3.32.94"
            style={{
              fill: "#c46d28",
            }}
          />
          <path
            d="M182.91 242h3v1c-.33.34-.67.67-1 1h-6v-1h1c.98-.35 2.53 1 3-1"
            style={{
              fill: "#b56d2b",
            }}
          />
          <path
            d="M186.91 248h-1c.33-1 .67-2 1-3l3 1a4.8 4.8 0 0 1-1.27 1c-.64.23-1.72-.3-1.73 1"
            style={{
              fill: "#ae5c2d",
            }}
          />
          <path d="M183.91 244h3v1h-3Z" className="templesOnly_svg__cls-299" />
          <path
            d="M186.91 244h-2c.33-.33.67-.66 1-1Z"
            style={{
              fill: "#9e5319",
            }}
          />
          <path
            d="M197.91 260v1c-1.5.09-.85 1.25-1 2l-2 1c-.09-1.49-1.24-.84-2-1v-1h2v-2z"
            style={{
              fill: "#914c23",
            }}
          />
          <path
            d="M194.91 253h1v2c-.33.34-.67.67-1 1h-3c.25-.33.51-.95.76-.95 1.68 0 1.15-1.18 1.24-2.05Z"
            style={{
              fill: "#aa5826",
            }}
          />
          <path
            d="M196.91 260h-2v-1c.33-.66.67-1.33 1-2 1.93.5.62 2.05 1 3M195.91 256v1l-1-1Z"
            className="templesOnly_svg__cls-303"
          />
          <path
            d="M195.91 256h-1c.33-.33.67-.66 1-1Z"
            style={{
              fill: "#944d13",
            }}
          />
          <path
            d="M186.91 248c0-1.33 1.06-.8 1.73-1a4.8 4.8 0 0 0 1.27-1c1.5.09.85 1.25 1 2-1 .39-2.53-.92-3 1Z"
            style={{
              fill: "#a75426",
            }}
          />
          <path
            d="M183.91 245h3c-.33 1-.67 2-1 3h-3v-1l1.9-.34V246h-2.86v-1Z"
            style={{
              fill: "#9f5724",
            }}
          />
          <path
            d="M182.91 248h1c.28.51.56 1 1 1.75l-2 .25h-2v-2Z"
            style={{
              fill: "#cf9861",
            }}
          />
          <path
            d="M182.91 251h1v1c-.33.34-.67.67-1 1h-2v-1c.33-.33.67-.66 1-1Z"
            style={{
              fill: "#dbae76",
            }}
          />
          <path
            d="M182.91 251h-3l-1-1h4Z"
            style={{
              fill: "#c68e52",
            }}
          />
          <ellipse
            cx={184.91}
            cy={251.53}
            rx={1.41}
            ry={0.71}
            style={{
              fill: "#e8b989",
            }}
          />
          <path
            d="M193.91 253c-.09.87.44 2.08-1.24 2.05-.25 0-.51.62-.76.95h-2v-2c.33-.33.67-.66 1-1Z"
            className="templesOnly_svg__cls-311"
          />
          <path
            d="M185.91 254h1v6h-1z"
            style={{
              fill: "#b87b48",
            }}
          />
          <path
            d="M183.91 252h2v1c-1.5.09-.85 1.25-1 2l-2-1v-1c.33-.3.67-.63 1-1"
            style={{
              fill: "#d9af7c",
            }}
          />
          <path
            d="M184.91 255c.15-.75-.5-1.91 1-2v3h-1Z"
            style={{
              fill: "#e0ac7b",
            }}
          />
          <path
            d="M186.91 257v-3l2-1v2a15 15 0 0 1-1 1.24 8 8 0 0 1-1 .76"
            style={{
              fill: "#914c1b",
            }}
          />
          <path d="M188.91 254v-1l1 1Z" className="templesOnly_svg__cls-311" />
          <path
            d="M188.91 230c-.23.86-.46 1.71-.74 2.77l.68.59-.94 1.64h-2l-1-1v-3l1-1 1.5.86Z"
            style={{
              fill: "#cb813d",
            }}
          />
          <path
            d="M186.91 236a2.48 2.48 0 0 1 0 4c-.33-1-.67-2-1-3 .33-.3.67-.63 1-1"
            style={{
              fill: "#b7601b",
            }}
          />
          <path
            d="m184.91 234 1 1v1c-1.5 0-.85-1.21-1-2M189.91 238c-.33.34-.67.67-1 1 .33-.3.67-.63 1-1"
            className="templesOnly_svg__cls-251"
          />
          <path
            d="M186.91 236c-.33.34-.67.67-1 1v-1Z"
            style={{
              fill: "#b55a19",
            }}
          />
          <path
            d="m188.91 230-1.5.86-1.5-.86c.08-.86-.44-2.07 1.24-2 .25 0 .5-.62.76-1l1.74-1c.09.64.17 1.3.26 2-1.5.12-.85 1.28-1 2"
            style={{
              fill: "#d17d3b",
            }}
          />
          <path
            d="M186.91 225h1v2h-2v-1c.33-.3.67-.63 1-1"
            className="templesOnly_svg__cls-320"
          />
          <path
            d="M183.91 180c-.33-.39-.88-.74-1-1.18a19 19 0 0 1 0-2.82 7.78 7.78 0 0 1 4-3v2c-.76.16-1.91-.49-2 1a5.35 5.35 0 0 0-1 4"
            className="templesOnly_svg__cls-321"
          />
          <path
            d="M186.91 175v-2c.51-.28 1-.57 1.81-1l.19 4Z"
            style={{
              fill: "#b6531b",
            }}
          />
          <path
            d="M183.91 171h2l-1.24 1c-.26-.3-.51-.63-.76-1"
            className="templesOnly_svg__cls-321"
          />
          <path
            d="m182.91 74 1 1v6c-.76.16-1.91-.49-2 1h-1c-.38-1 .93-2.53-1-3l-1-1c-.09-1.49-1.24-.84-2-1 .33-1 .67-2 1-3v-2l2 1c.47 2 2.02.65 3 1"
            style={{
              fill: "#8c360d",
            }}
          />
          <path
            d="M185.91 85c.15.76-.5 1.92 1 2v6l-3-1V82h2z"
            style={{
              fill: "#9f461d",
            }}
          />
          <path
            d="M181.91 82c.09-1.49 1.24-.84 2-1v1Z"
            className="templesOnly_svg__cls-325"
          />
          <path
            d="M185.91 66h2l1 1v1c-.76.16-1.91-.49-2 1-.33.34-.67.67-1 1l-1-1-1-2c.76-.12 1.91.53 2-1"
            style={{
              fill: "#70260b",
            }}
          />
          <path
            d="m184.91 69 1 1v1h-2v-1c.33-.3.67-.63 1-1"
            style={{
              fill: "#7d2e17",
            }}
          />
          <path
            d="M182.91 74c-1-.38-2.53.93-3-1 .33-.66.67-1.33 1-2l2 1Z"
            style={{
              fill: "#6b1f03",
            }}
          />
          <path
            d="M183.91 70v2h-1v-3Z"
            style={{
              fill: "#641400",
            }}
          />
          <path
            d="m202.91 261 1 1v1h-4v-2z"
            style={{
              fill: "#ba9565",
            }}
          />
          <path
            d="M202.91 261h-1v-2h2c-.15.79.5 2-1 2"
            style={{
              fill: "#563004",
            }}
          />
          <path
            d="M203.93 254v2h-1c.15-.72-.5-1.88 1-2"
            style={{
              fill: "#5b2e0e",
            }}
          />
          <path
            d="M199.91 261v2h-1l-.33-.82-.67.82h-1c.15-.75-.5-1.91 1-2Z"
            style={{
              fill: "#e9b187",
            }}
          />
          <path
            d="M203.93 263v-1l1-1h1v2Z"
            style={{
              fill: "#bb9361",
            }}
          />
          <path
            d="M179.91 188h4l2.13 1.71c-.34.69-.73 1.49-1.13 2.29.15.76-.5 1.92 1 2v2.54l-2.24 1c.4.71.77 1.36 1.14 2-1.81 1.48-.51 3.6-.9 5.41h-1v-3c-.27-1.51.74-3.3-1-4.49 1.42-.86.93-2.26 1-3.51l1-.75-1-1.25h-1v-2a8 8 0 0 0-.77-1c-.37-.28-.82-.58-1.23-.95"
            style={{
              fill: "#be5b25",
            }}
          />
          <path
            d="M182.91 205h1c.33 1 .67 2 1 3-.33.4-.88.75-1 1.19a19 19 0 0 0 0 2.81h-2v-1c.33-.33.67-.66 1-1z"
            className="templesOnly_svg__cls-220"
          />
          <path
            d="M183.91 212h1v2l-1 1h-2c.33-.66.67-1.33 1-2 .33-.3.67-.63 1-1"
            style={{
              fill: "#b76022",
            }}
          />
          <path
            d="M184.91 208c-.33-1-.67-2-1-3h2v3Z"
            style={{
              fill: "#c86027",
            }}
          />
          <path
            d="M187.91 217h-1l-1-1v-1h2ZM185.91 208v-3q2.055 1.5 0 3"
            className="templesOnly_svg__cls-220"
          />
          <path
            d="M184.91 214v-3h1v3Z"
            style={{
              fill: "#b7571a",
            }}
          />
          <path
            d="M184.91 214h1v1h-2Z"
            style={{
              fill: "#c36627",
            }}
          />
          <path
            d="m186.74 204.51.7-2.48a8 8 0 0 1 .44 1.41c.02.14-.35.34-1.14 1.07M185.91 211h-1l.67-.82ZM187.82 210.14l-.82-.7.32-.31.69.81Z"
            className="templesOnly_svg__cls-220"
          />
          <path
            d="M183.91 180a5.35 5.35 0 0 1 1-4c1.64 1.07 1.07 2.48.62 3.89-.22.7-.41 1.41-.62 2.11l-1-1Z"
            style={{
              fill: "#b24a17",
            }}
          />
          <path
            d="M185.91 185h-1v-3c1.93.5.62 2.05 1 3"
            style={{
              fill: "#be5926",
            }}
          />
          <path
            d="M184.91 182v3h-1a2.48 2.48 0 0 1 0-4Z"
            className="templesOnly_svg__cls-266"
          />
          <path
            d="m185.91 216 1 1v2l-2-1-2 1v-4h1c.09 1.53 1.24.88 2 1"
            style={{
              fill: "#c26729",
            }}
          />
          <path
            d="M185.91 226v1h-3c.22-.72.48-1.44.66-2.17s.23-1.22.34-1.83l2 1z"
            style={{
              fill: "#bd6024",
            }}
          />
          <path
            d="M183.91 223c-.11.61-.18 1.23-.34 1.83s-.44 1.45-.66 2.17h-2v-3l2-1Z"
            style={{
              fill: "#ae591f",
            }}
          />
          <path
            d="m182.91 223-2 1v-3a4.8 4.8 0 0 0 1-1.26c.22-.68-.31-1.73 1-1.74z"
            style={{
              fill: "#b65f24",
            }}
          />
          <path
            d="M182.91 221v-2l2-1v3Z"
            style={{
              fill: "#ca692f",
            }}
          />
          <circle
            cx={186.41}
            cy={224.53}
            r={0.71}
            className="templesOnly_svg__cls-320"
          />
          <path d="M186.91 219v-1l1 1Z" className="templesOnly_svg__cls-220" />
          <path
            d="M179.91 188c.41.34.86.64 1.23 1a8 8 0 0 1 .77 1c-1.93.47-.62 2-1 3v1c-1.95 3.22-1.95 3.59-1.19 6.36.24.9 1 2.25-.81 2.64a14.5 14.5 0 0 1-1-3 31 31 0 0 1 0-5.43c.17-1.86.63-3.69 1-5.53.38-1-.93-2.53 1-3Z"
            style={{
              fill: "#cb8842",
            }}
          />
          <path
            d="M178.91 189c-.33 1.84-.79 3.67-1 5.53a31 31 0 0 0 0 5.43 14.5 14.5 0 0 0 1 3h-1.84c.09 1.22 2.13 2.26-.16 3h-1c-.19-2.29.6-4.67-.83-6.82l1.6-.43c-.58-2-1.85-3.9-1.46-5.38 1.46-5.53.25-11.08.67-16.59.05-.71.38-1.76-1-1.78v-5h2c0 1.6-.07 3.2.05 4.79 0 .43.62.81.95 1.21.41 1.69-.32 3.32-.57 4.9-.32 2-.82 3.89.31 5.55L176.6 189Z"
            style={{
              fill: "#e6ab6a",
            }}
          />
          <path
            d="M176.91 170h-2v-1c.28-.11.81-.22.82-.35a57 57 0 0 1 .25-6.9c.35-2.11 1.32-4.05 0-6.22-.29-.49.58-1.67.91-2.53h1c0 1.93-.06 3.86.05 5.78 0 .43.62.82.95 1.22v1h-1l-.83.33.83.67h1v1c-.06 1.25.41 2.64-1 3.5s-.89 2.29-.98 3.5m0-5.66v.33h1v-.33Z"
            className="templesOnly_svg__cls-349"
          />
          <path
            d="M178.91 161v-1l1-1.86a25 25 0 0 1-1-2.46c0-.12.62-.44.95-.68l1 1v5c-1.5.09-.85 1.25-1 2h-1v-2Z"
            style={{
              fill: "#af672f",
            }}
          />
          <path
            d="M177.91 176c-.33-.4-.92-.78-.95-1.21-.12-1.59-.05-3.19-.05-4.79.33.41.92.79 1 1.22.09 1.62 0 3.22 0 4.78"
            className="templesOnly_svg__cls-349"
          />
          <path
            d="M180.91 161v-2h1l1 1c1.5-.08.85-1.24 1-2h3v3h-1l-.67-.82-.33.82c-.33.34-.67.67-1 1Z"
            className="templesOnly_svg__cls-277"
          />
          <path
            d="M183.91 158c-.15.76.5 1.92-1 2-.15-.75.5-1.91-1-2v-2c.33-.33.67-.66 1-1l2-1c.09 1.5 1.24.85 2 1v1h-2c-1.5.12-.85 1.28-1 2"
            style={{
              fill: "#ab4c16",
            }}
          />
          <path
            d="M184.91 156h2c-.09 1.5-1.24.85-2 1Z"
            className="templesOnly_svg__cls-289"
          />
          <path
            d="M184.91 156v2h-1c.15-.72-.5-1.88 1-2"
            style={{
              fill: "#bf5b27",
            }}
          />
          <path
            d="M183.91 162c.33-.33.67-.66 1-1v1Z"
            style={{
              fill: "#ad4915",
            }}
          />
          <path
            d="M185.91 114c0 .15.06.35 0 .44-.27.35-.59.66-1 1.11l1 .45c.33 1 .67 2 1 3v2l-1-1-1-1-1.56 1c-.48 2.12-.89 3.87-1.24 5.63a4.5 4.5 0 0 0 .8.32 3.74 3.74 0 0 0 0 5v2l-.83.33.83.67v5h-1c-.09-1.49-1.24-.84-2-1 .25-1.8.51-3.61.8-5.66-.23-.35-.62-1-1-1.58l1.15-1.24-1.13-1.34 1.17-2.18c.14-2-.52-4 1-5.83.06-.08-.62-.76-1-1.17-.38-1 .93-2.53-1-3v-1c.33-.33.67-.66 1-1h5Zm-4.75 23h.5v-2h-.5Z"
            style={{
              fill: "#aa4c1a",
            }}
          />
          <path
            d="M186.91 119c-.33-1-.67-2-1-3h1q2.055 1.5 0 3"
            style={{
              fill: "#9a4412",
            }}
          />
          <path
            d="M186.91 121c.76.16 1.91-.49 2 1-.76-.12-1.91.53-2-1"
            style={{
              fill: "#9a4714",
            }}
          />
          <path
            d="M182.91 131a3.74 3.74 0 0 1 0-5h1l1 1h2c-.33.67-.67 1.34-1 2h-2c.43.87.72 1.44 1 2ZM183.91 133c.33-.66.67-1.33 1-2h1v2ZM185.91 135c-.76-.15-1.91.5-2-1 .76.19 1.91-.46 2 1"
            className="templesOnly_svg__cls-357"
          />
          <path
            d="m185.81 130.94.69-.81.32.31-.82.7Z"
            style={{
              fill: "#b25924",
            }}
          />
          <path
            d="M186.91 127h-2l-1-1c.21-2.24.76-2.79 3-3a7.7 7.7 0 0 1-.59 2c-.57.91 0 .9.59 1Z"
            style={{
              fill: "#b75925",
            }}
          />
          <path
            d="M186.91 123c-2.24.21-2.79.76-3 3h-1a4.5 4.5 0 0 1-.8-.32c.35-1.76.76-3.51 1.24-5.63l1.56-1 1 1 1 1c.09 1.5 1.24.85 2 1v1Z"
            className="templesOnly_svg__cls-360"
          />
          <path
            d="M182.91 150v3l-3 1-1-2H181l-.33-2-1.75 1v-2l3-1c.14.79-.51 2 .99 2"
            style={{
              fill: "#ae612a",
            }}
          />
          <path
            d="M182.91 153v-1l2 2-2 1z"
            className="templesOnly_svg__cls-289"
          />
          <path
            d="M183.91 149c-.33.34-.67.67-1 1 .33-.3.67-.63 1-1"
            className="templesOnly_svg__cls-287"
          />
          <path
            d="m182.91 134-.83-.67.83-.33Z"
            className="templesOnly_svg__cls-357"
          />
          <path
            d="M181.91 139h1v2c-.24.81 1.84 1.52.11 2.4l.89.6-2 3h-1v-2c.33-1 .67-2 1-3-.15-.75.5-1.91-1-2Z"
            className="templesOnly_svg__cls-362"
          />
          <path
            d="M182.91 141v-1h1.83l.07.67Z"
            style={{
              fill: "#ab4214",
            }}
          />
          <path
            d="M183.91 149c-.33.34-.67.67-1 1-1.5-.08-.85-1.24-1-2h1Z"
            style={{
              fill: "#b6612e",
            }}
          />
          <path d="M182.91 148h-1v-1Z" className="templesOnly_svg__cls-362" />
          <path
            d="m183.91 92 3 1v3l-1.85-2.33c0 1.74-.95 3.22.85 4.33v1.55l-2 .91V102l-2.06.31c.42 1.45.74 2.57 1.06 3.69l-3 1v-5l2-1.3c-.45-1.26 1.16-2.93-1-3.7v-4c1.88 1 .64 3.87 3 4.81Z"
            className="templesOnly_svg__cls-365"
          />
          <path
            d="M180.91 93v4c-1.31 1.48-1 3.28-1 5v8h-1v-5c.76-3.44-1.28-6.6-1-10a6.13 6.13 0 0 0 .15-6.87c.38-1.42.62-2.27.85-3.13h1v6c.15.79-.5 2 1 2"
            style={{
              fill: "#ac4f19",
            }}
          />
          <path
            d="M183.91 102v-1.54l2-.91V98c.33-.33.67-.66 1-1v6l-1.5.86-1.5-.86Z"
            style={{
              fill: "#a94f1f",
            }}
          />
          <path
            d="M179.91 110v-1c.33.4.91.78 1 1.2a37 37 0 0 1 0 3.8c-.33.34-.67.67-1 1z"
            className="templesOnly_svg__cls-368"
          />
          <path
            d="M183.91 102v1c-.38 1 .93 2.54-1 3-.32-1.12-.64-2.24-1.06-3.69Z"
            style={{
              fill: "#983c11",
            }}
          />
          <path
            d="M184.91 114h-1l-1.77-1.5 2.77-2.5Z"
            style={{
              fill: "#9a3b0b",
            }}
          />
          <path
            d="M186.91 97c-.33.34-.67.67-1 1-1.8-1.11-.84-2.59-.85-4.33l1.85 2.33Z"
            style={{
              fill: "#a84d1e",
            }}
          />
          <path
            d="M184.91 114v-4c.33.4.88.75 1 1.19a17.5 17.5 0 0 1 0 2.81Z"
            className="templesOnly_svg__cls-291"
          />
          <path
            d="M185.91 85v-1l.83.68Z"
            className="templesOnly_svg__cls-294"
          />
          <path
            d="M185.91 236v1c.33 1 .67 2 1 3-1.1-.33-2.2-.7-3.32-.94-.15 0-.45.61-.68.94h-2v-1l3-3v-3h1v1c.15.79-.5 2 1 2"
            className="templesOnly_svg__cls-249"
          />
          <path
            d="M180.91 239v1h-2v-1c.33-.33.67-.66 1-1h1Z"
            style={{
              fill: "#bf702a",
            }}
          />
          <path
            d="M179.91 243h-1v-2h1l1 1c-.33.37-.67.7-1 1"
            style={{
              fill: "#cb7732",
            }}
          />
          <path
            d="M179.91 243c.33-.33.67-.66 1-1h2c-.47 2-2.02.65-3 1"
            style={{
              fill: "#be6f2c",
            }}
          />
          <path
            d="m185.38 241.2-2.47-.7a8 8 0 0 1 1.4-.43c.15-.02.35.35 1.07 1.13"
            style={{
              fill: "#d27837",
            }}
          />
          <circle
            cx={179.41}
            cy={240.53}
            r={0.71}
            style={{
              fill: "#be6823",
            }}
          />
          <path
            d="M183.91 245h-2c-.33.34-.67.67-1 1h-2c-.47-1.92-2-.61-3-1v-1h8Z"
            style={{
              fill: "#cf8849",
            }}
          />
          <path
            d="M178.91 244h-1v-4h1z"
            style={{
              fill: "#c06e2c",
            }}
          />
          <path
            d="M192.91 263c.76.16 1.91-.49 2 1h-1c-1 .39-2.53-.92-3 1v1l-1-1v-2Z"
            style={{
              fill: "#853a12",
            }}
          />
          <path
            d="M193.91 264h1l2-1v2c-.33.34-.67.67-1 1h-3c.33-.63.67-1.3 1-2"
            style={{
              fill: "#753c17",
            }}
          />
          <path
            d="M194.91 259v3h-2c.33-1 .67-2 1-3Z"
            style={{
              fill: "#994d15",
            }}
          />
          <ellipse
            cx={191.41}
            cy={262.53}
            rx={2.12}
            ry={0.71}
            style={{
              fill: "#b46132",
            }}
          />
          <path
            d="M194.91 259h-1c-.09-1.49-1.24-.84-2-1v-2h3l1 1c-.33.7-.67 1.37-1 2"
            style={{
              fill: "#b6662c",
            }}
          />
          <path
            d="M178.91 246h2c.09 1.5 1.24.85 2 1v1h-3Z"
            style={{
              fill: "#b26a35",
            }}
          />
          <path
            d="M182.91 247c-.76-.15-1.91.5-2-1h3.86v.66Z"
            style={{
              fill: "#9a501d",
            }}
          />
          <path
            d="M181.91 246h-1c.33-.33.67-.66 1-1Z"
            className="templesOnly_svg__cls-299"
          />
          <path
            d="M179.91 248h1v1h-3v-1Z"
            style={{
              fill: "#e7ad72",
            }}
          />
          <ellipse
            cx={179.91}
            cy={249.53}
            rx={1.41}
            ry={0.71}
            style={{
              fill: "#ecb579",
            }}
          />
          <path
            d="M180.91 252v3h-1c-.09-1.49-1.24-.84-2-1v-1h1c.33-.33.67-.66 1-1Z"
            style={{
              fill: "#eebf80",
            }}
          />
          <path
            d="M180.91 255v-2h2v1c-.33.34-.67.67-1 1Z"
            style={{
              fill: "#deb57b",
            }}
          />
          <path
            d="M180.91 252h-1v-1h2c-.33.37-.67.7-1 1"
            style={{
              fill: "#eeb779",
            }}
          />
          <path
            d="M183.91 252c-.33.34-.67.67-1 1 .33-.3.67-.63 1-1"
            style={{
              fill: "#cda46f",
            }}
          />
          <path
            d="M179.91 251v1h-1c-.33.34-.67.67-1 1h-2c-1 .39-2.53-.92-3 1h-2v-1a9 9 0 0 1 .76-1c.38-.37.83-.67 1.24-1l3-1h3Z"
            style={{
              fill: "#f4bf7e",
            }}
          />
          <path
            d="M191.91 256v3h-1v-2h-2v-3h1v2Z"
            style={{
              fill: "#a25116",
            }}
          />
          <path
            d="M185.91 258v2q-2.055 1.5 0 3c-.33.67-.67 1.34-1 2h-1c-2.3-.74-.25-1.78-.17-3h-1.83v-2h1c1.93-.46.62-2 1-3h1Z"
            style={{
              fill: "#daa76d",
            }}
          />
          <path
            d="M184.91 265c.33-.66.67-1.33 1-2v-3h1v3l1 1h2v1c-.76.16-1.91-.49-2 1h-1l-1-1Z"
            style={{
              fill: "#a55c2a",
            }}
          />
          <path
            d="M186.91 263v-6a8 8 0 0 0 1-.76 15 15 0 0 0 1-1.24v3c-.33.4-.91.78-.95 1.2a37 37 0 0 0-.05 3.8Z"
            style={{
              fill: "#954a12",
            }}
          />
          <path
            d="M184.91 257h-1v-1h2v1Z"
            style={{
              fill: "#ca9763",
            }}
          />
          <path
            d="M184.91 257h1v1Z"
            style={{
              fill: "#ebaf7a",
            }}
          />
          <path
            d="M184.91 256h-2l-1-1c.33-.33.67-.66 1-1l2 1Z"
            style={{
              fill: "#d1a670",
            }}
          />
          <path
            d="M184.91 227h3c-.26.34-.51 1-.76 1-1.68 0-1.16 1.18-1.24 2l-1 1zM184.91 233h-1v-1l1-1Z"
            className="templesOnly_svg__cls-251"
          />
          <path
            d="M185.91 225h1c-.33.34-.67.67-1 1Z"
            style={{
              fill: "#b05718",
            }}
          />
          <path
            d="M180.91 71c-.33.67-.67 1.34-1 2l-2-1v-3h2l1 1Z"
            className="templesOnly_svg__cls-401"
          />
          <path
            d="m178.91 78 1 1v4h-1a4.6 4.6 0 0 0-2-4v-1Z"
            className="templesOnly_svg__cls-402"
          />
          <path
            d="M177.91 74c-.33 1-.67 2-1 3h-2c-.33-1-.67-2-1-3h1l.39.88 1.61-.88Z"
            className="templesOnly_svg__cls-403"
          />
          <path
            d="M180.91 82h1v7h-1a17.5 17.5 0 0 0 0-2.81c-.07-.44-.62-.79-1-1.19v-2c.33-.3.67-.63 1-1"
            className="templesOnly_svg__cls-325"
          />
          <path
            d="M180.91 82c-.33.34-.67.67-1 1v-4c1.93.5.62 2.05 1 3"
            className="templesOnly_svg__cls-404"
          />
          <path
            d="M178.91 78h-2v-1c.76.19 1.91-.46 2 1"
            style={{
              fill: "#932a00",
            }}
          />
          <ellipse
            cx={177.41}
            cy={73.03}
            className="templesOnly_svg__cls-401"
            rx={0.71}
            ry={1.41}
          />
          <path
            d="M181.91 89v-6c1.93.34.66 1.84 1 2.75s-.64 2.09 1 2.25v9.81c-2.36-.94-1.12-3.8-3-4.81v-2c1.5 0 .85-1.21 1-2"
            style={{
              fill: "#8d340f",
            }}
          />
          <path
            d="M183.91 88c-1.65-.16-.73-1.47-1-2.25s.94-2.41-1-2.75v-1h2Z"
            style={{
              fill: "#923a14",
            }}
          />
          <path
            d="M183.91 66v1l1 2c-.33.34-.67.67-1 1l-1-1v-3Z"
            style={{
              fill: "#691d01",
            }}
          />
          <path
            d="M180.91 71v-2h2v3Z"
            style={{
              fill: "#722205",
            }}
          />
          <ellipse
            cx={201.91}
            cy={263.53}
            className="templesOnly_svg__cls-410"
            rx={1.41}
            ry={0.71}
          />
          <path d="M200.91 263v1h-2v-1z" className="templesOnly_svg__cls-411" />
          <circle
            cx={203.43}
            cy={263.53}
            r={0.71}
            className="templesOnly_svg__cls-411"
          />
          <path
            d="M198.91 263v1h-2v-1z"
            style={{
              fill: "#b98860",
            }}
          />
          <path
            d="M198.91 263h-1l.67-.82Z"
            style={{
              fill: "#fef1c8",
            }}
          />
          <ellipse
            cx={204.93}
            cy={263.53}
            className="templesOnly_svg__cls-414"
            rx={1.41}
            ry={0.71}
          />
          <path
            d="M178.91 203c1.83-.39 1.05-1.74.81-2.64-.76-2.77-.76-3.14 1.19-6.36l.85 1.49c-.56 1-1.15 2-1.74 3.1 1.31.81.8 2.2.89 3.41.09 1.5 1.24.85 2 1v3h-3c-.33-1-.67-2-1-3"
            style={{
              fill: "#be7632",
            }}
          />
          <path
            d="M180.91 202c-.09-1.21.42-2.6-.89-3.41.59-1.05 1.18-2.09 1.74-3.1l-.85-1.49v-1c.33-.33.67-.66 1-1h1v2c-.07 1.25.42 2.65-1 3.51 1.74 1.19.73 3 1 4.49Z"
            style={{
              fill: "#be6729",
            }}
          />
          <path
            d="M181.91 192c-.33.34-.67.67-1 1 .38-1-.93-2.53 1-3Z"
            style={{
              fill: "#b56526",
            }}
          />
          <path
            d="M180.91 202h2v1c-.76-.12-1.91.53-2-1"
            style={{
              fill: "#b76225",
            }}
          />
          <path
            d="M182.91 194v-2l1 1.25Z"
            style={{
              fill: "#c7642f",
            }}
          />
          <path
            d="M182.91 210c-.33.34-.67.67-1 1h-3a5.34 5.34 0 0 0 1-4h1l.33.83.67-.83h1v2l-1.9.34.07.66Z"
            className="templesOnly_svg__cls-420"
          />
          <path
            d="M178.91 211h3v1c-.67.67-1.33 1.34-2 2h-1Z"
            className="templesOnly_svg__cls-421"
          />
          <path
            d="M179.91 214c.67-.66 1.33-1.33 2-2h1v1c-.33.67-.67 1.34-1 2h-2Z"
            style={{
              fill: "#ae5c22",
            }}
          />
          <path
            d="M182.91 210h-1.83l-.07-.66 1.9-.34ZM182.91 213v-1h1c-.33.37-.67.7-1 1"
            className="templesOnly_svg__cls-423"
          />
          <circle
            cx={182.41}
            cy={206.53}
            r={0.71}
            className="templesOnly_svg__cls-423"
          />
          <path
            d="M182.91 215v2c-1.5-.08-.85-1.24-1-2Z"
            style={{
              fill: "#c06c30",
            }}
          />
          <path
            d="M185.91 216c-.76-.15-1.91.5-2-1h2Z"
            style={{
              fill: "#cb7131",
            }}
          />
          <path
            d="M181.91 215c.15.76-.5 1.92 1 2v1c-1.34 0-.81 1.06-1 1.74a4.8 4.8 0 0 1-1 1.26c-.33-2-.67-4-1-6Z"
            className="templesOnly_svg__cls-421"
          />
          <path
            d="M184.91 227v3l-3-1v-2z"
            style={{
              fill: "#bc6428",
            }}
          />
          <path
            d="M180.91 223v13h-1v-13Z"
            className="templesOnly_svg__cls-427"
          />
          <ellipse
            cx={181.41}
            cy={228.03}
            className="templesOnly_svg__cls-428"
            rx={0.71}
            ry={1.41}
          />
          <path
            d="M180.91 223h-1l-.9-1.57c2-1.1.26-2.26-.1-3.43v-4h1v1c.33 2 .67 4 1 6Z"
            className="templesOnly_svg__cls-429"
          />
          <path
            d="M174.91 169v6c0 3.33-.12 6.66 0 10s-1.5 6.25-1.09 9.57a62 62 0 0 1 .06 7.46c0 1 .33 2.14-.06 2.94-1.79 3.74-.94 7.39.06 11.06v8.76c0 .43.63.83 1 1.24v1c-.33.42-.94.83-1 1.25-.08 3.09-.17 6.19 0 9.26a6.7 6.7 0 0 1-1.06 3.49v1l-2-1.34q0-36.1-.06-72.09a8 8 0 0 1 1.06-3.57 9 9 0 0 1 1 .77c.37.38.68.82 1 1.23 1.59.09.94 1.25 1.09 1.97"
            style={{
              fill: "#eec699",
            }}
          />
          <path
            d="M173.91 202a62 62 0 0 0-.06-7.46c-.41-3.32 1.25-6.31 1.09-9.57s0-6.64 0-10c1.36 0 1 1.07 1 1.78-.42 5.51.79 11.06-.67 16.59-.39 1.48.88 3.41 1.46 5.38l-1.6.43c1.43 2.15.64 4.53.83 6.82v4h-1a1.3 1.3 0 0 1-.49 0c-.14-.05-.35-.29-.33-.32 1.46-2.33.7-4.86.63-7.32-.06-.07-.58-.18-.86-.33"
            style={{
              fill: "#e8b479",
            }}
          />
          <path
            d="M178.91 214v4h-1c.11-2.72-1.72-5.2-1-8v-4c2.29-.74.25-1.78.16-3h1.84c.33 1 .67 2 1 3v1a5.34 5.34 0 0 1-1 4Z"
            style={{
              fill: "#d7944e",
            }}
          />
          <ellipse
            cx={176.41}
            cy={208.03}
            className="templesOnly_svg__cls-433"
            rx={0.71}
            ry={2.83}
          />
          <path
            d="M174.91 169c-.15-.75.5-1.91-1-2 0-.64-.25-1.44 0-1.91 1.65-2.65.74-5.55.91-8.34 0-.23-.62-.5-1-.75-.7-2.17 1-3.94 1-6v-7l1 1v2c0 1.93-.06 3.86.05 5.78 0 .43.62.82.95 1.22-.33.86-1.2 2-.91 2.53 1.3 2.17.33 4.11 0 6.22a57 57 0 0 0-.25 6.9c.06.16-.47.27-.75.35"
            style={{
              fill: "#e0a868",
            }}
          />
          <path
            d="M176.91 153c-.33-.4-.93-.79-.95-1.22-.11-1.92-.05-3.85-.05-5.78h1l1 1c.15.76-.5 1.92 1 2v1c-1.93.47-.62 2-1 3Z"
            style={{
              fill: "#d08f4e",
            }}
          />
          <path
            d="M177.91 153c.38-1-.93-2.53 1-3v2l1 2v1c-.33.24-1 .56-.95.68a25 25 0 0 0 1 2.46l-1 1.86c-.33-.4-.93-.79-.95-1.22-.16-1.89-.1-3.78-.1-5.78"
            className="templesOnly_svg__cls-436"
          />
          <ellipse
            cx={177.41}
            cy={164.53}
            className="templesOnly_svg__cls-273"
            rx={0.71}
            ry={0.24}
          />
          <circle
            cx={178.41}
            cy={161.53}
            r={0.71}
            className="templesOnly_svg__cls-436"
          />
          <path
            d="M177.91 161v1l-.83-.67Z"
            className="templesOnly_svg__cls-273"
          />
          <path
            d="M179.91 155v-1l3-1v1l-.83.33.83.67c-.33.34-.67.67-1 1h-1Z"
            style={{
              fill: "#a85821",
            }}
          />
          <path
            d="M180.91 156h1v3h-1Z"
            style={{
              fill: "#b7652d",
            }}
          />
          <path
            d="M181.91 159v-1c1.5.09.85 1.25 1 2Z"
            style={{
              fill: "#a14710",
            }}
          />
          <path
            d="m180.91 126-1.17 2.18 1.13 1.34-1.15 1.24c.37.59.76 1.23 1 1.58-.29 2-.55 3.86-.8 5.66-.33.34-.67.67-1 1v-15.25c0-.72-.35-1.74 1-1.75a19 19 0 0 0 0 2.82c.08.47.66.82.99 1.18"
            className="templesOnly_svg__cls-440"
          />
          <path
            d="M180.91 126c-.33-.39-.88-.74-1-1.18a19 19 0 0 1 0-2.82 9.66 9.66 0 0 1-.46-8c0-.05.3 0 .46 0v2c.38 1-.93 2.54 1 3 .33.41 1 1.09 1 1.17-1.52 1.83-.86 3.9-1 5.83"
            className="templesOnly_svg__cls-360"
          />
          <path
            d="M178.91 139c.33-.33.67-.66 1-1 .76.16 1.91-.49 2 1l-1 1h-2Z"
            style={{
              fill: "#9c531a",
            }}
          />
          <path
            d="M180.91 119c-1.93-.46-.62-2-1-3 1.93.5.62 2.05 1 3"
            className="templesOnly_svg__cls-368"
          />
          <ellipse
            cx={181.41}
            cy={136.03}
            className="templesOnly_svg__cls-440"
            rx={0.35}
            ry={1.41}
          />
          <path
            d="m185.91 120-1-1Z"
            style={{
              fill: "#b85d2a",
            }}
          />
          <path d="m183.91 126 1 1Z" className="templesOnly_svg__cls-360" />
          <path
            d="M181.91 147v1l-3 1v-2z"
            style={{
              fill: "#a45b23",
            }}
          />
          <path
            d="M178.91 152v-1l1.75-1 .33 2Z"
            style={{
              fill: "#a45d21",
            }}
          />
          <path
            d="m182.91 155-.83-.67.83-.33Z"
            style={{
              fill: "#b45b26",
            }}
          />
          <path
            d="M180.91 147h-2c-.38-1 .93-2.53-1-3a5.34 5.34 0 0 0 1-4h2c1.5.09.85 1.25 1 2h-1.81c-.15 2.1-.15 2.1.81 3Z"
            style={{
              fill: "#b36c30",
            }}
          />
          <path
            d="M180.91 145c-1-.9-1-.9-.81-3h1.81c-.33 1-.67 2-1 3"
            style={{
              fill: "#a55b24",
            }}
          />
          <path
            d="M179.91 102c0-1.72-.31-3.52 1-5 2.12.77.51 2.44 1 3.7Z"
            className="templesOnly_svg__cls-291"
          />
          <path
            d="M179.91 114h-.46a9.66 9.66 0 0 0 .46 8c-1.34 0-1 1-1 1.75V137l-1-1c-.33-1.66-.67-3.33-1-5a10.6 10.6 0 0 0 1-2.53c.15-1.63 0-3.28 0-4.91s.5-3.22-.12-4.36c-.87-1.62.38-2.81.09-4.15a10.3 10.3 0 0 0-1-2 2.47 2.47 0 0 1 2-3h1Z"
            className="templesOnly_svg__cls-448"
          />
          <path
            d="M178.91 110a2.47 2.47 0 0 0-2 3c-1.37 0-1.15-1.14-.95-1.76.51-1.64 1.5-3.12.73-5-.7-1.71-1.2-3.49-1.78-5.25v-1c1.91-1.17 2.09-3 2-5h1c-.28 3.4 1.76 6.56 1 10l-1 .76c.33.42.67.83 1 1.24Z"
            style={{
              fill: "#d58f46",
            }}
          />
          <path
            d="M177.91 95h-1v-1c.33-1 .67-2 1-3a12.3 12.3 0 0 1-.91-3c-.13-3-.05-6-.05-8.94a4.6 4.6 0 0 1 2 4v2c-.23.86-.47 1.71-.85 3.13a6.13 6.13 0 0 1-.19 6.81"
            className="templesOnly_svg__cls-450"
          />
          <path
            d="M179.91 85c.33.4.88.75 1 1.19a17.5 17.5 0 0 1 0 2.81v2h-1Z"
            className="templesOnly_svg__cls-404"
          />
          <path
            d="M178.91 107c-.33-.41-.67-.82-1-1.24l1-.76Z"
            className="templesOnly_svg__cls-448"
          />
          <path
            d="M179.91 91h1v2c-1.5 0-.85-1.21-1-2"
            className="templesOnly_svg__cls-365"
          />
          <ellipse
            cx={179.41}
            cy={84.03}
            className="templesOnly_svg__cls-404"
            rx={0.71}
            ry={1.41}
          />
          <path
            d="M180.91 239v-2c.33-.33.67-.66 1-1h2Z"
            style={{
              fill: "#a7591a",
            }}
          />
          <path
            d="M183.91 236h-2v-2h1l1 1ZM183.91 232v2h-1v-2Z"
            className="templesOnly_svg__cls-427"
          />
          <path d="M182.91 234h1v1Z" className="templesOnly_svg__cls-251" />
          <path
            d="M180.91 237v1h-2c.15-.75-.5-1.91 1-2h1Z"
            style={{
              fill: "#b06324",
            }}
          />
          <path
            d="M178.91 240h-2c.33-.66.67-1.33 1-2h1z"
            style={{
              fill: "#b96c29",
            }}
          />
          <path
            d="M178.91 239v-1h1c-.33.37-.67.7-1 1"
            style={{
              fill: "#cc803a",
            }}
          />
          <path
            d="M175.91 245c1 .39 2.53-.92 3 1-.76.16-1.91-.49-2 1h-2c.33-.63.67-1.3 1-2"
            style={{
              fill: "#ebb072",
            }}
          />
          <path
            d="M177.91 243v1h-2v-3h1c.15.79-.5 2 1 2"
            style={{
              fill: "#b77435",
            }}
          />
          <path
            d="M175.91 242v3h-2c.33-1 .67-2 1-3Z"
            style={{
              fill: "#e0a86d",
            }}
          />
          <path
            d="M177.91 243c-1.5-.08-.85-1.24-1-2v-1h1Z"
            style={{
              fill: "#ab5d1e",
            }}
          />
          <path
            d="M187.91 266c.09-1.49 1.24-.84 2-1l1 1h1v1h-4Z"
            style={{
              fill: "#864b1d",
            }}
          />
          <path
            d="M193.91 264c-.33.67-.67 1.34-1 2h-1l-1-1c.47-1.89 2.02-.58 3-1"
            style={{
              fill: "#521100",
            }}
          />
          <path
            d="M189.91 264h-1c.15-.75-.5-1.91 1-2z"
            style={{
              fill: "#be6b39",
            }}
          />
          <path
            d="m190.91 265 1 1h-1Z"
            style={{
              fill: "#6c2904",
            }}
          />
          <path
            d="M196.91 264h2v2h-2z"
            style={{
              fill: "#75451f",
            }}
          />
          <path
            d="M191.91 266h3v1h-3Z"
            style={{
              fill: "#d5a678",
            }}
          />
          <path
            d="M196.91 265v1h-1c.33-.3.67-.63 1-1"
            style={{
              fill: "#743e12",
            }}
          />
          <path
            d="M189.91 262c-1.5.09-.85 1.25-1 2h-1v-1a37 37 0 0 1 .05-3.8c0-.42.62-.8.95-1.2l1 1v2.75c1-1.42 1.52-2.08 2-2.75v-1c.76.16 1.91-.49 2 1-.33 1-.67 2-1 3Z"
            style={{
              fill: "#ac5c22",
            }}
          />
          <path
            d="M176.91 247c.09-1.49 1.24-.84 2-1l1 2h-3Z"
            style={{
              fill: "#d19154",
            }}
          />
          <path
            d="M176.91 248h1v1h-3v-1Z"
            style={{
              fill: "#e9b979",
            }}
          />
          <path
            d="M175.91 249h3v1h-3Z"
            style={{
              fill: "#fdc988",
            }}
          />
          <path
            d="M183.91 257c-.38 1 .93 2.54-1 3v-1l-1-1-.83.33.83.67v1h-2v-1c-.22-.72-.48-1.44-.66-2.17s-.23-1.22-.34-1.83h2l1 1c.09 1.53 1.24.88 2 1"
            className="templesOnly_svg__cls-470"
          />
          <path
            d="M179.91 255h-6l-1-1c.47-1.92 2-.61 3-1 .09 1.5 1.24.85 2 1s1.91-.46 2 1"
            style={{
              fill: "#fdc787",
            }}
          />
          <path
            d="M177.91 254c-.76-.15-1.91.5-2-1h2Z"
            style={{
              fill: "#efb878",
            }}
          />
          <path
            d="M178.91 252h1c-.33.34-.67.67-1 1Z"
            style={{
              fill: "#f9c685",
            }}
          />
          <path
            d="M178.91 252v1h-1c.33-.3.67-.63 1-1"
            style={{
              fill: "#f0b677",
            }}
          />
          <path
            d="m181.91 256-1-1h1l1 1Z"
            style={{
              fill: "#b98e58",
            }}
          />
          <path
            d="M172.91 251c-.41.34-.86.64-1.24 1a9 9 0 0 0-.76 1h-5c0-1.37 1.07-.85 1.78-1 1-.23 2.06-.53 3.14-.81v-4.78l2.08-1.4h1l-1.86 3.68.86.32Z"
            style={{
              fill: "#fcd9a8",
            }}
          />
          <path
            d="M165.91 253h5v1c-2-.09-3.83.1-5 2h-3v-3Z"
            style={{
              fill: "#e4bd8b",
            }}
          />
          <path
            d="M165.91 256c1.17-1.9 3-2.09 5-2h2v2h-5c-.33.34-.67.67-1 1Z"
            style={{
              fill: "#fbc685",
            }}
          />
          <path
            d="M172.91 251v-2h3v1Z"
            style={{
              fill: "#fed294",
            }}
          />
          <path
            d="M188.91 258v-1h2v2h-1Z"
            style={{
              fill: "#b76529",
            }}
          />
          <path
            d="M189.91 259h2c-.48.67-1 1.33-2 2.75Z"
            style={{
              fill: "#a35012",
            }}
          />
          <path
            d="M181.91 262h1.83c-.08 1.22-2.13 2.26.17 3v1h-4l-3 1v-1c.22-.72.48-1.44.66-2.17s.23-1.22.34-1.83h1c1.01 1.4 1.99 1.4 3 0m-2 2.34v.33h1v-.33Z"
            className="templesOnly_svg__cls-482"
          />
          <path
            d="M181.91 262q-1.5 2.055-3 0c.33-.33.67-.66 1-1v-1h2v1l-.83.33Z"
            style={{
              fill: "#f6ca8d",
            }}
          />
          <path
            d="M185.91 260v3q-2.055-1.5 0-3"
            style={{
              fill: "#e9ae73",
            }}
          />
          <circle
            cx={184.41}
            cy={265.53}
            r={0.71}
            className="templesOnly_svg__cls-485"
          />
          <path
            d="m181.91 262-.83-.67.83-.33Z"
            className="templesOnly_svg__cls-482"
          />
          <circle
            cx={182.41}
            cy={259.53}
            r={0.71}
            style={{
              fill: "#ca9960",
            }}
          />
          <circle
            cx={187.41}
            cy={266.53}
            r={0.71}
            style={{
              fill: "#743b0e",
            }}
          />
          <path d="m185.91 265 1 1h-1Z" className="templesOnly_svg__cls-485" />
          <circle
            cx={185.41}
            cy={265.53}
            r={0.71}
            style={{
              fill: "#793b0a",
            }}
          />
          <path
            d="M187.91 263v1l-1-1Z"
            style={{
              fill: "#914612",
            }}
          />
          <path
            d="M181.91 256h2v1c-.76-.12-1.91.53-2-1"
            style={{
              fill: "#dcaa76",
            }}
          />
          <path
            d="M183.91 232h-1c-.33-1-.67-2-1-3l3 1v1Z"
            className="templesOnly_svg__cls-428"
          />
          <path
            d="M182.91 69h-4l-1-1c0-1.33 1.06-.8 1.73-1a4.8 4.8 0 0 0 1.27-1c.33-.33.67-.66 1-1h1z"
            style={{
              fill: "#803114",
            }}
          />
          <path
            d="M177.91 69v2h-1v-2h-3.36l-1.64-2v-2h1c.43.92.87 1.84 1.42 3h3.58Z"
            className="templesOnly_svg__cls-492"
          />
          <circle
            cx={177.41}
            cy={71.53}
            r={0.71}
            style={{
              fill: "#852f08",
            }}
          />
          <path
            d="M179.91 69h1v1Z"
            style={{
              fill: "#611d06",
            }}
          />
          <path
            d="M177.91 69v-1l1 1Z"
            style={{
              fill: "#bd6a46",
            }}
          />
          <path
            d="M174.91 77h1l1 1v1h-2Z"
            className="templesOnly_svg__cls-450"
          />
          <path
            d="M174.91 79h1v1c-.33.4-.88.75-1 1.19a19 19 0 0 0 0 2.81v7h-1c-1.31-1.47-1-3.27-1-5v-1c.14-1.58.29-3.16.45-5h-1.45v-1q2.055-1.5 0-3v-2h2c.33 1 .67 2 1 3l-1 .76c.33.45.67.86 1 1.24"
            className="templesOnly_svg__cls-496"
          />
          <path
            d="M176.91 72v2l-1.61.88-.39-.88-1-1v-2h2Z"
            style={{
              fill: "#842f07",
            }}
          />
          <path
            d="m173.91 73 1 1h-3v-1z"
            style={{
              fill: "#9e4e18",
            }}
          />
          <path d="m176.91 78-1-1h1Z" className="templesOnly_svg__cls-402" />
          <path
            d="M180.91 91v-2h1c-.15.79.5 2-1 2"
            className="templesOnly_svg__cls-365"
          />
          <path
            d="M200.91 264h2c-.33.34-.67.67-1 1h-1Z"
            style={{
              fill: "#2f0b00",
            }}
          />
          <path
            d="M200.91 264v2h-1l-1-1v-1Z"
            className="templesOnly_svg__cls-410"
          />
          <path
            d="M201.91 265c.33-.33.67-.66 1-1h1v2h-2Z"
            className="templesOnly_svg__cls-414"
          />
          <ellipse
            cx={204.93}
            cy={264.53}
            rx={1.41}
            ry={0.71}
            style={{
              fill: "#320700",
            }}
          />
          <path
            d="M179.91 207v-1h2v1z"
            style={{
              fill: "#b06525",
            }}
          />
          <path
            d="M180.91 207h1l-.67.83Z"
            className="templesOnly_svg__cls-423"
          />
          <path
            d="M178.91 238h-1l-.7-2.64a7 7 0 0 0 .66-1.94 35 35 0 0 0 0-5.41c-.16-1.68-.63-3.34-1-5h1l1 1 1 1v11c-1.46.11-.81 1.27-.96 1.99"
            style={{
              fill: "#c6813e",
            }}
          />
          <path
            d="M181.91 229c.33 1 .67 2 1 3l-2 1v-4Z"
            style={{
              fill: "#a9571d",
            }}
          />
          <path
            d="m180.91 233 2-1v2h-2Z"
            className="templesOnly_svg__cls-428"
          />
          <path
            d="M180.91 234h1v2c-.33.34-.67.67-1 1z"
            style={{
              fill: "#a4561e",
            }}
          />
          <path d="m179.91 225-1-1 1-1Z" className="templesOnly_svg__cls-429" />
          <path
            d="m179.91 223-1 1-1-1v-5h1c.36 1.17 2.13 2.33.1 3.43Z"
            style={{
              fill: "#c5813c",
            }}
          />
          <path
            d="M175.91 242h-1l-1-1h-1a6.7 6.7 0 0 0 1.06-3.49c-.19-3.07-.1-6.17 0-9.26 0-.42.63-.83 1-1.25l1 1v4q-2.055 1.5 0 3v7Z"
            style={{
              fill: "#eab67d",
            }}
          />
          <path
            d="M171.91 165v-7h2v-2c.33.25 1 .52 1 .75-.17 2.79.74 5.69-.91 8.34-.29.47 0 1.27 0 1.91-.33-.41-.64-.85-1-1.23a9 9 0 0 0-1.09-.77"
            style={{
              fill: "#e6b984",
            }}
          />
          <path
            d="M173.91 202c.28.12.8.23.81.35.07 2.46.83 5-.63 7.32 0 0 .19.27.33.32a1.3 1.3 0 0 0 .49 0v6h-1c-1-3.67-1.85-7.32-.06-11.06.39-.76.06-1.93.06-2.93"
            style={{
              fill: "#ecbc89",
            }}
          />
          <path
            d="M173.91 216h1a5.34 5.34 0 0 0 1 4c-.33.34-.67.67-1 1v5c-.33-.41-.94-.81-1-1.24-.04-2.88 0-5.76 0-8.76"
            style={{
              fill: "#e1af79",
            }}
          />
          <path
            d="m175.91 228-1-1v-1c1.5.12.85 1.28 1 2"
            className="templesOnly_svg__cls-510"
          />
          <path
            d="M172.91 241h1c-.33.34-.67.67-1 1Z"
            style={{
              fill: "#be9060",
            }}
          />
          <path
            d="M175.91 220a5.34 5.34 0 0 1-1-4v-6h1v7c.33 1 .67 2 1 3Z"
            className="templesOnly_svg__cls-512"
          />
          <path
            d="M176.91 220c-.33-1-.67-2-1-3l.83-.32-.83-.68v-6h1c-.72 2.8 1.11 5.28 1 8v5h-2v-1c1.5 0 .85-1.21 1-2"
            className="templesOnly_svg__cls-510"
          />
          <path
            d="M173.91 156v2h-2c-1.37 0-1-1.06-1-1.78V88.59l2-2.56c0 1.73-.31 3.53 1 5-.33.41-.93.81-.95 1.23-.1 2.09-.05 4.19-.05 5.1.53 2 .77 2.82 1 3.67-.33.27-1 .54-.95.79.09 2.09-.23 4.43.62 6.19 1.14 2.38-.8 3.95-.66 5.93 0 .3.09.73.29.86 1.09.71.68 1.79.68 2.72 0 4.81.08 9.63 0 14.44a11.6 11.6 0 0 1-1 3.07v2l.85 1.5-.85 1.5v3c1.16 1.45 1 3.16 1 4.84 0 .79-.63 2 1 2.16.01 2.06-1.68 3.83-.98 5.97"
            style={{
              fill: "#eac094",
            }}
          />
          <path
            d="m177.91 136 1 1v2c-1.91 1.17-2.09 3-2 5h-1l-1-1v-6c1.93-.46.62-2 1-3a9 9 0 0 1 1 .77c.36.41.67.85 1 1.23"
            style={{
              fill: "#d39451",
            }}
          />
          <path
            d="M174.91 141v9c-1.6-.13-.94-1.37-1-2.16-.07-1.68.13-3.39-1-4.84a8 8 0 0 0 1-.76 15 15 0 0 0 1-1.24"
            style={{
              fill: "#e1ac76",
            }}
          />
          <path
            d="M175.91 144h2c1.93.47.62 2 1 3v2c-1.5-.08-.85-1.24-1-2l-1-1h-1Z"
            style={{
              fill: "#cb8a47",
            }}
          />
          <path
            d="m176.91 146 1 1Z"
            style={{
              fill: "#dc9b58",
            }}
          />
          <path
            d="M177.91 144h-1c-.09-2 .09-3.83 2-5v1a5.34 5.34 0 0 1-1 4"
            className="templesOnly_svg__cls-518"
          />
          <path
            d="M174.91 101c.58 1.76 1.08 3.54 1.78 5.25.77 1.87-.22 3.35-.73 5-.2.62-.42 1.75.95 1.76a10.3 10.3 0 0 1 1 2c.29 1.34-1 2.53-.09 4.15.62 1.14.12 2.88.12 4.36s.11 3.28 0 4.91a10.6 10.6 0 0 1-1 2.53h-1a17.5 17.5 0 0 0 0-2.81c-.07-.44-.62-.79-1-1.19v-2.66l2.08-.69c-.37-.37-.85-.76-.81-.82 1.08-1.61-.84-3-.3-4.6s-.82-3-.94-4.58c-.14-1.82.06-3.67-.08-5.49a6.8 6.8 0 0 0-1-2.09q2.055-1.5 0-3v-2Z"
            className="templesOnly_svg__cls-519"
          />
          <path
            d="M175.91 131h1c.33 1.67.67 3.34 1 5-.33-.41-.64-.85-1-1.23a9 9 0 0 0-1-.77Z"
            style={{
              fill: "#da9a54",
            }}
          />
          <path
            d="M173.91 91h1l1 1c.15.76-.5 1.92 1 2v1c.09 2-.09 3.83-2 5-.23-.86-.47-1.72-.73-2.7.95-.73 1-1.8.41-3.17a16.7 16.7 0 0 1-.68-3.13"
            style={{
              fill: "#e3a45d",
            }}
          />
          <path
            d="M173.91 91a16.7 16.7 0 0 0 .68 3.13c.59 1.37.54 2.44-.41 3.17.26 1 .5 1.84.73 2.7v1h-1c-.23-.85-.47-1.71-1-3.67 0-.91 0-3 .05-5.1.04-.39.62-.79.95-1.23"
            className="templesOnly_svg__cls-496"
          />
          <path
            d="m175.91 92-1-1v-7c.33-.39.88-.74 1-1.18a17.7 17.7 0 0 0 0-2.82v-1h1c0 3-.08 6 .05 8.94a12.3 12.3 0 0 0 .95 3.06c-.76.19-1.91-.46-2 1"
            style={{
              fill: "#df9243",
            }}
          />
          <path
            d="M175.91 92c.09-1.49 1.24-.84 2-1-.33 1-.67 2-1 3-1.5 0-.85-1.21-1-2"
            style={{
              fill: "#d4863c",
            }}
          />
          <path
            d="M175.91 223h1c.33 1.67.8 3.33 1 5a35 35 0 0 1 0 5.41 7 7 0 0 1-.66 1.94l.7 2.64c-.33.67-.67 1.34-1 2v1h-1v-6l.85-1.5-.85-1.5a2.48 2.48 0 0 0 0-4c-.15-.75.5-1.91-1-2v-3Z"
            style={{
              fill: "#daa05b",
            }}
          />
          <path
            d="M174.91 249h-2l-.86-.32 1.86-3.68h2c-.33.67-.67 1.34-1 2z"
            className="templesOnly_svg__cls-525"
          />
          <ellipse
            cx={175.91}
            cy={247.53}
            rx={1.41}
            ry={0.71}
            style={{
              fill: "#d1a162",
            }}
          />
          <path
            d="M172.91 242c.33-.33.67-.66 1-1l1 1c-.33 1-.67 2-1 3h-1Z"
            className="templesOnly_svg__cls-525"
          />
          <path
            d="M199.91 266h-1v-1Z"
            style={{
              fill: "#572c09",
            }}
          />
          <path
            d="m188.91 258 1 1Z"
            style={{
              fill: "#c07031",
            }}
          />
          <path
            d="M177.91 255h1c.11.61.18 1.23.34 1.83s.44 1.45.66 2.17h-1l-1-1z"
            style={{
              fill: "#f4be83",
            }}
          />
          <path
            d="M182.91 259h-1v-1Z"
            style={{
              fill: "#dda971",
            }}
          />
          <path
            d="M181.91 258v1l-.83-.67Z"
            style={{
              fill: "#bd8951",
            }}
          />
          <circle
            cx={179.41}
            cy={259.53}
            r={0.71}
            style={{
              fill: "#c9975b",
            }}
          />
          <path
            d="M173.91 255h2v1l-2 1-1-1c.33-.3.67-.63 1-1"
            style={{
              fill: "#fdc17f",
            }}
          />
          <path d="M175.91 256v-1h2v1z" className="templesOnly_svg__cls-470" />
          <path
            d="M173.91 255c-.33.34-.67.67-1 1v-2Z"
            style={{
              fill: "#fecd8b",
            }}
          />
          <path
            d="m165.91 256 1 1v2c.09 1.5 1.24.85 2 1v2a12.3 12.3 0 0 1-2.13-.67 13.3 13.3 0 0 1-1.87-1.33l-1-2v-2Z"
            className="templesOnly_svg__cls-535"
          />
          <path
            d="M163.91 256v2a15 15 0 0 1-1 1.24 8 8 0 0 1-1 .76v-2l-1-1v-1z"
            style={{
              fill: "#cea985",
            }}
          />
          <path
            d="M168.91 262v-2c-.09-1.49-1.24-.84-2-1v-2c.33-.33.67-.66 1-1h5l1 1v1c-.67.67-1.33 1.34-2 2v2c-.76.16-1.91-.49-2 1h-1Z"
            className="templesOnly_svg__cls-537"
          />
          <path
            d="M167.91 256c-.33.34-.67.67-1 1 .33-.3.67-.63 1-1"
            className="templesOnly_svg__cls-535"
          />
          <path
            d="M177.91 262c-.11.61-.18 1.23-.34 1.83s-.44 1.45-.66 2.17h-1c-.15-.75.5-1.91-1-2v-1l2-1Z"
            style={{
              fill: "#fbc98a",
            }}
          />
          <path
            d="m179.91 266 1 1.78-3 .22h-2v-1h1Z"
            style={{
              fill: "#b07f44",
            }}
          />
          <path
            d="M176.91 267h-3c.33-.33.67-.66 1-1h2Z"
            style={{
              fill: "#f1bc83",
            }}
          />
          <path
            d="M182.91 268c-1.5-.08-.85-1.24-1-2h2v1c-.33.37-.67.7-1 1"
            className="templesOnly_svg__cls-485"
          />
          <path
            d="M177.91 262h-1v-1h2v1Z"
            style={{
              fill: "#f5c583",
            }}
          />
          <ellipse
            cx={180.41}
            cy={264.53}
            rx={0.71}
            ry={0.24}
            style={{
              fill: "#deab77",
            }}
          />
          <path
            d="M178.91 261h-2v-1h3v1Z"
            style={{
              fill: "#dfaf6e",
            }}
          />
          <path
            d="M178.91 261h1c-.33.34-.67.67-1 1Z"
            className="templesOnly_svg__cls-482"
          />
          <path
            d="M177.91 68h-1l-2-1.76.33-1.24h4.7l1 1a4.8 4.8 0 0 1-1.27 1c-.67.23-1.75-.3-1.76 1"
            style={{
              fill: "#5e1302",
            }}
          />
          <path
            d="m168.91 71-1-1h1c1-.38 2.53.93 3-1v-2l1.64 2h3.36v2h-2l-.33-.82-.67.82h-1c-.33.34-.67.67-1 1h-1c-.09-1.46-1.24-.81-2-1"
            style={{
              fill: "#c3662c",
            }}
          />
          <path
            d="M175.91 62h1v3h-1.7l-.33 1.24 2 1.76h-2.58c-.55-1.16-1-2.08-1.42-3l2-1c1.53 0 .88-1.21 1.03-2"
            style={{
              fill: "#7d3014",
            }}
          />
          <path d="M175.91 71h1v1Z" className="templesOnly_svg__cls-492" />
          <path
            d="M174.91 79c-.33-.41-.67-.82-1-1.24l1-.76Z"
            className="templesOnly_svg__cls-547"
          />
          <path
            d="M172.91 85c-.33-.39-.91-.77-.95-1.2a37 37 0 0 1-.05-3.8h1.45c-.16 1.87-.31 3.45-.45 5"
            className="templesOnly_svg__cls-548"
          />
          <path
            d="M175.91 80a17.7 17.7 0 0 1 0 2.82c-.07.44-.62.79-1 1.18a19 19 0 0 1 0-2.81c.09-.41.67-.76 1-1.19"
            className="templesOnly_svg__cls-547"
          />
          <path
            d="M171.91 79c-.33-1-.67-2-1-3h1q2.055 1.5 0 3"
            className="templesOnly_svg__cls-548"
          />
          <path d="M171.91 76h-1v-3h1z" className="templesOnly_svg__cls-403" />
          <path
            d="M172.91 71h1v2h-1zM173.91 71l.67-.82.33.82Z"
            className="templesOnly_svg__cls-492"
          />
          <circle
            cx={172.41}
            cy={72.53}
            r={0.71}
            style={{
              fill: "#7e2c00",
            }}
          />
          <circle
            cx={201.41}
            cy={265.53}
            r={0.71}
            style={{
              fill: "#94693d",
            }}
          />
          <path
            d="M204.93 266h-1v-1h2v1Z"
            style={{
              fill: "#562a09",
            }}
          />
          <path
            d="M168.91 71c.76.16 1.91-.49 2 1v1Z"
            className="templesOnly_svg__cls-403"
          />
          <path
            d="M167.91 68h1v2h-1Z"
            style={{
              fill: "#853e0c",
            }}
          />
          <circle
            cx={160.41}
            cy={256.53}
            r={0.71}
            style={{
              fill: "#705336",
            }}
          />
          <path
            d="M175.91 228a2.48 2.48 0 0 1 0 4ZM175.91 232l.85 1.5-.85 1.5q-2.055-1.5 0-3"
            className="templesOnly_svg__cls-510"
          />
          <path
            d="M176.91 220c-.15.76.5 1.92-1 2h-1v-1c.33-.33.67-.66 1-1Z"
            className="templesOnly_svg__cls-433"
          />
          <circle
            cx={175.41}
            cy={222.53}
            r={0.71}
            className="templesOnly_svg__cls-512"
          />
          <path
            d="M175.91 220c-.33.34-.67.67-1 1 .33-.3.67-.63 1-1"
            className="templesOnly_svg__cls-512"
          />
          <path
            d="m175.91 216 .83.68-.83.32Z"
            className="templesOnly_svg__cls-433"
          />
          <path
            d="M173.91 101v5a6.8 6.8 0 0 1 1 2.09c.14 1.82-.06 3.67.08 5.49.12 1.55 1.49 2.93.94 4.58s1.38 3 .3 4.6c0 .06.44.45.81.82l-2.08.69V135h-2a11.6 11.6 0 0 0 1-3.07c.11-4.81.07-9.63 0-14.44 0-.93.41-2-.68-2.72-.2-.13-.27-.56-.29-.86-.14-2 1.8-3.55.66-5.93-.85-1.76-.53-4.1-.62-6.19-.03-.22.55-.49.88-.79"
            style={{
              fill: "#e4b379",
            }}
          />
          <path
            d="M174.91 137v3h-2l.85-1.5-.85-1.5Z"
            className="templesOnly_svg__cls-555"
          />
          <path
            d="M172.91 140h2v1a15 15 0 0 1-1 1.24 8 8 0 0 1-1 .76Z"
            style={{
              fill: "#d09f6d",
            }}
          />
          <ellipse
            cx={173.91}
            cy={136.53}
            rx={1.41}
            ry={0.71}
            style={{
              fill: "#d3a373",
            }}
          />
          <ellipse
            cx={173.91}
            cy={135.53}
            className="templesOnly_svg__cls-555"
            rx={1.41}
            ry={0.71}
          />
          <path
            d="M174.91 136v-5h1v3c-.38 1 .93 2.54-1 3Z"
            className="templesOnly_svg__cls-519"
          />
          <path
            d="M175.91 131h-1v-4c.33.4.88.75 1 1.19a17.5 17.5 0 0 1 0 2.81"
            className="templesOnly_svg__cls-555"
          />
          <path
            d="M173.91 106v-3q2.055 1.5 0 3"
            className="templesOnly_svg__cls-496"
          />
          <path
            d="M173.91 258v-1l2-1 1 1h1v1c-.76.16-1.91-.49-2 1h-1Z"
            style={{
              fill: "#daa05d",
            }}
          />
          <path
            d="M175.91 259c.09-1.49 1.24-.84 2-1l1 1c-.33.34-.67.67-1 1h-1Z"
            style={{
              fill: "#dda868",
            }}
          />
          <circle
            cx={177.41}
            cy={256.53}
            r={0.71}
            style={{
              fill: "#b07e3f",
            }}
          />
          <path
            d="M177.91 260c.33-.33.67-.66 1-1v1Z"
            className="templesOnly_svg__cls-561"
          />
          <path
            d="M176.91 256v1l-1-1Z"
            style={{
              fill: "#a26d2d",
            }}
          />
          <path
            d="M168.91 262v1c-.33.34-.67.67-1 1h-2l-1-1h-1v-2c.33-.33.67-.66 1-1a13.3 13.3 0 0 0 1.87 1.33 12.3 12.3 0 0 0 2.13.67"
            style={{
              fill: "#feca90",
            }}
          />
          <path
            d="M163.91 261v2c-.33.34-.67.67-1 1h-1l-1-1v-1c1.5-.08.85-1.24 1-2a8 8 0 0 0 1-.76 15 15 0 0 0 1-1.24l1 2c-.33.37-.67.7-1 1"
            style={{
              fill: "#e3b682",
            }}
          />
          <path
            d="M166.91 259c.76.16 1.91-.49 2 1-.76-.12-1.91.53-2-1"
            style={{
              fill: "#f1b06f",
            }}
          />
          <path
            d="M161.91 260c-.15.76.5 1.92-1 2v-4h1Z"
            style={{
              fill: "#ebbb8b",
            }}
          />
          <path
            d="M161.91 258h-1v-1Z"
            style={{
              fill: "#e6bf9e",
            }}
          />
          <path
            d="M174.91 259h1c.15.76-.5 1.92 1 2v1l-2 1c-.21-2.24-.76-2.79-3-3 .67-.66 1.33-1.33 2-2Z"
            className="templesOnly_svg__cls-568"
          />
          <path
            d="M171.91 260c2.24.21 2.79.76 3 3h-1c-.09-1.49-1.24-.84-2-1Z"
            style={{
              fill: "#db9b54",
            }}
          />
          <path
            d="M169.91 263c.09-1.49 1.24-.84 2-1v2h-1Z"
            style={{
              fill: "#cc8e47",
            }}
          />
          <path
            d="M168.91 263h1l1 1v1h-2z"
            style={{
              fill: "#cf934b",
            }}
          />
          <path
            d="M170.91 265v-1h1l2-1h1v2Z"
            style={{
              fill: "#f2bb78",
            }}
          />
          <path
            d="M174.91 265v-1c1.5.09.85 1.25 1 2h-1Z"
            style={{
              fill: "#fed295",
            }}
          />
          <path
            d="M175.91 268v1h-2v-2h2Z"
            style={{
              fill: "#dfa46e",
            }}
          />
          <path
            d="M174.91 265v1c-.33.34-.67.67-1 1h-2l-1-1v-1Z"
            style={{
              fill: "#fdd08b",
            }}
          />
          <path
            d="M176.91 261c-1.5-.08-.85-1.24-1-2l1 1Z"
            className="templesOnly_svg__cls-561"
          />
          <path
            d="M169.91 68h2v1h-3v-1Z"
            style={{
              fill: "#c7752a",
            }}
          />
          <path
            d="M168.91 69h3c-.47 1.93-2 .62-3 1Z"
            style={{
              fill: "#8c3f00",
            }}
          />
          <circle
            cx={171.41}
            cy={72.53}
            r={0.71}
            className="templesOnly_svg__cls-578"
          />
          <path
            d="M172.91 72h-1c.33-.33.67-.66 1-1Z"
            className="templesOnly_svg__cls-578"
          />
          <path
            d="M160.91 260v4h-1v-4Z"
            style={{
              fill: "#d18e5c",
            }}
          />
          <path
            d="M159.91 260v-3h1v3Z"
            style={{
              fill: "#b47b4c",
            }}
          />
          <path
            d="m174.91 259-1-1Z"
            style={{
              fill: "#d1924c",
            }}
          />
          <path
            d="M165.91 264h2v1h-4c.33-.33.67-.66 1-1Z"
            className="templesOnly_svg__cls-582"
          />
          <path
            d="M164.91 264c-.33.34-.67.67-1 1v1h-1v-2c.33-.33.67-.66 1-1h1Z"
            style={{
              fill: "#fdc688",
            }}
          />
          <path
            d="M168.91 263v1h-1c.33-.3.67-.63 1-1"
            className="templesOnly_svg__cls-537"
          />
          <path
            d="M164.91 264v-1l1 1ZM163.91 261c.33-.33.67-.66 1-1-.33.37-.67.7-1 1"
            className="templesOnly_svg__cls-535"
          />
          <path
            d="M160.91 264v-1l1 1v2c-1.5 0-.85-1.21-1-2"
            style={{
              fill: "#e4ae7c",
            }}
          />
          <ellipse
            cx={162.41}
            cy={265.03}
            rx={0.71}
            ry={1.41}
            style={{
              fill: "#eab67e",
            }}
          />
          <path
            d="m173.91 263-2 1v-2c.76.19 1.91-.46 2 1"
            className="templesOnly_svg__cls-568"
          />
          <path
            d="m170.91 264-1-1Z"
            style={{
              fill: "#b47931",
            }}
          />
          <path
            d="M170.91 265v1h-2v-1Z"
            style={{
              fill: "#f8c177",
            }}
          />
          <circle
            cx={168.41}
            cy={264.53}
            r={0.71}
            style={{
              fill: "#c88c45",
            }}
          />
          <path
            d="M173.91 269h-1v-2h1Z"
            style={{
              fill: "#f3bd84",
            }}
          />
          <path
            d="M172.91 267v1c-.76-.15-1.91.5-2-1z"
            style={{
              fill: "#deb576",
            }}
          />
          <path
            d="M171.91 267h-2v-1h1Z"
            style={{
              fill: "#feda95",
            }}
          />
          <path
            d="M159.91 267v-3h1c.15.76-.5 1.92 1 2h1v1Z"
            style={{
              fill: "#dfa271",
            }}
          />
          <path
            d="M163.91 266v-1h1v3l1 1v1l-2 1z"
            style={{
              fill: "#fab97f",
            }}
          />
          <path
            d="M164.91 267v-2h4v1h-1c-.33.34-.67.67-1 1Z"
            style={{
              fill: "#d79c5a",
            }}
          />
          <path d="M163.91 266v4h-1v-4Z" className="templesOnly_svg__cls-582" />
          <path
            d="M167.91 266h2v1h-2Z"
            style={{
              fill: "#fbc782",
            }}
          />
          <path
            d="M171.91 270h-2v-3h1c.09 1.5 1.24.85 2 1v1c-.33.37-.67.7-1 1"
            style={{
              fill: "#efbe7d",
            }}
          />
          <path
            d="M162.91 269h-1c-.41-.33-.86-.63-1.24-1a8.5 8.5 0 0 1-.76-1h3Z"
            style={{
              fill: "#c18550",
            }}
          />
          <path
            d="M166.91 268h-2v-1h4c-.33.34-.67.67-1 1Z"
            style={{
              fill: "#e3a666",
            }}
          />
          <path
            d="M167.91 267h-1c.33-.33.67-.66 1-1Z"
            className="templesOnly_svg__cls-582"
          />
          <path
            d="M167.91 268c.33-.33.67-.66 1-1h1v2h-2Z"
            style={{
              fill: "#d7a260",
            }}
          />
        </g>
        <g id="templesOnly_svg__column3" ref={el => columnRefs.current[2] = el}>
          <path
            d="M59 262.08h2v2l1 1c-.34 1-.67 2-1 3h-1v-1c-.67-1.33-1.34-2.66-2-4Z"
            style={{
              fill: "#c1915a",
            }}
          />
          <path
            d="M68 225.07v-83.65c0-5.7 1.65-11.27 1-17-.26-2.53.44-5.17-1-7.57a7 7 0 0 1 1-.76c.08 1.49 1.24.85 2 1l-.81 1.38a10.35 10.35 0 0 1 .17 7.88c-.42 1.11.18 2.6.36 4.26C69 132.83 70 135 72 137.07l1 1v2l-3.22 1.54 1.19 3.7c-.11.16-.59.54-.6.92-.06 2.56-.41 5.21.12 7.66a7 7 0 0 1 .11 4.08 7.6 7.6 0 0 0-.58 2.24c-.05 4.16-.08 8.31 0 12.46a8 8 0 0 0 .94 2.52c-.34.74-.93 1.43-.94 2.14-.08 4.65-.06 9.3 0 13.95 0 .27.62.53 1 .79v1c-1.5.08-.85 1.24-1 2v15c.15.76-.5 1.91 1 2 0 3.45.05 6.9 0 10.35 0 1.15-1 2.91-.59 3.31C72 227.25 70 228 70 229.07c-1.65-.17-.81-1.45-1-2.25s.33-1.74-1-1.75"
            className="templesOnly_svg__cls-601"
          />
          <path
            d="M68 225.07c1.34 0 .85 1 1 1.75s-.66 2.08 1 2.25v8c-.38.48-.77 1-1.6 2H71c-.21.37-.39.76-.63 1.11-.59.91-.75 1.64.63 1.89v14h-2c-.16-.76.49-1.92-1-2Z"
            style={{
              fill: "#e4b886",
            }}
          />
          <path
            d="M68 254.07c1.49.08.84 1.24 1 2v2c.38 1-.93 2.53 1 3v1l-1 1-2 1-1-1v-1c2.34-2.25 2-5.18 2-8"
            style={{
              fill: "#f6cc96",
            }}
          />
          <path
            d="m67 264.07 2-1 1 2h-1l-3 1h-2v-2c1.49-.09.84-1.24 1-2h1v1Z"
            style={{
              fill: "#edbc81",
            }}
          />
          <path
            d="M68 112.07c-.34-1-.67-2-1-3l1-1v-1h1l1 1-1 2 1 1v1z"
            className="templesOnly_svg__cls-605"
          />
          <path
            d="M68 112.07h1l2 3-2 1a5.34 5.34 0 0 1-1-4"
            style={{
              fill: "#fcbf86",
            }}
          />
          <ellipse
            cx={62.49}
            cy={263.07}
            rx={2.12}
            ry={1.41}
            style={{
              fill: "#80573b",
            }}
          />
          <path
            d="M64 264.07v-2h1c-.17.76.48 1.93-1 2"
            className="templesOnly_svg__cls-608"
          />
          <path
            d="M60 268.08h1c.15.76-.5 1.92 1 2v1l.33.83.67-.83 1 1c.15.76-.5 1.92 1 2-.34 1-.67 2-1 3h-4c-.15-.76.49-1.91-1-2a31 31 0 0 1 0-3.95 16.6 16.6 0 0 1 1-3.05"
            style={{
              fill: "#dead70",
            }}
          />
          <path
            d="M62 270.07c-1.5-.09-.85-1.24-1-2 .33-1 .66-2 1-3h2v2Z"
            className="templesOnly_svg__cls-610"
          />
          <path
            d="M64 265.07h-2l-1-1h3Z"
            className="templesOnly_svg__cls-608"
          />
          <path
            d="M71 192.07c-.34-.26-1-.52-1-.79-.06-4.65-.08-9.3 0-13.95 0-.71.6-1.4.94-2.14a8 8 0 0 1-.94-2.52c-.1-4.15-.07-8.3 0-12.46a7.6 7.6 0 0 1 .58-2.24 7 7 0 0 0-.11-4.08c-.53-2.45-.18-5.1-.12-7.66 0-.38.49-.76.6-.92l-1.19-3.7 3.24-1.54v1l1 1v1c-.34.41-.95.82-1 1.24-.08 3.25 0 6.51 0 9.76v14c-.28 3.44.68 7-.91 10.34-.28.59-1 2.34.91 2.66a41 41 0 0 0 0 4.45 42 42 0 0 0 1 4.55c-1.93.47-.62 2-1 3v26h-1v-28.42c0-.13-.16-.28-.29-.37s-.23 0-.69-.11Z"
            className="templesOnly_svg__cls-611"
          />
          <path
            d="M71 192.07v-1.9c.46.07.61.05.69.11s.29.24.29.37v28.42c0 3.46.08 6.93 0 10.39a19.8 19.8 0 0 1-.78 3.7 10.36 10.36 0 0 1-.17 8.91c-1.38-.25-1.22-1-.63-1.89.24-.35.42-.74.63-1.11-.34-.67-.67-1.33-1-2v-8c0-1.09 2-1.82.37-3.34-.44-.4.56-2.16.59-3.31.09-3.45 0-6.9 0-10.35v-20Z"
            style={{
              fill: "#d99959",
            }}
          />
          <path
            d="M72 137.07c-2-2-3-4.24-1.28-6.48-.18-1.66-.78-3.15-.36-4.26a10.35 10.35 0 0 0-.17-7.88l.81-1.38 1 1v6.37c0 .94.2 2.2-.84 3.14-.24.23.76 1.57.79 2.41a10.4 10.4 0 0 1-.59 2.7l.65 1.38Z"
            style={{
              fill: "#efb97d",
            }}
          />
          <path
            d="M73 141.07v-7h1c.15.76-.5 1.91 1 2-1.32 1.47-1 3.27-1 5Z"
            className="templesOnly_svg__cls-614"
          />
          <ellipse
            cx={70.49}
            cy={206.07}
            className="templesOnly_svg__cls-615"
            rx={0.71}
            ry={5.66}
          />
          <path
            d="m72 118.07-1-1c-.76-.15-1.92.49-2-1l2-1h1l1 1v2Z"
            style={{
              fill: "#cc8f4f",
            }}
          />
          <ellipse
            cx={70.49}
            cy={200.07}
            className="templesOnly_svg__cls-617"
            rx={0.71}
            ry={2.83}
          />
          <path
            d="M73 134.07v4l-1-1v-3Z"
            className="templesOnly_svg__cls-611"
          />
          <path
            d="M70 210.07h1v2c-1.51-.07-.86-1.24-1-2"
            style={{
              fill: "#e9b780",
            }}
          />
          <ellipse
            cx={70.49}
            cy={196.07}
            className="templesOnly_svg__cls-617"
            rx={0.71}
            ry={1.41}
          />
          <path
            d="M71 195.07h-1c.15-.76-.5-1.92 1-2Z"
            className="templesOnly_svg__cls-615"
          />
          <circle
            cx={70.49}
            cy={197.57}
            r={0.71}
            className="templesOnly_svg__cls-615"
          />
          <path
            d="M70 261.07c-1.93-.47-.62-2-1-3 1.49-.09.84-1.24 1-2h1l1 1-1 2Z"
            style={{
              fill: "#e9b474",
            }}
          />
          <path
            d="M71 250.07v-8c1.92.47.61 2 1 3v5Z"
            style={{
              fill: "#d08e51",
            }}
          />
          <path d="M71 250.07h1v7l-1-1Z" className="templesOnly_svg__cls-621" />
          <path
            d="M70 237.07c.33.67.66 1.33 1 2h-2.6c.82-1.07 1.21-1.52 1.6-2"
            className="templesOnly_svg__cls-601"
          />
          <path
            d="M70 256.07c-.16.76.49 1.91-1 2v-2Z"
            style={{
              fill: "#d2a168",
            }}
          />
          <path
            d="m70 265.07-1-2 1-1h2c.08 1.49 1.24.85 2 1v1c-1.5.08-.85 1.24-1 2h-1l-.34-1.9-.66.06v1.84h-1Z"
            style={{
              fill: "#e7b06a",
            }}
          />
          <path
            d="M72 262.07h-2v-1h3v1Z"
            style={{
              fill: "#fbc379",
            }}
          />
          <path
            d="m67 264.07-1-1Z"
            style={{
              fill: "#fee1ad",
            }}
          />
          <path
            d="m62 270.07 2-3c.75-.15 1.91.49 2-1l3-1 1 1v1l-5 1-2 3h-1Z"
            style={{
              fill: "#f4c084",
            }}
          />
          <path
            d="M66 266.07c-.09 1.49-1.25.85-2 1v-1Z"
            style={{
              fill: "#e4b176",
            }}
          />
          <path
            d="m70 266.07-1-1h1Z"
            style={{
              fill: "#fdc886",
            }}
          />
          <path
            d="m70 108.07-1-1-1-1v-1h1l1-.76c-.34-.41-.67-.83-1-1.24v-1h3v1l-.83.33.83.67v2l-.83.33.83.67v1Z"
            style={{
              fill: "#9b3d05",
            }}
          />
          <path
            d="M70 112.07v-1l1-1a8 8 0 0 0 1 0l-.15.14.7.82.31-.32A5.5 5.5 0 0 0 72 110a7 7 0 0 1 0-1l1-1h2c-.3.52-.61 1-.91 1.57 1.33.81.82 2.2.91 3.43h-1c-.47-1.93-2-.62-3-1Z"
            className="templesOnly_svg__cls-630"
          />
          <path
            d="M70 112.07h1c.25.33.51 1 .76 1 1.68 0 1.15 1.18 1.24 2h-2l-2-3Z"
            style={{
              fill: "#e4944f",
            }}
          />
          <path
            d="m73 108.07-1 1-1 1h-2l1-2z"
            style={{
              fill: "#ce7335",
            }}
          />
          <path
            d="M69 110.07h2l-1 1Z"
            style={{
              fill: "#974003",
            }}
          />
          <path d="m68 106.07 1 1h-1Z" className="templesOnly_svg__cls-634" />
          <path
            d="M65 274.07c-1.5-.09-.85-1.24-1-2 1.49-.09.84-1.24 1-2h1v1l1 1v2z"
            style={{
              fill: "#f1bc7c",
            }}
          />
          <path
            d="M65 270.07c-.16.76.49 1.91-1 2l-1-1 2-3Z"
            className="templesOnly_svg__cls-610"
          />
          <path
            d="M65 274.07h1l.85 1.5-.85 1.5h-2c.32-1 .65-2 1-3"
            style={{
              fill: "#fac785",
            }}
          />
          <path
            d="M72 246.07v-1c1.65-.17 1-1.47 1-2.26.06-7.91 0-15.83 0-23.74v-20l2 1v-3h1v7a7.7 7.7 0 0 1-.29 1.76c-1 2.34-1 2.33 1.29 4.24a455 455 0 0 0-1 3.48l1 1a5.44 5.44 0 0 0-1 3.49h-1l-.35-1.9-.65.08v39.82h-1v-8.76c-.07-.39-.68-.8-1-1.21"
            style={{
              fill: "#b96c2b",
            }}
          />
          <path
            d="M73 219.07v23.74c0 .79.69 2.09-1 2.26-.39-1 .92-2.53-1-3a10.36 10.36 0 0 0 .17-8.91 19.8 19.8 0 0 0 .78-3.7c.13-3.46 0-6.93 0-10.39Z"
            className="templesOnly_svg__cls-638"
          />
          <path
            d="M73 181.07c-1.92-.32-1.19-2.07-.91-2.66 1.59-3.38.63-6.9.91-10.34.33.41.63.85 1 1.23a7.6 7.6 0 0 0 1 .77c.33.4.91.77 1 1.2a37 37 0 0 1 0 3.8c-1.93.47-.62 2-1 3a2.46 2.46 0 0 0-2 3"
            style={{
              fill: "#b76b2d",
            }}
          />
          <path
            d="M74 141.07c0-1.73-.32-3.53 1-5l1 1v11h-1a17.7 17.7 0 0 0 0-2.82c-.07-.43-.62-.79-1-1.18v-2l.82-.33Z"
            style={{
              fill: "#c1652a",
            }}
          />
          <path
            d="M74 190.07a42 42 0 0 1-1-4.55 41 41 0 0 1 0-4.45h2v9Z"
            style={{
              fill: "#b7682c",
            }}
          />
          <path
            d="M75 170.07a7.6 7.6 0 0 1-1-.77c-.37-.38-.67-.82-1-1.23v-3l2-1 1 1c-.35 1.67-.68 3.33-1 5"
            style={{
              fill: "#af5e21",
            }}
          />
          <path
            d="M74 143.07v9c-.16.76.49 1.91-1 2v-9.76c0-.42.65-.83 1-1.24"
            style={{
              fill: "#b26b2c",
            }}
          />
          <path
            d="M73 154.07c1.49-.09.84-1.24 1-2h1v5l-2-1Z"
            style={{
              fill: "#ae6223",
            }}
          />
          <path
            d="M73 195.07v-2h2c.33.67.66 1.33 1 2-1.5.08-.85 1.24-1 2h-1c-.17-.76.48-1.92-1-2"
            style={{
              fill: "#af6224",
            }}
          />
          <path
            d="m75 164.07-2 1v-4l2 1Z"
            className="templesOnly_svg__cls-646"
          />
          <path
            d="M74 197.07h1v3l-2-1v-2Z"
            className="templesOnly_svg__cls-647"
          />
          <path
            d="m75 162.07-2-1v-2h2Z"
            style={{
              fill: "#af6124",
            }}
          />
          <path
            d="M75 159.07h-2v-3l2 1Z"
            className="templesOnly_svg__cls-646"
          />
          <path
            d="M75 193.07h-2c.38-1-.93-2.53 1-3 .15.76-.5 1.91 1 2ZM74 197.07h-1v-2c1.48.08.83 1.24 1 2"
            className="templesOnly_svg__cls-649"
          />
          <path
            d="m74 141.07.82.67-.82.33-1-1Z"
            style={{
              fill: "#b16024",
            }}
          />
          <path
            d="M73 134.07h-1l-.65-1.38a10.4 10.4 0 0 0 .59-2.7c0-.84-1-2.18-.79-2.41 1-.94.81-2 .84-3.14s0-2 0-2.94v-3.43h1v16Z"
            style={{
              fill: "#eab278",
            }}
          />
          <path
            d="m76 137.07-1-1c-1.5-.09-.85-1.24-1-2l1-1 1-1h1v5Z"
            style={{
              fill: "#c0511a",
            }}
          />
          <circle
            cx={73.49}
            cy={133.57}
            r={0.71}
            className="templesOnly_svg__cls-653"
          />
          <path
            d="M72 115.07h1c1.49-.09.84-1.24 1-2h1v3h-2Z"
            style={{
              fill: "#a7581d",
            }}
          />
          <path
            d="M73 118.07v-1h2v1z"
            style={{
              fill: "#b66025",
            }}
          />
          <ellipse
            cx={73.99}
            cy={116.57}
            rx={1.41}
            ry={0.71}
            style={{
              fill: "#be672e",
            }}
          />
          <path
            d="M73 261.07h-3l1-2h1l1 1Z"
            style={{
              fill: "#e3a75f",
            }}
          />
          <path
            d="M72 259.07h-1l1-2h1v2Z"
            className="templesOnly_svg__cls-621"
          />
          <path
            d="M73 257.07h-1v-11c.33.41.94.82 1 1.24.09 2.92 0 5.84 0 8.76Z"
            className="templesOnly_svg__cls-638"
          />
          <path
            d="M72 266.07h1v1c-1.5.08-.85 1.24-1 2v1c.15.76-.5 1.91 1 2v2h-2c-.16-.76.49-1.92-1-2v-1l.82-.33-.82-.67v-1l1-2v-1Z"
            style={{
              fill: "#f5bd7f",
            }}
          />
          <path
            d="M74 264.07v-1h1c1 .38 2.53-.93 3 1v2h-1v-1l-1-1-2 1Z"
            style={{
              fill: "#d49c63",
            }}
          />
          <path
            d="M75 263.07h-1c-.76-.15-1.92.49-2-1h3Z"
            className="templesOnly_svg__cls-660"
          />
          <path
            d="M74 264.07v2h-1c.14-.76-.51-1.92 1-2"
            className="templesOnly_svg__cls-661"
          />
          <path
            d="M72 266.07h-1v-1.84l.66-.06Z"
            style={{
              fill: "#cc934f",
            }}
          />
          <circle
            cx={70.49}
            cy={266.57}
            r={0.71}
            style={{
              fill: "#fec582",
            }}
          />
          <ellipse
            cx={73.99}
            cy={261.57}
            rx={1.41}
            ry={0.71}
            style={{
              fill: "#efb06e",
            }}
          />
          <path
            d="M70 267.07h1l-1 2-1 1h-1l-1-1-1 1h-1v-2Z"
            style={{
              fill: "#e8b274",
            }}
          />
          <path
            d="M72 106.07v-1h1v2h-1Z"
            style={{
              fill: "#872800",
            }}
          />
          <path
            d="M69 105.07v-2c.33.41.66.83 1 1.24Z"
            className="templesOnly_svg__cls-634"
          />
          <path
            d="M72 103.07v-1l1 1v1h-1Z"
            style={{
              fill: "#c86d32",
            }}
          />
          <circle
            cx={72.49}
            cy={107.57}
            r={0.71}
            className="templesOnly_svg__cls-605"
          />
          <path
            d="M72 106.07v1l-.83-.67Z"
            className="templesOnly_svg__cls-668"
          />
          <circle
            cx={72.49}
            cy={104.57}
            r={0.71}
            style={{
              fill: "#c56b3c",
            }}
          />
          <path
            d="M72 103.07v1l-.83-.67Z"
            className="templesOnly_svg__cls-668"
          />
          <path
            d="M75 113.07c-.09-1.23.42-2.62-.91-3.43.3-.53.61-1 .91-1.57 1.34 0 .85 1 1 1.75s-.66 2.08 1 2.25c.46 1.93 2 .62 3 1 .75.15 1.91-.5 2 1l-1.29.74-2.71-.74ZM73 108.07v-1l.82-.33-.82-.67v-1h3v1c-1.5.08-.85 1.24-1 2Z"
            className="templesOnly_svg__cls-670"
          />
          <path
            d="M74 113.07c-.16.76.49 1.91-1 2-.09-.87.44-2.07-1.24-2-.25 0-.51-.62-.76-1 1 .38 2.52-.93 3 1"
            style={{
              fill: "#be652a",
            }}
          />
          <path
            d="m72.08 110 .81.7-.31.32-.7-.82Z"
            style={{
              fill: "#913500",
            }}
          />
          <path
            d="m71 110.07 1-1v1Z"
            style={{
              fill: "#da8140",
            }}
          />
          <path
            d="M76 99.07h1l1 1v1h-2z"
            className="templesOnly_svg__cls-674"
          />
          <path
            d="m66 277.07.85-1.5-.85-1.5h2c.15.76-.5 1.91 1 2v1z"
            style={{
              fill: "#e9b576",
            }}
          />
          <path
            d="m66 270.07 1-1 1 1h2v1h-4Z"
            className="templesOnly_svg__cls-610"
          />
          <path
            d="M67 271.07h3v1c-.76.15-1.92-.5-2 1h-1z"
            className="templesOnly_svg__cls-676"
          />
          <circle
            cx={67.49}
            cy={273.57}
            r={0.71}
            style={{
              fill: "#fecf92",
            }}
          />
          <path
            d="M67 271.07v1l-1-1Z"
            style={{
              fill: "#e1ae70",
            }}
          />
          <path
            d="M76 218.07a5.44 5.44 0 0 1 1-3.49l-1-1c.33-1.16.66-2.32 1-3.48v-1c1.33 0 1 1 1 1.75v14.25l-1 1v4h-1v-12ZM75 193.07v-1l1-1c.15-.76-.5-1.92 1-2v15h-1v-9c-.35-.67-.68-1.33-1-2"
            className="templesOnly_svg__cls-679"
          />
          <path
            d="M74 250.07v-3h2c.07 2-.48 4.19 1 6l-1 1-1 1-1 1v-4l1-.76c-.35-.41-.68-.83-1-1.24"
            style={{
              fill: "#b96a29",
            }}
          />
          <path
            d="M74 242.07v-8l1 1v2c.38 1-.93 2.53 1 3-.39 1 .92 2.53-1 3Z"
            style={{
              fill: "#b16223",
            }}
          />
          <path
            d="M76 204.07h1v6c-2.28-1.91-2.26-1.9-1.29-4.24a7.7 7.7 0 0 0 .29-1.76"
            className="templesOnly_svg__cls-682"
          />
          <path
            d="M76 229.07v3l-2 1v-4Z"
            style={{
              fill: "#b05b1c",
            }}
          />
          <path
            d="M76 218.07v5h-1l-1-1v-2c1.49-.09.84-1.24 1-2Z"
            style={{
              fill: "#af5f1e",
            }}
          />
          <path
            d="m74 242.07 1 1 .73 2.71-.73 1.29h-1Z"
            style={{
              fill: "#ab5f1f",
            }}
          />
          <path
            d="m74 222.07 1 1c.38 1-.93 2.53 1 3v1h-2Z"
            style={{
              fill: "#a65a1c",
            }}
          />
          <path
            d="m74 233.07 2-1c.15.76-.5 1.91 1 2v1h-2l-1-1Z"
            style={{
              fill: "#b86425",
            }}
          />
          <path
            d="M73 257.07v-1h1c.08 1.49 1.24.85 2 1v1c-.76.15-1.92-.5-2 1h-1Z"
            style={{
              fill: "#d48b4a",
            }}
          />
          <path
            d="M75 218.07c-.16.76.49 1.91-1 2v-3.82l.65-.08Z"
            style={{
              fill: "#a85d1f",
            }}
          />
          <circle
            cx={74.99}
            cy={228.07}
            r={1.41}
            className="templesOnly_svg__cls-690"
          />
          <path
            d="M76 195.07v2h-1c.14-.76-.51-1.92 1-2"
            className="templesOnly_svg__cls-649"
          />
          <path
            d="M74 250.07c.33.41.66.83 1 1.24l-1 .76Z"
            style={{
              fill: "#ad5d1b",
            }}
          />
          <path
            d="M75 170.07c.33-1.67.66-3.33 1-5v-3h2c.33 1 .66 2 1 3-1.93.47-.62 2-1 3-1.26.08-1.11.86-.82 1.67 1.16 3.37 1.15 4.09-.18 6.33l-1-1a37 37 0 0 0 0-3.8c-.1-.43-.68-.8-1-1.2"
            className="templesOnly_svg__cls-692"
          />
          <path
            d="m76 175.07 1 1v1l-.83.33.83.67v10c-.34-.43-.94-.84-1-1.28-.1-2.14 0-4.3-.09-6.44 0-.44-.62-.86-1-1.28v-1c.46-.99-.85-2.53 1.09-3"
            className="templesOnly_svg__cls-679"
          />
          <path
            d="M75 178.07v3h-2a2.46 2.46 0 0 1 2-3"
            style={{
              fill: "#ae5f22",
            }}
          />
          <path
            d="M76 142.07v-1h4V145h2v-2.91h1c.7 2.17-1 3.94-1 6l-2-2.3v6.3c-.34-.26-1-.52-1-.77 0-1.67-1.18-1.15-2-1.23v-1c.21-1 .43-1.91.64-2.84l-.84-1 2.92-2Z"
            className="templesOnly_svg__cls-694"
          />
          <path
            d="m76 142.07 3.72 1.19-2.92 2 .84 1c-.21.93-.43 1.88-.64 2.84h-1v-7Z"
            className="templesOnly_svg__cls-695"
          />
          <path
            d="M80 141.07h-1c-.47-1.93-2-.62-3-1v-3h1c.08 1.49 1.24.85 2 1l1 1Z"
            style={{
              fill: "#c8561f",
            }}
          />
          <path
            d="M74 148.07v-4c.33.39.88.75 1 1.18a17.7 17.7 0 0 1 0 2.82Z"
            style={{
              fill: "#b56428",
            }}
          />
          <path
            d="M76 140.07c1 .38 2.53-.93 3 1h-3Z"
            className="templesOnly_svg__cls-695"
          />
          <path
            d="M76 148.07v1c-.16.76.49 1.91-1 2v-3Z"
            style={{
              fill: "#c7672b",
            }}
          />
          <path
            d="M75 181.07v-2c.33.42.93.84 1 1.28.1 2.14 0 4.3.09 6.44 0 .44.62.85 1 1.28v1c-1.5.08-.85 1.24-1 2l-1-1Z"
            className="templesOnly_svg__cls-682"
          />
          <path
            d="m75 190.07 1 1-1 1c-1.5-.09-.85-1.24-1-2Z"
            style={{
              fill: "#b16426",
            }}
          />
          <path
            d="M75 151.07c1.49-.09.84-1.24 1-2h1v6c.19 2.35-.65 4.85 1 7h-2v3l-1-1v-7l.82-.33-.82-.67z"
            className="templesOnly_svg__cls-700"
          />
          <path
            d="M75 151.07v1h-1v-4h1Z"
            style={{
              fill: "#b8682b",
            }}
          />
          <path
            d="m75 156.07.82.67-.82.33Z"
            className="templesOnly_svg__cls-646"
          />
          <path
            d="M73 118.07h1v15h-1Z"
            style={{
              fill: "#d48146",
            }}
          />
          <path
            d="M74 132.07v-14h1v5q.49 4.5 1 9l-1 1Z"
            className="templesOnly_svg__cls-614"
          />
          <path
            d="M76 132.07q-.51-4.5-1-9h2a17.7 17.7 0 0 0 0 2.82c.07.43.62.79 1 1.18v5z"
            style={{
              fill: "#c55420",
            }}
          />
          <path
            d="M79 138.07c-.76-.15-1.92.49-2-1v-4l1-1c.33.4.92.79 1 1.21.05 1.59 0 3.19 0 4.79"
            style={{
              fill: "#cd551c",
            }}
          />
          <path d="M74 134.07v-1h1Z" className="templesOnly_svg__cls-614" />
          <path d="m78 132.07-1 1v-1Z" className="templesOnly_svg__cls-705" />
          <path
            d="M77 123.07h-2v-8l3 1v6Z"
            style={{
              fill: "#ba4e19",
            }}
          />
          <ellipse
            cx={76.49}
            cy={114.57}
            className="templesOnly_svg__cls-630"
            rx={1.3}
            ry={2.3}
            transform="rotate(-61.84 76.491 114.574)"
          />
          <ellipse
            cx={73.99}
            cy={260.57}
            className="templesOnly_svg__cls-707"
            rx={1.41}
            ry={0.71}
          />
          <path d="M72 259.07h1v1Z" className="templesOnly_svg__cls-707" />
          <path
            d="M74 266a7 7 0 0 1 0-.95l2-1 1 1v2l-2.75 2H77v3a8.5 8.5 0 0 0-1 .76 15 15 0 0 0-1 1.24c.58-1.29-1.74-2.39.05-4H73v-1l.87-.4c-.34-.62-.61-1.11-.87-1.6v-1a8 8 0 0 0 1-.05l-.15.14.7.82.31-.32A5.5 5.5 0 0 0 74 266"
            style={{
              fill: "#e7b57a",
            }}
          />
          <path
            d="M73 270.07h2c-1.79 1.61.53 2.71-.05 4l-2-1v-3Z"
            style={{
              fill: "#eebc83",
            }}
          />
          <path
            d="M68 274.07v-1c.08-1.5 1.24-.85 2-1 1.49.08.84 1.24 1 2l-1.61-.87-.39.87Z"
            style={{
              fill: "#fdc786",
            }}
          />
          <path
            d="m73 273.07 2 1 1 1-1 1h-1l-1-1z"
            style={{
              fill: "#e3ae77",
            }}
          />
          <path
            d="M73 274.07v2h-2v-2Z"
            style={{
              fill: "#f0b578",
            }}
          />
          <path
            d="M73 267.07c.26.49.53 1 .87 1.6l-.87.4h-1c.14-.76-.51-1.92 1-2"
            className="templesOnly_svg__cls-713"
          />
          <path
            d="M73 270.07v2c-1.5-.09-.85-1.24-1-2Z"
            style={{
              fill: "#eab276",
            }}
          />
          <path
            d="M70 271.07v-1l.82.67Z"
            className="templesOnly_svg__cls-715"
          />
          <circle
            cx={72.49}
            cy={269.57}
            r={0.71}
            className="templesOnly_svg__cls-715"
          />
          <path
            d="M70 270.07h-1l1-1Z"
            style={{
              fill: "#ba8445",
            }}
          />
          <path
            d="M77 267.07v-1h1l1 2v6l-1 1h-1z"
            style={{
              fill: "#ba7f47",
            }}
          />
          <path
            d="M75 261.07v-1c.75-.15 1.91.49 2-1h1c.08 1.49 1.24.85 2 1v2l-1 1v1h-1c-.47-1.93-2-.62-3-1v-1l1.9-.34-.07-.66Z"
            style={{
              fill: "#bd7833",
            }}
          />
          <path
            d="m79 268.07-1-2v-1l2 1c-.17.76.48 1.93-1 2"
            style={{
              fill: "#b0702b",
            }}
          />
          <path
            d="m80 266.07-2-1v-1h1l2 2Z"
            style={{
              fill: "#a26629",
            }}
          />
          <path d="m77 265.07-1-1Z" className="templesOnly_svg__cls-661" />
          <path
            d="M75 261.07h1.83l.07.66-1.9.34Z"
            className="templesOnly_svg__cls-660"
          />
          <path d="m68 270.07-1-1Z" className="templesOnly_svg__cls-676" />
          <path
            d="m73 106.07.82.67-.82.33Z"
            style={{
              fill: "#7e1e00",
            }}
          />
          <path
            d="m72 101.07 1-1 1-1h1v1c-.34 1-.67 2-1 3h-1l-1-1Z"
            style={{
              fill: "#bd6225",
            }}
          />
          <circle
            cx={73.49}
            cy={103.57}
            r={0.71}
            style={{
              fill: "#933b00",
            }}
          />
          <path
            d="M73 104.07h2v1h-2Z"
            style={{
              fill: "#933d0c",
            }}
          />
          <path
            d="M78 116.07v-2l2.71.74 1.29-.74v2.28l2.27 1.92-2.27 1.8a2.47 2.47 0 0 1-3 2c-.39-1 .92-2.53-1-3Z"
            style={{
              fill: "#953a11",
            }}
          />
          <path
            d="M75 108.07c.15-.76-.5-1.92 1-2l.53 1.09c.57-1.21 1-2.15 1.47-3.09v-1h1v4c-1.93.47-.62 2-1 3-1.5.08-.85 1.24-1 2-1.65-.17-.81-1.45-1-2.25s.33-1.74-1-1.75"
            style={{
              fill: "#843214",
            }}
          />
          <path
            d="M82 114.07c-.09-1.5-1.25-.85-2-1v-1h4v2Z"
            style={{
              fill: "#671c09",
            }}
          />
          <path
            d="M80 112.07v1c-1-.38-2.54.93-3-1 .15-.76-.5-1.92 1-2Z"
            style={{
              fill: "#6d2000",
            }}
          />
          <path
            d="M78 104.07c-.45.94-.9 1.88-1.47 3.09l-.53-1.09v-3h1Z"
            style={{
              fill: "#94401d",
            }}
          />
          <circle
            cx={75.49}
            cy={104.57}
            r={0.71}
            style={{
              fill: "#7c2800",
            }}
          />
          <path
            d="M78 99.07v-1h1v3h-1z"
            style={{
              fill: "#8c3418",
            }}
          />
          <path
            d="M76 104.07h-2v-1c.33-1 .66-2 1-3h1v2l-.83.33.83.67Z"
            style={{
              fill: "#9a4912",
            }}
          />
          <path
            d="M76 102.07v-1h3v2h-1l-.33-.83-.67.83h-1Z"
            style={{
              fill: "#600e00",
            }}
          />
          <path
            d="M71 274.07v1l-.83.33.83.67v1h-2v-3l.39-.87Z"
            style={{
              fill: "#f2ba7b",
            }}
          />
          <path
            d="M69 274.07v2c-1.5-.09-.85-1.24-1-2Z"
            className="templesOnly_svg__cls-676"
          />
          <path
            d="M77 189.07v-2c.28.11.68.15.82.36.41.64 1.15 1.8 1 1.95-1.09 1.06 0 1.8.18 2.66a1.2 1.2 0 0 1 0 .49c-.32 1.18-.66 2.36-1 3.54v7h2v2c-1.26.4-2.15 1.08-2 2.28l2 1.72v1a4.76 4.76 0 0 0 0 6v6.68l-2 1.32v-13.25c0-.72.35-1.74-1-1.75z"
            className="templesOnly_svg__cls-735"
          />
          <path
            d="m78 224.07 2-1.32v-5.68c1.49.08.84 1.24 1 2v7h-3z"
            className="templesOnly_svg__cls-736"
          />
          <path
            d="M77 234.07c-1.5-.09-.85-1.24-1-2v-2h1Z"
            style={{
              fill: "#b85d1a",
            }}
          />
          <path
            d="M76 226.07c-1.93-.47-.62-2-1-3h1Z"
            className="templesOnly_svg__cls-690"
          />
          <ellipse
            cx={77.49}
            cy={228.57}
            rx={0.71}
            ry={2.12}
            style={{
              fill: "#d26d2d",
            }}
          />
          <circle
            cx={77.49}
            cy={226.57}
            r={0.71}
            className="templesOnly_svg__cls-739"
          />
          <path d="M78 226.07h-1l1-1Z" className="templesOnly_svg__cls-735" />
          <path
            d="M76 257.07c-.76-.15-1.92.49-2-1l1-1h3l2 2z"
            className="templesOnly_svg__cls-740"
          />
          <path
            d="m75 247.07.73-1.29-.73-2.71c1.92-.47.61-2 1-3h1v7z"
            style={{
              fill: "#b96526",
            }}
          />
          <path
            d="M76 247.07h1v2c.33 1 .66 2 1 3l-1 1c-1.49-1.81-.94-3.96-1-6"
            className="templesOnly_svg__cls-740"
          />
          <path
            d="M78 255.07h-3l1-1h1Z"
            style={{
              fill: "#c47031",
            }}
          />
          <path d="M77 254.07h-1l1-1Z" className="templesOnly_svg__cls-740" />
          <path
            d="M77 240.07h-1c-1.93-.47-.62-2-1-3h2Z"
            style={{
              fill: "#bd6629",
            }}
          />
          <circle
            cx={75.99}
            cy={236.07}
            r={1.41}
            style={{
              fill: "#c16b2d",
            }}
          />
          <path
            d="M77 237.07v-7h1v7c.07 1.23-.43 2.63.72 3.32l-.72 2.68v1h-1z"
            style={{
              fill: "#c86525",
            }}
          />
          <path
            d="M76 257.07h1c.46 1.93 2 .62 3 1v1h-4z"
            style={{
              fill: "#c0702a",
            }}
          />
          <path
            d="M76 259.07h1c-.09 1.49-1.25.85-2 1h-2v-1z"
            style={{
              fill: "#b56e2e",
            }}
          />
          <path
            d="M76 259.07h-2c.08-1.5 1.24-.85 2-1Z"
            className="templesOnly_svg__cls-707"
          />
          <path
            d="M78 196.07c.33-1.18.67-2.36 1-3.54a1.2 1.2 0 0 0 0-.49c-.17-.86-1.27-1.6-.18-2.66.16-.15-.58-1.31-1-1.95-.14-.21-.54-.25-.82-.36v-11c1.33-2.24 1.34-3 .18-6.33-.29-.81-.44-1.59.82-1.67h1l1 1-.89 1.56c1.44.9.75 2.44.88 3.77.07.72-.26 1.67 1 1.67.13 2.34-.29 4.72.22 7H84a13.4 13.4 0 0 0 0 2.45c.23 1.2.92 2.36.9 3.53a18.8 18.8 0 0 1-.92 4 4.58 4.58 0 0 0-2 4L79.85 196c.45 1.64.8 2.85 1.14 4.07H79a27 27 0 0 0 0-3.22c-.1-.3-.68-.52-1-.78"
            className="templesOnly_svg__cls-748"
          />
          <path
            d="M78 162.07c-1.65-2.15-.81-4.65-1-7h3v2l-1.9.34.06.66H80v2q-2.055 1.5 0 3v2h-1c-.35-1-.68-2-1-3M79 168.07h-1c.38-1-.93-2.53 1-3Z"
            className="templesOnly_svg__cls-749"
          />
          <path
            d="M77 177.07v1l-.83-.67Z"
            className="templesOnly_svg__cls-692"
          />
          <path
            d="M80 165.07v-5l1-.76c-.34-.41-.67-.83-1-1.24v-1l.82-.33-.82-.67v-5h1c.33.67.66 1.33 1 2 .14 2.45-.61 5 1.07 7.16l-1.23 1.84H84v1l-2.75 2H84v4c-.76.15-1.92-.5-2 1-1.8.73-1 1.88-.5 3s1.29 2.27-.5 3c-1.27 0-.94-.95-1-1.67-.13-1.33.56-2.87-.88-3.77l.89-1.56Z"
            style={{
              fill: "#be4e17",
            }}
          />
          <path
            d="M82 148.07c0-2.06 1.7-3.83 1-6h1c.33.41.94.82 1 1.24.08 3.25 0 6.51 0 9.76-.34-.26-.94-.49-1-.77-.1-1.4 0-2.81 0-4.76l-2 2.53Z"
            className="templesOnly_svg__cls-751"
          />
          <path
            d="M80 152.07v2h-3v-4c.86.08 2.07-.44 2 1.23 0 .25.65.51 1 .77"
            className="templesOnly_svg__cls-749"
          />
          <path
            d="M82 142.07V145h-2v-3.91h2Z"
            style={{
              fill: "#b94813",
            }}
          />
          <path
            d="M82 148.07v2l-1 1h-1v-5.3Z"
            style={{
              fill: "#b54514",
            }}
          />
          <path d="M82 142.07v-5h1v5Z" className="templesOnly_svg__cls-751" />
          <path
            d="M82 137.07v2h-2l-1-1c0-1.6.06-3.2 0-4.79 0-.42-.62-.81-1-1.21v-9h1v2c-.53 3.49.85 6.69 1.29 10H82Z"
            className="templesOnly_svg__cls-705"
          />
          <circle
            cx={80.99}
            cy={140.07}
            r={1.41}
            className="templesOnly_svg__cls-754"
          />
          <ellipse
            cx={78.49}
            cy={154.57}
            className="templesOnly_svg__cls-694"
            rx={2.12}
            ry={0.71}
          />
          <path d="M75 133.07h-1v-1Z" className="templesOnly_svg__cls-653" />
          <path
            d="M78 123.07v4c-.34-.39-.89-.75-1-1.18a17.7 17.7 0 0 1 0-2.82l1-1Z"
            style={{
              fill: "#cc5421",
            }}
          />
          <path
            d="M78 123.07v-4c1.92.47.61 2 1 3v1Z"
            className="templesOnly_svg__cls-756"
          />
          <path
            d="M77 272.07v3h-1l-1-1a15 15 0 0 1 1-1.24 8.5 8.5 0 0 1 1-.76"
            style={{
              fill: "#eeb97e",
            }}
          />
          <path d="M77 267.07v2h-2.76Z" className="templesOnly_svg__cls-713" />
          <path
            d="m74.08 266 .81.7-.31.32-.7-.82Z"
            style={{
              fill: "#f8c78d",
            }}
          />
          <path
            d="M80 266.07h1v1c.07 1 .15 2 .22 3l1.78-1v1l-1 2-1 1-1 1h-1v-6c1.48-.07.83-1.24 1-2M79 275.07h-1l1-1Z"
            className="templesOnly_svg__cls-759"
          />
          <path
            d="M81 267.07v-1l-2-2v-1h3v4Z"
            style={{
              fill: "#b27034",
            }}
          />
          <path
            d="M80 261.07v-1h3l1 1z"
            style={{
              fill: "#c77732",
            }}
          />
          <path
            d="M80 261.07h2v2h-1l-1-1Z"
            className="templesOnly_svg__cls-762"
          />
          <path
            d="M78 259.07h2v1c-.77-.15-1.93.49-2-1"
            style={{
              fill: "#cb7e37",
            }}
          />
          <path d="M80 263.07h-1l1-1Z" className="templesOnly_svg__cls-762" />
          <path
            d="M85 112.07c.24 1.52-.7 3.3.9 4.45-1.74 2.36-.57 5-.9 7.55h-1v-4h-2l2.27-1.8-2.27-1.92v-2.28h2v-2Z"
            style={{
              fill: "#9c5028",
            }}
          />
          <path
            d="M82 120.07h2v3h-2.28l-2.73 2v-3a2.47 2.47 0 0 0 3.01-2"
            style={{
              fill: "#9e3c08",
            }}
          />
          <path
            d="M79 103.07v-1h1l1 1v1l-.83.33.83.67-1 1h-1Z"
            style={{
              fill: "#6f2403",
            }}
          />
          <path
            d="M79 106.07h1c.08 1.49 1.24.85 2 1v1h-3z"
            style={{
              fill: "#661d01",
            }}
          />
          <path
            d="M79 107.07v1c-.16.76.49 1.91-1 2 .37-.99-.94-2.53 1-3"
            style={{
              fill: "#6d1f00",
            }}
          />
          <path
            d="m78 104.07-1-1h1Z"
            style={{
              fill: "#994429",
            }}
          />
          <path
            d="M82 108.07v-1l1-2v-1h1c.33 1 .66 2 1 3v2l-.83.33.83.67v2h-1l-.33-.83-.67.83h-1v-1a7.4 7.4 0 0 1 .59-2c.55-.95.01-.94-.59-1"
            style={{
              fill: "#6f2c0f",
            }}
          />
          <path
            d="M82 111.07v1h-2c.08-1 .16-2 .25-3 .75.77 1.22 1.39 1.75 2"
            style={{
              fill: "#823b1b",
            }}
          />
          <path
            d="m83 112.07.67-.83.33.83Z"
            style={{
              fill: "#652003",
            }}
          />
          <path
            d="M82 111.07c-.52-.61-1-1.23-1.75-2-.09 1.07-.17 2.06-.25 3l-2-2c1.49-.09.84-1.24 1-2h3c.61.06 1.15.05.59 1a7.4 7.4 0 0 0-.59 2"
            style={{
              fill: "#7f3311",
            }}
          />
          <path
            d="M84 167.07v-5l1-2a4.75 4.75 0 0 1 0-6h1v40c-.34.4-.91.77-1 1.2a37 37 0 0 0 0 3.8v1l-1-1v-6a18.8 18.8 0 0 0 .92-4c0-1.17-.67-2.33-.9-3.53a13.4 13.4 0 0 1 0-2.45v-6l1-1a17.7 17.7 0 0 0 0-2.82c-.07-.43-.62-.79-1-1.18v-3l1-.76c-.37-.43-.7-.85-1.02-1.26"
            style={{
              fill: "#c5642c",
            }}
          />
          <path
            d="M86 200.07c.33 4.16.8 8.31 1 12.47s0 8.59 0 12.88.06 8.59-.06 12.89c0 .91 1 2.42-.94 2.76v-1c-.39-1 .92-2.53-1-3v-3c1.34 0 1-1 1-1.75v-14.25l-1-1c-.21-4.68.66-9.43-1-14 1.92-.47.61-2 1-3Z"
            style={{
              fill: "#be6b35",
            }}
          />
          <path
            d="M86 154.07h-1v-10.76c0-.42-.62-.83-1-1.24a33 33 0 0 1 0-4 37 37 0 0 1 1-4v-9c1.65.17 1 1.47 1 2.26z"
            style={{
              fill: "#d37f45",
            }}
          />
          <path
            d="M86 247.07c.33.42.93.82 1 1.25.1 2 0 3.91 0 5.87a47 47 0 0 0 0 4.89 28 28 0 0 0 1 4h-1l-1-2v-2c-.16-.76.49-1.92-1-2v-2c.33-.4.91-.77 1-1.2a37 37 0 0 0 0-3.8Z"
            style={{
              fill: "#ab7749",
            }}
          />
          <path
            d="M85 107.07c-.34-1-.67-2-1-3 .75-.15 1.91.49 2-1v-3l1-1c.33 1.68.67 3.37 1.08 5.46Z"
            className="templesOnly_svg__cls-778"
          />
          <path
            d="M87 263.07h2v5h-1l-1-2 1-1-1-1Z"
            style={{
              fill: "#bb8449",
            }}
          />
          <path
            d="M86 240.07v6h-1v-6Z"
            style={{
              fill: "#ad612f",
            }}
          />
          <path
            d="M85 199.07a37 37 0 0 1 0-3.8c0-.43.62-.8 1-1.2v5Z"
            style={{
              fill: "#b2652d",
            }}
          />
          <path
            d="M85 125.07v3h-1v-4h1Z"
            style={{
              fill: "#a25525",
            }}
          />
          <path
            d="M85 246.07h1v4c-.34-.39-.89-.75-1-1.18a17.7 17.7 0 0 1 0-2.82"
            style={{
              fill: "#a75b29",
            }}
          />
          <circle
            cx={85.49}
            cy={199.57}
            r={0.71}
            style={{
              fill: "#b06122",
            }}
          />
          <path
            d="m85 110.07-.83-.67.83-.33Z"
            style={{
              fill: "#551b03",
            }}
          />
          <path
            d="M80 102.07h-1v-1l1-1h1v2Z"
            style={{
              fill: "#823218",
            }}
          />
          <path
            d="m80 100.07-1 1v-2h1Z"
            style={{
              fill: "#a0482a",
            }}
          />
          <path
            d="M76 102.07v1l-.83-.67ZM78 103.07h-1l.67-.83Z"
            className="templesOnly_svg__cls-674"
          />
          <path
            d="M86 100.07v1l-1 1h-1v-2z"
            style={{
              fill: "#4b2204",
            }}
          />
          <circle
            cx={81.49}
            cy={101.57}
            r={0.71}
            style={{
              fill: "#490f00",
            }}
          />
          <path
            d="m82 101.07 1-1Z"
            style={{
              fill: "#481500",
            }}
          />
          <path
            d="M81 219.07c-.16-.76.49-1.92-1-2v-2.69l2.5-.81c-2.65-.35-.29-3.15-2.5-3.5v-1a2.48 2.48 0 0 0 0-4v-1h2v1.73l1.85.62-2.13 3.16 2.28.89v5.82c0 .27.62.52 1 .78v2Z"
            style={{
              fill: "#c75a1e",
            }}
          />
          <path
            d="M80 210.07c2.21.35-.15 3.15 2.5 3.5l-2.5.81v1.69a4.76 4.76 0 0 1 0-6M80 205.07a2.48 2.48 0 0 1 0 4l-2-1.72c-.16-1.2.73-1.88 2-2.28"
            className="templesOnly_svg__cls-736"
          />
          <path
            d="M78 196.07c.33.26.91.48 1 .78a27 27 0 0 1 0 3.22h2v3h-1v-1l-1-1h-1Z"
            style={{
              fill: "#d36226",
            }}
          />
          <path
            d="M78 201.07h1l1 1v1h-2Z"
            style={{
              fill: "#e07132",
            }}
          />
          <circle
            cx={80.49}
            cy={203.57}
            r={0.71}
            className="templesOnly_svg__cls-736"
          />
          <path
            d="M81 219.07h4v2a8 8 0 0 0-1 .05l.15-.14-.7-.82-.31.32a5.5 5.5 0 0 0 .86.64 6 6 0 0 1 0 .95l-1 .75 1 1.25v1c-2.85.79-1.8 3.15-2 5-1.5-.09-.85-1.24-1-2z"
            style={{
              fill: "#cb591f",
            }}
          />
          <path
            d="M81 226.07v2h-2v-2Z"
            style={{
              fill: "#d46128",
            }}
          />
          <circle
            cx={78.49}
            cy={226.57}
            r={0.71}
            className="templesOnly_svg__cls-735"
          />
          <path d="M78 227.07h1v4h-1z" className="templesOnly_svg__cls-739" />
          <path
            d="M77 254.07v-1l1-1 2-1c.2 2.24.76 2.79 3 3v2c-.76.15-1.92-.5-2 1h-1l-2-2Z"
            style={{
              fill: "#cb6c27",
            }}
          />
          <path
            d="M80 257.07h1c.75.15 1.91-.5 2 1h-3c-1-.38-2.54.93-3-1Z"
            style={{
              fill: "#b75c18",
            }}
          />
          <path
            d="M77 244.07h2v2l-1 1h-1Z"
            style={{
              fill: "#ca6927",
            }}
          />
          <path
            d="M77 247.07h2c.38 1-.93 2.53 1 3v1l-2 1c-.34-1-.67-2-1-3l.82-.33-.82-.67Z"
            style={{
              fill: "#d57632",
            }}
          />
          <path
            d="m77 248.07.82.67-.82.33Z"
            style={{
              fill: "#da7e3b",
            }}
          />
          <path
            d="m78 243.07.72-2.68c-1.15-.69-.65-2.09-.72-3.32l2 1v-4c1.32 0 .86 1 1 1.73a2.46 2.46 0 0 0 3 2.27v1c-1.93.47-.62 2-1 3l-1 1z"
            className="templesOnly_svg__cls-801"
          />
          <path
            d="M80 234.07v4l-2-1v-5c.33.41.63.85 1 1.23a7.6 7.6 0 0 0 1 .77"
            style={{
              fill: "#d66a2b",
            }}
          />
          <path
            d="M80 234.07a7.6 7.6 0 0 1-1-.77c-.37-.38-.67-.82-1-1.23v-1h1l2 .26c-.41.73-.69 1.24-1 1.74Z"
            style={{
              fill: "#d4642a",
            }}
          />
          <path
            d="M78 243.07h2l-1 1h-1Z"
            className="templesOnly_svg__cls-130"
          />
          <path
            d="M80 258.07h3v2h-3z"
            style={{
              fill: "#cd7530",
            }}
          />
          <path
            d="M84 171.07v1a3.43 3.43 0 0 0 0 5v6h-2.79c-.51-2.28-.09-4.66-.22-7 1.79-.73 1-1.88.5-3s-1.3-2.27.5-3Z"
            style={{
              fill: "#bd5218",
            }}
          />
          <path
            d="M81 204.07v-4c-.34-1.22-.69-2.43-1.14-4.07l2.14 1.07c1.49.08.84 1.24 1 2l-1.28 3.17L84 201v2l-2 1Z"
            style={{
              fill: "#c6541b",
            }}
          />
          <path
            d="M83 199.07c-.16-.76.49-1.92-1-2a4.58 4.58 0 0 1 2-4v6Z"
            style={{
              fill: "#ca5a22",
            }}
          />
          <path
            d="M80 165.07v4l-1-1v-3ZM80 160.07v3c-1.38-1.01-1.38-2 0-3M80 158.07c.33.41.66.83 1 1.24l-1 .76ZM80 157.07v1h-1.85l-.06-.66ZM80 156.07l.82.67-.82.33Z"
            className="templesOnly_svg__cls-694"
          />
          <path
            d="M85 153.07v1a4.75 4.75 0 0 0 0 6l-1 2h-2.17l1.23-1.84c-1.68-2.14-.93-4.71-1.07-7.16 1.37-.25 1.21-1 .62-1.89a12 12 0 0 1-.62-1.11l2-2.53c0 2-.06 3.36 0 4.76.06.28.66.51 1.01.77"
            className="templesOnly_svg__cls-808"
          />
          <path
            d="M82 150.07a12 12 0 0 0 .62 1.11c.59.91.75 1.64-.62 1.89-.34-.67-.67-1.33-1-2Z"
            className="templesOnly_svg__cls-694"
          />
          <path d="M84 163.07v2h-2.76Z" className="templesOnly_svg__cls-808" />
          <path
            d="m84 171.07-2-1c.08-1.5 1.24-.85 2-1Z"
            className="templesOnly_svg__cls-748"
          />
          <path
            d="M84 167.07c.33.41.66.83 1 1.24l-1 .76Z"
            className="templesOnly_svg__cls-808"
          />
          <path
            d="M85 134.07a37 37 0 0 0-1 4 33 33 0 0 0 0 4h-1v-5c-.16-.76.49-1.92-1-2v-2c1.92-.47.61-2 1-3h1a17.7 17.7 0 0 0 0 2.82c.1.43.65.79 1 1.18"
            style={{
              fill: "#da7430",
            }}
          />
          <path
            d="M82 135.07c1.49.08.84 1.24 1 2h-1Z"
            className="templesOnly_svg__cls-754"
          />
          <path
            d="M82 133.07v2h-1.72c-.44-3.31-1.82-6.51-1.29-10l2.73-2H84v1h-2z"
            className="templesOnly_svg__cls-756"
          />
          <path
            d="m82 272.07 1-2c.75-.15 1.91.49 2-1 1.49.08.84 1.24 1 2l-1 1z"
            className="templesOnly_svg__cls-810"
          />
          <path
            d="M81 267.07h2v2l-1.78 1c-.08-1.01-.16-2-.22-3"
            style={{
              fill: "#a9621d",
            }}
          />
          <path
            d="M79 275.07v-1h1v2h-1Z"
            style={{
              fill: "#885118",
            }}
          />
          <path
            d="M85 269.07c-.09 1.49-1.25.85-2 1v-1Z"
            style={{
              fill: "#c87a2f",
            }}
          />
          <path
            d="m80 274.07 1-1v1ZM81 273.07l1-1Z"
            className="templesOnly_svg__cls-810"
          />
          <path
            d="M82 266.07v-1c.75-.15 1.91.49 2-1h1v2l-1 1h-1Z"
            className="templesOnly_svg__cls-814"
          />
          <path
            d="M84 264.07c-.09 1.49-1.25.85-2 1v-1Z"
            style={{
              fill: "#ab652a",
            }}
          />
          <ellipse
            cx={82.99}
            cy={263.57}
            rx={1.41}
            ry={0.71}
            style={{
              fill: "#b97133",
            }}
          />
          <path d="m82 266.07 1 1h-1Z" className="templesOnly_svg__cls-817" />
          <path
            d="M80 263.07v-1l1 1Z"
            style={{
              fill: "#9e5a19",
            }}
          />
          <path
            d="M84 264.07v-1c-.09-1.5-1.25-.85-2-1v-1h3v3Z"
            style={{
              fill: "#bf742f",
            }}
          />
          <path
            d="M85 261.07h-1l-1-1v-1h2Z"
            style={{
              fill: "#cc813a",
            }}
          />
          <path
            d="M82 262.07c.75.15 1.91-.5 2 1h-2Z"
            style={{
              fill: "#c77c3b",
            }}
          />
          <path
            d="m83 105.07-1 2c-.76-.15-1.92.49-2-1l1-1z"
            style={{
              fill: "#571500",
            }}
          />
          <path
            d="M82 105.07h-1v-2h1z"
            style={{
              fill: "#6c2f19",
            }}
          />
          <path
            d="M81 104.07v1l-.83-.67Z"
            style={{
              fill: "#793311",
            }}
          />
          <path d="M80 102.07h1v1Z" className="templesOnly_svg__cls-825" />
          <path
            d="M86 103.07c-.09 1.49-1.25.85-2 1h-1v-1z"
            style={{
              fill: "#3b0700",
            }}
          />
          <circle
            cx={82.49}
            cy={104.57}
            r={0.71}
            style={{
              fill: "#3b0000",
            }}
          />
          <path
            d="M84 177.07a3.43 3.43 0 0 1 0-5c.33.39.88.75 1 1.18a17.7 17.7 0 0 1 0 2.82Z"
            style={{
              fill: "#b65016",
            }}
          />
          <path
            d="M83 199.07h1l1 1c-.39 1 .92 2.53-1 3v-2l-2.28 1.21Z"
            className="templesOnly_svg__cls-736"
          />
          <path d="m84 177.07 1-1Z" className="templesOnly_svg__cls-748" />
          <path
            d="m82 204.07 2-1c1.66 4.57.79 9.32 1 14-.34-.26-.95-.51-1-.78-.08-2 0-3.93 0-5.82l-2.28-.89 2.13-3.16-1.85-.62Z"
            className="templesOnly_svg__cls-736"
          />
          <path
            d="M85 221.07v-3h1v14.25c0 .72.36 1.74-1 1.75h-1v-5c.33-.41.93-.81 1-1.23z"
            style={{
              fill: "#bf5d20",
            }}
          />
          <path
            d="M84 239.07v-2h1c1.92.47.61 2 1 3h-1Z"
            style={{
              fill: "#b7642a",
            }}
          />
          <path
            d="M85 237.07h-1c-1.5-.09-.85-1.24-1-2l1-1h1Z"
            className="templesOnly_svg__cls-801"
          />
          <path d="M86 218.07h-1v-1Z" className="templesOnly_svg__cls-736" />
          <path
            d="M85 134.07c-.34-.39-.89-.75-1-1.18a17.7 17.7 0 0 1 0-2.82v-2h1Z"
            style={{
              fill: "#bd6d32",
            }}
          />
          <path
            d="M85 246.07a17.7 17.7 0 0 0 0 2.82c.07.43.62.79 1 1.18a37 37 0 0 1 0 3.8c0 .43-.62.8-1 1.2a17.7 17.7 0 0 0 0-2.82c-.07-.43-.62-.79-1-1.18v-9h1Z"
            className="templesOnly_svg__cls-832"
          />
          <path
            d="M84 251.07c.33.39.88.75 1 1.18a17.7 17.7 0 0 1 0 2.82v1h-2v-2c.32-1 .65-2 1-3"
            style={{
              fill: "#c46a2f",
            }}
          />
          <path
            d="M85 264.07v-3h1l1 2-1 1Z"
            className="templesOnly_svg__cls-814"
          />
          <ellipse
            cx={85.49}
            cy={260.07}
            rx={0.71}
            ry={1.41}
            style={{
              fill: "#c37e41",
            }}
          />
          <path
            d="M86 259.07h-1v-2c1.48.08.83 1.24 1 2M84 256.07h1v1Z"
            className="templesOnly_svg__cls-832"
          />
          <path
            d="M86 103.07h-1v-1l1-1Z"
            style={{
              fill: "#411c02",
            }}
          />
          <path
            d="M85 264.07h1c.15.76-.5 1.91 1 2l1 2c-1.34 0-.81 1.06-1 1.73a5 5 0 0 1-1 1.27c-.16-.76.49-1.92-1-2h-2v-2h1l1 2z"
            className="templesOnly_svg__cls-817"
          />
          <path
            d="M86 271.07a5 5 0 0 0 1-1.27c.23-.67-.3-1.72 1-1.73h1v4h-4Z"
            className="templesOnly_svg__cls-836"
          />
          <path
            d="M87 266.07c-1.5-.09-.85-1.24-1-2l1-1v1l1 1Z"
            style={{
              fill: "#c48142",
            }}
          />
          <path
            d="m88 265.07-1-1Z"
            style={{
              fill: "#c9894c",
            }}
          />
          <path
            d="M84 242.07v8l-1-1v-7c.38-1-.93-2.53 1-3l1 1v1Z"
            style={{
              fill: "#c4652c",
            }}
          />
          <path
            d="m84 242.07 1-1v1Z"
            style={{
              fill: "#c16c33",
            }}
          />
          <path
            d="M82 130.07v-6h2v4c-1.5.08-.85 1.24-1 2Z"
            style={{
              fill: "#ca692d",
            }}
          />
          <path
            d="m82 101.07 1-1h1v2l-1 1h-1z"
            style={{
              fill: "#5d3014",
            }}
          />
          <circle
            cx={84.49}
            cy={102.57}
            r={0.71}
            style={{
              fill: "#340a00",
            }}
          />
          <circle
            cx={81.49}
            cy={102.57}
            r={0.71}
            className="templesOnly_svg__cls-844"
          />
          <path
            d="m80 202.07-1-1Z"
            style={{
              fill: "#ee7b40",
            }}
          />
          <path
            d="m84 234.07-1 1c-.34-.67-.67-1.33-1-2v-3c.2-1.85-.85-4.21 2-5z"
            className="templesOnly_svg__cls-846"
          />
          <path
            d="M82 230.07v3h-2c.27-.5.55-1 1-1.74l-2-.26v-3h2c.14.76-.51 1.93 1 2"
            style={{
              fill: "#cf5e24",
            }}
          />
          <path
            d="M84 229.07v-8h1c0 2.26.05 4.52 0 6.77-.08.42-.68.82-1 1.23"
            style={{
              fill: "#c1591e",
            }}
          />
          <path
            d="M84 222.07v2l-1-1.25Z"
            className="templesOnly_svg__cls-846"
          />
          <path
            d="m83.9 221.17-.82-.69.31-.32.7.82Z"
            style={{
              fill: "#d06024",
            }}
          />
          <path
            d="m83 249.07 1 1v1c-.34 1-.67 2-1 3-2.24-.21-2.8-.76-3-3v-1c.08-1.5 1.24-.85 2-1Z"
            style={{
              fill: "#ca6021",
            }}
          />
          <path
            d="m84 256.07 1 1v1h-2c-.09-1.5-1.25-.85-2-1 .08-1.5 1.24-.85 2-1Z"
            style={{
              fill: "#b76123",
            }}
          />
          <path
            d="m79 244.07 1-1h2v5l-3-1z"
            style={{
              fill: "#cf6222",
            }}
          />
          <path
            d="M79 246.07v1h-1ZM79 247.07l3 1v1c-.76.15-1.92-.5-2 1-1.94-.47-.63-2.02-1-3"
            className="templesOnly_svg__cls-853"
          />
          <path
            d="M80 233.07h2c.33.67.66 1.33 1 2 .15.76-.5 1.91 1 2v1a2.46 2.46 0 0 1-3-2.27c-.15-.71.31-1.73-1-1.73Z"
            style={{
              fill: "#cb5a1e",
            }}
          />
          <path
            d="M82 249.07v-6l1-1v7Z"
            style={{
              fill: "#cf672b",
            }}
          />
          <ellipse
            cx={83.99}
            cy={258.57}
            rx={1.41}
            ry={0.71}
            style={{
              fill: "#c0712d",
            }}
          />
          <path
            d="M82 130.07h1c-.39 1 .92 2.53-1 3Z"
            className="templesOnly_svg__cls-705"
          />
          <path
            d="M83 130.07c.15-.76-.5-1.92 1-2v2Z"
            style={{
              fill: "#dd7938",
            }}
          />
          <path
            d="M85 272.07h4v1c-.76.15-1.92-.5-2 1h-3l-.88-.4.88-1.6Z"
            style={{
              fill: "#481a02",
            }}
          />
          <path
            d="m84 272.07-.88 1.6.88.4v1h-3v-2l1-1Z"
            className="templesOnly_svg__cls-836"
          />
          <circle
            cx={80.49}
            cy={274.57}
            r={0.71}
            style={{
              fill: "#7e430b",
            }}
          />
          <path
            d="M85 266.07v3l-1-2Z"
            style={{
              fill: "#c78647",
            }}
          />
          <circle
            cx={82.49}
            cy={103.57}
            r={0.71}
            className="templesOnly_svg__cls-844"
          />
          <path d="M84 102.07v1h-1Z" className="templesOnly_svg__cls-844" />
          <path
            d="M87 275.07h-3v-1h3Z"
            style={{
              fill: "#ae8a67",
            }}
          />
          <path
            d="m89 273.07-1 1h-1c.07-1.5 1.23-.85 2-1"
            style={{
              fill: "#3c1100",
            }}
          />
          <circle
            cx={87.49}
            cy={274.57}
            r={0.71}
            style={{
              fill: "#c19a72",
            }}
          />
        </g>
        <g id="templesOnly_svg__column5" ref={el => columnRefs.current[4] = el}>
          <path
            d="M159 258.05v-2h1v2Z"
            style={{
              fill: "#673d18",
            }}
          />
          <path
            d="M157.55 254.07v2c-.34-.33-.67-.67-1-1v-1Z"
            style={{
              fill: "#9b4e21",
            }}
          />
          <path
            d="M158.55 266.07h-2a2.46 2.46 0 0 1 2-3z"
            style={{
              fill: "#9f3a0f",
            }}
          />
          <path
            d="M160 262.05v3h-1v-2Z"
            style={{
              fill: "#9b4a1b",
            }}
          />
          <path
            d="M159 258.05h1v2c-1.46-.05-.81-1.24-1-2"
            style={{
              fill: "#964816",
            }}
          />
          <path
            d="M162 269.05h-3v-2h1a7.5 7.5 0 0 0 .76 1 15 15 0 0 0 1.24 1"
            style={{
              fill: "#8d5522",
            }}
          />
          <path
            d="M158.55 267.07v1h-1.84l-.06-.66Z"
            style={{
              fill: "#5e2000",
            }}
          />
          <path
            d="M160 267.05h-1v-2h1Z"
            style={{
              fill: "#995527",
            }}
          />
          <path
            d="M133 270.05c-1.5-.08-.85-1.24-1-2v-1h1z"
            className="templesOnly_svg__cls-872"
          />
          <path
            d="M131 262.05h2v2.75ZM133 267.05h-1c-.34-.66-.67-1.33-1-2h2Z"
            className="templesOnly_svg__cls-873"
          />
          <path
            d="M153 159.05v1c-.34.26-1 .68-1 .76 1.87 3.7.59 7.66.91 11.47 0 .23-.62.52-1 .77 0-1.59.06-3.19 0-4.78 0-.43-.62-.81-1-1.22a17.5 17.5 0 0 0 0-2.81c-.07-.44-.62-.79-1-1.19v-11l2-3v8.77c.19.42.79.82 1.09 1.23"
            style={{
              fill: "#cf7733",
            }}
          />
          <path
            d="M152 150.05v-6.71l-2-.67v-2.62c1.88-1.06 2-2.86 2-4.74v-18.26h1v33Z"
            style={{
              fill: "#cd7837",
            }}
          />
          <path
            d="M154 218.05c.33.27 1 .53 1 .79q.07 13.22 0 26.43c0 .26-.62.52-1 .78v-7c-.39-1 .92-2.53-1-3v-2c.33-.41.94-.82 1-1.24.08-3.59 0-7.17 0-10.76Z"
            style={{
              fill: "#cd763f",
            }}
          />
          <path
            d="M153 117.05h-1c0-3 .08-6 0-8.93a12.6 12.6 0 0 0-1-3.07c.33-.41.94-.82 1-1.25.08-3.91 0-7.83 0-11.75v-1c1.65.17 1 1.47 1 2.26.06 7.92 0 15.83 0 23.74"
            className="templesOnly_svg__cls-877"
          />
          <path
            d="M152 173.05c.33-.25 1-.54 1-.77-.32-3.81 1-7.77-.91-11.47 0-.08.62-.5 1-.76 1.34 0 1 1 1 1.76v15.24l-1 1c-.34-.39-.91-.77-1-1.2a37 37 0 0 1-.09-3.8"
            style={{
              fill: "#d6813c",
            }}
          />
          <path
            d="M158 256.05h1v2c.15.76-.5 1.92 1 2v2l-1 1a2.46 2.46 0 0 0-2 3h-1l-1-1c-.46-2.72 1.13-4.43 3-6Z"
            className="templesOnly_svg__cls-879"
          />
          <path
            d="M154 218.05v4h-1v-15h1Z"
            style={{
              fill: "#dc7c35",
            }}
          />
          <path
            d="M154 84.05c0 1.44.17 2.85-1.3 3.9-.49.35-.48 1.38-.7 2.1h-2v-2l1-1 .82-.33-.82-.67c.33-.66.66-1.33 1-2Z"
            style={{
              fill: "#5b1d06",
            }}
          />
          <path
            d="M154 246.05c1.22 4.88 1.22 4.88 4 7h-3l-1-1c-.16-.75.49-1.91-1-2v-2c.19-.75-.46-1.91 1-2"
            className="templesOnly_svg__cls-882"
          />
          <path
            d="M154 185.05v11h-1v-11Z"
            style={{
              fill: "#b76323",
            }}
          />
          <path
            d="M150 90.05h2v2c-.34.26-.91.48-1 .78a29 29 0 0 0-.21 3.22H149v-1q2.055-1.5 0-3v-1Z"
            style={{
              fill: "#8f390d",
            }}
          />
          <path
            d="M154 207.05h-1c-.16-.75.49-1.91-1-2v-1l1-.75-1-1.25v-2h1l1 1Z"
            style={{
              fill: "#c86923",
            }}
          />
          <path
            d="M152 150.05h1v9c-.34-.41-.94-.81-1-1.23z"
            style={{
              fill: "#d0823e",
            }}
          />
          <path
            d="m153 178.05 1-1v5h-1Z"
            style={{
              fill: "#ca792f",
            }}
          />
          <path
            d="M154 84.05h-2c.33-.66.66-1.33 1-2h1Z"
            className="templesOnly_svg__cls-888"
          />
          <path
            d="m154 201.05-1-1v-2h1Z"
            style={{
              fill: "#d07535",
            }}
          />
          <ellipse
            cx={153.54}
            cy={197.05}
            rx={0.71}
            ry={1.41}
            style={{
              fill: "#c46928",
            }}
          />
          <path
            d="M158 254.05h-2v-1h2Z"
            style={{
              fill: "#7f4f35",
            }}
          />
          <ellipse
            cx={153.54}
            cy={184.05}
            className="templesOnly_svg__cls-892"
            rx={0.71}
            ry={1.41}
          />
          <path
            d="M154 82.05h-1c.15-.75-.5-1.91 1-2Z"
            style={{
              fill: "#552d22",
            }}
          />
          <circle
            cx={153.54}
            cy={182.55}
            r={0.71}
            style={{
              fill: "#ca7529",
            }}
          />
          <path
            d="M153 182.05v3c-1.5.09-.85 1.25-1 2s.49 1.92-1 2c.72-2.79-1.12-5.27-1-8 1.49-.08.84-1.24 1-2-.39-1 .92-2.53-1-3v-9h1c.33.41.92.79 1 1.22.11 1.59 0 3.19 0 4.78a37 37 0 0 0 0 3.8c0 .43.62.81 1 1.2Z"
            style={{
              fill: "#de742d",
            }}
          />
          <path
            d="M150 140.05v2.62l2 .67v5.71l-2 3h-1c.72-2.79-1.12-5.27-1-8 1.92-.46.61-2 1-3v-1Z"
            style={{
              fill: "#c96326",
            }}
          />
          <path
            d="M150 160.05v1c-.34.4-.89.75-1 1.19a17.5 17.5 0 0 0 0 2.81c-3.85.13-3.88.15-4 4h-1v-7l1-1 2-1 .29 2.91.71-.08v-2.83Z"
            className="templesOnly_svg__cls-897"
          />
          <path
            d="M149 165.05a17.5 17.5 0 0 1 0-2.81c.07-.44.62-.79 1-1.19v13l-2 1.09-2-1.09v-1l2.36-.33-1.36-2.67c2.88-.79 1.83-3.14 2-5"
            style={{
              fill: "#ca571f",
            }}
          />
          <path
            d="M149 152.05h1v4h-2v4h-1c0-1.72.31-3.53-1-5v-1h3Z"
            style={{
              fill: "#c6551e",
            }}
          />
          <path d="M148 160.05v-4h2v4Z" className="templesOnly_svg__cls-900" />
          <path
            d="M150 167.05v-4c.33.4.88.75 1 1.19a17.5 17.5 0 0 1 0 2.81Z"
            className="templesOnly_svg__cls-897"
          />
          <path
            d="M151 105.05a12.6 12.6 0 0 1 1 3.07c.13 3 0 5.95 0 8.93v2h-1c.53-2.76-1.59-4.2-3-6v-1c-.16-.75.49-1.91-1-2-.34-.33-.67-.66-1-1v-6l1.63.82c.36-.27.66-.51 1.11-.84.23 1.44.42 2.65.61 3.86h.65v-5.79h1Z"
            style={{
              fill: "#b9531c",
            }}
          />
          <path
            d="M151 119.05h1v5l-1 1-2-1v5a17.7 17.7 0 0 1 0 2.82c-.07.44-.62.79-1 1.18-.39-1 .92-2.53-1-3l-1-2v3h-1l-1-1 1-2c1.93-.33.65-1.83 1-2.75.28-.77-.65-2.08 1-2.25.09 1 .19 1.93.29 2.9l.71-.06v-5.84Z"
            className="templesOnly_svg__cls-902"
          />
          <path
            d="m151 125.05 1-1v11.26c0 1.88-.12 3.68-2 4.74h-1l-1-1a7 7 0 0 0 .63-1.15c.44-1.37 1-2.8-.63-3.85v-1c.33-.39.88-.74 1-1.18a17.7 17.7 0 0 0 0-2.82c2.25-.56 2.12-2.29 2-4"
            className="templesOnly_svg__cls-903"
          />
          <path
            d="M153 82.05c-.34.67-.67 1.34-1 2l-1 2v1l-1 1-1-1c-.34-.33-.67-.66-1-1 .33-.66.66-1.33 1-2v-1h1c1.49-.08.84-1.24 1-2 .7.34 1.37.67 2 1"
            className="templesOnly_svg__cls-904"
          />
          <path
            d="M153 77.05v1c-.76.15-1.92-.49-2 1h-2v-1l1-1Z"
            style={{
              fill: "#260000",
            }}
          />
          <path
            d="M153 77.05h-3v-1h1c.79.15 2-.49 2 1M151 79.05c.08-1.49 1.24-.85 2-1l-2 2Z"
            className="templesOnly_svg__cls-906"
          />
          <path
            d="M150 83.05h-1v-3h1z"
            style={{
              fill: "#461100",
            }}
          />
          <path
            d="M150 83.05v-2h1c-.12.76.53 1.95-1 2"
            className="templesOnly_svg__cls-906"
          />
          <path
            d="M150 80.05h-1v-1h2v1Z"
            style={{
              fill: "#350b04",
            }}
          />
          <path
            d="M153 215.05v22h-1v-5l-.87-1.63c.32-1.56 1.08-3.56.71-3.8-1.86-1.19 1.52-2.65-.35-3.56a1.3 1.3 0 0 0-.49 0v-2c.33-.4.92-.78 1-1.21.11-1.59 0-3.19 0-4.79Z"
            style={{
              fill: "#cb5c1d",
            }}
          />
          <path
            d="M154 246.05c-1.5.09-.85 1.25-1 2h-3v-1h1.43a13.8 13.8 0 0 0 1.57-8h1Z"
            className="templesOnly_svg__cls-910"
          />
          <path
            d="M153 234.05v-12h1v10.76c0 .42-.63.83-1 1.24M154 239.05h-1v-3c2 .47.65 2.02 1 3"
            className="templesOnly_svg__cls-911"
          />
          <path
            d="M151 105.05v-4c-.39-1 .92-2.53-1-3-.34-.66-.67-1.33-1-2h1.83a29 29 0 0 1 .21-3.22c0-.3.62-.52 1-.78v11.75c-.04.43-.67.84-1.04 1.25"
            style={{
              fill: "#934214",
            }}
          />
          <path
            d="M156 253.05v1l1 1 1 1v3h-4v-3l2-1h-3a8 8 0 0 1 .76-1c.38-.37.82-.67 1.24-1Z"
            style={{
              fill: "#b75e29",
            }}
          />
          <path
            d="M155 259.05h3c-1.87 1.57-3.46 3.28-3 6-.76-.15-1.92.5-2-1v-4l2 1Z"
            style={{
              fill: "#b45622",
            }}
          />
          <path
            d="M153 264.05c.08 1.5 1.24.85 2 1l1 1c-.47 1.93-2 .62-3 1l-.4-.87-1.6.87v-5h1c.19.76-.46 1.95 1 2"
            style={{
              fill: "#af561d",
            }}
          />
          <path
            d="M153 267.05c1-.38 2.53.93 3-1h3v1l-1.9.34.06.66H159v1h-5l-1-1Z"
            style={{
              fill: "#733f19",
            }}
          />
          <path
            d="M153 215.05h-1a17.5 17.5 0 0 0 0-2.81c-.07-.44-.62-.79-1-1.19v-1a37 37 0 0 1 0-3.8c0-.42.62-.8 1-1.2 1.49.09.84 1.25 1 2Z"
            className="templesOnly_svg__cls-917"
          />
          <path
            d="M150 89.05v1h-3v-1z"
            style={{
              fill: "#71270c",
            }}
          />
          <path
            d="M150 89.05h-1v-2c.33.34.66.67 1 1ZM151 87.05v-1l.82.67Z"
            className="templesOnly_svg__cls-919"
          />
          <path
            d="M152 248.05h1v2l-1 2h2l1 1h-4l-4-1.51c.71-.52 1.37-1 2.08-1.54l-.15.14.7.82.31-.31a5 5 0 0 0-.86-.65 7 7 0 0 1 0-.95l1-1h1l.33 1.9.67-.06Z"
            style={{
              fill: "#b95d27",
            }}
          />
          <path
            d="M154 252.05h-2l1-2c1.53.09.88 1.25 1 2"
            className="templesOnly_svg__cls-910"
          />
          <path
            d="M151 189.05c1.49-.08.84-1.24 1-2h1v13h-1a31 31 0 0 0 0-4 36 36 0 0 0-1-4Z"
            style={{
              fill: "#d6742c",
            }}
          />
          <path
            d="M153 187.05h-1c.15-.75-.5-1.91 1-2Z"
            className="templesOnly_svg__cls-892"
          />
          <path
            d="M149 96.05c.33.67.66 1.34 1 2v3h-1c-.42-1.31-.83-2.63-1.25-4l-2.75 2a5.19 5.19 0 0 1-.75-4.88l1.75.91v-4h1v1c.15.76-.5 1.92 1 2h1v2Z"
            className="templesOnly_svg__cls-922"
          />
          <path
            d="M147 91.05h-1v-1h4l-1 1Z"
            style={{
              fill: "#98401d",
            }}
          />
          <path
            d="M149 95.05v-3c1.41 1.01 1.41 2 0 3"
            style={{
              fill: "#8b3105",
            }}
          />
          <path
            d="M147 91.05h2v1h-2Z"
            style={{
              fill: "#9f3f14",
            }}
          />
          <path
            d="M151 192.05a36 36 0 0 1 1 4 31 31 0 0 1 0 4v2h-1l-.34-1.9-.66.07v1.83h-1l-.33-.83-.67.83h-1v-3h1c.11.28.22.56.32.83l.68-.83v-3h-2v-2c1.87-.58.79-1.82.74-3.55l-.74 1.55-2 1v-3c.6-.1 1.22-.18 1.82-.33s1.45-.44 2.18-.67v3l.32.83.68-.83Z"
            style={{
              fill: "#cc5b20",
            }}
          />
          <path
            d="M152 205.05c-.34.4-.91.78-1 1.2a37 37 0 0 0 0 3.8l-2-1v-6l1-1h1l1 1z"
            style={{
              fill: "#ca5722",
            }}
          />
          <path
            d="M152 204.05v-2l1 1.25Z"
            style={{
              fill: "#d26a28",
            }}
          />
          <path d="m157 255.05-1-1h1Z" className="templesOnly_svg__cls-882" />
          <path
            d="M151 192.05h-1c-.39-1 .92-2.53-1-3-.73.23-1.45.48-2.18.67s-1.22.23-1.82.33v-4c.51.66 1 1.31 1.54 2l1.38-1.38c-.32-.53-.62-1-.92-1.58l1-1v-2l2-1c-.12 2.73 1.72 5.21 1 8Z"
            className="templesOnly_svg__cls-929"
          />
          <path
            d="m146 174.05 2 1.09 2-1.09v2a14.8 14.8 0 0 0-2 5l-2-1Z"
            className="templesOnly_svg__cls-930"
          />
          <path
            d="M148 181.05a14.8 14.8 0 0 1 2-5c1.92.47.61 2 1 3-1.5.09-.85 1.25-1 2l-2 1Z"
            style={{
              fill: "#c9571c",
            }}
          />
          <path
            d="M150 181.05c.15-.75-.5-1.91 1-2-.12.76.53 1.95-1 2"
            className="templesOnly_svg__cls-929"
          />
          <path
            d="m148 139.05 1 1v1c-1.93.47-.62 2-1 3-.12 2.73 1.72 5.21 1 8v2h-3c.12-1.17-.36-2.41.84-3.45.48-.42.34-1.51-.84-1.55-.34-1-.67-2-1-3 .06-1.24-.42-2.64 1-3.49-.33-.37-1-.75-.93-1.08.28-3.22-.48-6.31-1-9.43v-1h3v4a17.7 17.7 0 0 0 0 2.82c.08.44.63.79.93 1.18"
            style={{
              fill: "#c4511a",
            }}
          />
          <path
            d="M148 144.05c.38-1-.93-2.53 1-3-.35.95 1 2.54-1 3"
            className="templesOnly_svg__cls-903"
          />
          <path
            d="M144 162.05v9c.11 1.92-.46 3.94.81 5.69l-.81.31h-1c-.34-1.66-.67-3.33-1-5 .33-1.66.66-3.33 1-5v-5Z"
            className="templesOnly_svg__cls-933"
          />
          <path
            d="M149 165.05c-.21 1.86.84 4.21-2 5l-1-1h-1c.16-3.85.19-3.87 4-4"
            style={{
              fill: "#c75721",
            }}
          />
          <path
            d="M146 155.05c1.31 1.47 1 3.28 1 5l-2 1c-.39-1 .92-2.53-1-3v-1c1.49-.08.84-1.24 1-2Z"
            className="templesOnly_svg__cls-900"
          />
          <path
            d="M144 158.05c1.92.47.61 2 1 3l-1 1h-1v-2c.37-.66.7-1.33 1-2"
            className="templesOnly_svg__cls-935"
          />
          <path
            d="M147 160.05h1v2.83l-.71.08Z"
            className="templesOnly_svg__cls-900"
          />
          <path
            d="M144 171.05v-2h1l1 1v1Z"
            style={{
              fill: "#cd672c",
            }}
          />
          <path
            d="M144 171.05h2v14h-1v-2c-.34-.66-.67-1.33-1-2l1-.75-1-1.25v-2l.81-.31c-1.23-1.74-.66-3.74-.81-5.69"
            className="templesOnly_svg__cls-700"
          />
          <path
            d="M146 173.05v-4l1 1 1.36 2.67ZM146 155.05h-2v-1c1.65-.16.72-1.47 1-2.25s-.94-2.41 1-2.75c1.18 0 1.32 1.13.84 1.55-1.2 1-.72 2.28-.84 3.45Z"
            className="templesOnly_svg__cls-930"
          />
          <path
            d="M147 123.05c-1.66.17-.73 1.48-1 2.25-.34.92.94 2.42-1 2.75-1.93-.46-.62-2-1-3 .33-1.66.66-3.33 1-5 1.64-2.33 1.11-4.29-1-6 .33-1.66.66-3.33 1-5 .15-.75-.5-1.91 1-2v3c.11.28.22.56.32.83l.68-.83c1.49.09.84 1.25 1 2l-1 1-.84 1.44c1.55 1.68.53 3.74.84 5.56Z"
            style={{
              fill: "#bd4d17",
            }}
          />
          <path
            d="M146 107.05c-1.5.09-.85 1.25-1 2h-2l-1-1v-2h3v-2.92c1.18-1.32 1.9-2.13 2.6-2.9l1.43.82h1v5.79h-.65c-.19-1.21-.38-2.42-.61-3.86-.45.33-.75.57-1.11.84l-1.63-.82Z"
            style={{
              fill: "#ae4412",
            }}
          />
          <path
            d="m151 119.05-3 1v-7c1.45 1.8 3.57 3.24 3 6"
            className="templesOnly_svg__cls-939"
          />
          <path
            d="M150 101.05v-3c1.92.47.61 2 1 3Z"
            className="templesOnly_svg__cls-877"
          />
          <path
            d="m147 113.05 1-1v1ZM146 110.05v-1c.33.34.66.67 1 1Z"
            className="templesOnly_svg__cls-939"
          />
          <path
            d="M151 125.05c.08 1.71.21 3.44-2 4v-5Z"
            style={{
              fill: "#c65f1d",
            }}
          />
          <path
            d="M144 125.05c.38 1-.93 2.54 1 3l-1 2v2h-1v-7Z"
            style={{
              fill: "#bb511b",
            }}
          />
          <path
            d="M147 123.05v-3h1v5.84l-.71.06c-.06-.95-.16-1.95-.29-2.9"
            className="templesOnly_svg__cls-939"
          />
          <path
            d="M147 135.05v-5c1.92.47.61 2 1 3v1Z"
            className="templesOnly_svg__cls-942"
          />
          <path
            d="M147 130.05v1h-1v-3Z"
            style={{
              fill: "#ce5e24",
            }}
          />
          <path d="M144 131.05v-1l1 1Z" className="templesOnly_svg__cls-942" />
          <path
            d="m147 135.05 1-1c1.65 1 1.07 2.48.63 3.85a7 7 0 0 1-.63 1.15c-.34-.39-.89-.74-1-1.18a17.7 17.7 0 0 1 0-2.82"
            className="templesOnly_svg__cls-902"
          />
          <path
            d="M147 76.05v1h-4v-2h1c.08 1.5 1.24.85 2 1Z"
            style={{
              fill: "#501202",
            }}
          />
          <path
            d="M149 79.05v1h-1v-2h1Z"
            style={{
              fill: "#571e12",
            }}
          />
          <path
            d="M146 77.05h1c.33.34.66.67 1 1h-2Z"
            style={{
              fill: "#6b210a",
            }}
          />
          <path d="m150 77.05-1 1v-1Z" className="templesOnly_svg__cls-906" />
          <circle
            cx={149.54}
            cy={76.55}
            r={0.71}
            className="templesOnly_svg__cls-947"
          />
          <path
            d="M149 84.05c-.34.67-.67 1.34-1 2h-2l-.88-.39.88-1.61z"
            style={{
              fill: "#792b13",
            }}
          />
          <path
            d="M147 86.05h1c.33.34.66.67 1 1v1h-3v-1Z"
            style={{
              fill: "#6e2713",
            }}
          />
          <circle
            cx={148.54}
            cy={83.55}
            r={0.71}
            style={{
              fill: "#712f17",
            }}
          />
          <path
            d="M149 83.05h-1v-3h1Z"
            style={{
              fill: "#521301",
            }}
          />
          <path
            d="M153 237.05v2a13.8 13.8 0 0 1-1.57 8H150c.46-1.24 1.78-2.33.51-4l-1.51.33v1.7c-1.5-.08-.85-1.24-1-2a5.4 5.4 0 0 0 1-4 9 9 0 0 0 1-.76c.37-.38.67-.82 1-1.24l.32.83.68-.83Z"
            style={{
              fill: "#d25e22",
            }}
          />
          <path
            d="M151 211.05c.33.4.88.75 1 1.19a17.5 17.5 0 0 1 0 2.81c0 1.6.06 3.2 0 4.79 0 .43-.62.81-1 1.21l-.92-1.61.83-.77c-.32-.58-.62-1.1-.91-1.62 1.22-.06 1.23-.94.8-1.61s-1.19-.93-1.8-1.39v-2ZM151 223.05a1.3 1.3 0 0 1 .49 0c1.87.91-1.51 2.37.35 3.56.37.24-.39 2.24-.71 3.8l.87 1.63h-2v-2c-.13-2 .45-4-.66-5.59l.66-1.41Z"
            className="templesOnly_svg__cls-953"
          />
          <path
            d="M151 223.05h-1v-2h-2v-3l1-1h1c.29.52.59 1 .91 1.62l-.83.77.92 1.61Z"
            style={{
              fill: "#cc5a22",
            }}
          />
          <ellipse
            cx={151.54}
            cy={234.55}
            rx={0.71}
            ry={3.54}
            style={{
              fill: "#ca5819",
            }}
          />
          <path
            d="M149 245.05v-1.7l1.51-.33c1.27 1.7-.05 2.79-.51 4v1h-1v-3Z"
            style={{
              fill: "#d66429",
            }}
          />
          <path
            d="M152 248.05v1.84l-.67.06-.33-1.9Z"
            style={{
              fill: "#ab4c0f",
            }}
          />
          <path
            d="M152 262.05h-1v-2c-.16-.75.49-1.91-1-2l.85-1.5-.85-1.5h3l1 1v3h-1l-.35-1.89-.65.07z"
            style={{
              fill: "#ae5920",
            }}
          />
          <path
            d="M153 255.05h-1v-2h3c-.42.34-.86.64-1.24 1a8 8 0 0 0-.76 1"
            className="templesOnly_svg__cls-959"
          />
          <path
            d="M153 259.05h2v2l-2-1Z"
            className="templesOnly_svg__cls-879"
          />
          <path d="m154 256.05-1-1h3Z" className="templesOnly_svg__cls-959" />
          <path
            d="M152 262.05v-2h1v4c-1.46-.05-.81-1.24-1-2"
            style={{
              fill: "#a6490f",
            }}
          />
          <path
            d="M151 265.05v1l-1 1-1 1a17.5 17.5 0 0 0 0-2.81c-.07-.44-.62-.79-1-1.19v-7l2 1v2a37 37 0 0 0 0 3.8c.13.43.7.81 1 1.2"
            className="templesOnly_svg__cls-961"
          />
          <path
            d="M151 265.05c-.34-.39-.91-.77-1-1.2a37 37 0 0 1 0-3.8h1z"
            style={{
              fill: "#c46f34",
            }}
          />
          <path
            d="M153 267.05v1h-2v-1l1.6-.87Z"
            className="templesOnly_svg__cls-963"
          />
          <path
            d="m150 267.05 1-1v1Z"
            style={{
              fill: "#c86a3c",
            }}
          />
          <path
            d="M158 269.05v1h-6v-1z"
            style={{
              fill: "#d6b186",
            }}
          />
          <path
            d="M154 269.05h-3v-1h2Z"
            style={{
              fill: "#541f00",
            }}
          />
          <path
            d="m151 211.05-2 1v-3l2 1Z"
            className="templesOnly_svg__cls-967"
          />
          <path
            d="M146 88.05h3v1h-3Z"
            style={{
              fill: "#671f0c",
            }}
          />
          <path
            d="M146 89.05h1v1h-3v-1z"
            className="templesOnly_svg__cls-969"
          />
          <path
            d="M149 249.05v1l-2 1.49 4 1.51-1 1-3-1h-5v-1l3-.22c-.43-.76-.71-1.27-1-1.78.75-.15 1.91.5 2-1Z"
            className="templesOnly_svg__cls-970"
          />
          <path
            d="m150 254.05 1-1h1v2h-2Z"
            style={{
              fill: "#a05214",
            }}
          />
          <path
            d="m149.13 250 .81.7-.31.31-.7-.82Z"
            className="templesOnly_svg__cls-970"
          />
          <path d="M149 248.05h1l-1 1Z" className="templesOnly_svg__cls-910" />
          <path
            d="m149 101.05-1.43-.82c-.7.77-1.42 1.58-2.6 2.9v2.92h-2v-2l-2-1.55c1.11-.85 1.47-1.75.17-2.75l.8-.7 1.5 1.88 1.5-1.88 2.75-2c.52 1.37.93 2.69 1.31 4"
            style={{
              fill: "#a83c0e",
            }}
          />
          <path
            d="m145 99.05-1.5 1.88-1.5-1.88v-5l.82-.33-.82-.67c.15-.75-.5-1.91 1-2l-.15.14.7.82.31-.31a5 5 0 0 0-.86-.65l1-1h1l1 1v4l-1.75-.91a5.19 5.19 0 0 0 .75 4.91"
            style={{
              fill: "#99340a",
            }}
          />
          <ellipse
            cx={148.54}
            cy={93.05}
            rx={0.71}
            ry={1.41}
            style={{
              fill: "#99390d",
            }}
          />
          <path
            d="M148 92.05v2c-1.5-.08-.85-1.24-1-2Z"
            style={{
              fill: "#a84318",
            }}
          />
          <path d="m146 91.05-1-1h1Z" className="templesOnly_svg__cls-922" />
          <path
            d="M144 181.05c.33.67.66 1.34 1 2l-1 .76c.33.41.66.83 1 1.24v9c-1.5.09-.85 1.25-1 2-1.5-.08-.85-1.24-1-2-.11-.6-.19-1.22-.34-1.82s-.44-1.45-.66-2.18l.82-.33-.82-.67v-1l2.22-1.6c-1.93-.81-1-2.25-1.22-3.4.19-.75-.46-1.91 1-2"
            style={{
              fill: "#be6429",
            }}
          />
          <path
            d="M147 202.05h1c-.34 1.67-.67 3.34-1 5 .33.67.66 1.34 1 2-1.5.09-.85 1.25-1 2v1h-1v-3c-.16-.75.49-1.91-1-2v-4h1c.11.28.22.56.32.83l.68-.83Z"
            style={{
              fill: "#c45d1d",
            }}
          />
          <path
            d="M145 194.05v-1l2-1v5l-2-1 .87-1.6Z"
            style={{
              fill: "#ce6425",
            }}
          />
          <path
            d="M147 197.05v-1h2v3h-2z"
            style={{
              fill: "#d05f25",
            }}
          />
          <path
            d="M147 198.05v4a2.47 2.47 0 0 1 0-4"
            className="templesOnly_svg__cls-980"
          />
          <path
            d="M149 189.05c1.92.47.61 2 1 3h-1Z"
            style={{
              fill: "#d76428",
            }}
          />
          <path
            d="M147 194.05v-2l.74-1.55c.09 1.73 1.17 2.97-.74 3.55"
            className="templesOnly_svg__cls-929"
          />
          <path
            d="M151 202.05h-1v-1.83l.66-.07Z"
            style={{
              fill: "#d46026",
            }}
          />
          <path
            d="M152 202.05v1l-1-1ZM150 202.05l-1 1v-1ZM148 202.05l.67-.83.33.83ZM148 199.05h1l-.68.83c-.06-.27-.17-.55-.32-.83"
            className="templesOnly_svg__cls-917"
          />
          <path
            d="M149 192.05h1l-.68.83Z"
            className="templesOnly_svg__cls-929"
          />
          <path
            d="M148 202.05h1v5h-2c.37-1.66.7-3.33 1-5"
            style={{
              fill: "#cf6024",
            }}
          />
          <path
            d="M147 207.05h2v2h-1c-.3-.66-.63-1.33-1-2"
            className="templesOnly_svg__cls-984"
          />
          <path
            d="M146 185.05v-5l2 1v1l-1 .76c.33.41.66.83 1 1.24l-1 1Z"
            style={{
              fill: "#d06127",
            }}
          />
          <path
            d="M146 185.05h1c.3.53.6 1 .92 1.58l-1.34 1.37c-.51-.65-1-1.3-1.54-2v-1Z"
            style={{
              fill: "#c15919",
            }}
          />
          <path
            d="M148 184.05c-.34-.41-.67-.83-1-1.24l1-.76Z"
            style={{
              fill: "#d6652b",
            }}
          />
          <path
            d="M143 132.05h1c.56 3.12 1.32 6.21 1 9.43 0 .33.6.71.93 1.08-1.39.85-.91 2.25-1 3.49h-2v-14Z"
            className="templesOnly_svg__cls-942"
          />
          <path
            d="M144 146.05h1c.33 1 .66 2 1 3-1.94.34-.66 1.84-1 2.75s.65 2.09-1 2.25Z"
            className="templesOnly_svg__cls-935"
          />
          <path
            d="M143 160.05v7c-2.31-.64 0-3-2-4.28.05 3.17-.15 6 .19 8.93 0 .15.53.24.82.35.33 1.67.66 3.34 1 5h-1c-.16-.75.49-1.91-1-2l-1-1v-15a2.48 2.48 0 0 0 0-4v-1h2v2a17.7 17.7 0 0 0 0 2.82c.14.44.69.79.99 1.18"
            style={{
              fill: "#ac5c23",
            }}
          />
          <path
            d="M142 172.05c-.29-.11-.8-.2-.82-.35-.34-2.88-.14-5.76-.19-8.93 2 1.24-.3 3.64 2 4.28-.29 1.67-.62 3.34-.99 5"
            style={{
              fill: "#a4531e",
            }}
          />
          <path
            d="M142 177.05h2v2l-2-1Z"
            style={{
              fill: "#c16730",
            }}
          />
          <path d="M146 169.05v1l-1-1Z" className="templesOnly_svg__cls-897" />
          <path
            d="M143 160.05c-.34-.39-.89-.74-1-1.18a17.7 17.7 0 0 1 0-2.82h1l1 1v1c-.3.67-.63 1.34-1 2"
            className="templesOnly_svg__cls-991"
          />
          <path
            d="M144 155.05h1c-.16.76.49 1.92-1 2Z"
            className="templesOnly_svg__cls-935"
          />
          <path
            d="M145 185.05c-.34-.41-.67-.83-1-1.24l1-.76Z"
            style={{
              fill: "#cb6d2f",
            }}
          />
          <path
            d="m144 179.05 1 1.25-1 .75Z"
            style={{
              fill: "#ba5d1f",
            }}
          />
          <path
            d="M144 155.05v2l-1-1v-10h1z"
            style={{
              fill: "#bc5722",
            }}
          />
          <path
            d="M144 114.05c2.11 1.71 2.64 3.67 1 6l-2 1v-6Z"
            style={{
              fill: "#bf4b1e",
            }}
          />
          <path
            d="m144 114.05-1 1h-1c-.71-2.17 1-3.94 1-6h2c-.3 1.67-.63 3.34-1 5"
            className="templesOnly_svg__cls-996"
          />
          <path
            d="M148 120.05h-1c-.31-1.82.71-3.88-.84-5.56l.84-1.44h1Z"
            style={{
              fill: "#b74914",
            }}
          />
          <path
            d="m143 121.05 2-1c-.34 1.67-.67 3.34-1 5h-1z"
            style={{
              fill: "#b94a19",
            }}
          />
          <path
            d="M146 110.05h1l-.68.83c-.06-.27-.17-.55-.32-.83"
            className="templesOnly_svg__cls-996"
          />
          <path
            d="M143 109.05c0 2.06-1.71 3.83-1 6v1c-1.65-.16-.81-1.44-1-2.24s.33-1.75-1-1.76c-.18-2.27.53-4.64-.64-6.63l.64-1.37 1 1 1 1v2Z"
            className="templesOnly_svg__cls-999"
          />
          <path
            d="m142 106.05-1-1 2-1v2ZM143 109.05l-1-1Z"
            className="templesOnly_svg__cls-996"
          />
          <path
            d="M143 124.05v7h-3v-4l2 1v-4Z"
            className="templesOnly_svg__cls-1000"
          />
          <path
            d="M141 131.05h2v1l-2 1Z"
            style={{
              fill: "#b1541e",
            }}
          />
          <path
            d="M143 75.05v1l-3 1-1 1h-1v-2h2l1-1z"
            style={{
              fill: "#bd6135",
            }}
          />
          <path
            d="m140 77.05 3-1v2h-3Z"
            style={{
              fill: "#8c360b",
            }}
          />
          <path
            d="M146 77.05v2h-1v-2Z"
            style={{
              fill: "#913d20",
            }}
          />
          <ellipse
            cx={144.04}
            cy={77.55}
            rx={1.41}
            ry={0.71}
            style={{
              fill: "#a36542",
            }}
          />
          <path
            d="M148 80.05v1h-1v-3h1Z"
            style={{
              fill: "#6a230f",
            }}
          />
          <path
            d="M147 78.05v3l-1 1h-1v-2l1-1v-1Z"
            style={{
              fill: "#77280c",
            }}
          />
          <path
            d="m146 84.05-.88 1.61.88.39v1h-2v-1c.15-.75-.5-1.91 1-2Z"
            style={{
              fill: "#6a1e03",
            }}
          />
          <path d="M148 83.05v1h-2v-1z" className="templesOnly_svg__cls-904" />
          <path
            d="M146 87.05v-1h1Z"
            style={{
              fill: "#80371e",
            }}
          />
          <path
            d="M145 87.05h1v2h-1Z"
            style={{
              fill: "#5d1200",
            }}
          />
          <path
            d="M148 83.05h-1c-.34-.33-.67-.66-1-1l1-1h1Z"
            style={{
              fill: "#5f1a02",
            }}
          />
          <path
            d="M149 248.05v1h-3c-.16-.75.49-1.91-1-2-.16-.75.49-1.91-1-2h-1l-.83-.33.83-.67h2l2 1v-2h1c.15.76-.5 1.92 1 2v1l-1 .76c.37.41.7.83 1 1.24"
            style={{
              fill: "#c76c28",
            }}
          />
          <path
            d="M151 232.05v5c-.34.42-.64.86-1 1.24a9 9 0 0 1-1 .76v-4c.33-1 .66-2 1-3Z"
            className="templesOnly_svg__cls-1013"
          />
          <path
            d="M149 237.05v2a5.4 5.4 0 0 1-1 4h-1v-2c1.64-.16.8-1.44 1-2.24s-.31-1.75 1-1.76"
            style={{
              fill: "#c75d1e",
            }}
          />
          <path
            d="M151 237.05h1l-.68.83Z"
            className="templesOnly_svg__cls-1013"
          />
          <path
            d="m149 217.05-1 1-1-1a5.4 5.4 0 0 0 1-4l1-1z"
            style={{
              fill: "#cc5c1d",
            }}
          />
          <path
            d="M149 217.05v-3c.61.46 1.42.79 1.8 1.39s.42 1.55-.8 1.61Z"
            className="templesOnly_svg__cls-967"
          />
          <path
            d="M148 221.05h2v2l-.66 1.41c1.11 1.61.53 3.64.66 5.59-.34.42-.64.86-1 1.24a9 9 0 0 1-1 .76v-2c.07-1.24-.43-2.64 1-3.5-1.43-.85-.93-2.26-1-3.5Z"
            style={{
              fill: "#cf5f26",
            }}
          />
          <path
            d="M148 232.05a9 9 0 0 0 1-.76c.37-.38.67-.82 1-1.24v2c-.34 1-.67 2-1 3h-2v-1c1.53-.05.88-1.24 1-2"
            style={{
              fill: "#c75b21",
            }}
          />
          <path
            d="M148 221.05v2c-1.5-.08-.85-1.24-1-2v-3h1Z"
            style={{
              fill: "#cd652a",
            }}
          />
          <path
            d="M149 248.05c-.34-.41-.67-.83-1-1.24l1-.76Z"
            style={{
              fill: "#d67e3c",
            }}
          />
          <path
            d="m150 258.05-2-1c.33-.66.66-1.33 1-2h1l.85 1.5Z"
            className="templesOnly_svg__cls-1020"
          />
          <path
            d="M153 260.05h-1v-2.82l.65-.07.35 1.89Z"
            style={{
              fill: "#9a4e18",
            }}
          />
          <path
            d="M151 260.05h-1v-2c1.53.09.88 1.25 1 2"
            className="templesOnly_svg__cls-1020"
          />
          <path
            d="M148 258.05v10h-1v-10Z"
            style={{
              fill: "#da9b59",
            }}
          />
          <path
            d="M148 258.05h-1v-2l-1-1h-1v-1l1-1h1l2 2c-.34.67-.67 1.34-1 2Z"
            style={{
              fill: "#ab7446",
            }}
          />
          <path
            d="M148 268.05v-4c.33.4.88.75 1 1.19a17.5 17.5 0 0 1 0 2.81v1h-1Z"
            style={{
              fill: "#b46b2c",
            }}
          />
          <path
            d="M149 269.05v-1l1-1h1v2l-1 1Z"
            style={{
              fill: "#a85725",
            }}
          />
          <circle
            cx={151.54}
            cy={269.55}
            r={0.71}
            className="templesOnly_svg__cls-963"
          />
          <path
            d="m149 212.05-1 1-1-1v-1c1.49-.08.84-1.24 1-2h1Z"
            style={{
              fill: "#cf6122",
            }}
          />
          <path
            d="m144 90.05-1 1c-1.5.09-.85 1.25-1 2h-2v-2c.33-.66.66-1.33 1-2v-1h1c.08 1.5 1.24.85 2 1Z"
            className="templesOnly_svg__cls-922"
          />
          <path
            d="M145 87.05v2h-1l-1-1v-1z"
            style={{
              fill: "#7d3009",
            }}
          />
          <path
            d="m143 244.05-.83.67.83.33v2l3 2c-.09 1.5-1.25.85-2 1h-1l-3-3v-3a12 12 0 0 0 1.11-.62c.94-.59 1.68-.75 1.89.62"
            className="templesOnly_svg__cls-1028"
          />
          <path
            d="M142 252.05v1h-2l-1-1 2-2v1Z"
            style={{
              fill: "#b4773d",
            }}
          />
          <path
            d="m142 252.05-1-1c.75-.15 1.91.5 2-1h1c.28.51.56 1 1 1.78Z"
            style={{
              fill: "#884711",
            }}
          />
          <path
            d="m149 255.05-2-2 3 1v1Z"
            style={{
              fill: "#9b5d2e",
            }}
          />
          <path
            d="M140 253.05h3v1h-3Z"
            style={{
              fill: "#d79f6a",
            }}
          />
          <path
            d="M143 254.05v-1h3l-1 1Z"
            style={{
              fill: "#bb7c4a",
            }}
          />
          <path
            d="M140 91.05v2h2v6l-.8.7c1.3 1 .94 1.9-.17 2.75l2 1.55-2 1-1-1v-7.77a4.46 4.46 0 0 0-2-4.23c.09-1.49 1.25-.85 1.97-1"
            style={{
              fill: "#a94414",
            }}
          />
          <path
            d="M142 94.05v-1l.82.67Z"
            className="templesOnly_svg__cls-922"
          />
          <path
            d="m143.13 91 .81.7-.31.31-.7-.82Z"
            className="templesOnly_svg__cls-969"
          />
          <path
            d="M142 190.05c.22.73.47 1.45.66 2.18s.23 1.22.34 1.82c-1.78.64-1 1.79-.62 2.9.25.69.41 1.4.62 2.1-.34.42-.64.86-1 1.24a9 9 0 0 1-1 .76l-1-1v-6l.82-.33-.82-.67v-16h1v12Z"
            style={{
              fill: "#a45e20",
            }}
          />
          <path
            d="M141 189.05v-12h1v12Z"
            style={{
              fill: "#aa551f",
            }}
          />
          <path
            d="M143 199.05c-.21-.7-.37-1.41-.62-2.1-.4-1.11-1.16-2.26.62-2.9.15.76-.5 1.92 1 2h1a2.47 2.47 0 0 1-2 3"
            className="templesOnly_svg__cls-1037"
          />
          <path
            d="M142 183.05v-5l2 1v2c-1.5.09-.85 1.25-1 2Z"
            style={{
              fill: "#b75d27",
            }}
          />
          <path
            d="M142 183.05h1c.2 1.15-.71 2.59 1.22 3.4l-2.22 1.6Z"
            style={{
              fill: "#ab551f",
            }}
          />
          <path
            d="M145 196.05h-1c.15-.75-.5-1.91 1-2l.87.4Z"
            style={{
              fill: "#d36e2e",
            }}
          />
          <path
            d="M141 189.05h1l.82.67-.82.33Z"
            className="templesOnly_svg__cls-1041"
          />
          <path
            d="M145 205.05v2c.15.76-.5 1.92 1 2v3c-1.94.59-.59 2.19-1 3.25-.35.91.94 2.42-1 2.75a37 37 0 0 0 0-3.8c0-.42-.62-.8-1-1.2v-2c1.92-.46.61-2 1-3v-3Z"
            style={{
              fill: "#c26327",
            }}
          />
          <path
            d="M143 199.05a2.47 2.47 0 0 0 2-3l2 1v1a2.47 2.47 0 0 0 0 4v1h-2c-.63-1.33-1.3-2.66-2-4"
            style={{
              fill: "#c96323",
            }}
          />
          <path
            d="M143 199.05c.66 1.34 1.33 2.67 2 4v2h-1c-.16-.75.49-1.91-1-2l-1-1h-1v-1a9 9 0 0 0 1-.76c.4-.38.7-.82 1-1.24"
            className="templesOnly_svg__cls-1037"
          />
          <path
            d="m147 212.05 1 1a5.4 5.4 0 0 1-1 4c-.34-.39-.91-.77-1-1.2a37 37 0 0 1 0-3.8Z"
            className="templesOnly_svg__cls-1044"
          />
          <path
            d="M148 209.05c-.16.76.49 1.92-1 2 .19-.75-.46-1.91 1-2"
            className="templesOnly_svg__cls-984"
          />
          <path
            d="M146 209.05c-1.5-.08-.85-1.24-1-2 1.53.09.88 1.25 1 2"
            style={{
              fill: "#bc5b1c",
            }}
          />
          <path
            d="M146 203.05h1l-.68.83c-.06-.27-.17-.55-.32-.83"
            style={{
              fill: "#ca6324",
            }}
          />
          <path
            d="M141 131.05v4l.13 5.06 1.87-1.06v3h-1c-1.39.24-1.17 1-.52 2.11l.52-1.11h1v6h-1v-2l-.33-.83-.67.83c.15.76-.5 1.92 1 2v5h-2v-23Z"
            className="templesOnly_svg__cls-1047"
          />
          <path
            d="m143 139.05-1.87 1.06-.13-5.06h2Z"
            className="templesOnly_svg__cls-1048"
          />
          <path
            d="M143 135.05h-2v-2l2-1Z"
            className="templesOnly_svg__cls-1000"
          />
          <circle
            cx={142.54}
            cy={142.55}
            r={0.71}
            className="templesOnly_svg__cls-1048"
          />
          <path
            d="M140 131.05v43c-1.38 0-1-1.06-1-1.78v-14c0-1.43-.1-2.86-.16-4.27H137a5.63 5.63 0 0 0 1-4.06c-.05-1.32 0-2.65 0-4v-8.48c0-1.35.34-3.39-.44-4.22-1.29-1.39.64-2.37 0-3.18-1-1.18 1.17-1.55.47-2.36-1.75-2-.9-4.37-1-6.56-.11-5.8 0-11.61 0-17.41 0-.72.38-1.76-1-1.78l-.83-1.42c1.7-2.76.44-5.76.83-8.58h2a4.46 4.46 0 0 1 2 4.23v7.77l-.64 1.37c1.17 2 .46 4.36.64 6.63-.38 3.32.89 6.81-1.09 10.12 1.51 1.32 1 3.15 1.09 4.88Z"
            style={{
              fill: "#cb803d",
            }}
          />
          <path
            d="M142 154.05v-5h1v6h-1Z"
            className="templesOnly_svg__cls-991"
          />
          <path
            d="M140 159.05v-4a2.48 2.48 0 0 1 0 4"
            className="templesOnly_svg__cls-1047"
          />
          <path
            d="M142 177.05h-2v-1l1-1c1.53.09.88 1.25 1 2"
            style={{
              fill: "#a15118",
            }}
          />
          <path d="m141 175.05-1 1v-2Z" className="templesOnly_svg__cls-933" />
          <circle
            cx={142.54}
            cy={155.55}
            r={0.71}
            className="templesOnly_svg__cls-1047"
          />
          <path
            d="M143 124.05h-1v-9h1z"
            style={{
              fill: "#b44f1d",
            }}
          />
          <path
            d="M142 120.05v8l-2-1c-.06-1.73.42-3.56-1.09-4.88 2-3.31.71-6.8 1.09-10.12 1.34 0 .85 1 1 1.76s-.66 2.08 1 2.24v1c-1.33 1.01-1.33 2 0 3"
            style={{
              fill: "#af521d",
            }}
          />
          <path
            d="M138 78.05h1v1c.33.34.66.67 1 1v1l-.83.33.83.67v1h-1l-3-3 1-1Z"
            style={{
              fill: "#6f1a00",
            }}
          />
          <path
            d="M139 79.05v-1l1-1v2Z"
            style={{
              fill: "#cc7148",
            }}
          />
          <path
            d="M140 79.05v-1h2c.33.34.66.67 1 1v1h-1l-2 1z"
            style={{
              fill: "#9a3a16",
            }}
          />
          <path
            d="M143 79.05c-.34-.33-.67-.66-1-1h1Z"
            style={{
              fill: "#bb623d",
            }}
          />
          <path d="M143 79.05v-1h2v2Z" className="templesOnly_svg__cls-1057" />
          <path d="M145 80.05v-1h1Z" className="templesOnly_svg__cls-1058" />
          <path
            d="m143 79.05 2 1v2l-1 1h-1z"
            style={{
              fill: "#80300a",
            }}
          />
          <path
            d="M146 83.05v1h-1v-2h1Z"
            style={{
              fill: "#5f1803",
            }}
          />
          <path
            d="M145 83.05v1c-1.5.09-.85 1.25-1 2h-1c-.34-1-.67-2-1-3z"
            style={{
              fill: "#78290a",
            }}
          />
          <path
            d="M143 86.05h1v1h-2v-1Z"
            style={{
              fill: "#823515",
            }}
          />
          <path
            d="M146 83.05v-1c.33.34.66.67 1 1Z"
            style={{
              fill: "#530f00",
            }}
          />
          <path
            d="M143 244.05c-.25-1.37-1-1.21-1.89-.62a12 12 0 0 1-1.11.62l-1-1v-1l1-1v-5h1v6h3l1 1v1Z"
            style={{
              fill: "#b76322",
            }}
          />
          <path
            d="M145 244.05v-5h1c.33.67.66 1.34 1 2l-.83.33.83.67v3Z"
            style={{
              fill: "#bf6221",
            }}
          />
          <path
            d="m146 249.05-3-2h2c1.53.09.88 1.25 1 2"
            style={{
              fill: "#cc7933",
            }}
          />
          <path
            d="M145 247.05h-1v-2c1.53.09.88 1.25 1 2"
            className="templesOnly_svg__cls-1028"
          />
          <ellipse
            cx={143.54}
            cy={246.05}
            rx={0.71}
            ry={1.41}
            style={{
              fill: "#d58443",
            }}
          />
          <path
            d="M147 241.05c-.34-.66-.67-1.33-1-2 1.49-.08.84-1.24 1-2v-2h2v2c-1.35 0-.86 1-1 1.76s.68 2.08-1 2.24M147 242.05l-.83-.67.83-.33Z"
            className="templesOnly_svg__cls-1068"
          />
          <path d="M148 218.05h-1v-1Z" className="templesOnly_svg__cls-1044" />
          <path
            d="M147 221.05c.15.76-.5 1.92 1 2 .07 1.24-.43 2.65 1 3.5-1.43.86-.93 2.26-1 3.5h-1v-1c-.16-.75.49-1.91-1-2v-6Z"
            style={{
              fill: "#c75f21",
            }}
          />
          <path
            d="M147 230.05h1v2c-.16.76.49 1.92-1 2l-1-1c.37-1 .7-2 1-3"
            style={{
              fill: "#c96226",
            }}
          />
          <path
            d="m146 233.05 1 1v1c-1.46-.05-.81-1.24-1-2"
            style={{
              fill: "#cc692c",
            }}
          />
          <path
            d="M147 221.05h-1l-1-1-1-1v-1c1.93-.33.64-1.84 1-2.75.42-1.06-.93-2.66 1-3.25a37 37 0 0 0 0 3.8c0 .43.62.81 1 1.2z"
            className="templesOnly_svg__cls-1072"
          />
          <path
            d="M147 258.05v8h-1c-1.93-.46-.62-2-1-3v-4Z"
            style={{
              fill: "#daa86b",
            }}
          />
          <path
            d="M148 268.05v1l-1 1c-1.5.09-.85 1.25-1 2h-1l-1-1v-3z"
            className="templesOnly_svg__cls-1074"
          />
          <path
            d="M147 268.05h-4v-1h1c.75-.15 1.91.5 2-1h1Z"
            style={{
              fill: "#dfaa6b",
            }}
          />
          <path
            d="M145 255.05h1l1 1v1h-5l-1-1h2c.79-.15 2 .5 2-1"
            style={{
              fill: "#d6a574",
            }}
          />
          <path
            d="M144 257.05h3v1l-2 1h-1Z"
            style={{
              fill: "#daab76",
            }}
          />
          <path
            d="M143 254.05h2v1h-2l-1-1Z"
            style={{
              fill: "#a46f3f",
            }}
          />
          <path
            d="m147 256.05-1-1Z"
            style={{
              fill: "#e2b080",
            }}
          />
          <path
            d="m147 270.05 1-1h1l1 1h1l-1 1h-2Z"
            style={{
              fill: "#cb8d54",
            }}
          />
          <path
            d="M151 270.05h-1l1-1Z"
            style={{
              fill: "#7e3a09",
            }}
          />
          <path
            d="M138 92.05h-2v-1l.82-.33-.82-.67c-.34-.33-.67-.66-1-1v-1h1l2 1h3c-.34.67-.67 1.34-1 2-.72.15-1.88-.49-2 1"
            style={{
              fill: "#ce6f38",
            }}
          />
          <path
            d="M142 86.05v2h-1l-1-1v-1z"
            style={{
              fill: "#953915",
            }}
          />
          <path
            d="m143 88.05 1 1c-.76-.15-1.92.5-2-1Z"
            className="templesOnly_svg__cls-1084"
          />
          <path
            d="m140 87.05 1 1v1h-1Z"
            className="templesOnly_svg__cls-1085"
          />
          <circle
            cx={142.54}
            cy={87.55}
            r={0.71}
            style={{
              fill: "#7a2604",
            }}
          />
          <path
            d="m141 250.05-2 2-1-1v-2h1c1.49-.08.84-1.24 1-2l3 3Z"
            style={{
              fill: "#d98e4b",
            }}
          />
          <path
            d="M140 247.05c-.16.76.49 1.92-1 2l-1-1c.15-.75-.5-1.91 1-2h1Z"
            style={{
              fill: "#b3691e",
            }}
          />
          <ellipse
            cx={139.54}
            cy={245.05}
            rx={0.71}
            ry={1.41}
            style={{
              fill: "#e0934c",
            }}
          />
          <path
            d="m138 251.05 1 1 1 1v1l-3 1 .87-1.6-.87-.4v-2Z"
            className="templesOnly_svg__cls-1090"
          />
          <path
            d="M141 250.05h2c-.09 1.5-1.25.85-2 1Z"
            className="templesOnly_svg__cls-970"
          />
          <path
            d="m137 255.05 3-1h2l1 1v1h-2a17.7 17.7 0 0 1-2.82 0c-.4-.11-.75-.66-1.18-1"
            style={{
              fill: "#b58049",
            }}
          />
          <path
            d="M140 174.05v20c-.34.42-.95.83-1 1.25-.08 3.59 0 7.17 0 10.75-.34.27-1 .53-1 .79q-.09 8.72 0 17.43c0 .26.62.52 1 .78v5a7.94 7.94 0 0 1-2 6 13.05 13.05 0 0 1-2-7.61c.14-7.28 0-14.56.06-21.84 0-1.12-.19-2.51.37-3.3a5.39 5.39 0 0 0 .46-5.16c-1.3-3-.54-6.08-.84-9.09l1.78-2.49c-.32-2.88-.4-4.93-.83-6.9s1.19-3.65 1-5.56c-.44-5 1-10.09-.92-15-.23-.56.44-1.44.58-2.19.18-.93.24-1.89.36-2.84h1.83c.06 1.41.15 2.84.16 4.27v14c.04.66-.35 1.66.99 1.71"
            style={{
              fill: "#ce8e4e",
            }}
          />
          <path
            d="M139 206.05V195.3c0-.42.62-.83 1-1.25v6l1 1v2l-1 .76c.33.41.66.83 1 1.24v1c-.34.67-.67 1.34-1 2-1.46-.05-.81-1.24-1-2"
            className="templesOnly_svg__cls-1041"
          />
          <path d="m141 201.05-1-1Z" className="templesOnly_svg__cls-1037" />
          <path
            d="M140 194.05v-1l.82.67Z"
            className="templesOnly_svg__cls-1041"
          />
          <path
            d="M140 208.05c.33-.66.66-1.33 1-2l.82-.33-.82-.67v-1c1.49-.08.84-1.24 1-2l1 1v3l-.88 1.61.88.39v5c-.34 1-.67 2-1 3v4h-1v-1c-.62-1.7-1.23-3.4-2-5.47 2.18-1.25.61-3.58 1-5.53"
            style={{
              fill: "#a95b20",
            }}
          />
          <path
            d="M142 216.05c.33-1 .66-2 1-3 .33.4.91.78 1 1.2a37 37 0 0 1 0 3.8v1l1 1v2h-1l-2-1v-3l1-.75Z"
            style={{
              fill: "#ac571d",
            }}
          />
          <path
            d="M143 206.05v-3c1.49.09.84 1.25 1 2v1Z"
            style={{
              fill: "#c66832",
            }}
          />
          <path
            d="M143 206.05h1v2h-1l-.88-.39Z"
            className="templesOnly_svg__cls-1037"
          />
          <path
            d="M143 208.05h1c-.39 1 .92 2.54-1 3Z"
            style={{
              fill: "#b2581f",
            }}
          />
          <path
            d="M142 202.05c-.16.76.49 1.92-1 2v-2Z"
            style={{
              fill: "#9d4e18",
            }}
          />
          <path
            d="M142 149.05c-1.5-.08-.85-1.24-1-2h1ZM142 142.05v1l-.52 1.11c-.61-1.1-.83-1.87.52-2.11"
            className="templesOnly_svg__cls-1098"
          />
          <path
            d="M142 147.05h-1l.67-.83Z"
            style={{
              fill: "#a65219",
            }}
          />
          <path
            d="M135 189.05c.3 3-.46 6 .84 9.09a5.39 5.39 0 0 1-.46 5.16c-.56.79-.37 2.18-.37 3.3 0 7.28.08 14.56-.06 21.84a13.05 13.05 0 0 0 2 7.61l.81 4.36-.81 2.64-1 1-1 1v3l-1 1c-2.19-1-.94-2.89-.94-4.28Q133 167.91 133 91.05h3v1c-.39 2.82.87 5.82-.83 8.58l.83 1.42c-.34 1-.72 2-1 3.08-.75 2.8 1.19 5.29 1 8-.31 4.17-.63 8.35-1 12.52-.19 2 .69 4.22-.94 6.1a2 2 0 0 0 .12 1.86c1.6 2.26.63 4.71.64 7.07 0 .35-.64.82-.55 1 1.66 3.63.42 7.43.68 11.14a9.1 9.1 0 0 1-.76 3.11 11.5 11.5 0 0 1 .78 3c-.28 4.84.29 9.65-.76 14.56-.92 4.28-.24 8.91-.15 13.39.03.8.64 1.48.94 2.17"
            style={{
              fill: "#ecc59c",
            }}
          />
          <path
            d="M135 189.05c-.34-.69-.95-1.37-1-2.07-.09-4.48-.77-9.11.15-13.39 1.05-4.91.48-9.72.76-14.56a11.5 11.5 0 0 0-.78-3 9.1 9.1 0 0 0 .76-3.11c-.26-3.71 1-7.51-.68-11.14-.09-.22.56-.69.55-1 0-2.36 1-4.81-.64-7.07a2 2 0 0 1-.12-1.86c1.63-1.88.75-4.06.94-6.1.38-4.17.7-8.35 1-12.52.2-2.75-1.74-5.24-1-8 .28-1 .66-2 1-3.08 1.36 0 1 1.06 1 1.78 0 5.8-.06 11.61 0 17.41.05 2.19-.8 4.55 1 6.56.7.81-1.44 1.18-.47 2.36.67.81-1.26 1.79 0 3.18.78.83.38 2.77.44 4.22s0 2.65 0 4V150a5.63 5.63 0 0 1-1 4.06c-.12.95-.18 1.91-.36 2.84-.14.75-.81 1.63-.58 2.19 2 4.93.48 10 .92 15 .16 1.91-1.48 3.49-1 5.56s.51 4 .83 6.9Z"
            style={{
              fill: "#e6b57c",
            }}
          />
          <path
            d="M142 120.05q-2.055-1.5 0-3Z"
            className="templesOnly_svg__cls-999"
          />
          <path
            d="m136 80.05 3 3c-.47 1.93-2 .62-3 1-.34-1-.67-2-1-3v-1Z"
            className="templesOnly_svg__cls-1102"
          />
          <path
            d="M136 84.05c1-.38 2.53.93 3-1h1v2l-1 1v1h-1c-.12-.63-.23-1.27-.43-2.43l-.57 1.43h-1Z"
            style={{
              fill: "#c0602b",
            }}
          />
          <path
            d="M140 85.05v-3l2 1c.33 1 .66 2 1 3h-2Z"
            style={{
              fill: "#882e12",
            }}
          />
          <path
            d="m140 82.05-.83-.67.83-.33Z"
            style={{
              fill: "#620e00",
            }}
          />
          <path
            d="M140 79.05v1c-.34-.33-.67-.66-1-1Z"
            style={{
              fill: "#993d1c",
            }}
          />
          <path
            d="M140 82.05v-1l2-1v1c.33.34.66.67 1 1v1h-1Z"
            style={{
              fill: "#7c2103",
            }}
          />
          <circle
            cx={142.54}
            cy={80.55}
            r={0.71}
            style={{
              fill: "#7d2100",
            }}
          />
          <path d="M145 83.05h-1l1-1Z" className="templesOnly_svg__cls-1057" />
          <path
            d="M142 81.05h1v1c-.3-.33-.63-.66-1-1"
            style={{
              fill: "#892e09",
            }}
          />
          <path
            d="m137 243.05.81-2.64-.81-4.36a7.94 7.94 0 0 0 2-6c.33.4.88.75 1 1.19a17.5 17.5 0 0 1 0 2.81v1a4.76 4.76 0 0 0 0 6l-1 1Z"
            className="templesOnly_svg__cls-1110"
          />
          <path
            d="M145 240.05v2h-4v-2l2.13-1.55-1.13-.45 1-1h1v1c.19.76-.46 1.95 1 2"
            style={{
              fill: "#af5b22",
            }}
          />
          <path
            d="M140 241.05a4.76 4.76 0 0 1 0-6z"
            className="templesOnly_svg__cls-1112"
          />
          <path
            d="m143 237.05-1 1h-1v-2l2-1Z"
            className="templesOnly_svg__cls-1113"
          />
          <path
            d="M141 238.05h1l1.13.45-2.13 1.55Z"
            style={{
              fill: "#a6521c",
            }}
          />
          <path
            d="m137 243.05 2-1v2h-2Z"
            className="templesOnly_svg__cls-1112"
          />
          <path d="M140 236.05v-2h1v2Z" className="templesOnly_svg__cls-1113" />
          <path
            d="M139 244.05v-1l1 1Z"
            style={{
              fill: "#a55911",
            }}
          />
          <path
            d="M144 242.05h1v1Z"
            style={{
              fill: "#bd6928",
            }}
          />
          <path
            d="M147 237.05c-.16.76.49 1.92-1 2h-1v-1Z"
            style={{
              fill: "#ca682a",
            }}
          />
          <path
            d="M145 238.05v2c-1.5-.08-.85-1.24-1-2Z"
            style={{
              fill: "#bd6425",
            }}
          />
          <path
            d="m147 237.05-2 1v-5h1c.15.76-.5 1.92 1 2Z"
            style={{
              fill: "#c36225",
            }}
          />
          <path
            d="M146 225.05v2h-1c-.09-1.49-1.25-.85-2-1v-2l1-1h1c.19.76-.46 1.95 1 2"
            style={{
              fill: "#c16427",
            }}
          />
          <path
            d="M147 229.05v1h-3c.38-1-.93-2.53 1-3v2Z"
            className="templesOnly_svg__cls-1121"
          />
          <path
            d="M147 229.05h-2v-2h1c1.53.09.88 1.25 1 2"
            style={{
              fill: "#cb6a2d",
            }}
          />
          <path
            d="M146 225.05c-1.5-.08-.85-1.24-1-2h1Z"
            style={{
              fill: "#cb692c",
            }}
          />
          <path
            d="M145 222.05v-2l1 1v1Z"
            className="templesOnly_svg__cls-1121"
          />
          <circle
            cx={145.54}
            cy={222.55}
            r={0.71}
            className="templesOnly_svg__cls-1072"
          />
          <path
            d="M144 230.05h3c-.34 1-.67 2-1 3h-1c-.16-.75.49-1.91-1-2Z"
            style={{
              fill: "#bd5d1f",
            }}
          />
          <path d="m145 220.05-1-1Z" className="templesOnly_svg__cls-1121" />
          <path
            d="M144 259.05h1v3h-2v-2Z"
            style={{
              fill: "#d4a164",
            }}
          />
          <path
            d="M143 262.05h2v1c-1.93.47-.62 2-1 3h-1Z"
            style={{
              fill: "#d39e5e",
            }}
          />
          <path
            d="M144 266.05c.38-1-.93-2.53 1-3 .38 1-.93 2.54 1 3-.09 1.5-1.25.85-2 1Z"
            className="templesOnly_svg__cls-1127"
          />
          <path
            d="M144 269.05v1a17.7 17.7 0 0 0-2.82.05c-.44.07-.79.62-1.18.95h-1v-2h2l2-1Z"
            style={{
              fill: "#dba968",
            }}
          />
          <path
            d="m144 269.05-1-1h1Z"
            style={{
              fill: "#ebb578",
            }}
          />
          <path
            d="m143 268.05-2 1v-3h2z"
            className="templesOnly_svg__cls-1127"
          />
          <circle
            cx={143.54}
            cy={266.55}
            r={0.71}
            className="templesOnly_svg__cls-1074"
          />
          <path
            d="M143 260.05v2h-3l.62-3.88c-.71-1.52-2.25-1.08-3.62-1.12h-1v-2h1c.39.34.74.89 1.18 1a17.7 17.7 0 0 0 2.82 0l1 1c.37 1 .7 2 1 3"
            style={{
              fill: "#dba564",
            }}
          />
          <path
            d="M143 260.05c-.34-1-.67-2-1-3h2v2ZM143 256.05v-1h2c0 1.5-1.21.85-2 1"
            className="templesOnly_svg__cls-1131"
          />
          <path
            d="M138 87.05h1c-.34.67-.67 1.34-1 2l-2-1 1-1Z"
            style={{
              fill: "#a54a07",
            }}
          />
          <path
            d="m137 87.05-1 1h-1l-1-2h3Z"
            style={{
              fill: "#a5500a",
            }}
          />
          <path
            d="M138 89.05c.33-.66.66-1.33 1-2h1v2Z"
            style={{
              fill: "#be5f25",
            }}
          />
          <path
            d="M135 88.05v1l-2 1v-2Z"
            className="templesOnly_svg__cls-1135"
          />
          <path
            d="m136 90.05.82.67-.82.33Z"
            style={{
              fill: "#dd9854",
            }}
          />
          <path
            d="M135 89.05c.33.34.66.67 1 1-.3-.33-.63-.66-1-1"
            className="templesOnly_svg__cls-1135"
          />
          <path
            d="M140 85.05c.33.34.66.67 1 1h-2Z"
            style={{
              fill: "#8e2c03",
            }}
          />
          <circle
            cx={139.54}
            cy={86.55}
            r={0.71}
            className="templesOnly_svg__cls-1085"
          />
          <path
            d="m138 248.05 1 1h-3l-1-1z"
            style={{
              fill: "#d6914a",
            }}
          />
          <path
            d="M136 249.05h2v2h-2z"
            style={{
              fill: "#f1b372",
            }}
          />
          <path
            d="M138 248.05h-1v-4h2v2c-1.46.09-.81 1.25-1 2"
            style={{
              fill: "#c9843d",
            }}
          />
          <path
            d="M137 255.05h-2c.15-.75-.5-1.91 1-2h1l.87.4Z"
            style={{
              fill: "#f1b77a",
            }}
          />
          <ellipse
            cx={136.54}
            cy={252.05}
            rx={0.71}
            ry={1.41}
            style={{
              fill: "#e4ab71",
            }}
          />
          <path
            d="M140 208.05c-.43 2 1.14 4.28-1 5.53.74 2.07 1.35 3.77 2 5.47-.34.41-.93.79-1 1.22-.11 1.59 0 3.19 0 4.78h-1c-.34-.26-1-.52-1-.78q-.09-8.72 0-17.43c0-.26.62-.52 1-.79.19.76-.46 1.95 1 2"
            className="templesOnly_svg__cls-1110"
          />
          <path
            d="M139 225.05h1l1 1c0 1.73-.32 3.53 1 5l-1 1v2h-1a17.5 17.5 0 0 0 0-2.81c-.07-.44-.62-.79-1-1.19Z"
            style={{
              fill: "#b96e2e",
            }}
          />
          <path
            d="M141 203.05v2c-.34-.41-.67-.83-1-1.24ZM141 205.05l.82.67-.82.33Z"
            className="templesOnly_svg__cls-1037"
          />
          <path
            d="m141 226.05-1-1c0-1.59-.07-3.19 0-4.78 0-.43.62-.81 1-1.22v1c.38 1-.93 2.54 1 3v2Z"
            className="templesOnly_svg__cls-1144"
          />
          <path
            d="M142 223.05c-1.93-.46-.62-2-1-3h1z"
            style={{
              fill: "#a4561d",
            }}
          />
          <path
            d="m142 216.05 1 1.25-1 .75Z"
            style={{
              fill: "#9f4e16",
            }}
          />
          <path
            d="M142 223.05v-2l2 1v1l-1 1Z"
            className="templesOnly_svg__cls-1144"
          />
          <circle
            cx={144.54}
            cy={222.55}
            r={0.71}
            className="templesOnly_svg__cls-1121"
          />
          <path
            d="M137 244.05v4h-2v-3l1-1 1-1Z"
            className="templesOnly_svg__cls-1147"
          />
          <path
            d="M133 91.05v-1l2-1c.33.34.66.67 1 1v1Z"
            style={{
              fill: "#eac194",
            }}
          />
          <path
            d="M134 250.05v-1l1-1 1 1v1Z"
            className="templesOnly_svg__cls-1147"
          />
          <path
            d="m136 244.05-1 1Z"
            style={{
              fill: "#f0bf8a",
            }}
          />
          <path
            d="M132 86.05c-.34-.33-.67-.66-1-1l.82-.33-.82-.67v-1c1-.38 2.53.93 3-1v-1h1c.33 1 .66 2 1 3v2h-2l1 2h-2v-1Z"
            style={{
              fill: "#ce7a33",
            }}
          />
          <path
            d="M137 87.05v-1l.57-1.43c.2 1.16.31 1.8.43 2.43Z"
            style={{
              fill: "#f79555",
            }}
          />
          <path
            d="M145 235.05v1l-1 1h-1v-3Z"
            style={{
              fill: "#ba632a",
            }}
          />
          <path
            d="m144 237.05 1-1v2h-1Z"
            style={{
              fill: "#b55c1e",
            }}
          />
          <path
            d="M143 234.05v1l-2 1v-4l1-1c-1.32-1.47-1-3.27-1-5l1-1 1 1z"
            style={{
              fill: "#ab5b23",
            }}
          />
          <path
            d="M143 234.05v-3h1c1.49.09.84 1.25 1 2v2Z"
            style={{
              fill: "#b3591c",
            }}
          />
          <path
            d="M144 231.05h-1v-5c.75.15 1.91-.49 2 1-1.93.47-.62 2-1 3Z"
            style={{
              fill: "#b65c20",
            }}
          />
          <path
            d="m143 226.05-1-1v-2l1 1Z"
            style={{
              fill: "#a7561e",
            }}
          />
          <path
            d="M142 262.05h1v4h-2l-1-1v-1h2Z"
            style={{
              fill: "#daa25f",
            }}
          />
          <path
            d="M139 270.05v1h-2v3h-2v-3c1.49-.08.84-1.24 1-2Z"
            style={{
              fill: "#e4b072",
            }}
          />
          <path
            d="m139 270.05-3-1c.09-1 .18-2 .28-3l1.26.08c1.23.63-.6 2.74 1.46 2.94Z"
            style={{
              fill: "#fee0a3",
            }}
          />
          <path
            d="M141 268.05v1h-2v-1z"
            style={{
              fill: "#b88648",
            }}
          />
          <path
            d="M140 268.05h-1c.33-1 .66-2 1-3l1 1v1Z"
            className="templesOnly_svg__cls-1162"
          />
          <path
            d="m140 268.05 1-1v1Z"
            style={{
              fill: "#d5a263",
            }}
          />
          <path
            d="M137 257.05c1.37 0 2.91-.4 3.62 1.12l-.62 3.88v1l-1 1h-1v-1l-1-1-1-1h-1v-1a2.47 2.47 0 0 0 2-3"
            className="templesOnly_svg__cls-1090"
          />
          <path
            d="M137 257.05a2.47 2.47 0 0 1-2 3c-.62-.06-1.16-.05-.6-1a7.8 7.8 0 0 0 .6-2z"
            style={{
              fill: "#f4bc80",
            }}
          />
          <path
            d="M140 263.05v-1h2v2h-2Z"
            style={{
              fill: "#d99e5b",
            }}
          />
          <ellipse
            cx={135.54}
            cy={256.05}
            className="templesOnly_svg__cls-1090"
            rx={0.71}
            ry={1.41}
          />
          <path
            d="M134 250.05h2v3c-1.5.09-.85 1.25-1 2l-2 2h-1l-1-1v-2l2-1h-4c.25-.33.49-.93.77-1 1.29-.1 2.59 0 4.23 0Z"
            style={{
              fill: "#e5b989",
            }}
          />
          <path d="m142 231.05-1 1Z" className="templesOnly_svg__cls-1113" />
          <path
            d="M124 255.05c.79-2.84 3.14-1.79 5-2v1c.15.76-.5 1.92 1 2v1h-2c-.39-1 .92-2.53-1-3l-2 1Z"
            style={{
              fill: "#be9b70",
            }}
          />
          <path
            d="M121 260.05v-1c1.89-.23.52-1.89 1.44-3H124v1c-1.5.09-.85 1.25-1 2v1Z"
            className="templesOnly_svg__cls-1168"
          />
          <circle
            cx={124.54}
            cy={255.55}
            r={0.71}
            className="templesOnly_svg__cls-1168"
          />
          <path
            d="M132 86.05c.33.34.66.67 1 1-.3-.33-.63-.66-1-1"
            style={{
              fill: "#da844c",
            }}
          />
          <path
            d="M138 264.05h2v1c-.34 1-.67 2-1 3v1c-2.06-.2-.23-2.31-1.46-2.94l-1.26-.08c-.1 1-.19 2-.28 3-.16.76.49 1.92-1 2h-2v-3h2c0-1.63-.06-2.93 0-4.22 0-.28.62-.52 1-.78v1l1 1Z"
            className="templesOnly_svg__cls-873"
          />
          <ellipse
            cx={134.04}
            cy={271.55}
            rx={1.41}
            ry={0.71}
            style={{
              fill: "#d9965d",
            }}
          />
          <path
            d="m133 257.05 2-2v2a7.8 7.8 0 0 1-.6 2c-.56.91 0 .9.6 1v1l-2 1h-1v-1l-1-1v-1l1-1 2.43-.42c-.84-.35-1.12-.46-1.43-.58"
            style={{
              fill: "#e6b176",
            }}
          />
          <path
            d="m138 264.05-1 1-1-1v-1h2ZM140 264.05h-1l1-1Z"
            className="templesOnly_svg__cls-1162"
          />
          <path
            d="M138 263.05h-1v-1Z"
            style={{
              fill: "#f0b574",
            }}
          />
          <path
            d="m136 261.05 1 1h-1Z"
            style={{
              fill: "#b07737",
            }}
          />
          <path
            d="M136 261.05v1l-1-1Z"
            style={{
              fill: "#a67030",
            }}
          />
          <path
            d="M129 254.05v-1h4l-2 1Z"
            style={{
              fill: "#a48561",
            }}
          />
          <path
            d="M129 254.05h2v1l-1 1c-1.46-.05-.81-1.24-1-2"
            style={{
              fill: "#a4784c",
            }}
          />
          <path
            d="M130 257.05v-1h1l1 1v1h-2Z"
            className="templesOnly_svg__cls-1177"
          />
          <path
            d="M132 258.05v-1h1c.27.12.55.23 1.43.58Z"
            className="templesOnly_svg__cls-1178"
          />
          <path
            d="M131 256.05h-1l1-1Z"
            style={{
              fill: "#a27343",
            }}
          />
          <path
            d="M130 257.05v1l-2 .26 1 1.74h-2v-3z"
            style={{
              fill: "#ccab7e",
            }}
          />
          <path
            d="M125 256.05v-1l2-1v3h-2Z"
            style={{
              fill: "#bb9362",
            }}
          />
          <path
            d="M127 257.05v-3c1.92.47.61 2 1 3Z"
            style={{
              fill: "#ac8c5f",
            }}
          />
          <path
            d="M122 262.05h2v1l-1 1v1l-1-1Z"
            style={{
              fill: "#985b2b",
            }}
          />
          <path
            d="M121 260.05h2v1c-.72-.15-1.88.5-2-1"
            className="templesOnly_svg__cls-1184"
          />
          <path
            d="M122 262.05v2h-1v-1Z"
            style={{
              fill: "#ae6b38",
            }}
          />
          <circle
            cx={123.54}
            cy={261.55}
            r={0.71}
            className="templesOnly_svg__cls-1184"
          />
          <path
            d="M125 256.05v3h-1v-3Z"
            style={{
              fill: "#cc9b5d",
            }}
          />
          <path
            d="M124 259.05h2v1h-3v-1Z"
            style={{
              fill: "#c0915e",
            }}
          />
          <path
            d="M124 259.05h-1c.15-.75-.5-1.91 1-2Z"
            style={{
              fill: "#c49860",
            }}
          />
          <path
            d="m135 261.05 1 1h1v1h-1c-.34.26-.94.5-1 .78-.1 1.29 0 2.59 0 4.22h-2v-3h-2l-1-1h-1l1-2h1l2 2.75v-2.75Z"
            style={{
              fill: "#d49b5b",
            }}
          />
          <path
            d="M133 270.05v1l-2 1-1-1c.33-1 .66-2 1-3h1c.19.76-.46 1.95 1 2"
            style={{
              fill: "#c27a3b",
            }}
          />
          <path
            d="m136 264.05 1 1Z"
            style={{
              fill: "#e0a361",
            }}
          />
          <path
            d="m131 272.05 2-1v3h-1l-1-1h-1v-1Z"
            style={{
              fill: "#de985f",
            }}
          />
          <path
            d="M131 262.05h-1l-1-1v-1c1.49-.08.84-1.24 1-2h1v2l1 1v1Z"
            style={{
              fill: "#c6955d",
            }}
          />
          <path d="M131 259.05v-1h1Z" className="templesOnly_svg__cls-1178" />
          <path
            d="m132 261.05-1-1Z"
            style={{
              fill: "#eab77f",
            }}
          />
          <path
            d="M126 260.05v-3h1v4Z"
            style={{
              fill: "#d4a77b",
            }}
          />
          <path
            d="M130 258.05c-.16.76.49 1.92-1 2l-1-1.74Z"
            className="templesOnly_svg__cls-1177"
          />
          <path
            d="M127 261.05v-1h2v1l-1 1Z"
            style={{
              fill: "#ca9e6e",
            }}
          />
          <ellipse
            cx={125.54}
            cy={258.05}
            rx={0.71}
            ry={1.41}
            style={{
              fill: "#cb9a69",
            }}
          />
          <path
            d="m123 265.05-2 2v-3h1Z"
            style={{
              fill: "#ad6031",
            }}
          />
          <path
            d="M124 262.05v-1l2 2v1h-1l-1-1Z"
            style={{
              fill: "#dea773",
            }}
          />
          <path
            d="M124 264.05h-1l1-1Z"
            style={{
              fill: "#854d20",
            }}
          />
          <path
            d="m126 263.05-2-2h-1v-1h3l1 1 1 1-1 1Z"
            style={{
              fill: "#d29e6c",
            }}
          />
          <path
            d="m128 262.05 1-1 1 1-1 2h-2v-1Z"
            style={{
              fill: "#b78349",
            }}
          />
          <path
            d="M128 264.05h2v1l-1 1h-1Z"
            style={{
              fill: "#be8c53",
            }}
          />
          <path
            d="M130 265.05v-1l1 1Z"
            style={{
              fill: "#ae7c43",
            }}
          />
          <path
            d="M131 268.05c-.34 1-.67 2-1 3h-1l-1.86-1.5.86-1.5z"
            className="templesOnly_svg__cls-872"
          />
          <path
            d="M129 271.05h1l1 1h-2Z"
            style={{
              fill: "#ad6325",
            }}
          />
          <path
            d="M132 267.05v1h-1Z"
            style={{
              fill: "#c07f35",
            }}
          />
          <path
            d="M124 267.05c.15-.75-.5-1.91 1-2v3Z"
            style={{
              fill: "#874e1d",
            }}
          />
          <path
            d="m124 267.05 1 1v1h-2v-1Z"
            style={{
              fill: "#884b25",
            }}
          />
          <path
            d="M123 268.05v2h-1l-1-1v-1Z"
            style={{
              fill: "#8d5b3b",
            }}
          />
          <path
            d="M125 266.05v-2h1v2Z"
            style={{
              fill: "#cb9857",
            }}
          />
          <path d="M124 264.05v-1l1 1Z" className="templesOnly_svg__cls-1211" />
          <circle
            cx={126.54}
            cy={263.55}
            r={0.71}
            className="templesOnly_svg__cls-1211"
          />
          <path d="m128 262.05-1 1Z" className="templesOnly_svg__cls-1211" />
          <ellipse
            cx={127.54}
            cy={265.05}
            rx={0.71}
            ry={1.41}
            style={{
              fill: "#cf9b5b",
            }}
          />
          <ellipse
            cx={128.54}
            cy={267.05}
            rx={0.71}
            ry={1.41}
            style={{
              fill: "#966729",
            }}
          />
          <path
            d="m129 266.05 1-1Z"
            style={{
              fill: "#b2834e",
            }}
          />
          <path
            d="m129 266.05 1-1h1c.33.67.66 1.34 1 2l-1 1h-2Z"
            style={{
              fill: "#c99353",
            }}
          />
          <path
            d="M128 266.05v2l-.86 1.5 1.86 1.5h-3c-1.5-.08-.85-1.24-1-2v-3h1l.33 1.9.67-.06v-1.84Z"
            style={{
              fill: "#b97946",
            }}
          />
          <path
            d="M126 271.05h3v1c-.76.15-1.92-.49-2 1h-1z"
            style={{
              fill: "#a15e29",
            }}
          />
          <path
            d="M126 271.05v1h-4l-1-1v-1h1a8 8 0 0 0 1-.05l-.15.14.7.82.31-.31a5 5 0 0 0-.86-.65 7 7 0 0 1 0-.95h2c.19.76-.46 1.95 1 2"
            style={{
              fill: "#652d08",
            }}
          />
          <path
            d="M122 270.05h-1v-1Z"
            style={{
              fill: "#d3ac7e",
            }}
          />
          <ellipse
            cx={126.54}
            cy={265.05}
            rx={0.71}
            ry={1.41}
            style={{
              fill: "#dca965",
            }}
          />
          <path
            d="M126 266.05h1v1.84l-.67.06Z"
            style={{
              fill: "#e1ad71",
            }}
          />
          <path
            d="m123.13 270 .81.7-.31.31-.7-.82Z"
            style={{
              fill: "#4b1a00",
            }}
          />
          <path
            d="m119 257.05 2 2v1c.08 1.5 1.24.85 2 1v1h-1l-1 1h-1v-3l-1-1z"
            style={{
              fill: "#a7682f",
            }}
          />
          <path
            d="M120 263.05h1v4h-2l-1-1c.25-.33.51-.95.76-.95 1.72.02 1.24-1.18 1.24-2.05"
            style={{
              fill: "#a65124",
            }}
          />
          <path
            d="M123 265.05v-1h2v1c-1.5.09-.85 1.25-1 2l-1 1h-4v-1h2Z"
            style={{
              fill: "#915327",
            }}
          />
          <path
            d="M119 269.05v-1h2v3l-2 1h7v1h-8l1-2z"
            style={{
              fill: "#89502c",
            }}
          />
          <path
            d="m121 271.05 1 1h-3Z"
            style={{
              fill: "#411b01",
            }}
          />
        </g>
        <g id="templesOnly_svg__column4" ref={el => columnRefs.current[3] = el}>
          <path
            d="M98 267.07v1h-3v-2h1l1 1Z"
            style={{
              fill: "#ddad6b",
            }}
          />
          <path
            d="M96 265.07h2l-1 1h-1Z"
            style={{
              fill: "#e2a769",
            }}
          />
          <path
            d="M117 211.07c.33.52.94 1 1 1.57.13 5.51 2.11 11 1 16.47-1.77 8.32-.4 16.65-.91 25l-2-1h-2v-1h1q2.055-1.5 0-3v-2c.33-.4.91-.77 1-1.2a37 37 0 0 0 0-3.8v-5c.3-3-.42-6 .85-9a6 6 0 0 0-.85-6v-11Z"
            className="templesOnly_svg__cls-1230"
          />
          <path
            d="M117 104.07c1.67.17 1 1.48 1 2.28v60.72h-1v-4l-1-1a9 9 0 0 0 .62-1.14c.43-1.08 1.15-2.25-.62-2.86v-3l1-.76c-.34-.41-.67-.83-1-1.24v-3c.33-.26 1-.52 1-.79q.08-9.21 0-18.42c0-.27-.63-.53-1-.79v-12l.83-.33-.83-.67v-2l.83-.33-.83-.67v-2l-1-1v-2h2Z"
            className="templesOnly_svg__cls-1231"
          />
          <path
            d="M117 211.07h-1v-5c0-1.82.13-3.65 0-5.46s-.63-3.69-1-5.54l-1-1v-1l2-1a10.25 10.25 0 0 0 .91 5.06c.79 1.47-.07 3.32.61 5.16a10.43 10.43 0 0 1-.52 8.78"
            style={{
              fill: "#d47332",
            }}
          />
          <path
            d="m116 88.07 1-1h1v5h-1c-.47-1.93-2-.62-3-1h-4v-1l1-1h1l1-1z"
            style={{
              fill: "#772e17",
            }}
          />
          <path
            d="M118 173.07v5.8a4.41 4.41 0 0 1-2 4.2v-7a17.7 17.7 0 0 1 0-2.82c.07-.43.62-.79 1-1.18.36.33.69.67 1 1"
            className="templesOnly_svg__cls-1234"
          />
          <path
            d="M117 92.07h1l1.09.57c-.67 2.27-2.57 4-2.09 6.43h-1v-2c-.09-.66-.18-1.32-.26-2l-1.74 1c.44-1.36.89-2.72 1.31-4Z"
            className="templesOnly_svg__cls-1235"
          />
          <path
            d="m116 192.07-2 1c-.34-2.33-.67-4.67-1-7v-1h1l2 3Z"
            className="templesOnly_svg__cls-1236"
          />
          <path
            d="M116 99.07h1c.23.84.46 1.68.73 2.71-.13.25-.43.77-.73 1.29h-2a5.35 5.35 0 0 0-4-1h-2v-1c.76-.15 1.91.49 2-1a5.34 5.34 0 0 0 4 1c1.52-.07.88-1.24 1-2"
            style={{
              fill: "#802401",
            }}
          />
          <path d="M115 103.07h2v6h-2z" className="templesOnly_svg__cls-1238" />
          <path
            d="M118 169.07v3h-1a11 11 0 0 1-.63-1.14c-.42-1.08-1.15-2.25.63-2.86.36.33.69.67 1 1"
            className="templesOnly_svg__cls-1234"
          />
          <path
            d="m116 253.07 2 1c.33.67.66 1.33 1 2l-1 1h-1c-.15-.76.49-1.92-1-2Z"
            style={{
              fill: "#b2602d",
            }}
          />
          <path
            d="m116 188.07-2-3h2Z"
            style={{
              fill: "#9b572a",
            }}
          />
          <circle
            cx={115.03}
            cy={184.07}
            r={1.41}
            style={{
              fill: "#8b3802",
            }}
          />
          <path d="m118 257.07 1-1v1Z" className="templesOnly_svg__cls-1242" />
          <path
            d="M117 172.07h1v1c-.31-.33-.64-.67-1-1M118 169.07c-.34-.33-.67-.67-1-1h1Z"
            className="templesOnly_svg__cls-1231"
          />
          <circle
            cx={117.53}
            cy={167.57}
            r={0.71}
            className="templesOnly_svg__cls-1234"
          />
          <path
            d="M113 186.07c.33 2.33.66 4.67 1 7v2c-2.31-.61.07-3.07-.88-3.58l-2.12.9c0 1.51 1.2 2.13.23 3.38-.37.46.82 2.15 1.32 3.3H114l.93.46-.78 1c.32 1.63.52 3 .88 4.29.13.47.63.84 1 1.25v10c-.34-.33-.67-.67-1-1-.38-1 .92-2.53-1-3v-2c0-1.12.08-2.24 0-3.35-.23-2.65-1.37-3.93-4-4.65-.34-.33-.67-.67-1-1v-4l.66-1.15c-.53-3.5-1.73-6.54-1.66-9.85a9 9 0 0 0 1.14.62c1.08.43 2.25 1.15 2.86-.62Z"
            className="templesOnly_svg__cls-1243"
          />
          <path
            d="M116 222.07a6 6 0 0 1 .85 6c-1.27 3-.55 6-.85 9h-1c-.11-.64-.22-1.27-.43-2.44l-.57 1.44h-1v-2l1-1 1-1.69-3-2.31h-1v-2c.76-.15 1.91.49 2-1h2.74c-2.08-1.47-2.18-2.69-1.27-4Z"
            style={{
              fill: "#da6828",
            }}
          />
          <path
            d="M116 222.07h-1.5c-.91 1.31-.81 2.53 1.27 4H113l-1.08-2.07 1.07-1.57-2-1.31v-1h3.08c-.15-.91-.24-1.47-.39-2.32l-2.68 1.27-1-1v-1h1.08l2.92-3c.33.33.66.67 1 1s.66.67 1 1Z"
            className="templesOnly_svg__cls-1245"
          />
          <path
            d="M114 252.07v1h-1v-1c-.67-.67-1.34-1.33-2-2v-8c.33.42.89.81 1 1.27.18 1.24.15 2.5.21 3.73H114Z"
            className="templesOnly_svg__cls-1246"
          />
          <path
            d="M116 242.07a37 37 0 0 1 0 3.8c0 .43-.62.8-1 1.2v-1q-.51-3-1-6a9 9 0 0 1 1 .76c.39.38.69.82 1 1.24"
            className="templesOnly_svg__cls-1247"
          />
          <path
            d="M116 242.07c-.34-.42-.64-.86-1-1.24a9 9 0 0 0-1-.76c.33-1 .66-2 1-3h1Z"
            className="templesOnly_svg__cls-1248"
          />
          <path d="M114 252.07v-5h1v5Z" className="templesOnly_svg__cls-1247" />
          <path
            d="M115 252.07v-3c1.4 1 1.4 1.99 0 3"
            style={{
              fill: "#d56420",
            }}
          />
          <path
            d="M116 253.07v2h-2v-1l1-1Z"
            style={{
              fill: "#c6662d",
            }}
          />
          <path
            d="m115 253.07-1 1v-1Z"
            style={{
              fill: "#c45e23",
            }}
          />
          <path
            d="M116 152.07v1l-.83.33.83.67v1c-1.5.08-.85 1.24-1 2-.34.39-.89.75-1 1.18a17.7 17.7 0 0 0 0 2.82l-3-2-1-1 1.08-2-1.08-2v-2c.33-.26.94-.51 1-.78 0-1.41-.07-2.83-.13-4.22H109v-2c1.49-.09.85-1.24 1-2v-3l2 1h1v2a6.7 6.7 0 0 0-1.81 1.38c-.43.68-.42 1.56.81 1.62.21 2.24.76 2.79 3 3 .41.98-.9 2.53 1 3"
            style={{
              fill: "#c7571c",
            }}
          />
          <path
            d="M115 105.07v6c.33.33.66.67 1 1v2a6.4 6.4 0 0 0 0 7v2h-1l-2-1.57a8 8 0 0 0-.85-4.13c-.51-.84.45-2.57.84-4.33l-3-1c-.13-1.18.36-2.42-.84-3.46-.49-.42-.35-1.5.84-1.54h2v-2Zm-3.83 5.84.86-.1-.39-1.64-.47.08Z"
            style={{
              fill: "#b84611",
            }}
          />
          <path
            d="M115 123.07h1v18l-1.5.85-1.5-.85h-1v-3c.33-1.67.66-3.33 1-5v-1c2.08.19.16 2.42 1.81 3.09a18.8 18.8 0 0 0 0-6.09H113v-2h2.37c-.5-1.52-.86-2.59-1.17-3.68a7 7 0 0 1 .8-.32"
            style={{
              fill: "#c14a1a",
            }}
          />
          <path
            d="M116 141.07v-11c.33.26 1 .52 1 .79q.08 9.21 0 18.42c0 .27-.63.53-1 .79z"
            style={{
              fill: "#c1622e",
            }}
          />
          <path
            d="M117 167.07v1c-1.78.61-1 1.78-.63 2.86a11 11 0 0 0 .63 1.14c-.34.39-.89.75-1 1.18a17.7 17.7 0 0 0 0 2.82c-.28-.11-.78-.2-.79-.33a23.3 23.3 0 0 0-1.21-6.67c1.92-.47.62-2 1-3 .09-.65.19-1.31.28-2l1.72 2Z"
            style={{
              fill: "#b94f13",
            }}
          />
          <path
            d="m117 166.07-1.72-2c-.09.68-.19 1.34-.28 2h-1v-5a17.7 17.7 0 0 1 0-2.82c.07-.43.62-.79 1-1.18l1 1c-.2.7-.37 1.42-.61 2.1-.41 1.11-1.17 2.26.61 2.9h1Z"
            style={{
              fill: "#bf521b",
            }}
          />
          <path
            d="M116 121.07a6.4 6.4 0 0 1 0-7z"
            style={{
              fill: "#bf4e12",
            }}
          />
          <path
            d="M116 163.07c-1.78-.64-1-1.79-.61-2.9.24-.68.41-1.4.61-2.1 1.77.61 1 1.78.62 2.86a9 9 0 0 1-.62 1.14Z"
            className="templesOnly_svg__cls-1259"
          />
          <path
            d="M116 149.07v3c-1.93-.47-.62-2-1-3Z"
            style={{
              fill: "#c75a23",
            }}
          />
          <path
            d="m116 158.07-1-1c.15-.76-.5-1.92 1-2ZM116 155.07v-2c.33.41.66.83 1 1.24Z"
            className="templesOnly_svg__cls-1261"
          />
          <path d="M116 163.07v-1l1 1Z" className="templesOnly_svg__cls-1234" />
          <path
            d="M116 118.07v-1l.83.67ZM116 115.07v-1l.83.67ZM116 112.07c-.34-.33-.67-.67-1-1Z"
            className="templesOnly_svg__cls-1238"
          />
          <path
            d="M116 206.07c-.34-.41-.84-.78-1-1.25-.36-1.31-.56-2.66-.88-4.29l.78-1-.93-.46v-4h1c.33 1.85.79 3.68 1 5.54s.03 3.64.03 5.46"
            style={{
              fill: "#dc722c",
            }}
          />
          <path d="M115 195.07h-1v-1Z" className="templesOnly_svg__cls-1236" />
          <path
            d="M117 92.07h-1.69c-.42 1.28-.87 2.64-1.31 4h-2c-.34-.33-.67-.67-1-1l2-2c1.49-.09.85-1.24 1-2 1 .38 2.56-.93 3 1"
            style={{
              fill: "#5a1901",
            }}
          />
          <path
            d="M110 90.07v2h-3v-1l2-1Z"
            style={{
              fill: "#a54521",
            }}
          />
          <path
            d="M114 91.07c-.15.76.49 1.91-1 2v-2Z"
            className="templesOnly_svg__cls-1235"
          />
          <path
            d="M113 91.07v2h-1v-2Z"
            style={{
              fill: "#762e19",
            }}
          />
          <ellipse
            cx={111.03}
            cy={91.57}
            rx={1.41}
            ry={0.71}
            style={{
              fill: "#842f14",
            }}
          />
          <path
            d="M110 90.07h-1v-1h2Z"
            style={{
              fill: "#5e0700",
            }}
          />
          <path
            d="M114 169.07a23.3 23.3 0 0 1 1.21 6.67c0 .13.51.22.79.33v2h-2a17.7 17.7 0 0 0 0-2.82c-.07-.43-.62-.79-1-1.18v-4Z"
            className="templesOnly_svg__cls-1259"
          />
          <path
            d="M114 178.07h1c.38 1-.93 2.53 1 3v2h-2z"
            style={{
              fill: "#bb591c",
            }}
          />
          <path
            d="M116 181.07c-1.93-.47-.62-2-1-3h1Z"
            style={{
              fill: "#b95412",
            }}
          />
          <path
            d="M112 96.07h2l1.74-1c.08.64.17 1.3.26 2h-4Z"
            style={{
              fill: "#7a3113",
            }}
          />
          <ellipse
            cx={115.53}
            cy={98.07}
            rx={0.71}
            ry={1.41}
            style={{
              fill: "#742002",
            }}
          />
          <path
            d="M114 182.07v3h-1c-.34-.33-.67-.67-1-1l-1-2v3h-1c.38-1-.93-2.53 1-3z"
            style={{
              fill: "#cc6828",
            }}
          />
          <path
            d="M112 184.07c.33.33.66.67 1 1v1h-1Z"
            className="templesOnly_svg__cls-1273"
          />
          <path
            d="M115 101.07a5.34 5.34 0 0 1-4-1h-1v-2l2-1c.33.33.66.67 1 1a9 9 0 0 1 1 .76c.37.38.67.82 1 1.24Z"
            style={{
              fill: "#872c0e",
            }}
          />
          <path
            d="M115 105.07h-5c.33-1 .66-2 1-3a5.35 5.35 0 0 1 4 1Z"
            style={{
              fill: "#a33b14",
            }}
          />
          <path
            d="M111 102.07c-.34 1-.67 2-1 3h-1c-.34-.33-.67-.67-1-1-.09-1.5-1.24-.85-2-1v-2l3 1Z"
            style={{
              fill: "#ab4518",
            }}
          />
          <path
            d="m109 102.07-3-1c-.34-.67-.67-1.33-1-2h2l1 1c.33.33.66.67 1 1Z"
            style={{
              fill: "#8b3009",
            }}
          />
          <path
            d="M110 100.07h1c-.09 1.49-1.24.85-2 1Z"
            style={{
              fill: "#791f00",
            }}
          />
          <path
            d="M115 101.07v-2h1c-.12.76.52 1.93-1 2"
            style={{
              fill: "#721700",
            }}
          />
          <path
            d="M118 257.07h1v1l-3.38.28c.59 1.17 1 1.95 1.38 2.72v5c-.52-.6-1-1.2-1.56-1.82-.43.85-.94 1.83-1.44 2.82h-1c-.24-.86-.47-1.72-.69-2.5.22-.78.45-1.64.69-2.5l3 1.22c-.69-1.87-1.65-2.4-3-2.22v-1l2-.26-1-1.74 1-1z"
            style={{
              fill: "#aa5f27",
            }}
          />
          <path
            d="M117 261.07c-.4-.77-.79-1.55-1.38-2.72l3.38-.28v3Z"
            style={{
              fill: "#bf6629",
            }}
          />
          <path
            d="M117 263.07v-1h3v1Z"
            style={{
              fill: "#b76528",
            }}
          />
          <circle
            cx={119.53}
            cy={261.57}
            r={0.71}
            style={{
              fill: "#be7433",
            }}
          />
          <circle
            cx={119.53}
            cy={260.57}
            r={0.71}
            className="templesOnly_svg__cls-1284"
          />
          <path d="M120 260.07h-1v-1Z" className="templesOnly_svg__cls-1242" />
          <path
            d="M117 257.07h-3v-1l1-1h1c1.52.08.88 1.24 1 2"
            style={{
              fill: "#c36b34",
            }}
          />
          <path
            d="M99 97.07c.33-.67.66-1.33 1-2h1l1 1v1l-.87.39.87 1.61h-3v-1l.83-.33Z"
            className="templesOnly_svg__cls-1286"
          />
          <path
            d="M103 90.07h1v2h-2v-2Z"
            style={{
              fill: "#832f03",
            }}
          />
          <path
            d="m99 97.07.83.67-.83.33h-1c-.34-.33-.67-.67-1-1z"
            className="templesOnly_svg__cls-1288"
          />
          <path
            d="M102 90.07v2h-1c.18-.76-.47-1.92 1-2M100 93.07v-1h1Z"
            className="templesOnly_svg__cls-1286"
          />
          <path
            d="M110 202.07c2.61.72 3.75 2 4 4.65.1 1.11 0 2.23 0 3.35l-1.58-.91c-.91 1.52-.25 3.92-2.42 4.91v-9.76c0-.42-.62-.83-1-1.24v-1Z"
            style={{
              fill: "#d56324",
            }}
          />
          <path
            d="M110 214.07c2.17-1 1.51-3.39 2.42-4.91l1.58.91v4l-2.92 3H110Z"
            className="templesOnly_svg__cls-1290"
          />
          <path
            d="M109 197.07v5h-2v-2c-.34-2.67-.67-5.33-1-8h1a5.93 5.93 0 0 1 1 3.82c.06.38.69.79 1 1.18"
            style={{
              fill: "#c57029",
            }}
          />
          <path
            d="M109 197.07c-.34-.39-1-.8-1-1.18a5.93 5.93 0 0 0-1-3.82l.83-.33-.83-.67v-2c.38-1-.93-2.53 1-3-.07 3.31 1.13 6.35 1.66 9.85Z"
            style={{
              fill: "#c76922",
            }}
          />
          <path
            d="M114 195.07v1l-1 .75 1 1.25v1h-1.45c-.5-1.15-1.69-2.84-1.32-3.3 1-1.25-.24-1.87-.23-3.38l2.12-.9c.98.51-1.4 2.97.88 3.58"
            style={{
              fill: "#d86226",
            }}
          />
          <path
            d="M111 182.07c-1.93.47-.62 2-1 3l1 1h1c-.61 1.77-1.78 1.05-2.86.62a9 9 0 0 1-1.14-.62l.73-2.72c-.13-.24-.43-.76-.73-1.28l1-1h2Z"
            style={{
              fill: "#cb6221",
            }}
          />
          <path
            d="M114 214.07v-2c1.92.47.62 2 1 3-.31-.33-.64-.67-1-1M109 202.07v-1c.33.33.66.67 1 1Z"
            className="templesOnly_svg__cls-1230"
          />
          <path
            d="M111 227.07v8c-.34-.43-.93-.84-1-1.28-.11-1.81 0-3.63-.09-5.44 0-.45-.62-.86-1-1.28v-5h2Z"
            style={{
              fill: "#d4702c",
            }}
          />
          <path
            d="M111 235.07v-6h1a37 37 0 0 0 0 3.8c.05.43.62.8 1 1.2v6l-2 1Z"
            style={{
              fill: "#d96f2c",
            }}
          />
          <path
            d="M113 234.07c-.34-.4-.91-.77-1-1.2a37 37 0 0 1 0-3.8l3 2.31-1 1.69Z"
            style={{
              fill: "#dd6c2b",
            }}
          />
          <path
            d="M111 227.07v-6l2 1.31-1.08 1.62 1.11 2.12c-.09 1.44-1.24.8-2.03.95"
            style={{
              fill: "#d96c2b",
            }}
          />
          <path
            d="M113 240.07v-4h1c.33.33.66.67 1 1-.34 1-.67 2-1 3Z"
            className="templesOnly_svg__cls-1247"
          />
          <path
            d="M115 237.07c-.34-.33-.67-.67-1-1l.57-1.44c.24 1.17.35 1.8.43 2.44"
            className="templesOnly_svg__cls-1248"
          />
          <path d="m113 234.07 1-1Z" className="templesOnly_svg__cls-1247" />
          <path
            d="M111 221.07v1h-3v-12c0-1.93-.06-3.86 0-5.78 0-.42.62-.81 1-1.22.33.41.94.82 1 1.24.08 3.25 0 6.51 0 9.76v3a8 8 0 0 0 0 1l-.14-.15-.82.7.32.32a6 6 0 0 0 .64-.87c.28.29.61.63 1 1z"
            className="templesOnly_svg__cls-1230"
          />
          <path
            d="M111 220.07v-1l2.69-1.32c.15.85.24 1.41.39 2.32Z"
            className="templesOnly_svg__cls-1290"
          />
          <path
            d="M111 245.07v8l-2 1a5.34 5.34 0 0 1-1-4c.28-.12.81-.23.81-.35q.07-4.16 0-8.3c0-.12-.53-.24-.81-.35v-2h1a6 6 0 0 1 1 4.33c0 .71-.24 1.67 1 1.67"
            className="templesOnly_svg__cls-1299"
          />
          <path
            d="M111 245.07c-1.27 0-1-1-1-1.67a6 6 0 0 0-1-4.33v-12c.33.42.93.83 1 1.28.11 1.81 0 3.63.09 5.44 0 .44.62.85 1 1.28v10Z"
            style={{
              fill: "#d0712c",
            }}
          />
          <path
            d="M111 242.07v-1l2-1h1l1 6-1 1h-1.8c-.06-1.23 0-2.49-.21-3.73-.07-.46-.63-.85-.99-1.27"
            style={{
              fill: "#df732d",
            }}
          />
          <path
            d="M114 253.07v2h-2v-2z"
            style={{
              fill: "#cc6b2d",
            }}
          />
          <path
            d="M111 252.07v-2c.66.67 1.33 1.33 2 2Z"
            style={{
              fill: "#db7834",
            }}
          />
          <path
            d="M111 252.07h2v1h-2Z"
            style={{
              fill: "#d2712e",
            }}
          />
          <path d="m114 247.07 1-1v1Z" className="templesOnly_svg__cls-1246" />
          <path
            d="M113 255.07h2l-1 1c-.31-.33-.64-.67-1-1"
            style={{
              fill: "#b95d24",
            }}
          />
          <path
            d="M116 149.07h-1c-2.24-.21-2.79-.76-3-3 1.92-.47.62-2 1-3v-2l1.5.85 1.5-.85v6l-1.91-.87v1.87H116Z"
            style={{
              fill: "#c34d1d",
            }}
          />
          <path
            d="m110 154.07 1.08 2-1.08 2-1 1h-1l-2-1a5.34 5.34 0 0 1 1-4Z"
            className="templesOnly_svg__cls-1261"
          />
          <path
            d="m109 159.07 1-1 1 1v9a4.8 4.8 0 0 1-1-1.27c-.22-.67.3-1.72-1-1.73Z"
            className="templesOnly_svg__cls-980"
          />
          <path
            d="M111 168.07v-9l3 2v4l-1.57-.71c-1.26 1.1.81 3.07-1.43 3.71"
            className="templesOnly_svg__cls-1307"
          />
          <path
            d="M109 145.07v4h-1v-9c1.92.47.62 2 1 3Z"
            style={{
              fill: "#c56026",
            }}
          />
          <path
            d="M108 149.07h1c1.92.47.62 2 1 3v1h-2Z"
            style={{
              fill: "#bd571f",
            }}
          />
          <path
            d="M110 152.07c-.38-1 .92-2.53-1-3v-2h1.82c.06 1.39.17 2.81.13 4.22.05.27-.59.52-.95.78"
            className="templesOnly_svg__cls-1261"
          />
          <path
            d="M112 138.07v3l-2-1c-.34-.67-.67-1.33-1-2l1.5-.86Z"
            style={{
              fill: "#c1521a",
            }}
          />
          <path
            d="M109 138.07c.33.67.66 1.33 1 2v3h-1c-.38-1 .92-2.53-1-3v-2Z"
            style={{
              fill: "#c25a1f",
            }}
          />
          <path
            d="M113 143.07c-.38 1 .92 2.53-1 3-1.23-.06-1.24-.94-.81-1.62a6.7 6.7 0 0 1 1.81-1.38"
            style={{
              fill: "#c14e17",
            }}
          />
          <path
            d="M108 153.07h2v1h-3v-1Z"
            style={{
              fill: "#b34c13",
            }}
          />
          <path
            d="M109 143.07h1c-.15.76.49 1.91-1 2Z"
            className="templesOnly_svg__cls-1261"
          />
          <path
            d="M116 153.07v1l-.83-.67Z"
            style={{
              fill: "#be4c13",
            }}
          />
          <path
            d="M115 123.07a7 7 0 0 0-.8.32c.31 1.09.67 2.16 1.17 3.68H113c-.15-.76.49-1.92-1-2h-1q-.51-3-1-6c.33-1 .66-2 1-3a5.34 5.34 0 0 0-1-4l3 1c-.39 1.76-1.35 3.49-.84 4.33a8 8 0 0 1 .85 4.13Z"
            className="templesOnly_svg__cls-1238"
          />
          <path
            d="M110 112.07a5.34 5.34 0 0 1 1 4 7.68 7.68 0 0 0-4-3v-3c.33-.4.91-.77 1-1.2a37 37 0 0 0 0-3.8h2v2c-1.19 0-1.33 1.12-.84 1.54 1.23 1.04.74 2.28.84 3.46"
            style={{
              fill: "#be4b19",
            }}
          />
          <path
            d="M110 107.07v-2h2v2ZM111.2 110.91v-1.66l.47-.08.39 1.64Z"
            className="templesOnly_svg__cls-1238"
          />
          <path
            d="m112 138.07-1.5-.86-1.5.86c-.34-.67-.67-1.33-1-2h2.29l-2.29-2.63v-3.37c.76-.15 1.91.49 2-1h2v1l-1 1v2h2c-.31 1.67-.64 3.33-1 5"
            style={{
              fill: "#c1501c",
            }}
          />
          <path
            d="M112 129.07h-2l-1.4-1.67 3.4-.64v-1.69c1.49.08.85 1.24 1 2v2Z"
            className="templesOnly_svg__cls-1317"
          />
          <path
            d="M113 129.07h1.77a18.8 18.8 0 0 1 0 6.09c-1.65-.67.27-2.9-1.81-3.09v-3Z"
            style={{
              fill: "#bf4517",
            }}
          />
          <path
            d="M113 130.07v3h-2v-2l1-1Z"
            className="templesOnly_svg__cls-1317"
          />
          <path
            d="M116 148.07h-1.91v-1.87l1.91.87Z"
            style={{
              fill: "#c04c17",
            }}
          />
          <path
            d="M114 166.07h1c-.38 1 .92 2.53-1 3Z"
            className="templesOnly_svg__cls-1259"
          />
          <path
            d="M114 166.07v3l-1 1-1 1h-1v-3c2.21-.64.14-2.61 1.43-3.71l1.57.71Z"
            style={{
              fill: "#d16324",
            }}
          />
          <path
            d="m114 198.07-1-1.25 1-.75Z"
            className="templesOnly_svg__cls-1243"
          />
          <path
            d="m112 97.07-2 1c-.34-.33-.67-.67-1-1 1.49-.09.85-1.24 1-2v-3h2v1c-1.5.08-.85 1.24-1 2 .33.33.66.67 1 1Z"
            style={{
              fill: "#731c03",
            }}
          />
          <path
            d="M111 95.07c.15-.76-.5-1.92 1-2h1Z"
            className="templesOnly_svg__cls-1235"
          />
          <path
            d="M110 92.07v1l-1 1h-3v-2z"
            style={{
              fill: "#8c300c",
            }}
          />
          <path
            d="M107 92.07h-1v-2l1-1z"
            style={{
              fill: "#94350e",
            }}
          />
          <path
            d="M107 91.07v-2h2v1Z"
            style={{
              fill: "#852601",
            }}
          />
          <path
            d="M111 171.07h1c.33.33.66.67 1 1v2c-1.5.08-.85 1.24-1 2h-1c-1.93-.47-.62-2-1-3 .18-.76-.47-1.92 1-2"
            style={{
              fill: "#cb5a19",
            }}
          />
          <path
            d="M114 182.07h-1v-8c.33.39.88.75 1 1.18a17.7 17.7 0 0 1 0 2.82Z"
            style={{
              fill: "#d37031",
            }}
          />
          <path
            d="M113 172.07c-.34-.33-.67-.67-1-1l1-1Z"
            style={{
              fill: "#db6c2d",
            }}
          />
          <path
            d="M115 99.07v1c-.34-.42-.64-.86-1-1.24a9 9 0 0 0-1-.76v-1h2Z"
            style={{
              fill: "#873014",
            }}
          />
          <path
            d="M113 97.07v1c-.34-.33-.67-.67-1-1Z"
            className="templesOnly_svg__cls-1235"
          />
          <path
            d="M111 176.07h1v6h-1v-1c-.09-1.23.42-2.62-.91-3.43Z"
            style={{
              fill: "#da6a26",
            }}
          />
          <ellipse
            cx={112.53}
            cy={180.07}
            rx={0.71}
            ry={2.83}
            style={{
              fill: "#e17735",
            }}
          />
          <path
            d="M112 186.07h-1v-4l1 2Z"
            className="templesOnly_svg__cls-1243"
          />
          <path
            d="M111 185.07v1l-1-1Z"
            style={{
              fill: "#c6601e",
            }}
          />
          <path
            d="M109 97.07c.33.33.66.67 1 1v1h-2v-2Z"
            style={{
              fill: "#782208",
            }}
          />
          <path
            d="M108 99.07h2v1l-1 1c-.34-.33-.67-.67-1-1Z"
            style={{
              fill: "#7f2506",
            }}
          />
          <path
            d="M106 102.07v1l-2 2h-1.74l-.12-.6.87-1.07-2-1.33v-1l2.71.74 1.29-.74c.35.33.68.67.99 1"
            className="templesOnly_svg__cls-1288"
          />
          <path
            d="M106 103.07c.76.15 1.91-.5 2 1v1h-2Z"
            style={{
              fill: "#ad420c",
            }}
          />
          <path
            d="M108 105.07v-1c.33.33.66.67 1 1ZM106 102.07c-.34-.33-.67-.67-1-1h1Z"
            className="templesOnly_svg__cls-1238"
          />
          <path
            d="M106 101.07h-1l-1.29.74-2.71-.74c-.09-1.5-1.24-.85-2-1v-1h4l.33.83.67-.83h1c.36.67.69 1.33 1 2"
            style={{
              fill: "#9b3f0f",
            }}
          />
          <path
            d="M108 99.07v1l-1-1-1-1v-2l2 1Z"
            style={{
              fill: "#853010",
            }}
          />
          <path
            d="m106 98.07 1 1h-3v-1Z"
            style={{
              fill: "#832c02",
            }}
          />
          <path
            d="M113 262.07c-.24.86-.47 1.72-.69 2.5.22.78.45 1.64.69 2.5v7h-1l-1-2a4.78 4.78 0 0 0 0-6v-6h2z"
            style={{
              fill: "#b06a30",
            }}
          />
          <path
            d="M113 260.07h-2v2h-1v-3l1-1h3l1 1.74Z"
            style={{
              fill: "#b9753c",
            }}
          />
          <path
            d="M117 263.07h3c-.09.87.44 2.07-1.24 2.05-.25 0-.51.62-.76.95h-1Z"
            style={{
              fill: "#b35c20",
            }}
          />
          <path
            d="M117 266.07h1v1h-4c.5-1 1-2 1.44-2.82.56.62 1.07 1.22 1.56 1.82"
            style={{
              fill: "#9e4c17",
            }}
          />
          <path
            d="M113 270.07v-3h1c.15.76-.5 1.91 1 2l1 .51c-.32.28-.44.47-.56.47-.78.03-1.59.02-2.44.02"
            style={{
              fill: "#a45926",
            }}
          />
          <path
            d="M113 262.07v-1c1.38-.18 2.34.35 3 2.22Z"
            style={{
              fill: "#965018",
            }}
          />
          <path
            d="M114 258.07h-3v-1h4Z"
            style={{
              fill: "#b06129",
            }}
          />
          <ellipse
            cx={118.03}
            cy={261.57}
            className="templesOnly_svg__cls-1284"
            rx={1.41}
            ry={0.71}
          />
          <path
            d="M119 267.07v1l-1-1v-1Z"
            style={{
              fill: "#954414",
            }}
          />
          <path
            d="M114 257.07h-2v-2h1c.33.33.66.67 1 1Z"
            style={{
              fill: "#bb652b",
            }}
          />
          <path
            d="M99 99.07v1c.33.33.66.67 1 1v4l1.7 2.47a45 45 0 0 0-.67 5.22c-.06 9.44 0 18.87 0 28.31v2a1.4 1.4 0 0 0-.5 0c-.14.06-.36.25-.34.34.26 1 1.12 2.47.74 2.94-1.35 1.65-.76 3.43-.89 5.15-.4 5 .85 10.13-1 15.07-.32.88-.46 2.4 0 2.91 1.58 1.61.92 3.45.87 5.15-.22 7-.74 14-.92 21-.16 6.82 0 13.64 0 20.46 0 2.27-.05 4.55 1.06 6.55s.9 4 1 6.09c0 .77.12 1.54.17 2.29H103v1c-1.5.08-.85 1.24-1 2l.73 2.71c-.13.25-.43.77-.73 1.29h-2v3h-2v-76.49c0-7.7 1.34-15.34 1-23.09s-.11-15.33 0-23c0-1.37.72-2.71.93-4.09.16-1-1.53-2.11 0-3.17-.34-2.53 0-5.39-1.18-7.49s-.44-3.83-.82-5.68h1Z"
            style={{
              fill: "#edc397",
            }}
          />
          <path
            d="M98 260.07c-.68-3.11.9-6 1-9l1-1c.33.33.66.67 1 1l-.87 1.6.87.4v1l-1 1v1c-1.37.24-1.22 1-.62 1.88.23.36.41.75.62 1.12l-1 1Z"
            style={{
              fill: "#fcd194",
            }}
          />
          <path
            d="m100 250.07-1 1c-.34-.41-.93-.8-1-1.22-.1-1.92 0-3.85 0-5.78l2-1z"
            style={{
              fill: "#edc994",
            }}
          />
          <path
            d="M98 260.07h1c-.75.67-1.52 1.31-2.25 2a7.4 7.4 0 0 0-.75 1h-3v-1a2.3 2.3 0 0 0 2.5-1 2.28 2.28 0 0 1 2.5-1"
            className="templesOnly_svg__cls-1350"
          />
          <path
            d="m100 243.07-2 1v-3h2l1 1Z"
            style={{
              fill: "#fad096",
            }}
          />
          <path
            d="M89 264.07v-1h2l1 1v1h-1Z"
            className="templesOnly_svg__cls-1352"
          />
          <path
            d="m92 264.07-1-1c.08-1.5 1.24-.85 2-1v1Z"
            style={{
              fill: "#c9a47b",
            }}
          />
          <path
            d="M106 90.07v4h-2c-1.5-.09-.85-1.24-1-2h1l1 2v-4Z"
            style={{
              fill: "#9f4117",
            }}
          />
          <path
            d="M105 90.07v4l-1-2v-2Z"
            style={{
              fill: "#bb6134",
            }}
          />
          <path
            d="M103 92.07c.15.76-.5 1.91 1 2v1l-1 1h-1c-.34-.33-.67-.67-1-1h-1v-2l1-1z"
            style={{
              fill: "#983703",
            }}
          />
          <path
            d="M103 99.07h-1l-.87-1.61.87-.39h1Z"
            style={{
              fill: "#dc8447",
            }}
          />
          <circle
            cx={102.53}
            cy={96.57}
            r={0.71}
            className="templesOnly_svg__cls-1358"
          />
          <path
            d="M101 95.07c.33.33.66.67 1 1Z"
            className="templesOnly_svg__cls-1358"
          />
          <path
            d="M109 203.07c-.34.41-.93.8-1 1.22-.1 1.92 0 3.85 0 5.78h-1a36.5 36.5 0 0 1-1-4.55c-.17-1.8 0-3.63 0-5.45h1v2h2Z"
            style={{
              fill: "#b16224",
            }}
          />
          <path
            d="M107 200.07h-1c0-.17.07-.41 0-.48a5 5 0 0 0-1-.51v11c-.15.76.49 1.91-1 2-.34-1-.67-2-1-3 1.34 0 1-1 1-1.75v-13.25c1.49-.09.85-1.24 1-2h1c.36 2.66.69 5.32 1 7.99"
            style={{
              fill: "#b6692a",
            }}
          />
          <path
            d="m107 191.07.83.67-.83.33h-1ZM108 182.07c.3.52.6 1 .73 1.28l-.73 2.72c-1.93.47-.62 2-1 3-1.34 0-.81-1.06-1-1.74a4.9 4.9 0 0 0-1-1.26h-1v-1c.33-.42.93-.83 1-1.27.1-2.23 0-4.47 0-6.89l2 1.16v1q-2.055 1.5 0 3Z"
            className="templesOnly_svg__cls-1361"
          />
          <path
            d="M105 186.07a4.9 4.9 0 0 1 1 1.26c.23.68-.3 1.73 1 1.74v2l-1 1h-1Z"
            style={{
              fill: "#b06024",
            }}
          />
          <path
            d="m111 176.07-.91 1.57c1.33.81.82 2.2.91 3.43h-2v-8h1c.41.98-.9 2.53 1 3"
            style={{
              fill: "#d16422",
            }}
          />
          <path
            d="M109 180.07v1l-1 1v-2Z"
            style={{
              fill: "#d06f30",
            }}
          />
          <path
            d="M109 227.07v12h-1v-8.5l-2.12-2.12 1.12-4.38v-1l1-1h1Z"
            className="templesOnly_svg__cls-1365"
          />
          <path
            d="M104 212.07c1.49-.09.85-1.24 1-2l1.6.87.4-.87h1v7l-2 2v2c-1.29 0-.93-1-1-1.69-.17-1.72.35-3.53-.5-5.6l-.5 1.29c-1.37-.25-1.22-1-.62-1.89.26-.35.44-.74.62-1.11"
            style={{
              fill: "#b26526",
            }}
          />
          <path
            d="m106 219.07 2-2v5l-1 1c-.15-.76.49-1.92-1-2v-1l.83-.33Z"
            style={{
              fill: "#b96321",
            }}
          />
          <path
            d="m110.13 218.16-.69.82-.32-.32.82-.7Z"
            style={{
              fill: "#d57330",
            }}
          />
          <path
            d="M108 240.07v1c-.34 1-.67 2-1 3h-1c-.34-.67-.67-1.33-1-2v-4q2.055-1.5 0-3v-1l2-2.31v7.31Z"
            style={{
              fill: "#bd702c",
            }}
          />
          <path
            d="M107 244.07c.33-1 .66-2 1-3 .28.11.81.23.81.35q.07 4.14 0 8.3c0 .12-.53.23-.81.35-.34-.33-.67-.67-1-1z"
            className="templesOnly_svg__cls-1365"
          />
          <path
            d="M108 250.07a5.34 5.34 0 0 0 1 4c-1 .38-2.53-.93-3 1h-1v-2c.76-.15 1.91.49 2-1v-2Z"
            style={{
              fill: "#d1823d",
            }}
          />
          <path
            d="M111 253.07h1v2h-3v-1Z"
            style={{
              fill: "#ba6321",
            }}
          />
          <path d="m108 240.07-1-1h1Z" className="templesOnly_svg__cls-1365" />
          <path
            d="m106 158.07 2 1c0 1.6-.07 3.2 0 4.79 0 .42.62.81 1 1.21v2h-2v-6l-1-1Z"
            style={{
              fill: "#c7692e",
            }}
          />
          <path
            d="M106 158.07v2h-1c.34-2.18-.81-4.58.53-6.08-.2-1.54-.35-2.68-.6-4.52l2.07 2.6v2a5.34 5.34 0 0 0-1 4"
            style={{
              fill: "#b46425",
            }}
          />
          <path
            d="M109 165.07c-.34-.4-.93-.79-1-1.21-.11-1.59 0-3.19 0-4.79h1Z"
            className="templesOnly_svg__cls-1374"
          />
          <path
            d="M109 167.07v-2c1.33 0 .81 1.06 1 1.73a4.8 4.8 0 0 0 1 1.27v3c-1.5.08-.85 1.24-1 2h-1z"
            className="templesOnly_svg__cls-1307"
          />
          <path
            d="M108 146.07v3h-3v-2c1.49-.09.85-1.24 1-2Z"
            style={{
              fill: "#c76e32",
            }}
          />
          <path
            d="m108 146.07-2-1v-3l2-1Z"
            className="templesOnly_svg__cls-420"
          />
          <path
            d="m108 141.07-2 1c.11-.61.18-1.23.33-1.83s.44-1.45.67-2.17h1z"
            style={{
              fill: "#bf6427",
            }}
          />
          <path d="M107 149.07h1v4h-1z" className="templesOnly_svg__cls-1261" />
          <path
            d="M108 138.07h-1c-1.91-1.17-2.1-3-2-5 .33-.41.93-.8 1-1.22.11-1.92 0-3.85 0-5.78h1v8.76c0 .42.62.83 1 1.24.33.67.66 1.33 1 2Z"
            style={{
              fill: "#ba5922",
            }}
          />
          <path
            d="M107 113.07a7.68 7.68 0 0 1 4 3c-.34 1-.67 2-1 3h-2c-.38-1 .92-2.53-1-3Z"
            style={{
              fill: "#ba4814",
            }}
          />
          <path
            d="M108 119.07h2l1 6h-3c.23-.86.47-1.73.72-2.68-1.12-.69-.61-2.09-.72-3.32"
            style={{
              fill: "#bb4713",
            }}
          />
          <path
            d="M108 125.07h4v1.69l-3.4.64 1.4 1.67c-.09 1.49-1.24.85-2 1Z"
            className="templesOnly_svg__cls-1380"
          />
          <path
            d="M107 113.07v3h-1c-.38-1 .92-2.53-1-3v-2c.33-.39.88-.75 1-1.18a17.7 17.7 0 0 0 0-2.82c1.92.47.62 2 1 3Z"
            style={{
              fill: "#b15017",
            }}
          />
          <path
            d="M107 110.07c-.38-1 .92-2.53-1-3v-2h2a37 37 0 0 1 0 3.8c-.06.43-.64.8-1 1.2"
            className="templesOnly_svg__cls-1238"
          />
          <path
            d="M106 116.07h1c1.92.47.62 2 1 3 .08 1.23-.43 2.63.72 3.32-.25 1-.49 1.82-.72 2.68v8.37l2.29 2.63H108c-.34-.41-1-.82-1-1.24-.08-2.92 0-5.84 0-8.76v-4c-.34-.33-.67-.67-1-1Z"
            style={{
              fill: "#bc501b",
            }}
          />
          <path d="m112 130.07-1 1Z" className="templesOnly_svg__cls-1380" />
          <circle
            cx={112.53}
            cy={129.57}
            r={0.71}
            className="templesOnly_svg__cls-1380"
          />
          <path
            d="M109 97.07h-1v-3h1l1 1c-.12.76.52 1.93-1 2"
            style={{
              fill: "#832e13",
            }}
          />
          <path
            d="m110 95.07-1-1 1-1Z"
            style={{
              fill: "#8a3618",
            }}
          />
          <path
            d="M108 94.07v3l-2-1h-1c.33-.67.66-1.33 1-2Z"
            style={{
              fill: "#782001",
            }}
          />
          <path
            d="M113 178.07h-1v-2c.15-.76-.5-1.92 1-2Z"
            style={{
              fill: "#df702e",
            }}
          />
          <path
            d="M101 141.07v-28.31a45 45 0 0 1 .67-5.22l-1.7-2.47c1.92-.47.62-2 1-3l2 1.33-.87 1.07.12.6H104c-.39 1.81.91 3.93-.73 5.27l.73 2.73h-2v26.21c0 .72.4 1.78-1 1.79"
            className="templesOnly_svg__cls-1387"
          />
          <path
            d="M101 102.07c-.38 1 .92 2.53-1 3v-4h1Z"
            style={{
              fill: "#fec68b",
            }}
          />
          <path d="M106 103.07v2h-2Z" className="templesOnly_svg__cls-1238" />
          <path
            d="M103 99.07v-2h1v2l-.67.83Z"
            style={{
              fill: "#ba632f",
            }}
          />
          <path
            d="M101 101.07h-1c-.34-.33-.67-.67-1-1 .79.15 1.94-.5 2 1"
            className="templesOnly_svg__cls-1288"
          />
          <path
            d="M104 97.07h-1v-1h3v1Z"
            style={{
              fill: "#c46d41",
            }}
          />
          <ellipse
            cx={105.03}
            cy={97.57}
            rx={1.41}
            ry={0.71}
            style={{
              fill: "#9a441b",
            }}
          />
          <path
            d="m118 267.07 1 1v1c-.32 0-.75-.14-.92 0-1.06 1-2.06 2-3.08 3h-2v-2h2.45c.12 0 .24-.19.56-.47l-1-.51 1-1 1-1Z"
            style={{
              fill: "#994e1e",
            }}
          />
          <path
            d="M111 264.07v7c-1.5-.09-.85-1.24-1-2v-5Z"
            style={{
              fill: "#e8ae70",
            }}
          />
          <path
            d="M111 271.07v-5a4.78 4.78 0 0 1 0 6Z"
            className="templesOnly_svg__cls-1394"
          />
          <path
            d="M113 272.07h2v2h-2Z"
            style={{
              fill: "#8a4412",
            }}
          />
          <path
            d="m111 272.07 1 2h-2v-2Z"
            className="templesOnly_svg__cls-1394"
          />
          <circle
            cx={110.53}
            cy={263.57}
            r={0.71}
            style={{
              fill: "#f7c087",
            }}
          />
          <circle
            cx={110.53}
            cy={262.57}
            r={0.71}
            className="templesOnly_svg__cls-1397"
          />
          <path
            d="M110 262.07v1h-1a2.46 2.46 0 0 0-3-2v-1h4Z"
            style={{
              fill: "#f3bf86",
            }}
          />
          <path
            d="M111 257.07v1l-1 1v-3Z"
            className="templesOnly_svg__cls-64"
          />
          <ellipse
            cx={109.03}
            cy={259.57}
            rx={1.41}
            ry={0.71}
            style={{
              fill: "#f4bd85",
            }}
          />
          <path
            d="m116 268.07-1 1c-1.5-.09-.85-1.24-1-2h2Z"
            style={{
              fill: "#944513",
            }}
          />
          <path
            d="M116 268.07v-1h1Z"
            style={{
              fill: "#a65621",
            }}
          />
          <path
            d="m111 257.07-1-1v-1h2v2Z"
            style={{
              fill: "#c06e32",
            }}
          />
          <path
            d="M103 231.07h-1.8c0-.75-.14-1.52-.17-2.29-.06-2.07.14-4.12-1-6.09S99 218.41 99 216.14c.06-6.82-.11-13.64 0-20.46.18-7 .7-14 .92-21 0-1.7.71-3.54-.87-5.15-.5-.51-.36-2 0-2.91 1.82-4.94.57-10.05 1-15.07.13-1.72-.46-3.5.89-5.15.38-.47-.48-1.93-.74-2.94 0-.09.2-.28.34-.34a1.4 1.4 0 0 1 .5 0c1.65.16.72 1.47 1 2.25s-.94 2.41 1 2.75c.33.33.66.67 1 1v10l-1.79 2.5c.33 2.88.48 4.92.81 6.94.58 3.62-1.2 7-1 10.56a31 31 0 0 0-1 4.07 39 39 0 0 0 0 4.48v24.45a8 8 0 0 0 0 2.45c.53 1.58 1.6 3 1.88 4.64a35 35 0 0 1 .08 5.91c-1.84.32-1.21 2.13-.84 2.49 1.14 1.05.74 2.27.82 3.46"
            className="templesOnly_svg__cls-1387"
          />
          <path
            d="M103 148.07c-1.93-.34-.66-1.84-1-2.75s.64-2.09-1-2.25v-2c1.37 0 1-1.07 1-1.79v-26.21h2a31 31 0 0 0-1 4.07 39 39 0 0 0 0 4.48z"
            style={{
              fill: "#dba260",
            }}
          />
          <path
            d="M103 231.07c-.11-1.19.29-2.41-.84-3.51-.37-.36-1-2.17.84-2.49h1c-.31.52-.61 1.05-.92 1.58.2.2.63.43.64.67.12 4.91.19 9.83.28 14.75v6l-1 1v-5a37 37 0 0 0 0-3.8c0-.43-.62-.8-1-1.2v-1c.3-.52.6-1 .73-1.29l-.73-2.71c1.49-.09.85-1.24 1-2Z"
            style={{
              fill: "#e2a76a",
            }}
          />
          <path
            d="M102 238.07v1a37 37 0 0 0 0 3.8c.05.43.62.8 1 1.2v7h-2c-.34-.33-.67-.67-1-1v-1h1.73c.75-2.28-.63-2-1.73-2v-4l1-1-1-1v-3Z"
            style={{
              fill: "#fcce8e",
            }}
          />
          <path
            d="M103 232.07c-.15.76.49 1.91-1 2 .18-.76-.47-1.92 1-2"
            className="templesOnly_svg__cls-1387"
          />
          <path
            d="M101 251.07h3v2l-1 1c-.09-1.5-1.24-.85-2-1l-.87-.4Z"
            style={{
              fill: "#ecb575",
            }}
          />
          <path
            d="M100 259.07c-.21-.37-.39-.76-.62-1.12-.6-.9-.75-1.64.62-1.88.08 1.49 1.24.85 2 1v2Z"
            className="templesOnly_svg__cls-1407"
          />
          <path
            d="M102 257.07c-.76-.15-1.92.49-2-1v-1l1-1h2c-.31 1-.64 2-1 3"
            className="templesOnly_svg__cls-1408"
          />
          <path
            d="M103 254.07h-2v-1c.79.15 1.94-.5 2 1M101 254.07l-1 1ZM99 260.07l1-1Z"
            className="templesOnly_svg__cls-1407"
          />
          <path
            d="M100 247.07c1.1 0 2.48-.28 1.73 2H100Z"
            style={{
              fill: "#fed79a",
            }}
          />
          <path
            d="m99 260.07 1-1h2v-2h1l1 1v3l-2.91.29.08.71H103v1l-1 1h-2c-.47-1.93-2-.62-3-1h-1a7.4 7.4 0 0 1 .75-1c.76-.69 1.53-1.33 2.25-2"
            className="templesOnly_svg__cls-1408"
          />
          <path
            d="M96 263.07h1v1l-1 1h-4v-1h1c.76-.15 1.91.49 2-1Z"
            style={{
              fill: "#f0b97d",
            }}
          />
          <path
            d="M95 263.07c-.09 1.49-1.24.85-2 1v-1Z"
            className="templesOnly_svg__cls-1352"
          />
          <path
            d="m89 264.07 2 1v1a2.48 2.48 0 0 0 0 4h2l1 1v1h-3l-1-1h-1z"
            style={{
              fill: "#d0a675",
            }}
          />
          <path d="m101 242.07-1 1Z" className="templesOnly_svg__cls-1412" />
          <path
            d="M91 266.07v-1h1c.33 1 .66 2 1 3l-2 1Z"
            style={{
              fill: "#d3a372",
            }}
          />
          <path d="M93 263.07v1h-1Z" className="templesOnly_svg__cls-1350" />
          <path
            d="M105 96.07h-1v-2h2c-.31.67-.64 1.33-1 2"
            style={{
              fill: "#882d03",
            }}
          />
          <path d="M104 95.07v1h-1Z" className="templesOnly_svg__cls-1358" />
          <path
            d="m107 210.07-.4.87-1.6-.87v-11a5 5 0 0 1 1 .51c.09.07 0 .31 0 .48 0 1.82-.13 3.65 0 5.45a36.5 36.5 0 0 0 1 4.56"
            style={{
              fill: "#af6225",
            }}
          />
          <path
            d="M104 185.07v1c-.53 1.11-1.39 2.11-1 3.51s.68 3 1 4.49v13.25c0 .72.35 1.74-1 1.75-.53-1.13-1.26-2.12-1-3.55a30 30 0 0 0 0-4.45v-12.45a39 39 0 0 1 0-4.48 30.4 30.4 0 0 1 1-4.07c.33.4.91.77 1 1.2a37 37 0 0 1 0 3.8M104 225.07h-1a35 35 0 0 0-.08-5.91c-.28-1.61-1.35-3.06-1.88-4.64a8 8 0 0 1 0-2.45l.83-.33-.83-.67v-2h2c.33 1 .66 2 1 3-.21.37-.39.76-.62 1.11-.6.91-.75 1.64.62 1.89 0 1.93-.06 3.86 0 5.78 0 .42.62.81 1 1.22-.35 1-.68 2-1.04 3"
            className="templesOnly_svg__cls-1416"
          />
          <path
            d="M104 194.07c-.34-1.5-.62-3-1-4.49s.49-2.4 1-3.51h1v6c-.12.76.52 1.93-1 2M104 185.07a37 37 0 0 0 0-3.8c0-.43-.62-.8-1-1.2v-1c.06-.86 1.48-1.68.09-2.59 1.42-.91.88-2.35.89-3.58v-23.83h3v3l-2.07-2.6c.25 1.84.4 3 .6 4.52-1.34 1.5-.19 3.9-.53 6.08v10c.07 1 .15 2 .23 3l1.77-1v1c-.21.37-.39.76-.62 1.11-.6.91-.75 1.64.62 1.89v2l-2-1.16v6.89c.02.44-.62.85-.98 1.27"
            className="templesOnly_svg__cls-1417"
          />
          <path
            d="M109 172.07v8h-2v-2l1-.76c-.34-.41-.67-.83-1-1.24.33-1 .66-2 1-3v-1Z"
            style={{
              fill: "#cb6a2c",
            }}
          />
          <path
            d="M107 179.07v3c-1.34-1.01-1.34-2 0-3"
            className="templesOnly_svg__cls-1417"
          />
          <ellipse
            cx={107.53}
            cy={181.07}
            rx={0.71}
            ry={1.41}
            style={{
              fill: "#d2773a",
            }}
          />
          <path
            d="M104 225.07c.33-1 .66-2 1-3h1v1c.33.33.66.67 1 1l-1.12 4.38 2.12 2.12v8.5h-1v-7.31l-2 2.31v-7.77c0-.42-.64-.82-1-1.23"
            style={{
              fill: "#c97732",
            }}
          />
          <path
            d="M107 224.07c-.34-.33-.67-.67-1-1h1ZM106 222.07h-1c-.34-.41-.93-.8-1-1.22-.1-1.92 0-3.85 0-5.78l.5-1.29c.85 2.07.33 3.88.5 5.6.07.71-.29 1.69 1 1.69Z"
            className="templesOnly_svg__cls-1421"
          />
          <path
            d="m106 219.07.83.67-.83.33Z"
            style={{
              fill: "#bd6e29",
            }}
          />
          <path
            d="M106 222.07v-1c1.49.08.85 1.24 1 2h-1Z"
            style={{
              fill: "#b0621d",
            }}
          />
          <path
            d="M104 225.07c.33.41.94.81 1 1.23.09 2.59 0 5.18 0 7.77v8h-1c-.09-4.92-.16-9.84-.28-14.75 0-.24-.44-.47-.64-.67.34-.53.64-1.06.92-1.58"
            className="templesOnly_svg__cls-1416"
          />
          <path
            d="M104 242.07h1c.33.67.66 1.33 1 2-.34.23-1 .53-1 .68.24 1.12.61 2.22 1 3.32h-2Z"
            className="templesOnly_svg__cls-518"
          />
          <path
            d="M106 248.07c-.34-1.1-.71-2.2-1-3.32 0-.15.61-.45 1-.68h1v4Z"
            style={{
              fill: "#b56c25",
            }}
          />
          <path
            d="M105 238.07v-3c1.4 1 1.4 1.99 0 3"
            style={{
              fill: "#b56b2a",
            }}
          />
          <path
            d="M106 248.07h1v4c-2-.21-.25-2.24-1.57-3l-1.43 2h-1v-2l1-1Z"
            style={{
              fill: "#d38e48",
            }}
          />
          <path
            d="M107 250.07v-1c.33.33.66.67 1 1Z"
            className="templesOnly_svg__cls-1299"
          />
          <path
            d="m104 251.07 1.43-2c1.32.75-.47 2.78 1.57 3-.09 1.49-1.24.85-2 1h-1Z"
            style={{
              fill: "#c5853e",
            }}
          />
          <path
            d="M104 253.07h1v2c-1.5.08-.85 1.24-1 2h-2c.33-1 .66-2 1-3Z"
            style={{
              fill: "#da9a59",
            }}
          />
          <path
            d="M109 254.07v1h-3c.5-1.93 2-.62 3-1"
            style={{
              fill: "#c07431",
            }}
          />
          <path
            d="M106 255.07h1l-.76 1-1.24-1Z"
            style={{
              fill: "#ab6323",
            }}
          />
          <path
            d="M108 255.07h2v2h-2Z"
            style={{
              fill: "#b06225",
            }}
          />
          <path
            d="M109 172.07h-1c-.34-.33-.67-.67-1-1v-4h2Z"
            className="templesOnly_svg__cls-1374"
          />
          <path
            d="M105 166.07v-2a4.7 4.7 0 0 0 1-1.27c.23-.67-.3-1.72 1-1.73v6h-1c-.31-.33-.64-.67-1-1"
            style={{
              fill: "#bf672b",
            }}
          />
          <path
            d="M107 161.07c-1.34 0-.81 1.06-1 1.73a4.7 4.7 0 0 1-1 1.27v-4h1Z"
            style={{
              fill: "#b25f1f",
            }}
          />
          <path
            d="M106 143.07v2c-.15.76.49 1.91-1 2-.15-.76.49-1.92-1-2v-1l1-1Z"
            style={{
              fill: "#bc6c2b",
            }}
          />
          <path
            d="M104 145.07c1.49.08.85 1.24 1 2v2h-1Z"
            className="templesOnly_svg__cls-1435"
          />
          <path
            d="M106 143.07h-1c-.38-1 .92-2.53-1-3v-7h1c-.1 2 .09 3.83 2 5-.23.72-.48 1.44-.67 2.17s-.22 1.22-.33 1.83Z"
            style={{
              fill: "#c16f2f",
            }}
          />
          <path
            d="M106 116.07v10c0 1.93.06 3.86 0 5.78 0 .42-.62.81-1 1.22v-3c-.36-2.17.81-4.57-.55-6.07 1-3.84.38-7.42.55-10.93 2 .47.65 2.01 1 3"
            className="templesOnly_svg__cls-1437"
          />
          <ellipse
            cx={106.53}
            cy={124.07}
            rx={0.71}
            ry={2.83}
            style={{
              fill: "#b3571a",
            }}
          />
          <path
            d="M105 113.07c-.17 3.51.41 7.09-.55 10.93 1.36 1.5.19 3.9.55 6.07-1.93.47-.62 2-1 3v5h-1v-16.45a39 39 0 0 1 0-4.48 31 31 0 0 1 1-4.07l-.73-2.73c1.64-1.34.34-3.46.73-5.27h1z"
            style={{
              fill: "#d08b46",
            }}
          />
          <path
            d="M105 111.07v-6h1v2a17.7 17.7 0 0 1 0 2.82c-.09.43-.64.79-1 1.18"
            className="templesOnly_svg__cls-1437"
          />
          <path
            d="M107 122.07h-1v-1c.36.33.69.67 1 1"
            style={{
              fill: "#ad5116",
            }}
          />
          <path
            d="M119 269.07v1l-.83.33.83.67-1 2h-1c-.09-1.5-1.24-.85-2-1 1-1 2-2 3.08-3 .2-.14.63 0 .92 0"
            style={{
              fill: "#642706",
            }}
          />
          <path
            d="M110 264.07v2l-2 1-1 1h-1l-1-2v3h-1l-1-1v-1l.83-.33-.83-.67v-1c.76-.15 1.91.49 2-1z"
            style={{
              fill: "#d8a873",
            }}
          />
          <path
            d="M106 268.07h1c.08 1.49 1.24.85 2 1h1c.15.76-.5 1.91 1 2v1h-5v-1l1.9-.34-.07-.66H106Z"
            style={{
              fill: "#d59e63",
            }}
          />
          <path
            d="M110 269.07h-1l-1-2 2-1Z"
            style={{
              fill: "#d2995d",
            }}
          />
          <path
            d="M115 272.07c.76.15 1.91-.5 2 1l-1 1h-1Z"
            style={{
              fill: "#4b1000",
            }}
          />
          <path d="M106 272.07h4v2h-3Z" className="templesOnly_svg__cls-1446" />
          <path
            d="M110 264.07h-4v-1h4Z"
            className="templesOnly_svg__cls-1397"
          />
          <path
            d="M109 263.07h-2c-.39-.33-.75-.89-1.19-1a19 19 0 0 0-2.81 0h-1.8l-.08-.71 2.91-.29h2a2.46 2.46 0 0 1 2.97 2"
            style={{
              fill: "#ddab72",
            }}
          />
          <path
            d="M104 260.07v-2h1c.47 1.93 2 .62 3 1v1z"
            style={{
              fill: "#d99e65",
            }}
          />
          <ellipse
            cx={105.03}
            cy={260.57}
            rx={1.41}
            ry={0.71}
            style={{
              fill: "#edb77f",
            }}
          />
          <path
            d="M108 259.07c-1-.38-2.53.93-3-1h1c.76-.15 1.91.49 2-1h2v2Z"
            style={{
              fill: "#c38248",
            }}
          />
          <path
            d="m119 271.07-.83-.67.83-.33Z"
            style={{
              fill: "#2f0000",
            }}
          />
          <path
            d="M104 159.07v13.83c0 1.23.53 2.67-.89 3.58 1.39.91 0 1.73-.09 2.59h-1c-.18-3.57 1.6-6.94 1-10.56-.33-2-.48-4.06-.81-6.94Z"
            style={{
              fill: "#d79755",
            }}
          />
          <path
            d="M102 179.07h1v1a30.4 30.4 0 0 0-1 4.07 39 39 0 0 0 0 4.48v12.45h-1v-13.45a39 39 0 0 1 0-4.48 31 31 0 0 1 1-4.07"
            style={{
              fill: "#dea161",
            }}
          />
          <path
            d="M103 138.07h1v11c-.34-.33-.67-.67-1-1Z"
            className="templesOnly_svg__cls-1454"
          />
          <path
            d="M101 201.07h1a30 30 0 0 1 0 4.45c-.21 1.43.52 2.42 1 3.55h-2ZM101 211.07l.83.67-.83.33Z"
            className="templesOnly_svg__cls-1455"
          />
          <path
            d="M103 244.07c-.34-.4-.91-.77-1-1.2a37 37 0 0 1 0-3.8c.33.4.91.77 1 1.2a37 37 0 0 1 0 3.8"
            className="templesOnly_svg__cls-1412"
          />
          <path
            d="M100 264.07h2v1c-.76.15-1.92-.5-2 1l-1 1h-2v-1l1-1 1-1Z"
            style={{
              fill: "#e6ab6f",
            }}
          />
          <path
            d="M106 263.07v1h-4l1-1Z"
            style={{
              fill: "#ddad75",
            }}
          />
          <path
            d="M106 263.07h-3v-1a19 19 0 0 1 2.81 0c.44.07.8.63 1.19 1Z"
            style={{
              fill: "#e9b87e",
            }}
          />
          <path
            d="M106 258.07h-2l-1-1h3Z"
            style={{
              fill: "#ecaa6e",
            }}
          />
          <path
            d="M100 264.07h-3v-1c1 .38 2.56-.93 3 1"
            style={{
              fill: "#f5bd82",
            }}
          />
          <path
            d="M93 268.07c-.34-1-.67-2-1-3h4v1h-1l-.83.33.83.67v1z"
            style={{
              fill: "#e2b070",
            }}
          />
          <path
            d="M97 264.07h2l-1 1h-2Z"
            style={{
              fill: "#ecb177",
            }}
          />
          <path
            d="M91 266.07v4a2.48 2.48 0 0 1 0-4"
            style={{
              fill: "#dcac82",
            }}
          />
          <path
            d="M91 270.07v-1l2-1v2Z"
            style={{
              fill: "#b78b64",
            }}
          />
          <path
            d="M94 272.07v-3l1 1v2Z"
            style={{
              fill: "#d1a070",
            }}
          />
          <path
            d="M91 274.07c-1.93-.47-.62-2-1-3l1 1Z"
            style={{
              fill: "#ddb384",
            }}
          />
          <path
            d="M91 274.07v-2h2v1l-1 1Z"
            style={{
              fill: "#dbae7e",
            }}
          />
          <path
            d="M93 273.07v-1h2v1Z"
            style={{
              fill: "#dca576",
            }}
          />
          <path
            d="M94 269.07v2l-1-1v-1Z"
            style={{
              fill: "#dbaf82",
            }}
          />
          <path
            d="M106 167.07h1v5l-1.77 1c-.08-1-.16-2-.23-3 2-.47.65-2.02 1-3"
            style={{
              fill: "#b06023",
            }}
          />
          <path
            d="M106 167.07c-.38 1 .92 2.53-1 3v-4c.36.33.69.67 1 1"
            style={{
              fill: "#b05e1e",
            }}
          />
          <path
            d="M108 173.07c-.34 1-.67 2-1 3-1.37-.25-1.22-1-.62-1.89.23-.35.41-.74.62-1.11Z"
            className="templesOnly_svg__cls-1374"
          />
          <path
            d="M107 176.07c.33.41.66.83 1 1.24l-1 .76Z"
            style={{
              fill: "#cd7033",
            }}
          />
          <path
            d="M108 173.07h-1v-2c.33.33.66.67 1 1Z"
            style={{
              fill: "#c66d31",
            }}
          />
          <path
            d="M106 257.07h-2c.15-.76-.5-1.92 1-2l1.24 1 .76-1h1v2Z"
            style={{
              fill: "#b26a2c",
            }}
          />
          <path
            d="M104 144.07v-4c1.92.47.62 2 1 3Z"
            className="templesOnly_svg__cls-1435"
          />
          <path
            d="M104 133.07c.38-1-.93-2.53 1-3v3Z"
            className="templesOnly_svg__cls-1454"
          />
          <path
            d="M106 268.07v3h-1v-5Z"
            style={{
              fill: "#dbac74",
            }}
          />
          <path
            d="M105 269.07v3h-2v-1c1.49-.09.85-1.24 1-2Z"
            style={{
              fill: "#d3a06a",
            }}
          />
          <path
            d="m108 267.07 1 2c-.76-.15-1.92.49-2-1Z"
            style={{
              fill: "#bc8c54",
            }}
          />
          <path
            d="M104 269.07c-.15.76.49 1.91-1 2v-3Z"
            style={{
              fill: "#e3b07a",
            }}
          />
          <path
            d="M103 267.07v1h-1v-2h1Z"
            style={{
              fill: "#d09966",
            }}
          />
          <path
            d="M103 264.07h2c-.09 1.49-1.24.85-2 1Z"
            style={{
              fill: "#d4a36b",
            }}
          />
          <path
            d="M103 267.07v-1l.83.67Z"
            style={{
              fill: "#deaa79",
            }}
          />
          <circle
            cx={102.53}
            cy={265.57}
            r={0.71}
            style={{
              fill: "#fbc48c",
            }}
          />
          <path
            d="M106 271.07v-1h1.83l.07.66Z"
            style={{
              fill: "#e4b077",
            }}
          />
          <circle
            cx={105.53}
            cy={271.57}
            r={0.71}
            className="templesOnly_svg__cls-1446"
          />
          <path
            d="M105 272.07h1l1 2h-4a9 9 0 0 1 .76-1 15 15 0 0 1 1.24-1"
            style={{
              fill: "#7f3f0f",
            }}
          />
          <path
            d="M106 257.07h2c-.09 1.49-1.24.85-2 1Z"
            style={{
              fill: "#d59056",
            }}
          />
          <path
            d="M102 265.07v1l-1 .75 1 1.25v2l1 1v1h-2v-2h-2c-.15-.76.49-1.92-1-2v-1h1l1-1c.11-1.5 1.27-.85 2-1"
            style={{
              fill: "#e6af6f",
            }}
          />
          <path
            d="m100 266.07-1 1Z"
            style={{
              fill: "#e1a864",
            }}
          />
          <path
            d="M96 266.07h1v1Z"
            style={{
              fill: "#d5a05d",
            }}
          />
          <circle
            cx={102.53}
            cy={264.57}
            r={0.71}
            className="templesOnly_svg__cls-1408"
          />
          <path
            d="M95 268.07h2v2h-2l-1-1v-1Z"
            style={{
              fill: "#e1af7f",
            }}
          />
          <circle
            cx={93.53}
            cy={268.57}
            r={0.71}
            style={{
              fill: "#e7b88c",
            }}
          />
          <path
            d="M95 266.07v1l-.83-.67Z"
            style={{
              fill: "#e7b672",
            }}
          />
          <path
            d="M95 270.07h2v1c.08 1.49 1.24.85 2 1v1h-4z"
            style={{
              fill: "#dea16a",
            }}
          />
          <path
            d="M93 274.07h-1l1-1h2v1Z"
            style={{
              fill: "#cb9463",
            }}
          />
          <path
            d="M102 272.07h3a15 15 0 0 0-1.24 1 9 9 0 0 0-.76 1h-2v-1Z"
            className="templesOnly_svg__cls-1446"
          />
          <ellipse
            cx={102.53}
            cy={269.07}
            rx={0.71}
            ry={1.41}
            style={{
              fill: "#ebb780",
            }}
          />
          <path
            d="M102 270.07h1v1Z"
            style={{
              fill: "#f5b983",
            }}
          />
          <path
            d="m102 268.07-1-1.25 1-.75Z"
            style={{
              fill: "#bd864b",
            }}
          />
          <path
            d="M99 272.07c-.76-.15-1.92.49-2-1 .76-.15 1.91.49 2-1h2v2Z"
            style={{
              fill: "#eead68",
            }}
          />
          <path
            d="M97 270.07v-2h1c1.49.08.85 1.24 1 2Z"
            style={{
              fill: "#daa275",
            }}
          />
          <path
            d="M99 272.07h3l-1 1h-2ZM97 273.07l-1 1h-1v-1Z"
            className="templesOnly_svg__cls-1499"
          />
          <path
            d="M97 270.07h2c-.09 1.49-1.24.85-2 1Z"
            style={{
              fill: "#dd9e61",
            }}
          />
        </g>
        <g id="templesOnly_svg__Upper_Part" data-name="Upper Part" ref={el => upperRefs.current[0] = el}>
          <path
            d="M169.07 9.05h3l1 1c.15.76-.5 1.91 1 2h3c-.33.67-.67 1.33-1 2l-1 1c-1.93.47-.62 2-1 3-2.1-.19-.15-2.44-1.54-3h-1.46v-1l-1-1h-1Z"
            className="templesOnly_svg__cls-1501"
          />
          <path
            d="M152.07 17.05a4.7 4.7 0 0 1 .3-.77c2.15.46 3.09-1.61 4.7-2.23.15.76-.5 1.91 1 2 .47.38 1 .76 1.48 1.2l1.52-3.2 1-1h1v6h-4c-.24-1.37-1-1.22-1.88-.62-.36.23-.75.41-1.12.62v-2zm9.67 0h-.34v1h.34Z"
            style={{
              fill: "#703016",
            }}
          />
          <path
            d="M183.07 3.05c2.7-.91 4.8-3.43 8-3v2h-1l-.33-.83-.67.83v3H188c-1.1 1.12-2 2.06-2.92 3-.33-.67-.67-1.33-1-2l1-1c-.08-1.5-1.24-.85-2-1Z"
            className="templesOnly_svg__cls-1503"
          />
          <path
            d="m9 112.05.65-1.41C8.58 109 9.16 107 9 105.05v-2h2v2a2.47 2.47 0 0 0 0 4l2 1.6v-2.6c.61-.06 1.15 0 .59-1a7.4 7.4 0 0 1-.59-2l1.61-.93c1.2.55-.7 2.73 1.39 2.93v1l-.83.33.83.67-1 1-1 1h-2l-1 1z"
            style={{
              fill: "#d48140",
            }}
          />
          <path
            d="M195.07 50.05c.33 1.6.74 3.2 1 4.81 0 .35-.62.79-1 1.19l-1-1c-.15-2.3.32-4.66-.29-7.11L192.46 49l-.39-1a19 19 0 0 0 0-2.82c-.07-.43-.63-.79-1-1.18v-1h1l2 1c.15.76-.5 1.91 1 2Z"
            className="templesOnly_svg__cls-1505"
          />
          <path
            d="M83 50.05a4.62 4.62 0 0 1 4-2h3.33l1.67 2c-.34.67-.67 1.34-1 2h-2c-.47-1.92-2-.61-3-1h-1c0-1.49-1.21-.85-2-1"
            className="templesOnly_svg__cls-1506"
          />
          <path
            d="M199.07 6.05c.33.42 1 .83 1 1.25.07 3.92 0 7.83 0 11.75h-2v-1c1.5-.09.85-1.24 1-2-.33-.67-.67-1.33-1-2 1.5-.09.85-1.24 1-2l-1-1h-1v-4c.76-.15 1.93.49 2-1"
            style={{
              fill: "#9a4c17",
            }}
          />
          <path
            d="M194.07 57.05c.21.37.39.76.62 1.11.6.91.75 1.64-.66 1.94l.15-.14-.7-.82-.32.32a6 6 0 0 0 .87.64 29 29 0 0 1 0 3.75c-.05.43-.63.8-1 1.2v-2.61l-3-2.39h-1l-1-1v-1h1l.76 1 1.24-1c.33-.67.67-1.33 1-2h1Z"
            style={{
              fill: "#853410",
            }}
          />
          <path
            d="M201.07 25.05h1.71c-.28 1.27-.43 2.28-.74 3.23-.11.33-.64.52-1 .77l-2 1v-2.39.48l1.95-.39-.08-.64a3.5 3.5 0 0 0-1.9.55 1.09 1.09 0 0 1-1 .39h-2a9.8 9.8 0 0 1 .61-2.07c.53-.95.8-1.67-.61-1.93v-1h2c.15.76-.5 1.91 1 2l1 1Z"
            style={{
              fill: "#9e4517",
            }}
          />
          <path
            d="M183.07 3.05v2c-1 .38-2.53-.93-3 1-.76.15-1.91-.5-2 1-1.3 1-3.49.9-4 3h-1l-1-1c.12-.28.15-.69.36-.82a36.7 36.7 0 0 1 10.64-5.18"
            style={{
              fill: "#efc5a6",
            }}
          />
          <path
            d="M106.07 39.05a11.6 11.6 0 0 1 8-4v1h-1l-1 1c-.76.15-1.91-.5-2 1h-1c-1.23.06-1.23.94-.8 1.61a6.5 6.5 0 0 0 1.8 1.39v1c-.47 1.93-2 .62-3 1a19 19 0 0 0 0-2.82c-.07-.43-.67-.79-1-1.18"
            style={{
              fill: "#8d4b25",
            }}
          />
          <path
            d="M163.07 13.05h-2c1-2.24 2.9-.42 4.5-1.2l3.5-2.8v4c-.33.67-.67 1.33-1 2h-1c-.56-2.21-2.29-2.05-4-2"
            style={{
              fill: "#af855f",
            }}
          />
          <path
            d="m119.07 33.05 1-1h3.58l1.42 3 2 1.6v-2.6h1v3h-2l-2 1v-2h-2v-1l1.58-2Z"
            className="templesOnly_svg__cls-1513"
          />
          <path
            d="m34 73.05 3-2c.15.76-.5 1.92 1 2 .06.62.05 1.16 1 .6a7.3 7.3 0 0 1 2-.6v2c-.76.15-1.92-.49-2 1h-3c-.16-.75.49-1.91-1-2h-1Z"
            style={{
              fill: "#964519",
            }}
          />
          <path
            d="M195.07 50.05v-4c-.15-.76.5-1.92-1-2-.15-.76.5-1.92-1-2v-3h2c.15.76-.5 1.91 1 2 0 2.59.05 5.18 0 7.76-.07.43-.67.83-1 1.24"
            style={{
              fill: "#a64f16",
            }}
          />
          <path
            d="m125.07 35.05-1.42-3h-3.58c.24-.33.47-.94.73-1 1.59-.09 3.19 0 4.77 0 1.05-.9 1.74-2.39 3.5-2v1l-3 3c-.15.76.5 1.95-1 2"
            style={{
              fill: "#9c7458",
            }}
          />
          <path
            d="M65 58.05a20.7 20.7 0 0 1 8-3v1c-.76.15-1.92-.49-2 1h-2.6c.83 1.05 1.21 1.53 1.6 2h1l1 1v1h-2c-.09-1.49-1.25-.85-2-1v-2.59l-2 1.59h-1Z"
            style={{
              fill: "#8f4317",
            }}
          />
          <path
            d="M9 103.05v2c-2.2.15-3.13-1.39-4-3l1-1 1-1h3v2Z"
            className="templesOnly_svg__cls-1518"
          />
          <path
            d="M41 73.05a7.3 7.3 0 0 0-2 .6c-.91.56-.9 0-1-.6v-1l1-1c.75-.15 1.91.5 2-1l3-2c.33.34.66.67 1 1v2a6.4 6.4 0 0 0-1 .06l.15-.15-.7-.81-.31.31a5.5 5.5 0 0 0 .86.65l-1 .94h-1Z"
            className="templesOnly_svg__cls-1519"
          />
          <path
            d="M152.07 17.05h2v1l-1 1c-1.34 0-.81 1.06-1 1.73a5 5 0 0 1-1 1.27 5 5 0 0 0-1.27-1c-.67-.22-1.72.31-1.73-1 .91-.94 1.82-1.88 2.92-3Z"
            style={{
              fill: "#4c1803",
            }}
          />
          <path
            d="M93 47.05c.33-.41.63-.85 1-1.23a8.6 8.6 0 0 1 1-.77v1l.32.83.68-.83h1c.15.31.3.62 1 2v-3h1v2c-.34.67-.67 1.34-1 2h-4l-1-1Z"
            className="templesOnly_svg__cls-1521"
          />
          <path
            d="M75 56.05h2.27l4.73-4h1v1l-1 1c-1.5.09-.85 1.25-1 2v1h-4c-.72-.15-1.88.5-2-1"
            style={{
              fill: "#af7847",
            }}
          />
          <path
            d="M21 79.05c.46-1.92 2-.61 3-1l.32.83.68-.83c1.49.09.84 1.25 1 2-.76.15-1.92-.49-2 1-.76.15-1.92-.49-2 1h-1l-1-1-1-1h2l.82-.33Z"
            style={{
              fill: "#7f360d",
            }}
          />
          <path
            d="M0 93.05v-2h2c.08 1.5 1.24.85 2 1 .08 1.5 1.24.85 2 1v1c-.76.15-1.92-.49-2 1H1c-.12-.75.53-1.91-1-2"
            className="templesOnly_svg__cls-1524"
          />
          <path
            d="m201.07 25.05-1 1-1-1c-.38-1 .93-2.53-1-3v-3h2c.33 2 .67 4 1 6"
            style={{
              fill: "#944a15",
            }}
          />
          <path
            d="M75 56.05c.08 1.5 1.24.85 2 1v1l-1 .76c.33.41.66.83 1 1.24l-1 1h-1v-1c-.67-.66-1.34-1.33-2-2v-3c.79.15 2-.49 2 1"
            style={{
              fill: "#b65517",
            }}
          />
          <path
            d="M129.07 29.05c.88-1.61 1.8-3.15 4-3v1l-.83.39 1.83 1.61v2h-2c-.15-.76.5-1.92-1-2z"
            style={{
              fill: "#924a21",
            }}
          />
          <path
            d="m199.07 30.05 2-1v3.66l-4 1.34c-.76-.15-1.91.49-2-1h1l1-1 1-1a8 8 0 0 0 1.05-.05.8.8 0 0 0-.15.14l.69.82.32-.32a6 6 0 0 0-.86-.64 6 6 0 0 1-.05-.95"
            style={{
              fill: "#7f2f0a",
            }}
          />
          <path
            d="M12 122.05h-1.4c-.85-2.33-1.71-4.66-2.56-7h4v1l-1 1-.83.33.83.67c.38 1-.93 2.54 1 3Z"
            style={{
              fill: "#e5bd98",
            }}
          />
          <path
            d="M133.07 27.05v-1c2.21-2.21 5.07-2.72 8-3a4.2 4.2 0 0 1-.77 1c-1.28.93-3.23.48-4.23 2Z"
            className="templesOnly_svg__cls-1530"
          />
          <path
            d="M195.07 33.05c.09 1.49 1.24.85 2 1-.22.72-.48 1.44-.66 2.17s-.23 1.22-.34 1.83h-1c-1.34 0-.85-1-1-1.75s.66-2.09-1-2.25v-1z"
            style={{
              fill: "#832a08",
            }}
          />
          <path
            d="M148.07 20.05c0 1.34 1.06.81 1.73 1a5 5 0 0 1 1.27 1h-1l-1 1-2 1v-1c-.08-1.5-1.24-.85-2-1v-1Z"
            style={{
              fill: "#5e2307",
            }}
          />
          <path
            d="M1 95.05h3v2H3c-1.5.09-.85 1.25-1 2-2.22-.56-2.08-2.29-2-4Z"
            style={{
              fill: "#b08262",
            }}
          />
          <path
            d="M93 47.05v2l-1 1-1.67-2H87c.39-.33.75-.89 1.18-.95 1.18-.18 2.52.33 3.25-.93Z"
            className="templesOnly_svg__cls-1534"
          />
          <path
            d="M99 45.05h-1v-1c.2-2 2.14-.31 2.93-1.37s1.54-2 3.07-1.63c-.34.67-.67 1.34-1 2v1h-1c-.95.39-2.5-.92-3 1"
            className="templesOnly_svg__cls-1535"
          />
          <path
            d="M47 67.05c.08-1.49 1.24-.85 2-1 .33.34.66.67 1 1v2l-2 1h3v1c-1-.38-2.54.93-3-1v-1c-.12-.75.53-1.91-1-2"
            className="templesOnly_svg__cls-1536"
          />
          <path
            d="M34 73.05v1c-1.5.09-.85 1.25-1 2a8.6 8.6 0 0 0-1 .77c-.37.38-.67.82-1 1.23v-3h-2v-.45c1.7-.53 3.37-1.04 5-1.55"
            style={{
              fill: "#d3a887",
            }}
          />
          <path
            d="M197.07 7.05v1l-1-1-1-1v-3h1l2 2c-1.5.08-.85 1.24-1 2"
            style={{
              fill: "#91400f",
            }}
          />
          <path
            d="m19 80.05 1 1 1 1v2h-1l-.33-.83-.67.83-1-1c-.16-.75.49-1.91-1-2 .12-1.49 1.28-.85 2-1"
            className="templesOnly_svg__cls-1539"
          />
          <path
            d="M58 62.05h3v3l-1 1h-1c-.34-.33-.67-.66-1-1l.85-1.5Z"
            style={{
              fill: "#8a3f14",
            }}
          />
          <path
            d="m18 83.05 1 1v1c-1.5.09-.85 1.25-1 2h-2v-1c.38-.47.75-1 1.58-2H14v-1z"
            style={{
              fill: "#853804",
            }}
          />
          <path
            d="M4 87.05a4.62 4.62 0 0 1 4-2v1l-1 2-1 1H5c-.12-.75.53-1.91-1-2"
            style={{
              fill: "#a9673d",
            }}
          />
          <path
            d="M65 58.05v1l1 1v3h-1l-.43-2.43-.57 1.43h-1a4.6 4.6 0 0 1 2-4"
            className="templesOnly_svg__cls-1543"
          />
          <path
            d="M27 77.05v-1c1 .39 2.53-.92 3 1v1l-1 1h-2Z"
            style={{
              fill: "#7b3503",
            }}
          />
          <path
            d="M191.07 2.05v-2c1.27 0 2.55-.08 3.8 0 .43.05.8.63 1.2 1a19 19 0 0 0-2.82 0c-.43.07-.79.63-1.18 1v1h-1Z"
            className="templesOnly_svg__cls-1545"
          />
          <path
            d="M14 83.05v2l1 1v1h-2v-2c-.09-1.49-1.25-.85-2-1 .5-1.92 2.05-.61 3-1"
            style={{
              fill: "#8f4f2c",
            }}
          />
          <path
            d="M2 99.05c.15-.75-.5-1.91 1-2 .08 1.5 1.24.85 2 1v2c-.95-.38-2.5.95-3-1"
            className="templesOnly_svg__cls-1547"
          />
          <path
            d="M192.07 3.05v-1h4v1h-1l-1 1h-2Z"
            style={{
              fill: "#843e12",
            }}
          />
          <path
            d="M145.07 21.05v1l-1 1-1 1-2-1a4.58 4.58 0 0 1 4-2"
            style={{
              fill: "#50200a",
            }}
          />
          <path
            d="M119.07 33.05h4.58l-1.58 2-1-1h-3Z"
            style={{
              fill: "#5f1e00",
            }}
          />
          <path
            d="M114.07 36.05v-1c.47-1.93 2-.62 3-1v1c-.47 1.95-2.01.62-3 1"
            className="templesOnly_svg__cls-1551"
          />
          <path
            d="M54 64.05a2.47 2.47 0 0 1 3-2v1l-1 1v1h-1Z"
            className="templesOnly_svg__cls-1552"
          />
          <path
            d="M57 63.05v-1h1l.85 1.5-.85 1.5h-2v-1Z"
            style={{
              fill: "#7e3811",
            }}
          />
          <path
            d="m54 64.05 1 1-1 1h-2v-1c.12-1.49 1.28-.85 2-1"
            style={{
              fill: "#76350f",
            }}
          />
          <path
            d="m50 67.05-1-1h3c.28.57.57 1.14 1 2h-2Z"
            style={{
              fill: "#7b3207",
            }}
          />
          <path
            d="M4 92.05c-.76-.15-1.92.5-2-1v-1h2l1 1Z"
            style={{
              fill: "#97572e",
            }}
          />
          <path
            d="M27 77.05v3h-1c-.16-.75.49-1.91-1-2h-1c.5-1.92 2.05-.61 3-1"
            style={{
              fill: "#8c5122",
            }}
          />
          <path
            d="M30 77.05c-.47-1.92-2-.61-3-1 .08-1.49 1.24-.85 2-1h2v2Z"
            style={{
              fill: "#864e2c",
            }}
          />
          <path
            d="M106.07 39.05c.33.39.89.75 1 1.18a19 19 0 0 1 0 2.82v1l-1-1z"
            className="templesOnly_svg__cls-1559"
          />
          <path
            d="M18 83.05h-3a8 8 0 0 1 .76-1c.38-.37.82-.67 1.24-1 1.53.09.88 1.25 1 2"
            className="templesOnly_svg__cls-1560"
          />
          <path
            d="M83 52.05h-1c.15-.75-.5-1.91 1-2 .75.15 1.91-.49 2 1h-1Z"
            style={{
              fill: "#69371c",
            }}
          />
          <path
            d="M161.07 13.05h1l-1 1h-3c.47-1.93 2.02-.62 3-1"
            className="templesOnly_svg__cls-1562"
          />
          <path
            d="M196.07 2.05h-4c.39-.33.75-.89 1.18-1a19 19 0 0 1 2.82 0Z"
            style={{
              fill: "#71391e",
            }}
          />
          <circle
            cx={9.04}
            cy={114.05}
            r={1.41}
            style={{
              fill: "#866041",
            }}
          />
          <path
            d="M197.07 7.05c.15-.76-.5-1.92 1-2l1 1c-.07 1.49-1.24.85-2 1"
            style={{
              fill: "#8f3e02",
            }}
          />
          <path
            d="M195.07 38.05h1v3c-1.5-.09-.85-1.24-1-2Z"
            className="templesOnly_svg__cls-1566"
          />
          <path
            d="M98 44.05v4c-.7-1.39-.85-1.7-1-2v-1Z"
            style={{
              fill: "#792a09",
            }}
          />
          <path
            d="m194.07 57.05-1-1 1-1 1 1Z"
            className="templesOnly_svg__cls-1568"
          />
          <path
            d="M63 62.05h1v1l-1 1c-.34-.33-.67-.66-1-1v-1Z"
            style={{
              fill: "#c6804d",
            }}
          />
          <path
            d="M47 67.05c1.49.09.84 1.25 1 2l-2-1Z"
            className="templesOnly_svg__cls-1570"
          />
          <path
            d="M11 84.05c.75.15 1.91-.49 2 1h-3Z"
            className="templesOnly_svg__cls-1571"
          />
          <path
            d="M4 87.05c1.49.09.84 1.25 1 2H3Z"
            style={{
              fill: "#78441e",
            }}
          />
          <path d="M10 113.05H8l1-1h1Z" className="templesOnly_svg__cls-1573" />
          <path
            d="M5 100.05v-1c.33.34.66.67 1 1v1H5Z"
            style={{
              fill: "#611100",
            }}
          />
          <path
            d="M1 95.05H0v-2c1.53.09.88 1.25 1 2"
            style={{
              fill: "#68462d",
            }}
          />
          <path
            d="M2 90.05v1H0c.12-1.49 1.28-.85 2-1"
            style={{
              fill: "#743a15",
            }}
          />
          <path
            d="M38 72.05v1c-1.5-.08-.85-1.24-1-2h1ZM41 70.05c-.09 1.5-1.25.85-2 1 .12-1.49 1.28-.85 2-1M45 69.05c-.34-.33-.67-.66-1-1h2v1Z"
            className="templesOnly_svg__cls-1577"
          />
          <path d="M97 45.05v1h-2v-1Z" className="templesOnly_svg__cls-1578" />
          <path
            d="M158.07 16.05c-1.5-.09-.85-1.24-1-2h1Z"
            className="templesOnly_svg__cls-1579"
          />
          <path d="M5 101.05h1l-1 1Z" className="templesOnly_svg__cls-1580" />
          <circle
            cx={3.54}
            cy={89.55}
            r={0.71}
            style={{
              fill: "#803c0f",
            }}
          />
          <circle
            cx={9.54}
            cy={85.55}
            r={0.71}
            className="templesOnly_svg__cls-1571"
          />
          <circle
            cx={8.54}
            cy={85.55}
            r={0.71}
            style={{
              fill: "#73330f",
            }}
          />
          <path
            d="m21 79.05.82.67-.82.33Z"
            style={{
              fill: "#733111",
            }}
          />
          <path
            d="M38 72.05v-1h1Z"
            style={{
              fill: "#783606",
            }}
          />
          <path d="M192.07 66.05h1v1Z" className="templesOnly_svg__cls-218" />
          <path d="M52 66.05h-1l1-1Z" className="templesOnly_svg__cls-1585" />
          <circle
            cx={61.54}
            cy={62.55}
            r={0.71}
            className="templesOnly_svg__cls-1543"
          />
          <circle
            cx={105.57}
            cy={40.55}
            r={0.71}
            style={{
              fill: "#601a01",
            }}
          />
          <path d="M105.07 40.05v1h-1Z" className="templesOnly_svg__cls-1535" />
          <circle
            cx={117.57}
            cy={34.55}
            r={0.71}
            style={{
              fill: "#4b1300",
            }}
          />
          <path
            d="M171.07 15.05h1.46c1.39.56-.56 2.81 1.54 3v2l-1.5-.86-1.5.86-1-1 .87-1.61-.87-.39v-1Z"
            className="templesOnly_svg__cls-1588"
          />
          <path
            d="M176.07 14.05c.33-.67.67-1.33 1-2v-1h3v2l-.33.85-1.67-.9v2h-1Z"
            className="templesOnly_svg__cls-1589"
          />
          <path
            d="M168.07 15.05c.33-.67.67-1.33 1-2h1l1 1v1l-1 1h-2Z"
            style={{
              fill: "#692b0c",
            }}
          />
          <path
            d="M176.07 12.05h-2v-2h3v1Z"
            className="templesOnly_svg__cls-1589"
          />
          <path
            d="M174.07 19.05v-1c.38-1-.93-2.53 1-3v3Z"
            style={{
              fill: "#a54f24",
            }}
          />
          <path
            d="m176.07 14.05 1 1h-2Z"
            style={{
              fill: "#763203",
            }}
          />
          <path
            d="M174.07 10.05v2c-1.5-.09-.85-1.24-1-2Z"
            className="templesOnly_svg__cls-1503"
          />
          <path
            d="m171.07 14.05-1-1Z"
            style={{
              fill: "#682401",
            }}
          />
          <path
            d="m176.07 12.05 1-1v1Z"
            className="templesOnly_svg__cls-1588"
          />
          <path d="m172.07 9.05 1 1Z" className="templesOnly_svg__cls-1503" />
          <path
            d="M163.07 13.05c1.71-.08 3.44-.21 4 2h-1c-1.5.08-.85 1.24-1 2l-2-1Z"
            className="templesOnly_svg__cls-1562"
          />
          <path
            d="m163.07 16.05 2 1v4h-3c.33-.67.67-1.33 1-2Z"
            style={{
              fill: "#601d02",
            }}
          />
          <path
            d="M163.07 19.05c-.33.67-.67 1.33-1 2v1h-3c.3-.52.59-1 .86-1.5-.27-.46-.56-1-.86-1.5Z"
            style={{
              fill: "#5e1904",
            }}
          />
          <path
            d="M156.07 19.05c.37-.21.76-.39 1.12-.62.9-.6 1.64-.75 1.88.62l-3 2-1 1c-1.5-.09-.85-1.24-1-2l1-1Z"
            style={{
              fill: "#7b3810",
            }}
          />
          <path
            d="M159.07 14.05h2l-1.52 3.2c-.53-.44-1-.82-1.48-1.2 1.5-.05.85-1.24 1-2M156.07 19.05h-1l-1-1v-1h2Z"
            className="templesOnly_svg__cls-1579"
          />
          <ellipse
            cx={161.57}
            cy={17.55}
            rx={0.24}
            ry={0.71}
            style={{
              fill: "#7c3a20",
            }}
          />
          <path
            d="M185.07 8.05c.91-.94 1.82-1.88 2.92-3h1.08v1l-.83.33.83.67 1 1v1c-2.24.21-2.79.76-3 3v1h-3v-2h1l.45.95c0-1 1.62-2.41-.45-2.95Z"
            className="templesOnly_svg__cls-1598"
          />
          <path
            d="M183.07 5.05v-1c.76.15 1.92-.5 2 1l-1 1c.33.67.67 1.33 1 2h-7v-1c.76-.15 1.92.49 2-1l1.66.91Z"
            style={{
              fill: "#8f6b37",
            }}
          />
          <path
            d="M189.07 6.05v-2a8 8 0 0 0 1.05 0 .8.8 0 0 0-.15.14l.69.82.32-.32a6 6 0 0 0-.86-.64l.95-1h1v3c-.76.15-1.91-.5-2 1h-1Z"
            style={{
              fill: "#a0652f",
            }}
          />
          <path
            d="M190.07 4.05h-1v-2h2v1Z"
            className="templesOnly_svg__cls-1598"
          />
          <path
            d="m184.07 6.05 1-1Z"
            style={{
              fill: "#74460b",
            }}
          />
          <path
            d="M190.07 2.05h-1l.67-.83Z"
            className="templesOnly_svg__cls-1545"
          />
          <path
            d="m15 110.05 1-1h3v2a6.4 6.4 0 0 0-1.05.06l.15-.15-.7-.81-.31.31a5.5 5.5 0 0 0 .86.65 5.6 5.6 0 0 1 .05.94h-4v-1Z"
            style={{
              fill: "#b55d17",
            }}
          />
          <path
            d="M16 107.05c-2.09-.2-.19-2.38-1.39-2.93l-1.61.93v-2h1c1.49-.08.84-1.24 1-2h1z"
            style={{
              fill: "#a1521d",
            }}
          />
          <path
            d="M13 105.05a7.4 7.4 0 0 0 .59 2c.56.91 0 .9-.59 1h-1c-.34-1-.67-2-1-3z"
            className="templesOnly_svg__cls-17"
          />
          <path
            d="M11 105.05c.33 1 .66 2 1 3l-1 1a2.47 2.47 0 0 1 0-4"
            className="templesOnly_svg__cls-1518"
          />
          <path
            d="m11 109.05 1-1h1v2.6Z"
            style={{
              fill: "#b35e25",
            }}
          />
          <path
            d="M11 104.05v-2h2v1l-1 1Z"
            className="templesOnly_svg__cls-1605"
          />
          <path
            d="M18 109.05h-2l-.83-.67.83-.33h2Z"
            style={{
              fill: "#f29b55",
            }}
          />
          <path
            d="M14 111.05v1l-2 1v-2Z"
            className="templesOnly_svg__cls-1607"
          />
          <path
            d="M12 112.05v1h-2v-1z"
            style={{
              fill: "#904a0c",
            }}
          />
          <path d="M18 108.05h-2v-1h2Z" className="templesOnly_svg__cls-1609" />
          <path
            d="M11 102.05v1H9l1-1Z"
            style={{
              fill: "#9a501c",
            }}
          />
          <path
            d="M12 112.05h-1l1-1ZM15 110.05l-1 1Z"
            className="templesOnly_svg__cls-1573"
          />
          <circle
            cx={11.54}
            cy={104.55}
            r={0.71}
            className="templesOnly_svg__cls-1518"
          />
          <path
            d="M191.07 43.05v1c-.33.39-.88.75-.95 1.18a17.7 17.7 0 0 0-.05 2.82v2c-.76.15-1.91-.5-2 1l-1.9.34.07.66h1.83v1h-4v-3l2-2 .83-.33-.83-.67c-.76-.15-1.91.49-2-1v-2.6l-2 1.6h-5c.41-2.31 2.7-1.64 4-2.38v-1.62h1c.15.76-.5 1.91 1 2 .76-.15 1.92.49 2-1h4c.09 1.49 1.24.85 2 1m-6 2.33v.34h1v-.34Z"
            className="templesOnly_svg__cls-1611"
          />
          <path
            d="M190.07 50.05v-2h2l.39 1 1.32-1.07c.61 2.45.14 4.81.29 7.11h-1a15 15 0 0 1-1.23-1 8 8 0 0 1-.77-1c-.38-1.03.93-2.57-1-3.04"
            style={{
              fill: "#88360b",
            }}
          />
          <path
            d="M192.07 48.05h-2a17.7 17.7 0 0 1 .05-2.82c.07-.43.62-.79.95-1.18.33.39.89.75 1 1.18a19 19 0 0 1 0 2.82"
            style={{
              fill: "#7a2200",
            }}
          />
          <path
            d="M191.07 43.05c-.76-.15-1.91.49-2-1h3v1Z"
            style={{
              fill: "#a34713",
            }}
          />
          <path
            d="M192.07 43.05v-1h1c1.5.08.85 1.24 1 2Z"
            className="templesOnly_svg__cls-1611"
          />
          <path
            d="M194.07 44.05c1.5.08.85 1.24 1 2-1.5-.05-.85-1.24-1-2"
            className="templesOnly_svg__cls-1566"
          />
          <path
            d="M89 52.05h2v1l-1.9.34.07.66H91v1c-.76.15-1.92-.49-2 1h-1v-4Z"
            style={{
              fill: "#7f2f08",
            }}
          />
          <path
            d="M89 52.05h-1l-1 1-.76 1-1.24-1c.33-.66.66-1.33 1-2 1 .39 2.57-.92 3 1"
            style={{
              fill: "#98592e",
            }}
          />
          <path
            d="m92 50.05 1-1h2c-.09.87.44 2.07-1.24 2.05-.25 0-.51.62-.76.95h-2c.37-.66.7-1.33 1-2"
            className="templesOnly_svg__cls-1617"
          />
          <path
            d="M86 51.05c-.34.67-.67 1.34-1 2h-2v-1l1-1z"
            style={{
              fill: "#70380e",
            }}
          />
          <path
            d="m196.07 7.05 1 1v3c-1.5.08-.85 1.24-1 2v1l-2-1-1.93-1.56c.8-1 2.34-1.67 1.93-3.44l1-1Z"
            style={{
              fill: "#8a4019",
            }}
          />
          <path
            d="M198.07 19.05v4h-3v-1l2-2v-2h1Z"
            className="templesOnly_svg__cls-1620"
          />
          <path
            d="M196.07 13.05c.15-.76-.5-1.92 1-2h1v3h-1Z"
            style={{
              fill: "#8a3d0f",
            }}
          />
          <path
            d="M197.07 14.05h1c.33.67.67 1.33 1 2-1.5.08-.85 1.24-1 2h-1z"
            className="templesOnly_svg__cls-1622"
          />
          <path
            d="M198.07 18.05c.15-.76-.5-1.92 1-2-.15.76.5 1.95-1 2"
            style={{
              fill: "#843200",
            }}
          />
          <path
            d="M198.07 14.05v-2h1c-.15.76.5 1.95-1 2"
            className="templesOnly_svg__cls-1622"
          />
          <path
            d="M199.07 12.05h-1v-1Z"
            style={{
              fill: "#8d4f27",
            }}
          />
          <path
            d="M191.07 53.05a8 8 0 0 0 .77 1 15 15 0 0 0 1.23 1v1h-1l-1-1h-3c-.7-1.85-1.89-.87-2.93-.62l.93 1.62 1 1v1a5.34 5.34 0 0 1-4-1c.33-1 .67-2 1-3v-1z"
            className="templesOnly_svg__cls-1568"
          />
          <path
            d="M189.07 60.05c-.38 1 .93 2.53-1 3v-2h-2v-2h2Z"
            style={{
              fill: "#9d471e",
            }}
          />
          <path
            d="m191.07 55.05 1 1c-.33.67-.67 1.33-1 2h-2v-2c.76-.15 1.93.49 2-1"
            style={{
              fill: "#6e1f08",
            }}
          />
          <path
            d="M188.07 59.05h-5v-2a5.34 5.34 0 0 0 4 1h1Z"
            style={{
              fill: "#772c09",
            }}
          />
          <path
            d="M188.07 58.05h-1v-1l1-1h1v2Z"
            style={{
              fill: "#631a03",
            }}
          />
          <path
            d="M189.07 58.05h2l-1.24 1Z"
            style={{
              fill: "#893e1c",
            }}
          />
          <path
            d="m194 60.15-.82-.69.32-.32.7.82Z"
            style={{
              fill: "#7d3310",
            }}
          />
          <path
            d="M195.07 23.05h1v1c-1.93.47-.62 2-1 3h-2a5.34 5.34 0 0 1 1-4Z"
            style={{
              fill: "#9f501d",
            }}
          />
          <path
            d="M195.07 27.05c.38-1-.93-2.53 1-3 1.41.26 1.14 1 .61 1.93a9.8 9.8 0 0 0-.61 2.07h-1Z"
            style={{
              fill: "#9b3c07",
            }}
          />
          <path
            d="M195.07 28.05h2v2h-1l-1.83-1.61Z"
            style={{
              fill: "#741b00",
            }}
          />
          <path
            d="M198.07 23.05v-1c1.93.47.62 2 1 3-1.5-.05-.85-1.24-1-2"
            style={{
              fill: "#9f5120",
            }}
          />
          <path
            d="M197.07 30.05v-2h1l1 1v1Z"
            className="templesOnly_svg__cls-1635"
          />
          <path
            d="m199 27.27 1.92-.16.08.64-1.95.39Z"
            style={{
              fill: "#ad4d16",
            }}
          />
          <path
            d="m199.07 29.05-1-1h1ZM199.07 25.05l1 1Z"
            className="templesOnly_svg__cls-1637"
          />
          <path
            d="M178.07 7.05v1a9 9 0 0 1-.76 1 15 15 0 0 1-1.24 1h-2c.51-2.05 2.7-1.96 4-3M183.07 5.05 181.73 7l-1.66-.91c.47-1.97 2.02-.66 3-1.04M180.07 6.05c-.08 1.49-1.24.85-2 1 .09-1.5 1.24-.85 2-1"
            className="templesOnly_svg__cls-1503"
          />
          <path
            d="M107 44.05v-1c1-.38 2.53.93 3-1h1c.56 2.22 2.29 2.08 4 2v1a17.7 17.7 0 0 0-2.82.05c-.44.07-.79.62-1.18.95l-1 1h-4l1-1c.75-.15 1.91.5 2-1l.82-.33-.82-.67Z"
            className="templesOnly_svg__cls-1638"
          />
          <path
            d="M117.07 35.05h1v2h-3v3h-1l-1-1v-3h1c.99-.38 2.53.95 3-1"
            style={{
              fill: "#682001",
            }}
          />
          <path
            d="M113.07 37.05v2l-1.55-.86-1.45 2.86a6.5 6.5 0 0 1-1.8-1.39c-.43-.67-.43-1.55.8-1.61l.33.83.67-.83c.09-1.5 1.24-.85 2-1Z"
            style={{
              fill: "#873707",
            }}
          />
          <path
            d="m110.07 41.05 1.45-2.86 1.55.86 1 1v1h-1c-.76.15-1.91-.5-2 1h-1Z"
            style={{
              fill: "#883f12",
            }}
          />
          <path
            d="m110.07 38.05-.67.83-.33-.83Z"
            style={{
              fill: "#762a00",
            }}
          />
          <path
            d="M113.07 37.05h-1l1-1Z"
            className="templesOnly_svg__cls-1551"
          />
          <path
            d="M165.07 17.05c.15-.76-.5-1.92 1-2l.33.83.67-.83h1v2z"
            style={{
              fill: "#471500",
            }}
          />
          <path
            d="M118.07 37.05v-1h2v-2h1l1 1v1l-1 1-1 1h-2Z"
            className="templesOnly_svg__cls-1644"
          />
          <path
            d="M128.07 37.05v-3h1c.09 1.49 1.24.85 2 1l-1 1c-1.5.08-.85 1.24-1 2h-1Z"
            style={{
              fill: "#642003",
            }}
          />
          <path
            d="M122.07 36.05h2v2c-.76-.15-1.91.49-2-1Z"
            style={{
              fill: "#591200",
            }}
          />
          <path
            d="M125.07 35.05c1.5-.09.85-1.24 1-2h1v3.6ZM124.07 38.05l2-1v2h-2ZM128.07 37.05v2h-1v-2Z"
            className="templesOnly_svg__cls-1647"
          />
          <ellipse
            cx={126.57}
            cy={38.05}
            className="templesOnly_svg__cls-825"
            rx={0.71}
            ry={1.41}
          />
          <circle
            cx={127.57}
            cy={33.55}
            r={0.71}
            style={{
              fill: "#975624",
            }}
          />
          <path
            d="M36 76.05h3c.33.34.66.67 1 1h1c-.42.34-.86.64-1.24 1a8 8 0 0 0-.76 1h-1v-2h-4v-2h1ZM41 75.05v-1h1l1-1h2l-1 2v1h-2Z"
            className="templesOnly_svg__cls-1519"
          />
          <path
            d="M41 77.05h-1l-1-1c.08-1.49 1.24-.85 2-1 .33.34.66.67 1 1v1Z"
            style={{
              fill: "#833306",
            }}
          />
          <path
            d="m36 76.05-1-1v-1c1.53.09.88 1.25 1 2"
            className="templesOnly_svg__cls-1650"
          />
          <path
            d="M42 74.05h-1v-1l1-1Z"
            className="templesOnly_svg__cls-1577"
          />
          <circle
            cx={34.54}
            cy={74.55}
            r={0.71}
            style={{
              fill: "#7b3905",
            }}
          />
          <path
            d="M195.07 38.05v1h-2l-1-1v-4h1c1.65.16.81 1.44 1 2.25s-.34 1.7 1 1.75"
            style={{
              fill: "#9d4312",
            }}
          />
          <path
            d="m192.07 38.05 1 1v3h-3c.33-.67.67-1.33 1-2 1.5-.05.85-1.24 1-2"
            style={{
              fill: "#a34709",
            }}
          />
          <path
            d="M128.07 33.05h-2l3-3 1 1v2Z"
            className="templesOnly_svg__cls-1654"
          />
          <path
            d="m130.07 31.05-1-1v-1h1Z"
            className="templesOnly_svg__cls-1655"
          />
          <path
            d="M65 63.05h1l1-.75-1-1.25v-1l.82-.33-.82-.67 2-1.59v2.59c.15.76-.5 1.92 1 2h2v1l-1 1-1 1h-2c-1.5.09-.85 1.25-1 2h-1c-.09-1.49-1.25-.85-2-1v-1h2Z"
            className="templesOnly_svg__cls-1656"
          />
          <path
            d="M73 58.05c.66.67 1.33 1.34 2 2l-3 1v-1c-.34-.33-.67-.66-1-1v-1Z"
            style={{
              fill: "#95420f",
            }}
          />
          <path
            d="M70 59.05c-.39-.47-.77-.95-1.6-2H71v1Z"
            className="templesOnly_svg__cls-1658"
          />
          <path
            d="M69 62.05c-1.5-.08-.85-1.24-1-2 .75.15 1.91-.49 2 1Z"
            className="templesOnly_svg__cls-1659"
          />
          <path
            d="M71 63.05v-2h1v2Z"
            style={{
              fill: "#772700",
            }}
          />
          <path d="M71 61.05v1h-2l1-1Z" className="templesOnly_svg__cls-1661" />
          <path
            d="M73 56.05v1h-2c.12-1.49 1.28-.85 2-1"
            className="templesOnly_svg__cls-1658"
          />
          <path
            d="M71 59.05c.33.34.66.67 1 1Z"
            style={{
              fill: "#a85b2a",
            }}
          />
          <path d="m66 60.05-1-1h1Z" className="templesOnly_svg__cls-1656" />
          <path
            d="m70 59.05 1-1v1Z"
            style={{
              fill: "#7b2e00",
            }}
          />
          <path
            d="M10 100.05H7l1-1h3v1Z"
            style={{
              fill: "#98491a",
            }}
          />
          <circle
            cx={10.54}
            cy={101.55}
            r={0.71}
            style={{
              fill: "#8f4413",
            }}
          />
          <circle
            cx={10.54}
            cy={100.55}
            r={0.71}
            style={{
              fill: "#b36636",
            }}
          />
          <path d="M6 101.05v-1h1Z" className="templesOnly_svg__cls-1580" />
          <path
            d="M45 73.05h-2v-1l1-1h1z"
            style={{
              fill: "#893c11",
            }}
          />
          <path
            d="M43 72.05v1l-1 1v-2Z"
            style={{
              fill: "#9b4f24",
            }}
          />
          <path d="M45 69.05h1v2h-1Z" className="templesOnly_svg__cls-1536" />
          <path
            d="m43.94 71.16-.81-.7.31-.31.7.81Z"
            style={{
              fill: "#6e2000",
            }}
          />
          <path
            d="M154.07 20.05c.15.76-.5 1.91 1 2a15 15 0 0 0-1.23 1 8 8 0 0 0-.77 1h-2c-.33-.67-.67-1.33-1-2h1a5 5 0 0 0 1-1.27c.22-.67-.31-1.72 1-1.73Z"
            className="templesOnly_svg__cls-1670"
          />
          <path
            d="m154.07 20.05-1-1 1-1 1 1Z"
            style={{
              fill: "#591500",
            }}
          />
          <path
            d="M93 52.05c.25-.33.51-.95.76-.95 1.68 0 1.15-1.18 1.24-2.05h1l.32.83.68-.83h1l1 1v1h-1l-1 1h-1l-1 1h-1Z"
            style={{
              fill: "#762904",
            }}
          />
          <path
            d="M98 49.05c.33-.66.66-1.33 1-2h1l1 1v1Z"
            style={{
              fill: "#732101",
            }}
          />
          <path
            d="M100 47.05h-1v-2h2v1Z"
            style={{
              fill: "#924a29",
            }}
          />
          <path
            d="m97 49.05-.68.83-.32-.83Z"
            className="templesOnly_svg__cls-1617"
          />
          <path
            d="M94 49.05h-1v-1Z"
            style={{
              fill: "#782f04",
            }}
          />
          <path
            d="M95 46.05h1l-.68.83Z"
            className="templesOnly_svg__cls-1534"
          />
          <path
            d="M77 58.05v-1h4v4h-1c-.09-1.49-1.25-.85-2-1v-1c-.3-.33-.63-.66-1-1"
            style={{
              fill: "#a1501d",
            }}
          />
          <path
            d="M83 53.05h1v5h-1c-.34-.33-.67-.66-1-1v-3Z"
            style={{
              fill: "#854517",
            }}
          />
          <path
            d="M82 54.05v2h-1c.19-.75-.46-1.91 1-2"
            style={{
              fill: "#753b11",
            }}
          />
          <circle
            cx={81.54}
            cy={56.55}
            r={0.71}
            style={{
              fill: "#733100",
            }}
          />
          <path
            d="M24 81.05c.08-1.49 1.24-.85 2-1v2h-2Z"
            style={{
              fill: "#a44f25",
            }}
          />
          <path
            d="M24 81.05v1l-1 1c-.34-.33-.67-.66-1-1 .12-1.49 1.28-.85 2-1"
            className="templesOnly_svg__cls-1681"
          />
          <circle
            cx={21.54}
            cy={82.55}
            r={0.71}
            className="templesOnly_svg__cls-1681"
          />
          <path d="m21 82.05-1-1Z" className="templesOnly_svg__cls-1681" />
          <path
            d="M24 78.05h1l-.68.83Z"
            style={{
              fill: "#71380b",
            }}
          />
          <path
            d="M4 96.05v-1c.08-1.49 1.24-.85 2-1l1-1h1v2H7l-1 1z"
            style={{
              fill: "#af6e43",
            }}
          />
          <path
            d="M6 93.05c-.76-.15-1.92.5-2-1l1-1h2v2Z"
            style={{
              fill: "#853c12",
            }}
          />
          <path d="M6 93.05h1l-1 1Z" className="templesOnly_svg__cls-1685" />
          <path
            d="M78 59.05v1c.33.34.66.67 1 1v2h-4v-1l1-1 1-1Z"
            style={{
              fill: "#b75810",
            }}
          />
          <path
            d="M72 63.05v-2l3-1v2c-.76.15-1.92-.49-2 1Z"
            style={{
              fill: "#883002",
            }}
          />
          <path
            d="m78 59.05-1 1c-.34-.41-.67-.83-1-1.24l1-.76Z"
            style={{
              fill: "#af4c11",
            }}
          />
          <ellipse
            cx={72.04}
            cy={57.55}
            rx={1.41}
            ry={0.71}
            style={{
              fill: "#7f2a00",
            }}
          />
          <path d="M75 62.05v-1h1Z" className="templesOnly_svg__cls-1690" />
          <path
            d="m133.07 27.05 3-1h3v1l-1 1c-.61.11-1.23.18-1.82.33-.74.19-1.45.44-2.18.67l-1.83-1.61Z"
            className="templesOnly_svg__cls-1691"
          />
          <path
            d="M134.07 29.05c.73-.23 1.44-.48 2.18-.67.59-.15 1.21-.22 1.82-.33l-2 2h-2Z"
            style={{
              fill: "#83401a",
            }}
          />
          <ellipse
            cx={133.07}
            cy={31.55}
            rx={1.41}
            ry={0.71}
            style={{
              fill: "#8a4016",
            }}
          />
          <path
            d="M134.07 30.05h2c-.08 1.49-1.24.85-2 1Z"
            className="templesOnly_svg__cls-1691"
          />
          <path
            d="M131.07 29.05c1.5.08.85 1.24 1 2h-1Z"
            className="templesOnly_svg__cls-1655"
          />
          <ellipse
            cx={130.57}
            cy={30.05}
            rx={0.71}
            ry={1.41}
            style={{
              fill: "#620",
            }}
          />
          <path
            d="M196.07 30.05h1l1 1-1 1-1 1h-2v-3Z"
            style={{
              fill: "#7d270b",
            }}
          />
          <path
            d="m198.07 31.05-1-1h2v1Z"
            style={{
              fill: "#791e00",
            }}
          />
          <path
            d="m196.07 33.05 1-1Z"
            style={{
              fill: "#701c00",
            }}
          />
          <path
            d="m199.16 30.94.82.7-.32.32-.69-.82Z"
            style={{
              fill: "#752504",
            }}
          />
          <path
            d="m188.07 64.05 2 2-1 1-1-1z"
            style={{
              fill: "#712301",
            }}
          />
          <path
            d="M188.07 64.05v1h-1v-1l1-1Z"
            style={{
              fill: "#8d3408",
            }}
          />
          <path d="m191.07 64.05 1 1Z" className="templesOnly_svg__cls-218" />
          <path
            d="M10 113.05h2l2-1h2v1l-1 1c-1 .39-2.54-.92-3 1h-2Z"
            className="templesOnly_svg__cls-1573"
          />
          <path
            d="M14 122.05h-2v-1a2.46 2.46 0 0 1 2-3h1v1l-1 2Z"
            style={{
              fill: "#bc7d3e",
            }}
          />
          <path
            d="M14 118.05a2.46 2.46 0 0 0-2 3c-1.93-.46-.62-2-1-3l1-1h2Z"
            style={{
              fill: "#f2c594",
            }}
          />
          <path
            d="M12 115.05c.46-1.92 2-.61 3-1v1l-1 1h-2Z"
            style={{
              fill: "#f8b67c",
            }}
          />
          <path
            d="M12 116.05h2v1h-3Z"
            style={{
              fill: "#eaa76d",
            }}
          />
          <path
            d="M11 117.05h1l-1 1-.83-.67Z"
            style={{
              fill: "#dfb086",
            }}
          />
          <path
            d="M139.07 26.05h-3c1-1.54 3-1.09 4.23-2a4.2 4.2 0 0 0 .77-1l2 1v1l-3 1Z"
            className="templesOnly_svg__cls-1706"
          />
          <path
            d="M194.07 30.05v3h-1c.38-.99-.93-2.53 1-3"
            style={{
              fill: "#721800",
            }}
          />
          <circle
            cx={192.57}
            cy={33.55}
            r={0.71}
            className="templesOnly_svg__cls-1708"
          />
          <path
            d="m147.07 24.05 2-1 1 1v1l-3 1Z"
            className="templesOnly_svg__cls-1709"
          />
          <path
            d="m144.07 23.05 1-1c.76.15 1.92-.5 2 1z"
            style={{
              fill: "#5f1f01",
            }}
          />
          <path
            d="m150.07 24.05-1-1 1-1c.33.67.67 1.33 1 2Z"
            style={{
              fill: "#6c2c0f",
            }}
          />
          <circle
            cx={146.57}
            cy={23.55}
            r={0.71}
            className="templesOnly_svg__cls-1709"
          />
          <path
            d="M5 96.05h1v2H5c-.76-.15-1.92.5-2-1h1Z"
            className="templesOnly_svg__cls-1712"
          />
          <path d="m5 96.05-1 1v-1Z" className="templesOnly_svg__cls-1547" />
          <path
            d="m100 47.05 1-1 1-1v-1h1l1 1h1l-1 1-1 1-1 1-1 1v-1Z"
            style={{
              fill: "#7d320f",
            }}
          />
          <path
            d="M104.07 41.05h2v2h-3c.33-.67.67-1.33 1-2"
            style={{
              fill: "#681d06",
            }}
          />
          <path
            d="M102 44.05v1h-3c.5-1.92 2.05-.61 3-1"
            style={{
              fill: "#763d1c",
            }}
          />
          <path
            d="M103 43.05h1v2l-1-1Z"
            style={{
              fill: "#7c3210",
            }}
          />
          <path
            d="M46 71.05v-1h2c.46 1.93 2 .62 3 1h2c-.42.34-.86.64-1.24 1a8 8 0 0 0-.76 1l-5 1-1-1v-1Z"
            className="templesOnly_svg__cls-1570"
          />
          <path
            d="M53 71.05h-1l-1-1c-.34-.33-.67-.66-1-1v-1h3c-.44-.86-.73-1.43-1-2h2v1c.08 1.5 1.24.85 2 1v1c-1.5.09-.85 1.25-1 2h-1c-.12-.63-.23-1.26-.34-1.9l-.66.08Z"
            className="templesOnly_svg__cls-1585"
          />
          <path
            d="M48 70.05h-2v-2l2 1Z"
            style={{
              fill: "#7f3303",
            }}
          />
          <path
            d="M50 69.05c.33.34.66.67 1 1h-3Z"
            style={{
              fill: "#ac6034",
            }}
          />
          <path
            d="m51 70.05 1 1h-1Z"
            style={{
              fill: "#7b2409",
            }}
          />
          <path
            d="M51 68.05h-1v-1c.37.34.7.67 1 1"
            style={{
              fill: "#732d00",
            }}
          />
          <path
            d="M31 78.05c.33-.41.63-.85 1-1.23a8.6 8.6 0 0 1 1-.77v3h-1c-.3-.33-.63-.66-1-1M34 74.05v2h-1c.19-.75-.46-1.91 1-2"
            className="templesOnly_svg__cls-1721"
          />
          <circle
            cx={30.54}
            cy={77.55}
            r={0.71}
            className="templesOnly_svg__cls-1722"
          />
          <path
            d="m194.07 4.05 1-1v3h-1z"
            style={{
              fill: "#924a23",
            }}
          />
          <path
            d="M196.07 7.05h-1v-1Z"
            style={{
              fill: "#94481a",
            }}
          />
          <path
            d="M20 84.05h2v1h-2Z"
            style={{
              fill: "#803202",
            }}
          />
          <circle
            cx={21.54}
            cy={83.55}
            r={0.71}
            className="templesOnly_svg__cls-1726"
          />
          <path
            d="m19 84.05.67-.83.33.83Z"
            style={{
              fill: "#a35b28",
            }}
          />
          <path
            d="M56 65.05h2c.33.34.66.67 1 1l-1 1h-2c-.34-.33-.67-.66-1-1v-1Z"
            style={{
              fill: "#9a481c",
            }}
          />
          <path
            d="m58 67.05 1-1h1l.32.83.68-.83h1v2h-3c-.3-.33-.63-.66-1-1"
            className="templesOnly_svg__cls-1729"
          />
          <path
            d="M61 63.05h1c.33.34.66.67 1 1l-1 1h-1Z"
            style={{
              fill: "#833d0b",
            }}
          />
          <path
            d="m60 66.05 1-1v1Z"
            style={{
              fill: "#803307",
            }}
          />
          <path
            d="M16 87.05h1v3l-3 2h-1c-.34-.33-.67-.66-1-1h-1v-1l3-2c.79-.15 2 .5 2-1"
            className="templesOnly_svg__cls-1732"
          />
          <path
            d="M17 88.05v-1h3v2c-.09 1.5-1.25.85-2 1v-1l2-1Z"
            className="templesOnly_svg__cls-1605"
          />
          <path
            d="M14 85.05v-1h3.58c-.83 1-1.2 1.53-1.58 2h-1Z"
            style={{
              fill: "#9e5729",
            }}
          />
          <path
            d="M19 87.05h-1c.15-.75-.5-1.91 1-2h1v1Z"
            style={{
              fill: "#7d2d03",
            }}
          />
          <circle
            cx={15.54}
            cy={86.55}
            r={0.71}
            className="templesOnly_svg__cls-1732"
          />
          <circle
            cx={19.54}
            cy={84.55}
            r={0.71}
            className="templesOnly_svg__cls-1539"
          />
          <path
            d="M7 93.05v-2H5l-1-1v-1h2c.33.34.66.67 1 1h3v1c-.76.15-1.92-.49-2 1v1Z"
            className="templesOnly_svg__cls-1685"
          />
          <path
            d="M8 90.05H7v-2l1-2h2l1 2H9c-1.46.09-.81 1.25-1 2"
            style={{
              fill: "#994e22",
            }}
          />
          <path
            d="M7 88.05v2c-.34-.33-.67-.66-1-1Z"
            style={{
              fill: "#c07140",
            }}
          />
          <path
            d="m66 61.05 1 1.25-1 .75Z"
            className="templesOnly_svg__cls-1737"
          />
          <path
            d="M64 63.05v-1l.57-1.43.43 2.43Z"
            style={{
              fill: "#81440c",
            }}
          />
          <path
            d="M30 78.05h1c.33.34.66.67 1 1l.32.83.68-.83v-2h1v1c.15.76-.5 1.92 1 2v1c-.76.15-1.92-.49-2 1v1h-1c-.34-.33-.67-.66-1-1-.76.15-1.92-.49-2 1h-3v-1h1l1-1v-2h1c.15.31.31.62 1 2Z"
            style={{
              fill: "#89350e",
            }}
          />
          <path
            d="M30 78.05v3c-.69-1.38-.85-1.69-1-2Z"
            className="templesOnly_svg__cls-1722"
          />
          <circle
            cx={27.54}
            cy={79.55}
            r={0.71}
            style={{
              fill: "#af6935",
            }}
          />
          <path
            d="m14 121.05 1-2h3v1c-.76.15-1.92-.49-2 1z"
            style={{
              fill: "#933f0a",
            }}
          />
          <path
            d="M9 88.05h2l-1-2v-1h1l.32.83.68-.83h1v2l-2 1h3l-3 2c-.34-.33-.67-.66-1-1H9Z"
            style={{
              fill: "#853407",
            }}
          />
          <path
            d="M14 88.05h-3l2-1h3c0 1.5-1.21.85-2 1"
            style={{
              fill: "#782b04",
            }}
          />
          <path
            d="m14 85.05 1 1Z"
            style={{
              fill: "#b5714a",
            }}
          />
          <path
            d="M5 98.05h3v1l-1 1H6c-.34-.33-.67-.66-1-1Z"
            style={{
              fill: "#742300",
            }}
          />
          <ellipse
            cx={193.07}
            cy={4.55}
            className="templesOnly_svg__cls-1560"
            rx={1.41}
            ry={0.71}
          />
          <path d="m143.07 24.05 1-1Z" className="templesOnly_svg__cls-1706" />
          <path
            d="M120.07 34.05v2h-2v-2ZM122.07 35.05l-1-1Z"
            className="templesOnly_svg__cls-1513"
          />
          <path
            d="m57 63.05-1 1Z"
            style={{
              fill: "#703108",
            }}
          />
          <path d="M55 65.05v1h-1Z" className="templesOnly_svg__cls-1585" />
          <path d="m5 91.05-1 1Z" className="templesOnly_svg__cls-1524" />
          <path
            d="M27 80.05h1v1h-2v-1Z"
            style={{
              fill: "#b45c30",
            }}
          />
          <path
            d="M105 43.05h1c.33.34.66.67 1 1v1h-2Z"
            style={{
              fill: "#7e2c0f",
            }}
          />
          <path
            d="m84 51.05-1 1Z"
            style={{
              fill: "#511f04",
            }}
          />
          <path
            d="M159.07 14.05c-.15.76.5 1.91-1 2v-2Z"
            style={{
              fill: "#4a1908",
            }}
          />
          <path
            d="M193.07 56.05v-1h1Z"
            style={{
              fill: "#702100",
            }}
          />
          <path
            d="M64 63.05h1v2h-2v-1Z"
            className="templesOnly_svg__cls-1737"
          />
          <path
            d="m12 85.05-.68.83-.32-.83Z"
            style={{
              fill: "#722900",
            }}
          />
          <path
            d="m171.07 20.05 1.5-.86 1.5.86 1 1a8 8 0 0 0 .05 1l-.14-.15-.82.7.32.32a6 6 0 0 0 .64-.87 7 7 0 0 1 .95 0v2l-1 1h-3l.87-1.61-.87-.39 1-2h-2Z"
            style={{
              fill: "#591902",
            }}
          />
          <path
            d="M168.07 17.05v-1h1l1 1 .87.39-.87 1.61h-1l-1-1Z"
            style={{
              fill: "#521e01",
            }}
          />
          <path
            d="m174.07 19.05 1-1h1c-.15.76.5 1.91-1 2h-1Z"
            style={{
              fill: "#a14d33",
            }}
          />
          <path
            d="M169.07 19.05h1l1 1v1h-1l-1-1Z"
            style={{
              fill: "#7e4720",
            }}
          />
          <path
            d="m170.07 17.05-1-1h1Z"
            style={{
              fill: "#6b3217",
            }}
          />
          <path
            d="m170.07 16.05 1-1Z"
            style={{
              fill: "#5b1900",
            }}
          />
          <path
            d="M176.07 10.05a15 15 0 0 0 1.24-1 9 9 0 0 0 .76-1h1l.33.83.67-.83h5v3h-1v-1l-.33-.83-.67.83-1 1c-1.5.08-.85 1.24-1 2h-1v-2h-2l-1-1Z"
            style={{
              fill: "#7c4420",
            }}
          />
          <path
            d="M180.07 13.05h1v1l1 2h-3l-1-1V13l1.67.89Z"
            style={{
              fill: "#622602",
            }}
          />
          <path
            d="m178.07 15.05 1 1-3 1v-2z"
            style={{
              fill: "#732600",
            }}
          />
          <path
            d="m177.07 10.05 1 1h-1Z"
            className="templesOnly_svg__cls-1588"
          />
          <path
            d="M176.07 16.05v2h-1v-2Z"
            style={{
              fill: "#9d471d",
            }}
          />
          <circle
            cx={175.57}
            cy={15.55}
            r={0.71}
            className="templesOnly_svg__cls-1501"
          />
          <path
            d="m167.07 15.05-.67.83-.33-.83Z"
            style={{
              fill: "#350300",
            }}
          />
          <path
            d="M169.07 19.05v1h-2l-1 1h-1v-2c.76-.15 1.92.49 2-1h1Z"
            style={{
              fill: "#5b2507",
            }}
          />
          <path
            d="M165.07 21.05h1c-.39.33-.75.88-1.18.95a17.7 17.7 0 0 1-2.82.05v-1ZM167.07 18.05c-.08 1.49-1.24.85-2 1v-1z"
            className="templesOnly_svg__cls-1765"
          />
          <circle
            cx={165.57}
            cy={17.55}
            r={0.71}
            className="templesOnly_svg__cls-1562"
          />
          <path
            d="M159.07 22.05h2v1l-1 1-2 1h-3v-1h1a2.46 2.46 0 0 0 3-2"
            style={{
              fill: "#762f0e",
            }}
          />
          <path
            d="m156.07 21.05 3-2c.3.52.59 1 .86 1.5-.27.46-.56 1-.86 1.5l-3 1Z"
            style={{
              fill: "#6f2606",
            }}
          />
          <circle
            cx={161.57}
            cy={22.55}
            r={0.71}
            className="templesOnly_svg__cls-1765"
          />
          <path
            d="M156.07 21.05v3h-3a8 8 0 0 1 .77-1 15 15 0 0 1 1.23-1Z"
            style={{
              fill: "#5f1a01",
            }}
          />
          <path
            d="M194.07 8.05c.41 1.77-1.13 2.45-1.93 3.44l1.93 1.56h-1l-1 1-2-1v-5l2-1c.09 1.49 1.24.85 2 1"
            style={{
              fill: "#813d0f",
            }}
          />
          <path
            d="M181.07 14.05v-1c.15-.76-.5-1.92 1-2v2h4v1z"
            className="templesOnly_svg__cls-1589"
          />
          <path
            d="M190.07 9.05v1l-1 1-1 1h-1c.21-2.24.76-2.79 3-3"
            style={{
              fill: "#a77130",
            }}
          />
          <path
            d="M184.07 13.05h-2v-2l1-1h1z"
            style={{
              fill: "#662e07",
            }}
          />
          <path
            d="M185.07 11.05v-2c2.07.54.41 1.91.45 2.95Z"
            className="templesOnly_svg__cls-1503"
          />
          <path
            d="M187.07 12.05h2v1h-2Z"
            className="templesOnly_svg__cls-1772"
          />
          <circle
            cx={186.57}
            cy={13.55}
            r={0.71}
            className="templesOnly_svg__cls-1772"
          />
          <path
            d="M189.07 7.05h1v1Z"
            style={{
              fill: "#d2985a",
            }}
          />
          <path
            d="M189.07 6.05v1l-.83-.67Z"
            style={{
              fill: "#925b1e",
            }}
          />
          <path
            d="m180.07 8.05-.67.83-.33-.83Z"
            className="templesOnly_svg__cls-1589"
          />
          <path
            d="M192.07 5.05h2v1l-1 1h-1z"
            style={{
              fill: "#8d4f23",
            }}
          />
          <path
            d="M192.07 6.05v1l-2 1v-1c.09-1.5 1.24-.85 2-1"
            style={{
              fill: "#b77d42",
            }}
          />
          <path
            d="m190.16 3.94.82.7-.32.32-.66-.82Z"
            style={{
              fill: "#814310",
            }}
          />
          <path d="M18 112.05v-1h3v1Z" className="templesOnly_svg__cls-1778" />
          <path
            d="M16 113.05v-1h2v2h-1c-.3-.33-.63-.66-1-1"
            className="templesOnly_svg__cls-1779"
          />
          <path d="M21 111.05h-2v-1h2Z" className="templesOnly_svg__cls-1609" />
          <path
            d="m17.94 111.16-.81-.7.31-.31.7.81Z"
            style={{
              fill: "#a34505",
            }}
          />
          <path
            d="M20 110.05h-1v-1Z"
            style={{
              fill: "#b7560f",
            }}
          />
          <circle
            cx={18.54}
            cy={108.55}
            r={0.71}
            className="templesOnly_svg__cls-1609"
          />
          <path
            d="M18 107.05h-1c-.16-.75.49-1.91-1-2v-3h1c.15.76-.5 1.92 1 2Z"
            style={{
              fill: "#8e2f01",
            }}
          />
          <path
            d="M17 102.05h-1v-1c.75-.15 1.91.5 2-1h2l-1 2z"
            style={{
              fill: "#7a2f07",
            }}
          />
          <path
            d="M18 100.05c-.09 1.5-1.25.85-2 1h-2v-2h1c.33.34.66.67 1 1z"
            style={{
              fill: "#8b451a",
            }}
          />
          <path
            d="M16 105.05c1.49.09.84 1.25 1 2h-1Z"
            style={{
              fill: "#863100",
            }}
          />
          <path
            d="M12 105.05v-1l1-1v2Z"
            style={{
              fill: "#8e3f0c",
            }}
          />
          <path
            d="M14 101.05h1c-.16.76.49 1.92-1 2Z"
            style={{
              fill: "#c67b45",
            }}
          />
          <path
            d="M14 101.05v2h-1v-2Z"
            style={{
              fill: "#af6330",
            }}
          />
          <path
            d="M13 101.05v1h-2v-1l1-1h1Z"
            style={{
              fill: "#95451c",
            }}
          />
          <circle
            cx={18.54}
            cy={107.55}
            r={0.71}
            className="templesOnly_svg__cls-1790"
          />
          <path
            d="M181.07 41.05v1.62c-1.3.74-3.59.07-4 2.38h-3l-1-1v-1c2.68.55 4.8-.88 7-2Z"
            className="templesOnly_svg__cls-1791"
          />
          <path
            d="M178.07 45.05h4l1 1a2.46 2.46 0 0 0-2 3h-1v-2l-1-1h-1Z"
            style={{
              fill: "#d98f4d",
            }}
          />
          <path
            d="M187.07 42.05h-2v-2c2.3-.74.25-1.78.17-3h1.83v1c.15.76-.5 1.91 1 2-.33.67-.67 1.33-1 2"
            style={{
              fill: "#954615",
            }}
          />
          <path
            d="M182.07 41.05h-1v-5h1v1l.34 1.9.66-.07v-1.83h1v3c-.76.15-1.91-.5-2 1"
            style={{
              fill: "#ce8b4f",
            }}
          />
          <path
            d="M184.07 46.05c.09 1.49 1.24.85 2 1v1c-.76.15-1.91-.5-2 1h-1v-3Z"
            style={{
              fill: "#8e3a09",
            }}
          />
          <path
            d="M183.07 49.05h1v4h-1z"
            style={{
              fill: "#ac5d30",
            }}
          />
          <path
            d="M187.07 42.05c.33-.67.67-1.33 1-2h1v2Z"
            style={{
              fill: "#ae5422",
            }}
          />
          <path
            d="M184.07 46.05h-1l-1-1 2-1.6Z"
            className="templesOnly_svg__cls-1791"
          />
          <path
            d="M184.07 50.05v-1c.09-1.5 1.24-.85 2-1Z"
            style={{
              fill: "#994215",
            }}
          />
          <path
            d="M188.07 52.05h-1.83l-.07-.66 1.9-.34Z"
            className="templesOnly_svg__cls-1568"
          />
          <path
            d="M188.07 51.05c.09-1.5 1.24-.85 2-1-.07 1.49-1.24.85-2 1"
            style={{
              fill: "#85390c",
            }}
          />
          <path
            d="M185.07 42.05c-.08 1.49-1.24.85-2 1v-1z"
            style={{
              fill: "#944a17",
            }}
          />
          <path
            d="M183.07 42.05v1c-1.5-.09-.85-1.24-1-2Z"
            style={{
              fill: "#803600",
            }}
          />
          <path
            d="M189.07 53.05h-1v-1Z"
            style={{
              fill: "#8c421a",
            }}
          />
          <path
            d="M186.07 48.05v-1l.83.67Z"
            style={{
              fill: "#9c451d",
            }}
          />
          <ellipse
            cx={185.57}
            cy={45.55}
            rx={0.71}
            ry={0.24}
            style={{
              fill: "#802d01",
            }}
          />
          <circle
            cx={177.57}
            cy={45.55}
            r={0.71}
            className="templesOnly_svg__cls-1791"
          />
          <path
            d="m189.07 53.05-1-1v-1c.76-.15 1.92.49 2-1 1.93.47.62 2 1 3Z"
            style={{
              fill: "#8a3f11",
            }}
          />
          <path
            d="M189.07 42.05v-4h1c.15.76-.5 1.91 1 2-.33.67-.67 1.33-1 2Z"
            style={{
              fill: "#ae5116",
            }}
          />
          <path
            d="M84 56.05v-3h1l1.24 1 .76-1h1v3h-2l-.33-.83-.67.83Z"
            style={{
              fill: "#7d360a",
            }}
          />
          <path
            d="M89 56.05c.08-1.49 1.24-.85 2-1l1 1-1 1h-1c-.3-.33-.63-.66-1-1"
            style={{
              fill: "#ae6634",
            }}
          />
          <path
            d="m92 56.05-1-1v-1h3v1Z"
            style={{
              fill: "#ad5b28",
            }}
          />
          <path
            d="M94 54.05h-2l-1-1v-1h2c.33.34.66.67 1 1Z"
            style={{
              fill: "#8f3312",
            }}
          />
          <path
            d="m91 53.05 1 1h-2.79l-.07-.66Z"
            style={{
              fill: "#802504",
            }}
          />
          <path d="M88 56.05h1v1l-1 1z" className="templesOnly_svg__cls-1812" />
          <path d="M88 53.05h-1l1-1Z" className="templesOnly_svg__cls-1506" />
          <path
            d="M197.07 14.05v3l-1-1v-3Z"
            style={{
              fill: "#9a491d",
            }}
          />
          <path
            d="M196.07 14.05v2h-1c-.33-1-.67-2-1-3Z"
            style={{
              fill: "#87390c",
            }}
          />
          <path
            d="m193.07 7.05 1-1h1v1l-1 1Z"
            style={{
              fill: "#7e3d12",
            }}
          />
          <path
            d="m197.07 20.05-2 2-1-1-.87-.39.87-1.61v-1h1l1 1Z"
            style={{
              fill: "#6f3312",
            }}
          />
          <path
            d="m197.07 20.05-1-1-1-1v-2h1l1 1z"
            style={{
              fill: "#8c4721",
            }}
          />
          <circle
            cx={194.57}
            cy={22.55}
            r={0.71}
            style={{
              fill: "#98542b",
            }}
          />
          <path
            d="M184.07 54.05c-.33 1-.67 2-1 3h-1v-3Z"
            style={{
              fill: "#7c320c",
            }}
          />
          <path
            d="m186.07 56.05-.93-1.62c1-.25 2.23-1.23 2.93.62v1Z"
            style={{
              fill: "#601800",
            }}
          />
          <path
            d="M188.07 56.05v-1h3c-.08 1.49-1.24.85-2 1Z"
            className="templesOnly_svg__cls-1821"
          />
          <path
            d="M186.07 56.05h2l-1 1Z"
            style={{
              fill: "#561100",
            }}
          />
          <path
            d="M184.07 54.05h-2v-1h2Z"
            style={{
              fill: "#7b2e01",
            }}
          />
          <path
            d="M182.07 57.05h1v2h2l1 1v1c-.15.76.5 1.91-1 2h-1c-.08-1.5-1.24-.85-2-1v-1.39.48l1.95-.39-.08-.64a3.5 3.5 0 0 0-1.9.55 1.09 1.09 0 0 1-1 .39v-1l-1-1v-2l1.61.87c.13-.22.27-.55.42-.87"
            style={{
              fill: "#98471a",
            }}
          />
          <path
            d="M185.07 63.05c1.5-.09.85-1.24 1-2h2v2l-1 1-.83.33.83.67h1v1h-3z"
            style={{
              fill: "#98401a",
            }}
          />
          <path
            d="m186.07 60.05-1-1h1Z"
            style={{
              fill: "#a65325",
            }}
          />
          <path
            d="M193.07 33.05h-1v-3l-1-1v-2h4v1l-.83.39 1.83 1.61h-2c-1.93.47-.62 2.01-1 3"
            className="templesOnly_svg__cls-1635"
          />
          <path
            d="M193.07 27.05h-2l-1-1 1-1v-1l2-1h1a5.34 5.34 0 0 0-1 4"
            style={{
              fill: "#8a4014",
            }}
          />
          <path
            d="M111.07 42.05c.09-1.5 1.24-.85 2-1 .39.33.75.88 1.18 1a17.7 17.7 0 0 0 2.82 0v1l-2 1c-1.71.08-3.44.21-4-2"
            className="templesOnly_svg__cls-1559"
          />
          <path
            d="M111 46.05c.39-.33.74-.88 1.18-.95a17.7 17.7 0 0 1 2.82-.05h1v1l-1 1h-2c0-1.49-1.21-.85-2-1"
            style={{
              fill: "#a45a2b",
            }}
          />
          <path
            d="M105 45.05h2v1l-1 1h-2v-1Z"
            style={{
              fill: "#762605",
            }}
          />
          <path
            d="M116 45.05h-1v-1l2-1c.33.34.66.67 1 1v1z"
            style={{
              fill: "#b97340",
            }}
          />
          <path
            d="m110 47.05 1-1c.33.34.66.67 1 1v1h-2Z"
            style={{
              fill: "#ce884e",
            }}
          />
          <path
            d="M108 47.05h1l1 1v1h-2z"
            style={{
              fill: "#b06a33",
            }}
          />
          <path
            d="M108 47.05v1h-2v-1Z"
            style={{
              fill: "#964a17",
            }}
          />
          <path
            d="M107 46.05v-1h2c0 1.5-1.21.85-2 1"
            className="templesOnly_svg__cls-1559"
          />
          <ellipse
            cx={108.04}
            cy={44.55}
            rx={1.41}
            ry={0.71}
            style={{
              fill: "#732205",
            }}
          />
          <path
            d="m110 48.05-1-1h1Z"
            style={{
              fill: "#d58f54",
            }}
          />
          <path
            d="M109 45.05v-1l.82.67Z"
            className="templesOnly_svg__cls-1559"
          />
          <path
            d="M117.07 42.05a17.7 17.7 0 0 1-2.82 0c-.43-.07-.79-.62-1.18-1h1l1-1h2v-3h1v1l.33.83.67-.83h1v2h-1l-1 1Z"
            style={{
              fill: "#6c1f01",
            }}
          />
          <path
            d="M117.07 37.05v3h-2v-3ZM115.07 40.05l-1 1v-1Z"
            className="templesOnly_svg__cls-1559"
          />
          <circle
            cx={167.57}
            cy={17.55}
            r={0.71}
            style={{
              fill: "#906040",
            }}
          />
          <circle
            cx={166.57}
            cy={17.55}
            r={0.71}
            style={{
              fill: "#99674a",
            }}
          />
          <path
            d="M124.07 38.05v1h-3l-1-1 1-1h1c.09 1.49 1.24.85 2 1"
            style={{
              fill: "#702906",
            }}
          />
          <path
            d="m119.07 38.05-.67.83-.33-.83Z"
            className="templesOnly_svg__cls-1559"
          />
          <path
            d="M122.07 37.05h-1l1-1Z"
            className="templesOnly_svg__cls-1513"
          />
          <path
            d="m130.07 36.05 1-1h2l2-1v2h-2v2c-.08 1.49-1.24.85-2 1v-1l.83-.33-.83-.67h-1Z"
            style={{
              fill: "#803412",
            }}
          />
          <path
            d="M130.07 31.05h1v3h-3v-1h2Z"
            className="templesOnly_svg__cls-1655"
          />
          <path
            d="M130.07 37.05h1v2l-1 1h-1l-1-1v-1h1Z"
            style={{
              fill: "#8b431a",
            }}
          />
          <path
            d="M129.07 34.05h3l1 1h-2c-.76-.15-1.91.49-2-1"
            style={{
              fill: "#6d230a",
            }}
          />
          <path
            d="m130.07 37.05-1 1c.15-.76-.5-1.92 1-2Z"
            className="templesOnly_svg__cls-1647"
          />
          <ellipse
            cx={125.07}
            cy={39.55}
            className="templesOnly_svg__cls-1843"
            rx={1.41}
            ry={0.71}
          />
          <path
            d="M126.07 40.05v-1h2l1 1c-.76.15-1.91-.5-2 1h-1Z"
            style={{
              fill: "#9f5b33",
            }}
          />
          <path
            d="M41 77.05h1l1 1a8.6 8.6 0 0 1-.77 1c-.38.37-.82.67-1.23 1h-1c-.34-.33-.67-.66-1-1a8 8 0 0 1 .76-1c.42-.36.86-.66 1.24-1"
            style={{
              fill: "#9f5121",
            }}
          />
          <path
            d="M35 77.05h3v2h-2c-.34-.33-.67-.66-1-1Z"
            style={{
              fill: "#742802",
            }}
          />
          <path
            d="M39 79.05c.33.34.66.67 1 1h-1l-1-1Z"
            style={{
              fill: "#a35629",
            }}
          />
          <circle
            cx={34.54}
            cy={77.55}
            r={0.71}
            className="templesOnly_svg__cls-1848"
          />
          <path
            d="m39 76.05 1 1c-.3-.33-.63-.66-1-1"
            style={{
              fill: "#722300",
            }}
          />
          <circle
            cx={33.54}
            cy={76.55}
            r={0.71}
            className="templesOnly_svg__cls-1848"
          />
          <path
            d="m46 74.05 5-1c-.42.34-.86.64-1.24 1a8 8 0 0 0-.76 1l-1.9.34.07.66H49l-1 1h-2l-1-1h-1v-1c.79-.15 2 .5 2-1"
            style={{
              fill: "#97481d",
            }}
          />
          <path
            d="M44 76.05h1c.33.34.66.67 1 1-.09 1.5-1.25.85-2 1-.09-1.49-1.25-.85-2-1v-1Z"
            style={{
              fill: "#a05020",
            }}
          />
          <path
            d="M46 74.05c-.09 1.5-1.25.85-2 1l1-2Z"
            style={{
              fill: "#7c2e02",
            }}
          />
          <path
            d="M42 76.05c-.34-.33-.67-.66-1-1Z"
            style={{
              fill: "#7f2e01",
            }}
          />
          <path
            d="M192.07 31.05v4h-1v-1l-1-1v-1Z"
            style={{
              fill: "#a64d1b",
            }}
          />
          <ellipse
            cx={191.57}
            cy={36.55}
            rx={0.71}
            ry={2.12}
            style={{
              fill: "#b1551d",
            }}
          />
          <path
            d="M191.07 38.05h1c-.15.76.5 1.91-1 2-1.5-.09-.85-1.24-1-2Z"
            style={{
              fill: "#b65a1c",
            }}
          />
          <path
            d="M72 63.05h1c.33.34.66.67 1 1l-1 1-2 1c-.09-1.49-1.25-.85-2-1l1-1c.79-.15 2 .5 2-1"
            style={{
              fill: "#b86c36",
            }}
          />
          <path
            d="M69 65.05c.75.15 1.91-.49 2 1h-1l-1 1h-1c-.34-.33-.67-.66-1-1v-1Z"
            style={{
              fill: "#dc9157",
            }}
          />
          <path
            d="M65 67.05h1v1l-1 1h-1c-.34-.33-.67-.66-1-1v-1Z"
            style={{
              fill: "#a55c33",
            }}
          />
          <path
            d="M66 68.05v-1c.15-.75-.5-1.91 1-2v1c.33.34.66.67 1 1v1Z"
            className="templesOnly_svg__cls-1737"
          />
          <path
            d="M65 67.05h-2v-1c.79.15 2-.49 2 1"
            style={{
              fill: "#762b05",
            }}
          />
          <path
            d="M72 63.05c-.09 1.5-1.25.85-2 1l1-1Z"
            className="templesOnly_svg__cls-1661"
          />
          <circle
            cx={62.54}
            cy={65.55}
            r={0.71}
            style={{
              fill: "#9b4e27",
            }}
          />
          <path
            d="M66 60.05v-1l.82.67Z"
            className="templesOnly_svg__cls-1638"
          />
          <path
            d="M11 99.05h-1v-1l2-1h2v1c-.76.15-1.92-.49-2 1Z"
            style={{
              fill: "#742605",
            }}
          />
          <path
            d="M10 98.05v1H8v-3a9 9 0 0 1 1 .77c.4.38.7.82 1 1.23"
            className="templesOnly_svg__cls-1863"
          />
          <path
            d="M11 99.05h1v1l-1 1z"
            style={{
              fill: "#a7542d",
            }}
          />
          <path
            d="m46 71.05-1 1v-1Z"
            style={{
              fill: "#a85a33",
            }}
          />
          <path
            d="M150.07 24.05h3l1 1v1h-4z"
            style={{
              fill: "#651e00",
            }}
          />
          <path
            d="M98 51.05h1l1-1h2v1l-1 1v1h-1c-.09-1.49-1.25-.85-2-1Z"
            style={{
              fill: "#954b24",
            }}
          />
          <path
            d="M98 52.05c.75.15 1.91-.49 2 1l-2 1c-.34-.33-.67-.66-1-1h-1v-1z"
            style={{
              fill: "#b16f3a",
            }}
          />
          <path
            d="M94 54.05v-1h1c.33.34.66.67 1 1h1l-1 1h-2Z"
            style={{
              fill: "#a74f21",
            }}
          />
          <path
            d="M101 50.05h-2l-1-1h3Z"
            className="templesOnly_svg__cls-1617"
          />
          <path
            d="M96 52.05v1h-1ZM98 52.05h-1l1-1ZM99 50.05h1l-1 1Z"
            className="templesOnly_svg__cls-1521"
          />
          <path d="m100 47.05 1 1Z" className="templesOnly_svg__cls-1870" />
          <path
            d="M101 45.05h1l-1 1Z"
            style={{
              fill: "#98542a",
            }}
          />
          <path
            d="M75 63.05h4v-2h2c-.11.61-.19 1.23-.34 1.83s-.44 1.45-.66 2.17h-3c-.09-1.49-1.25-.85-2-1Z"
            className="templesOnly_svg__cls-1690"
          />
          <path
            d="M81 57.05h1c.33.34.66.67 1 1-.34.67-.67 1.34-1 2v1h-1Z"
            style={{
              fill: "#7d380b",
            }}
          />
          <path
            d="M80 61.05h-1c-.34-.33-.67-.66-1-1 .79.15 2-.49 2 1"
            style={{
              fill: "#a94e05",
            }}
          />
          <path
            d="M84 58.05v-1h1c.46 1.93 2 .62 3 1v1h-3c-.3-.33-.63-.66-1-1"
            className="templesOnly_svg__cls-1812"
          />
          <path
            d="M84 58.05c.33.34.66.67 1 1v1l-1 1c-.67-.33-1.34-.66-2-1 .33-.66.66-1.33 1-2Z"
            style={{
              fill: "#7d3915",
            }}
          />
          <path
            d="M85 57.05h-1v-1h4v1Z"
            style={{
              fill: "#8e4f1c",
            }}
          />
          <path
            d="M26 82.05v1l-1 1c-.76.15-1.92-.49-2 1h-1v-2h1l1-1Z"
            style={{
              fill: "#853104",
            }}
          />
          <circle
            cx={26.54}
            cy={81.55}
            r={0.71}
            className="templesOnly_svg__cls-1877"
          />
          <path
            d="M23 83.05h-1v-1c.37.34.7.67 1 1"
            style={{
              fill: "#9f4c1d",
            }}
          />
          <path
            d="M10 98.05c-.34-.41-.64-.85-1-1.23a9 9 0 0 0-1-.77H7v-1h1l1-1h2v1c.33.34.66.67 1 1v1Z"
            className="templesOnly_svg__cls-1879"
          />
          <path
            d="M7 95.05v1l-1 1v-1ZM9 94.05l-1 1v-1Z"
            className="templesOnly_svg__cls-1863"
          />
          <path
            d="M9 94.05H8v-1Z"
            style={{
              fill: "#c2875e",
            }}
          />
          <path
            d="M73 63.05c.08-1.49 1.24-.85 2-1v1Z"
            className="templesOnly_svg__cls-1690"
          />
          <path
            d="m138.07 28.05 1-1v1Z"
            className="templesOnly_svg__cls-1530"
          />
          <circle
            cx={139.57}
            cy={26.55}
            r={0.71}
            className="templesOnly_svg__cls-1530"
          />
          <path
            d="M138.07 28.05h1l1 1h1v1l-.33.85-1.67-.9v2l-3 1c-.08-1.5-1.24-.85-2-1v-1c.76-.15 1.92.49 2-1Z"
            style={{
              fill: "#6c2606",
            }}
          />
          <path
            d="M132.07 34.05h-1v-2h3a9 9 0 0 1-.76 1 15 15 0 0 1-1.24 1"
            style={{
              fill: "#722801",
            }}
          />
          <circle
            cx={131.57}
            cy={31.55}
            r={0.71}
            className="templesOnly_svg__cls-1654"
          />
          <path
            d="m187.07 65.05-.83-.67.83-.33Z"
            style={{
              fill: "#a5471b",
            }}
          />
          <path
            d="M15 115.05v-1l1-1v1Z"
            style={{
              fill: "#fabb76",
            }}
          />
          <ellipse
            cx={16.54}
            cy={118.55}
            rx={2.12}
            ry={0.71}
            style={{
              fill: "#a25a20",
            }}
          />
          <path
            d="M14 117.05v-1h1v2h-1Z"
            style={{
              fill: "#fcbd80",
            }}
          />
          <path
            d="M15 116.05h-1l1-1 1-1h1v2Z"
            style={{
              fill: "#eaae68",
            }}
          />
          <path
            d="M140.07 27.05v-1l3-1c.15.76-.5 1.91 1 2v1h-3Z"
            className="templesOnly_svg__cls-1888"
          />
          <path
            d="m143.07 24.05 1-1h1l1 1c-.08 1.49-1.24.85-2 1h-1Z"
            style={{
              fill: "#6d2d0b",
            }}
          />
          <path
            d="M150.07 25.05v1c-.39.33-.75.88-1.18.95a17.7 17.7 0 0 1-2.82.05v-1h1Z"
            style={{
              fill: "#5e1601",
            }}
          />
          <path
            d="M147.07 26.05h-3v-1c.76-.15 1.92.49 2-1h1Z"
            style={{
              fill: "#803a1a",
            }}
          />
          <path
            d="m146.07 24.05-1-1h1Z"
            style={{
              fill: "#7e3512",
            }}
          />
          <path
            d="m6 97.05 1-1h1v2H6Z"
            style={{
              fill: "#a44f2c",
            }}
          />
          <path
            d="M106 47.05v1l-1 1h-2c-.34-.33-.67-.66-1-1l1-1z"
            style={{
              fill: "#86370f",
            }}
          />
          <path
            d="M102 48.05c.33.34.66.67 1 1l-1 1h-1v-1Z"
            style={{
              fill: "#883917",
            }}
          />
          <ellipse
            cx={104.54}
            cy={44.05}
            rx={0.71}
            ry={1.41}
            style={{
              fill: "#8b3d21",
            }}
          />
          <path
            d="M104 47.05h-1l1-1Z"
            style={{
              fill: "#702000",
            }}
          />
          <path
            d="M51 73.05a8 8 0 0 1 .76-1c.38-.37.82-.67 1.24-1h1v1c.33.34.66.67 1 1-.09 1.5-1.25.85-2 1-.34-.33-.67-.66-1-1Z"
            style={{
              fill: "#944b1f",
            }}
          />
          <path
            d="M55 71.05c.15-.75-.5-1.91 1-2 .24 1.38 1 1.22 1.88.63.35-.24.74-.42 1.12-.63v3h-1c-.09-1.49-1.25-.85-2-1Z"
            style={{
              fill: "#8b400f",
            }}
          />
          <path
            d="M58 67.05c.33.34.66.67 1 1l-3 1v-2Z"
            style={{
              fill: "#7b2800",
            }}
          />
          <path
            d="M56 67.05v1c-.76-.15-1.92.5-2-1l1-1c.37.34.7.67 1 1"
            style={{
              fill: "#aa592a",
            }}
          />
          <path
            d="M55 71.05h1v1h-2v-1Z"
            className="templesOnly_svg__cls-1902"
          />
          <path
            d="M54 71.05h-1v-1.82l.66-.08c.15.64.26 1.27.34 1.9"
            style={{
              fill: "#7f2c02",
            }}
          />
          <path d="m55 66.05-1 1v-1Z" className="templesOnly_svg__cls-1552" />
          <path
            d="m33 79.05-.68.83-.32-.83Z"
            className="templesOnly_svg__cls-1722"
          />
          <path
            d="M22 85.05h1v2h-3v-2Z"
            style={{
              fill: "#964c1c",
            }}
          />
          <path
            d="m56 69.05 3-1h2v1h-2c-.38.21-.77.39-1.12.63-.88.59-1.6.75-1.88-.63"
            className="templesOnly_svg__cls-1585"
          />
          <path d="M62 66.05h1v2h-1Z" className="templesOnly_svg__cls-1905" />
          <circle
            cx={61.54}
            cy={68.55}
            r={0.71}
            style={{
              fill: "#9b5017",
            }}
          />
          <path
            d="M60 66.05h1l-.68.83Z"
            className="templesOnly_svg__cls-1905"
          />
          <circle
            cx={61.54}
            cy={65.55}
            r={0.71}
            className="templesOnly_svg__cls-1905"
          />
          <path
            d="M63 65.05h-1l1-1Z"
            style={{
              fill: "#671f00",
            }}
          />
          <path
            d="M18 90.05c.75-.15 1.91.5 2-1h1a13.7 13.7 0 0 1-.68 2.14A13 13 0 0 1 19 93.05h-1c-.09-1.49-1.25-.85-2-1h-2l3-2Z"
            style={{
              fill: "#772709",
            }}
          />
          <path
            d="M13 92.05h1c.08 1.5 1.24.85 2 1h1v1h-2c-1.5.09-.85 1.25-1 2h-1z"
            style={{
              fill: "#6d1f0e",
            }}
          />
          <path
            d="M13 92.05v1h-2c-.34-.33-.67-.66-1-1v-1h2Z"
            style={{
              fill: "#994b1d",
            }}
          />
          <path
            d="M11 91.05h-1v-2c.33.34.66.67 1 1Z"
            style={{
              fill: "#752800",
            }}
          />
          <path
            d="M17 88.05h3l-2 1h-1Z"
            style={{
              fill: "#cb7945",
            }}
          />
          <path
            d="m13 92.05-1-1c.37.34.7.67 1 1"
            style={{
              fill: "#a95d31",
            }}
          />
          <circle
            cx={17.54}
            cy={89.55}
            r={0.71}
            style={{
              fill: "#bf6e3c",
            }}
          />
          <path
            d="M21 89.05h-1v-2h2v1Z"
            style={{
              fill: "#b7653b",
            }}
          />
          <path
            d="M20 86.05v1h-1Z"
            style={{
              fill: "#742b00",
            }}
          />
          <path
            d="M10 92.05c.33.34.66.67 1 1l-1 1H9l-1-1v-1Z"
            style={{
              fill: "#a4612f",
            }}
          />
          <path
            d="M10 92.05H8c.08-1.49 1.24-.85 2-1Z"
            style={{
              fill: "#843b0b",
            }}
          />
          <path
            d="M9 88.05v2H8c.19-.75-.46-1.91 1-2"
            style={{
              fill: "#944010",
            }}
          />
          <circle
            cx={9.54}
            cy={89.55}
            r={0.71}
            style={{
              fill: "#9c4c1d",
            }}
          />
          <path
            d="m38 79.05 1 1v1c-.76.15-1.92-.49-2 1h-2v-2c.75-.15 1.91.5 2-1Z"
            className="templesOnly_svg__cls-1644"
          />
          <path
            d="M32 83.05h1v2l1 1v1h-2c-.34-.33-.67-.66-1-1v-1l1-1Z"
            style={{
              fill: "#7c2d0b",
            }}
          />
          <path
            d="M37 79.05c-.09 1.5-1.25.85-2 1-1.5-.08-.85-1.24-1-2h1l1 1Z"
            style={{
              fill: "#7c2c05",
            }}
          />
          <path
            d="M26 83.05h3c-.47 1.93-2 .62-3 1Z"
            className="templesOnly_svg__cls-1923"
          />
          <path
            d="M32 83.05v1h-1v-2c.37.34.7.67 1 1"
            style={{
              fill: "#ae5b2f",
            }}
          />
          <path
            d="M31 82.05v1h-2c.12-1.49 1.28-.85 2-1"
            className="templesOnly_svg__cls-1923"
          />
          <path
            d="M35 81.05v1h-2c.12-1.49 1.28-.85 2-1"
            style={{
              fill: "#c5774c",
            }}
          />
          <circle
            cx={33.54}
            cy={82.55}
            r={0.71}
            style={{
              fill: "#bf725b",
            }}
          />
          <path
            d="M27 82.05v-1h1Z"
            style={{
              fill: "#8c2d03",
            }}
          />
          <path
            d="M18 119.05v-1h1v2h-1Z"
            style={{
              fill: "#93460e",
            }}
          />
          <path
            d="M176.07 24.05v-2h1v1l1 1c.33.67.67 1.33 1 2l-1 1-1-2v3h-3v-1l1-1c1.5-.05.85-1.24 1-2"
            className="templesOnly_svg__cls-1821"
          />
          <path
            d="M170.07 21.05h3l-1 2h-1l-1 1h-1c-.08-1.5-1.24-.85-2-1v-1h1Z"
            style={{
              fill: "#4c1505",
            }}
          />
          <path
            d="M172.07 25.05h1c-.33.67-.67 1.33-1 2-.08 1.49-1.24.85-2 1l1-2h-2v-1z"
            className="templesOnly_svg__cls-1930"
          />
          <path
            d="M172.07 27.05c.33-.67.67-1.33 1-2h2v1l-1 1Z"
            style={{
              fill: "#5f1a0b",
            }}
          />
          <path
            d="M172.07 25.05h-2v-1l1-1h1l.87.39Z"
            style={{
              fill: "#6a3111",
            }}
          />
          <path
            d="M175.07 26.05v-1l1-1c-.15.76.5 1.95-1 2"
            className="templesOnly_svg__cls-1933"
          />
          <path
            d="m175.18 22.14-.7.82-.32-.32.82-.7Z"
            style={{
              fill: "#480600",
            }}
          />
          <circle
            cx={175.57}
            cy={21.55}
            r={0.71}
            className="templesOnly_svg__cls-1933"
          />
          <path d="M174.07 20.05h1v1Z" className="templesOnly_svg__cls-1588" />
          <path
            d="m169.07 19.05-1-1Z"
            style={{
              fill: "#461300",
            }}
          />
          <path
            d="M175.07 21.05v-1c1.5-.09.85-1.24 1-2l1 1v2z"
            style={{
              fill: "#914624",
            }}
          />
          <path
            d="m170.07 21.05-2 1-1-1v-1h2Z"
            style={{
              fill: "#aa7944",
            }}
          />
          <path
            d="m183.07 10.05-1 1ZM184.07 10.05h-1l.67-.83Z"
            className="templesOnly_svg__cls-1589"
          />
          <path
            d="M181.07 14.05h2v3c-1.5.08-.85 1.24-1 2h-1v-2h-2v-1h3Z"
            className="templesOnly_svg__cls-1938"
          />
          <path
            d="M179.07 16.05v3h-2l-1-1v-1Z"
            style={{
              fill: "#7d2f0f",
            }}
          />
          <path d="M167.07 20.05v1h-1Z" className="templesOnly_svg__cls-1765" />
          <path
            d="M166.07 21.05h1v2c-.76.15-1.91-.5-2 1h-1c-.08-1.5-1.24-.85-2-1v-1a17.7 17.7 0 0 0 2.82-.05c.43-.07.79-.62 1.18-.95"
            style={{
              fill: "#995d30",
            }}
          />
          <path
            d="M156.07 25.05h2v2h-1l-1 1h-1v-2Z"
            className="templesOnly_svg__cls-1941"
          />
          <path
            d="M158.07 27.05v-2l2-1 1 1a15 15 0 0 0-1.23 1 8 8 0 0 0-.77 1Z"
            className="templesOnly_svg__cls-1942"
          />
          <path
            d="m161.07 25.05-1-1 1-1h1l1 1v1z"
            style={{
              fill: "#864a23",
            }}
          />
          <path
            d="M156.07 24.05v-1l3-1a2.46 2.46 0 0 1-3 2"
            style={{
              fill: "#5e1b03",
            }}
          />
          <path
            d="m156.07 25.05-1 1h-1v-1z"
            className="templesOnly_svg__cls-1942"
          />
          <path
            d="M155.07 25.05h-1l-1-1h2Z"
            className="templesOnly_svg__cls-1670"
          />
          <path
            d="M194.07 13.05c.33 1 .67 2 1 3h-2l-1-1v-1l1-1Z"
            style={{
              fill: "#8f4311",
            }}
          />
          <path
            d="M192.07 14.05v1l-1 1h-1v-3Z"
            style={{
              fill: "#773200",
            }}
          />
          <path
            d="M189.07 13.05v-2h1v2Z"
            style={{
              fill: "#cd9057",
            }}
          />
          <path
            d="m193.07 7.05 1 1c-.76-.15-1.91.49-2-1Z"
            style={{
              fill: "#703102",
            }}
          />
          <path
            d="m193.07 13.05-1 1Z"
            style={{
              fill: "#954c1b",
            }}
          />
          <path
            d="M190.07 11.05h-1l1-1Z"
            className="templesOnly_svg__cls-1598"
          />
          <path
            d="M183.07 17.05v-3h1c.09 1.49 1.24.85 2 1h1v1c-.33 1-.67 2-1 3-.09.65-.19 1.31-.28 2l-1.72-2A8 8 0 0 0 184 18l.14.15.82-.69-.32-.32a6 6 0 0 0-.64.86Z"
            style={{
              fill: "#642a12",
            }}
          />
          <path
            d="M186.07 15.05c-.76-.15-1.91.49-2-1h2Z"
            className="templesOnly_svg__cls-1938"
          />
          <path
            d="M189.07 11.05v1h-1Z"
            style={{
              fill: "#935d1d",
            }}
          />
          <path
            d="M187.07 14.05v-1h2c-.07 1.49-1.24.85-2 1"
            style={{
              fill: "#d19363",
            }}
          />
          <circle
            cx={186.57}
            cy={14.55}
            r={0.71}
            className="templesOnly_svg__cls-1953"
          />
          <path
            d="M18 113.05v-1h4c.33.34.66.67 1 1l1 1v1h-2c-.34-.33-.67-.66-1-1-.09-1.49-1.25-.85-2-1Z"
            style={{
              fill: "#f8bd71",
            }}
          />
          <path
            d="M22 112.05h-1v-2h2v1Z"
            style={{
              fill: "#fbc179",
            }}
          />
          <circle
            cx={17.54}
            cy={114.55}
            r={0.71}
            style={{
              fill: "#e39f55",
            }}
          />
          <path d="M18 113.05h1l-1 1Z" className="templesOnly_svg__cls-1778" />
          <path
            d="M17 114.05h-1v-1c.37.34.7.67 1 1"
            style={{
              fill: "#fec677",
            }}
          />
          <path
            d="M19 109.05v-1h2v2h-1Z"
            style={{
              fill: "#c2651e",
            }}
          />
          <path
            d="M19 107.05h-1v-5h1z"
            style={{
              fill: "#a6471c",
            }}
          />
          <path
            d="M18 102.05v2c-1.5-.08-.85-1.24-1-2Z"
            style={{
              fill: "#7d2304",
            }}
          />
          <path
            d="m19 102.05 1-2v-1h1v4h-1c-.3-.33-.63-.66-1-1"
            style={{
              fill: "#b05e26",
            }}
          />
          <path
            d="M18 100.05h-1l1-2h1v2Z"
            style={{
              fill: "#ab6434",
            }}
          />
          <circle
            cx={19.54}
            cy={99.55}
            r={0.71}
            className="templesOnly_svg__cls-1963"
          />
          <path
            d="M12 99.05c.08-1.49 1.24-.85 2-1v2h-1c-.3-.33-.63-.66-1-1"
            style={{
              fill: "#974723",
            }}
          />
          <path
            d="m18 98.05-1 2h-1v-2Z"
            style={{
              fill: "#763206",
            }}
          />
          <circle
            cx={13.54}
            cy={100.55}
            r={0.71}
            style={{
              fill: "#84360b",
            }}
          />
          <path
            d="M16 99.05v1c-.34-.33-.67-.66-1-1Z"
            style={{
              fill: "#682500",
            }}
          />
          <path
            d="M14 99.05v-1l1 1Z"
            style={{
              fill: "#aa633d",
            }}
          />
          <path
            d="M12 99.05c.33.34.66.67 1 1h-1Z"
            style={{
              fill: "#af5b36",
            }}
          />
          <path
            d="M19 107.05v-1h1c.33.67.66 1.34 1 2h-2Z"
            style={{
              fill: "#c47534",
            }}
          />
          <path
            d="M180.07 41.05c-2.2 1.12-4.32 2.55-7 2v-2l1-1h1c.37.2.76.39 1.12.62.9.6 1.64.75 1.88-.62h1Z"
            style={{
              fill: "#eca563",
            }}
          />
          <path
            d="m180.07 41.05-1-1 .86-1.5c-.27-.46-.56-1-.86-1.5l2-1v5Z"
            className="templesOnly_svg__cls-1972"
          />
          <path
            d="M174.07 45.05h1c-.33.67-.67 1.33-1 2h-1l-2-2v-1h2Z"
            style={{
              fill: "#8c3711",
            }}
          />
          <path
            d="M174.07 47.05c.33-.67.67-1.33 1-2h2v1l-1 1z"
            style={{
              fill: "#8f3f05",
            }}
          />
          <path
            d="M173.07 44.05h-2v-1c.09-1.5 1.24-.85 2-1z"
            style={{
              fill: "#e49456",
            }}
          />
          <path
            d="m174.07 45.05-1-1Z"
            style={{
              fill: "#7b2700",
            }}
          />
          <path
            d="M175.07 47.05h1l.76 1 1.24-1v-1h1l1 1v1l-1 1c-.76.15-1.91-.5-2 1h-2z"
            style={{
              fill: "#f6b46b",
            }}
          />
          <path
            d="M180.07 49.05h1v2l-3 1-2 1v-2l1-1c.99-.38 2.53.95 3-1"
            style={{
              fill: "#f5b770",
            }}
          />
          <path
            d="M181.07 51.05v-2a2.46 2.46 0 0 1 2-3v5Z"
            style={{
              fill: "#b3692d",
            }}
          />
          <path
            d="m179.07 49.05 1-1v1Z"
            style={{
              fill: "#b97c2f",
            }}
          />
          <path
            d="m180.07 47.05-1-1Z"
            style={{
              fill: "#fec076",
            }}
          />
          <path
            d="M184.07 40.05v-3c.33-.67.67-1.33 1-2h1c.33.67.67 1.33 1 2h-1.83c.08 1.22 2.13 2.26-.17 3Z"
            style={{
              fill: "#a46028",
            }}
          />
          <path
            d="M187.07 37.05c-.33-.67-.67-1.33-1-2 .33-.67.67-1.33 1-2h2v1c-.33.39-.88.75-.95 1.18a17.7 17.7 0 0 0-.05 2.82h-1Z"
            className="templesOnly_svg__cls-1983"
          />
          <path
            d="M184.07 40.05h1v1l-1 1h-1l-1-1c.09-1.5 1.24-.85 2-1"
            style={{
              fill: "#8d470d",
            }}
          />
          <path
            d="M187.07 38.05h1v2c-1.5-.05-.85-1.24-1-2"
            style={{
              fill: "#8d3906",
            }}
          />
          <path
            d="m184.07 42.05 1-1v1Z"
            style={{
              fill: "#9e5621",
            }}
          />
          <path
            d="M185.07 35.05c-.33.67-.67 1.33-1 2h-2v-1Z"
            style={{
              fill: "#dda165",
            }}
          />
          <path
            d="M182.07 37.05h1v1.83l-.66.07Z"
            style={{
              fill: "#fec487",
            }}
          />
          <circle
            cx={181.57}
            cy={35.55}
            r={0.71}
            className="templesOnly_svg__cls-1972"
          />
          <path
            d="M181.07 51.05h2v2h-1l-1-1Z"
            style={{
              fill: "#974e17",
            }}
          />
          <path
            d="M188.07 40.05v-2a17.7 17.7 0 0 1 .05-2.82c.07-.43.62-.79.95-1.18h1a5.34 5.34 0 0 0-1 4v2Z"
            style={{
              fill: "#9f4914",
            }}
          />
          <path
            d="M178.07 46.05v1h-2l1-1Z"
            style={{
              fill: "#f1ab60",
            }}
          />
          <path
            d="M189.07 38.05a5.34 5.34 0 0 1 1-4h1v4z"
            style={{
              fill: "#a34a0f",
            }}
          />
          <path
            d="M86 56.05h-1l.67-.83Z"
            style={{
              fill: "#702a00",
            }}
          />
          <path
            d="M94 55.05h2v2h-3c-1.5.09-.85 1.25-1 2-.34-.33-.67-.66-1-1v-1l1-1Z"
            className="templesOnly_svg__cls-1994"
          />
          <path
            d="M91 57.05v1c-1.5.09-.85 1.25-1 2v2h-1v-1c-.16-.75.49-1.91-1-2v-1l1-1z"
            style={{
              fill: "#813109",
            }}
          />
          <path
            d="M90 57.05h-1v-1c.37.34.7.67 1 1"
            style={{
              fill: "#be7641",
            }}
          />
          <path
            d="M85 57.05h3v1c-.95-.38-2.5.95-3-1"
            style={{
              fill: "#ce8f5a",
            }}
          />
          <path
            d="M194.07 23.05h-1c-.33-1-.67-2-1-3v-1h2l-.87 1.61.87.39z"
            style={{
              fill: "#793c1f",
            }}
          />
          <path
            d="M194.07 16.05h1v2h-1c-.76-.15-1.91.49-2-1v-1h1l.33.83Z"
            style={{
              fill: "#8d481c",
            }}
          />
          <path
            d="M192.07 17.05c.09 1.49 1.24.85 2 1v1h-2l-1-1v-1Z"
            className="templesOnly_svg__cls-2000"
          />
          <path
            d="M194.07 22.05v-1l1 1Z"
            className="templesOnly_svg__cls-1620"
          />
          <path d="m195.07 18.05 1 1Z" className="templesOnly_svg__cls-2000" />
          <path
            d="M182.07 57.05c-.15.32-.29.65-.39.87l-1.61-.87h-1l-1-1v-2h4Z"
            className="templesOnly_svg__cls-2001"
          />
          <path
            d="M182.07 54.05h-1v-2l1 1Z"
            style={{
              fill: "#bc723a",
            }}
          />
          <path
            d="M181.07 61.05h1v2l-2-1v-1Z"
            className="templesOnly_svg__cls-2001"
          />
          <path
            d="M182.07 63.05v-1c.76.15 1.92-.5 2 1z"
            style={{
              fill: "#b1673f",
            }}
          />
          <path
            d="m182 60.27 1.92-.16.08.64-1.95.39Z"
            style={{
              fill: "#742a00",
            }}
          />
          <path
            d="M181.07 61.05h-1l-1-1h2Z"
            style={{
              fill: "#de8954",
            }}
          />
          <path
            d="M179.07 57.05h1v1h-1l-1-1Z"
            style={{
              fill: "#8c3904",
            }}
          />
          <circle
            cx={184.57}
            cy={63.55}
            r={0.71}
            style={{
              fill: "#6e1c00",
            }}
          />
          <path
            d="M181.07 60.05h-1v-1Z"
            className="templesOnly_svg__cls-2001"
          />
          <circle
            cx={179.57}
            cy={58.55}
            r={0.71}
            style={{
              fill: "#803805",
            }}
          />
          <path
            d="M184.07 64.05h1v2h-2v-1Z"
            className="templesOnly_svg__cls-2009"
          />
          <path
            d="M184.07 66.05h2c-.08 1.49-1.24.85-2 1Z"
            style={{
              fill: "#833817",
            }}
          />
          <path
            d="m192.07 31.05-2 1h-1v-4a15 15 0 0 0 1 1.23 8 8 0 0 0 1 .77h1Z"
            style={{
              fill: "#98461b",
            }}
          />
          <path
            d="M191.07 30.05a8 8 0 0 1-1-.77 15 15 0 0 1-1-1.23v-2h1l1 1z"
            style={{
              fill: "#86350b",
            }}
          />
          <path
            d="M191.07 30.05v-1l1 1Z"
            className="templesOnly_svg__cls-1708"
          />
          <path
            d="M190.07 26.05h-1l-2 2h-3v-1l1-1 .33.83.67-.83 1-1v-1h4v1Z"
            style={{
              fill: "#65290e",
            }}
          />
          <path
            d="M192.07 20.05c.33 1 .67 2 1 3l-2 1c-.15-.76.5-1.92-1-2Z"
            style={{
              fill: "#652b0f",
            }}
          />
          <path
            d="m190.07 26.05 1-1Z"
            style={{
              fill: "#914926",
            }}
          />
          <path
            d="M117.07 43.05v-1h3l1 1-1 1h-1c-.07-1.5-1.24-.85-2-1"
            style={{
              fill: "#a15c2b",
            }}
          />
          <path
            d="m115 47.05 1-1h1v2h-1Z"
            style={{
              fill: "#5e1f04",
            }}
          />
          <path
            d="m115 47.05 1 1h-3v-1Z"
            style={{
              fill: "#530c00",
            }}
          />
          <path
            d="M112 47.05c-.34-.33-.67-.66-1-1 .75.15 1.91-.49 2 1Z"
            style={{
              fill: "#d38b51",
            }}
          />
          <circle
            cx={116.54}
            cy={45.55}
            r={0.71}
            className="templesOnly_svg__cls-2020"
          />
          <path d="M117 46.05v-1h2v1z" className="templesOnly_svg__cls-2021" />
          <path
            d="M117.07 43.05c.76.15 1.92-.5 2 1h-1Z"
            style={{
              fill: "#d2834b",
            }}
          />
          <circle
            cx={118.54}
            cy={44.55}
            r={0.71}
            className="templesOnly_svg__cls-2020"
          />
          <path
            d="M113 48.05h3v1c-.87.09-2.08-.44-2.05 1.24 0 .25-.62.51-.95.76l-1-1c-.34-.66-.67-1.33-1-2z"
            style={{
              fill: "#631c06",
            }}
          />
          <path
            d="M111 48.05c.33.67.66 1.34 1 2h-2v-2Z"
            style={{
              fill: "#6e260d",
            }}
          />
          <circle
            cx={112.54}
            cy={47.55}
            r={0.71}
            style={{
              fill: "#72280a",
            }}
          />
          <path d="M110 49.05v1h-2v-1Z" className="templesOnly_svg__cls-2026" />
          <path
            d="M107 48.05h1v1c-.3-.33-.63-.66-1-1"
            style={{
              fill: "#d28d49",
            }}
          />
          <path
            d="M107 48.05c.33.34.66.67 1 1v1h-2c-.34-.33-.67-.66-1-1l1-1Z"
            style={{
              fill: "#a9611f",
            }}
          />
          <path
            d="M120.07 42.05h-3l1-1 1-1h2c-.33.67-.67 1.33-1 2"
            style={{
              fill: "#83371b",
            }}
          />
          <path
            d="M121.07 40.05h-1v-1h3c-.07 1.49-1.24.85-2 1"
            style={{
              fill: "#783412",
            }}
          />
          <path d="m119.07 40.05-1 1Z" className="templesOnly_svg__cls-1559" />
          <path
            d="M121.07 39.05h-1v-1Z"
            style={{
              fill: "#652000",
            }}
          />
          <path
            d="M121.07 40.05c.76-.15 1.92.49 2-1h1v2h-2v2h-1l-1-1c.33-.67.67-1.33 1-2"
            style={{
              fill: "#833b0b",
            }}
          />
          <path
            d="m130 40.05 1-1c.75-.15 1.91.5 2-1l2-1 .62 2.88-.75 1.07 3.17 1v1l-1 1-3 1-2 1c-.34-.33-.67-.66-1-1 .26-.49.53-1 .87-1.6l-.87-.4c-.16-.75.49-1.91-1-2Z"
            className="templesOnly_svg__cls-2033"
          />
          <path
            d="M132.07 34.05a15 15 0 0 0 1.24-1 9 9 0 0 0 .76-1c.76.15 1.92-.5 2 1v1h-1l-2 1Z"
            className="templesOnly_svg__cls-1691"
          />
          <path
            d="M135.07 34.05h1c.76.15 1.92-.5 2 1l-1 1h-2Z"
            style={{
              fill: "#914d1e",
            }}
          />
          <path
            d="M135.07 36.05h2v1h-2l-2 1v-2Z"
            style={{
              fill: "#742d12",
            }}
          />
          <path
            d="M131.07 38.05v-1l.83.67Z"
            style={{
              fill: "#9f5327",
            }}
          />
          <path
            d="M130 40.05v1c.15.76-.5 1.92 1 2l.87.4c-.34.63-.61 1.11-.87 1.6a17.7 17.7 0 0 1-2.82 0c-.44-.07-.79-.62-1.18-1l2-2v-2Z"
            style={{
              fill: "#450c03",
            }}
          />
          <path
            d="M124.07 41.05v-1h2v1z"
            style={{
              fill: "#a76433",
            }}
          />
          <path
            d="M129.07 41.05v1c-.76.15-1.91-.5-2 1h-1v-2z"
            style={{
              fill: "#4b0c00",
            }}
          />
          <path
            d="M129.07 41.05h-2c.09-1.5 1.24-.85 2-1Z"
            className="templesOnly_svg__cls-2040"
          />
          <path
            d="M41 80.05c.41-.33.85-.63 1.23-1a8.6 8.6 0 0 0 .77-1h1v2z"
            style={{
              fill: "#81320c",
            }}
          />
          <path
            d="M41 80.05h1v2c-.67-.66-1.34-1.33-2-2Z"
            className="templesOnly_svg__cls-1712"
          />
          <path
            d="M44 78.05h-1l-1-1c.79.15 2-.49 2 1"
            style={{
              fill: "#cd7e4b",
            }}
          />
          <path
            d="m36 79.05-1-1c.37.34.7.67 1 1"
            style={{
              fill: "#6e1f00",
            }}
          />
          <path
            d="M40 80.05c.66.67 1.33 1.34 2 2h1c.33.34.66.67 1 1v1h-2v2l-3 1-2 1v-2l2-1h-4v-1l1-1a5.7 5.7 0 0 1 2.21.58c.53-.19.33-.56.19-.54a8 8 0 0 0-1.4.43c.6.17 1.2.34 1.21.11C37 82.72 37 82.39 37 82.05c.75-.15 1.91.5 2-1v-1Z"
            className="templesOnly_svg__cls-2044"
          />
          <path
            d="M51 73.05h1v2l-1 1h-2v-1a8 8 0 0 1 .76-1c.42-.36.86-.66 1.24-1"
            style={{
              fill: "#b36737",
            }}
          />
          <path
            d="M44 79.05v-1c.75-.15 1.91.5 2-1h2v2Z"
            style={{
              fill: "#772806",
            }}
          />
          <path
            d="M48 78.05v-1l1-1h1v2Z"
            style={{
              fill: "#75270b",
            }}
          />
          <path
            d="M49 75.05v1h-1.79l-.07-.66Z"
            style={{
              fill: "#a65a26",
            }}
          />
          <path
            d="M46 77.05c-.34-.33-.67-.66-1-1Z"
            style={{
              fill: "#ae6131",
            }}
          />
          <path
            d="M191.07 34.05h-2v-1h1Z"
            style={{
              fill: "#b05a24",
            }}
          />
          <circle
            cx={189.57}
            cy={32.55}
            r={0.71}
            className="templesOnly_svg__cls-1983"
          />
          <path
            d="M75 64.05c.75.15 1.91-.49 2 1a2.46 2.46 0 0 0-2 3l-1 1h-1v-4l1-1Z"
            className="templesOnly_svg__cls-2051"
          />
          <path
            d="M73 65.05v2h-3v-1h1Z"
            style={{
              fill: "#762c07",
            }}
          />
          <path
            d="M75 64.05h-1c-.34-.33-.67-.66-1-1h2Z"
            style={{
              fill: "#cf7f47",
            }}
          />
          <path
            d="M70 67.05h1v1l-3 1v-2z"
            style={{
              fill: "#6b1f02",
            }}
          />
          <path d="M70 67.05h-1l1-1Z" className="templesOnly_svg__cls-1737" />
          <path
            d="M68 67.05c-.34-.33-.67-.66-1-1 .37.34.7.67 1 1"
            style={{
              fill: "#e3975a",
            }}
          />
          <path
            d="m65 69.05 1-1c.08 1.5 1.24.85 2 1l-1 1h-2Z"
            style={{
              fill: "#752713",
            }}
          />
          <path
            d="M65 69.05v2h-1v-2Z"
            style={{
              fill: "#671900",
            }}
          />
          <path
            d="M63 68.05c.33.34.66.67 1 1h-1Z"
            style={{
              fill: "#d68d5b",
            }}
          />
          <path
            d="M68 69.05c-.76-.15-1.92.5-2-1h2Z"
            style={{
              fill: "#611300",
            }}
          />
          <path
            d="M13 96.05h1l1 1h-3v-1Z"
            className="templesOnly_svg__cls-2060"
          />
          <path
            d="M14 97.05h2v2h-1l-1-1Z"
            style={{
              fill: "#84401a",
            }}
          />
          <path
            d="M146.07 27.05a17.7 17.7 0 0 0 2.82-.05c.43-.07.79-.62 1.18-.95h3v1l-2 1-3 1h-2Z"
            className="templesOnly_svg__cls-2062"
          />
          <path d="M153.07 27.05v-1h1Z" className="templesOnly_svg__cls-1941" />
          <path
            d="M100 53.05h2v1c.33.34.66.67 1 1h1v1l-1 1-1 1h-3v-3c1.53-.05.88-1.24 1-2"
            style={{
              fill: "#58130a",
            }}
          />
          <path
            d="m102 50.05 1-1h1v2h-2Z"
            className="templesOnly_svg__cls-2064"
          />
          <circle
            cx={101.54}
            cy={52.55}
            r={0.71}
            className="templesOnly_svg__cls-2065"
          />
          <path d="M102 52.05h-1l1-1Z" className="templesOnly_svg__cls-2064" />
          <path
            d="M100 53.05c-.16.76.49 1.92-1 2h-1v-1Z"
            className="templesOnly_svg__cls-2065"
          />
          <path
            d="M97 53.05c.33.34.66.67 1 1h-1Z"
            style={{
              fill: "#c0763f",
            }}
          />
          <circle
            cx={96.54}
            cy={53.55}
            r={0.71}
            style={{
              fill: "#e0905e",
            }}
          />
          <path
            d="M97 54.05h1v2h-2v-1Z"
            style={{
              fill: "#862d0a",
            }}
          />
          <path
            d="M96 53.05v1c-.34-.33-.67-.66-1-1Z"
            style={{
              fill: "#d98558",
            }}
          />
          <path
            d="M79 65.05h2l1-1h1v2l-1 1v1h-1l-2-2Z"
            className="templesOnly_svg__cls-2044"
          />
          <path
            d="M81 65.05h-1c.22-.72.47-1.44.66-2.17s.23-1.22.34-1.83h1v3Z"
            className="templesOnly_svg__cls-2070"
          />
          <path
            d="M79 65.05v1h-1c-.34-.33-.67-.66-1-1Z"
            className="templesOnly_svg__cls-2051"
          />
          <path
            d="M82 62.05v-2l2 1v1z"
            style={{
              fill: "#7b3111",
            }}
          />
          <path
            d="M85 60.05v-1h2c.33.67.66 1.34 1 2-.76.15-1.92-.49-2 1h-1z"
            style={{
              fill: "#7e3607",
            }}
          />
          <path
            d="M88 61.05c-.34-.66-.67-1.33-1-2h1c1.49.09.84 1.25 1 2Z"
            className="templesOnly_svg__cls-2073"
          />
          <path
            d="M85 60.05v1h-1Z"
            style={{
              fill: "#77310d",
            }}
          />
          <path
            d="M23 86.05v-1c.08-1.49 1.24-.85 2-1v3h-1Z"
            className="templesOnly_svg__cls-1726"
          />
          <path d="M26 83.05v1h-1Z" className="templesOnly_svg__cls-1877" />
          <path
            d="m10 94.05 1-1h2v1z"
            style={{
              fill: "#7f2b02",
            }}
          />
          <path
            d="M13 96.05h-1c-.34-.33-.67-.66-1-1h2Z"
            style={{
              fill: "#802f16",
            }}
          />
          <ellipse
            cx={12.04}
            cy={94.55}
            rx={1.41}
            ry={0.71}
            style={{
              fill: "#a04c27",
            }}
          />
          <path
            d="m140.07 29.05-1-1v-1h1z"
            style={{
              fill: "#894828",
            }}
          />
          <path
            d="M138.07 35.05c-.08-1.5-1.24-.85-2-1v-1l3-1h1v1l-2 1h3c-.08 1.49-1.24.85-2 1Z"
            style={{
              fill: "#904920",
            }}
          />
          <path
            d="M140.07 32.05h-1V30l1.67.89.33-.85h1l1 1v1Z"
            style={{
              fill: "#7e3311",
            }}
          />
          <path
            d="M142.07 30.05h-1v-1Z"
            className="templesOnly_svg__cls-1888"
          />
          <circle
            cx={140.57}
            cy={28.55}
            r={0.71}
            className="templesOnly_svg__cls-1888"
          />
          <path
            d="M19 118.05h-4v-1h4Z"
            style={{
              fill: "#e4a868",
            }}
          />
          <ellipse
            cx={16.04}
            cy={116.55}
            rx={1.41}
            ry={0.71}
            style={{
              fill: "#fed38e",
            }}
          />
          <path
            d="M17 117.05v-2h1c.08 1.5 1.24.85 2 1v1z"
            style={{
              fill: "#fbbf78",
            }}
          />
          <path
            d="M141.07 29.05v-1h3v1l-1 1h-1Z"
            style={{
              fill: "#631900",
            }}
          />
          <path
            d="M144.07 29.05v-2h2v2Z"
            style={{
              fill: "#631b01",
            }}
          />
          <path
            d="M144.07 25.05v2c-1.5-.09-.85-1.24-1-2Z"
            style={{
              fill: "#7d391d",
            }}
          />
          <path
            d="M141.07 28.05h-1v-1Z"
            className="templesOnly_svg__cls-1530"
          />
          <ellipse
            cx={145.07}
            cy={26.55}
            className="templesOnly_svg__cls-2062"
            rx={1.41}
            ry={0.71}
          />
          <path
            d="M104 51.05v-2h1c.33.34.66.67 1 1v1z"
            style={{
              fill: "#954820",
            }}
          />
          <path
            d="M52 75.05v-1h1c.75-.15 1.91.5 2-1h1c.33.67.66 1.34 1 2h-3v2h-1v-1c-.3-.33-.63-.66-1-1"
            style={{
              fill: "#772e0b",
            }}
          />
          <path
            d="M56 73.05h-1c-.34-.33-.67-.66-1-1h2Z"
            style={{
              fill: "#d28a5b",
            }}
          />
          <path
            d="M53 74.05h-1v-1c.37.34.7.67 1 1"
            style={{
              fill: "#b17139",
            }}
          />
          <path
            d="M57 75.05c-.34-.66-.67-1.33-1-2l1-1h2v3Z"
            style={{
              fill: "#691703",
            }}
          />
          <path
            d="M59 73.05v-2h2v2Z"
            style={{
              fill: "#802e0f",
            }}
          />
          <path
            d="M61 71.05h-2v-2h1c.33.34.66.67 1 1Z"
            style={{
              fill: "#b26d33",
            }}
          />
          <path
            d="M58 72.05h-2v-1c.79.15 2-.49 2 1"
            style={{
              fill: "#ba7541",
            }}
          />
          <path
            d="M22 88.05v-1h2l-1 1Z"
            className="templesOnly_svg__cls-2095"
          />
          <path
            d="M24 87.05h-1v-1Z"
            style={{
              fill: "#b26733",
            }}
          />
          <path
            d="M61 70.05c-.34-.33-.67-.66-1-1h2v1Z"
            style={{
              fill: "#dd9657",
            }}
          />
          <path
            d="M62 70.05v-2h1v2Z"
            style={{
              fill: "#d1894f",
            }}
          />
          <path
            d="M19 93.05a13 13 0 0 0 1.32-1.86 13.7 13.7 0 0 0 .68-2.14h1v3l-1 2h-1c-.3-.33-.63-.66-1-1"
            style={{
              fill: "#651700",
            }}
          />
          <path
            d="M19 93.05c.33.34.66.67 1 1v1h-1l-.4-.87-1.6.87v-2z"
            style={{
              fill: "#731e04",
            }}
          />
          <path
            d="M18 93.05h-2v-1c.79.15 2-.49 2 1"
            style={{
              fill: "#833c26",
            }}
          />
          <path
            d="M16 92.05v1c-.76-.15-1.92.5-2-1Z"
            style={{
              fill: "#641805",
            }}
          />
          <path
            d="M16 97.05h-1l-1-1c.15-.75-.5-1.91 1-2 .33.34.66.67 1 1Z"
            style={{
              fill: "#601604",
            }}
          />
          <path
            d="M16 95.05c-.34-.33-.67-.66-1-1h2v1Z"
            style={{
              fill: "#560c00",
            }}
          />
          <path d="M22 89.05h-1l1-1Z" className="templesOnly_svg__cls-2095" />
          <path
            d="m36 83.05-1 1v-2h1Z"
            style={{
              fill: "#661907",
            }}
          />
          <path
            d="M39 81.05c-.09 1.5-1.25.85-2 1 .12-1.49 1.28-.85 2-1"
            style={{
              fill: "#6e2201",
            }}
          />
          <circle
            cx={36.54}
            cy={82.55}
            r={0.71}
            className="templesOnly_svg__cls-2107"
          />
          <path
            d="M32 87.05h2a4.6 4.6 0 0 1-4 2h-1c.41-.33.85-.63 1.23-1a8.6 8.6 0 0 0 .77-1Z"
            style={{
              fill: "#621300",
            }}
          />
          <path
            d="M35 84.05v2h-1l-1-1 1-1Z"
            style={{
              fill: "#79270a",
            }}
          />
          <path d="M31 85.05v1h-2v-1z" className="templesOnly_svg__cls-2110" />
          <path d="M31 85.05h-1l1-1h1Z" className="templesOnly_svg__cls-2111" />
          <path
            d="M35 84.05h-2v-1h2Z"
            style={{
              fill: "#6f1f0d",
            }}
          />
          <circle
            cx={34.54}
            cy={86.55}
            r={0.71}
            className="templesOnly_svg__cls-2113"
          />
          <path
            d="M32 87.05h-1v-1c.37.34.7.67 1 1"
            style={{
              fill: "#8a3d19",
            }}
          />
          <path
            d="M33 84.05h1l-1 1Z"
            style={{
              fill: "#701900",
            }}
          />
          <path
            d="m31 84.05-1 1h-1l-1 1h-3v-2h1c1-.38 2.53.93 3-1h2Z"
            style={{
              fill: "#c98245",
            }}
          />
          <circle
            cx={34.54}
            cy={82.55}
            r={0.71}
            className="templesOnly_svg__cls-1644"
          />
          <ellipse
            cx={19.54}
            cy={119.05}
            className="templesOnly_svg__cls-2117"
            rx={0.71}
            ry={1.41}
          />
          <circle
            cx={20.54}
            cy={120.55}
            r={0.71}
            className="templesOnly_svg__cls-2117"
          />
          <path
            d="M181.07 19.05h1v2h2v2l-1 1v1l-2 1h-2c-.33-.67-.67-1.33-1-2v-2c.33-.67.67-1.33 1-2l2 1Z"
            style={{
              fill: "#5f2108",
            }}
          />
          <path
            d="M175.07 28.05h1v1l1 1 1 1 1 1v1h-3l-1-1-2-2v-1c.76-.15 1.93.49 2-1"
            style={{
              fill: "#612005",
            }}
          />
          <path
            d="M176.07 29.05v-1h2l1 1c.09 1.49 1.24.85 2 1v1l-1 1h-1l-1-1-1-1Z"
            style={{
              fill: "#63260a",
            }}
          />
          <path
            d="M172.07 27.05h2v1l-1 1h-3v-1c.76-.15 1.93.49 2-1"
            style={{
              fill: "#62220d",
            }}
          />
          <path
            d="M179.07 26.05h1c-.38 1 .93 2.53-1 3l-1-1v-1Z"
            style={{
              fill: "#692106",
            }}
          />
          <path
            d="m173.07 29.05 1-1h1c-.07 1.49-1.24.85-2 1"
            style={{
              fill: "#833e25",
            }}
          />
          <path
            d="M178.07 27.05v1h-1v-3Z"
            style={{
              fill: "#92411c",
            }}
          />
          <path
            d="M178.07 23.05v1l-1-1Z"
            style={{
              fill: "#7d3926",
            }}
          />
          <circle
            cx={177.57}
            cy={22.55}
            r={0.71}
            className="templesOnly_svg__cls-2126"
          />
          <circle
            cx={176.57}
            cy={21.55}
            r={0.71}
            className="templesOnly_svg__cls-2126"
          />
          <path
            d="M169.07 25.05v1h-1c-.33-.67-.67-1.33-1-2v-1c.76.15 1.92-.5 2 1Z"
            style={{
              fill: "#320102",
            }}
          />
          <circle
            cx={169.57}
            cy={24.55}
            r={0.71}
            className="templesOnly_svg__cls-2128"
          />
          <path d="m171.07 23.05-1 1Z" className="templesOnly_svg__cls-2128" />
          <path
            d="M167.07 22.05v-1l1 1Z"
            style={{
              fill: "#bc8658",
            }}
          />
          <path
            d="M169.07 26.05h2l-1 2h-1Z"
            style={{
              fill: "#2e0300",
            }}
          />
          <path
            d="M177.07 22.05v-3h2v1c-.33.67-.67 1.33-1 2Z"
            style={{
              fill: "#6f3400",
            }}
          />
          <path
            d="M179.07 20.05v-3h2v4Z"
            style={{
              fill: "#702b0d",
            }}
          />
          <path
            d="M184.07 21.05h-2v-2c.15-.76-.5-1.92 1-2l1 1z"
            style={{
              fill: "#561900",
            }}
          />
          <path
            d="M162.07 25.05h1l1-1h1c.33.67.67 1.33 1 2l-1 1h-1c-.08-1.5-1.24-.85-2-1Z"
            className="templesOnly_svg__cls-2134"
          />
          <path
            d="M167.07 23.05v1h-2c.09-1.5 1.24-.85 2-1"
            className="templesOnly_svg__cls-2135"
          />
          <path
            d="m163.07 24.05-1-1c.76.15 1.92-.5 2 1Z"
            style={{
              fill: "#c58347",
            }}
          />
          <path
            d="M157.07 27.05h1v1l1 1h2v1H158c.15.9.24 1.46.29 1.75l2.79-.75c-1.87 2.55-2.19 2.63-4 1v-1c-.33-.67-.67-1.33-1-2l1-1Z"
            style={{
              fill: "#430c0c",
            }}
          />
          <path
            d="m153.07 27.05 1-1h1v2h-1Z"
            style={{
              fill: "#ca8348",
            }}
          />
          <path
            d="m157.07 28.05-1 1h-1v-1z"
            style={{
              fill: "#470b00",
            }}
          />
          <path
            d="M157.07 28.05h-1l1-1Z"
            className="templesOnly_svg__cls-2140"
          />
          <path
            d="M162.07 25.05v1l-1 1h-2a8 8 0 0 1 .77-1 15 15 0 0 1 1.23-1Z"
            style={{
              fill: "#470f01",
            }}
          />
          <path
            d="M159.07 27.05h1l-1 1h-1v-1Z"
            style={{
              fill: "#360000",
            }}
          />
          <path
            d="M163.07 24.05h1l-1 1Z"
            className="templesOnly_svg__cls-2135"
          />
          <path
            d="m194.07 16.05-.67.83-.33-.83Z"
            style={{
              fill: "#863f0d",
            }}
          />
          <path
            d="M193.07 16.05h-1v-1Z"
            style={{
              fill: "#974f1c",
            }}
          />
          <path
            d="M187.07 16.05v-1h3v3h-2c-.15-.76.5-1.92-1-2"
            className="templesOnly_svg__cls-1953"
          />
          <path
            d="M190.07 15.05h-3v-1c.76-.15 1.92.49 2-1h1Z"
            style={{
              fill: "#85451a",
            }}
          />
          <path
            d="M190.07 18.05v-2h1v2Z"
            style={{
              fill: "#6c2c07",
            }}
          />
          <path
            d="M191.07 17.05v-1l1-1v2Z"
            style={{
              fill: "#874114",
            }}
          />
          <path
            d="M184.07 21.05v-2l1.72 2c.09-.67.19-1.33.28-2h1a10 10 0 0 0 .61 2.07c.53.95.8 1.66-.61 1.93h-3Z"
            className="templesOnly_svg__cls-2148"
          />
          <path
            d="M187.07 19.05h-1c.33-1 .67-2 1-3 1.5.08.85 1.24 1 2Z"
            style={{
              fill: "#551c06",
            }}
          />
          <path
            d="m184 18 .69-.82.32.32-.82.69Z"
            style={{
              fill: "#783b26",
            }}
          />
          <path
            d="m22 112.05 1-1h4v1c-1 .39-2.54-.92-3 1h-1c-.3-.33-.63-.66-1-1"
            style={{
              fill: "#e7b06e",
            }}
          />
          <path
            d="M20 117.05v-1l2-1h1v1l-2 2h-1Z"
            style={{
              fill: "#dd9c52",
            }}
          />
          <path
            d="m18 114.05 1-1c.75.15 1.91-.49 2 1l-1 1h-2Z"
            className="templesOnly_svg__cls-1779"
          />
          <path
            d="m20 115.05 1-1c.33.34.66.67 1 1l-2 1Z"
            className="templesOnly_svg__cls-2153"
          />
          <path
            d="M24 115.05v-1c.66.34 1.33.67 2 1v1h-2Z"
            className="templesOnly_svg__cls-2154"
          />
          <circle
            cx={23.54}
            cy={115.55}
            r={0.71}
            style={{
              fill: "#fec475",
            }}
          />
          <path
            d="M23 113.05h1v1Z"
            style={{
              fill: "#fec37c",
            }}
          />
          <path
            d="M21 110.05v-2h2v2Z"
            style={{
              fill: "#c87b36",
            }}
          />
          <path
            d="M25 111.05h-2v-1c.79.15 2-.49 2 1"
            style={{
              fill: "#fed595",
            }}
          />
          <path
            d="M20 106.05h-1v-2l1-1h1c.15.76-.5 1.92 1 2h1v1Z"
            style={{
              fill: "#ba5a20",
            }}
          />
          <path
            d="m20 103.05-1 1v-2c.37.34.7.67 1 1"
            style={{
              fill: "#d47e4b",
            }}
          />
          <path
            d="M23 105.05h-1c-.16-.75.49-1.91-1-2v-1l2-1Z"
            style={{
              fill: "#9d3a05",
            }}
          />
          <path
            d="M21 100.05v-1l1-1h1l1 1v1z"
            style={{
              fill: "#92420e",
            }}
          />
          <path
            d="M21 100.05h2v1l-2 1Z"
            style={{
              fill: "#9e420e",
            }}
          />
          <path
            d="m22 98.05-1 1h-1v-1z"
            className="templesOnly_svg__cls-1963"
          />
          <path
            d="M16 98.05v-1l1-1h1l1 1v1z"
            style={{
              fill: "#914118",
            }}
          />
          <circle
            cx={19.54}
            cy={98.55}
            r={0.71}
            style={{
              fill: "#b86936",
            }}
          />
          <path
            d="M20 106.05h3v1l-1 1h-1c-.3-.66-.63-1.33-1-2"
            style={{
              fill: "#de8847",
            }}
          />
          <path
            d="M173.07 42.05c-.76.15-1.91-.5-2 1l-1 1h-1c.23-.73.48-1.44.67-2.18.15-.59.22-1.21.33-1.82.33-.67.67-1.33 1-2h1l1 1z"
            style={{
              fill: "#a24c16",
            }}
          />
          <path
            d="M178.07 40.05c-.24 1.37-1 1.22-1.88.62-.36-.23-.75-.42-1.12-.62v-2l1-1h1v1c.15.76-.5 1.95 1 2"
            className="templesOnly_svg__cls-647"
          />
          <path
            d="M178.07 40.05c-1.5-.09-.85-1.24-1-2l2-1c.3.52.59 1 .86 1.5l-.86 1.5Z"
            style={{
              fill: "#97470f",
            }}
          />
          <path
            d="M173.07 41.05v-2h1v1Z"
            className="templesOnly_svg__cls-2169"
          />
          <circle
            cx={174.57}
            cy={39.55}
            r={0.71}
            style={{
              fill: "#803700",
            }}
          />
          <path
            d="M181.07 35.05v1l-2 1-1-1v-1c.76-.15 1.92.49 2-1h1Z"
            style={{
              fill: "#76370b",
            }}
          />
          <path
            d="m171.07 45.05 2 2-1 1h-1c-.76.15-1.91-.5-2 1l-1.57-.87-1.43 1.07v-2.2h4v-2Z"
            style={{
              fill: "#7c2304",
            }}
          />
          <path
            d="M175.07 47.05v1h-2v-1z"
            className="templesOnly_svg__cls-2173"
          />
          <path
            d="M171.07 45.05h-1v-1l1-1z"
            style={{
              fill: "#cd7a4e",
            }}
          />
          <path
            d="M175.07 49.05v1h-1l-1 1h-2l-1 1h-1c-.76.15-1.91-.5-2 1-.76.15-1.91-.5-2 1-.76.15-1.91-.5-2 1h-1c-.76.15-1.91-.5-2 1h-1v-2h1l1-1c.76-.15 1.92.49 2-1h2l1-1h2l1-1h1c.76-.15 1.92.49 2-1z"
            style={{
              fill: "#feb25a",
            }}
          />
          <path
            d="M172.07 51.05h1l1-1h2v1a5.34 5.34 0 0 1-4 1Z"
            className="templesOnly_svg__cls-2176"
          />
          <path
            d="M179.07 49.05h1c-.47 1.93-2 .62-3 1 .09-1.5 1.24-.85 2-1"
            className="templesOnly_svg__cls-2173"
          />
          <ellipse
            cx={174.07}
            cy={48.55}
            rx={1.41}
            ry={0.71}
            style={{
              fill: "#feb868",
            }}
          />
          <path
            d="M176.07 47.05h2l-1.24 1Z"
            style={{
              fill: "#fec17a",
            }}
          />
          <path d="M176.07 51.05v-1h1Z" className="templesOnly_svg__cls-2173" />
          <path
            d="M172.07 52.05a5.34 5.34 0 0 0 4-1v4l-3 1v-2l2-1h-3Z"
            style={{
              fill: "#f3a95a",
            }}
          />
          <path
            d="M176.07 54.05v-1l2-1v3h-1Z"
            style={{
              fill: "#eea967",
            }}
          />
          <path
            d="M178.07 53.05v-1l3-1v2Z"
            style={{
              fill: "#e9a764",
            }}
          />
          <path
            d="M187.07 33.05c-.33.67-.67 1.33-1 2h-1l-1-1v-1l1-1h1Z"
            style={{
              fill: "#9f612c",
            }}
          />
          <path
            d="M186 32a6 6 0 0 1-1 0v-2c.76-.15 1.92.49 2-1v-1h2v5h-2zl.14.15.82-.69-.32-.32a6 6 0 0 0-.64.86"
            style={{
              fill: "#8f4519",
            }}
          />
          <path
            d="m184.07 34.05 1 1-3 1v-2z"
            style={{
              fill: "#aa7137",
            }}
          />
          <path
            d="M182.07 34.05v1h-1v-1l1-1Z"
            style={{
              fill: "#793f0f",
            }}
          />
          <path
            d="M92 59.05c.15-.75-.5-1.91 1-2 .15.76-.5 1.92 1 2 .33.34.66.67 1 1v1h-2l-1-1Z"
            style={{
              fill: "#6a1503",
            }}
          />
          <path
            d="M96 56.05h2v2h-1c-.34-.33-.67-.66-1-1Z"
            style={{
              fill: "#823315",
            }}
          />
          <path
            d="M92 59.05v1h-2c.15-.75-.5-1.91 1-2 .37.34.7.67 1 1"
            style={{
              fill: "#923d1d",
            }}
          />
          <path
            d="M94 59.05c-1.5-.08-.85-1.24-1-2h1z"
            style={{
              fill: "#6a1711",
            }}
          />
          <circle
            cx={95.54}
            cy={57.55}
            r={0.71}
            className="templesOnly_svg__cls-2190"
          />
          <circle
            cx={94.54}
            cy={57.55}
            r={0.71}
            style={{
              fill: "#6e2919",
            }}
          />
          <path
            d="M89 62.05h1l1 1v2l-1 1v1h-1z"
            className="templesOnly_svg__cls-2192"
          />
          <path
            d="M90 60.05h2l1 1v1h-2c-.34-.33-.67-.66-1-1Z"
            style={{
              fill: "#88370a",
            }}
          />
          <path
            d="M90 61.05c.33.34.66.67 1 1v1l-1-1Z"
            style={{
              fill: "#a75b2f",
            }}
          />
          <path
            d="M89 62.05v1h-1v-2h1Z"
            style={{
              fill: "#7c2e0e",
            }}
          />
          <path
            d="m187.07 19.05 1-1h3l1 1v1l-2 2v2h-3v-1c1.41-.27 1.14-1 .61-1.93a10 10 0 0 1-.61-2.07"
            style={{
              fill: "#6b361c",
            }}
          />
          <ellipse
            cx={179.57}
            cy={53.55}
            rx={2.12}
            ry={0.71}
            style={{
              fill: "#feba7c",
            }}
          />
          <path
            d="M177.07 55.05h1v1c-.76-.15-1.91.49-2-1Z"
            style={{
              fill: "#984d16",
            }}
          />
          <path
            d="M179.07 57.05h-1v-1Z"
            style={{
              fill: "#b4642c",
            }}
          />
          <path
            d="m180.07 62.05 2 1v1h-1l-1 1h-1v-3Z"
            style={{
              fill: "#782400",
            }}
          />
          <path
            d="M180.07 62.05h-2l-1-1v-1h2l1 1Z"
            style={{
              fill: "#9a450f",
            }}
          />
          <circle
            cx={183.57}
            cy={63.55}
            r={0.71}
            className="templesOnly_svg__cls-2009"
          />
          <circle
            cx={182.57}
            cy={63.55}
            r={0.71}
            className="templesOnly_svg__cls-2001"
          />
          <circle
            cx={179.57}
            cy={59.55}
            r={0.71}
            style={{
              fill: "#d88f5d",
            }}
          />
          <path
            d="M179.07 58.05v1h-4v-1l3-1Z"
            style={{
              fill: "#934302",
            }}
          />
          <path
            d="M183.07 65.05h-1l-1-1h3Z"
            style={{
              fill: "#752501",
            }}
          />
          <path
            d="M189.07 28.05h-2l2-2Z"
            className="templesOnly_svg__cls-2205"
          />
          <path
            d="M187.07 23.05v2l-1 1h-1c-.08-1.5-1.24-.85-2-1v-1l1-1Z"
            style={{
              fill: "#622e12",
            }}
          />
          <path
            d="M183.07 25.05c.76.15 1.92-.5 2 1l-1 1h-2l-1-1Z"
            style={{
              fill: "#693011",
            }}
          />
          <path
            d="M187.07 29.05c-.08 1.49-1.24.85-2 1l-1-1v-1h2Z"
            style={{
              fill: "#a56842",
            }}
          />
          <path
            d="M182.07 27.05h2v1h-1Z"
            style={{
              fill: "#5e2502",
            }}
          />
          <path
            d="M190.07 24.05v-2c1.5.08.85 1.24 1 2Z"
            style={{
              fill: "#5c2103",
            }}
          />
          <path
            d="m187.07 29.05-1-1h1Z"
            className="templesOnly_svg__cls-2205"
          />
          <path
            d="M185.07 26.05h1l-.67.83Z"
            style={{
              fill: "#5b1f03",
            }}
          />
          <path
            d="m186.07 26.05 1-1Z"
            style={{
              fill: "#551d04",
            }}
          />
          <path
            d="M121 43.05h2v2a12 12 0 0 0-1 1.17c-.34.51-.6 1.06-.9 1.59l.52.42 1.38-1.18h2v1c-1.5.09-.85 1.25-1 2h-1l-1.5-.85-1.5.85-1-1v-1c1.49-.08.84-1.24.94-2l.15.15.81-.7-.31-.31a5.5 5.5 0 0 0-.59.81 7 7 0 0 1-.94 0v-2h1Z"
            style={{
              fill: "#611a0c",
            }}
          />
          <path d="m121.07 43.05-1 1Z" className="templesOnly_svg__cls-1559" />
          <path
            d="M119 48.05v1h-2v-3h1c.19.76-.46 1.95 1 2"
            className="templesOnly_svg__cls-2214"
          />
          <circle
            cx={116.54}
            cy={48.55}
            r={0.71}
            style={{
              fill: "#7a381e",
            }}
          />
          <path
            d="M119 48.05c-1.5-.08-.85-1.24-1-2h1Z"
            style={{
              fill: "#9b522f",
            }}
          />
          <path
            d="M113 51.05c.33-.25.95-.51.95-.76 0-1.68 1.18-1.15 2.05-1.24v2l-2 2-1 1c-.67-.66-1.34-1.33-2-2h1Z"
            className="templesOnly_svg__cls-2217"
          />
          <path
            d="M111 50.05h1l1 1h-1c-.3-.33-.63-.66-1-1"
            style={{
              fill: "#8a4720",
            }}
          />
          <path
            d="M111 50.05c.33.34.66.67 1 1v1h-2c-.34-.33-.67-.66-1-1v-1z"
            style={{
              fill: "#75330e",
            }}
          />
          <path
            d="M109 50.05v4c-.76-.15-1.92.5-2-1 .33-1 .66-2 1-3Z"
            style={{
              fill: "#5c0e03",
            }}
          />
          <path
            d="M108 50.05c-.34 1-.67 2-1 3h-1l-1-1v-1h1l1-1Z"
            className="templesOnly_svg__cls-2221"
          />
          <path d="m107 50.05-1 1v-1Z" className="templesOnly_svg__cls-2026" />
          <path
            d="M106 50.05c-.34-.33-.67-.66-1-1 .37.34.7.67 1 1"
            style={{
              fill: "#bd7435",
            }}
          />
          <path
            d="M123.07 43.05h-1v-2h2v1Z"
            style={{
              fill: "#ab6429",
            }}
          />
          <path
            d="M135.07 37.05h2c.15.76-.5 1.91 1 2h3v1l-.83.33.83.67c-.33.67-.67 1.33-1 2h-2a8 8 0 0 0 0-1l.14.15.82-.69-.32-.32a6 6 0 0 0-.71.81c-1-.28-2-.61-3.11-1l.78-1.1Z"
            style={{
              fill: "#561501",
            }}
          />
          <path
            d="M125 48.05v-1l.82-.33-.82-.67v-1c1.49-.08.84-1.24 1-2h1v1c.39.34.74.89 1.18 1a17.7 17.7 0 0 0 2.82 0c.33.34.66.67 1 1h-4l-.83.33.83.67v1c-.76.15-1.92-.49-2 1-.3-.33-.63-.66-1-1"
            className="templesOnly_svg__cls-1578"
          />
          <path
            d="M128 46.05h4l2-1c.08 1.5 1.24.85 2 1 0 1.34-1.06.81-1.74 1a4.7 4.7 0 0 0-1.26 1h-1c-.34-.33-.67-.66-1-1l-1 1c-.67-.33-1.34-.66-2-1Z"
            style={{
              fill: "#6f2c0d",
            }}
          />
          <path
            d="M136 46.05c-.76-.15-1.92.5-2-1l3-1 1 1v1Z"
            style={{
              fill: "#854721",
            }}
          />
          <path
            d="m138 45.05-1-1 1-1h2v2z"
            style={{
              fill: "#8b462a",
            }}
          />
          <path
            d="M131.07 43.05c-1.5-.09-.85-1.24-1-2 1.5.08.85 1.24 1 2"
            style={{
              fill: "#561c18",
            }}
          />
          <path
            d="M138.07 35.05h1v1h-2Z"
            className="templesOnly_svg__cls-1691"
          />
          <path
            d="M137.07 36.05h2c-.33 1-.67 2-1 3-1.5-.09-.85-1.24-1-2Z"
            className="templesOnly_svg__cls-2033"
          />
          <path
            d="M127.07 44.05v-1c.09-1.5 1.24-.85 2-1Z"
            className="templesOnly_svg__cls-2040"
          />
          <path
            d="M126.07 41.05v2h-2v-1l1-1Z"
            style={{
              fill: "#6d2400",
            }}
          />
          <path
            d="m125.07 41.05-1 1v-1Z"
            className="templesOnly_svg__cls-1843"
          />
          <path
            d="M44 79.05h4c.08 1.5 1.24.85 2 1v1l-1 1h-1l-.33-.83c-.91.15-1.92 2.06-2.73-.21l.15.15.81-.7-.31-.31A5.5 5.5 0 0 0 45 81a7 7 0 0 1-.94 0v-2Z"
            className="templesOnly_svg__cls-2111"
          />
          <path
            d="M44 80.05v2h-2v-2Z"
            style={{
              fill: "#8c3c20",
            }}
          />
          <path
            d="M44 82.05v-1h1c.75 2.23 1.76.32 2.67.17l.33.83v1l-1 1h-3z"
            className="templesOnly_svg__cls-2231"
          />
          <path
            d="M44 84.05h2v1l-1 1-.76-1-1.24 1h-1v-2Z"
            className="templesOnly_svg__cls-2232"
          />
          <path
            d="M35 87.05v-2h1c.33.34.66.67 1 1v2h-2Z"
            style={{
              fill: "#6b1c07",
            }}
          />
          <path
            d="m39 87.05 3-1v1l-1 1h-2Z"
            style={{
              fill: "#9a4d27",
            }}
          />
          <path
            d="M39 87.05v2h-2v-1Z"
            style={{
              fill: "#8b3d1c",
            }}
          />
          <path
            d="M37 86.05c-.34-.33-.67-.66-1-1h3Z"
            style={{
              fill: "#5c0f00",
            }}
          />
          <path
            d="M39.46 84.21 37 83.52a8 8 0 0 1 1.4-.43c.18-.02.38.35 1.06 1.12"
            style={{
              fill: "#8d4125",
            }}
          />
          <path
            d="M44 82.05v1c-.34-.33-.67-.66-1-1Z"
            style={{
              fill: "#5f0d00",
            }}
          />
          <path
            d="M53 76.05v1l-1 1-1-1v-1l1-1Z"
            style={{
              fill: "#651900",
            }}
          />
          <circle
            cx={50.54}
            cy={76.55}
            r={0.71}
            style={{
              fill: "#5d0e00",
            }}
          />
          <ellipse
            cx={49.04}
            cy={78.55}
            rx={1.41}
            ry={0.71}
            style={{
              fill: "#904128",
            }}
          />
          <path
            d="M50 79.05v-2h1l1 1-1 1Z"
            className="templesOnly_svg__cls-2242"
          />
          <path
            d="m67 70.05 1-1 3-1 1 1h2c-.34.67-.67 1.34-1 2a7 7 0 0 1-1-.05c-1.23-1-1.23-1-2.89-.06 1.12 0 2 0 2.89.06a5 5 0 0 1 0 1.05l-2.72.74-1.28-.74h-1Z"
            style={{
              fill: "#67190a",
            }}
          />
          <path
            d="M77 65.05c.33.34.66.67 1 1v4h-1l-1-1-1-1a2.46 2.46 0 0 1 2-3"
            style={{
              fill: "#601309",
            }}
          />
          <path
            d="m76 69.05 1 1c-.09 1.5-1.25.85-2 1h-2c.33-.66.66-1.33 1-2l1-1Z"
            className="templesOnly_svg__cls-2245"
          />
          <path
            d="m72 69.05-1-1v-1h2v1Z"
            style={{
              fill: "#7e331c",
            }}
          />
          <path
            d="m72 69.05 1-1v1Z"
            style={{
              fill: "#8f4530",
            }}
          />
          <path
            d="M67 70.05v2h-2v-2Z"
            style={{
              fill: "#8e3f18",
            }}
          />
          <path d="M65 71.05v1h-2v-1z" className="templesOnly_svg__cls-2249" />
          <path d="M64 71.05h-2v-1h2Z" className="templesOnly_svg__cls-1879" />
          <circle
            cx={63.54}
            cy={69.55}
            r={0.71}
            className="templesOnly_svg__cls-2249"
          />
          <path
            d="m148.07 29.05 3-1 1 1v1h-1l-1 1h-2z"
            style={{
              fill: "#a1612f",
            }}
          />
          <path
            d="M148.07 29.05v1h-1a5.34 5.34 0 0 1-4 1v-1l1-1z"
            style={{
              fill: "#7f3809",
            }}
          />
          <path
            d="m152.07 29.05-1-1 2-1 1 1c-.07 1.49-1.24.85-2 1"
            style={{
              fill: "#ae6d3f",
            }}
          />
          <path
            d="M101 58.05h1v2c.33.34.66.67 1 1v1l-1 1h-1v-1c-.16-.75.49-1.91-1-2v-1Z"
            style={{
              fill: "#722008",
            }}
          />
          <path
            d="M105 51.05v1c-.76.15-1.92-.49-2 1v1h-1v-3z"
            style={{
              fill: "#702200",
            }}
          />
          <path
            d="M102 59.05v-1l1-1 1-1h1v2c-.76.15-1.92-.49-2 1Z"
            style={{
              fill: "#7e2c0a",
            }}
          />
          <path
            d="m101 58.05-1 1h-4v-1z"
            className="templesOnly_svg__cls-2190"
          />
          <path
            d="M103 54.05v-1h2v2h-2Z"
            style={{
              fill: "#9c4f2f",
            }}
          />
          <path
            d="M99 58.05h-1v-3h1Z"
            style={{
              fill: "#71220b",
            }}
          />
          <path d="m104 56.05-1 1Z" className="templesOnly_svg__cls-2258" />
          <circle
            cx={104.54}
            cy={55.55}
            r={0.71}
            className="templesOnly_svg__cls-2258"
          />
          <path
            d="M103 54.05v1c-.34-.33-.67-.66-1-1Z"
            className="templesOnly_svg__cls-2065"
          />
          <path
            d="M89 64.05v2l-1 1-3-1h-2v-1c.75-.15 1.91.5 2-1l1.28.74Z"
            style={{
              fill: "#6a2509",
            }}
          />
          <path
            d="M78 70.05v-2c1.49-.08.84-1.24 1-2l2 2v2z"
            style={{
              fill: "#6a2308",
            }}
          />
          <path
            d="M81 70.05v-2h1c.33.34.66.67 1 1h1v1Z"
            style={{
              fill: "#7f341b",
            }}
          />
          <path
            d="M82 62.05h1c.33.34.66.67 1 1v1h-2Z"
            style={{
              fill: "#7b3008",
            }}
          />
          <path d="M83 66.05h2v1h-3Z" className="templesOnly_svg__cls-2263" />
          <path
            d="M82 67.05h1v2c-.34-.33-.67-.66-1-1Z"
            style={{
              fill: "#853d1e",
            }}
          />
          <path
            d="M83 64.05h2c-.09 1.5-1.25.85-2 1Z"
            className="templesOnly_svg__cls-2263"
          />
          <path
            d="m81 65.05 1-1Z"
            style={{
              fill: "#712002",
            }}
          />
          <path
            d="M79 66.05c-.16.76.49 1.92-1 2v-2Z"
            style={{
              fill: "#570801",
            }}
          />
          <path
            d="M85 64.05h-1v-3h1z"
            style={{
              fill: "#7e3817",
            }}
          />
          <path
            d="M84 62.05v1c-.34-.33-.67-.66-1-1ZM85 64.05v-2h1l2 1h1v1l-2.72.74Z"
            className="templesOnly_svg__cls-2263"
          />
          <path
            d="m88 63.05-2-1c.08-1.49 1.24-.85 2-1Z"
            style={{
              fill: "#853a17",
            }}
          />
          <path
            d="m23 88.05 1-1h1c1.49.09.84 1.25 1 2l-1 1h-1c-.3-.66-.63-1.33-1-2"
            style={{
              fill: "#6b1d02",
            }}
          />
          <path
            d="M26 89.05c-.16-.75.49-1.91-1-2v-1h2v3Z"
            style={{
              fill: "#813410",
            }}
          />
          <path
            d="M140.07 32.05h3v2h-2l-1-1Z"
            style={{
              fill: "#b46f3b",
            }}
          />
          <path
            d="M141.07 34.05h1v1l-2 2-1-1v-1c.76-.15 1.93.49 2-1"
            style={{
              fill: "#531101",
            }}
          />
          <path
            d="m140.07 33.05 1 1h-3Z"
            style={{
              fill: "#df9966",
            }}
          />
          <path
            d="M143.07 31.05a5.34 5.34 0 0 0 4-1v2h-1l-1 1h-1l-1-1Z"
            style={{
              fill: "#a76532",
            }}
          />
          <path
            d="M143.07 30.05v1l-1-1Z"
            className="templesOnly_svg__cls-1888"
          />
          <circle
            cx={19.54}
            cy={117.55}
            r={0.71}
            style={{
              fill: "#c38742",
            }}
          />
          <path
            d="M20 115.05v1c-.76-.15-1.92.5-2-1Z"
            style={{
              fill: "#fece87",
            }}
          />
          <path d="m144.07 29.05-1 1Z" className="templesOnly_svg__cls-1888" />
          <path
            d="M50 79.05h1c2 .1 3.83-.09 5-2v-2h1c.39.34.74.89 1.18 1a17.7 17.7 0 0 0 2.82 0v1c-.09 1.5-1.25.85-2 1s-1.92-.49-2 1c-.76.15-1.92-.49-2 1h-1c-.76.15-1.92-.49-2 1l-1 1h-1z"
            style={{
              fill: "#6d1f07",
            }}
          />
          <path
            d="M56 77.05c-1.17 1.91-3 2.1-5 2l1-1 1-1z"
            style={{
              fill: "#5e1000",
            }}
          />
          <path
            d="M56 77.05h-2v-2h2Z"
            style={{
              fill: "#873c1b",
            }}
          />
          <path
            d="m53 76.05-1-1c.37.34.7.67 1 1"
            className="templesOnly_svg__cls-2280"
          />
          <path d="M56 72.05h1l-1 1Z" className="templesOnly_svg__cls-1902" />
          <path
            d="M61 77.05v-1c-.09-1.49-1.25-.85-2-1v-1c.75-.15 1.91.5 2-1v-1l1-1h1v1l-1 2h2c.33.34.66.67 1 1v1h-1c-.76.15-1.92-.49-2 1Z"
            style={{
              fill: "#7a290e",
            }}
          />
          <path
            d="M59 75.05c.75.15 1.91-.49 2 1a17.7 17.7 0 0 1-2.82 0c-.44-.07-.79-.62-1.18-1Z"
            style={{
              fill: "#5d0f00",
            }}
          />
          <path
            d="M61 73.05c-.09 1.5-1.25.85-2 1v-1Z"
            style={{
              fill: "#9b4031",
            }}
          />
          <path d="m62 71.05-1 1v-1Z" className="templesOnly_svg__cls-2284" />
          <circle
            cx={61.54}
            cy={70.55}
            r={0.71}
            className="templesOnly_svg__cls-2249"
          />
          <path
            d="M23 88.05c.33.67.66 1.34 1 2h-2v-2Z"
            style={{
              fill: "#712207",
            }}
          />
          <path
            d="m21 94.05 1-2h2v1l-1 1Z"
            className="templesOnly_svg__cls-2286"
          />
          <path
            d="M22 90.05h3v1h-3Z"
            style={{
              fill: "#792d16",
            }}
          />
          <ellipse
            cx={23.04}
            cy={91.55}
            rx={1.41}
            ry={0.71}
            style={{
              fill: "#681a04",
            }}
          />
          <circle
            cx={20.54}
            cy={94.55}
            r={0.71}
            className="templesOnly_svg__cls-2289"
          />
          <path
            d="m19 97.05-1-1 1-1h1v2Z"
            style={{
              fill: "#9d4b23",
            }}
          />
          <path
            d="m19 95.05-1 1h-1v-1l1.6-.87Z"
            className="templesOnly_svg__cls-2289"
          />
          <path
            d="M17 95.05v1l-1 1v-2Z"
            className="templesOnly_svg__cls-2060"
          />
          <path
            d="M35 87.05v2c-.76.15-1.92-.49-2 1h-3v-1a4.6 4.6 0 0 0 4-2Z"
            style={{
              fill: "#74220c",
            }}
          />
          <path
            d="M31 86.05v1a8.6 8.6 0 0 1-.77 1c-.38.37-.82.67-1.23 1h-1v-2l1-1Z"
            className="templesOnly_svg__cls-2292"
          />
          <path
            d="M28 89.05h2v2h-1c-.34-.33-.67-.66-1-1h-2v-1z"
            style={{
              fill: "#6e210a",
            }}
          />
          <path d="m28 86.05 1-1v1Z" className="templesOnly_svg__cls-2292" />
          <path
            d="M28 86.05h1l-1 1h-1v-1Z"
            style={{
              fill: "#6b1d00",
            }}
          />
          <path
            d="M20 118.05h1v2h-1Z"
            style={{
              fill: "#f6af6e",
            }}
          />
          <path
            d="M21 120.05v-1h1v2h-1Z"
            style={{
              fill: "#8b3402",
            }}
          />
          <path
            d="m182.07 27.05 1 1v1l-1 1h-1c-.76-.15-1.91.49-2-1 1.93-.47.62-2 1-3h1Z"
            style={{
              fill: "#692a0d",
            }}
          />
          <path d="m184.07 23.05-1 1Z" className="templesOnly_svg__cls-2148" />
          <path
            d="m175.07 32.05 1 1v2l-1 1h-3c.33-.67.67-1.33 1-2Z"
            style={{
              fill: "#a55a28",
            }}
          />
          <path
            d="m175.07 32.05-2 2c-.33-.67-.67-1.33-1-2v-1l1-1Z"
            style={{
              fill: "#ae6437",
            }}
          />
          <path
            d="M176.07 34.05v-1h3l1 1c-.08 1.49-1.24.85-2 1l-1-1Z"
            style={{
              fill: "#854626",
            }}
          />
          <path
            d="m173.07 30.05-1 1h-1l-1-1v-1h3Z"
            style={{
              fill: "#6f2b0f",
            }}
          />
          <path
            d="M179.07 32.05h1l-1 1Z"
            className="templesOnly_svg__cls-2302"
          />
          <path
            d="m177.07 30.05 1 1Z"
            style={{
              fill: "#672f14",
            }}
          />
          <path
            d="m176.07 29.05 1 1Z"
            style={{
              fill: "#4d0c00",
            }}
          />
          <path
            d="m179.07 33.05 1-1 1-1h1v2l-1 1h-1Z"
            style={{
              fill: "#985a35",
            }}
          />
          <circle
            cx={181.57}
            cy={30.55}
            r={0.71}
            className="templesOnly_svg__cls-2302"
          />
          <path
            d="m178.07 28.05 1 1Z"
            style={{
              fill: "#732c10",
            }}
          />
          <path
            d="M169.07 28.05h1v1h-3c.09-1.5 1.24-.85 2-1"
            style={{
              fill: "#441609",
            }}
          />
          <path
            d="M169.07 28.05c-.76.15-1.91-.5-2 1l-1-1-1-1 1-1h3Z"
            style={{
              fill: "#250603",
            }}
          />
          <ellipse
            cx={166.57}
            cy={25.05}
            rx={1.1}
            ry={1.81}
            style={{
              fill: "#371315",
            }}
            transform="rotate(-52.02 166.56 25.045)"
          />
          <path
            d="m166.07 28.05 1 1h3v1h-2l-1 1a4.58 4.58 0 0 0-4 2h-1l-1 1h-3l-1 1h-4v2h-1c-.76.15-1.91-.5-2 1a2.48 2.48 0 0 1 0-4v2.74l2-2.74c1-.38 2.53.93 3-1v-1h2c1.81 1.63 2.13 1.55 4-1l.83-.33-.83-.67v-1h3v-2h1Z"
            className="templesOnly_svg__cls-2310"
          />
          <path
            d="M164.07 27.05v2h-3v-2l1-1c.76.15 1.93-.5 2 1"
            style={{
              fill: "#622a1a",
            }}
          />
          <path
            d="m161.07 30.05.83.67-.83.33-2.79.75c-.05-.29-.14-.85-.29-1.75Z"
            style={{
              fill: "#350805",
            }}
          />
          <path
            d="M155.07 29.05h1c.33.67.67 1.33 1 2h-3c.33-.67.67-1.33 1-2"
            className="templesOnly_svg__cls-2313"
          />
          <path
            d="M161.07 27.05v2h-2v-1l1-1Z"
            className="templesOnly_svg__cls-2310"
          />
          <path
            d="M154.07 31.05h3v1h-3Z"
            style={{
              fill: "#632217",
            }}
          />
          <path
            d="M159.07 28.05v1l-1-1Z"
            className="templesOnly_svg__cls-2140"
          />
          <path
            d="M155.07 29.05c-.33.67-.67 1.33-1 2h-1l-1-1v-1c.76-.15 1.92.49 2-1h1Z"
            className="templesOnly_svg__cls-2315"
          />
          <path
            d="M26 116.05v-1c1.49-.08.84-1.24 1-2v-2h1c.2 2.24.76 2.8 3 3v1a5.4 5.4 0 0 0-4 1Z"
            className="templesOnly_svg__cls-2316"
          />
          <path
            d="M27 112.05v1c-1.5.09-.85 1.25-1 2-.67-.33-1.34-.66-2-1v-1c.5-1.92 2.05-.61 3-1"
            style={{
              fill: "#fcbe7c",
            }}
          />
          <path
            d="M25 111.05c-.09-1.49-1.25-.85-2-1v-1h2l1 1v1Z"
            style={{
              fill: "#f9c584",
            }}
          />
          <path
            d="M26 111.05v-1l1-1h1v2z"
            style={{
              fill: "#e8a76a",
            }}
          />
          <path
            d="M23 116.05h1v1l-1 1h-2Z"
            style={{
              fill: "#bc6c22",
            }}
          />
          <path
            d="M24 117.05v-1h3v1c-.34.42-.64.86-1 1.24a9 9 0 0 1-1 .76l-1-1Z"
            style={{
              fill: "#b5571e",
            }}
          />
          <path
            d="M24 109.05h-1v-1c.37.34.7.67 1 1"
            style={{
              fill: "#ba7832",
            }}
          />
          <path
            d="m22 108.05 1-1v1Z"
            style={{
              fill: "#e89351",
            }}
          />
          <path
            d="M23 101.05v-1h1c.38 1-.93 2.54 1 3v2l-1 1h-1z"
            className="templesOnly_svg__cls-2324"
          />
          <path
            d="M21 103.05c1.49.09.84 1.25 1 2-1.46-.05-.81-1.24-1-2"
            style={{
              fill: "#972d00",
            }}
          />
          <path
            d="M25 103.05c-1.93-.46-.62-2-1-3v-2h2v2c-1.89.47-.58 2.02-1 3"
            style={{
              fill: "#c47840",
            }}
          />
          <path
            d="M22 98.05h-1v-1h3v1z"
            style={{
              fill: "#af6532",
            }}
          />
          <path
            d="M23 98.05h1v1Z"
            style={{
              fill: "#712c00",
            }}
          />
          <path
            d="M21 97.05v1h-2v-1z"
            style={{
              fill: "#994918",
            }}
          />
          <path
            d="M23 106.05h1l-1 1Z"
            style={{
              fill: "#f29551",
            }}
          />
          <path
            d="M170.07 40.05c-.11.61-.18 1.23-.33 1.82-.19.74-.44 1.45-.67 2.18a5.34 5.34 0 0 0-4-1v-2h2l1-1Z"
            style={{
              fill: "#792202",
            }}
          />
          <path
            d="M173.07 34.05c-.33.67-.67 1.33-1 2v2h-1c.24-.81-1.84-1.51-.11-2.39l-.89-.61v-1z"
            style={{
              fill: "#692706",
            }}
          />
          <path
            d="M170.07 40.05h-3v-1l1-1c.06.61.05 1.16 1 .59a7.8 7.8 0 0 1 2-.59c-.33.67-.67 1.33-1 2"
            style={{
              fill: "#752508",
            }}
          />
          <path
            d="M172.07 38.05v-2h1v3Z"
            className="templesOnly_svg__cls-2169"
          />
          <circle
            cx={169.57}
            cy={44.55}
            r={0.71}
            style={{
              fill: "#da8454",
            }}
          />
          <path
            d="M176.07 34.05h1v3h-1z"
            style={{
              fill: "#8a3b0d",
            }}
          />
          <path
            d="M176.07 35.05v2l-1 1v-2Z"
            style={{
              fill: "#b66528",
            }}
          />
          <path
            d="M177.07 37.05v-1h1l1 1-2 1Z"
            style={{
              fill: "#8d3607",
            }}
          />
          <path
            d="M175.07 37.05v2h-1v-2Z"
            className="templesOnly_svg__cls-2169"
          />
          <path
            d="M174.07 37.05v2h-1v-3h1Z"
            style={{
              fill: "#e2985a",
            }}
          />
          <path
            d="M178.07 36.05h-1v-2l1 1Z"
            style={{
              fill: "#6a1b00",
            }}
          />
          <path
            d="M164.07 52.05h-2v-4h1l3-1v2.2l1.43-1.07 1.57.87v1h-1c-.76.15-1.91-.5-2 1h-1ZM169.07 45.05h1v2h-4c.09-1.5 1.24-.85 2-1Z"
            className="templesOnly_svg__cls-2340"
          />
          <path
            d="M173.07 48.05v1h-2v-1z"
            className="templesOnly_svg__cls-2341"
          />
          <path
            d="M171.07 48.05v1h-2c.09-1.5 1.24-.85 2-1M173.07 48.05h-1l1-1Z"
            className="templesOnly_svg__cls-2340"
          />
          <path
            d="M159.07 54.05v2l-1 1h-1l-1 1h-4v-1h1l1-1 1-1h2l1-1Z"
            style={{
              fill: "#f6a051",
            }}
          />
          <path
            d="M169.07 52.05h1v2h-2v-1Z"
            style={{
              fill: "#d17c27",
            }}
          />
          <path
            d="M159.07 54.05h-2v-1h3v1Z"
            className="templesOnly_svg__cls-2344"
          />
          <path
            d="M162.07 55.05h3l-1 1h-2Z"
            className="templesOnly_svg__cls-2345"
          />
          <path
            d="m158.07 57.05 1-1h1v1c-.08 1.49-1.24.85-2 1Z"
            style={{
              fill: "#c16d12",
            }}
          />
          <path
            d="M162.07 55.05v1h-2c.09-1.5 1.24-.85 2-1"
            className="templesOnly_svg__cls-2347"
          />
          <path
            d="M165.07 55.05h-2c.09-1.5 1.24-.85 2-1Z"
            className="templesOnly_svg__cls-2341"
          />
          <path
            d="M165.07 54.05c.09-1.5 1.24-.85 2-1v1zM169.07 52.05l-1 1h-1c.09-1.5 1.24-.85 2-1"
            className="templesOnly_svg__cls-2348"
          />
          <path
            d="M162.07 52.05h1c-.08 1.49-1.24.85-2 1v-1ZM166.07 51.05c.09-1.5 1.24-.85 2-1v1Z"
            className="templesOnly_svg__cls-2341"
          />
          <path
            d="M170.07 49.05h2c-.08 1.49-1.24.85-2 1Z"
            className="templesOnly_svg__cls-2348"
          />
          <path d="M160.07 54.05v-1h1Z" className="templesOnly_svg__cls-2341" />
          <circle
            cx={171.57}
            cy={51.55}
            r={0.71}
            className="templesOnly_svg__cls-2341"
          />
          <path
            d="M171.07 51.05v1h-1ZM165.07 51.05h1l-1 1Z"
            className="templesOnly_svg__cls-2348"
          />
          <path
            d="M165.07 51.05v1h-1ZM174.07 50.05l-1 1Z"
            className="templesOnly_svg__cls-2341"
          />
          <path d="M168.07 51.05v-1h1Z" className="templesOnly_svg__cls-2348" />
          <circle
            cx={169.57}
            cy={49.55}
            r={0.71}
            className="templesOnly_svg__cls-2341"
          />
          <path
            d="m178.07 57.05-3 1-.33-.83-.67.83-1-1v-1l3-1c.09 1.49 1.24.85 2 1Z"
            className="templesOnly_svg__cls-2349"
          />
          <path
            d="M173.07 56.05v1h-1v-1l-1-1-1-1v-1h2l1 1Z"
            style={{
              fill: "#efa147",
            }}
          />
          <path
            d="m173.07 54.05-1-1h3Z"
            style={{
              fill: "#feb15d",
            }}
          />
          <path
            d="M177.07 55.05h-1v-1Z"
            style={{
              fill: "#f5aa71",
            }}
          />
          <circle
            cx={171.57}
            cy={52.55}
            r={0.71}
            className="templesOnly_svg__cls-2176"
          />
          <circle
            cx={183.57}
            cy={33.55}
            r={0.71}
            style={{
              fill: "#aa743c",
            }}
          />
          <path
            d="m185.07 32.05-1 1v-1Z"
            style={{
              fill: "#a36c38",
            }}
          />
          <path
            d="M185.07 32.05h-1l-1 1v1h-1v-4l3 1Z"
            style={{
              fill: "#a26b3a",
            }}
          />
          <path
            d="m185.07 31.05-3-1 1-1h1l1 1Z"
            className="templesOnly_svg__cls-2356"
          />
          <path
            d="m186 32 .69-.82.32.32-.82.69Z"
            style={{
              fill: "#713103",
            }}
          />
          <path
            d="M96 59.05h4v1l-1 1h-4v-1Z"
            style={{
              fill: "#742a0d",
            }}
          />
          <path
            d="M95 61.05h4c0 1.35-1.05.86-1.76 1s-2.08-.66-2.24 1h-1c-.34-.33-.67-.66-1-1v-1Z"
            className="templesOnly_svg__cls-2359"
          />
          <path
            d="m96 59.05-1 1c-.34-.33-.67-.66-1-1l1-1h1Z"
            style={{
              fill: "#500",
            }}
          />
          <path
            d="M97 58.05h-1v-1c.37.34.7.67 1 1"
            className="templesOnly_svg__cls-1994"
          />
          <path d="m95 58.05-1 1v-1Z" className="templesOnly_svg__cls-2190" />
          <path
            d="M89 67.05h1c-.67 1-1.34 2-2 3h-1l-.33-.83-.67.83h-1v-3c.37.21.76.39 1.11.63.9.59 1.64.75 1.89-.63Z"
            className="templesOnly_svg__cls-2263"
          />
          <path
            d="M88 70.05c.66-1 1.33-2 2-3v-1h1v3l-1 1z"
            className="templesOnly_svg__cls-2361"
          />
          <path
            d="M93 62.05c.33.34.66.67 1 1l-3 1v-2Z"
            style={{
              fill: "#8d430c",
            }}
          />
          <path
            d="m91 64.05 3-1c.33.34.66.67 1 1v1h-4Z"
            style={{
              fill: "#924816",
            }}
          />
          <path d="M89 67.05h-1l1-1Z" className="templesOnly_svg__cls-2361" />
          <path
            d="M91 66.05h-1l1-1Z"
            style={{
              fill: "#924e2d",
            }}
          />
          <path
            d="M178.07 62.05h1v2h-2v-2Z"
            style={{
              fill: "#b8652d",
            }}
          />
          <path
            d="m181.07 66.05-1-1 1-1 1 1Z"
            style={{
              fill: "#91431b",
            }}
          />
          <ellipse
            cx={178.07}
            cy={64.55}
            rx={1.41}
            ry={0.71}
            style={{
              fill: "#82371a",
            }}
          />
          <path
            d="M178.07 62.05h-2v-1h1Z"
            style={{
              fill: "#db8144",
            }}
          />
          <path
            d="M177.07 61.05h-1v-2h1z"
            className="templesOnly_svg__cls-2369"
          />
          <circle
            cx={178.57}
            cy={59.55}
            r={0.71}
            className="templesOnly_svg__cls-2349"
          />
          <circle
            cx={177.57}
            cy={59.55}
            r={0.71}
            style={{
              fill: "#7d3306",
            }}
          />
          <ellipse
            cx={175.57}
            cy={60.05}
            rx={0.71}
            ry={1.41}
            style={{
              fill: "#eb8f4f",
            }}
          />
          <path
            d="m174.07 58.05.67-.83.33.83v1h-1Z"
            style={{
              fill: "#a25513",
            }}
          />
          <path
            d="m175.07 64.05-2 1h-1v-1l1-1 1-1 1 1Z"
            style={{
              fill: "#d38a57",
            }}
          />
          <path
            d="M172.07 65.05v2l-3-1v-1l1-1h1Z"
            style={{
              fill: "#c7742e",
            }}
          />
          <circle
            cx={183.57}
            cy={28.55}
            r={0.71}
            className="templesOnly_svg__cls-2205"
          />
          <path
            d="M125 48.05c.33.34.66.67 1 1s.66.67 1 1l-2 1-1-1c.19-.75-.46-1.91 1-2"
            style={{
              fill: "#722e0d",
            }}
          />
          <path
            d="m120 50.05 1.5-.85 1.5.85-1 1h-2Z"
            className="templesOnly_svg__cls-2376"
          />
          <path
            d="m123 47.05-1.37 1.18-.52-.42c.3-.53.56-1.08.9-1.59a12 12 0 0 1 1-1.17v2Z"
            style={{
              fill: "#510700",
            }}
          />
          <path d="M124 42.05v3h-1v-2Z" className="templesOnly_svg__cls-2021" />
          <path
            d="M123 47.05v-1h2l.82.67-.82.33Z"
            style={{
              fill: "#4f0700",
            }}
          />
          <path
            d="M120 50.05v1l-2-1v-1h1Z"
            style={{
              fill: "#550d00",
            }}
          />
          <path
            d="m122 51.05 1-1h1v1c-.09 1.5-1.25.85-2 1Z"
            style={{
              fill: "#7d3b1a",
            }}
          />
          <path
            d="M119 48.05v-2h1c-.12.76.53 1.95-1 2"
            className="templesOnly_svg__cls-2214"
          />
          <path
            d="m119.93 46 .7-.81.31.31-.81.7Z"
            style={{
              fill: "#712515",
            }}
          />
          <path
            d="M118 49.05v1l-1 1h-1v-2z"
            style={{
              fill: "#5f1504",
            }}
          />
          <path
            d="M110 52.05h1c.66.67 1.33 1.34 2 2v1h-3zM114 53.05l2-2v2ZM113 54.05l1-1ZM112 52.05v-1h1Z"
            className="templesOnly_svg__cls-2383"
          />
          <path
            d="M109 52.05v-1c.33.34.66.67 1 1Z"
            className="templesOnly_svg__cls-2221"
          />
          <path
            d="M110 54.05v1h-4v-2h1c.08 1.5 1.24.85 2 1Z"
            style={{
              fill: "#701e03",
            }}
          />
          <ellipse
            cx={109.54}
            cy={53.05}
            rx={0.71}
            ry={1.41}
            style={{
              fill: "#550903",
            }}
          />
          <path
            d="M106 53.05v3h-1v-4Z"
            style={{
              fill: "#7f2d11",
            }}
          />
          <path
            d="m139.07 36.05 1 1c.33.67.67 1.33 1 2h-3c.33-1 .67-2 1-3"
            style={{
              fill: "#703123",
            }}
          />
          <path
            d="M140.07 44.05v-1c.33-.67.67-1.33 1-2h1l1 1v1l-1 1Z"
            style={{
              fill: "#682308",
            }}
          />
          <path
            d="M142.07 41.05h-1l-.83-.67.83-.33h1Z"
            style={{
              fill: "#5d1904",
            }}
          />
          <path
            d="m138 42 .69-.82.32.32-.82.69Z"
            style={{
              fill: "#5c1d0b",
            }}
          />
          <circle
            cx={141.57}
            cy={39.55}
            r={0.71}
            style={{
              fill: "#561500",
            }}
          />
          <path
            d="M127 50.05c-.34-.33-.67-.66-1-1 .08-1.49 1.24-.85 2-1 .33.34.66.67 1 1v2h-1Z"
            className="templesOnly_svg__cls-2065"
          />
          <path
            d="M124 45.05v-2h2c-.16.76.49 1.92-1 2Z"
            style={{
              fill: "#8e4123",
            }}
          />
          <path
            d="M129 49.05c-.34-.33-.67-.66-1-1v-1c.66.34 1.33.67 2 1Z"
            style={{
              fill: "#7b3015",
            }}
          />
          <path
            d="M124 45.05h1v1h-2v-1Z"
            style={{
              fill: "#621805",
            }}
          />
          <path
            d="M128 46.05v1l-.83-.67Z"
            style={{
              fill: "#6d2c0d",
            }}
          />
          <path
            d="M136 46.05h2v1l1 1v1h-2v3h-1v-1l-1-1v-1c-.09-1.49-1.25-.85-2-1a4.7 4.7 0 0 1 1.26-1c.74-.19 1.74.34 1.74-1"
            className="templesOnly_svg__cls-2396"
          />
          <path
            d="m129 49.05 1-1 1-1c.33.34.66.67 1 1s.66.67 1 1v2a5.8 5.8 0 0 1-2.24-.58c-.51.2-.31.57-.17.55a9 9 0 0 0 1.41-.43c-.61-.17-1.21-.34-1.24-.12 1.24.92 1.24 1.25 1.24 1.58h-3z"
            style={{
              fill: "#732814",
            }}
          />
          <path
            d="M133 49.05c-.34-.33-.67-.66-1-1h1Z"
            style={{
              fill: "#641c03",
            }}
          />
          <path
            d="M132 48.05c-.34-.33-.67-.66-1-1 .37.34.7.67 1 1"
            style={{
              fill: "#8d4729",
            }}
          />
          <path
            d="M138 47.05v-2h1v1Z"
            style={{
              fill: "#571a05",
            }}
          />
          <path
            d="M140 44.05h3c-.09 1.5-1.25.85-2 1h-1Z"
            style={{
              fill: "#5c1506",
            }}
          />
          <path
            d="M140 45.05h1v1h-2v-1Z"
            className="templesOnly_svg__cls-2280"
          />
          <path
            d="M48 83.05v-1h2c.33.34.66.67 1 1v2h-3v-1l.82-.33Z"
            style={{
              fill: "#702507",
            }}
          />
          <path
            d="M50 79.05v1c-.76-.15-1.92.5-2-1ZM50 82.05h-1l1-1Z"
            className="templesOnly_svg__cls-2231"
          />
          <path
            d="m44.93 81 .7-.81.31.31-.81.7Z"
            style={{
              fill: "#722207",
            }}
          />
          <path
            d="M48 84.05v1h-2v-1z"
            style={{
              fill: "#934627",
            }}
          />
          <path
            d="M48 84.05h-1l1-1 .82.67Z"
            style={{
              fill: "#843919",
            }}
          />
          <path
            d="M46 85.05h3l-1 1-1 1h-3l1-1Z"
            className="templesOnly_svg__cls-1870"
          />
          <path
            d="m45 86.05-1 1h-1v-1l1.24-1Z"
            style={{
              fill: "#974b1f",
            }}
          />
          <circle
            cx={42.54}
            cy={86.55}
            r={0.71}
            style={{
              fill: "#a1532c",
            }}
          />
          <path
            d="M35 89.05v-1h2v2h-1Z"
            style={{
              fill: "#803311",
            }}
          />
          <path
            d="M39 89.05v-1h1c.08 1.5 1.24.85 2 1v1l-2 1h-1l-.88-.39Z"
            style={{
              fill: "#893d17",
            }}
          />
          <path
            d="M42 87.05h2v1l-1 1h-1c-.34-.33-.67-.66-1-1Z"
            style={{
              fill: "#782809",
            }}
          />
          <path
            d="M41 88.05c.33.34.66.67 1 1-.76-.15-1.92.5-2-1Z"
            className="templesOnly_svg__cls-2073"
          />
          <path
            d="m39 89.05-.88 1.61.88.39v5c-1.93.47-.62 2-1 3h-1v-4c-.34-1-.67-2-1-3v-1l1-1v-1Z"
            style={{
              fill: "#691d05",
            }}
          />
          <path
            d="m68 72.05 1.28.74 2.72-.74h1c.08 1.5 1.24.85 2 1 .08 1.5 1.24.85 2 1v2c-1 .19-1.68-2.19-2.87-.56l.87 1.56h-2l-1-1c-.34-.33-.67-.66-1-1-.09-1.49-1.25-.85-2-1h-1Z"
            className="templesOnly_svg__cls-2412"
          />
          <path
            d="M68 72.05v2h-3v-2h1l.32.83.68-.83Z"
            style={{
              fill: "#641c0b",
            }}
          />
          <path
            d="M71.88 70.93h-2.81c1.66-.93 1.66-.93 2.81 0"
            style={{
              fill: "#580801",
            }}
          />
          <circle
            cx={72.54}
            cy={71.55}
            r={0.71}
            className="templesOnly_svg__cls-2245"
          />
          <path
            d="M75 71.05c.75-.15 1.91.5 2-1h1v2l-3 1z"
            style={{
              fill: "#934e21",
            }}
          />
          <path
            d="m76 69.05-1-1Z"
            style={{
              fill: "#560c01",
            }}
          />
          <ellipse
            cx={74.04}
            cy={71.55}
            className="templesOnly_svg__cls-2412"
            rx={1.41}
            ry={0.71}
          />
          <path
            d="m67 72.05-.68.83-.32-.83Z"
            style={{
              fill: "#5a1200",
            }}
          />
          <path
            d="M65 72.05v1l-1 1h-2l1-2Z"
            style={{
              fill: "#671703",
            }}
          />
          <path
            d="m152.07 30.05 1 1 1 1v1h-3v-1l.83-.33-.83-.67v-1Z"
            style={{
              fill: "#4b1405",
            }}
          />
          <path
            d="m151.07 31.05.83.67-.83.33h-2v-1z"
            style={{
              fill: "#3a0500",
            }}
          />
          <path
            d="M149.07 31.05v1h-2v-1z"
            className="templesOnly_svg__cls-2421"
          />
          <path
            d="M151.07 31.05h-1l1-1Z"
            className="templesOnly_svg__cls-2315"
          />
          <circle
            cx={147.57}
            cy={30.55}
            r={0.71}
            style={{
              fill: "#bd7c3f",
            }}
          />
          <path
            d="m102 63.05 1-1c.33.34.66.67 1 1-.16.76.49 1.92-1 2l-1-1Z"
            className="templesOnly_svg__cls-2423"
          />
          <path
            d="M102 59.05h1c.33.34.66.67 1 1v1h-1c-.34-.33-.67-.66-1-1Z"
            style={{
              fill: "#9d4623",
            }}
          />
          <path
            d="m99 61.05 1-1c1.49.09.84 1.25 1 2h-1Z"
            style={{
              fill: "#96491e",
            }}
          />
          <path
            d="M102 63.05v1l-1 1h-1v-2z"
            style={{
              fill: "#934419",
            }}
          />
          <circle
            cx={100.54}
            cy={62.55}
            r={0.71}
            className="templesOnly_svg__cls-2423"
          />
          <circle
            cx={103.54}
            cy={61.55}
            r={0.71}
            className="templesOnly_svg__cls-2423"
          />
          <path d="m102 60.05 1 1Z" className="templesOnly_svg__cls-2423" />
          <path
            d="M105 52.05v1h-2c.12-1.49 1.28-.85 2-1"
            style={{
              fill: "#863915",
            }}
          />
          <path
            d="M105 56.05h1c.33.34.66.67 1 1v1h-2Z"
            className="templesOnly_svg__cls-2428"
          />
          <path
            d="M104 60.05c-.34-.33-.67-.66-1-1 .08-1.49 1.24-.85 2-1v2Z"
            style={{
              fill: "#94420f",
            }}
          />
          <path
            d="M88 67.05c-.25 1.38-1 1.22-1.89.63-.35-.24-.74-.42-1.11-.63v-1Z"
            style={{
              fill: "#753615",
            }}
          />
          <path
            d="M81 70.05h3v1l-1 1h-2c-.34-.33-.67-.66-1-1v-1Z"
            style={{
              fill: "#651e07",
            }}
          />
          <ellipse
            cx={79.04}
            cy={70.55}
            rx={1.41}
            ry={0.71}
            style={{
              fill: "#955328",
            }}
          />
          <circle
            cx={84.54}
            cy={69.55}
            r={0.71}
            style={{
              fill: "#632003",
            }}
          />
          <path
            d="M83 69.05v-1l1 1Z"
            style={{
              fill: "#8a482b",
            }}
          />
          <path
            d="m84 69.05-1-1v-1h2v2Z"
            style={{
              fill: "#773617",
            }}
          />
          <path
            d="M26 89.05v1h-1Z"
            style={{
              fill: "#5a0e00",
            }}
          />
          <ellipse
            cx={27.54}
            cy={88.05}
            rx={0.71}
            ry={1.41}
            style={{
              fill: "#9d5039",
            }}
          />
          <path
            d="M144.07 33.05h2c-.15.76.5 1.91-1 2-.08-1.5-1.24-.85-2-1v-1Z"
            className="templesOnly_svg__cls-2438"
          />
          <path
            d="M143.07 34.05c.76.15 1.92-.5 2 1h-3v-1Z"
            style={{
              fill: "#410200",
            }}
          />
          <path
            d="M144.07 33.05h-1v-1Z"
            style={{
              fill: "#c48155",
            }}
          />
          <path
            d="M142.07 35.05h2v1a2.46 2.46 0 0 0-2 3h-1c-.33-.67-.67-1.33-1-2Z"
            style={{
              fill: "#58190c",
            }}
          />
          <path
            d="M145.07 35.05c1.5-.09.85-1.24 1-2v-1h5v1l-1 1a2.48 2.48 0 0 0 0 4v1h-1c-1 .38-2.53-.93-3 1h-1l-1-1c.6-1.94 2.21-.58 3.27-1a4.2 4.2 0 0 0 .8-.6c-.11-.42-.22-.87-.37-1.46l-1.14 1-1.56-.91Zm2.83-1.84-.87.1.39 1.63.48-.07Z"
            className="templesOnly_svg__cls-2442"
          />
          <path d="M146.07 32.05v1h-1Z" className="templesOnly_svg__cls-2421" />
          <path
            d="M61 77.05h1c.33.34.66.67 1 1v1h-2l-2 1v-2c.79-.15 2 .5 2-1"
            style={{
              fill: "#8f4120",
            }}
          />
          <path
            d="M54 80.05h1c.75-.15 1.91.5 2-1h1v1a8.6 8.6 0 0 1-.77 1c-.38.37-.82.67-1.23 1h-1l-1-1Z"
            className="templesOnly_svg__cls-2444"
          />
          <path
            d="M54 80.05v1h-2c.12-1.49 1.28-.85 2-1"
            className="templesOnly_svg__cls-2242"
          />
          <path
            d="M57 79.05c-.09 1.5-1.25.85-2 1 .12-1.49 1.28-.85 2-1M58 79.05h-1c.08-1.49 1.24-.85 2-1v1Z"
            className="templesOnly_svg__cls-2445"
          />
          <path
            d="M51 83.05c-.34-.33-.67-.66-1-1h1Z"
            className="templesOnly_svg__cls-2446"
          />
          <path d="m51 82.05 1-1v1Z" className="templesOnly_svg__cls-2242" />
          <path
            d="M65 76.05v-1h4v1h-1l-1 1h-1c-.3-.33-.63-.66-1-1"
            style={{
              fill: "#9d502b",
            }}
          />
          <path
            d="M67 75.05h-2c-.34-.33-.67-.66-1-1h3Z"
            style={{
              fill: "#742509",
            }}
          />
          <path
            d="M65 76.05c.33.34.66.67 1 1h-2v-1Z"
            style={{
              fill: "#aa5c35",
            }}
          />
          <path
            d="M64 76.05v1h-2c.12-1.49 1.28-.85 2-1"
            className="templesOnly_svg__cls-2450"
          />
          <path
            d="M24 97.05h-3v-3h2c.15.76-.5 1.92 1 2Z"
            style={{
              fill: "#904419",
            }}
          />
          <path
            d="M24 92.05v-1h4v1h-2l-1 1h-1Z"
            style={{
              fill: "#6f2409",
            }}
          />
          <path
            d="M24 93.05h1v2l-1 1c-1.5-.08-.85-1.24-1-2Z"
            style={{
              fill: "#80300c",
            }}
          />
          <path d="M28 91.05h-3v-1h3Z" className="templesOnly_svg__cls-2107" />
          <ellipse
            cx={20.54}
            cy={96.05}
            rx={0.71}
            ry={1.41}
            style={{
              fill: "#873c0f",
            }}
          />
          <path
            d="m35 89.05 1 1h-1l-1 1h-1v-1c.12-1.49 1.28-.85 2-1"
            style={{
              fill: "#9c4b2b",
            }}
          />
          <path d="M30 91.05v-1h2v1z" className="templesOnly_svg__cls-2456" />
          <circle
            cx={32.54}
            cy={90.55}
            r={0.71}
            style={{
              fill: "#a75932",
            }}
          />
          <path
            d="M30 91.05h1v1c-.47 1.93-2 .62-3 1v-1l1-1Z"
            style={{
              fill: "#9b4d26",
            }}
          />
          <path
            d="m29 91.05-1 1v-2c.37.34.7.67 1 1"
            className="templesOnly_svg__cls-2456"
          />
          <path
            d="M23 119.05h-2v-1h3Z"
            style={{
              fill: "#b5571a",
            }}
          />
          <path
            d="m158.07 69.05-2.73 3.4c-.53 1.77-1 3.23-1.44 4.82.74.8 1.43 1.57 2.52 2.78h-2.35c-1.5.08-.85 1.24-1 2l-2-1h-1v-1h1l2-2v-1c-.08-1.5-1.24-.85-2-1v-2h1l.33.83.67-.83 1.6-2h-2.6v-2l.83-.33-.83-.67v-1h3c.47 1.95 2.02.62 3 1"
            style={{
              fill: "#572617",
            }}
          />
          <path
            d="M158.07 69.05c-1-.38-2.53.93-3-1a12 12 0 0 0 2.85-1c1-.7 2.73-.32 3.15-2h2.05a.8.8 0 0 0-.15.14l.69.82.32-.32a6 6 0 0 0-.86-.64c.28-.62.62-1.28.95-2h2a8 8 0 0 0 .05 1l-.14-.15-.82.7.32.32a6 6 0 0 0 .64-.87 4.3 4.3 0 0 1 .78-.37l-.83-.67-.85-1.5.85-1.5h1l1 1v5c-.72.22-1.44.48-2.17.66s-1.22.23-1.83.34c-1.85.2-4.21-.85-5 2Z"
            style={{
              fill: "#6a2405",
            }}
          />
          <path
            d="M164.07 67.05c.61-.11 1.23-.18 1.83-.34s1.45-.44 2.17-.66l1 1 1 1h-6Z"
            style={{
              fill: "#cb8140",
            }}
          />
          <path
            d="M164.07 67.05v1l-5 1c.79-2.85 3.15-1.8 5-2"
            style={{
              fill: "#77290e",
            }}
          />
          <circle
            cx={174.57}
            cy={36.55}
            r={0.71}
            style={{
              fill: "#e99b5a",
            }}
          />
          <path
            d="M173.07 34.05h-2v-2h1c.33.67.67 1.33 1 2"
            style={{
              fill: "#823d12",
            }}
          />
          <path
            d="M172.07 32.05h-2l1-1h1Z"
            style={{
              fill: "#6b2200",
            }}
          />
          <path
            d="m171.07 31.05-1 1h-1l-2 1v-2l1-1h2Z"
            style={{
              fill: "#7b3817",
            }}
          />
          <path d="m166.07 28.05-1-1Z" className="templesOnly_svg__cls-2134" />
          <path
            d="M167.07 31.05v2l-3 1-1-1a4.58 4.58 0 0 1 4-2"
            style={{
              fill: "#863c21",
            }}
          />
          <path
            d="m150.07 34.05 1-1h4c-.47 1.93-2 .62-3 1Z"
            className="templesOnly_svg__cls-2469"
          />
          <path
            d="M153.07 37.05v-2h4v1c-1 .38-2.53-.93-3 1Z"
            className="templesOnly_svg__cls-2442"
          />
          <path
            d="M157.07 36.05v-1l1-1h1v2l-1 1Z"
            style={{
              fill: "#5a1d0b",
            }}
          />
          <path
            d="M162.07 33.05h1v1c-.08 1.49-1.24.85-2 1v-1Z"
            style={{
              fill: "#843b22",
            }}
          />
          <path
            d="M150.07 34.05h2l-2 2.74Z"
            style={{
              fill: "#3a0102",
            }}
          />
          <path
            d="M159.07 36.05v-2h1l1 1v1Z"
            style={{
              fill: "#6c2c15",
            }}
          />
          <path
            d="M153.07 37.05h1l1 1h-3v-1Z"
            style={{
              fill: "#74280c",
            }}
          />
          <path
            d="M152.07 37.05v1h-2c.09-1.5 1.24-.85 2-1"
            className="templesOnly_svg__cls-2442"
          />
          <path
            d="m161.07 35.05-1-1h1Z"
            style={{
              fill: "#803f27",
            }}
          />
          <path d="m158.07 34.05-1 1Z" className="templesOnly_svg__cls-1930" />
          <path
            d="m162.07 33.05-1 1Z"
            style={{
              fill: "#6a230d",
            }}
          />
          <circle
            cx={154.57}
            cy={32.55}
            r={0.71}
            style={{
              fill: "#5b2314",
            }}
          />
          <path d="m168.07 30.05-1 1Z" className="templesOnly_svg__cls-2478" />
          <path
            d="m154.07 32.05-1-1h1Z"
            className="templesOnly_svg__cls-2313"
          />
          <path
            d="M27 117.13v-1a5.3 5.3 0 0 1 4-1h2v1h-2v2h-2l-1-1Z"
            style={{
              fill: "#9d3f0f",
            }}
          />
          <path
            d="M28 111.05v-1l1.61 1.84.39-.84h1l1 1v1l-1 1c-2.2-.2-2.76-.76-3-3"
            style={{
              fill: "#f5b36e",
            }}
          />
          <path
            d="M33 115.05h-2v-1l1-1 1-1h2v1l1 1-1 1-1.61-.87Z"
            style={{
              fill: "#ae4d13",
            }}
          />
          <path
            d="M26 115.05c.15-.75-.5-1.91 1-2-.12.76.53 1.95-1 2"
            className="templesOnly_svg__cls-2154"
          />
          <path
            d="m23 107.05 1-1h1v3h-1c-.34-.33-.67-.66-1-1Z"
            className="templesOnly_svg__cls-2482"
          />
          <path
            d="M25 109.05v-1h2v1l-1 1Z"
            style={{
              fill: "#f7be78",
            }}
          />
          <path
            d="m30 111.05-.39.84-1.61-1.84v-1h1l3-1v3h-1l-.33-.83Z"
            style={{
              fill: "#f2b372",
            }}
          />
          <path
            d="M29 109.05h-2v-1h2Z"
            style={{
              fill: "#fece8d",
            }}
          />
          <path
            d="M24 118.05h-1l1-1Z"
            style={{
              fill: "#b15311",
            }}
          />
          <path
            d="M25 119.05v1c-.76-.15-1.92.5-2-1l1-1Z"
            style={{
              fill: "#c35c2c",
            }}
          />
          <path
            d="M25 105.05v-2h1c.33.67.66 1.34 1 2z"
            style={{
              fill: "#f79d5f",
            }}
          />
          <path
            d="M25 106.05h-1l1-1Z"
            style={{
              fill: "#e6934e",
            }}
          />
          <path
            d="M26 103.05h-1c.38-1-.93-2.53 1-3z"
            className="templesOnly_svg__cls-2324"
          />
          <ellipse
            cx={26.54}
            cy={99.05}
            rx={0.71}
            ry={1.41}
            style={{
              fill: "#97440f",
            }}
          />
          <path
            d="M24 98.05v-1h2v1Z"
            style={{
              fill: "#97521e",
            }}
          />
          <path
            d="M165.07 41.05v2c-1.93.47-.62 2-1 3l-1 1h-1c.33-1.67.67-3.33 1-5v-2h1Z"
            style={{
              fill: "#a14c1d",
            }}
          />
          <path
            d="M164.07 46.05c.38-1-.93-2.53 1-3a5.34 5.34 0 0 1 4 1v1l-1 1c-.4-1.26-1.08-2.14-2.28-2Z"
            style={{
              fill: "#b75e27",
            }}
          />
          <path
            d="m165.07 41.05-1-1v-1h3v2Z"
            style={{
              fill: "#aa5c33",
            }}
          />
          <path
            d="M167.07 41.05v-1h1Z"
            style={{
              fill: "#6d1700",
            }}
          />
          <path
            d="M171.07 38.05a7.8 7.8 0 0 0-2 .59c-.91.57-.9 0-1-.59l-.85-1.5.85-1.5h2l.89.61c-1.73.88.35 1.58.11 2.39"
            style={{
              fill: "#671e05",
            }}
          />
          <ellipse
            cx={169.07}
            cy={34.55}
            rx={1.41}
            ry={0.71}
            style={{
              fill: "#8d4d2d",
            }}
          />
          <circle
            cx={170.57}
            cy={33.55}
            r={0.71}
            style={{
              fill: "#864523",
            }}
          />
          <path
            d="M168.07 34.05v1l-.85 1.5.85 1.5-1 1h-1l-1-1c.33-1 .67-2 1-3l1-1Z"
            className="templesOnly_svg__cls-2499"
          />
          <path
            d="M161.07 53.05h-4l1.86-1.51-.86-1.49c.76-.15 1.92.49 2-1h2v3a8 8 0 0 0-1 .05l.15-.14c-.24-.27-.47-.55-.7-.82l-.32.32a6 6 0 0 0 .87.64 7 7 0 0 1 0 .95"
            style={{
              fill: "#7e2502",
            }}
          />
          <path
            d="m164.07 46.05 1.72-2c1.2-.15 1.88.73 2.28 2-.76.15-1.91-.5-2 1l-3 1v-1Z"
            style={{
              fill: "#e38a45",
            }}
          />
          <path
            d="M162.07 49.05h-2v-1l2-1z"
            className="templesOnly_svg__cls-2502"
          />
          <circle
            cx={162.57}
            cy={47.55}
            r={0.71}
            style={{
              fill: "#e88f4e",
            }}
          />
          <path
            d="M153.07 57.05h-1c-.76.15-1.91-.5-2 1h-2a14 14 0 0 0 1.33-1.87 12.6 12.6 0 0 0 .67-2.13v-1h2c.38 1-.93 2.53 1 3Z"
            className="templesOnly_svg__cls-2504"
          />
          <path
            d="M149.07 58.05h4v1l-1 1h-3z"
            style={{
              fill: "#fca54f",
            }}
          />
          <path
            d="m152.07 60.05 1-1 1-1h1v2c-.76.15-1.91-.5-2 1h-1Z"
            style={{
              fill: "#c27024",
            }}
          />
          <path
            d="M156.07 55.05h-2v-2h1l1 1Z"
            style={{
              fill: "#812401",
            }}
          />
          <path
            d="M152.07 58.05h-2c.09-1.5 1.24-.85 2-1Z"
            className="templesOnly_svg__cls-2508"
          />
          <path
            d="M154.07 55.05h1l-1 1h-1Z"
            className="templesOnly_svg__cls-2504"
          />
          <circle
            cx={155.57}
            cy={58.55}
            r={0.71}
            style={{
              fill: "#c3721e",
            }}
          />
          <path
            d="m154.07 58.05-1 1v-1Z"
            className="templesOnly_svg__cls-2508"
          />
          <circle
            cx={157.57}
            cy={57.55}
            r={0.71}
            style={{
              fill: "#d27b21",
            }}
          />
          <path
            d="M157.07 57.05v1h-1ZM153.07 56.05h1l-1 1Z"
            className="templesOnly_svg__cls-2508"
          />
          <path
            d="M157.07 54.05h1l-1 1Z"
            className="templesOnly_svg__cls-2347"
          />
          <circle
            cx={156.57}
            cy={54.55}
            r={0.71}
            className="templesOnly_svg__cls-2344"
          />
          <path
            d="M168.07 54.05h2v2h-2l-1-1v-1Z"
            className="templesOnly_svg__cls-2348"
          />
          <circle
            cx={167.57}
            cy={53.55}
            r={0.71}
            className="templesOnly_svg__cls-2341"
          />
          <circle
            cx={170.57}
            cy={52.55}
            r={0.71}
            style={{
              fill: "#c16b1b",
            }}
          />
          <path
            d="M157.07 54.05h-1l-1-1v-1l1-1 2-1 .86 1.49-1.86 1.51Z"
            style={{
              fill: "#8a2a06",
            }}
          />
          <path
            d="m164.07 56.05 1-1h1l1 1-1 1h-2Z"
            style={{
              fill: "#f9aa56",
            }}
          />
          <path
            d="M164.07 56.05v2h-1l-1-1v-1Z"
            style={{
              fill: "#f39f43",
            }}
          />
          <path
            d="M158.07 58.05c.76-.15 1.92.49 2-1h1l1 1c-.08 1.49-1.24.85-2 1l-2 1z"
            style={{
              fill: "#f39e40",
            }}
          />
          <circle
            cx={160.57}
            cy={56.55}
            r={0.71}
            style={{
              fill: "#b4680c",
            }}
          />
          <circle
            cx={161.57}
            cy={56.55}
            r={0.71}
            style={{
              fill: "#c5751a",
            }}
          />
          <circle
            cx={165.57}
            cy={54.55}
            r={0.71}
            className="templesOnly_svg__cls-2345"
          />
          <circle
            cx={166.57}
            cy={54.55}
            r={0.71}
            className="templesOnly_svg__cls-2341"
          />
          <path
            d="M174.07 58.05v1h-1l-1 1v1h-1v-1l-1-1v-1l1-1h2Z"
            style={{
              fill: "#d08c45",
            }}
          />
          <path
            d="M170.07 56.05v-1h1l1 1z"
            style={{
              fill: "#e69838",
            }}
          />
          <circle
            cx={171.57}
            cy={56.55}
            r={0.71}
            style={{
              fill: "#feb068",
            }}
          />
          <path
            d="M171.07 55.05h-1v-1Z"
            style={{
              fill: "#fcac4a",
            }}
          />
          <path
            d="m183.07 33.05 1-1v1Z"
            className="templesOnly_svg__cls-2356"
          />
          <path
            d="M100 62.05v1h-3l-1 1h-1v-1c.16-1.64 1.44-.8 2.24-1s1.75.33 1.76-1Z"
            style={{
              fill: "#a0561f",
            }}
          />
          <path
            d="M95 63.05v1c-.34-.33-.67-.66-1-1Z"
            style={{
              fill: "#a45824",
            }}
          />
          <path
            d="M88 70.05h1v3h-3c.26-.49.53-1 .87-1.6l-.87-.4v-1z"
            style={{
              fill: "#a45a29",
            }}
          />
          <path
            d="M86 70.05v1h-2v-1z"
            style={{
              fill: "#722d0e",
            }}
          />
          <path
            d="M87 70.05h-1l.67-.83Z"
            className="templesOnly_svg__cls-2361"
          />
          <path
            d="M89 72.05v-2h1c.33.34.66.67 1 1V76h-2v-2.95l.82-.33Z"
            style={{
              fill: "#631a00",
            }}
          />
          <path
            d="M92 65.05h1v2h-2v-1Z"
            style={{
              fill: "#6c2a00",
            }}
          />
          <path
            d="M91 71.05c-.34-.33-.67-.66-1-1l1-1h1v2Z"
            style={{
              fill: "#6d2700",
            }}
          />
          <ellipse
            cx={91.54}
            cy={68.05}
            className="templesOnly_svg__cls-2529"
            rx={0.71}
            ry={1.41}
          />
          <path
            d="M95 64.05h2v1l-1 1h-1z"
            className="templesOnly_svg__cls-2530"
          />
          <path
            d="M95 65.05v1h-2v-1Z"
            style={{
              fill: "#621800",
            }}
          />
          <path d="m92 65.05-1 1v-1Z" className="templesOnly_svg__cls-2192" />
          <path
            d="m175.07 63.05-1-1v-1h2v1Z"
            style={{
              fill: "#b15a1e",
            }}
          />
          <path
            d="M175.07 61.05h-1v-2h1Z"
            className="templesOnly_svg__cls-2369"
          />
          <path
            d="m170.07 68.05-1-1v-1l3 1v1Z"
            style={{
              fill: "#ec994a",
            }}
          />
          <path
            d="m175.07 63.05 1-1c-.15.76.5 1.91-1 2Z"
            style={{
              fill: "#8c3b0b",
            }}
          />
          <path
            d="M174.07 60.05v2l-1 1h-1c-1-.38-2.53.93-3-1h1l1-1h1l1-1Z"
            style={{
              fill: "#e4954c",
            }}
          />
          <path
            d="m172.07 65.05-1-1h1Z"
            style={{
              fill: "#f0a261",
            }}
          />
          <path
            d="M172.07 63.05h1l-1 1Z"
            style={{
              fill: "#c67d3c",
            }}
          />
          <path
            d="M172.07 63.05v1h-2l-1 1h-1v-3h1c.47 1.95 2.02.62 3 1"
            className="templesOnly_svg__cls-2538"
          />
          <circle
            cx={168.57}
            cy={65.55}
            r={0.71}
            style={{
              fill: "#db8d4e",
            }}
          />
          <path
            d="m169.07 65.05 1-1Z"
            style={{
              fill: "#954300",
            }}
          />
          <path
            d="m125 51.05 2-1v2h-2Z"
            style={{
              fill: "#601700",
            }}
          />
          <path
            d="M124 51.05v-1l1 1Z"
            style={{
              fill: "#8a4929",
            }}
          />
          <path
            d="M122 51.05v1l-1 1h-1v-2Z"
            style={{
              fill: "#7c3d16",
            }}
          />
          <path
            d="M120 51.05v1h-2l-1-1 1-1Z"
            className="templesOnly_svg__cls-2376"
          />
          <path
            d="m121 53.05 1-1c.75-.15 1.91.5 2-1h1v2z"
            style={{
              fill: "#631e02",
            }}
          />
          <path
            d="m117 51.05 1 1c-.09 1.5-1.25.85-2 1v-2Z"
            style={{
              fill: "#853720",
            }}
          />
          <path
            d="m113 54.05 1-1h2c.08 1.5 1.24.85 2 1l1 1v1h-2c-.09-1.49-1.25-.85-2-1l-1 1h-1z"
            style={{
              fill: "#873d18",
            }}
          />
          <path
            d="M107 55.05h4v1h-3c-.3-.33-.63-.66-1-1"
            style={{
              fill: "#752507",
            }}
          />
          <path
            d="M111 56.05v-1h2v1l-2 1Z"
            className="templesOnly_svg__cls-2548"
          />
          <path
            d="M107 55.05c.33.34.66.67 1 1v1h-1c-.34-.33-.67-.66-1-1v-1Z"
            style={{
              fill: "#88310c",
            }}
          />
          <path
            d="m144.07 39.05 1 1v1c-.76.15-1.91-.5-2 1l-1-1v-2Z"
            style={{
              fill: "#6a220a",
            }}
          />
          <path
            d="M143.07 44.05h-1l1-1h1v1Z"
            style={{
              fill: "#591b00",
            }}
          />
          <path
            d="M144.07 43.05h-1v-1Z"
            style={{
              fill: "#7b3b15",
            }}
          />
          <path
            d="M127 52.05v-1h2v2Z"
            style={{
              fill: "#7e3414",
            }}
          />
          <path
            d="M128 51.05h-1v-1Z"
            style={{
              fill: "#5e1400",
            }}
          />
          <path
            d="M133 49.05v-1c.75.15 1.91-.49 2 1l-.83.33.83.67 1 1h-3Z"
            style={{
              fill: "#934f23",
            }}
          />
          <path
            d="M134 51.05h2v1c-.16.76.49 1.92-1 2-1.5-.08-.85-1.24-1-2Z"
            style={{
              fill: "#b8672f",
            }}
          />
          <path
            d="M137 52.05v-3h2v2l-1 1Z"
            className="templesOnly_svg__cls-2469"
          />
          <path
            d="M135 54.05c1.49-.08.84-1.24 1-2h1v4c-.63-.66-1.3-1.33-2-2"
            className="templesOnly_svg__cls-2557"
          />
          <path
            d="M139 46.05h1v2h-1l-1-1Z"
            style={{
              fill: "#662717",
            }}
          />
          <path
            d="M139 48.05h1v3h-1z"
            style={{
              fill: "#4c0b01",
            }}
          />
          <path
            d="m135 50.05-.83-.67.83-.33Z"
            style={{
              fill: "#a86639",
            }}
          />
          <path
            d="M129 53.05v-1h2c.33.34.66.67 1 1v3a8.5 8.5 0 0 1-1-.76 15 15 0 0 1-1-1.24Z"
            style={{
              fill: "#561205",
            }}
          />
          <path d="M132 54.05v-3h1v3Z" className="templesOnly_svg__cls-2217" />
          <path
            d="m129.56 49.88 2.48.71a9 9 0 0 1-1.41.43c-.14-.02-.34-.35-1.07-1.14"
            style={{
              fill: "#8c422d",
            }}
          />
          <path
            d="M132 52.05v1c-.34-.33-.67-.66-1-1Z"
            style={{
              fill: "#4e0500",
            }}
          />
          <path
            d="M143 44.05h1c.33.34.66.67 1 1v1l-1 1h-2l-1-1v-1c.79-.15 2 .5 2-1"
            style={{
              fill: "#712c12",
            }}
          />
          <path
            d="M140 51.05v-5h1v5Z"
            style={{
              fill: "#7f351c",
            }}
          />
          <path
            d="m48 86.05 1-1h1v2h-2Z"
            style={{
              fill: "#853a19",
            }}
          />
          <path
            d="M50 86.05v-1h2v1z"
            style={{
              fill: "#a75e39",
            }}
          />
          <ellipse
            cx={51.54}
            cy={84.05}
            className="templesOnly_svg__cls-2446"
            rx={0.71}
            ry={1.41}
          />
          <path
            d="M45 87.05h1v4h-1c-.16-.75.49-1.91-1-2v-1Z"
            style={{
              fill: "#b96a45",
            }}
          />
          <path d="M46 91.05v-4h1v4Z" className="templesOnly_svg__cls-2569" />
          <path
            d="m45 87.05-1 1v-1ZM48 86.05v1h-1Z"
            className="templesOnly_svg__cls-2232"
          />
          <path
            d="M35 90.05h2l-1 1c-.3-.33-.63-.66-1-1"
            style={{
              fill: "#671c00",
            }}
          />
          <path
            d="m40 91.05 2-1 1 1v1c-.34.4-.89.75-1 1.19a17.5 17.5 0 0 0 0 2.81c-1.93-.46-.62-2-1-3-.34-.33-.67-.66-1-1Z"
            style={{
              fill: "#b15d2d",
            }}
          />
          <path d="m43 91.05-1-1v-1h1Z" className="templesOnly_svg__cls-2572" />
          <circle
            cx={39.54}
            cy={91.55}
            r={0.71}
            style={{
              fill: "#6e1e02",
            }}
          />
          <path d="M44 88.05v1h-1Z" className="templesOnly_svg__cls-2572" />
          <path
            d="M36 92.05c.33 1 .66 2 1 3l-1 1c-1.93-.46-.62-2-1-3v-1ZM39 92.05h1v6h-1z"
            className="templesOnly_svg__cls-2574"
          />
          <path d="m36 96.05 1-1v4h-1z" className="templesOnly_svg__cls-2575" />
          <path
            d="M36 92.05h-2v-1l1-1c.33.34.66.67 1 1Z"
            style={{
              fill: "#863b13",
            }}
          />
          <path
            d="M39 96.05v3h-1c.42-.98-.89-2.53 1-3"
            className="templesOnly_svg__cls-2575"
          />
          <path
            d="M38 99.05h1v1h-2v-1Z"
            style={{
              fill: "#e88952",
            }}
          />
          <path
            d="M74 77.05h1l1 1v2l-1 .76c.33.41.66.83 1 1.24v1l-1 1h-1z"
            style={{
              fill: "#bc7242",
            }}
          />
          <path
            d="M74 77.05v1c-1.5.09-.85 1.25-1 2h-1c-.34-.33-.67-.66-1-1v-2z"
            style={{
              fill: "#641b01",
            }}
          />
          <path
            d="m75 77.05-.87-1.56c1.19-1.63 1.83.75 2.87.56v2h-1c-.3-.33-.63-.66-1-1"
            style={{
              fill: "#914924",
            }}
          />
          <path
            d="M68 76.05h1l1-1h1c.33.34.66.67 1 1l-1 1h-3Z"
            style={{
              fill: "#6b2203",
            }}
          />
          <path
            d="m75 73.05 3-1v1l-1 1c-.72-.15-1.88.5-2-1"
            style={{
              fill: "#6b2206",
            }}
          />
          <path
            d="m77 74.05 1-1h1v1l-1 1h-1Z"
            style={{
              fill: "#7e3822",
            }}
          />
          <path
            d="m71 77.05 1-1 1 1Z"
            style={{
              fill: "#914929",
            }}
          />
          <path
            d="M77 75.05h1l1 1h-2Z"
            style={{
              fill: "#4f0400",
            }}
          />
          <path
            d="M71 75.05h-2v-1c.79.15 2-.49 2 1"
            style={{
              fill: "#af6234",
            }}
          />
          <path d="M69 74.05v1h-2v-1z" className="templesOnly_svg__cls-2587" />
          <path
            d="M73 72.05h2v1c-.72-.15-1.88.5-2-1"
            style={{
              fill: "#ac5e3d",
            }}
          />
          <path
            d="M65 74.05h-1l1-1Z"
            style={{
              fill: "#580b00",
            }}
          />
          <path
            d="M78 71.05h2c.33.34.66.67 1 1h-3Z"
            style={{
              fill: "#6d2804",
            }}
          />
          <path
            d="M103 65.05c1.49-.08.84-1.24 1-2v-1h4v2h-2l-.33-.83-.67.83c.29.53.59 1 .66 1.16L104 70.05c-1.5.09-.85 1.25-1 2-1.5.09-.85 1.25-1 2h-1v-4a4.62 4.62 0 0 0 2-4Z"
            style={{
              fill: "#9c4616",
            }}
          />
          <path
            d="m101 65.05 1-1c.33.34.66.67 1 1Z"
            style={{
              fill: "#752604",
            }}
          />
          <path
            d="M104 62.05v1c-.34-.33-.67-.66-1-1ZM105 62.05h-1v-2h2v1Z"
            className="templesOnly_svg__cls-2593"
          />
          <path
            d="M100 65.05h1v1l-1 1h-1l-1-1v-1Z"
            className="templesOnly_svg__cls-2594"
          />
          <path
            d="M97 63.05h3v1h-3Z"
            style={{
              fill: "#873909",
            }}
          />
          <ellipse
            cx={99.04}
            cy={64.55}
            rx={1.41}
            ry={0.71}
            style={{
              fill: "#ae5e2f",
            }}
          />
          <path
            d="M106 60.05h-1v-2h2v1Z"
            style={{
              fill: "#a14a14",
            }}
          />
          <path
            d="M107 57.05h1c.33.34.66.67 1 1h-2Z"
            style={{
              fill: "#a04a20",
            }}
          />
          <path
            d="M81 72.05h1l1 1v7h-2c.33-.66.66-1.33 1-2a5.4 5.4 0 0 0-1-4Z"
            style={{
              fill: "#933e0e",
            }}
          />
          <path
            d="M84 71.05h1v1h-2Z"
            style={{
              fill: "#7b3418",
            }}
          />
          <path d="m83 73.05-1-1h1Z" className="templesOnly_svg__cls-2601" />
          <path
            d="m39 120.13-5-1 1-1a2.16 2.16 0 0 0 2.66-1.79l1.34-4.21 2 1c-.33 1-.66 2-1 3v3Z"
            style={{
              fill: "#d98547",
            }}
          />
          <path
            d="m35 118.13-1 1h-2v-1c1.5-.09.85-1.25 1-2v-1l.4-.88 1.6.88z"
            style={{
              fill: "#983605",
            }}
          />
          <circle
            cx={144.57}
            cy={35.55}
            r={0.71}
            className="templesOnly_svg__cls-2438"
          />
          <path
            d="M144.07 39.05h-2a2.46 2.46 0 0 1 2-3l.33.83.67-.83 1.56.91 1.14-1c.15.59.26 1 .37 1.46a4.2 4.2 0 0 1-.8.6c-1.06.45-2.67-.91-3.27 1.03"
            style={{
              fill: "#490c00",
            }}
          />
          <path
            d="M146.07 40.05c.47-1.93 2-.62 3-1v2h-1c-.07-1.5-1.24-.85-2-1"
            className="templesOnly_svg__cls-2605"
          />
          <path
            d="M150.07 38.05h3l-1 1h-2Z"
            style={{
              fill: "#74321c",
            }}
          />
          <path
            d="M146.07 40.05c.76.15 1.92-.5 2 1h-3v-1Z"
            style={{
              fill: "#843519",
            }}
          />
          <path
            d="M150.07 39.05h1v1h-2v-1Z"
            style={{
              fill: "#7f3419",
            }}
          />
          <path
            d="M147.9 33.21v1.66l-.48.07-.42-1.63Z"
            style={{
              fill: "#68271c",
            }}
          />
          <path
            d="m59 80.05 2-1c.33.34.66.67 1 1-.09 1.5-1.25.85-2 1h-1Z"
            style={{
              fill: "#772a09",
            }}
          />
          <path
            d="M62 80.05c-.34-.33-.67-.66-1-1h3v1Z"
            className="templesOnly_svg__cls-2070"
          />
          <path
            d="M64 79.05h-1v-1h1l.82.33Z"
            style={{
              fill: "#6c1f00",
            }}
          />
          <path
            d="M64 78.05h-1c-.34-.33-.67-.66-1-1h2Z"
            style={{
              fill: "#a0532d",
            }}
          />
          <circle
            cx={58.54}
            cy={79.55}
            r={0.71}
            style={{
              fill: "#934527",
            }}
          />
          <path
            d="M58 80.05h1v3h-1c-.09-1.49-1.25-.85-2-1 .41-.33.85-.63 1.23-1a8.6 8.6 0 0 0 .77-1"
            style={{
              fill: "#6a1f00",
            }}
          />
          <path
            d="M52 82.05v-1h2l1 1-1 1h-1c-.3-.33-.63-.66-1-1"
            style={{
              fill: "#93472a",
            }}
          />
          <path
            d="m54 83.05 1-1h1v1z"
            style={{
              fill: "#6d2203",
            }}
          />
          <path
            d="M52 82.05c.33.34.66.67 1 1h-2v-1Z"
            style={{
              fill: "#995131",
            }}
          />
          <path
            d="M68 76.05v2h-1v-1Z"
            style={{
              fill: "#7f3b18",
            }}
          />
          <circle
            cx={66.54}
            cy={77.55}
            r={0.71}
            style={{
              fill: "#6b1f00",
            }}
          />
          <path d="M69 75.05h1l-1 1Z" className="templesOnly_svg__cls-2587" />
          <path
            d="M66 77.05v3l-1 1h-1v-2l.82-.67-.82-.33v-1Z"
            className="templesOnly_svg__cls-2450"
          />
          <path
            d="M25 97.05h-1v-1l1-1Z"
            style={{
              fill: "#702300",
            }}
          />
          <path
            d="M28 92.05v2h-1l-1-1v-1Z"
            style={{
              fill: "#8a401d",
            }}
          />
          <path d="M26 92.05v1h-1Z" className="templesOnly_svg__cls-2286" />
          <path
            d="M25 93.05h1c.33.34.66.67 1 1v1l-1 2h-1z"
            style={{
              fill: "#893b13",
            }}
          />
          <circle
            cx={33.54}
            cy={91.55}
            r={0.71}
            style={{
              fill: "#803000",
            }}
          />
          <path
            d="M33 91.05v1h-2v-1z"
            style={{
              fill: "#a9592c",
            }}
          />
          <path
            d="M31 92.05h2v4h-1c-.46-.61-.79-1.42-1.39-1.8s-1.55-.42-1.61.8h-1v-2c1-.38 2.57.95 3-1"
            className="templesOnly_svg__cls-2625"
          />
          <path
            d="M161 65.1c-.38 1.59-2.08 1.21-3.11 1.91a12 12 0 0 1-2.85 1h-3l-2-1v-1h1l1-1h1c.76-.15 1.92.49 2-1h2c.76-.15 1.92.49 2-1 1.6 0 3.27.3 4.69-.81l.31.81c-.33.67-.67 1.33-1 2h-2l.15-.14-.7-.82-.32.32a6 6 0 0 0 .83.73"
            className="templesOnly_svg__cls-2626"
          />
          <path
            d="m150.07 67.05 2 1v1h-1a6.5 6.5 0 0 0-1.8 1.38c-.43.68-.43 1.56.8 1.62-.33.67-.67 1.33-1 2v4h-1l-1-1v-1q2.055-1.5 0-3v-1c1.5-.09.85-1.24 1-2 .33-1 .67-2 1-3Z"
            className="templesOnly_svg__cls-2627"
          />
          <path
            d="M149.07 74.05c.33-.67.67-1.33 1-2h4.6l-1.6 2-.33-.83-.67.83z"
            style={{
              fill: "#65190e",
            }}
          />
          <path
            d="M152.07 72.05h-2c-1.23-.06-1.23-.94-.8-1.62a6.5 6.5 0 0 1 1.8-1.38l1 1Z"
            style={{
              fill: "#511005",
            }}
          />
          <ellipse
            cx={150.57}
            cy={75.05}
            className="templesOnly_svg__cls-947"
            rx={0.71}
            ry={1.41}
          />
          <path
            d="m152.07 74.05.67-.83.33.83-.67.83Z"
            style={{
              fill: "#74281a",
            }}
          />
          <path
            d="m152.07 70.05-1-1h1l.83.67Z"
            style={{
              fill: "#380201",
            }}
          />
          <path
            d="m164.07 63.05-.31-.81c-1.42 1.11-3.09.77-4.69.81l1-1c.76-.15 1.92.49 2-1h1l3-1-.85 1.5.85 1.5Z"
            className="templesOnly_svg__cls-2632"
          />
          <path
            d="m166.07 60.05-3 1v-1c.33-.67.67-1.33 1-2v-1h2v1l-2 1h3v1Z"
            style={{
              fill: "#e69333",
            }}
          />
          <path
            d="M169.07 62.05h-1v-2h1Z"
            style={{
              fill: "#eea36d",
            }}
          />
          <path
            d="M168.07 60.05v1l-1-1v-1Z"
            className="templesOnly_svg__cls-1650"
          />
          <path
            d="m163.16 64.94.82.7-.32.32-.69-.82Z"
            style={{
              fill: "#671700",
            }}
          />
          <path
            d="m166.18 64.14-.7.82-.32-.32.82-.7Z"
            style={{
              fill: "#581500",
            }}
          />
          <path
            d="M166.07 64.05v-1l.83.67Z"
            className="templesOnly_svg__cls-2637"
          />
          <path
            d="M168.07 66.05h1v1Z"
            style={{
              fill: "#c4792e",
            }}
          />
          <path
            d="M171.07 33.05h-1l-1-1h2Z"
            style={{
              fill: "#611b00",
            }}
          />
          <path
            d="m169.07 32.05 1 1v1h-3v-1Z"
            className="templesOnly_svg__cls-2478"
          />
          <path
            d="M167.07 33.05v1l-1 1h-1l-1 1-1 1h-2v-2c.76-.15 1.92.49 2-1h1Z"
            style={{
              fill: "#682105",
            }}
          />
          <path
            d="M164.07 34.05h-1v-1Z"
            style={{
              fill: "#894528",
            }}
          />
          <path
            d="m155.07 38.05-1-1c.47-1.93 2-.62 3-1l1 1v1z"
            style={{
              fill: "#691e08",
            }}
          />
          <path
            d="M158.07 38.05v-1l1-1h2v1l-1 1z"
            style={{
              fill: "#501106",
            }}
          />
          <path
            d="m158.07 37.05-1-1Z"
            style={{
              fill: "#803e2e",
            }}
          />
          <path
            d="m152.07 39.05 1-1h2l1 1h1v1h-2c-.76.15-1.91-.5-2 1h-1z"
            style={{
              fill: "#631f05",
            }}
          />
          <path
            d="M32 119.13a8 8 0 0 0-1 .76c-.37.38-.67.82-1 1.24-.08-1.5-1.24-.85-2-1v-1c.76-.16 1.92.49 2-1h2Z"
            style={{
              fill: "#732703",
            }}
          />
          <path
            d="M32 118.13h-1v-2h2c-.11.75.54 1.87-1 2"
            style={{
              fill: "#8b2c00",
            }}
          />
          <path
            d="M30 118.13c-.08 1.49-1.24.84-2 1v-1z"
            style={{
              fill: "#6e2100",
            }}
          />
          <path d="M29 118.13h-1v-1Z" className="templesOnly_svg__cls-2649" />
          <path
            d="M32 111.05v-1h2v1l-1 1-1 1z"
            style={{
              fill: "#eba75e",
            }}
          />
          <path d="m32 113.05-1 1Z" className="templesOnly_svg__cls-2316" />
          <path
            d="M32 111.05v1l-1-1Z"
            style={{
              fill: "#e7a760",
            }}
          />
          <path
            d="m30 111.05.67-.83.33.83Z"
            style={{
              fill: "#fec481",
            }}
          />
          <path
            d="M34 111.05v-2h3v1l-1 1-1 1h-1Z"
            style={{
              fill: "#f8b161",
            }}
          />
          <path
            d="M35 116.05v-1l1-1v-1c1.84.74.88 1.91.57 3Z"
            style={{
              fill: "#913301",
            }}
          />
          <path d="M36 113.05v1l-1-1Z" className="templesOnly_svg__cls-1607" />
          <circle
            cx={35.54}
            cy={112.55}
            r={0.71}
            style={{
              fill: "#9e4c08",
            }}
          />
          <path
            d="M34 111.05v1h-1Z"
            style={{
              fill: "#fab066",
            }}
          />
          <path
            d="M26 105.05h3v1l-1 1-1 1h-2v-2Z"
            style={{
              fill: "#b95e1b",
            }}
          />
          <path
            d="M29 109.05v-1l1-1 1-1h2v2h-1Z"
            style={{
              fill: "#fdc685",
            }}
          />
          <path
            d="M34 109.05v1h-2v-1z"
            style={{
              fill: "#fdbf6d",
            }}
          />
          <circle
            cx={32.54}
            cy={108.55}
            r={0.71}
            style={{
              fill: "#dea056",
            }}
          />
          <path
            d="m30 107.05-1 1h-1v-1Z"
            style={{
              fill: "#f9bb7e",
            }}
          />
          <path d="M28 107.05v1h-1Z" className="templesOnly_svg__cls-2482" />
          <path
            d="M28 120.13h-1c.15-.76-.49-1.92 1-2z"
            className="templesOnly_svg__cls-2649"
          />
          <path
            d="M28 105.05h-1c-.34-.66-.67-1.33-1-2h2Z"
            className="templesOnly_svg__cls-2324"
          />
          <path d="m26 105.05-1 1v-1Z" className="templesOnly_svg__cls-2662" />
          <path
            d="M26 100.05h2v2h-2Z"
            style={{
              fill: "#8e3500",
            }}
          />
          <ellipse
            cx={27.04}
            cy={102.55}
            className="templesOnly_svg__cls-2574"
            rx={1.41}
            ry={0.71}
          />
          <path
            d="M28 100.05h-1v-2h1z"
            style={{
              fill: "#8b3200",
            }}
          />
          <path
            d="M28 98.05h-2v-1h2Z"
            style={{
              fill: "#883805",
            }}
          />
          <path
            d="m162.07 47.05-2 1h-1l-1-1h-1v-2h2c.12.28.23.57.47 1.15a24 24 0 0 1 1.55-2.28 25 25 0 0 1 2-1.87c-.35 1.67-.69 3.33-1.02 5"
            className="templesOnly_svg__cls-2666"
          />
          <path
            d="M163.07 42.05a25 25 0 0 0-2 1.87 24 24 0 0 0-1.55 2.28c-.24-.58-.35-.87-.47-1.15v-4l3-1h1Z"
            className="templesOnly_svg__cls-2667"
          />
          <path
            d="M162.07 37.05h1l1 1v2h-1c-.15-.76.5-1.92-1-2Z"
            style={{
              fill: "#722905",
            }}
          />
          <path
            d="M164.07 39.05v-1h1l1 1Z"
            style={{
              fill: "#772e03",
            }}
          />
          <path
            d="M165.07 38.05h-1l-1-1 1-1 1-1h1c-.33 1-.67 2-1 3"
            style={{
              fill: "#8e481e",
            }}
          />
          <path
            d="M160.07 49.05c-.08 1.49-1.24.85-2 1 .09-1.5 1.24-.85 2-1"
            className="templesOnly_svg__cls-2502"
          />
          <path
            d="m161 52.15-.82-.69.32-.32c.23.27.46.55.7.82Z"
            className="templesOnly_svg__cls-2671"
          />
          <path
            d="M160.07 49.05c-.76.15-1.91-.5-2 1l-2 1-1-1v-1l2-2h1l1 1h1Z"
            style={{
              fill: "#e48c4f",
            }}
          />
          <path
            d="M150 54.05a13.7 13.7 0 0 1-.68 2.14 13 13 0 0 1-1.32 1.86c-.76.15-1.92-.49-2 1h-1c-.34-.33-.67-.66-1-1h-1v-1l1-1h1l1-1h2l1-1Z"
            style={{
              fill: "#862601",
            }}
          />
          <path
            d="m154.07 55.05-1 1c-1.93-.47-.62-2-1-3l1-1h1z"
            style={{
              fill: "#792200",
            }}
          />
          <path
            d="M150.07 54.05h-2v-1l1-1 1 1Z"
            style={{
              fill: "#e58c49",
            }}
          />
          <path
            d="M152.07 53.05h-2l1-1h1Z"
            style={{
              fill: "#f89c5e",
            }}
          />
          <circle
            cx={148.57}
            cy={58.55}
            r={0.71}
            className="templesOnly_svg__cls-2508"
          />
          <path
            d="M148.07 59.05h1v1l-1 1c-1.5-.09-.85-1.24-1-2Z"
            style={{
              fill: "#feaf5d",
            }}
          />
          <path
            d="m148.07 61.05 1-1h1v1l-1 1Z"
            className="templesOnly_svg__cls-2678"
          />
          <ellipse
            cx={151.07}
            cy={60.55}
            rx={1.41}
            ry={0.71}
            style={{
              fill: "#d5842f",
            }}
          />
          <path
            d="M155.07 59.05h2v2h-1l-1-1Z"
            style={{
              fill: "#f1a651",
            }}
          />
          <path
            d="M152.07 61.05h2l-1 1Z"
            style={{
              fill: "#feb669",
            }}
          />
          <path
            d="M154.07 61.05h-1c.09-1.5 1.24-.85 2-1v1Z"
            style={{
              fill: "#f0a457",
            }}
          />
          <circle
            cx={154.57}
            cy={52.55}
            r={0.71}
            style={{
              fill: "#711900",
            }}
          />
          <path
            d="M157.07 59.05h-1v-1h2v1Z"
            style={{
              fill: "#ce8024",
            }}
          />
          <path
            d="M171.07 56.05v1h-2v-1z"
            style={{
              fill: "#ee9e52",
            }}
          />
          <path
            d="M166.07 55.05h1l1 1h-1Z"
            style={{
              fill: "#febc70",
            }}
          />
          <circle
            cx={168.57}
            cy={56.55}
            r={0.71}
            style={{
              fill: "#e99746",
            }}
          />
          <path
            d="M155.07 52.05h-1v-1h2Z"
            style={{
              fill: "#973911",
            }}
          />
          <path
            d="M168.07 56.05v1c-.08 1.49-1.24.85-2 1v-1l1-1Z"
            style={{
              fill: "#f4a34d",
            }}
          />
          <path
            d="M164.07 58.05c-.33.67-.67 1.33-1 2h-1c-.76-.15-1.91.49-2-1 .76-.15 1.92.49 2-1z"
            style={{
              fill: "#e3812e",
            }}
          />
          <path
            d="M163.07 58.05h-1l-1-1h1Z"
            style={{
              fill: "#fea752",
            }}
          />
          <path
            d="M160.07 59.05c.09 1.49 1.24.85 2 1v1h-5v-1h1Z"
            style={{
              fill: "#e69535",
            }}
          />
          <circle
            cx={157.57}
            cy={59.55}
            r={0.71}
            style={{
              fill: "#feb453",
            }}
          />
          <path
            d="M169.07 62.05v-3h1l1 1c-1.5.08-.85 1.24-1 2Z"
            className="templesOnly_svg__cls-2538"
          />
          <path
            d="M170.07 62.05c.15-.76-.5-1.92 1-2v1Z"
            style={{
              fill: "#b66d24",
            }}
          />
          <path
            d="M170.07 59.05h-1v-2h1z"
            style={{
              fill: "#f9af65",
            }}
          />
          <path
            d="m173.07 60.05-1 1v-1Z"
            style={{
              fill: "#f3a65f",
            }}
          />
          <circle
            cx={173.57}
            cy={59.55}
            r={0.71}
            style={{
              fill: "#f2a860",
            }}
          />
          <path
            d="M173.07 59.05v1h-1Z"
            style={{
              fill: "#c08135",
            }}
          />
          <path
            d="M170.07 58.05v-1h1Z"
            style={{
              fill: "#feb370",
            }}
          />
          <path d="M97 63.05v1h-1Z" className="templesOnly_svg__cls-2359" />
          <path
            d="M91 71.05h1v2a17.7 17.7 0 0 1 0 2.82c-.07.44-.62.79-.95 1.18H88v-4h1V76h2Z"
            className="templesOnly_svg__cls-2700"
          />
          <path
            d="M85 72.05v-1h1l.87.4c-.34.63-.61 1.11-.87 1.6h-1Z"
            className="templesOnly_svg__cls-2601"
          />
          <path
            d="M88 73.05v2h-2v-1l1-1Z"
            style={{
              fill: "#bb6f38",
            }}
          />
          <path
            d="m87 73.05-1 1v-1Z"
            style={{
              fill: "#be7244",
            }}
          />
          <path
            d="m89 72.05.82.67-.82.33Z"
            className="templesOnly_svg__cls-2700"
          />
          <path
            d="M92 73.05v-6h2v7c-.16.76.49 1.92-1 2-.35-.98 1-2.53-1-3"
            style={{
              fill: "#bb6d39",
            }}
          />
          <circle
            cx={93.54}
            cy={66.55}
            r={0.71}
            className="templesOnly_svg__cls-2529"
          />
          <path
            d="m98 66.05 1 1-.83.33.83.67v1h-2v-1l-.33-.83-.67.83v2h-1v-4z"
            style={{
              fill: "#792712",
            }}
          />
          <path d="M98 66.05h-2l1-1h1Z" className="templesOnly_svg__cls-2529" />
          <circle
            cx={97.54}
            cy={64.55}
            r={0.71}
            className="templesOnly_svg__cls-2594"
          />
          <circle
            cx={94.54}
            cy={66.55}
            r={0.71}
            className="templesOnly_svg__cls-2530"
          />
          <path
            d="M125 53.05v-1h2v2h-1Z"
            style={{
              fill: "#83390d",
            }}
          />
          <path
            d="m119 55.05-1-1c.75-.15 1.91.5 2-1h1c.33.34.66.67 1 1v1z"
            style={{
              fill: "#6c2703",
            }}
          />
          <path
            d="M119 52.05h1v1c-.3-.33-.63-.66-1-1"
            style={{
              fill: "#995931",
            }}
          />
          <path
            d="M119 52.05c.33.34.66.67 1 1-.09 1.5-1.25.85-2 1-.76-.15-1.92.5-2-1 .75-.15 1.91.5 2-1Z"
            style={{
              fill: "#8c4922",
            }}
          />
          <path
            d="M122 53.05h3v1h-3Z"
            style={{
              fill: "#722b11",
            }}
          />
          <path
            d="M122 53.05v1c-.34-.33-.67-.66-1-1Z"
            style={{
              fill: "#5a1300",
            }}
          />
          <path
            d="M117 56.05h2v1l-1 1h-4v-1h1Z"
            style={{
              fill: "#8c4e27",
            }}
          />
          <path
            d="M115 57.05h-1l-1 1h-2v-1l2-1h2Z"
            style={{
              fill: "#6c1b00",
            }}
          />
          <path
            d="M119 57.05v-2h2c-.16.76.49 1.92-1 2Z"
            style={{
              fill: "#934a25",
            }}
          />
          <path
            d="M115 57.05v-2c.75.15 1.91-.49 2 1Z"
            className="templesOnly_svg__cls-2714"
          />
          <path d="M115 55.05v1h-1Z" className="templesOnly_svg__cls-2548" />
          <path
            d="M109 58.05c-.34-.33-.67-.66-1-1v-1h3v1Z"
            style={{
              fill: "#95421e",
            }}
          />
          <path
            d="m144.07 43.05-1-1c.09-1.5 1.24-.85 2-1v3h-1Z"
            style={{
              fill: "#75310d",
            }}
          />
          <path
            d="M127 54.05v-2l2 1v1Z"
            style={{
              fill: "#984d22",
            }}
          />
          <circle
            cx={133.54}
            cy={51.55}
            r={0.71}
            className="templesOnly_svg__cls-2718"
          />
          <path
            d="M133 52.05h1c.15.76-.5 1.92 1 2 .66.67 1.33 1.34 2 2v1h-2c-.67-.66-1.34-1.33-2-2z"
            style={{
              fill: "#a44418",
            }}
          />
          <path
            d="M139 51.05h1q-.51 3-1 6h-1c-.34-.33-.67-.66-1-1v-4a8 8 0 0 0 1 0l-.15.14.7.82.31-.31a5 5 0 0 0-.86-.65Z"
            className="templesOnly_svg__cls-2396"
          />
          <path
            d="M130 54.05a15 15 0 0 0 1 1.24 8.5 8.5 0 0 0 1 .76v1l-.88.4.88 1.6h-2z"
            style={{
              fill: "#591100",
            }}
          />
          <path
            d="M130 54.05v2h-1v-3Z"
            style={{
              fill: "#6b2507",
            }}
          />
          <path d="M132 57.05v-3h1v3Z" className="templesOnly_svg__cls-2718" />
          <path
            d="m144 47.05 1-1v2l.32.83.68-.83v-1h1q-.51 3-1 6h-2z"
            style={{
              fill: "#661d03",
            }}
          />
          <path
            d="M147.07 47.05h-1l-1-1v-1h1l2-1 1 1v1c-.76.15-1.91-.5-2 1"
            className="templesOnly_svg__cls-2723"
          />
          <ellipse
            cx={143.54}
            cy={48.05}
            rx={0.71}
            ry={1.41}
            style={{
              fill: "#833a0d",
            }}
          />
          <ellipse
            cx={142.54}
            cy={48.05}
            rx={0.71}
            ry={1.41}
            style={{
              fill: "#702600",
            }}
          />
          <path
            d="M146.07 45.05h-1l-1-1h1Z"
            style={{
              fill: "#8d482c",
            }}
          />
          <path
            d="M141 47.05v-1l1 1Z"
            style={{
              fill: "#9e5434",
            }}
          />
          <path
            d="m139 57.05 1-6h1c0 1.73.31 3.53-1 5v1Z"
            className="templesOnly_svg__cls-2557"
          />
          <path d="M141 47.05h1v3h-1Z" className="templesOnly_svg__cls-1659" />
          <path
            d="M141 50.05h1l-1 1Z"
            style={{
              fill: "#c0703b",
            }}
          />
          <path
            d="M47 87.05h2v3L48.69 92l-.69-.12v-2.83c-.34-.33-.67-.66-1-1Z"
            style={{
              fill: "#781b00",
            }}
          />
          <circle
            cx={49.54}
            cy={87.55}
            r={0.71}
            style={{
              fill: "#631800",
            }}
          />
          <circle
            cx={50.54}
            cy={86.55}
            r={0.71}
            style={{
              fill: "#cf8561",
            }}
          />
          <path
            d="M51 87.05v-1h1v4l-1 1c.33.34.66.67 1 1v1h-2v-5Z"
            style={{
              fill: "#bd7143",
            }}
          />
          <path
            d="M52 86.05v-1h2v3h-1c-.12-.75.53-1.91-1-2"
            style={{
              fill: "#7e3510",
            }}
          />
          <path
            d="M53 85.05h-1v-2h2v1Z"
            style={{
              fill: "#6a2200",
            }}
          />
          <path
            d="M43 89.05h1c1.49.09.84 1.25 1 2v1h-1l-1-1Z"
            style={{
              fill: "#732301",
            }}
          />
          <path
            d="M45 92.05v-1h2v1l-1 1h-1Z"
            className="templesOnly_svg__cls-1790"
          />
          <path
            d="M47 92.05v-3h1v2.83l.65.07.35-1.9h1v4h-3Z"
            style={{
              fill: "#883304",
            }}
          />
          <path
            d="M48 89.05h-1v-1c.37.34.7.67 1 1"
            className="templesOnly_svg__cls-2232"
          />
          <path
            d="M45 92.05v1c-.34 1-.67 2-1 3l-1 1c-.34-.33-.67-.66-1-1a17.5 17.5 0 0 1 0-2.81c.07-.44.62-.79 1-1.19.11.28.21.56.32.83l.68-.83Z"
            style={{
              fill: "#9b3a0c",
            }}
          />
          <path
            d="M42 96.05c.33.34.66.67 1 1-.76.15-1.92-.49-2 1h-1v-5h1c.42.95-.89 2.54 1 3"
            style={{
              fill: "#c66a32",
            }}
          />
          <path
            d="m44 92.05-.68.83c-.11-.27-.21-.55-.32-.83v-1Z"
            style={{
              fill: "#691500",
            }}
          />
          <path
            d="M41 93.05h-1v-1c.37.34.7.67 1 1"
            style={{
              fill: "#d27744",
            }}
          />
          <path
            d="M33 94.05v-2h1c.33.34.66.67 1 1 .38 1-.93 2.54 1 3v1h-2v-1c-.12-.75.53-1.91-1-2"
            style={{
              fill: "#bc6735",
            }}
          />
          <path
            d="M35 93.05c-.34-.33-.67-.66-1-1h1Z"
            style={{
              fill: "#d28153",
            }}
          />
          <path
            d="M40 98.05h2v1h-3v-1Z"
            style={{
              fill: "#de7f43",
            }}
          />
          <path
            d="M34 97.05h1l1 1v1l-2 1Z"
            style={{
              fill: "#c87233",
            }}
          />
          <path
            d="M37 99.05v1l-1-1Z"
            style={{
              fill: "#fa9e5c",
            }}
          />
          <path d="m36 98.05-1-1h1Z" className="templesOnly_svg__cls-2574" />
          <path
            d="M40 99.05h3v2h-1c-.76.15-1.92-.49-2 1h-2v-2h1Z"
            style={{
              fill: "#a73d04",
            }}
          />
          <circle
            cx={37.54}
            cy={100.55}
            r={0.71}
            className="templesOnly_svg__cls-2747"
          />
          <path d="m40 99.05-1 1v-1Z" className="templesOnly_svg__cls-2748" />
          <path
            d="M77 76.05h2v3c-1.93.47-.62 2-1 3h-2v-3l1-1Z"
            className="templesOnly_svg__cls-2113"
          />
          <path
            d="M73 80.05c.15-.75-.5-1.91 1-2v6h-1Z"
            style={{
              fill: "#944419",
            }}
          />
          <path
            d="m75 84.05 1-1h2v1z"
            style={{
              fill: "#d87f44",
            }}
          />
          <ellipse
            cx={77.04}
            cy={82.55}
            className="templesOnly_svg__cls-2751"
            rx={1.41}
            ry={0.71}
          />
          <path
            d="M76 80.05v2c-.34-.41-.67-.83-1-1.24Z"
            className="templesOnly_svg__cls-2751"
          />
          <circle
            cx={74.54}
            cy={84.55}
            r={0.71}
            style={{
              fill: "#d98548",
            }}
          />
          <path d="m77 78.05-1 1v-1Z" className="templesOnly_svg__cls-2751" />
          <path
            d="M75 77.05c.33.34.66.67 1 1Z"
            style={{
              fill: "#cc8050",
            }}
          />
          <path
            d="M68 78.05v-1h3v5h-1c-.09-1.49-1.25-.85-2-1v-1l1-1 2-1Z"
            style={{
              fill: "#94451d",
            }}
          />
          <path
            d="M71 82.05v-1l1-1h1v4c-.63-.66-1.3-1.33-2-2"
            className="templesOnly_svg__cls-2284"
          />
          <path
            d="M71 80.05v-1c.33.34.66.67 1 1Z"
            style={{
              fill: "#71280b",
            }}
          />
          <circle
            cx={78.54}
            cy={72.55}
            r={0.71}
            style={{
              fill: "#5c1600",
            }}
          />
          <path
            d="M79 77.05v-1l-1-1 1-1h1v3Z"
            style={{
              fill: "#7a2a08",
            }}
          />
          <path
            d="M80 74.05h-1v-2h2v2Z"
            style={{
              fill: "#ab6238",
            }}
          />
          <path
            d="m104 70.05 1.66-4.84c-.07-.11-.37-.63-.66-1.16h3c.33.34.66.67 1 1v1c-1.5.09-.85 1.25-1 2l-2-1v3z"
            className="templesOnly_svg__cls-2759"
          />
          <path
            d="M101 70.05v3c-.76.15-1.92-.49-2 1h-1a2.27 2.27 0 0 1 1-2.5 2.29 2.29 0 0 0 1-2.5h1Z"
            className="templesOnly_svg__cls-2760"
          />
          <path
            d="M101 74.05h1l1 1v1l-1 1a5.4 5.4 0 0 0-4 1v-2c1-.38 2.53.93 3-1Z"
            style={{
              fill: "#973602",
            }}
          />
          <path
            d="M109 65.05c-.34-.33-.67-.66-1-1v-1h2l1 1v2h-1c-.3-.33-.63-.66-1-1"
            style={{
              fill: "#973f11",
            }}
          />
          <path
            d="M101 70.05v-3l2-1a4.62 4.62 0 0 1-2 4"
            style={{
              fill: "#813c11",
            }}
          />
          <path
            d="M106 61.05v-1h2c.33.34.66.67 1 1v1h-2Z"
            style={{
              fill: "#a24e1a",
            }}
          />
          <path
            d="M101 74.05v1h-2v-1c.08-1.49 1.24-.85 2-1Z"
            style={{
              fill: "#d0773a",
            }}
          />
          <path
            d="m103 66.05-2 1v-2h2Z"
            style={{
              fill: "#5f1500",
            }}
          />
          <path
            d="m103 75.05-1-1c.15-.75-.5-1.91 1-2ZM103 72.05c.15-.75-.5-1.91 1-2v2Z"
            className="templesOnly_svg__cls-2760"
          />
          <path
            d="M108 62.05h2v1h-2Z"
            style={{
              fill: "#b86737",
            }}
          />
          <path
            d="m106 61.05 1 1h-2Z"
            style={{
              fill: "#b55b30",
            }}
          />
          <path
            d="M106 64.05h-1l.67-.83Z"
            style={{
              fill: "#8b3406",
            }}
          />
          <path
            d="M99 69.05v-2h1v2ZM101 66.05v1h-1Z"
            className="templesOnly_svg__cls-2770"
          />
          <path
            d="M108 60.05h-2l1-1h1Z"
            style={{
              fill: "#903b03",
            }}
          />
          <circle
            cx={107.54}
            cy={58.55}
            r={0.71}
            className="templesOnly_svg__cls-2428"
          />
          <path
            d="M108 59.05v-1h1v2h-1Z"
            style={{
              fill: "#8e3d0d",
            }}
          />
          <path
            d="M79 77.05h1l1 1h1c-.34.67-.67 1.34-1 2v1l-1 1h-1z"
            style={{
              fill: "#b0511b",
            }}
          />
          <path
            d="M83 77.05v-4a9 9 0 0 1 1 .77c.37.38.67.82 1 1.23v2Z"
            style={{
              fill: "#711e02",
            }}
          />
          <path
            d="M83 77.05h2v3h-2Z"
            style={{
              fill: "#862c0a",
            }}
          />
          <path
            d="M82 78.05h-1c-.16-.75.49-1.91-1-2v-2h1a5.4 5.4 0 0 1 1 4"
            className="templesOnly_svg__cls-2776"
          />
          <path
            d="M81 81.05v-1h2v2h-1Z"
            style={{
              fill: "#e38749",
            }}
          />
          <path
            d="M85 75.05c-.34-.41-.64-.85-1-1.23a9 9 0 0 0-1-.77v-1h2z"
            style={{
              fill: "#661700",
            }}
          />
          <path
            d="M36 113.13v-1l.83-.33-.83-.67 1-1h1l1 1v1l-1.34 4.21a2.16 2.16 0 0 1-2.66 1.79v-2h1.58c.35-1.13 1.31-2.27-.58-3"
            style={{
              fill: "#b45720",
            }}
          />
          <path
            d="M42 111.05c-.16.76.49 1.92-1 2l-2-1v-1z"
            style={{
              fill: "#f9a360",
            }}
          />
          <path
            d="m145.07 36.05-.67.83-.33-.83Z"
            style={{
              fill: "#3c0400",
            }}
          />
          <path
            d="M152.07 41.05h1v1h-3l-1-1v-1h2Z"
            style={{
              fill: "#6d250f",
            }}
          />
          <path
            d="m149.07 41.05 1 1h-2v-1Z"
            className="templesOnly_svg__cls-2442"
          />
          <circle
            cx={151.57}
            cy={39.55}
            r={0.71}
            style={{
              fill: "#6f240d",
            }}
          />
          <path
            d="M148.07 41.05v1h-2v-1Z"
            style={{
              fill: "#7d2d0c",
            }}
          />
          <circle
            cx={145.57}
            cy={41.55}
            r={0.71}
            style={{
              fill: "#934423",
            }}
          />
          <path
            d="M64 80.05v1c-1.5.09-.85 1.25-1 2h-1c-.09-1.49-1.25-.85-2-1v-1c.75-.15 1.91.5 2-1Z"
            style={{
              fill: "#93491f",
            }}
          />
          <circle
            cx={59.54}
            cy={81.55}
            r={0.71}
            className="templesOnly_svg__cls-2787"
          />
          <path
            d="M56 83.05v-1c.75.15 1.91-.49 2 1l1 1v2h-1c-.09-1.49-1.25-.85-2-1v-1l.82-.33Z"
            style={{
              fill: "#994c23",
            }}
          />
          <path
            d="M59 86.05v-4h1c.38 1-.93 2.54 1 3v2h-1Z"
            className="templesOnly_svg__cls-2789"
          />
          <path d="M59 83.05v1l-1-1Z" className="templesOnly_svg__cls-2787" />
          <path
            d="M56 84.05v1h-2v-2h1c.37.34.7.67 1 1"
            style={{
              fill: "#79300d",
            }}
          />
          <path
            d="M56 84.05c-.34-.33-.67-.66-1-1h1Z"
            className="templesOnly_svg__cls-2444"
          />
          <path
            d="M66 79.05v-1h2v1Z"
            style={{
              fill: "#954922",
            }}
          />
          <path
            d="M66 79.05h2v3h-1c-.16-.75.49-1.91-1-2Z"
            style={{
              fill: "#7b3006",
            }}
          />
          <ellipse
            cx={64.54}
            cy={82.05}
            rx={0.71}
            ry={1.41}
            style={{
              fill: "#9d542c",
            }}
          />
          <path d="m65 81.05 1-1v1Z" className="templesOnly_svg__cls-2110" />
          <circle
            cx={27.54}
            cy={94.55}
            r={0.71}
            style={{
              fill: "#7a2f05",
            }}
          />
          <path
            d="M27 94.05c-.34-.33-.67-.66-1-1Z"
            style={{
              fill: "#a75a36",
            }}
          />
          <path
            d="M27 95.05h1v2h-2Z"
            style={{
              fill: "#a15223",
            }}
          />
          <path
            d="M29 95.05c.06-1.22.94-1.23 1.61-.8s.93 1.19 1.39 1.8v5h-1v-3a2.48 2.48 0 0 0-2-3"
            className="templesOnly_svg__cls-2574"
          />
          <path
            d="M29 95.05a2.48 2.48 0 0 1 2 3l-2-1-1-1v-1Z"
            className="templesOnly_svg__cls-2797"
          />
          <path
            d="M32 99.05v-3h1v3Z"
            style={{
              fill: "#882900",
            }}
          />
          <path
            d="M33 94.05c1.49.09.84 1.25 1 2h-1Z"
            className="templesOnly_svg__cls-2574"
          />
          <path
            d="m152.07 61.05 1 1v1h-1l-2.44.42 1.44.58v2h-1c-.76.15-1.91-.5-2 1-1.5-.09-.85-1.24-1-2v-2l1-1h1l1-1Z"
            style={{
              fill: "#f0a044",
            }}
          />
          <path
            d="M152.07 63.05h1v2h-2v-1Z"
            style={{
              fill: "#f7a152",
            }}
          />
          <path
            d="M148.07 67.05c.09-1.5 1.24-.85 2-1v1z"
            className="templesOnly_svg__cls-2801"
          />
          <path
            d="M153.07 65.05v-1h2c-.07 1.49-1.24.85-2 1"
            className="templesOnly_svg__cls-2802"
          />
          <path
            d="M159.07 63.05c-.08 1.49-1.24.85-2 1v-1z"
            className="templesOnly_svg__cls-2632"
          />
          <ellipse
            cx={156.07}
            cy={63.55}
            className="templesOnly_svg__cls-2802"
            rx={1.41}
            ry={0.71}
          />
          <path
            d="M151.07 65.05h1l-1 1Z"
            className="templesOnly_svg__cls-2801"
          />
          <path
            d="m161 65.15-.82-.69.32-.32.7.82Z"
            className="templesOnly_svg__cls-2632"
          />
          <path
            d="M148.07 70.05c-.15.76.5 1.91-1 2l-1 1h-1v-4h1l1 1Z"
            className="templesOnly_svg__cls-2803"
          />
          <path
            d="M147.07 73.05q2.055 1.5 0 3l-1-1v-2Z"
            style={{
              fill: "#7a3422",
            }}
          />
          <path
            d="M148.07 70.05h-1v-2l1-1h1c-.33 1-.67 2-1 3"
            className="templesOnly_svg__cls-2626"
          />
          <ellipse
            cx={149.57}
            cy={75.05}
            rx={0.71}
            ry={1.41}
            style={{
              fill: "#380200",
            }}
          />
          <path
            d="M147.07 73.05h-1l1-1Z"
            style={{
              fill: "#853a20",
            }}
          />
          <path
            d="M159.07 63.05h-1c-.08-1.5-1.24-.85-2-1v-1h4v1Z"
            style={{
              fill: "#eea051",
            }}
          />
          <path
            d="M160.07 62.05v-1h2c-.07 1.49-1.24.85-2 1"
            className="templesOnly_svg__cls-2808"
          />
          <circle
            cx={162.57}
            cy={60.55}
            r={0.71}
            className="templesOnly_svg__cls-2808"
          />
          <path
            d="M169.07 57.05v3h-1l-1-1h-3l2-1c.76-.15 1.92.49 2-1Z"
            style={{
              fill: "#f2a457",
            }}
          />
          <path
            d="M162.07 37.05v1l-1-1Z"
            style={{
              fill: "#772e1d",
            }}
          />
          <path d="m165.07 35.05-1 1Z" className="templesOnly_svg__cls-2499" />
          <path
            d="M157.07 39.05h-1v-1h3v1z"
            style={{
              fill: "#5b1a01",
            }}
          />
          <path
            d="M156.07 38.05v1l-1-1Z"
            className="templesOnly_svg__cls-2812"
          />
          <path
            d="m161.07 37.05 1 1v1h-2v-1Z"
            style={{
              fill: "#651f11",
            }}
          />
          <circle
            cx={159.57}
            cy={38.55}
            r={0.71}
            className="templesOnly_svg__cls-2667"
          />
          <path
            d="M155.07 40.05h2v3h-1c-.15-.76.5-1.92-1-2Z"
            style={{
              fill: "#853813",
            }}
          />
          <path
            d="M155.07 40.05v1h-2c.09-1.5 1.24-.85 2-1"
            style={{
              fill: "#8f401f",
            }}
          />
          <path
            d="M157.07 41.05v-2h1v2Z"
            style={{
              fill: "#7f3e1f",
            }}
          />
          <path
            d="M151.07 40.05h1v1Z"
            style={{
              fill: "#5c1300",
            }}
          />
          <path
            d="M37 109.05h-3c.41-.33.85-.63 1.23-1a8.6 8.6 0 0 0 .77-1h1c1.49.09.84 1.25 1 2Z"
            style={{
              fill: "#febe70",
            }}
          />
          <path
            d="M37 109.05h1l2-1c.15.76-.5 1.92 1 2v1h-2c-.34-.33-.67-.66-1-1h-1Z"
            style={{
              fill: "#c97130",
            }}
          />
          <path
            d="m36 111.05.82.67-.82.33h-1Z"
            style={{
              fill: "#e79d4f",
            }}
          />
          <path
            d="M33 106.05h-4v-1l1-2h1v1c.08 1.5 1.24.85 2 1Z"
            className="templesOnly_svg__cls-2821"
          />
          <path
            d="m30 103.05-1 2h-1v-2l2-1Z"
            style={{
              fill: "#e68e4f",
            }}
          />
          <path
            d="M29 106.05h2l-1 1h-2Z"
            className="templesOnly_svg__cls-2662"
          />
          <path
            d="M36 107.05a8.6 8.6 0 0 1-.77 1c-.38.37-.82.67-1.23 1h-1v-2l3-1Z"
            style={{
              fill: "#e7aa57",
            }}
          />
          <path
            d="m36 106.05-3 1v-1l1-1h1c.75.15 1.91-.49 2 1Z"
            style={{
              fill: "#fec466",
            }}
          />
          <path
            d="m30 102.05-2 1v-3l1-1v-2l2 1v2c-1.46.09-.81 1.25-1 2"
            className="templesOnly_svg__cls-2821"
          />
          <path d="m29 99.05-1 1v-1Z" className="templesOnly_svg__cls-2574" />
          <circle
            cx={28.54}
            cy={98.55}
            r={0.71}
            className="templesOnly_svg__cls-2797"
          />
          <circle
            cx={28.54}
            cy={97.55}
            r={0.71}
            className="templesOnly_svg__cls-2574"
          />
          <path
            d="M156.07 43.05h3v2h-2L155.85 44l-1.78 2.06-1-1v-1Z"
            className="templesOnly_svg__cls-2825"
          />
          <path
            d="m154.07 46.05 1.78-2.05 1.22 1.06v2l-2 2c-.15-.76.5-1.92-1-2Z"
            className="templesOnly_svg__cls-2826"
          />
          <path d="m159.07 48.05-1-1Z" className="templesOnly_svg__cls-2502" />
          <path
            d="M159.07 39.05h3v1l-3 1Z"
            style={{
              fill: "#4e0a00",
            }}
          />
          <path
            d="M159.07 43.05h-2v-2h2Z"
            className="templesOnly_svg__cls-2666"
          />
          <path
            d="M162.07 40.05v-2c1.5.08.85 1.24 1 2Z"
            style={{
              fill: "#5b1100",
            }}
          />
          <path
            d="M156.07 51.05h-1v-1Z"
            style={{
              fill: "#eb925b",
            }}
          />
          <circle
            cx={154.57}
            cy={49.55}
            r={0.71}
            className="templesOnly_svg__cls-2826"
          />
          <path
            d="m148 62.05-1 1c-.34-.33-.67-.66-1-1h-1c-.09-1.49-1.25-.85-2-1h-1v-1h1c.75-.15 1.91.5 2-1h2c.15.76-.5 1.92 1 2Z"
            className="templesOnly_svg__cls-2678"
          />
          <path
            d="M148 53.05v2h-2l-1 1h-1v-2h2Z"
            style={{
              fill: "#d27d49",
            }}
          />
          <path
            d="M143 57.05v1h-3v-1ZM145 59.05c-.09 1.5-1.25.85-2 1v-2h1c.37.34.7.67 1 1"
            className="templesOnly_svg__cls-2831"
          />
          <path
            d="M147.07 59.05h-1c.09-1.5 1.24-.85 2-1v1Z"
            className="templesOnly_svg__cls-2504"
          />
          <path
            d="M145 59.05c-.34-.33-.67-.66-1-1 .37.34.7.67 1 1"
            style={{
              fill: "#801e00",
            }}
          />
          <path d="m144 56.05-1 1v-1Z" className="templesOnly_svg__cls-2831" />
          <path
            d="m145.07 56.05 1-1ZM148.07 55.05v-1h1ZM152.07 53.05v-1h1Z"
            className="templesOnly_svg__cls-2504"
          />
          <circle
            cx={153.57}
            cy={51.55}
            r={0.71}
            style={{
              fill: "#de8f57",
            }}
          />
          <path
            d="m148.07 53.05-2 1v-1c.33-2 .67-4 1-6 .09-1.5 1.24-.85 2-1v6Z"
            className="templesOnly_svg__cls-2825"
          />
          <path
            d="M149.07 52.05v-1c.76.15 1.92-.5 2 1l-1 1Z"
            style={{
              fill: "#f29654",
            }}
          />
          <path
            d="M151.07 52.05c-.08-1.5-1.24-.85-2-1v-5h2v1c-1.84.73-.89 1.91-.58 3h1.58l1 1v1z"
            style={{
              fill: "#cd7f58",
            }}
          />
          <path
            d="M148.07 62.05v-1l1 1Z"
            className="templesOnly_svg__cls-2801"
          />
          <path
            d="M155.07 61.05v-1l1 1Z"
            style={{
              fill: "#feb767",
            }}
          />
          <path
            d="M153.07 63.05v-1l1-1h1v2Z"
            className="templesOnly_svg__cls-2802"
          />
          <circle
            cx={154.57}
            cy={50.55}
            r={0.71}
            style={{
              fill: "#dc8d55",
            }}
          />
          <path
            d="M92 73.05c1.92.47.61 2 1 3 .33.34.66.67 1 1v1l-1 1.06.15-.15-.7-.81-.31.31a5.5 5.5 0 0 0 .86.65 10 10 0 0 1 1.05.94v1H92c-.67-.66-1.34-1.33-2-2v-1l1-1c.33-.39.88-.74.95-1.18a17.7 17.7 0 0 0 .05-2.82"
            style={{
              fill: "#9c4210",
            }}
          />
          <path
            d="M85 79.05v-4h3v2h-1L86.52 76c-.65 1.1-.87 1.87.52 2.1l-1 1Z"
            style={{
              fill: "#a14f23",
            }}
          />
          <path
            d="M87 77.05h4l-1 1h-3Z"
            style={{
              fill: "#bb6234",
            }}
          />
          <path
            d="M86 75.05h-1v-2h1z"
            style={{
              fill: "#792c04",
            }}
          />
          <path
            d="M94 77.05c-.34-.33-.67-.66-1-1 1.49-.08.84-1.24 1-2h1c.33.34.66.67 1 1h1v1c-.76.15-1.92-.49-2 1Z"
            style={{
              fill: "#db8643",
            }}
          />
          <path d="M94 67.05h1v5h-1Z" className="templesOnly_svg__cls-2529" />
          <ellipse
            cx={94.54}
            cy={73.05}
            className="templesOnly_svg__cls-2700"
            rx={0.71}
            ry={1.41}
          />
          <path
            d="M99 69.05h1a2.29 2.29 0 0 1-1 2.5 2.27 2.27 0 0 0-1 2.5h-1v-5Z"
            style={{
              fill: "#9b4c18",
            }}
          />
          <ellipse
            cx={95.54}
            cy={71.05}
            className="templesOnly_svg__cls-2700"
            rx={0.71}
            ry={1.41}
          />
          <path
            d="M97 69.05v1h-1v-2h1Z"
            style={{
              fill: "#691c00",
            }}
          />
          <path
            d="M99 67.05v1l-.83-.67Z"
            style={{
              fill: "#97492b",
            }}
          />
          <path
            d="M97 68.05h-1l.67-.83Z"
            style={{
              fill: "#601200",
            }}
          />
          <path
            d="M126 54.05h1v1h-1c-.34-.33-.67-.66-1-1Z"
            style={{
              fill: "#681d00",
            }}
          />
          <path
            d="M126 54.05h-1v-1Z"
            style={{
              fill: "#8c441b",
            }}
          />
          <path
            d="M120 57.05c1.49-.08.84-1.24 1-2h1c.33.34.66.67 1 1v2h-1l-1 1-1-1Z"
            style={{
              fill: "#853312",
            }}
          />
          <path
            d="M122 54.05h2l-1 1h-1Z"
            style={{
              fill: "#7a3014",
            }}
          />
          <path
            d="m123 55.05 1-1h1c.33.34.66.67 1 1v2h-3z"
            style={{
              fill: "#6d250a",
            }}
          />
          <path
            d="M115 58.05h2l1 1 1 1v2l-3-1-1-1z"
            className="templesOnly_svg__cls-2637"
          />
          <path d="M115 58.05v1h-4v-1z" className="templesOnly_svg__cls-2852" />
          <path
            d="M120 57.05v1h-2l1-1Z"
            style={{
              fill: "#5c1c00",
            }}
          />
          <path
            d="m118 59.05-1-1h1Z"
            style={{
              fill: "#480a00",
            }}
          />
          <path d="M114 58.05h-1l1-1Z" className="templesOnly_svg__cls-2714" />
          <path
            d="M111 58.05v1h-2v-1l2-1Z"
            style={{
              fill: "#7f320e",
            }}
          />
          <path
            d="m146.07 45.05-1-1v-1h3v1Z"
            style={{
              fill: "#893e20",
            }}
          />
          <path
            d="M147.07 43.05h-2v-1h2Z"
            style={{
              fill: "#722503",
            }}
          />
          <path
            d="M127 55.05v-1h2v2c.38 1-.93 2.54 1 3v1h-2v-4Z"
            style={{
              fill: "#96451d",
            }}
          />
          <path
            d="M133 57.05v-2c.66.67 1.33 1.34 2 2-1.5.09-.85 1.25-1 2h-1Z"
            style={{
              fill: "#913401",
            }}
          />
          <path
            d="M135 57.05h2v1l-1 1h-1Z"
            style={{
              fill: "#db7e3d",
            }}
          />
          <path
            d="M137 58.05v-2c.33.34.66.67 1 1v1Z"
            className="templesOnly_svg__cls-2557"
          />
          <path
            d="M138 58.05v-1h2v1z"
            style={{
              fill: "#d5824d",
            }}
          />
          <path
            d="m138.13 52 .81.7-.31.31-.7-.82Z"
            style={{
              fill: "#440a00",
            }}
          />
          <path
            d="M130 59.05c-1.93-.46-.62-2-1-3h1ZM133 57.05v2h-1l-.88-1.6.88-.4ZM130 60.05v-1h2v1z"
            className="templesOnly_svg__cls-2863"
          />
          <path
            d="M142 50.05v-1h2v3h-1c-.12-.75.53-1.91-1-2"
            style={{
              fill: "#964913",
            }}
          />
          <ellipse
            cx={145.04}
            cy={53.55}
            className="templesOnly_svg__cls-2865"
            rx={1.41}
            ry={0.71}
          />
          <circle
            cx={143.54}
            cy={52.55}
            r={0.71}
            className="templesOnly_svg__cls-2865"
          />
          <path
            d="m146.07 48.05-.67.83-.33-.83Z"
            style={{
              fill: "#5a0f00",
            }}
          />
          <circle
            cx={145.57}
            cy={47.55}
            r={0.71}
            className="templesOnly_svg__cls-2723"
          />
          <path
            d="M146.07 47.05h-1v-1Z"
            style={{
              fill: "#520600",
            }}
          />
          <ellipse
            cx={150.07}
            cy={45.55}
            rx={1.41}
            ry={0.71}
            style={{
              fill: "#ae613b",
            }}
          />
          <path
            d="m149.07 45.05-1-1Z"
            style={{
              fill: "#560b00",
            }}
          />
          <path
            d="M143 53.05h1v1c-.76.15-1.92-.49-2 1v1h-2c1.31-1.47 1-3.27 1-5l1-1c1.49.09.84 1.25 1 2l-.83.33Z"
            style={{
              fill: "#b9652b",
            }}
          />
          <path
            d="M140 56.05h3v1h-3Z"
            style={{
              fill: "#c8723f",
            }}
          />
          <ellipse
            cx={49.54}
            cy={89.05}
            className="templesOnly_svg__cls-2232"
            rx={0.71}
            ry={1.41}
          />
          <path d="m51 87.05-1 1v-1Z" className="templesOnly_svg__cls-2872" />
          <path
            d="M52 90.05v-1h1v3h-1c-.34-.33-.67-.66-1-1Z"
            style={{
              fill: "#903812",
            }}
          />
          <path
            d="M53 89.05h-1v-3c1.49.09.84 1.25 1 2Z"
            className="templesOnly_svg__cls-2872"
          />
          <path
            d="M51 93.05h2v1h-2Z"
            style={{
              fill: "#fe9a59",
            }}
          />
          <path d="M53 93.05h-1v-1h2Z" className="templesOnly_svg__cls-2875" />
          <circle
            cx={50.54}
            cy={93.55}
            r={0.71}
            className="templesOnly_svg__cls-2876"
          />
          <path d="m52 90.05-1 1Z" className="templesOnly_svg__cls-2876" />
          <path
            d="M54 92.05h-1v-4h2v4Z"
            style={{
              fill: "#6e1b01",
            }}
          />
          <ellipse
            cx={54.54}
            cy={86.55}
            rx={0.71}
            ry={2.12}
            style={{
              fill: "#5b0f00",
            }}
          />
          <path
            d="M54 84.05v1h-1Z"
            style={{
              fill: "#823a19",
            }}
          />
          <path
            d="M44 96.05c.33-1 .66-2 1-3h1l1 1h2c.33.34.66.67 1 1v1h-2l-.76-1-1.24 1z"
            style={{
              fill: "#c5662e",
            }}
          />
          <path d="m47 94.05-1-1 1-1Z" className="templesOnly_svg__cls-2569" />
          <path
            d="M50 95.05c-.34-.33-.67-.66-1-1h2v1Z"
            style={{
              fill: "#dc8541",
            }}
          />
          <path
            d="M44 96.05h1c.33.34.66.67 1 1-.47 1.93-2 .62-3 1v-1Z"
            className="templesOnly_svg__cls-2882"
          />
          <path
            d="M43 97.05v1h-2c.12-1.49 1.28-.85 2-1"
            style={{
              fill: "#ec8643",
            }}
          />
          <circle
            cx={33.54}
            cy={96.55}
            r={0.71}
            className="templesOnly_svg__cls-2625"
          />
          <circle
            cx={42.54}
            cy={98.55}
            r={0.71}
            className="templesOnly_svg__cls-2748"
          />
          <path
            d="M37 100.05v1h-1l-1 1h-1c-.34-.33-.67-.66-1-1v-1h1l2-1Z"
            style={{
              fill: "#e3824b",
            }}
          />
          <path
            d="M34 100.05h-1v-3h1Z"
            style={{
              fill: "#ac511a",
            }}
          />
          <path
            d="M43 99.05v-1c1-.38 2.53.93 3-1h4v1c-.76.15-1.92-.49-2 1h-1l-1 1h-1l-.33-.83-.67.83h-1Z"
            style={{
              fill: "#a2360d",
            }}
          />
          <ellipse
            cx={39.04}
            cy={102.55}
            className="templesOnly_svg__cls-2887"
            rx={1.41}
            ry={0.71}
          />
          <path
            d="M42 101.05h2c-.09 1.5-1.25.85-2 1Z"
            className="templesOnly_svg__cls-2888"
          />
          <path
            d="M42 101.05v1h-2c.12-1.49 1.28-.85 2-1M36 101.05h2v1h-2Z"
            className="templesOnly_svg__cls-2887"
          />
          <path
            d="M44 101.05h-1v-1h2v1Z"
            className="templesOnly_svg__cls-2748"
          />
          <path
            d="M79 79.05v3h-1c.42-.98-.89-2.53 1-3"
            className="templesOnly_svg__cls-2751"
          />
          <circle
            cx={73.54}
            cy={84.55}
            r={0.71}
            className="templesOnly_svg__cls-2889"
          />
          <path
            d="M74 85.05h1c.75-.15 1.91.5 2-1h1l1-1h1l1-1h1v1c.33.34.66.67 1 1v1h-1l-1 1c-.76.15-1.92-.49-2 1h-3l-1 1h-1l-1 1h-1l-1 1h-2l-1-1v-1h1l1-1h1l1-1h1Z"
            style={{
              fill: "#973905",
            }}
          />
          <path
            d="M77 84.05c-.09 1.5-1.25.85-2 1v-1Z"
            className="templesOnly_svg__cls-2891"
          />
          <path d="m79 83.05-1 1v-2h1Z" className="templesOnly_svg__cls-961" />
          <path
            d="M73 84.05v1h-3v-3h1c.7.67 1.37 1.34 2 2"
            className="templesOnly_svg__cls-2892"
          />
          <path
            d="M70 82.05v1h-2v-2c.79.15 2-.49 2 1"
            style={{
              fill: "#be703d",
            }}
          />
          <path
            d="M68 79.05v-1h3l-2 1Z"
            style={{
              fill: "#ab5d32",
            }}
          />
          <path
            d="M71 80.05h1l-1 1ZM68 79.05h1l-1 1Z"
            className="templesOnly_svg__cls-2892"
          />
          <path
            d="M80 76.05c1.49.09.84 1.25 1 2l-1-1Z"
            style={{
              fill: "#ca713c",
            }}
          />
          <path
            d="M106 70.05v-3l2 1c.33.34.66.67 1 1h1l1-1h1v2h-1l-1 1h-1c-.43-1.92-2-.61-3-1"
            style={{
              fill: "#e28143",
            }}
          />
          <path
            d="M104 72.05v-2h1c.41.34.85.64 1.23 1a9 9 0 0 1 .77 1l-2 2c-1.46-.05-.81-1.24-1-2"
            className="templesOnly_svg__cls-2153"
          />
          <path
            d="m111 68.05-1 1v-1l-.33-.83-.67.83h-1c.15-.75-.5-1.91 1-2h2Z"
            style={{
              fill: "#a3410d",
            }}
          />
          <path
            d="M107 72.05a9 9 0 0 0-.77-1c-.38-.37-.82-.67-1.23-1h1c1 .39 2.53-.92 3 1l-1 1Z"
            className="templesOnly_svg__cls-2898"
          />
          <path
            d="M110 66.05h-1v-1c.37.34.7.67 1 1"
            style={{
              fill: "#7f1e00",
            }}
          />
          <ellipse
            cx={100.54}
            cy={68.05}
            rx={0.71}
            ry={1.41}
            style={{
              fill: "#a96233",
            }}
          />
          <circle
            cx={98.54}
            cy={74.55}
            r={0.71}
            style={{
              fill: "#d07743",
            }}
          />
          <path
            d="M104 72.05c.15.76-.5 1.92 1 2v2l-2 1v-5Z"
            className="templesOnly_svg__cls-2902"
          />
          <path
            d="M94 77.05h1c.75-.15 1.91.5 2-1h1v2l-1 1h-1c-.09-1.49-1.25-.85-2-1Z"
            style={{
              fill: "#892f00",
            }}
          />
          <path
            d="m97 79.05 1-1a5.4 5.4 0 0 1 4-1v1c-.61.11-1.23.19-1.83.34s-1.45.44-2.17.66ZM98 75.05h3c-.47 1.93-2 .62-3 1ZM103 76.05v1h-1Z"
            className="templesOnly_svg__cls-2904"
          />
          <path
            d="M111 65.05v-1a4.9 4.9 0 0 0 1-1.26c.23-.68-.3-1.73 1-1.74.33.34.66.67 1 1l-.83.33.83.67c.15.76-.5 1.92 1 2v1h-2c0-1.49-1.21-.85-2-1"
            style={{
              fill: "#c26f2a",
            }}
          />
          <path
            d="M111 65.05c.75.15 1.91-.49 2 1v2h-2z"
            style={{
              fill: "#bf6425",
            }}
          />
          <path
            d="m111 64.05-1-1Z"
            style={{
              fill: "#7a2700",
            }}
          />
          <path
            d="M109 59.05h1l1 1c-.34.67-.67 1.34-1 2h-1z"
            style={{
              fill: "#984f23",
            }}
          />
          <path
            d="M109 60.05v1c-.34-.33-.67-.66-1-1Z"
            style={{
              fill: "#aa5b26",
            }}
          />
          <path
            d="M110 62.05c.33-.66.66-1.33 1-2 .75.15 1.91-.49 2 1-1.34 0-.81 1.06-1 1.74a4.9 4.9 0 0 1-1 1.26l-1-1Z"
            className="templesOnly_svg__cls-2852"
          />
          <path
            d="M82 82.05h-2l1-1Z"
            style={{
              fill: "#f89a5b",
            }}
          />
          <circle
            cx={79.54}
            cy={82.55}
            r={0.71}
            style={{
              fill: "#e38151",
            }}
          />
          <path
            d="M83 81.05v-1h2v1z"
            style={{
              fill: "#cd754c",
            }}
          />
          <path
            d="M85 81.05v-2h1v2Z"
            style={{
              fill: "#b15c2d",
            }}
          />
          <path
            d="M85 81.05h1c-.34.67-.67 1.34-1 2l-1 1h-1c-.34-.33-.67-.66-1-1v-1h1l1-1Z"
            style={{
              fill: "#7a2600",
            }}
          />
          <path d="m84 81.05-1 1v-1Z" className="templesOnly_svg__cls-2915" />
          <path
            d="M38 110.05c.33.34.66.67 1 1Z"
            style={{
              fill: "#a7430f",
            }}
          />
          <path
            d="M41 111.05v-1h3v3h-1c-.16-.75.49-1.91-1-2Z"
            className="templesOnly_svg__cls-2917"
          />
          <path
            d="M43 113.05h1v2c-1.46-.05-.81-1.24-1-2"
            style={{
              fill: "#ce7835",
            }}
          />
          <ellipse
            cx={152.57}
            cy={43.05}
            rx={0.71}
            ry={1.41}
            style={{
              fill: "#530f01",
            }}
          />
          <ellipse
            cx={151.57}
            cy={43.05}
            rx={0.71}
            ry={1.41}
            style={{
              fill: "#641e07",
            }}
          />
          <path
            d="M151.07 42.05v2c-1.5-.09-.85-1.24-1-2Z"
            style={{
              fill: "#8e4625",
            }}
          />
          <circle
            cx={153.57}
            cy={41.55}
            r={0.71}
            style={{
              fill: "#8d3e25",
            }}
          />
          <path
            d="M150.07 42.05c.15.76-.5 1.91 1 2v1h-2l-1-1v-2Z"
            className="templesOnly_svg__cls-2605"
          />
          <circle
            cx={147.57}
            cy={42.55}
            r={0.71}
            style={{
              fill: "#6a2000",
            }}
          />
          <path
            d="M61 85.05c-1.93-.46-.62-2-1-3 .75.15 1.91-.49 2 1-1.46.09-.81 1.25-1 2"
            className="templesOnly_svg__cls-2284"
          />
          <path
            d="M62 83.05h2v2h-1c-.34-.33-.67-.66-1-1Z"
            style={{
              fill: "#b96e3f",
            }}
          />
          <path
            d="M64 83.05h-1c.15-.75-.5-1.91 1-2Z"
            style={{
              fill: "#ad6538",
            }}
          />
          <path
            d="M60 87.05h1c.33.67.66 1.34 1 2l-1 1h-3c-.34-.33-.67-.66-1-1l1-2v-1h1l.42 2.44c.39-.88.5-1.16.58-1.44"
            style={{
              fill: "#90330a",
            }}
          />
          <path
            d="M58 86.05v1h-2v-2c.79.15 2-.49 2 1"
            style={{
              fill: "#85350b",
            }}
          />
          <path
            d="M56 84.05v-1l.82.67Z"
            style={{
              fill: "#bc724a",
            }}
          />
          <path
            d="M62 89.05c-.34-.66-.67-1.33-1-2v-2h1l.32.83.68-.83h1v2c-1.5.09-.85 1.25-1 2Z"
            style={{
              fill: "#aa5118",
            }}
          />
          <path
            d="M60 87.05c-.12.28-.23.56-.58 1.44L59 86.05Z"
            style={{
              fill: "#7b2000",
            }}
          />
          <path
            d="M56 85.05v2l-1 1v-3Z"
            style={{
              fill: "#732402",
            }}
          />
          <path
            d="M66 81.05v-1c1.49.09.84 1.25 1 2v1h-1Z"
            style={{
              fill: "#5f1400",
            }}
          />
          <path
            d="M67 83.05v-1h1v2h-1Z"
            style={{
              fill: "#85380b",
            }}
          />
          <path
            d="M64 87.05v-4h1v4Z"
            style={{
              fill: "#803105",
            }}
          />
          <ellipse
            cx={65.54}
            cy={82.05}
            rx={0.71}
            ry={1.41}
            style={{
              fill: "#6d2208",
            }}
          />
          <path
            d="M29 97.05h-1v-1Z"
            style={{
              fill: "#903e0c",
            }}
          />
          <path
            d="M30 102.05c.15-.75-.5-1.91 1-2v1c.33.67.66 1.34 1 2h-2Z"
            style={{
              fill: "#e59254",
            }}
          />
          <path
            d="M32 103.05c-.34-.66-.67-1.33-1-2h2v1Z"
            style={{
              fill: "#e07b43",
            }}
          />
          <path
            d="M33 101.05h-1v-2h1z"
            style={{
              fill: "#a23e0b",
            }}
          />
          <path
            d="m148.07 67.05-1 1h-1c-.33-.67-.67-1.33-1-2v-1h2c.15.76-.5 1.95 1 2"
            className="templesOnly_svg__cls-2801"
          />
          <path
            d="M147.07 65.05h-2v-1l1-1h1Z"
            style={{
              fill: "#f99d51",
            }}
          />
          <path
            d="m152.07 63.05-1 1-1.44-.58Z"
            style={{
              fill: "#e19031",
            }}
          />
          <ellipse
            cx={154.07}
            cy={63.55}
            rx={1.41}
            ry={0.71}
            style={{
              fill: "#feb56d",
            }}
          />
          <path
            d="M155.07 63.05v-1h1c.76.15 1.92-.5 2 1z"
            style={{
              fill: "#feb271",
            }}
          />
          <path
            d="m145 66.05 1 2-1 1v4h-1v-5l-1-1v-1z"
            style={{
              fill: "#db9352",
            }}
          />
          <path
            d="M144 73.05h2v2h-2z"
            style={{
              fill: "#521200",
            }}
          />
          <path
            d="M147.07 69.05v1l-1-1ZM145.07 69.05l1-1v1Z"
            className="templesOnly_svg__cls-2801"
          />
          <path
            d="M144 75.05h2v1c-.72-.15-1.88.5-2-1"
            style={{
              fill: "#350000",
            }}
          />
          <path
            d="M143 75.05h-1v-1h2v1Z"
            style={{
              fill: "#be6a38",
            }}
          />
          <path
            d="M146.07 76.05v-1l1 1Z"
            className="templesOnly_svg__cls-2627"
          />
          <circle
            cx={146.57}
            cy={68.55}
            r={0.71}
            className="templesOnly_svg__cls-2803"
          />
          <circle
            cx={155.57}
            cy={61.55}
            r={0.71}
            style={{
              fill: "#dd9349",
            }}
          />
          <ellipse
            cx={158.57}
            cy={40.05}
            className="templesOnly_svg__cls-2667"
            rx={0.71}
            ry={1.41}
          />
          <path
            d="M153.07 42.05h1l1-1c1.5.08.85 1.24 1 2l-3 1Z"
            style={{
              fill: "#712201",
            }}
          />
          <path
            d="m155.07 41.05-1 1v-1Z"
            className="templesOnly_svg__cls-2825"
          />
          <path
            d="m40 108.05-2 1c-.16-.75.49-1.91-1-2v-1h2l1 1Z"
            style={{
              fill: "#f1a34e",
            }}
          />
          <circle
            cx={36.54}
            cy={106.55}
            r={0.71}
            style={{
              fill: "#dd9b48",
            }}
          />
          <path
            d="M44 110.05h-3c-1.5-.08-.85-1.24-1-2h1l.32.83.68-.83h1l1 1Z"
            style={{
              fill: "#9b4309",
            }}
          />
          <path
            d="m32 103.05 1-1h1c.15.76-.5 1.92 1 2v1h-2c-.09-1.49-1.25-.85-2-1v-1Z"
            className="templesOnly_svg__cls-2953"
          />
          <path
            d="M31 104.05c.75.15 1.91-.49 2 1-.72-.15-1.88.5-2-1"
            style={{
              fill: "#a43d00",
            }}
          />
          <path
            d="M33 105.05h1l-1 1Z"
            style={{
              fill: "#f8b767",
            }}
          />
          <path
            d="M35 105.05v-1c.75-.15 1.91.5 2-1h3v2c-.76.15-1.92-.49-2 1h-1c0-1.49-1.21-.85-2-1"
            style={{
              fill: "#f4a658",
            }}
          />
          <path
            d="M151.07 45.05v-1h2a5.8 5.8 0 0 1-.58 2.24c.2.51.57.31.55.16a8.7 8.7 0 0 0-.43-1.4c-.18.6-.35 1.2-.12 1.24.91-.91 1.25-.57 1.58-.24v4l-1 1-1-1c-.33-1-.67-2-1-3z"
            style={{
              fill: "#662201",
            }}
          />
          <path
            d="M154.07 49.05v-2c1.5.08.85 1.24 1 2Z"
            className="templesOnly_svg__cls-2825"
          />
          <path
            d="M142 61.05h1c-.34.67-.67 1.34-1 2l-1 1h-2v-2l1-1Z"
            style={{
              fill: "#fca258",
            }}
          />
          <path
            d="m141 64.05 1-1 3-1h1v1l-1 1c-.76.15-1.92-.49-2 1h-1c-.3-.33-.63-.66-1-1"
            style={{
              fill: "#e39340",
            }}
          />
          <path
            d="M143 59.05v1h-1c-.76.15-1.92-.49-2 1-1.5-.08-.85-1.24-1-2h1l1-1h1c.37.34.7.67 1 1"
            style={{
              fill: "#932804",
            }}
          />
          <path
            d="m145 62.05-3 1c.33-.66.66-1.33 1-2 .79.15 2-.49 2 1"
            style={{
              fill: "#fdaf5a",
            }}
          />
          <path
            d="M140 61.05c.08-1.49 1.24-.85 2-1v1Z"
            className="templesOnly_svg__cls-2962"
          />
          <path
            d="M146.07 63.05v-1l1 1Z"
            className="templesOnly_svg__cls-2801"
          />
          <path
            d="M143 56.05h-1v-1h2v1Z"
            style={{
              fill: "#f4995b",
            }}
          />
          <path
            d="M144 55.05h-2c.08-1.49 1.24-.85 2-1Z"
            style={{
              fill: "#d67f43",
            }}
          />
          <path
            d="M143 59.05c-.34-.33-.67-.66-1-1h1Z"
            style={{
              fill: "#a13619",
            }}
          />
          <path
            d="m141 58.05-1 1v-1Z"
            style={{
              fill: "#801c00",
            }}
          />
          <path
            d="m153.07 51.05 1-1v1ZM151.07 47.05c.33 1 .67 2 1 3h-1.58c-.31-1.05-1.26-2.27.58-3"
            className="templesOnly_svg__cls-2825"
          />
          <path
            d="M85 83.05c.33-.66.66-1.33 1-2v-1c.75-.15 1.91.5 2-1h2c.66.67 1.33 1.34 2 2v1h-3l-.45-1.13c-.59.8-1.07 1.47-1.55 2.13Z"
            style={{
              fill: "#8c350a",
            }}
          />
          <path
            d="M94 78.05c.75.15 1.91-.49 2 1v1h-2c-.34-.33-.67-.66-1-1Z"
            style={{
              fill: "#9a3c01",
            }}
          />
          <path
            d="M92 82.05v-1h2v2h-1c-.3-.33-.63-.66-1-1"
            className="templesOnly_svg__cls-2969"
          />
          <ellipse
            cx={95.04}
            cy={80.55}
            className="templesOnly_svg__cls-2970"
            rx={1.41}
            ry={0.71}
          />
          <ellipse
            cx={89.04}
            cy={78.55}
            rx={1.41}
            ry={0.71}
            style={{
              fill: "#e6955f",
            }}
          />
          <path
            d="m92.94 79.16-.81-.7.31-.31.7.81Z"
            style={{
              fill: "#923404",
            }}
          />
          <path
            d="M88 78.05v1c-.09 1.5-1.25.85-2 1v-1l1-1Z"
            style={{
              fill: "#ce7c48",
            }}
          />
          <path
            d="M87 77.05v1c-1.39-.23-1.17-1-.52-2.1Z"
            className="templesOnly_svg__cls-2700"
          />
          <path
            d="M95 72.05h2v3h-1c-.34-.33-.67-.66-1-1Z"
            style={{
              fill: "#792402",
            }}
          />
          <path
            d="M97 76.05c-.09 1.5-1.25.85-2 1 .12-1.49 1.28-.85 2-1"
            className="templesOnly_svg__cls-2904"
          />
          <path
            d="M97 75.05v-1h1v2h-1Z"
            style={{
              fill: "#c76f39",
            }}
          />
          <path
            d="M95 74.05c.33.34.66.67 1 1-.3-.33-.63-.66-1-1"
            className="templesOnly_svg__cls-2700"
          />
          <ellipse
            cx={96.54}
            cy={71.05}
            rx={0.71}
            ry={1.41}
            style={{
              fill: "#712000",
            }}
          />
          <path
            d="m127 55.05 1 1c-1.5.09-.85 1.25-1 2v1h-1v-4Z"
            style={{
              fill: "#a65a32",
            }}
          />
          <path
            d="M126 58.05v2l-1.78-.82-.41.37c.39.49.79 1 1.19 1.45v1h-2a5.4 5.4 0 0 0-1-4z"
            style={{
              fill: "#681b02",
            }}
          />
          <path
            d="M122 58.05a5.4 5.4 0 0 1 1 4c-.76-.15-1.92.5-2-1v-2Z"
            className="templesOnly_svg__cls-1729"
          />
          <path
            d="M121 59.05v1l-1 1h-1v-3h1Z"
            style={{
              fill: "#894223",
            }}
          />
          <ellipse
            cx={124.54}
            cy={57.55}
            rx={2.12}
            ry={0.71}
            style={{
              fill: "#5f1800",
            }}
          />
          <path
            d="M123 55.05v1c-.34-.33-.67-.66-1-1Z"
            style={{
              fill: "#6f2001",
            }}
          />
          <path
            d="m116 61.05 3 1v3h-1l-1 1h-1c-.34-.33-.67-.66-1-1v-3Z"
            style={{
              fill: "#621b03",
            }}
          />
          <path
            d="M115 62.05v1h-1v-1c-.34-.33-.67-.66-1-1-.09-1.49-1.25-.85-2-1l-1-1h5z"
            style={{
              fill: "#a85b31",
            }}
          />
          <path
            d="M119 65.05v-4h1v4Z"
            style={{
              fill: "#752500",
            }}
          />
          <path
            d="M115 62.05v-2l1 1ZM119 58.05v2l-1-1v-1Z"
            className="templesOnly_svg__cls-2852"
          />
          <path
            d="M127 59.05v-1h1v3h-1Z"
            className="templesOnly_svg__cls-2776"
          />
          <path
            d="M128 61.05v-1h1c.33.67.66 1.34 1 2h-1c-.3-.33-.63-.66-1-1"
            style={{
              fill: "#f59856",
            }}
          />
          <path
            d="M130 62.05c-.34-.66-.67-1.33-1-2h2v2Z"
            className="templesOnly_svg__cls-2776"
          />
          <path
            d="M128 58.05h-1c.15-.75-.5-1.91 1-2Z"
            style={{
              fill: "#ce7c50",
            }}
          />
          <path
            d="M135 57.05v3h-1v-1c.19-.75-.46-1.91 1-2"
            style={{
              fill: "#9c4209",
            }}
          />
          <path
            d="M134 59.05v1l-1 1-1-1v-1z"
            style={{
              fill: "#b56233",
            }}
          />
          <path
            d="M135 60.05v-1h1a2.48 2.48 0 0 1 2 3 6.4 6.4 0 0 0-1 .06l.15-.15-.7-.81-.31.31a5.5 5.5 0 0 0 .86.65 5.6 5.6 0 0 1 0 .94h-2Z"
            style={{
              fill: "#a1491b",
            }}
          />
          <path
            d="M138 62.05a2.48 2.48 0 0 0-2-3l1-1h1c.33.34.66.67 1 1 .15.76-.5 1.92 1 2l-1 1Z"
            style={{
              fill: "#c26f2e",
            }}
          />
          <circle
            cx={139.54}
            cy={58.55}
            r={0.71}
            className="templesOnly_svg__cls-2962"
          />
          <path
            d="M139 58.05v1c-.34-.33-.67-.66-1-1Z"
            style={{
              fill: "#dc884b",
            }}
          />
          <circle
            cx={131.54}
            cy={60.55}
            r={0.71}
            style={{
              fill: "#d07e4c",
            }}
          />
          <path
            d="m143 53.05-.83-.67.83-.33Z"
            className="templesOnly_svg__cls-2557"
          />
          <path
            d="M54 92.05h2v1l-2 1h-1v-1Z"
            style={{
              fill: "#e18253",
            }}
          />
          <path d="M51 95.05v-1h2v1z" className="templesOnly_svg__cls-2875" />
          <path
            d="m55 88.05 1-1h2l-1 2-1 1h-1Z"
            style={{
              fill: "#943f17",
            }}
          />
          <path
            d="M55 90.05h1v2h-1Z"
            style={{
              fill: "#a34a1d",
            }}
          />
          <path
            d="M51 95.05h1l1 1v1h-3v-2Z"
            className="templesOnly_svg__cls-2996"
          />
          <ellipse
            cx={49.04}
            cy={96.55}
            rx={1.41}
            ry={0.71}
            style={{
              fill: "#a23509",
            }}
          />
          <path
            d="M47 97.05h-1c-.34-.33-.67-.66-1-1h2Z"
            style={{
              fill: "#e38645",
            }}
          />
          <path
            d="M47 96.05h-1l1.24-1 .76 1Z"
            style={{
              fill: "#f9985e",
            }}
          />
          <path
            d="M38 103.05h-1c-.76.15-1.92-.49-2 1-1.5-.08-.85-1.24-1-2h4Z"
            style={{
              fill: "#a73e09",
            }}
          />
          <path d="M36 102.05h-1l1-1Z" className="templesOnly_svg__cls-2747" />
          <path
            d="M34 102.05h-1v-1c.37.34.7.67 1 1"
            style={{
              fill: "#ea854e",
            }}
          />
          <path
            d="M45 101.05v-1h1l1-1h2v2c-.76.15-1.92-.49-2 1h-2Z"
            style={{
              fill: "#fab667",
            }}
          />
          <path
            d="M49 99.05h-1c.08-1.49 1.24-.85 2-1v1Z"
            className="templesOnly_svg__cls-2882"
          />
          <path d="M50 97.05h2v1h-2Z" className="templesOnly_svg__cls-3003" />
          <path d="m47 99.05-1 1Z" className="templesOnly_svg__cls-2882" />
          <path
            d="M45 100.05h-1l.67-.83Z"
            style={{
              fill: "#a0370d",
            }}
          />
          <circle
            cx={47.54}
            cy={96.55}
            r={0.71}
            className="templesOnly_svg__cls-2882"
          />
          <path
            d="M40 102.05h2c-.09 1.5-1.25.85-2 1Z"
            className="templesOnly_svg__cls-2888"
          />
          <path
            d="M40 103.05c.75-.15 1.91.5 2-1 .75-.15 1.91.5 2-1h1v2c-.76.15-1.92-.49-2 1h-3Z"
            style={{
              fill: "#fdbc75",
            }}
          />
          <path d="m74 85.05-1 1v-1Z" className="templesOnly_svg__cls-2891" />
          <path
            d="M82 85.05h1c.75-.15 1.91.5 2-1h5c-.09 1.5-1.25.85-2 1l-1 1h-1l-2 1c-.09-1.49-1.25-.85-2-1Z"
            style={{
              fill: "#f6aa58",
            }}
          />
          <path
            d="M78 87.05h1l1 1a14.8 14.8 0 0 1-5 2c-.34-.33-.67-.66-1-1l1-1h1c.79-.15 2 .5 2-1"
            className="templesOnly_svg__cls-3007"
          />
          <path
            d="m68 89.05 1 1v1h-1l-.33-.83-.67.83h-1l-1-1 1-1z"
            style={{
              fill: "#942b03",
            }}
          />
          <path
            d="M74 89.05c.33.34.66.67 1 1v1h-3v-2z"
            className="templesOnly_svg__cls-3009"
          />
          <path
            d="M70 85.05h1v2h-1c-.34-.33-.67-.66-1-1Z"
            style={{
              fill: "#d87647",
            }}
          />
          <path
            d="M69 88.05h-2v-1l1-1h1z"
            style={{
              fill: "#e38348",
            }}
          />
          <path
            d="M72 90.05v1h-2v-1z"
            style={{
              fill: "#f2964e",
            }}
          />
          <path
            d="M78 87.05c-.09 1.5-1.25.85-2 1v-1Z"
            className="templesOnly_svg__cls-2891"
          />
          <path
            d="M79 87.05c.08-1.49 1.24-.85 2-1 0 1.5-1.21.85-2 1"
            style={{
              fill: "#ec964d",
            }}
          />
          <path d="M71 86.05v-1h2v1z" className="templesOnly_svg__cls-2889" />
          <path
            d="M85 84.05c-.09 1.5-1.25.85-2 1v-1z"
            className="templesOnly_svg__cls-961"
          />
          <circle
            cx={69.54}
            cy={90.55}
            r={0.71}
            className="templesOnly_svg__cls-3014"
          />
          <path d="M72 90.05h-1l1-1Z" className="templesOnly_svg__cls-3014" />
          <path d="m75 88.05-1 1v-1Z" className="templesOnly_svg__cls-2891" />
          <path d="M74 88.05v1h-1Z" className="templesOnly_svg__cls-3014" />
          <circle
            cx={67.54}
            cy={88.55}
            r={0.71}
            className="templesOnly_svg__cls-3014"
          />
          <path
            d="M76 87.05v1h-1ZM69 88.05v-1h1ZM71 86.05h1l-1 1Z"
            className="templesOnly_svg__cls-3014"
          />
          <path d="M82 85.05v1h-1Z" className="templesOnly_svg__cls-961" />
          <path
            d="M82 83.05c.33.34.66.67 1 1-.3-.33-.63-.66-1-1"
            className="templesOnly_svg__cls-2915"
          />
          <path d="M80 83.05v-1h1Z" className="templesOnly_svg__cls-961" />
          <path
            d="M69 86.05h-1v-3h2v2Z"
            className="templesOnly_svg__cls-3015"
          />
          <path
            d="M111 70.05h1l1-1 1-1h2l-.86 1.5.86 1.5v1h-3c-.76.15-1.92-.49-2 1h-1c-.34-.33-.67-.66-1-1l1-1Z"
            style={{
              fill: "#9d400d",
            }}
          />
          <path
            d="m110 71.05-1 1v-1ZM111 70.05l-1 1ZM113 69.05l-1 1v-1Z"
            className="templesOnly_svg__cls-3017"
          />
          <circle
            cx={112.54}
            cy={68.55}
            r={0.71}
            style={{
              fill: "#f29052",
            }}
          />
          <circle
            cx={109.54}
            cy={68.55}
            r={0.71}
            style={{
              fill: "#a54206",
            }}
          />
          <path
            d="M109 68.05v1c-.34-.33-.67-.66-1-1Z"
            className="templesOnly_svg__cls-2759"
          />
          <path
            d="m105 74.05 2-2v1l-1 1Z"
            className="templesOnly_svg__cls-2898"
          />
          <path
            d="M110 68.05h-1l.67-.83Z"
            style={{
              fill: "#902c00",
            }}
          />
          <path
            d="M107 73.05v-1h1ZM109 71.05v1h-1Z"
            className="templesOnly_svg__cls-2759"
          />
          <path
            d="m103 77.05 2-1v2l-1 1h-1Z"
            style={{
              fill: "#fec48c",
            }}
          />
          <path
            d="M105 74.05h1l1 1v1h-2Z"
            className="templesOnly_svg__cls-3022"
          />
          <path
            d="M96 80.05v-1h2c0 1.5-1.21.85-2 1"
            className="templesOnly_svg__cls-2970"
          />
          <path
            d="M96 80.05c.75-.15 1.91.5 2-1 .72-.22 1.44-.47 2.17-.66s1.22-.23 1.83-.34l1 1v1c-1 .39-2.54-.92-3 1h-1c-.76.15-1.92-.49-2 1h-1z"
            className="templesOnly_svg__cls-3023"
          />
          <path
            d="m103 79.05-1-1v-1h1Z"
            className="templesOnly_svg__cls-3024"
          />
          <path
            d="M113 69.05v-3h2v1l-1 1Z"
            className="templesOnly_svg__cls-1273"
          />
          <path
            d="M114 63.05h1v2c-1.46-.05-.81-1.24-1-2M115 65.05c.33.34.66.67 1 1h-1Z"
            className="templesOnly_svg__cls-2852"
          />
          <path
            d="M114 62.05v1l-.83-.67Z"
            style={{
              fill: "#cf8041",
            }}
          />
          <path d="M85 84.05h-1l1-1Z" className="templesOnly_svg__cls-2915" />
          <path
            d="M47 113.05v-2h1v1l1 1h1l-1 1h-2Z"
            style={{
              fill: "#5c0e00",
            }}
          />
          <path
            d="M47 110.05h-2v-2h2z"
            style={{
              fill: "#e48f54",
            }}
          />
          <path
            d="M44 113.05v-2h2Z"
            style={{
              fill: "#d77039",
            }}
          />
          <path
            d="M47 114.05h2v1h-3v-1Z"
            style={{
              fill: "#b25227",
            }}
          />
          <path d="M47 114.05h-1l1-1Z" className="templesOnly_svg__cls-3030" />
          <path
            d="M48 111.05h-1v-1c.37.34.7.67 1 1"
            style={{
              fill: "#580800",
            }}
          />
          <circle
            cx={45.54}
            cy={110.55}
            r={0.71}
            style={{
              fill: "#ee905b",
            }}
          />
          <circle
            cx={44.54}
            cy={110.55}
            r={0.71}
            style={{
              fill: "#a4400a",
            }}
          />
          <path
            d="M62 85.05h-1c.15-.75-.5-1.91 1-2z"
            className="templesOnly_svg__cls-2789"
          />
          <path
            d="M62 85.05v-1c.33.34.66.67 1 1l-.68.83Z"
            style={{
              fill: "#cc7d4b",
            }}
          />
          <path
            d="M56 91.05v-1l1-1c.33.34.66.67 1 1l-1 1Z"
            style={{
              fill: "#ab5220",
            }}
          />
          <path
            d="m57 91.05 1-1h1v1l-1 1h-1Z"
            style={{
              fill: "#e98f54",
            }}
          />
          <ellipse
            cx={60.04}
            cy={90.55}
            className="templesOnly_svg__cls-3037"
            rx={1.41}
            ry={0.71}
          />
          <path d="M61 91.05v-1l1-1v2Z" className="templesOnly_svg__cls-3038" />
          <path
            d="M63 89.05c.15-.75-.5-1.91 1-2 .33.67.66 1.34 1 2z"
            style={{
              fill: "#ef934a",
            }}
          />
          <circle
            cx={62.54}
            cy={89.55}
            r={0.71}
            style={{
              fill: "#e1803f",
            }}
          />
          <path
            d="M65 83.05h2v1l-2 1Z"
            style={{
              fill: "#681b04",
            }}
          />
          <ellipse
            cx={67.54}
            cy={85.05}
            rx={0.71}
            ry={1.41}
            style={{
              fill: "#a04313",
            }}
          />
          <path
            d="M65 89.05c-.34-.66-.67-1.33-1-2h3v2z"
            style={{
              fill: "#c46435",
            }}
          />
          <path
            d="M67 87.05h-2v-2l2-1z"
            style={{
              fill: "#721b01",
            }}
          />
          <path
            d="M143 65.05c.08-1.49 1.24-.85 2-1v2h-1Z"
            style={{
              fill: "#fab267",
            }}
          />
          <path
            d="M144 68.05v1l-1 1h-1c-.09-1.49-1.25-.85-2-1v-1z"
            style={{
              fill: "#c77532",
            }}
          />
          <path
            d="M143 68.05h-1l-1-1v-1l1-1h1z"
            style={{
              fill: "#faaa60",
            }}
          />
          <path
            d="M144 71.05v2c-1.5-.08-.85-1.24-1-2Z"
            style={{
              fill: "#f7b277",
            }}
          />
          <path
            d="M144 71.05h-1v-1l1-1Z"
            style={{
              fill: "#fecd8f",
            }}
          />
          <path
            d="M143 68.05v-1l1 1Z"
            style={{
              fill: "#be752a",
            }}
          />
          <path
            d="M143 66.05v-1l1 1Z"
            style={{
              fill: "#fec57a",
            }}
          />
          <path
            d="M143 70.05v1c.15.76-.5 1.92 1 2v1h-2a5.4 5.4 0 0 0-1-4z"
            style={{
              fill: "#ea935e",
            }}
          />
          <path
            d="M141 70.05a5.4 5.4 0 0 1 1 4 6.4 6.4 0 0 0-1 .06l.15-.15-.7-.81-.31.31a5.5 5.5 0 0 0 .86.65 5.6 5.6 0 0 1 0 .94h-1l-1 1h-1c-.16-.75.49-1.91-1-2-.76-.15-1.92.5-2-1v-2h2v1l.32.83c.23-.27.45-.55.68-.83h2v-2Z"
            style={{
              fill: "#8f350d",
            }}
          />
          <path
            d="m137 79.05-1 1v-3c.33-1 .66-2 1-3 1.49.09.84 1.25 1 2v1c-1.46.09-.81 1.25-1 2"
            className="templesOnly_svg__cls-1102"
          />
          <path
            d="M137 79.05c.15-.75-.5-1.91 1-2v1Z"
            className="templesOnly_svg__cls-2671"
          />
          <path
            d="M140 75.05h1l-1 1Z"
            style={{
              fill: "#c26a3e",
            }}
          />
          <path
            d="M140 75.05v1h-1Z"
            style={{
              fill: "#640d00",
            }}
          />
          <circle
            cx={141.54}
            cy={74.55}
            r={0.71}
            style={{
              fill: "#d47542",
            }}
          />
          <path
            d="M43 108.05h-3v-1h4Z"
            style={{
              fill: "#bf7231",
            }}
          />
          <path
            d="M42 107.05h-2l-1-1h3Z"
            style={{
              fill: "#fbb163",
            }}
          />
          <path
            d="M40 106.05h-2c.08-1.49 1.24-.85 2-1Z"
            style={{
              fill: "#e49a43",
            }}
          />
          <path
            d="m43 108.05 1-1h1v2h-1Z"
            style={{
              fill: "#924207",
            }}
          />
          <circle
            cx={44.54}
            cy={109.55}
            r={0.71}
            className="templesOnly_svg__cls-2917"
          />
          <path
            d="M41 108.05h1l-.68.83Z"
            className="templesOnly_svg__cls-2917"
          />
          <path
            d="M40 106.05v-2h1l1 1v1Z"
            style={{
              fill: "#eca454",
            }}
          />
          <path
            d="M35 104.05c.08-1.49 1.24-.85 2-1 0 1.5-1.21.85-2 1"
            className="templesOnly_svg__cls-2953"
          />
          <path
            d="M151.9 47.52c.36-1.27.53-1.87.71-2.47a8.7 8.7 0 0 1 .43 1.4c.02.15-.35.35-1.14 1.07"
            className="templesOnly_svg__cls-2812"
          />
          <path
            d="M139 64.05h2v1l-1 1v1h-1l-.4-.87-1.6.87v-2c.79-.15 2 .5 2-1"
            style={{
              fill: "#e19946",
            }}
          />
          <path
            d="M139 64.05c-.09 1.5-1.25.85-2 1v-1l1-1h1Z"
            style={{
              fill: "#f9b667",
            }}
          />
          <path
            d="M139 63.05h-2v-1h2Z"
            style={{
              fill: "#ea9e51",
            }}
          />
          <path
            d="M141 65.05v-1c.33.34.66.67 1 1Z"
            style={{
              fill: "#c47321",
            }}
          />
          <path
            d="M90 84.05h-2v-1l1-1h3c.33.34.66.67 1 1v1z"
            style={{
              fill: "#f4a85e",
            }}
          />
          <path
            d="m89 82.05-1 1h-1c.48-.66 1-1.33 1.55-2.13Z"
            className="templesOnly_svg__cls-3067"
          />
          <ellipse
            cx={86.04}
            cy={83.55}
            className="templesOnly_svg__cls-3067"
            rx={1.41}
            ry={0.71}
          />
          <path
            d="M96 81.05v1l-1 1h-1v-2Z"
            style={{
              fill: "#febb60",
            }}
          />
          <circle
            cx={93.54}
            cy={83.55}
            r={0.71}
            className="templesOnly_svg__cls-3069"
          />
          <path
            d="M127 59.05v3h-2v-1l1-1v-1Z"
            className="templesOnly_svg__cls-3070"
          />
          <path
            d="m126 60.05-1 1c-.4-.48-.8-1-1.19-1.45l.41-.37Z"
            style={{
              fill: "#6f1d0e",
            }}
          />
          <ellipse
            cx={124.04}
            cy={62.55}
            className="templesOnly_svg__cls-3070"
            rx={1.41}
            ry={0.71}
          />
          <path
            d="M123 62.05v1c-.76.15-1.92-.49-2 1v1h-1v-4h1c.12 1.5 1.28.85 2 1"
            style={{
              fill: "#a64f1d",
            }}
          />
          <path
            d="M121 61.05h-1l1-1Z"
            style={{
              fill: "#bc6e43",
            }}
          />
          <path
            d="M115 66.05h2v2h-1c-.34-.33-.67-.66-1-1Z"
            style={{
              fill: "#bd6537",
            }}
          />
          <path
            d="M118 65.05h1v2h-1z"
            style={{
              fill: "#bc6034",
            }}
          />
          <path
            d="M118 65.05v1h-1Z"
            style={{
              fill: "#782a06",
            }}
          />
          <circle
            cx={119.54}
            cy={65.55}
            r={0.71}
            style={{
              fill: "#d27841",
            }}
          />
          <path
            d="M127 62.05v-1h1c.33.34.66.67 1 1-.09 1.5-1.25.85-2 1Z"
            style={{
              fill: "#e6864b",
            }}
          />
          <path
            d="M127 63.05c.75-.15 1.91.5 2-1h2v1l-2 1h-2Z"
            className="templesOnly_svg__cls-3079"
          />
          <path d="M131 61.05h1l-1 1Z" className="templesOnly_svg__cls-3080" />
          <path
            d="m131 62.05 1-1h1l1-1h1v3l-1 1h-3z"
            style={{
              fill: "#832a07",
            }}
          />
          <path
            d="M133 61.05h-1v-1Z"
            style={{
              fill: "#c7734a",
            }}
          />
          <path
            d="m134 64.05 1-1h2v3h-1v-1c-.34-.33-.67-.66-1-1Z"
            style={{
              fill: "#d88c4e",
            }}
          />
          <path
            d="m136.94 62.16-.81-.7.31-.31.7.81Z"
            style={{
              fill: "#822a02",
            }}
          />
          <path
            d="m53 96.05-1-1h1l1-1 2-1c.33.34.66.67 1 1v1c-.76.15-1.92-.49-2 1Z"
            style={{
              fill: "#9a3504",
            }}
          />
          <path
            d="M57 91.05v1l-1 1v-2Z"
            style={{
              fill: "#d17740",
            }}
          />
          <path d="m54 94.05-1 1v-1Z" className="templesOnly_svg__cls-2996" />
          <path
            d="M52 98.05v-1h3l1-1h2v1l-1 1-3 1c0-1.49-1.21-.85-2-1"
            style={{
              fill: "#f5ad61",
            }}
          />
          <ellipse
            cx={54.04}
            cy={96.55}
            className="templesOnly_svg__cls-3003"
            rx={1.41}
            ry={0.71}
          />
          <path
            d="M45 103.05v-1h2c.33.34.66.67 1 1h-1l-2 1Z"
            style={{
              fill: "#e7a459",
            }}
          />
          <path
            d="M48 103.05c-.34-.33-.67-.66-1-1 .08-1.49 1.24-.85 2-1v1ZM49 101.05v-1h1Z"
            className="templesOnly_svg__cls-3089"
          />
          <circle
            cx={49.54}
            cy={99.55}
            r={0.71}
            style={{
              fill: "#feca73",
            }}
          />
          <path d="M50 100.05v-2h1v2Z" className="templesOnly_svg__cls-3089" />
          <path
            d="M51 100.05v-2h1c.75.15 1.91-.49 2 1h-1l-1 1Z"
            style={{
              fill: "#fec06f",
            }}
          />
          <path
            d="M45 103.05v1l-2 1v-1c.12-1.49 1.28-.85 2-1"
            className="templesOnly_svg__cls-3092"
          />
          <path
            d="M43 104.05v1h-1l-1-1Z"
            style={{
              fill: "#de9848",
            }}
          />
          <path
            d="M90 84.05h1l1 1v1h-2l-2 1v-2c.79-.15 2 .5 2-1"
            style={{
              fill: "#df9641",
            }}
          />
          <path
            d="m84 87.05 2-1v2h-1l-2 1-1-1v-1Z"
            style={{
              fill: "#e59640",
            }}
          />
          <path
            d="M86 87.05v-1h2v1z"
            style={{
              fill: "#d5852e",
            }}
          />
          <path
            d="M84 87.05h-2v-1c.79.15 2-.49 2 1"
            style={{
              fill: "#febb63",
            }}
          />
          <path
            d="M88 86.05h-1l1-1Z"
            style={{
              fill: "#e59b44",
            }}
          />
          <circle
            cx={87.54}
            cy={83.55}
            r={0.71}
            style={{
              fill: "#f2aa59",
            }}
          />
          <path
            d="M75 91.05v-1a14.8 14.8 0 0 0 5-2h1v2h-1l-1 1h-1c-.76.15-1.92-.49-2 1h-1Z"
            className="templesOnly_svg__cls-3100"
          />
          <path
            d="M81 88.05h-1l-1-1c.75-.15 1.91.5 2-1h1v2Z"
            style={{
              fill: "#feb36a",
            }}
          />
          <path
            d="M69 91.05h3v1l-3 1-1 1a5.4 5.4 0 0 0-4 1c-.34-.33-.67-.66-1-1v-1h2l1-1c.75-.15 1.91.5 2-1Z"
            style={{
              fill: "#f79a51",
            }}
          />
          <path
            d="M65 93.05h-2c.33-1 .66-2 1-3h1l1 1v1Z"
            style={{
              fill: "#962d01",
            }}
          />
          <path
            d="M66 92.05v-1h2c0 1.5-1.21.85-2 1M65 90.05h-1v-1h2Z"
            className="templesOnly_svg__cls-3104"
          />
          <path
            d="M68 91.05h-1l.67-.83Z"
            style={{
              fill: "#912900",
            }}
          />
          <path
            d="M72 92.05v-1h2v2h-1Z"
            style={{
              fill: "#e19235",
            }}
          />
          <circle
            cx={74.54}
            cy={91.55}
            r={0.71}
            className="templesOnly_svg__cls-2891"
          />
          <path
            d="M70 87.05h-1v-1c.37.34.7.67 1 1"
            style={{
              fill: "#ef8b5a",
            }}
          />
          <path d="M67 87.05v-1h1Z" className="templesOnly_svg__cls-3015" />
          <path
            d="M127 64.05h2v1l-1 1c-.76.15-1.92-.49-2 1-.76.15-1.92-.49-2 1h-1l-1 1h-1c-.76.15-1.92-.49-2 1v1h-3l-.86-1.5.86-1.5h1l1-1h1l1.68 1 2.32-3h1c.75-.15 1.91.5 2-1Z"
            style={{
              fill: "#892705",
            }}
          />
          <path
            d="M110 73.05h3c.75-.15 1.91.5 2-1h1c.75.15 1.91-.49 2 1h-1l-1 1-1 1h-2l-1 1h-1c-.47-1.92-2-.61-3-1a8 8 0 0 1 .76-1c.42-.36.86-.66 1.24-1"
            className="templesOnly_svg__cls-3109"
          />
          <path
            d="M118 73.05c-.09-1.49-1.25-.85-2-1v-1h3l1-1h2v2h-2l-1 1Z"
            className="templesOnly_svg__cls-3009"
          />
          <path
            d="M110 73.05c-.42.34-.86.64-1.24 1a8 8 0 0 0-.76 1h-1l-1-1 1-1 1-1h1c.37.34.7.67 1 1"
            className="templesOnly_svg__cls-3017"
          />
          <path
            d="M115 72.05c-.09 1.5-1.25.85-2 1v-1Z"
            className="templesOnly_svg__cls-3009"
          />
          <path
            d="M113 72.05v1h-2c.12-1.49 1.28-.85 2-1"
            className="templesOnly_svg__cls-3017"
          />
          <path
            d="M115 67.05c.33.34.66.67 1 1h-2Z"
            style={{
              fill: "#f99960",
            }}
          />
          <path
            d="M103 80.05v-1h1v2h-1ZM104 79.05l1-1Z"
            className="templesOnly_svg__cls-3024"
          />
          <path d="M105 78.05v-1h1Z" className="templesOnly_svg__cls-3022" />
          <circle
            cx={105.54}
            cy={76.55}
            r={0.71}
            className="templesOnly_svg__cls-2902"
          />
          <path
            d="M106 77.05v-1h1l1-1c1 .39 2.53-.92 3 1l-1 1z"
            style={{
              fill: "#fcbd68",
            }}
          />
          <path d="m108 75.05-1 1v-1Z" className="templesOnly_svg__cls-3109" />
          <path
            d="M103 80.05v1h-3c.5-1.92 2.05-.61 3-1"
            style={{
              fill: "#df8f37",
            }}
          />
          <path
            d="M97 82.05c.08-1.49 1.24-.85 2-1v2h-1Z"
            className="templesOnly_svg__cls-3113"
          />
          <path
            d="m97 82.05 1 1h-2v-1Z"
            style={{
              fill: "#d78429",
            }}
          />
          <circle
            cx={99.54}
            cy={81.55}
            r={0.71}
            style={{
              fill: "#d18025",
            }}
          />
          <path
            d="M48 111.05c-.34-.33-.67-.66-1-1v-1h2c.33.34.66.67 1 1v1l-1 1h-1Z"
            className="templesOnly_svg__cls-3030"
          />
          <circle
            cx={49.54}
            cy={112.55}
            r={0.71}
            className="templesOnly_svg__cls-2221"
          />
          <path
            d="M49 112.05v1l-1-1Z"
            style={{
              fill: "#4f0a00",
            }}
          />
          <path
            d="M49 109.05h-2v-1l1-1 1 1Z"
            style={{
              fill: "#9e4111",
            }}
          />
          <path
            d="M45 108.05v-2h1v2Z"
            style={{
              fill: "#c27c38",
            }}
          />
          <path
            d="M46 108.05v-1l1 1Z"
            style={{
              fill: "#feb575",
            }}
          />
          <path d="M62 108.05v-1h3v2Z" className="templesOnly_svg__cls-3120" />
          <path
            d="M65 109.05v-1h2v1Z"
            style={{
              fill: "#a16946",
            }}
          />
          <path
            d="m56 93.05 1-1h1l.32.83.68-.83h2v1l-1 1h-3c-.3-.33-.63-.66-1-1"
            style={{
              fill: "#94310b",
            }}
          />
          <path d="m58 92.05 1-1v1Z" className="templesOnly_svg__cls-3037" />
          <path
            d="M59 92.05v-1h3l-1 1Z"
            className="templesOnly_svg__cls-3123"
          />
          <path
            d="m61 92.05 1-1v-1h2c-.34 1-.67 2-1 3h-2Z"
            style={{
              fill: "#9a3203",
            }}
          />
          <circle
            cx={63.54}
            cy={89.55}
            r={0.71}
            className="templesOnly_svg__cls-3038"
          />
          <path
            d="M140 68.05v1l-1 1h-4c.33-.66.66-1.33 1-2v-1h1l.25 2 1.75-1Z"
            style={{
              fill: "#d9934d",
            }}
          />
          <path
            d="m139 70.05 1-1c.75.15 1.91-.49 2 1z"
            style={{
              fill: "#8a3507",
            }}
          />
          <path
            d="M140 68.05h-1v-1h2v1Z"
            style={{
              fill: "#d0863e",
            }}
          />
          <path
            d="M141 68.05v-1l1 1ZM141 65.05h1l-1 1h-1Z"
            className="templesOnly_svg__cls-3128"
          />
          <circle
            cx={140.54}
            cy={66.55}
            r={0.71}
            style={{
              fill: "#faac63",
            }}
          />
          <path
            d="M137 74.05c-.34 1-.67 2-1 3L134 76l-2 1.08v-2h1c1.49-.08.84-1.24 1-2h1c.12 1.47 1.28.82 2 .97"
            className="templesOnly_svg__cls-3130"
          />
          <path
            d="M139 70.05h1v2h-3v-1l1-1Z"
            style={{
              fill: "#721d00",
            }}
          />
          <path
            d="m138 70.05-1 1h-2v-1ZM135 73.05h-1v-1l1-1Z"
            className="templesOnly_svg__cls-3132"
          />
          <path
            d="m140.94 74.16-.81-.7.31-.31.7.81Z"
            style={{
              fill: "#771a00",
            }}
          />
          <path
            d="M137 72.05h1c-.23.28-.45.56-.68.83Z"
            className="templesOnly_svg__cls-1058"
          />
          <path
            d="m132 77.05 2-1.05 2 1.08v1c-1.5.09-.85 1.25-1 2h-2c-.16-.75.49-1.91-1-2Z"
            style={{
              fill: "#f6bd86",
            }}
          />
          <path
            d="M135 80.05c.15-.75-.5-1.91 1-2v2Z"
            className="templesOnly_svg__cls-3130"
          />
          <path
            d="M45 106.05v1h-3v-2h1c.12 1.5 1.28.85 2 1"
            style={{
              fill: "#fab672",
            }}
          />
          <path
            d="M139 67.05v1l-1.75 1-.25-2 1.6-.87Z"
            style={{
              fill: "#f0ae62",
            }}
          />
          <circle
            cx={136.54}
            cy={66.55}
            r={0.71}
            style={{
              fill: "#bc782d",
            }}
          />
          <path
            d="M137 64.05v-1h1Z"
            style={{
              fill: "#fec27b",
            }}
          />
          <path
            d="m92 85.05-1-1h2v1Z"
            style={{
              fill: "#d98937",
            }}
          />
          <circle
            cx={94.54}
            cy={83.55}
            r={0.71}
            style={{
              fill: "#d98a2f",
            }}
          />
          <path d="M96 82.05v1h-1Z" className="templesOnly_svg__cls-2969" />
          <path
            d="M94 84.05h1l1-1h3v1l-2 2h-3c-.34-.33-.67-.66-1-1v-1Z"
            style={{
              fill: "#feaf60",
            }}
          />
          <path
            d="M127 62.05v1h-2v-1Z"
            style={{
              fill: "#d87b47",
            }}
          />
          <path
            d="M123 63.05h2v1h-2Z"
            style={{
              fill: "#df8353",
            }}
          />
          <ellipse
            cx={122.04}
            cy={64.55}
            rx={1.41}
            ry={0.71}
            style={{
              fill: "#f4925b",
            }}
          />
          <path
            d="M123 64.05h-2c.08-1.49 1.24-.85 2-1Z"
            className="templesOnly_svg__cls-3145"
          />
          <path
            d="M120 66.05v-1h1Z"
            style={{
              fill: "#e08148",
            }}
          />
          <path d="m118 67.05-1 1v-1Z" className="templesOnly_svg__cls-3147" />
          <circle
            cx={117.54}
            cy={66.55}
            r={0.71}
            style={{
              fill: "#cd7648",
            }}
          />
          <path
            d="m120 66.05 1-1h2l-2.32 3-1.68-1v-1Z"
            className="templesOnly_svg__cls-3149"
          />
          <path
            d="M129 65.05v-1l2-1v2Z"
            className="templesOnly_svg__cls-3150"
          />
          <circle
            cx={126.54}
            cy={63.55}
            r={0.71}
            className="templesOnly_svg__cls-3080"
          />
          <path
            d="M136 65.05v1a4.62 4.62 0 0 0-4 2h-1c-.34-.33-.67-.66-1-1v-1l1-1c.75-.15 1.91.5 2-1h2c.37.34.7.67 1 1"
            style={{
              fill: "#f1a65f",
            }}
          />
          <path
            d="M133 64.05c-.09 1.5-1.25.85-2 1v-1Z"
            className="templesOnly_svg__cls-3079"
          />
          <path
            d="M136 65.05c-.34-.33-.67-.66-1-1 .37.34.7.67 1 1"
            style={{
              fill: "#feb075",
            }}
          />
          <path
            d="M57 94.05h3v1h-3Z"
            style={{
              fill: "#ac4b1c",
            }}
          />
          <path
            d="M57 96.05h-2c.08-1.49 1.24-.85 2-1Z"
            className="templesOnly_svg__cls-2996"
          />
          <path
            d="M51 100.05h1l1-1h1l3-1v1l-3 2c-.16.76.49 1.92-1 2v-2.59l-2 1.59h-2v-1l1-1Z"
            className="templesOnly_svg__cls-3154"
          />
          <path
            d="M59 95.05h1v2h-2v-1Z"
            className="templesOnly_svg__cls-3155"
          />
          <path
            d="m59 95.05-1 1h-1v-1Z"
            style={{
              fill: "#ee9c4e",
            }}
          />
          <path
            d="m57 98.05 1-1v1ZM55 96.05h1l-1 1Z"
            className="templesOnly_svg__cls-3155"
          />
          <path
            d="M49 102.05h1v3h-1c-.09-1.49-1.25-.85-2-1v-1h1Z"
            style={{
              fill: "#fbb25f",
            }}
          />
          <path
            d="M47 103.05v1l-1 2h-1v-2Z"
            className="templesOnly_svg__cls-3092"
          />
          <path d="m53 99.05-1 1Z" className="templesOnly_svg__cls-3089" />
          <path
            d="M45 104.05v2c-.76-.15-1.92.5-2-1Z"
            style={{
              fill: "#feca89",
            }}
          />
          <path
            d="M87 87.05h1l2-1v2h-3Z"
            style={{
              fill: "#faa958",
            }}
          />
          <ellipse
            cx={91.04}
            cy={86.55}
            rx={1.41}
            ry={0.71}
            style={{
              fill: "#feb96b",
            }}
          />
          <path
            d="M93 85.05c.33.34.66.67 1 1h-2v-1Z"
            className="templesOnly_svg__cls-3007"
          />
          <path
            d="m83 89.05 2-1v2h-3v-1Z"
            style={{
              fill: "#feac5f",
            }}
          />
          <path
            d="M83 89.05h-2v-1h1Z"
            style={{
              fill: "#d6852f",
            }}
          />
          <path
            d="M87 87.05v2h-1v-2Z"
            style={{
              fill: "#f6a654",
            }}
          />
          <circle
            cx={85.54}
            cy={88.55}
            r={0.71}
            style={{
              fill: "#feb366",
            }}
          />
          <path
            d="M75 92.05h1l1 1c-.47 1.93-2 .62-3 1v-1Z"
            style={{
              fill: "#feb45e",
            }}
          />
          <path
            d="M76 92.05c.08-1.49 1.24-.85 2-1v1z"
            className="templesOnly_svg__cls-3009"
          />
          <path
            d="M80 90.05h2l-1 1h-1Z"
            style={{
              fill: "#feb45a",
            }}
          />
          <path d="M80 90.05v2h-1v-1Z" className="templesOnly_svg__cls-3009" />
          <circle
            cx={78.54}
            cy={91.55}
            r={0.71}
            style={{
              fill: "#feb671",
            }}
          />
          <circle
            cx={81.54}
            cy={89.55}
            r={0.71}
            className="templesOnly_svg__cls-3168"
          />
          <path
            d="M60 96.05v-2h3c.33.34.66.67 1 1l-1 1Z"
            style={{
              fill: "#f9ae65",
            }}
          />
          <path
            d="m63 96.05 1-1a5.4 5.4 0 0 1 4-1l-1 1a5.35 5.35 0 0 1-4 1"
            className="templesOnly_svg__cls-3038"
          />
          <path
            d="m69 93.05 3-1v1l-3 1Z"
            style={{
              fill: "#e7903d",
            }}
          />
          <path d="M69 93.05v1h-1Z" className="templesOnly_svg__cls-3038" />
          <circle
            cx={62.54}
            cy={93.55}
            r={0.71}
            className="templesOnly_svg__cls-3038"
          />
          <path d="m65 93.05 1-1Z" className="templesOnly_svg__cls-3038" />
          <path
            d="M74 93.05v1c-.34-.33-.67-.66-1-1ZM75 92.05l-1 1v-1Z"
            className="templesOnly_svg__cls-3171"
          />
          <path
            d="M72 93.05v-1l1 1Z"
            style={{
              fill: "#d7832c",
            }}
          />
          <path
            d="m131 65.05-1 1h-2l1-1Z"
            className="templesOnly_svg__cls-3079"
          />
          <path
            d="M123 68.05h3l-1 1h-2Z"
            className="templesOnly_svg__cls-3173"
          />
          <path
            d="M121 70.05h-2c.08-1.49 1.24-.85 2-1Z"
            className="templesOnly_svg__cls-3147"
          />
          <path
            d="M126 68.05h-2c.08-1.49 1.24-.85 2-1Z"
            className="templesOnly_svg__cls-3149"
          />
          <path
            d="M126 67.05c.08-1.49 1.24-.85 2-1v1ZM124 64.05h2c-.09 1.5-1.25.85-2 1Z"
            className="templesOnly_svg__cls-3150"
          />
          <path d="M119 70.05h1l-1 1Z" className="templesOnly_svg__cls-3174" />
          <circle
            cx={121.54}
            cy={69.55}
            r={0.71}
            className="templesOnly_svg__cls-3174"
          />
          <path d="M123 68.05v1h-1Z" className="templesOnly_svg__cls-3149" />
          <circle
            cx={123.54}
            cy={64.55}
            r={0.71}
            className="templesOnly_svg__cls-3145"
          />
          <path
            d="M118 73.05h1v1l-1 1h-3l1-1 1-1Z"
            className="templesOnly_svg__cls-3175"
          />
          <path
            d="M111 76.05h2v1c-.72-.15-1.88.5-2-1"
            style={{
              fill: "#d0812f",
            }}
          />
          <path d="M113 75.05h2v1h-2Z" className="templesOnly_svg__cls-3175" />
          <path d="M113 75.05v1h-1Z" className="templesOnly_svg__cls-3177" />
          <path d="m117 73.05-1 1Z" className="templesOnly_svg__cls-3009" />
          <path
            d="M122 72.05v-1h1c.33.34.66.67 1 1h1c.24 1.38 1 1.22 1.88.63.35-.24.74-.42 1.12-.63l.32.83c.23-.27.45-.55.68-.83l1-1c.75-.15 1.91.5 2-1h1v2l-1 1-1 1c-2.38-.46-4 1.3-6 2h-4v-1l1-1 1.9-.33-.08-.67H122Z"
            className="templesOnly_svg__cls-3174"
          />
          <path
            d="M119 74.05v-1l1-1c.33.34.66.67 1 1v1Z"
            style={{
              fill: "#de8b39",
            }}
          />
          <path
            d="M121 73.05c-.34-.33-.67-.66-1-1h2v1Z"
            className="templesOnly_svg__cls-3179"
          />
          <path
            d="M123 71.05h-1v-1c.37.34.7.67 1 1"
            style={{
              fill: "#feb460",
            }}
          />
          <path
            d="M106 77.05h1v2l-1 1-1 1h-1v-2l1-1Z"
            style={{
              fill: "#d89347",
            }}
          />
          <path
            d="M103 81.05h1v3h-2v-2Z"
            style={{
              fill: "#fec082",
            }}
          />
          <path
            d="M111 76.05c.08 1.5 1.24.85 2 1h1c-.47 1.93-2 .62-3 1h-1v-1Z"
            className="templesOnly_svg__cls-3109"
          />
          <path
            d="M107 79.05v-2h1c.33.34.66.67 1 1l-1 1Z"
            style={{
              fill: "#f7ad5e",
            }}
          />
          <path
            d="M109 78.05c-.34-.33-.67-.66-1-1h2v1Z"
            style={{
              fill: "#e29649",
            }}
          />
          <ellipse
            cx={101.04}
            cy={81.55}
            className="templesOnly_svg__cls-3023"
            rx={1.41}
            ry={0.71}
          />
          <path
            d="M102 82.05v-1h1ZM100 82.05h2v1h-3v-1Z"
            className="templesOnly_svg__cls-3185"
          />
          <path d="M53 114.05h-2v-1h1Z" className="templesOnly_svg__cls-3186" />
          <path
            d="M51 114.05h1v1c-.3-.33-.63-.66-1-1"
            style={{
              fill: "#7e3725",
            }}
          />
          <path
            d="M50 113.05v-1l1 1Z"
            style={{
              fill: "#8c3f28",
            }}
          />
          <path
            d="M49 109.05v-1h1c1.92-.46.61-2 1-3h2l-1 2c-.16.76.49 1.92-1 2l-1 1c-.3-.33-.63-.66-1-1"
            style={{
              fill: "#993a0a",
            }}
          />
          <path
            d="M50 112.05h-1l1-1Z"
            style={{
              fill: "#92432a",
            }}
          />
          <circle
            cx={50.54}
            cy={110.55}
            r={0.71}
            style={{
              fill: "#95411a",
            }}
          />
          <path
            d="m46 106.05 1-2c.75.15 1.91-.49 2 1-1.5.09-.85 1.25-1 2l-1 1-1-1Z"
            style={{
              fill: "#cf843e",
            }}
          />
          <path
            d="M48 107.05c.15-.75-.5-1.91 1-2 .33 1 .66 2 1 3h-1Z"
            style={{
              fill: "#b35615",
            }}
          />
          <path
            d="M51 111.05v-2c1.49-.08.84-1.24 1-2h2c.15.76-.5 1.92 1 2l-1 2-2 1Z"
            className="templesOnly_svg__cls-3186"
          />
          <path
            d="m52 112.05 2-1v1c.33.34.66.67 1 1v1l-1 1-1-1-1-1Z"
            className="templesOnly_svg__cls-888"
          />
          <path
            d="M64 107.05h-4v-1c1-.38 2.53.93 3-1h1z"
            className="templesOnly_svg__cls-3194"
          />
          <path
            d="M58 106.05h-1l-1 1h-1l-1-2a17.5 17.5 0 0 1 2.81 0c.48.12.83.67 1.19 1"
            className="templesOnly_svg__cls-3195"
          />
          <path
            d="M55 107.05h1v1l-1 1c-1.5-.08-.85-1.24-1-2Z"
            style={{
              fill: "#681e02",
            }}
          />
          <path
            d="M56 108.05v-1l1-1c-.12.76.53 1.95-1 2"
            className="templesOnly_svg__cls-3194"
          />
          <path
            d="M60 106.05v1h-1v-1l1-1Z"
            className="templesOnly_svg__cls-3195"
          />
          <path
            d="M55 114.05v-1c.33.34.66.67 1 1Z"
            className="templesOnly_svg__cls-3194"
          />
          <path
            d="M55 113.05c-.34-.33-.67-.66-1-1 .37.34.7.67 1 1"
            className="templesOnly_svg__cls-3186"
          />
          <path
            d="M59 106.05v1l-1-1Z"
            style={{
              fill: "#782c0a",
            }}
          />
          <path
            d="M67 108.05h-1v-1h2v1Z"
            className="templesOnly_svg__cls-3120"
          />
          <path
            d="M67 108.05h1l-1 1Z"
            style={{
              fill: "#964a1c",
            }}
          />
          <path
            d="M68 106.05v1h-4v-1l1-1h1c.12 1.5 1.28.85 2 1"
            style={{
              fill: "#ed8f48",
            }}
          />
          <circle
            cx={65.54}
            cy={107.55}
            r={0.71}
            style={{
              fill: "#b36528",
            }}
          />
          <path
            d="m53 114.05 1 1c-.3-.33-.63-.66-1-1"
            style={{
              fill: "#4e0e00",
            }}
          />
          <path d="M62 93.05v1h-2l1-1Z" className="templesOnly_svg__cls-3123" />
          <path
            d="M58 92.05h1l-.68.83Z"
            style={{
              fill: "#842300",
            }}
          />
          <path
            d="M133 72.05v-2l2-1h-3v-1h4c-.34.67-.67 1.34-1 2v1l-1 1Z"
            className="templesOnly_svg__cls-3203"
          />
          <path d="M136 68.05h-1l1-1Z" className="templesOnly_svg__cls-3204" />
          <path
            d="M133 72.05h1v1c-.16.76.49 1.92-1 2-.34-.33-.67-.66-1-1v-1Z"
            style={{
              fill: "#f2ab66",
            }}
          />
          <path
            d="M132 75.05v1l-1 1h-1c.33-1 .66-2 1-3h1Z"
            style={{
              fill: "#6b1e00",
            }}
          />
          <path
            d="m131 77.05 1-1v2h-1Z"
            className="templesOnly_svg__cls-3207"
          />
          <path
            d="M132 75.05v-1c.33.34.66.67 1 1Z"
            className="templesOnly_svg__cls-3208"
          />
          <circle
            cx={134.54}
            cy={80.55}
            r={0.71}
            className="templesOnly_svg__cls-3207"
          />
          <path d="M134 80.05v1h-2v-1z" className="templesOnly_svg__cls-3209" />
          <path
            d="M133 80.05h-1v-2c1.53.09.88 1.25 1 2"
            className="templesOnly_svg__cls-3207"
          />
          <path
            d="m136 67.05-1 1h-3a4.62 4.62 0 0 1 4-2Z"
            style={{
              fill: "#d5914b",
            }}
          />
          <path d="m96 83.05-1 1v-1Z" className="templesOnly_svg__cls-3113" />
          <path
            d="M96 86.05h3v1l-1 1c.33.34.66.67 1 1v1h-2v-2l-1-1Z"
            style={{
              fill: "#9a4206",
            }}
          />
          <path d="M99 86.05h-2l2-2Z" className="templesOnly_svg__cls-3069" />
          <path
            d="M94 86.05h1v1l-1 1h-1c.37-.66.7-1.33 1-2"
            style={{
              fill: "#feb26e",
            }}
          />
          <circle
            cx={95.54}
            cy={86.55}
            r={0.71}
            className="templesOnly_svg__cls-3069"
          />
          <circle
            cx={99.54}
            cy={83.55}
            r={0.71}
            className="templesOnly_svg__cls-3113"
          />
          <circle
            cx={125.54}
            cy={63.55}
            r={0.71}
            style={{
              fill: "#d97c49",
            }}
          />
          <path
            d="M130 67.05c.33.34.66.67 1 1h-2v-1Z"
            style={{
              fill: "#feb966",
            }}
          />
          <path d="M130 67.05h-2v-1h2Z" className="templesOnly_svg__cls-3173" />
          <circle
            cx={131.54}
            cy={68.55}
            r={0.71}
            className="templesOnly_svg__cls-3204"
          />
          <path
            d="m54 101.05 3-2h1l.32.83.68-.83 1-1 2-1c.33.34.66.67 1 1l-1 1c-.76.15-1.92-.49-2 1v2h-1c-.09-1.49-1.25-.85-2-1l-1 1c-.63-.33-1.3-.66-2-1"
            style={{
              fill: "#f2ab57",
            }}
          />
          <path
            d="M57 101.05c.75.15 1.91-.49 2 1l-1 1h-1c-.76.15-1.92-.49-2 1h-2v-1c1.49-.08.84-1.24 1-2l2 1Z"
            style={{
              fill: "#fda86a",
            }}
          />
          <path
            d="M53 103.05v1h-3v-1l1-1 2-1.59Z"
            className="templesOnly_svg__cls-3089"
          />
          <path
            d="m51 102.05-1 1v-1Z"
            style={{
              fill: "#fec16e",
            }}
          />
          <circle
            cx={57.54}
            cy={98.55}
            r={0.71}
            style={{
              fill: "#d88c39",
            }}
          />
          <path d="m62 97.05-2 1v-2h3Z" className="templesOnly_svg__cls-3219" />
          <path
            d="M60 97.05v1l-1 1h-1v-2Z"
            style={{
              fill: "#ce852a",
            }}
          />
          <path
            d="M50 108.05c-.34-1-.67-2-1-3h2c-.35.95 1 2.54-1 3"
            style={{
              fill: "#d37234",
            }}
          />
          <path
            d="M51 105.05h-1v-1h2v1Z"
            style={{
              fill: "#feb56c",
            }}
          />
          <path
            d="m81 91.05 1-1h4l1-1v-1h1v3h-3c-.76.15-1.92-.49-2 1h-2Z"
            className="templesOnly_svg__cls-3168"
          />
          <path
            d="M90 87.05h2v1l-.83.33.83.67v1h-2z"
            style={{
              fill: "#ea9a4c",
            }}
          />
          <ellipse
            cx={89.04}
            cy={88.55}
            rx={1.41}
            ry={0.71}
            style={{
              fill: "#e2923d",
            }}
          />
          <path
            d="M92 88.05v-2h2c-.34.67-.67 1.34-1 2Z"
            className="templesOnly_svg__cls-3225"
          />
          <circle
            cx={85.54}
            cy={89.55}
            r={0.71}
            className="templesOnly_svg__cls-3226"
          />
          <path
            d="M86 90.05v-1h1Z"
            style={{
              fill: "#e58e40",
            }}
          />
          <path
            d="M74 94.05c1-.38 2.53.93 3-1h1v2l-1 1-.83.33.83.67v2h-1c-.34-.33-.67-.66-1-1-.39-1 .92-2.53-1-3Z"
            className="templesOnly_svg__cls-3228"
          />
          <path
            d="M76 92.05h1v1Z"
            style={{
              fill: "#febf71",
            }}
          />
          <path
            d="M77 93.05v-1h3c.08 1.5 1.24.85 2 1v1h-3c-.34-.33-.67-.66-1-1Z"
            className="templesOnly_svg__cls-3100"
          />
          <circle
            cx={80.54}
            cy={91.55}
            r={0.71}
            style={{
              fill: "#dc872e",
            }}
          />
          <path
            d="M74 94.05v1l-1 1h-6v-1l1-1h1l3-1h1c.37.34.7.67 1 1"
            style={{
              fill: "#f9ac5e",
            }}
          />
          <path
            d="M67 95.05v2l-1 1h-3c-.34-.33-.67-.66-1-1l1-1a5.35 5.35 0 0 0 4-1"
            style={{
              fill: "#fec16d",
            }}
          />
          <path
            d="M128 67.05h1v2h-1l-1 1h-2v-1l1-1c.79-.15 2 .5 2-1"
            style={{
              fill: "#fdb661",
            }}
          />
          <path
            d="M125 69.05v1l-1 1h-1c-.34-.33-.67-.66-1-1v-1z"
            style={{
              fill: "#f8a453",
            }}
          />
          <path
            d="M128 67.05c-.09 1.5-1.25.85-2 1v-1Z"
            className="templesOnly_svg__cls-3173"
          />
          <path
            d="M111 78.05c1-.38 2.53.93 3-1l1-1v-1h1c.33.34.66.67 1 1l1 1v2h-1l-1 1h-1c-.76.15-1.92-.49-2 1-.76.15-1.92-.49-2 1h-4Z"
            className="templesOnly_svg__cls-3177"
          />
          <path
            d="M117 76.05c-.34-.33-.67-.66-1-1h2v1Z"
            style={{
              fill: "#faae56",
            }}
          />
          <path
            d="M118 76.05v-1l1-1v1Z"
            style={{
              fill: "#f6a754",
            }}
          />
          <circle
            cx={113.54}
            cy={76.55}
            r={0.71}
            className="templesOnly_svg__cls-3177"
          />
          <path
            d="M114 77.05v-1h1Z"
            style={{
              fill: "#f9b35c",
            }}
          />
          <path
            d="M117 79.05h1c.75-.15 1.91.5 2-1h1l1-1 1-1h1v1l-.91 1.58.84.92c-1.11.46-2.2 1.25-3.32 1.3s-2.85 1.32-3.61-.8Z"
            className="templesOnly_svg__cls-3238"
          />
          <path
            d="M131 74.05c-.34 1-.67 2-1 3h-1l-1.29-.73-2.71.73v-1c2-.7 3.66-2.46 6-2"
            className="templesOnly_svg__cls-3208"
          />
          <path
            d="M128 72.05c-.38.21-.77.39-1.12.63-.9.59-1.64.75-1.88-.63.08-1.49 1.24-.85 2-1l1-1h4c-.09 1.5-1.25.85-2 1l-1 1Z"
            style={{
              fill: "#f9b56c",
            }}
          />
          <path
            d="m118 76.05 1-1h2v1l-1 1h-2c-.34-.33-.67-.66-1-1Z"
            style={{
              fill: "#e49644",
            }}
          />
          <path
            d="M127 71.05c-.76.15-1.92-.49-2 1h-1v-1l1-1h2Z"
            style={{
              fill: "#db9145",
            }}
          />
          <path
            d="M132 70.05h-1v-1h4l-2 1Z"
            style={{
              fill: "#f7b674",
            }}
          />
          <path
            d="m120 77.05 1-1h1v1l-1 1h-1Z"
            style={{
              fill: "#eda256",
            }}
          />
          <path
            d="M122 73.05h1.82l.08.67-1.9.33Z"
            style={{
              fill: "#feb769",
            }}
          />
          <path
            d="M122 73.05v1l-1 1v-2Z"
            style={{
              fill: "#fdaf61",
            }}
          />
          <circle
            cx={124.54}
            cy={76.55}
            r={0.71}
            className="templesOnly_svg__cls-3246"
          />
          <path d="M122 77.05v-1h1Z" className="templesOnly_svg__cls-3246" />
          <path d="M132 74.05h-1l1-1Z" className="templesOnly_svg__cls-3208" />
          <path
            d="M128 72.05h1c-.23.28-.45.56-.68.83ZM129 72.05l1-1Z"
            className="templesOnly_svg__cls-3203"
          />
          <path
            d="M124 71.05v1c-.34-.33-.67-.66-1-1Z"
            className="templesOnly_svg__cls-3179"
          />
          <ellipse
            cx={120.04}
            cy={74.55}
            rx={1.41}
            ry={0.71}
            style={{
              fill: "#fca95a",
            }}
          />
          <path
            d="M107 79.05h1c-.09 1.5-1.25.85-2 1Z"
            className="templesOnly_svg__cls-3248"
          />
          <path
            d="M104 82.05v-1h1Z"
            style={{
              fill: "#fecc8b",
            }}
          />
          <path d="m105 81.05 1-1Z" className="templesOnly_svg__cls-3248" />
          <path
            d="m105 81.05 1-1c.75-.15 1.91.5 2-1l1-1h2l-4 4v1h-3v-1Z"
            style={{
              fill: "#fdb36a",
            }}
          />
          <path
            d="M104 83.05h3l-1 1h-2ZM102 84.05h2c-.09 1.5-1.25.85-2 1Z"
            className="templesOnly_svg__cls-3251"
          />
          <ellipse
            cx={101.04}
            cy={83.55}
            className="templesOnly_svg__cls-3251"
            rx={1.41}
            ry={0.71}
          />
          <path
            d="M52 112.05v1h-1l-1-1v-1h1Z"
            style={{
              fill: "#7a2c12",
            }}
          />
          <path
            d="M55 107.05h-3l1-2h1Z"
            className="templesOnly_svg__cls-3194"
          />
          <path d="M54 105.05h-2v-1h2Z" className="templesOnly_svg__cls-3253" />
          <path d="M51 109.05v1h-1Z" className="templesOnly_svg__cls-3194" />
          <path
            d="M60 106.05v-1l1-1h2v1c-.43 1.95-2 .62-3 1"
            style={{
              fill: "#812b00",
            }}
          />
          <path d="m65 105.05-1 1v-1Z" className="templesOnly_svg__cls-3120" />
          <path
            d="M63 105.05v-1c.33.34.66.67 1 1Z"
            style={{
              fill: "#771d00",
            }}
          />
          <path
            d="m61 104.05-1 1-1 1h-1c-.4-.33-.75-.88-1.19-1a17.5 17.5 0 0 0-2.81 0v-1h1c.75-.15 1.91.5 2-1h2l.32.83.68-.83h1Z"
            className="templesOnly_svg__cls-3194"
          />
          <path
            d="M68 106.05c-.76-.15-1.92.5-2-1-.34-.33-.67-.66-1-1v-2c.06-.61 0-1.15 1-.59a7.3 7.3 0 0 0 2 .59c.33.34.66.67 1 1v2a6.4 6.4 0 0 0-1.05.06l.15-.15-.7-.81-.31.31a5.5 5.5 0 0 0 .86.65 5.6 5.6 0 0 1 .05.94"
            className="templesOnly_svg__cls-3120"
          />
          <path
            d="M70 102.05h-1l-1-1c-.34-.33-.67-.66-1-1l1-1h1c.08 1.5 1.24.85 2 1v1Z"
            className="templesOnly_svg__cls-3256"
          />
          <path
            d="m68 101.05 1 1v1c-.34-.33-.67-.66-1-1Z"
            style={{
              fill: "#f79e5b",
            }}
          />
          <circle
            cx={71.54}
            cy={101.55}
            r={0.71}
            className="templesOnly_svg__cls-3256"
          />
          <path
            d="M71 101.05v1h-1ZM65 104.05c.33.34.66.67 1 1h-1Z"
            className="templesOnly_svg__cls-634"
          />
          <path
            d="M124 77.05h1l2.71-.73 1.29.73v1l-3 2-1 1-3 2-1.59-.92-1.37 1.38 2 1.54h-4c-.62-1.86-1.85-.81-3.43-.67.64.76 1 1.22 1.43 1.67.75.15 1.91-.49 2 1l-1 1-1-1h-1.23c-1-1.4-1.88-2.7-2.77-4v-1c.75-.15 1.91.5 2-1 .75-.15 1.91.5 2-1h2c.76 2.12 2.43.86 3.61.8s2.21-.84 3.32-1.3l-.84-.92Zm-8 5.67v-.33h-1v.33Z"
            style={{
              fill: "#772401",
            }}
          />
          <path
            d="m122 83.05 3-2 1-1h6v1l-1 1h-2l-3 2a5.35 5.35 0 0 1-4 1Z"
            style={{
              fill: "#792a0c",
            }}
          />
          <path
            d="m126 84.05 3-2c.08 1.5 1.24.85 2 1v2Z"
            style={{
              fill: "#9b5531",
            }}
          />
          <path
            d="M122 83.05v2h-1l-2-1.54 1.37-1.38Z"
            className="templesOnly_svg__cls-3261"
          />
          <path
            d="M118 87.05h-1c-.09-1.49-1.25-.85-2-1 .08-1.49 1.24-.85 2-1h1Z"
            style={{
              fill: "#561a02",
            }}
          />
          <path
            d="M131 77.05v1l-.76 1-1.24-1 1-1Z"
            style={{
              fill: "#581900",
            }}
          />
          <path
            d="m129 78.05 1.24 1 .76-1h1v2h-6Z"
            className="templesOnly_svg__cls-3264"
          />
          <path
            d="M131 83.05c-.76-.15-1.92.5-2-1h5c-.43 1.95-2 .62-3 1"
            className="templesOnly_svg__cls-3209"
          />
          <ellipse
            cx={133.04}
            cy={81.55}
            rx={1.41}
            ry={0.71}
            style={{
              fill: "#feb179",
            }}
          />
          <path
            d="M131 85.05v-1l.82.67Z"
            style={{
              fill: "#954b17",
            }}
          />
          <path
            d="M99 90.05v-3h1v1l.75 1 1.25-1h1v2h-1c-1.5.09-.85 1.25-1 2h-1l-2.44.43 1.44.57c.15.76-.5 1.92 1 2-.34.67-.67 1.34-1 2h-1l-.33-.83-.67.83h-3v-1h1l1.9-1.34-.9-1.66c1.49-.08.84-1.24 1-2h2l.82-.33Z"
            style={{
              fill: "#d98747",
            }}
          />
          <path
            d="M97 89.05v2h-2v-2Z"
            style={{
              fill: "#c06d36",
            }}
          />
          <path
            d="M97 89.05h-3v-1l1-1h1l1 1Z"
            className="templesOnly_svg__cls-3269"
          />
          <ellipse
            cx={98.04}
            cy={90.55}
            className="templesOnly_svg__cls-3269"
            rx={1.41}
            ry={0.71}
          />
          <path
            d="M99 88.05v1c-.34-.33-.67-.66-1-1Z"
            className="templesOnly_svg__cls-3269"
          />
          <path
            d="M99 88.05h-1l1-1Z"
            style={{
              fill: "#9b3f02",
            }}
          />
          <path
            d="m97 88.05-1-1Z"
            style={{
              fill: "#983f01",
            }}
          />
          <circle
            cx={99.54}
            cy={86.55}
            r={0.71}
            className="templesOnly_svg__cls-3272"
          />
          <path
            d="M100 86.05h-1v-2h3v1l-1 1Z"
            style={{
              fill: "#802c00",
            }}
          />
          <circle
            cx={93.54}
            cy={88.55}
            r={0.71}
            className="templesOnly_svg__cls-3225"
          />
          <path d="M130 70.05h-1v-2h1z" className="templesOnly_svg__cls-3173" />
          <circle
            cx={130.54}
            cy={68.55}
            r={0.71}
            style={{
              fill: "#d7914a",
            }}
          />
          <path
            d="M61 103.05h-2v-1h1l1-1h2Z"
            className="templesOnly_svg__cls-634"
          />
          <path
            d="M63 101.05h-1v-2l1-1h2v1Z"
            style={{
              fill: "#f8ab61",
            }}
          />
          <path
            d="M62 100.05v1h-2v-1Z"
            style={{
              fill: "#feb36b",
            }}
          />
          <path
            d="M62 100.05h-2c.08-1.49 1.24-.85 2-1Z"
            style={{
              fill: "#dd9544",
            }}
          />
          <path
            d="M60 101.05h1l-1 1ZM57 101.05l-1 1Z"
            className="templesOnly_svg__cls-3154"
          />
          <path
            d="M58 99.05h1l-.68.83Z"
            style={{
              fill: "#febf6d",
            }}
          />
          <path
            d="M57 103.05c-.09 1.5-1.25.85-2 1 .12-1.49 1.28-.85 2-1"
            className="templesOnly_svg__cls-3253"
          />
          <path d="M59 102.05v1h-1Z" className="templesOnly_svg__cls-3154" />
          <path
            d="M87 91.05h3c-.47 1.93-2 .62-3 1Z"
            className="templesOnly_svg__cls-3279"
          />
          <path
            d="M80 92.05h3v1h-1c-.72-.15-1.88.5-2-1"
            style={{
              fill: "#feb16c",
            }}
          />
          <ellipse
            cx={86.04}
            cy={91.55}
            className="templesOnly_svg__cls-3226"
            rx={1.41}
            ry={0.71}
          />
          <path
            d="M85 91.05v1h-2c.12-1.49 1.28-.85 2-1"
            style={{
              fill: "#f4a256",
            }}
          />
          <path
            d="M88 89.05h2v1h-2Z"
            style={{
              fill: "#fba758",
            }}
          />
          <circle
            cx={88.54}
            cy={90.55}
            r={0.71}
            className="templesOnly_svg__cls-3226"
          />
          <path
            d="M89 91.05v-1h3c-.09 1.5-1.25.85-2 1ZM93 89.05h1c-.09 1.5-1.25.85-2 1v-1Z"
            className="templesOnly_svg__cls-3283"
          />
          <path
            d="M93 89.05h-1l-.83-.67.83-.33h1Z"
            style={{
              fill: "#fcab5a",
            }}
          />
          <path
            d="M68 96.05h5l1-1c1.92.47.61 2 1 3h-2a2.48 2.48 0 0 0-4 0c-1.46-.05-.81-1.24-1-2"
            className="templesOnly_svg__cls-3285"
          />
          <path
            d="m77 96.05 1-1c.66.34 1.33.67 2 1v1l-1 1h-1c-.34-.33-.67-.66-1-1Z"
            style={{
              fill: "#a3460e",
            }}
          />
          <path
            d="m80 96.05-2-1v-1h3v1Z"
            className="templesOnly_svg__cls-3287"
          />
          <path
            d="M77 97.05c.33.34.66.67 1 1v1h-1Z"
            style={{
              fill: "#7e2c02",
            }}
          />
          <path
            d="M75 98.05c.33.34.66.67 1 1h-1Z"
            style={{
              fill: "#eca371",
            }}
          />
          <path
            d="M77 96.05v1l-.83-.67Z"
            style={{
              fill: "#f4ad6e",
            }}
          />
          <path
            d="M79 94.05h-1v-1c.37.34.7.67 1 1"
            style={{
              fill: "#a14400",
            }}
          />
          <path
            d="M82 93.05h1c.33.34.66.67 1 1h2v1h-3c-.34-.33-.67-.66-1-1Z"
            className="templesOnly_svg__cls-778"
          />
          <path
            d="M82 94.05c.33.34.66.67 1 1v1l-2 1v-3Z"
            className="templesOnly_svg__cls-3292"
          />
          <path
            d="M68 96.05c.15.76-.5 1.92 1 2v1h-2v-3Z"
            className="templesOnly_svg__cls-3038"
          />
          <path d="m74 95.05-1 1Z" className="templesOnly_svg__cls-3228" />
          <path d="M67 98.05v1h-2v-1z" className="templesOnly_svg__cls-634" />
          <path d="M67 98.05h-1l1-1Z" className="templesOnly_svg__cls-3219" />
          <circle
            cx={128.54}
            cy={69.55}
            r={0.71}
            style={{
              fill: "#d29345",
            }}
          />
          <path d="M128 69.05v1h-1Z" className="templesOnly_svg__cls-3173" />
          <path
            d="M107 83.05v-1h3v3h-2c-.12-.75.53-1.91-1-2"
            className="templesOnly_svg__cls-3251"
          />
          <path
            d="M113 81.05c-.09 1.5-1.25.85-2 1 .12-1.49 1.28-.85 2-1M115 80.05c-.09 1.5-1.25.85-2 1 .12-1.49 1.28-.85 2-1"
            className="templesOnly_svg__cls-3238"
          />
          <path
            d="M120 78.05c-.09 1.5-1.25.85-2 1v-1Z"
            className="templesOnly_svg__cls-3246"
          />
          <ellipse
            cx={119.04}
            cy={77.55}
            rx={1.41}
            ry={0.71}
            style={{
              fill: "#f7a558",
            }}
          />
          <circle
            cx={110.54}
            cy={82.55}
            r={0.71}
            className="templesOnly_svg__cls-3295"
          />
          <path
            d="M117 80.05h-1l1-1Z"
            style={{
              fill: "#ac571e",
            }}
          />
          <path d="m121 78.05 1-1Z" className="templesOnly_svg__cls-3246" />
          <path d="m130 77.05-1 1v-1Z" className="templesOnly_svg__cls-3264" />
          <path d="M127 70.05h1l-1 1Z" className="templesOnly_svg__cls-3203" />
          <circle
            cx={130.54}
            cy={69.55}
            r={0.71}
            className="templesOnly_svg__cls-3203"
          />
          <path
            d="m101 86.05 1-1c.75-.15 1.91.5 2-1h1v2l-1 1-1 1h-1c-.34-.33-.67-.66-1-1Z"
            style={{
              fill: "#853007",
            }}
          />
          <path
            d="M105 86.05v-2h1c.15.76-.5 1.92 1 2v1l-1 1h-1z"
            className="templesOnly_svg__cls-3298"
          />
          <path
            d="M107 86.05c-1.5-.08-.85-1.24-1-2l1-1c1.49.09.84 1.25 1 2Z"
            style={{
              fill: "#df8248",
            }}
          />
          <path
            d="m61 103.05 2-2 2 1v3h-1c-.34-.33-.67-.66-1-1h-2Z"
            style={{
              fill: "#9c3c05",
            }}
          />
          <path
            d="M59 103.05h1l-.68.83Z"
            className="templesOnly_svg__cls-3195"
          />
          <path
            d="m65 102.05-2-1 2-2c.08 1.5 1.24.85 2 1 .33.34.66.67 1 1v1a7.3 7.3 0 0 1-2-.59c-.91-.56-.9-.02-1 .59"
            className="templesOnly_svg__cls-634"
          />
          <path
            d="m67.94 105.16-.81-.7.31-.31.7.81Z"
            style={{
              fill: "#ef9d64",
            }}
          />
          <path
            d="M67 100.05c-.76-.15-1.92.5-2-1h3Z"
            style={{
              fill: "#8d3400",
            }}
          />
          <path
            d="M72 101.05h-1v-1h2ZM71 100.05c-.76-.15-1.92.5-2-1h2Z"
            className="templesOnly_svg__cls-3285"
          />
          <path
            d="M108 85.05h2c1.49-.08.84-1.24 1-2 .89 1.3 1.79 2.6 2.77 4H115v1h-3l-1-1c-.47-1.92-2-.61-3-1Z"
            className="templesOnly_svg__cls-3295"
          />
          <path
            d="M117 85.05c-.76.15-1.92-.49-2 1-.4-.45-.79-.91-1.43-1.67 1.62-.14 2.85-1.19 3.43.67"
            className="templesOnly_svg__cls-3261"
          />
          <path
            d="M115 88.05v-1l1 1Z"
            style={{
              fill: "#752100",
            }}
          />
          <ellipse
            cx={115.54}
            cy={82.55}
            className="templesOnly_svg__cls-3238"
            rx={0.71}
            ry={0.24}
          />
          <path
            d="m126 80.05-1 1Z"
            style={{
              fill: "#6e1e00",
            }}
          />
          <path d="M132 81.05v1h-1Z" className="templesOnly_svg__cls-3207" />
          <path
            d="m111 87.05 1 1v1h-1Z"
            style={{
              fill: "#9f4626",
            }}
          />
          <path d="M112 89.05v-1h1Z" className="templesOnly_svg__cls-3238" />
          <path
            d="M93 97.05c-.61.11-1.23.19-1.83.34s-1.45.44-2.17.66l-.92-1.58 2.38-2.38 1 .87 1.54-.91.32.83.68-.83v-1h1v3h-1Z"
            className="templesOnly_svg__cls-778"
          />
          <path
            d="M105 88.05h1l1-1v-1h1v3h-1l-1 1h-3v-1h1Z"
            style={{
              fill: "#a14722",
            }}
          />
          <path
            d="M95 96.05v-3h1l.9 1.66Z"
            className="templesOnly_svg__cls-1286"
          />
          <path
            d="M104 89.05h-1v-1l1-1h1v1Z"
            style={{
              fill: "#6d1900",
            }}
          />
          <path
            d="M100 95.05c-1.5-.08-.85-1.24-1-2h1Z"
            className="templesOnly_svg__cls-1286"
          />
          <path
            d="M100 93.05h-1l-1.44-.57 2.44-.43Z"
            style={{
              fill: "#ef9655",
            }}
          />
          <path
            d="M96 91.05h1c-.16.76.49 1.92-1 2Z"
            className="templesOnly_svg__cls-1286"
          />
          <path
            d="m102 88.05-1.25 1-.75-1z"
            style={{
              fill: "#f6a85f",
            }}
          />
          <path
            d="M98 97.05h-1l.67-.83ZM93 97.05l1-1v1Z"
            className="templesOnly_svg__cls-1286"
          />
          <path
            d="M99 91.05v-1l.82.67Z"
            style={{
              fill: "#e79854",
            }}
          />
          <circle
            cx={100.54}
            cy={87.55}
            r={0.71}
            className="templesOnly_svg__cls-3272"
          />
          <path
            d="M92 90.05c.75-.15 1.91.5 2-1h1v2h-1l-3 2h-2l-1 1h-1v-2c1-.38 2.53.93 3-1 .79-.15 2 .5 2-1"
            style={{
              fill: "#85300e",
            }}
          />
          <path
            d="M94 91.05h2v2h-1c-.34-.33-.67-.66-1-1Z"
            style={{
              fill: "#6d2600",
            }}
          />
          <circle
            cx={100.54}
            cy={86.55}
            r={0.71}
            className="templesOnly_svg__cls-3251"
          />
          <circle
            cx={83.54}
            cy={92.55}
            r={0.71}
            className="templesOnly_svg__cls-3168"
          />
          <path
            d="M87 92.05v1c-.76-.15-1.92.5-2-1Z"
            className="templesOnly_svg__cls-3279"
          />
          <path
            d="M85 92.05c.08 1.5 1.24.85 2 1v1h-3v-2Z"
            style={{
              fill: "#923e17",
            }}
          />
          <path
            d="M71 99.05h-2v-1a2.48 2.48 0 0 1 4 0h-1Z"
            style={{
              fill: "#882b09",
            }}
          />
          <path
            d="M72 98.05h2v1h-2Z"
            style={{
              fill: "#9f4018",
            }}
          />
          <circle
            cx={74.54}
            cy={98.55}
            r={0.71}
            style={{
              fill: "#943f0e",
            }}
          />
          <path
            d="M81 96.05v4h-1v-4Z"
            style={{
              fill: "#812504",
            }}
          />
          <path d="M79 99.05v-1l1-1v2Z" className="templesOnly_svg__cls-3287" />
          <path
            d="M81 96.05h-1l1-1Z"
            style={{
              fill: "#b45120",
            }}
          />
          <path
            d="M78 99.05v1l-1-1Z"
            style={{
              fill: "#5f0e00",
            }}
          />
          <circle
            cx={75.54}
            cy={99.55}
            r={0.71}
            style={{
              fill: "#c06f3c",
            }}
          />
          <path
            d="M86 94.05h2l1-1h4v1l-1.54.95-1-.87-2.38 2.38.92 1.54c-.67 0-1.34 0-2.05.06l.15-.15-.7-.81-.31.31a5.5 5.5 0 0 0 .86.65 5.6 5.6 0 0 1 .05.94l-1 1h-1v-4l1-1Z"
            className="templesOnly_svg__cls-3321"
          />
          <path
            d="m86 95.05-1 1h-2v-1Z"
            className="templesOnly_svg__cls-3322"
          />
          <path
            d="M84 93.05v1c-.34-.33-.67-.66-1-1Z"
            className="templesOnly_svg__cls-3292"
          />
          <path
            d="M81 100.05v-3l2-1v2l-.83.33.83.67v1l-1 1h-1Z"
            style={{
              fill: "#561604",
            }}
          />
          <path
            d="M111 83.05c-.16.76.49 1.92-1 2v-2Z"
            className="templesOnly_svg__cls-3238"
          />
          <path
            d="M101 88.05v-1c.33.34.66.67 1 1Z"
            className="templesOnly_svg__cls-3251"
          />
          <path
            d="M105 87.05h-1l1-1Z"
            style={{
              fill: "#8e3b16",
            }}
          />
          <path
            d="m107 87.05-1 1Z"
            style={{
              fill: "#b55a2b",
            }}
          />
          <path
            d="M108 86.05h-1l1-1Z"
            style={{
              fill: "#cb6f34",
            }}
          />
          <path
            d="M72 99.05h2l-1 1h-2v-1Z"
            className="templesOnly_svg__cls-1084"
          />
          <path
            d="M108 88.05v-2c1 .39 2.53-.92 3 1v2h-1c-.12-.63-.23-1.27-.43-2.43l-.57 1.43Z"
            style={{
              fill: "#7c2506",
            }}
          />
          <path
            d="m109 88.05.57-1.43c.2 1.16.31 1.8.43 2.43h-1Z"
            style={{
              fill: "#691300",
            }}
          />
          <path
            d="m94 94.05-.68.83-.32-.83Z"
            className="templesOnly_svg__cls-3321"
          />
          <circle
            cx={93.54}
            cy={93.55}
            r={0.71}
            className="templesOnly_svg__cls-3329"
          />
          <path
            d="M94 92.05c.33.34.66.67 1 1h-1Z"
            className="templesOnly_svg__cls-3329"
          />
          <circle
            cx={108.54}
            cy={88.55}
            r={0.71}
            className="templesOnly_svg__cls-3295"
          />
          <path d="m104 89.05 1-1Z" className="templesOnly_svg__cls-3298" />
          <path
            d="M94 92.05v1h-3l3-2Z"
            style={{
              fill: "#71230a",
            }}
          />
          <path d="m89 93.05-1 1Z" className="templesOnly_svg__cls-778" />
          <path d="M72 99.05h-1l1-1Z" className="templesOnly_svg__cls-3285" />
          <path
            d="M85 100.05h-2v-1h2Z"
            style={{
              fill: "#69280d",
            }}
          />
          <path d="M83 98.05v-1h2v1z" className="templesOnly_svg__cls-3322" />
          <ellipse
            cx={84.04}
            cy={96.55}
            rx={1.41}
            ry={0.71}
            style={{
              fill: "#400200",
            }}
          />
          <circle
            cx={84.54}
            cy={98.55}
            r={0.71}
            className="templesOnly_svg__cls-778"
          />
          <path
            d="m86.94 98.16-.81-.7.31-.31.7.81Z"
            className="templesOnly_svg__cls-778"
          />
          <path
            d="M84 98.05v1h-1l-.83-.67.83-.33Z"
            style={{
              fill: "#6d2916",
            }}
          />
          <path
            d="m56 120.07-2-1-1-1v-1.78l3-.52v-1.7c-.34-.33-.67-.67-1-1l-1-1v-1l1-2 1-1c1.49-.09.84-1.24 1-2h1l1 1h3v1l-4.88 1.26a24 24 0 0 0 .28 5.83c.33 1.48-.85 3.26-1.4 4.91"
            className="templesOnly_svg__cls-3334"
          />
        </g>
        <g id="templesOnly_svg__column2" ref={el => columnRefs.current[1] = el}>
          <path
            d="M33 268h3v4h-1v-3h-2Z"
            style={{
              fill: "#eeb888",
            }}
          />
          <path
            d="M36 268h-1c.33-.67.66-1.33 1-2h1v2Z"
            className="templesOnly_svg__cls-3336"
          />
          <path
            d="M40 248c.09-8.74 0-15.82 0-20.46-.2-18.8-.88-30.18-.7-44.05 0-.66.16-10.52.72-19.17 0-.62.16-2.48.27-4.13.65-9.66.65-9.07.79-11.4A126 126 0 0 0 41 132.9c0-1.55.37-3.18-.83-4.52a1 1 0 0 1 .34-.33 1.4 1.4 0 0 1 .5 0h2v34c.3 1 .61 2 .92 3L43 168v2a33 33 0 0 0-1 4.08 42 42 0 0 0 0 4.49V207a49 49 0 0 0-1 5 43 43 0 0 0 0 5.45c.1 2.53 1.61 4.88 1 7.51a5.36 5.36 0 0 0 0 5.04c-.42 1.38-1.77 2.39-.46 4.3s.58 4.23-.41 5.6L42 243v12c-.34-.26-.94-.5-1-.78-.09-1.65 0-3.3-.09-4.94.09-.41-.54-.82-.91-1.28"
            style={{
              fill: "#dbab79",
            }}
          />
          <path
            d="M40 248c.33.42.92.83 1 1.28.11 1.64 0 3.29.09 4.94 0 .28.62.52 1 .78h1v1l-1 .76c.33.41.66.83 1 1.24h1v1l-1 1 1 1 1 1-1 1-1 1 .87 1.61-.96.39h-1c-1.92-1.84-.67-3.79.29-6H40l-.86-.35c1.31-2.54 1-5.08.34-7.77-.26-1.13.36-2.54.52-3.88"
            style={{
              fill: "#ecb277",
            }}
          />
          <path
            d="M40 260h2.29c-1 2.21-2.21 4.16-.29 6h-3q.53-3 1-6"
            className="templesOnly_svg__cls-3339"
          />
          <path
            d="M42 128h-1c-.34-1.67-.67-3.33-1-5h2v1l1 2-1 1Z"
            className="templesOnly_svg__cls-3340"
          />
          <path
            d="M42 123h-1l-1-1v-1h2l.87 1.61Z"
            style={{
              fill: "#9e4a07",
            }}
          />
          <path
            d="M37 268v-2h2c-.34.67-.67 1.33-1 2Z"
            className="templesOnly_svg__cls-3339"
          />
          <path
            d="m39 120 1-1h1v1z"
            style={{
              fill: "#c07842",
            }}
          />
          <path
            d="m40 122 1 1h-1Z"
            style={{
              fill: "#b2784a",
            }}
          />
          <circle
            cx={40.54}
            cy={120.54}
            r={0.71}
            className="templesOnly_svg__cls-3344"
          />
          <path
            d="M31 272h4v4l-1 1c-.16-.76.49-1.91-1-2l-.33-.83-.67.83h-1z"
            style={{
              fill: "#d9ac76",
            }}
          />
          <ellipse
            cx={32.54}
            cy={270.54}
            rx={0.71}
            ry={2.12}
            style={{
              fill: "#e4b37c",
            }}
          />
          <circle
            cx={32.54}
            cy={268.54}
            r={0.71}
            className="templesOnly_svg__cls-3347"
          />
          <path
            d="M33 272v-3h2v2l-1 1Z"
            className="templesOnly_svg__cls-3347"
          />
          <path
            d="M36 268h1v4h-1Z"
            style={{
              fill: "#f1c190",
            }}
          />
          <path
            d="M35 274v-2h1l1 1c0 1.54-1.21.89-2 1"
            style={{
              fill: "#ecbe89",
            }}
          />
          <path
            d="m34 272 1-1v1Z"
            style={{
              fill: "#c89d6b",
            }}
          />
          <path
            d="M42 207v-28.39a42 42 0 0 1 0-4.49 33 33 0 0 1 1-4.12h1v7a3.43 3.43 0 0 0 0 5v2l-1 1v4c.33.33.66.67 1 1v1c-.34.26-1 .52-1 .78-.06 3.81-.06 7.63 0 11.44 0 .26.62.52 1 .78v3z"
            style={{
              fill: "#d4995c",
            }}
          />
          <path
            d="m42 243-.87-3.17c1-1.37 1.7-3.73.41-5.6s0-2.92.46-4.3a5.36 5.36 0 0 1 0-4.93c1.64-.16.8-1.44 1-2.25s-.33-1.74 1-1.75c-.29 3.17.62 6.46-.69 9.76 1.49 1.68.34 4.07.69 6.24v1l-1 1a17.7 17.7 0 0 1 0 2.82c-.08.47-.63.83-1 1.18"
            style={{
              fill: "#d69c5f",
            }}
          />
          <path
            d="M44 221c-1.35 0-.86 1.05-1 1.75s.66 2.09-1 2.25c.62-2.63-.89-5-1-7.51a43 43 0 0 1 0-5.45 49 49 0 0 1 1-5h1c.15.76-.5 1.91 1 2-.13 2 .45 4-.66 5.59.27.58.46 1 .66 1.41l-.83.33.83.63Z"
            style={{
              fill: "#d79b5f",
            }}
          />
          <path
            d="M42 243c.33-.39.88-.75 1-1.18a17.7 17.7 0 0 0 0-2.82h1v5a8.6 8.6 0 0 0-1 1.15c1.29 1.45.91 3.19 1 4.85v8h-1v-3c-.16-.76.49-1.91-1-2Z"
            style={{
              fill: "#d79751",
            }}
          />
          <path
            d="M44 177v-7c-.16-.76.49-1.91-1-2l.92-3c-.31-1-.62-2-.92-3h1c1.47 1.81.92 4 1 6v17h-1z"
            className="templesOnly_svg__cls-3355"
          />
          <path
            d="M43 139v-1h2v14.25c0 .72.36 1.74-1 1.75 0-2.26.05-4.52 0-6.77 0-.42-.62-.82-1-1.23v-3c1.49-.09.84-1.24 1-2v-1Z"
            className="templesOnly_svg__cls-3356"
          />
          <path
            d="M44 162h-1v-7h1v2a5.4 5.4 0 0 1 1 4Z"
            className="templesOnly_svg__cls-3357"
          />
          <ellipse
            cx={43.54}
            cy={133.54}
            className="templesOnly_svg__cls-3358"
            rx={0.71}
            ry={6.36}
          />
          <path
            d="M43 146c.33.41.93.81 1 1.23.1 2.25 0 4.51 0 6.77h-1Z"
            className="templesOnly_svg__cls-3358"
          />
          <path
            d="M43 168c1.49.09.84 1.24 1 2h-1Z"
            className="templesOnly_svg__cls-3357"
          />
          <path
            d="M42 253c1.49.09.84 1.24 1 2h-1Z"
            style={{
              fill: "#d39b5f",
            }}
          />
          <path
            d="M44 141c-.16.76.49 1.91-1 2v-2Z"
            className="templesOnly_svg__cls-3358"
          />
          <circle
            cx={43.54}
            cy={154.54}
            r={0.71}
            className="templesOnly_svg__cls-3340"
          />
          <circle
            cx={43.54}
            cy={140.54}
            r={0.71}
            className="templesOnly_svg__cls-3340"
          />
          <path d="M44 140h-1v-1Z" className="templesOnly_svg__cls-3358" />
          <circle
            cx={43.54}
            cy={128.54}
            r={0.71}
            className="templesOnly_svg__cls-3340"
          />
          <circle
            cx={42.54}
            cy={127.54}
            r={0.71}
            className="templesOnly_svg__cls-3358"
          />
          <path
            d="m43 266 .87-.39L43 264h2c.75.67 1.52 1.32 2.25 2a8 8 0 0 1 .75 1h-5Z"
            className="templesOnly_svg__cls-3360"
          />
          <path
            d="M43 266v2c-.76.15-1.92-.5-2 1h-1v-3z"
            style={{
              fill: "#daa876",
            }}
          />
          <path
            d="m45 262-1-1-1-1 1-1h1l1 1 1 2Z"
            style={{
              fill: "#d18d47",
            }}
          />
          <path
            d="M45 259h-1v-3h1z"
            style={{
              fill: "#ba762e",
            }}
          />
          <path
            d="M43 256v2c-.34-.41-.67-.83-1-1.24Z"
            style={{
              fill: "#fcbc7f",
            }}
          />
          <path
            d="M44 264h-1l1-1ZM44 263l1-1v1Z"
            className="templesOnly_svg__cls-3365"
          />
          <path
            d="m43 260 1 1Z"
            style={{
              fill: "#c68542",
            }}
          />
          <path
            d="M40 116c.33-1 .66-2 1-3 1.49-.09.84-1.24 1-2 1.49.09.84 1.24 1 2s-.5 1.91 1 2l-1 1z"
            style={{
              fill: "#c5702d",
            }}
          />
          <path
            d="M41 116h2v1a8 8 0 0 0 .76 1 15 15 0 0 0 1.24 1h-5v-2Z"
            style={{
              fill: "#a74410",
            }}
          />
          <path
            d="m41 116-1 1v-1Z"
            style={{
              fill: "#a03f00",
            }}
          />
          <path
            d="M40 266v2h-2c.33-.67.66-1.33 1-2Z"
            className="templesOnly_svg__cls-3336"
          />
          <path
            d="m42 123 .87-.39L42 121l1-1h1a2.46 2.46 0 0 0 2 3h1l1 1v2l-1 1c-1.19 0-1.33 1.12-.85 1.54 1.2 1 .72 2.28.85 3.46l-1.87-1.24C45 128.48 45 128.26 44 127h-1v-1c1.4.2 2.31-.4 3-2h-4Z"
            style={{
              fill: "#b2581a",
            }}
          />
          <path
            d="M42 124h4c-.69 1.6-1.6 2.2-3 2ZM43 126v1h-1Z"
            className="templesOnly_svg__cls-3356"
          />
          <path
            d="m43 120-1 1h-1v-1l1-1h1Z"
            style={{
              fill: "#ec9551",
            }}
          />
          <path
            d="M40 269h3l2.9.29-.08.71H43l-3 2h-2l-1-1v-3h1c.12 1.54 1.28.89 2 1"
            className="templesOnly_svg__cls-3336"
          />
          <path d="m42 119-1 1v-1Z" className="templesOnly_svg__cls-3344" />
          <path
            d="M31 276v-1h2c.38 1-.93 2.53 1 3l3 1v1h-4l-.33-.83-.67.83-1-1Z"
            className="templesOnly_svg__cls-3372"
          />
          <path
            d="m37 271 1 1v5h-1l-1-1-1-1v-1c.75-.15 1.91.5 2-1z"
            style={{
              fill: "#e7ba7d",
            }}
          />
          <path
            d="m36 276 1 1 1 1h1v1h-2l-3-1v-1l1-1Z"
            style={{
              fill: "#f2be84",
            }}
          />
          <path
            d="M34 277v1c-1.93-.47-.62-2-1-3 1.53.13.88 1.28 1 2"
            style={{
              fill: "#d2a876",
            }}
          />
          <path d="M36 276h-1v-1Z" className="templesOnly_svg__cls-3372" />
          <path
            d="M33 275h-1l.67-.83Z"
            style={{
              fill: "#e1b47e",
            }}
          />
          <path
            d="M37 272v1l-1-1Z"
            style={{
              fill: "#facd96",
            }}
          />
          <path
            d="M44 204c-.34-.26-1-.52-1-.78-.06-3.81-.06-7.63 0-11.44 0-.26.62-.52 1-.78z"
            className="templesOnly_svg__cls-3357"
          />
          <path
            d="M44 192v-2q2.055-1.5 0-3v-2h1c.33.33.66.67 1 1v2c.33 1.67.66 3.33 1 5h-1c-.09-.66-.18-1.32-.26-2Z"
            className="templesOnly_svg__cls-3378"
          />
          <path
            d="M44 204v-1h2v3l-2 1Z"
            className="templesOnly_svg__cls-3379"
          />
          <path
            d="M44 177v5a3.43 3.43 0 0 1 0-5"
            className="templesOnly_svg__cls-3357"
          />
          <path
            d="M44 187q2.055 1.5 0 3l-1-1v-1Z"
            className="templesOnly_svg__cls-3355"
          />
          <path
            d="M44 209c-1.5-.09-.85-1.24-1-2h1Z"
            className="templesOnly_svg__cls-3379"
          />
          <ellipse
            cx={43.54}
            cy={186.04}
            className="templesOnly_svg__cls-3355"
            rx={0.71}
            ry={1.41}
          />
          <path
            d="m43 189 1 1c-.3-.29-.63-.63-1-1M43 187h1l-1 1ZM44 185h-1l1-1Z"
            className="templesOnly_svg__cls-3357"
          />
          <path
            d="M44 216c-.2-.41-.39-.83-.66-1.41 1.11-1.61.53-3.64.66-5.59l2-1 1 1v3l-2-1v26h-1c-.35-2.17.8-4.56-.69-6.24 1.31-3.3.4-6.59.69-9.76z"
            className="templesOnly_svg__cls-3380"
          />
          <path
            d="M44 239h-1l1-1ZM44 237h1l-1 1Z"
            className="templesOnly_svg__cls-3381"
          />
          <path
            d="M44 216v1l-.83-.67Z"
            style={{
              fill: "#db9b5f",
            }}
          />
          <path
            d="m44 238 1-1v-2h2c.61.06 1.15.05.59 1a7.4 7.4 0 0 0-.59 2l-1 .76c.33.41.66.83 1 1.24.15.76-.5 1.91 1 2v1h-1l-1 .76c.33.41.66.83 1 1.24v2h-1l-2-3v-1a2.48 2.48 0 0 0 0-4Z"
            style={{
              fill: "#b36628",
            }}
          />
          <path
            d="m44 244 2 3-1 1v2h-1c0-1.66.33-3.4-1-4.85a8.6 8.6 0 0 1 1-1.15"
            className="templesOnly_svg__cls-3381"
          />
          <path
            d="M44 250h1c.38 1-.93 2.53 1 3v1l-1 1v1h-1Z"
            className="templesOnly_svg__cls-3384"
          />
          <path
            d="M44 239a2.48 2.48 0 0 1 0 4Z"
            className="templesOnly_svg__cls-3381"
          />
          <path
            d="M46 188v-2l-1-1v-7h1l1 1-1 .76c.33.41.66.83 1 1.24v4c-.35 1 1 2.57-1 3"
            style={{
              fill: "#b26427",
            }}
          />
          <path
            d="M46 178h-1v-10h1l1 1c0 2.05-1.71 3.83-1 6z"
            style={{
              fill: "#be7134",
            }}
          />
          <path
            d="M46 168h-1c-.08-2 .47-4.19-1-6l1-1h1Z"
            style={{
              fill: "#ac6429",
            }}
          />
          <path
            d="M46 161h-1a5.4 5.4 0 0 0-1-4 9.4 9.4 0 0 0 .94-1 2 2 0 0 0 .15.15l.81-.69-.31-.32a6 6 0 0 0-.59.86 5.6 5.6 0 0 1-.94 0v-2c1.34 0 1-1 1-1.75V138c.33.42.92.83 1 1.28.11 1.81 0 3.63.09 5.44 0 .45.62.85 1 1.28v14Z"
            style={{
              fill: "#b86c30",
            }}
          />
          <path
            d="M47 146c-.34-.43-.93-.83-1-1.28-.11-1.81 0-3.63-.09-5.44 0-.45-.62-.86-1-1.28H44v-11c.94 1.22 1 1.44 1.13 3.76L47 132c-.27 1.51.73 3.31-1 4.5 1.73 1.19.73 3 1 4.5Z"
            style={{
              fill: "#bb6829",
            }}
          />
          <path d="M44 156h1l-1 1Z" className="templesOnly_svg__cls-3390" />
          <circle
            cx={43.54}
            cy={127.54}
            r={0.71}
            className="templesOnly_svg__cls-3356"
          />
          <path
            d="M48 267a8 8 0 0 0-.75-1c-.73-.69-1.5-1.34-2.25-2h1c2.24.21 2.79.76 3 3Z"
            className="templesOnly_svg__cls-3365"
          />
          <path
            d="M44 267h4v2a5.35 5.35 0 0 0-4-1Z"
            style={{
              fill: "#e7b67c",
            }}
          />
          <path
            d="M46 264h-2v-1h1Z"
            style={{
              fill: "#9f652b",
            }}
          />
          <circle
            cx={43.54}
            cy={267.54}
            r={0.71}
            style={{
              fill: "#e8b685",
            }}
          />
          <path
            d="M43 269h-2c.08-1.5 1.24-.85 2-1Z"
            style={{
              fill: "#e4b480",
            }}
          />
          <path
            d="M40 269c-.76-.15-1.92.5-2-1h2Z"
            style={{
              fill: "#d2a973",
            }}
          />
          <path
            d="m46 264-1-1v-1h3l1 1c.08 1.5 1.24.85 2 1v3h3l-1 1h-1.52c-.92 1.11.45 2.77-1.44 3a17.7 17.7 0 0 0 0-2.82c-.07-.43-.62-.79-1-1.18-.21-2.2-.76-2.75-3.04-3"
            className="templesOnly_svg__cls-3396"
          />
          <path
            d="M48 262h-1l-1-2 2-1h1v2Z"
            style={{
              fill: "#c77b34",
            }}
          />
          <path
            d="m48 259-2 1-1-1c1.49-.09.84-1.24 1-2h1c1.53.13.88 1.28 1 2"
            style={{
              fill: "#bf732e",
            }}
          />
          <path
            d="M46 257c-.16.76.49 1.91-1 2v-2Z"
            style={{
              fill: "#b16723",
            }}
          />
          <path
            d="M46 257h-1v-2h1Z"
            style={{
              fill: "#a95f1e",
            }}
          />
          <path
            d="M43 117v-1l1-1v-2l2-2v-1h1v3l-1 1v3Z"
            style={{
              fill: "#a04a16",
            }}
          />
          <path
            d="M43 117h3l1 1h1v4h-1l-2-2v-1a15 15 0 0 1-1.24-1 8 8 0 0 1-.76-1"
            className="templesOnly_svg__cls-1505"
          />
          <path d="M45 119v1h-2v-1Z" className="templesOnly_svg__cls-3344" />
          <path
            d="M47 141c-.27-1.52.73-3.31-1-4.5 1.73-1.19.73-3 1-4.5-.13-1.18.35-2.42-.85-3.46-.48-.42-.34-1.5.85-1.54h4c.38 1-.93 2.53 1 3h1l-1 2 1 2-1 2 1 2h-3c-1.34 0-.81 1.06-1 1.73a5 5 0 0 1-1 1.27Z"
            style={{
              fill: "#bf4d1b",
            }}
          />
          <path
            d="M48 126v-2h3c1.14 1.79 2.59.89 4 .8V122h1v8.76c0 .42-.62.83-1 1.24-.21-1.85.84-4.21-2-5h-1c-.4-.33-.75-.88-1.19-1a17.5 17.5 0 0 0-2.81 0"
            style={{
              fill: "#a74d20",
            }}
          />
          <path
            d="M51 124h-3l-1-1 1-1v-4h1l1 1c-.34.67-.67 1.33-1 2 .08 1.5 1.24.85 2 1z"
            style={{
              fill: "#812a09",
            }}
          />
          <path
            d="M44 120h1l2 2-1 1a2.46 2.46 0 0 1-2-3"
            style={{
              fill: "#8c3303",
            }}
          />
          <path
            d="M48 126a17.5 17.5 0 0 1 2.81 0c.44.07.79.62 1.19 1h-5Z"
            style={{
              fill: "#af4113",
            }}
          />
          <path
            d="m46 123 1-1h1l-1 1Z"
            style={{
              fill: "#822601",
            }}
          />
          <path
            d="M43 269v-1h1a5.35 5.35 0 0 1 4 1v4h-5v-3h2.82l.08-.71Z"
            className="templesOnly_svg__cls-3360"
          />
          <path
            d="M43 270v3h-1l-.33-.83-.67.83h-1v-1Z"
            style={{
              fill: "#e8b580",
            }}
          />
          <path
            d="M40 272v2h-2v-2Z"
            style={{
              fill: "#cba265",
            }}
          />
          <path
            d="m32 280 .67-.83.33.83Z"
            style={{
              fill: "#e9ba86",
            }}
          />
          <path
            d="M38 274h2v1h-2Z"
            style={{
              fill: "#edc181",
            }}
          />
          <ellipse
            cx={38.54}
            cy={276.04}
            rx={0.71}
            ry={1.41}
            style={{
              fill: "#f4c786",
            }}
          />
          <path
            d="m38 278-1-1h1Z"
            style={{
              fill: "#ddad70",
            }}
          />
          <path
            d="M40 279h-1v-2c1.53.13.88 1.28 1 2"
            style={{
              fill: "#f8c88a",
            }}
          />
          <circle
            cx={38.54}
            cy={277.54}
            r={0.71}
            className="templesOnly_svg__cls-3415"
          />
          <path
            d="m47 209-1-1v-5h-2v-1l3-1c2.34.73.2 1.79.61 2.71-.29 1.8 1.7 3.65-.61 5.29"
            style={{
              fill: "#ca7937",
            }}
          />
          <path
            d="m47 201-3 1v-5h1c.08 1.5 1.24.85 2 1z"
            style={{
              fill: "#b96f2e",
            }}
          />
          <path
            d="M45 197h-1v-4l2 1-1 2Z"
            className="templesOnly_svg__cls-3378"
          />
          <path
            d="m46 194-2-1v-1l1.74-1c.08.64.17 1.3.26 2Z"
            style={{
              fill: "#a55f1f",
            }}
          />
          <path
            d="M47 200v-7c-.34-1.67-.67-3.33-1-5 1.92-.47.61-2 1-3 .33.33.66.67 1 1 .25 1.81.51 3.62.79 5.67l-.7.75L49 194q-2.055 1.5 0 3v1a8.5 8.5 0 0 0-1 .76c-.33.42-.63.87-1 1.24"
            style={{
              fill: "#c0682b",
            }}
          />
          <path
            d="M47 193v5c-.76-.15-1.92.5-2-1l.82-.33L45 196l1-2v-1Z"
            style={{
              fill: "#ae6321",
            }}
          />
          <path
            d="m45 185 1 1c-.3-.29-.63-.63-1-1"
            style={{
              fill: "#a95e22",
            }}
          />
          <path
            d="M46 206v2l-2 1v-2Z"
            style={{
              fill: "#b26c2a",
            }}
          />
          <path
            d="M47 200c.33-.41.63-.86 1-1.24a8.5 8.5 0 0 1 1-.76v38c-.24.86-.47 1.71-.74 2.71L49 240v5h-1v-3c-.16-.76.49-1.91-1-2v-2a7.4 7.4 0 0 1 .59-2c.56-.91 0-.9-.59-1-.39-1 .92-2.53-1-3v-1h2l-1.23-2.17a2.83 2.83 0 0 0 .62-4c-.6-1-.32-2.51-.43-3.79 0-1.66-.34-3.4 1-4.85A9 9 0 0 0 47 215v-6c2.27-1.68.28-3.53.61-5.29-.41-.92 1.73-2-.61-2.71Z"
            style={{
              fill: "#cc732f",
            }}
          />
          <path
            d="M47 221c.11 1.28-.17 2.8.43 3.79a2.83 2.83 0 0 1-.62 4l1.27 2.21H45v-4l.82-.33L45 226v-4ZM46 232c1.92.47.61 2 1 3h-2v-1c1.53 0 .88-1.2 1-2"
            className="templesOnly_svg__cls-3424"
          />
          <path
            d="M46 232c-.16.76.49 1.91-1 2v-3h1Z"
            style={{
              fill: "#b1672a",
            }}
          />
          <path
            d="m45 226 .82.67-.82.33Z"
            style={{
              fill: "#aa6124",
            }}
          />
          <path
            d="m45 217 .82.67-.82.33Z"
            style={{
              fill: "#a45b1c",
            }}
          />
          <path
            d="M48 243v4a37 37 0 0 0 0 3.8c.05.43.62.8 1 1.2-.16.76.49 1.91-1 2h-1v-11Z"
            className="templesOnly_svg__cls-3428"
          />
          <path
            d="M47 247v2c-.34-.33-.67-.67-1-1v-1ZM47 243v2c-.34-.41-.67-.83-1-1.24ZM47 240c1.49.09.84 1.24 1 2-1.46 0-.81-1.2-1-2M47 238v2c-.34-.41-.67-.83-1-1.24Z"
            className="templesOnly_svg__cls-3381"
          />
          <path
            d="M46 248c.33.33.66.67 1 1v1c-1.93.47-.62 2-1 3-1.93-.47-.62-2-1-3v-2Z"
            className="templesOnly_svg__cls-3429"
          />
          <path d="M46 248h-1l1-1Z" className="templesOnly_svg__cls-3384" />
          <path
            d="M46 253c.38-1-.93-2.53 1-3v5h-1z"
            style={{
              fill: "#bc6b30",
            }}
          />
          <path d="M46 254v1h-1Z" className="templesOnly_svg__cls-3429" />
          <path
            d="M48 186c-.34-.33-.67-.67-1-1v-4h2a37 37 0 0 1 0 3.8c0 .47-.63.84-1 1.2"
            style={{
              fill: "#c16929",
            }}
          />
          <path
            d="M46 178v-2l3 1v2h-2Z"
            className="templesOnly_svg__cls-3432"
          />
          <path
            d="M47 179h2v2h-2c-.34-.41-.67-.83-1-1.24Z"
            style={{
              fill: "#b46323",
            }}
          />
          <path
            d="M46 175c-.71-2.17 1-3.95 1-6v-2h2v1l-1 .76c.33.41.66.83 1 1.24v4Z"
            className="templesOnly_svg__cls-3432"
          />
          <path
            d="m46 175 3-1v3l-3-1Z"
            style={{
              fill: "#c46823",
            }}
          />
          <path
            d="M47 168v1l-1-1Z"
            style={{
              fill: "#c06b2b",
            }}
          />
          <path
            d="M47 168h-1v-7l1-1c.23.86.46 1.73.72 2.69-1.46 1-.46 2.8-.72 4.31Z"
            style={{
              fill: "#ad5f20",
            }}
          />
          <path
            d="M47 167c.26-1.51-.74-3.3.72-4.31-.26-1-.49-1.83-.72-2.69v-5h2v12Z"
            className="templesOnly_svg__cls-3437"
          />
          <path
            d="M47 141h1v1a37 37 0 0 0 0 3.8c.05.43.62.8 1 1.2v1c-1.94.59-.59 2.19-1 3.25-.36.91.94 2.41-1 2.75z"
            style={{
              fill: "#ca6726",
            }}
          />
          <path
            d="M47 154c1.93-.34.63-1.84 1-2.75.42-1.06-.93-2.66 1-3.25v1c.11 1.92-.46 3.93.81 5.68L49 155h-2Z"
            style={{
              fill: "#d36929",
            }}
          />
          <path
            d="m44.93 156 .7-.82.31.32-.81.69Z"
            className="templesOnly_svg__cls-3390"
          />
          <path
            d="M48 269v-2h1c-.12.8.53 2-1 2"
            className="templesOnly_svg__cls-3360"
          />
          <path
            d="M51 265v-1h2a17.5 17.5 0 0 0 2.81-.05c.44-.07.79-.62 1.19-.95h1l2 4-1 1h-1l-1.33-1.81L54 270l-1-2 1-1a2.47 2.47 0 0 0-3-2"
            className="templesOnly_svg__cls-3440"
          />
          <path
            d="M48 269c1.49-.09.84-1.24 1-2 .33.39.88.75 1 1.18a17.7 17.7 0 0 1 0 2.82c-.34.4-.93.79-1 1.21-.11 1.59 0 3.19 0 4.79h-1z"
            style={{
              fill: "#c58444",
            }}
          />
          <path
            d="m53 268 1 2-2 3-2-1v-1c1.89-.23.52-1.89 1.44-3Z"
            style={{
              fill: "#a45c1c",
            }}
          />
          <path
            d="M53 264h-2c-.76-.15-1.92.5-2-1l1-1h1a8 8 0 0 0 .76 1 15 15 0 0 0 1.24 1"
            className="templesOnly_svg__cls-3443"
          />
          <path
            d="M51 265a2.47 2.47 0 0 1 3 2h-3Z"
            style={{
              fill: "#a05d26",
            }}
          />
          <path
            d="m50 262-1 1-1-1Z"
            style={{
              fill: "#b06626",
            }}
          />
          <path
            d="M48 259c-.16-.76.49-1.91-1-2v-1l1-1c1.92.47.61 2 1 3v1Z"
            className="templesOnly_svg__cls-3428"
          />
          <path
            d="M49 259v-1h1v3h-1Z"
            style={{
              fill: "#cf7934",
            }}
          />
          <path
            d="M49 261h2v1h-3Z"
            style={{
              fill: "#be712e",
            }}
          />
          <path
            d="M47 256v1h-1v-2h1Z"
            style={{
              fill: "#b96a2a",
            }}
          />
          <path
            d="M46 115h3v1h-3Z"
            style={{
              fill: "#a54216",
            }}
          />
          <path
            d="M46 116h2c-.34.67-.67 1.33-1 2l-1-1Z"
            style={{
              fill: "#8e2e02",
            }}
          />
          <path
            d="M47 118c.33-.67.66-1.33 1-2h1v2z"
            style={{
              fill: "#95360f",
            }}
          />
          <path
            d="m53 138-1-2 1-2h1a17.7 17.7 0 0 0 0 2.82c.07.43.62.79 1 1.18q.49 5.51 1 11h-1c-1.5-.09-.85-1.24-1-2q-.47-4.46-1-9"
            style={{
              fill: "#c3581e",
            }}
          />
          <path
            d="M53 138q.49 4.5 1 9l-2 2h-1c-.27-1.51.73-3.3-.73-4.31L51 142c.1-.61.18-1.23.33-1.82.19-.74.44-1.46.67-2.18Z"
            className="templesOnly_svg__cls-3453"
          />
          <path
            d="M52 138c-.23.72-.48 1.44-.67 2.18-.15.59-.23 1.21-.33 1.82h-1v-4Z"
            style={{
              fill: "#c24918",
            }}
          />
          <path
            d="M54 134h-1l-1-2 1-2c.33.39.88.75 1 1.18a17.7 17.7 0 0 1 0 2.82"
            className="templesOnly_svg__cls-3455"
          />
          <path
            d="M50 138v4h-2v-1a5 5 0 0 0 1-1.27c.23-.63-.3-1.68 1-1.73"
            className="templesOnly_svg__cls-3453"
          />
          <path
            d="M51 127h2v1c-1.5.09-.85 1.24-1 2-1.89-.43-.58-2-1-3"
            style={{
              fill: "#aa3e13",
            }}
          />
          <path
            d="M52 130c.15-.76-.5-1.91 1-2v2Z"
            className="templesOnly_svg__cls-3455"
          />
          <path
            d="M51 123v-1c-.09-1.5-1.25-.85-2-1 .33-.67.66-1.33 1-2l1-1h2l1 1v1l-2.75 2H55v2.8c-1.41.09-2.86 1-4-.8l2.9-.29-.08-.71Z"
            style={{
              fill: "#86320e",
            }}
          />
          <path
            d="M55 132v6c-.34-.39-.89-.75-1-1.18a17.7 17.7 0 0 1 0-2.82 17.7 17.7 0 0 0 0-2.82c-.07-.43-.62-.79-1-1.18v-3c2.88.83 1.83 3.19 2 5"
            style={{
              fill: "#b15015",
            }}
          />
          <path
            d="M54 120v-1l2 1 .87.39L56 122h-2Z"
            style={{
              fill: "#792d0b",
            }}
          />
          <path
            d="m51 118-1 1-1-1 2-1Z"
            style={{
              fill: "#681c01",
            }}
          />
          <path
            d="M51 123h2.82l.08.71-2.9.29Z"
            style={{
              fill: "#7e2404",
            }}
          />
          <path
            d="M49 121c.75.15 1.91-.5 2 1-.72-.11-1.88.54-2-1"
            style={{
              fill: "#8d3b13",
            }}
          />
          <path
            d="M44 273h2c.15.76-.5 1.91 1 2v2h-2v-1c-.16-.76.49-1.91-1-2Z"
            style={{
              fill: "#ebb577",
            }}
          />
          <path
            d="M47 277v-4h1v4Z"
            style={{
              fill: "#e8ad6e",
            }}
          />
          <path
            d="M47 273v2c-1.5-.09-.85-1.24-1-2Z"
            style={{
              fill: "#f4bf80",
            }}
          />
          <path
            d="M44 273v1h-2v-1z"
            style={{
              fill: "#f4be84",
            }}
          />
          <path
            d="M42 273v1l-1 1h-1v-2z"
            style={{
              fill: "#e6b577",
            }}
          />
          <path
            d="M42 273h-1l.67-.83Z"
            style={{
              fill: "#f5c289",
            }}
          />
          <path
            d="M42 279h-2c-.16-.76.49-1.91-1-2v-2h1l.32.83.68-.83 1-1h2v5Z"
            className="templesOnly_svg__cls-3415"
          />
          <path
            d="m45 196 .82.67-.82.33Z"
            style={{
              fill: "#a35d1b",
            }}
          />
          <path
            d="M49 202v-8l1-1h1l1.15 2.33-1.14 1.19c1.4.86.9 2.25 1 3.48l-2 2Z"
            className="templesOnly_svg__cls-1245"
          />
          <path
            d="m50 193-1 1-.91-1.58.7-.75c-.28-2.05-.54-3.86-.79-5.67.33-.4.91-.77 1-1.2a37 37 0 0 0 0-3.8v-2h1z"
            style={{
              fill: "#cd682b",
            }}
          />
          <path
            d="M49 194v3c-1.33-1-1.33-1.95 0-3"
            style={{
              fill: "#ce7033",
            }}
          />
          <path
            d="M49 217v-10l3-1v2l-.83.33.83.67 1 1v1h-1.69c-.76 2.27.63 2 1.73 2a37 37 0 0 0 0 3.8c.05.43.62.8 1 1.2v3c-.16.76.49 1.91-1 2-.16-.31-.32-.62-1-2v5l-1 .76L52 228v4h-2v-2l.82-.33L50 229v-7a17.8 17.8 0 0 0 1.52-5.88L50 217Z"
            style={{
              fill: "#db6d2a",
            }}
          />
          <path
            d="M50 222v10a5.3 5.3 0 0 0 1 4h-2v-19h1Z"
            style={{
              fill: "#d2722c",
            }}
          />
          <path
            d="m52 206-3 1v-5h1v2h2Z"
            className="templesOnly_svg__cls-3474"
          />
          <path
            d="M49 236h2v4h-2l-.74-1.29c.31-.96.54-1.81.74-2.71"
            style={{
              fill: "#d47830",
            }}
          />
          <path
            d="M49 245v-4h1v4ZM48 247v-2h1c.33.33.66.67 1 1 0 1.54-1.21.89-2 1"
            className="templesOnly_svg__cls-3476"
          />
          <path d="M50 241h-1v-1h2Z" className="templesOnly_svg__cls-3477" />
          <path
            d="m47 215-.83-.67.83-.33Z"
            className="templesOnly_svg__cls-3380"
          />
          <path
            d="M48 247c.75-.15 1.91.5 2-1v-2c.33.33.66.67 1 1v9h-1c-.16-.76.49-1.91-1-2-.34-.4-.91-.77-1-1.2a37 37 0 0 1 0-3.8"
            className="templesOnly_svg__cls-3477"
          />
          <path
            d="M49 252c1.49.09.84 1.24 1 2v4h-1c-.39-1 .92-2.53-1-3v-1c1.53 0 .88-1.2 1-2"
            style={{
              fill: "#c9702a",
            }}
          />
          <path
            d="M48 254v1l-1 1v-2Z"
            style={{
              fill: "#c37331",
            }}
          />
          <path
            d="M50 179h-1v-12a5 5 0 0 1 1 1.27c.23.67-.3 1.72 1 1.73-1.32 1.47-1 3.27-1 5Z"
            style={{
              fill: "#d56729",
            }}
          />
          <path
            d="M49 168v2c-.34-.41-.67-.83-1-1.24Z"
            className="templesOnly_svg__cls-3437"
          />
          <path
            d="M51 170c-1.34 0-.81-1.06-1-1.73a5 5 0 0 0-1-1.27v-5c1.92-.47.61-2 1-3 1.49.09.84 1.24 1 2a5.4 5.4 0 0 1 1 4c.22.72.47 1.44.66 2.18.15.59.23 1.21.34 1.82-1.21 13.64-2.12 24-2 1"
            style={{
              fill: "#d25b26",
            }}
          />
          <path
            d="m49 155 .81-.32C48.58 153 49.15 151 49 149h1a17.7 17.7 0 0 0 0 2.82c.07.43.62.79 1 1.18.33 1 .66 2 1 3-.34.25-1 .51-1 .76 0 1.68-1.18 1.15-2 1.24Z"
            className="templesOnly_svg__cls-3482"
          />
          <path
            d="M49 158c.86-.09 2.07.44 2-1.24 0-.25.62-.51 1-.76h2c-.34 1.67-.67 3.33-1 5h-2c-.16-.76.49-1.91-1-2h-1Z"
            style={{
              fill: "#c8511c",
            }}
          />
          <path
            d="M49 159h1c-.39 1 .92 2.53-1 3Z"
            className="templesOnly_svg__cls-3482"
          />
          <path
            d="M50 149h-1v-1c1.39-.24 1.16-1 .51-2.1L49 147c-.34-.4-.91-.77-1-1.2a37 37 0 0 1 0-3.8h3l-.73 2.69c1.46 1 .46 2.8.73 4.31Z"
            style={{
              fill: "#cf5821",
            }}
          />
          <path
            d="m49 147 .51-1.1c.65 1.09.88 1.86-.51 2.1Z"
            className="templesOnly_svg__cls-3453"
          />
          <path
            d="M56 258v3c.15.76-.5 1.91 1 2-.4.33-.75.88-1.19.95A17.5 17.5 0 0 1 53 264a15 15 0 0 1-1.24-1 8 8 0 0 1-.76-1h1l2.43-.43L53 261v-1h1c1.49-.09.84-1.24 1-2Z"
            style={{
              fill: "#d16f30",
            }}
          />
          <path
            d="m54 270 2.67-3.81L58 268c-.11.61-.19 1.23-.34 1.82s-.44 1.46-.66 2.18h-3Z"
            className="templesOnly_svg__cls-1299"
          />
          <path
            d="M57 272c.22-.72.47-1.44.66-2.18s.23-1.21.34-1.82h2a16.6 16.6 0 0 0-1 3 31 31 0 0 0 0 4v1l-1-1c-.35-.94 1-2.49-1-3"
            style={{
              fill: "#ba6f30",
            }}
          />
          <path
            d="M60 267v1h-1Z"
            style={{
              fill: "#a46422",
            }}
          />
          <path
            d="M50 271v5c-.16.76.49 1.91-1 2v-1c0-1.6-.07-3.2 0-4.79.11-.38.7-.77 1-1.21"
            className="templesOnly_svg__cls-3396"
          />
          <path
            d="M49 277v3h-1v-3Z"
            style={{
              fill: "#ba8854",
            }}
          />
          <path
            d="M57 272c1.92.47.61 2 1 3l-1.65-1.89c-.39.53-.87 1.21-1.35 1.89h-1c-.09-1.5-1.25-.85-2-1v-1l2-3v2Z"
            className="templesOnly_svg__cls-3440"
          />
          <path
            d="M52 273v1l-1 1-1 1v-4Z"
            style={{
              fill: "#a35415",
            }}
          />
          <path
            d="M54 260h-4v-2h1l1 1h2Z"
            style={{
              fill: "#d77c32",
            }}
          />
          <circle
            cx={50.54}
            cy={260.54}
            r={0.71}
            style={{
              fill: "#db823f",
            }}
          />
          <path
            d="M51 261v-1h2v1l-1 1h-1Z"
            className="templesOnly_svg__cls-3443"
          />
          <path
            d="m51 117-2 1v-4l1-1h1v1l1 1c-.3.71-.63 1.37-1 2"
            className="templesOnly_svg__cls-3334"
          />
          <path
            d="M56 149v23h-1v-23Z"
            style={{
              fill: "#d26c32",
            }}
          />
          <path
            d="M55 149v5h-2c0-1.63.05-2.93 0-4.22 0-.28-.62-.52-1-.78l2-2c.19.8-.46 2 1 2"
            style={{
              fill: "#d0571e",
            }}
          />
          <path
            d="M52 149c.33.26.93.5 1 .78.1 1.29 0 2.59 0 4.22h2v2h-3c-.34-1-.67-2-1-3v-4Z"
            className="templesOnly_svg__cls-3494"
          />
          <path
            d="M51 246v-1l1-.76c-.34-.41-.67-.83-1-1.24s-.67-.67-1-1v-1l1-1v-4a5.3 5.3 0 0 1-1-4h2l.51 1 1.32-1.4c-1.68-2.84-.46-5.82-.83-8.62 1.49-.09.84-1.24 1-2h1c-.23 1.9.61 4-.89 5.76L56 228v23l-2 2h-1v-1c-.34-.33-.67-.67-1-1v-1h3c-.09-1.58-.15-2.8-.21-4zm2.16-12.56v9.64l2-.39-1.36-1.44 1.2-1.81c-2.08-1.35-.15-3.72-1.8-5.96ZM54.7 244h-.33v1h.33Z"
            className="templesOnly_svg__cls-3495"
          />
          <path
            d="M50 183v-2c.33-.25 1-.51 1-.76 0-1.68 1.18-1.16 2-1.24-.31.52-.61 1-.89 1.54 1.28.18.16 3.31 2.89 2.13V180h1v14l-.83.33.83.67v2c-2.85.79-1.8 3.15-2 5h-2v-2c-.09-1.23.41-2.62-1-3.48l1.14-1.19L51 193c.33-.24.89-.43 1-.73.52-2.21-.54-4.19-1-6.27 1.8-1.11.82-2.59.86-4.08Z"
            style={{
              fill: "#d65f24",
            }}
          />
          <path
            d="M55 221h-1v-12.11l2 1.11v10Z"
            className="templesOnly_svg__cls-3497"
          />
          <path
            d="m56 210-2-1.15V218c-.34-.4-.91-.77-1-1.2a37 37 0 0 1 0-3.8v-3c0-1.6.06-3.2 0-4.79 0-.42-.62-.81-1-1.21v-1l1-1h1c.11 2-.27 4 .28 6.09L56 206Z"
            style={{
              fill: "#db6629",
            }}
          />
          <path
            d="m56 206-1.72 2.09c-.55-2-.17-4.09-.28-6.09.2-1.85-.85-4.21 2-5Z"
            className="templesOnly_svg__cls-3497"
          />
          <path
            d="M53 179c-.87.08-2.08-.44-2 1.24 0 .25-.62.51-1 .76v-6a8 8 0 0 1 1 .75c.69.73 1.34 1.5 2 2.25h2v-2h1v4h-1Z"
            className="templesOnly_svg__cls-3499"
          />
          <path
            d="m55 221 1-1v8l-1.89-1.24c1.54-1.76.7-3.82.89-5.76"
            className="templesOnly_svg__cls-3500"
          />
          <path
            d="m54 253 2-2v6l-1 1h-1v-2l1-1v-1c-.3-.29-.63-.63-1-1"
            style={{
              fill: "#d7742a",
            }}
          />
          <path d="M56 176h-1v-4h1Z" className="templesOnly_svg__cls-3502" />
          <path d="m55 258 1-1v1Z" className="templesOnly_svg__cls-3503" />
          <path
            d="m56 195-.83-.67.83-.33Z"
            className="templesOnly_svg__cls-3502"
          />
          <path
            d="M56 114v1.71l-3 .51V118h-2v-1c.33-.67.66-1.33 1-2v-1h1l1 1 1-1Z"
            style={{
              fill: "#641d04",
            }}
          />
          <path
            d="M54 120v2h-2.71Z"
            style={{
              fill: "#8a3919",
            }}
          />
          <path
            d="m53 118 1 1Z"
            style={{
              fill: "#7b2903",
            }}
          />
          <path
            d="M48 277v2h-3c.33-.67.66-1.33 1-2z"
            style={{
              fill: "#eab77c",
            }}
          />
          <path
            d="M46 277c-.34.67-.67 1.33-1 2h-1v-2z"
            style={{
              fill: "#fac489",
            }}
          />
          <path
            d="M44 276v-2c1.49.09.84 1.24 1 2Z"
            style={{
              fill: "#f5ba7e",
            }}
          />
          <circle
            cx={44.54}
            cy={276.54}
            r={0.71}
            style={{
              fill: "#dfa469",
            }}
          />
          <path
            d="m41 275-.68.83L40 275Z"
            style={{
              fill: "#dead6c",
            }}
          />
          <path
            d="m42 274-1 1Z"
            style={{
              fill: "#f6c082",
            }}
          />
          <path
            d="M52 200v3l-2-1Z"
            style={{
              fill: "#de6e2d",
            }}
          />
          <path
            d="M50 193v-2c1.49.09.84 1.24 1 2Z"
            style={{
              fill: "#d26123",
            }}
          />
          <path
            d="m50 183 1.9-1c0 1.49.94 3-.86 4.08l-1-1Z"
            className="templesOnly_svg__cls-3499"
          />
          <path
            d="m50 185 1 1h-1Z"
            style={{
              fill: "#d05d22",
            }}
          />
          <path
            d="M53 223c.37 2.8-.85 5.78.83 8.62l-1.32 1.4L52 232v-11c.72 1.42.88 1.73 1 2"
            className="templesOnly_svg__cls-3500"
          />
          <path
            d="M50 222v-5l1.52-.88A17.8 17.8 0 0 1 50 222"
            style={{
              fill: "#d56c24",
            }}
          />
          <path
            d="M52 204c.33.4.92.79 1 1.21.11 1.59 0 3.19 0 4.79l-1-1z"
            className="templesOnly_svg__cls-3517"
          />
          <path
            d="M53 211v2c-1.1 0-2.49.27-1.73-2Z"
            style={{
              fill: "#e0702d",
            }}
          />
          <path
            d="M52 226v2l-1-1.24ZM50 230v-1l.82.67Z"
            className="templesOnly_svg__cls-3495"
          />
          <path d="M52 208v1l-.83-.67Z" className="templesOnly_svg__cls-3474" />
          <path d="m50 202 2 1v1h-2Z" className="templesOnly_svg__cls-3517" />
          <path
            d="M51 243c.33.41.66.83 1 1.24l-1 .76c-.34-.33-.67-.67-1-1v-1Z"
            style={{
              fill: "#d36820",
            }}
          />
          <path
            d="M50 245v1c-.34-.33-.67-.67-1-1Z"
            style={{
              fill: "#dc7b34",
            }}
          />
          <path
            d="M51 243h-1v-1c.37.37.7.71 1 1"
            className="templesOnly_svg__cls-3477"
          />
          <path d="M53 250h-2v-4h2Z" className="templesOnly_svg__cls-3521" />
          <path
            d="M55 254v1l-1 1h-1c-.09-1.5-1.25-.85-2-1v-2h1l.32.83.68-.83h1Z"
            style={{
              fill: "#de7a34",
            }}
          />
          <path
            d="M51 254v4h-1v-4Z"
            style={{
              fill: "#ce722b",
            }}
          />
          <path
            d="M52 253h-1v-2h1c.33.33.66.67 1 1Z"
            className="templesOnly_svg__cls-3521"
          />
          <circle
            cx={51.54}
            cy={250.54}
            r={0.71}
            style={{
              fill: "#e17636",
            }}
          />
          <path
            d="M53 178c-.67-.75-1.32-1.52-2-2.25a8 8 0 0 0-1-.75c0-1.73-.32-3.53 1-5l2-1z"
            className="templesOnly_svg__cls-3525"
          />
          <path
            d="M54 156h1v5c-.34.41-.94.81-1 1.23-.1 2.25 0 4.51 0 6.77h-1c-.11-.61-.19-1.23-.34-1.82-.19-.74-.44-1.46-.66-2.18.33-.39.88-.75 1-1.18a17.7 17.7 0 0 0 0-2.82c.37-1.63.7-3.29 1-5"
            style={{
              fill: "#d25423",
            }}
          />
          <path
            d="M53 161a17.7 17.7 0 0 1 0 2.82c-.07.43-.62.79-1 1.18a5.4 5.4 0 0 0-1-4Z"
            style={{
              fill: "#cd531f",
            }}
          />
          <path
            d="M51 149v4c-.34-.39-.89-.75-1-1.18a17.7 17.7 0 0 1 0-2.82Z"
            style={{
              fill: "#d05924",
            }}
          />
          <path
            d="m52 262 1-1 1.43.57Z"
            style={{
              fill: "#be6b23",
            }}
          />
          <path
            d="M54 258h1c-.16.76.49 1.91-1 2z"
            className="templesOnly_svg__cls-3503"
          />
          <path
            d="m50 276 1-1 1-1c.75.15 1.91-.5 2 1l.32.83.68-.83c.48-.68 1-1.36 1.35-1.89L58 275l1 1v2h-1c-.09-1.5-1.25-.85-2-1h-5v2h-2v-1c1.53 0 .88-1.2 1-2"
            style={{
              fill: "#a05320",
            }}
          />
          <path
            d="m55 275-.68.83L54 275Z"
            style={{
              fill: "#9a4d1c",
            }}
          />
          <path
            d="m52 274-1 1Z"
            style={{
              fill: "#9b4a10",
            }}
          />
          <path
            d="M51 258v-2h1v3Z"
            style={{
              fill: "#d26f25",
            }}
          />
          <ellipse
            cx={52.54}
            cy={257.54}
            rx={0.71}
            ry={2.12}
            style={{
              fill: "#dd7529",
            }}
          />
          <path
            d="M53 259v-3h1v3Z"
            style={{
              fill: "#ed8235",
            }}
          />
          <path
            d="M54 169c0-2.26-.06-4.52 0-6.77 0-.42.62-.82 1-1.23v8Z"
            className="templesOnly_svg__cls-3494"
          />
          <path
            d="M54 169h1v6c-.34-.4-.91-.77-1-1.2a37 37 0 0 1 0-3.8Z"
            className="templesOnly_svg__cls-3525"
          />
          <path
            d="M53.2 233.48c1.65 2.24-.28 4.61 1.77 6l-1.13 1.85 1.36 1.44-2 .39Z"
            style={{
              fill: "#d76828",
            }}
          />
          <path
            d="M53 250v-4h1.83c.06 1.2.12 2.42.21 4Z"
            style={{
              fill: "#d56826",
            }}
          />
          <path
            d="m52 253 1-1v1l-.68.83Z"
            style={{
              fill: "#ea8037",
            }}
          />
          <ellipse
            cx={54.54}
            cy={244.54}
            rx={0.24}
            ry={0.71}
            style={{
              fill: "#d97232",
            }}
          />
          <path
            d="m53 179 2 1v2.67c-2.73 1.18-1.61-2-2.89-2.13.32-.46.62-.98.89-1.54"
            style={{
              fill: "#d15820",
            }}
          />
          <path d="M52 203v-1h1Z" className="templesOnly_svg__cls-3517" />
          <path
            d="M54 170a37 37 0 0 0 0 3.8c.05.43.62.8 1 1.2v3h-2v-8Z"
            style={{
              fill: "#d0591f",
            }}
          />
          <path
            d="m54 256 1-1ZM55 254l-1-1c.37.37.7.71 1 1"
            className="templesOnly_svg__cls-3503"
          />
          <path
            d="M53 256h-2v-1c.79.19 2-.46 2 1"
            style={{
              fill: "#d7732d",
            }}
          />
          <circle
            cx={53.54}
            cy={169.54}
            r={0.71}
            className="templesOnly_svg__cls-3494"
          />
          <path
            d="M53 279h-2v-2h4c-.34.67-.67 1.33-1 2Z"
            className="templesOnly_svg__cls-3543"
          />
          <path
            d="M54 279c.33-.67.66-1.33 1-2h1v2z"
            style={{
              fill: "#612a01",
            }}
          />
          <path
            d="M56 278v-1c.75.15 1.91-.5 2 1Z"
            style={{
              fill: "#5d2407",
            }}
          />
          <circle
            cx={58.54}
            cy={278.54}
            r={0.71}
            style={{
              fill: "#b68350",
            }}
          />
          <ellipse
            cx={57.04}
            cy={278.54}
            className="templesOnly_svg__cls-3543"
            rx={1.41}
            ry={0.71}
          />
          <path
            d="M47 257c1.32-20.55 1.72-35.78 0-36-.54-.07-1.29 1.29-2 1-1-.38-1.06-3.4 0-4 .33-.19.79-.14.82-.33s-.54-.47-.82-.67c-1.57-1.08-1.38-5.41 0-6 .64-.26 1.58.29 2 1a1.75 1.75 0 0 1 0 2c-.32.28-.8.16-.83.33s.39.33.83.67a3.8 3.8 0 0 1 1 1.15"
            className="templesOnly_svg__cls-3372"
          />
        </g>
      </g>
    </g>
  </svg>
);
}